/* eslint-disable */

/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-mixed-operators, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars, default-case, jsdoc/require-param*/
import $protobuf from "protobufjs/minimal.js";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
const $Object = $util.global.Object, $undefined = $util.global.undefined, $Error = $util.global.Error, $RangeError = $util.global.RangeError, $TypeError = $util.global.TypeError, $String = $util.global.String, $Boolean = $util.global.Boolean, $Number = $util.global.Number, $isFinite = $util.global.isFinite, $Array = $util.global.Array, $parseInt = $util.global.parseInt, $BigInt = $util.global.BigInt;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const Alert = $root.Alert = (() => {

    /**
     * Properties of an Alert.
     * @typedef {Object} Alert.$Properties
     * @property {string|null} [body] Alert body
     * @property {Alert.Format|null} [format] Alert format
     * @property {string|null} [icon] Alert icon
     * @property {streamlit.WidthConfig.$Properties|null} [widthConfig] Alert widthConfig
     * @property {string|null} [title] Alert title
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an Alert.
     * @exports IAlert
     * @interface IAlert
     * @augments Alert.$Properties
     * @deprecated Use Alert.$Properties instead.
     */

    /**
     * Shape of an Alert.
     * @typedef {{
     *   body?: string|null;
     *   format?: Alert.Format|null;
     *   icon?: string|null;
     *   widthConfig?: streamlit.WidthConfig.$Shape|null;
     *   title?: string|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} Alert.$Shape
     */

    /**
     * Constructs a new Alert.
     * @exports Alert
     * @classdesc Represents an Alert.
     * @constructor
     * @param {Alert.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Alert = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Alert body.
     * @member {string} body
     * @memberof Alert
     * @instance
     */
    Alert.prototype.body = "";

    /**
     * Alert format.
     * @member {Alert.Format} format
     * @memberof Alert
     * @instance
     */
    Alert.prototype.format = 0;

    /**
     * Alert icon.
     * @member {string} icon
     * @memberof Alert
     * @instance
     */
    Alert.prototype.icon = "";

    /**
     * Alert widthConfig.
     * @member {streamlit.WidthConfig.$Properties|null|undefined} widthConfig
     * @memberof Alert
     * @instance
     */
    Alert.prototype.widthConfig = null;

    /**
     * Alert title.
     * @member {string} title
     * @memberof Alert
     * @instance
     */
    Alert.prototype.title = "";

    /**
     * Creates a new Alert instance using the specified properties.
     * @function create
     * @memberof Alert
     * @static
     * @param {Alert.$Properties=} [properties] Properties to set
     * @returns {Alert} Alert instance
     * @type {{
     *   (properties: Alert.$Shape): Alert & Alert.$Shape;
     *   (properties?: Alert.$Properties): Alert;
     * }}
     */
    Alert.create = function(properties) {
        return new Alert(properties);
    };

    /**
     * Encodes the specified Alert message. Does not implicitly {@link Alert.verify|verify} messages.
     * @function encode
     * @memberof Alert
     * @static
     * @param {Alert.$Properties} message Alert message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Alert.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.body != null && $Object.hasOwnProperty.call(message, "body") && message.body !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.body);
        if (message.format != null && $Object.hasOwnProperty.call(message, "format") && message.format !== 0)
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.format);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.icon);
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            $root.streamlit.WidthConfig.encode(message.widthConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
        if (message.title != null && $Object.hasOwnProperty.call(message, "title") && message.title !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.title);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an Alert message from the specified reader or buffer.
     * @function decode
     * @memberof Alert
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Alert & Alert.$Shape} Alert
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Alert.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Alert();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.body = value;
                    else
                        delete message.body;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.format = value;
                    else
                        delete message.format;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.widthConfig = $root.streamlit.WidthConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.widthConfig);
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.title = value;
                    else
                        delete message.title;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an Alert message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Alert
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Alert} Alert
     */
    Alert.fromObject = function (object, _depth) {
        if (object instanceof $root.Alert)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Alert: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Alert();
        if (object.body != null)
            if (typeof object.body !== "string" || object.body.length)
                message.body = $String(object.body);
        if (object.format !== 0 && (typeof object.format !== "string" || $root.Alert.Format[object.format] !== 0))
            switch (object.format) {
            case "UNUSED":
            case 0:
                message.format = 0;
                break;
            case "ERROR":
            case 1:
                message.format = 1;
                break;
            case "WARNING":
            case 2:
                message.format = 2;
                break;
            case "INFO":
            case 3:
                message.format = 3;
                break;
            case "SUCCESS":
            case 4:
                message.format = 4;
                break;
            default:
                if (typeof object.format === "number" && (object.format | 0) === object.format)
                    message.format = object.format;
            }
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        if (object.widthConfig != null) {
            if (!$util.isObject(object.widthConfig))
                throw $TypeError(".Alert.widthConfig: object expected");
            message.widthConfig = $root.streamlit.WidthConfig.fromObject(object.widthConfig, _depth + 1);
        }
        if (object.title != null)
            if (typeof object.title !== "string" || object.title.length)
                message.title = $String(object.title);
        return message;
    };

    /**
     * Creates a plain object from an Alert message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Alert
     * @static
     * @param {Alert} message Alert
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Alert.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.body = "";
            object.format = options.enums === $String ? "UNUSED" : 0;
            object.icon = "";
            object.widthConfig = null;
            object.title = "";
        }
        if (message.body != null && $Object.hasOwnProperty.call(message, "body"))
            object.body = message.body;
        if (message.format != null && $Object.hasOwnProperty.call(message, "format"))
            object.format = options.enums === $String ? $root.Alert.Format[message.format] === $undefined ? message.format : $root.Alert.Format[message.format] : message.format;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            object.widthConfig = $root.streamlit.WidthConfig.toObject(message.widthConfig, options, _depth + 1);
        if (message.title != null && $Object.hasOwnProperty.call(message, "title"))
            object.title = message.title;
        return object;
    };

    /**
     * Converts this Alert to JSON.
     * @function toJSON
     * @memberof Alert
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Alert.prototype.toJSON = function() {
        return Alert.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Alert
     * @function getTypeUrl
     * @memberof Alert
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Alert.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Alert";
    };

    /**
     * Format enum.
     * @name Alert.Format
     * @enum {number}
     * @property {number} UNUSED=0 UNUSED value
     * @property {number} ERROR=1 ERROR value
     * @property {number} WARNING=2 WARNING value
     * @property {number} INFO=3 INFO value
     * @property {number} SUCCESS=4 SUCCESS value
     */
    Alert.Format = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "UNUSED"] = 0;
        values[valuesById[1] = "ERROR"] = 1;
        values[valuesById[2] = "WARNING"] = 2;
        values[valuesById[3] = "INFO"] = 3;
        values[valuesById[4] = "SUCCESS"] = 4;
        return values;
    })();

    return Alert;
})();

export const streamlit = $root.streamlit = (() => {

    /**
     * Namespace streamlit.
     * @exports streamlit
     * @namespace
     */
    const streamlit = {};

    streamlit.WidthConfig = (function() {

        /**
         * Properties of a WidthConfig.
         * @typedef {Object} streamlit.WidthConfig.$Properties
         * @property {boolean|null} [useStretch] WidthConfig useStretch
         * @property {boolean|null} [useContent] WidthConfig useContent
         * @property {number|null} [pixelWidth] WidthConfig pixelWidth
         * @property {number|null} [remWidth] WidthConfig remWidth
         * @property {"useStretch"|"useContent"|"pixelWidth"|"remWidth"} [widthSpec] WidthConfig widthSpec
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a WidthConfig.
         * @memberof streamlit
         * @interface IWidthConfig
         * @augments streamlit.WidthConfig.$Properties
         * @deprecated Use streamlit.WidthConfig.$Properties instead.
         */

        /**
         * Narrowed shape of a WidthConfig.
         * @typedef {{
         *   useStretch?: boolean|null;
         *   useContent?: boolean|null;
         *   pixelWidth?: number|null;
         *   remWidth?: number|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ widthSpec?: undefined; useStretch?: null; useContent?: null; pixelWidth?: null; remWidth?: null }|{ widthSpec?: "useStretch"; useStretch: boolean; useContent?: null; pixelWidth?: null; remWidth?: null }|{ widthSpec?: "useContent"; useStretch?: null; useContent: boolean; pixelWidth?: null; remWidth?: null }|{ widthSpec?: "pixelWidth"; useStretch?: null; useContent?: null; pixelWidth: number; remWidth?: null }|{ widthSpec?: "remWidth"; useStretch?: null; useContent?: null; pixelWidth?: null; remWidth: number })
         * )} streamlit.WidthConfig.$Shape
         */

        /**
         * Constructs a new WidthConfig.
         * @memberof streamlit
         * @classdesc Represents a WidthConfig.
         * @constructor
         * @param {streamlit.WidthConfig.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const WidthConfig = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * WidthConfig useStretch.
         * @member {boolean|null|undefined} useStretch
         * @memberof streamlit.WidthConfig
         * @instance
         */
        WidthConfig.prototype.useStretch = null;

        /**
         * WidthConfig useContent.
         * @member {boolean|null|undefined} useContent
         * @memberof streamlit.WidthConfig
         * @instance
         */
        WidthConfig.prototype.useContent = null;

        /**
         * WidthConfig pixelWidth.
         * @member {number|null|undefined} pixelWidth
         * @memberof streamlit.WidthConfig
         * @instance
         */
        WidthConfig.prototype.pixelWidth = null;

        /**
         * WidthConfig remWidth.
         * @member {number|null|undefined} remWidth
         * @memberof streamlit.WidthConfig
         * @instance
         */
        WidthConfig.prototype.remWidth = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * WidthConfig widthSpec.
         * @member {"useStretch"|"useContent"|"pixelWidth"|"remWidth"|undefined} widthSpec
         * @memberof streamlit.WidthConfig
         * @instance
         */
        $Object.defineProperty(WidthConfig.prototype, "widthSpec", {
            get: $util.oneOfGetter($oneOfFields = ["useStretch", "useContent", "pixelWidth", "remWidth"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new WidthConfig instance using the specified properties.
         * @function create
         * @memberof streamlit.WidthConfig
         * @static
         * @param {streamlit.WidthConfig.$Properties=} [properties] Properties to set
         * @returns {streamlit.WidthConfig} WidthConfig instance
         * @type {{
         *   (properties: streamlit.WidthConfig.$Shape): streamlit.WidthConfig & streamlit.WidthConfig.$Shape;
         *   (properties?: streamlit.WidthConfig.$Properties): streamlit.WidthConfig;
         * }}
         */
        WidthConfig.create = function(properties) {
            return new WidthConfig(properties);
        };

        /**
         * Encodes the specified WidthConfig message. Does not implicitly {@link streamlit.WidthConfig.verify|verify} messages.
         * @function encode
         * @memberof streamlit.WidthConfig
         * @static
         * @param {streamlit.WidthConfig.$Properties} message WidthConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WidthConfig.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.useStretch != null && $Object.hasOwnProperty.call(message, "useStretch"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.useStretch);
            if (message.useContent != null && $Object.hasOwnProperty.call(message, "useContent"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.useContent);
            if (message.pixelWidth != null && $Object.hasOwnProperty.call(message, "pixelWidth"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.pixelWidth);
            if (message.remWidth != null && $Object.hasOwnProperty.call(message, "remWidth"))
                writer.uint32(/* id 4, wireType 5 =*/37).float(message.remWidth);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a WidthConfig message from the specified reader or buffer.
         * @function decode
         * @memberof streamlit.WidthConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {streamlit.WidthConfig & streamlit.WidthConfig.$Shape} WidthConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WidthConfig.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.streamlit.WidthConfig();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        message.useStretch = reader.bool();
                        message.widthSpec = "useStretch";
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        message.useContent = reader.bool();
                        message.widthSpec = "useContent";
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        message.pixelWidth = reader.uint32();
                        message.widthSpec = "pixelWidth";
                        continue;
                    }
                case 4: {
                        if (wireType !== 5)
                            break;
                        message.remWidth = reader.float();
                        message.widthSpec = "remWidth";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a WidthConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof streamlit.WidthConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {streamlit.WidthConfig} WidthConfig
         */
        WidthConfig.fromObject = function (object, _depth) {
            if (object instanceof $root.streamlit.WidthConfig)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".streamlit.WidthConfig: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.streamlit.WidthConfig();
            if (object.useStretch != null)
                message.useStretch = $Boolean(object.useStretch);
            if (object.useContent != null)
                message.useContent = $Boolean(object.useContent);
            if (object.pixelWidth != null)
                message.pixelWidth = object.pixelWidth >>> 0;
            if (object.remWidth != null)
                message.remWidth = $Number(object.remWidth);
            return message;
        };

        /**
         * Creates a plain object from a WidthConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof streamlit.WidthConfig
         * @static
         * @param {streamlit.WidthConfig} message WidthConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WidthConfig.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (message.useStretch != null && $Object.hasOwnProperty.call(message, "useStretch")) {
                object.useStretch = message.useStretch;
                if (options.oneofs)
                    object.widthSpec = "useStretch";
            }
            if (message.useContent != null && $Object.hasOwnProperty.call(message, "useContent")) {
                object.useContent = message.useContent;
                if (options.oneofs)
                    object.widthSpec = "useContent";
            }
            if (message.pixelWidth != null && $Object.hasOwnProperty.call(message, "pixelWidth")) {
                object.pixelWidth = message.pixelWidth;
                if (options.oneofs)
                    object.widthSpec = "pixelWidth";
            }
            if (message.remWidth != null && $Object.hasOwnProperty.call(message, "remWidth")) {
                object.remWidth = options.json && !$isFinite(message.remWidth) ? $String(message.remWidth) : message.remWidth;
                if (options.oneofs)
                    object.widthSpec = "remWidth";
            }
            return object;
        };

        /**
         * Converts this WidthConfig to JSON.
         * @function toJSON
         * @memberof streamlit.WidthConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WidthConfig.prototype.toJSON = function() {
            return WidthConfig.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for WidthConfig
         * @function getTypeUrl
         * @memberof streamlit.WidthConfig
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        WidthConfig.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/streamlit.WidthConfig";
        };

        return WidthConfig;
    })();

    /**
     * GapSize enum.
     * @name streamlit.GapSize
     * @enum {number}
     * @property {number} GAP_UNDEFINED=0 GAP_UNDEFINED value
     * @property {number} SMALL=1 SMALL value
     * @property {number} MEDIUM=2 MEDIUM value
     * @property {number} LARGE=3 LARGE value
     * @property {number} NONE=4 NONE value
     * @property {number} XXSMALL=5 XXSMALL value
     * @property {number} XSMALL=6 XSMALL value
     * @property {number} XLARGE=7 XLARGE value
     * @property {number} XXLARGE=8 XXLARGE value
     */
    streamlit.GapSize = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "GAP_UNDEFINED"] = 0;
        values[valuesById[1] = "SMALL"] = 1;
        values[valuesById[2] = "MEDIUM"] = 2;
        values[valuesById[3] = "LARGE"] = 3;
        values[valuesById[4] = "NONE"] = 4;
        values[valuesById[5] = "XXSMALL"] = 5;
        values[valuesById[6] = "XSMALL"] = 6;
        values[valuesById[7] = "XLARGE"] = 7;
        values[valuesById[8] = "XXLARGE"] = 8;
        return values;
    })();

    streamlit.GapConfig = (function() {

        /**
         * Properties of a GapConfig.
         * @typedef {Object} streamlit.GapConfig.$Properties
         * @property {streamlit.GapSize|null} [gapSize] GapConfig gapSize
         * @property {number|null} [pixelGap] GapConfig pixelGap
         * @property {"gapSize"|"pixelGap"} [gapSpec] GapConfig gapSpec
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a GapConfig.
         * @memberof streamlit
         * @interface IGapConfig
         * @augments streamlit.GapConfig.$Properties
         * @deprecated Use streamlit.GapConfig.$Properties instead.
         */

        /**
         * Narrowed shape of a GapConfig.
         * @typedef {{
         *   gapSize?: streamlit.GapSize|null;
         *   pixelGap?: number|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ gapSpec?: undefined; gapSize?: null; pixelGap?: null }|{ gapSpec?: "gapSize"; gapSize: streamlit.GapSize; pixelGap?: null }|{ gapSpec?: "pixelGap"; gapSize?: null; pixelGap: number })
         * )} streamlit.GapConfig.$Shape
         */

        /**
         * Constructs a new GapConfig.
         * @memberof streamlit
         * @classdesc Represents a GapConfig.
         * @constructor
         * @param {streamlit.GapConfig.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const GapConfig = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * GapConfig gapSize.
         * @member {streamlit.GapSize|null|undefined} gapSize
         * @memberof streamlit.GapConfig
         * @instance
         */
        GapConfig.prototype.gapSize = null;

        /**
         * GapConfig pixelGap.
         * @member {number|null|undefined} pixelGap
         * @memberof streamlit.GapConfig
         * @instance
         */
        GapConfig.prototype.pixelGap = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * GapConfig gapSpec.
         * @member {"gapSize"|"pixelGap"|undefined} gapSpec
         * @memberof streamlit.GapConfig
         * @instance
         */
        $Object.defineProperty(GapConfig.prototype, "gapSpec", {
            get: $util.oneOfGetter($oneOfFields = ["gapSize", "pixelGap"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GapConfig instance using the specified properties.
         * @function create
         * @memberof streamlit.GapConfig
         * @static
         * @param {streamlit.GapConfig.$Properties=} [properties] Properties to set
         * @returns {streamlit.GapConfig} GapConfig instance
         * @type {{
         *   (properties: streamlit.GapConfig.$Shape): streamlit.GapConfig & streamlit.GapConfig.$Shape;
         *   (properties?: streamlit.GapConfig.$Properties): streamlit.GapConfig;
         * }}
         */
        GapConfig.create = function(properties) {
            return new GapConfig(properties);
        };

        /**
         * Encodes the specified GapConfig message. Does not implicitly {@link streamlit.GapConfig.verify|verify} messages.
         * @function encode
         * @memberof streamlit.GapConfig
         * @static
         * @param {streamlit.GapConfig.$Properties} message GapConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GapConfig.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.gapSize != null && $Object.hasOwnProperty.call(message, "gapSize"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.gapSize);
            if (message.pixelGap != null && $Object.hasOwnProperty.call(message, "pixelGap"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.pixelGap);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a GapConfig message from the specified reader or buffer.
         * @function decode
         * @memberof streamlit.GapConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {streamlit.GapConfig & streamlit.GapConfig.$Shape} GapConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GapConfig.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.streamlit.GapConfig();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        message.gapSize = reader.int32();
                        message.gapSpec = "gapSize";
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        message.pixelGap = reader.uint32();
                        message.gapSpec = "pixelGap";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a GapConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof streamlit.GapConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {streamlit.GapConfig} GapConfig
         */
        GapConfig.fromObject = function (object, _depth) {
            if (object instanceof $root.streamlit.GapConfig)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".streamlit.GapConfig: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.streamlit.GapConfig();
            switch (object.gapSize) {
            case "GAP_UNDEFINED":
            case 0:
                message.gapSize = 0;
                break;
            case "SMALL":
            case 1:
                message.gapSize = 1;
                break;
            case "MEDIUM":
            case 2:
                message.gapSize = 2;
                break;
            case "LARGE":
            case 3:
                message.gapSize = 3;
                break;
            case "NONE":
            case 4:
                message.gapSize = 4;
                break;
            case "XXSMALL":
            case 5:
                message.gapSize = 5;
                break;
            case "XSMALL":
            case 6:
                message.gapSize = 6;
                break;
            case "XLARGE":
            case 7:
                message.gapSize = 7;
                break;
            case "XXLARGE":
            case 8:
                message.gapSize = 8;
                break;
            default:
                if (typeof object.gapSize === "number" && (object.gapSize | 0) === object.gapSize)
                    message.gapSize = object.gapSize;
            }
            if (object.pixelGap != null)
                message.pixelGap = object.pixelGap >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a GapConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof streamlit.GapConfig
         * @static
         * @param {streamlit.GapConfig} message GapConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GapConfig.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (message.gapSize != null && $Object.hasOwnProperty.call(message, "gapSize")) {
                object.gapSize = options.enums === $String ? $root.streamlit.GapSize[message.gapSize] === $undefined ? message.gapSize : $root.streamlit.GapSize[message.gapSize] : message.gapSize;
                if (options.oneofs)
                    object.gapSpec = "gapSize";
            }
            if (message.pixelGap != null && $Object.hasOwnProperty.call(message, "pixelGap")) {
                object.pixelGap = message.pixelGap;
                if (options.oneofs)
                    object.gapSpec = "pixelGap";
            }
            return object;
        };

        /**
         * Converts this GapConfig to JSON.
         * @function toJSON
         * @memberof streamlit.GapConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GapConfig.prototype.toJSON = function() {
            return GapConfig.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for GapConfig
         * @function getTypeUrl
         * @memberof streamlit.GapConfig
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        GapConfig.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/streamlit.GapConfig";
        };

        return GapConfig;
    })();

    streamlit.HeightConfig = (function() {

        /**
         * Properties of an HeightConfig.
         * @typedef {Object} streamlit.HeightConfig.$Properties
         * @property {boolean|null} [useStretch] HeightConfig useStretch
         * @property {boolean|null} [useContent] HeightConfig useContent
         * @property {number|null} [pixelHeight] HeightConfig pixelHeight
         * @property {number|null} [remHeight] HeightConfig remHeight
         * @property {"useStretch"|"useContent"|"pixelHeight"|"remHeight"} [heightSpec] HeightConfig heightSpec
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an HeightConfig.
         * @memberof streamlit
         * @interface IHeightConfig
         * @augments streamlit.HeightConfig.$Properties
         * @deprecated Use streamlit.HeightConfig.$Properties instead.
         */

        /**
         * Narrowed shape of an HeightConfig.
         * @typedef {{
         *   useStretch?: boolean|null;
         *   useContent?: boolean|null;
         *   pixelHeight?: number|null;
         *   remHeight?: number|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ heightSpec?: undefined; useStretch?: null; useContent?: null; pixelHeight?: null; remHeight?: null }|{ heightSpec?: "useStretch"; useStretch: boolean; useContent?: null; pixelHeight?: null; remHeight?: null }|{ heightSpec?: "useContent"; useStretch?: null; useContent: boolean; pixelHeight?: null; remHeight?: null }|{ heightSpec?: "pixelHeight"; useStretch?: null; useContent?: null; pixelHeight: number; remHeight?: null }|{ heightSpec?: "remHeight"; useStretch?: null; useContent?: null; pixelHeight?: null; remHeight: number })
         * )} streamlit.HeightConfig.$Shape
         */

        /**
         * Constructs a new HeightConfig.
         * @memberof streamlit
         * @classdesc Represents an HeightConfig.
         * @constructor
         * @param {streamlit.HeightConfig.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const HeightConfig = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * HeightConfig useStretch.
         * @member {boolean|null|undefined} useStretch
         * @memberof streamlit.HeightConfig
         * @instance
         */
        HeightConfig.prototype.useStretch = null;

        /**
         * HeightConfig useContent.
         * @member {boolean|null|undefined} useContent
         * @memberof streamlit.HeightConfig
         * @instance
         */
        HeightConfig.prototype.useContent = null;

        /**
         * HeightConfig pixelHeight.
         * @member {number|null|undefined} pixelHeight
         * @memberof streamlit.HeightConfig
         * @instance
         */
        HeightConfig.prototype.pixelHeight = null;

        /**
         * HeightConfig remHeight.
         * @member {number|null|undefined} remHeight
         * @memberof streamlit.HeightConfig
         * @instance
         */
        HeightConfig.prototype.remHeight = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * HeightConfig heightSpec.
         * @member {"useStretch"|"useContent"|"pixelHeight"|"remHeight"|undefined} heightSpec
         * @memberof streamlit.HeightConfig
         * @instance
         */
        $Object.defineProperty(HeightConfig.prototype, "heightSpec", {
            get: $util.oneOfGetter($oneOfFields = ["useStretch", "useContent", "pixelHeight", "remHeight"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new HeightConfig instance using the specified properties.
         * @function create
         * @memberof streamlit.HeightConfig
         * @static
         * @param {streamlit.HeightConfig.$Properties=} [properties] Properties to set
         * @returns {streamlit.HeightConfig} HeightConfig instance
         * @type {{
         *   (properties: streamlit.HeightConfig.$Shape): streamlit.HeightConfig & streamlit.HeightConfig.$Shape;
         *   (properties?: streamlit.HeightConfig.$Properties): streamlit.HeightConfig;
         * }}
         */
        HeightConfig.create = function(properties) {
            return new HeightConfig(properties);
        };

        /**
         * Encodes the specified HeightConfig message. Does not implicitly {@link streamlit.HeightConfig.verify|verify} messages.
         * @function encode
         * @memberof streamlit.HeightConfig
         * @static
         * @param {streamlit.HeightConfig.$Properties} message HeightConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HeightConfig.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.useStretch != null && $Object.hasOwnProperty.call(message, "useStretch"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.useStretch);
            if (message.useContent != null && $Object.hasOwnProperty.call(message, "useContent"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.useContent);
            if (message.pixelHeight != null && $Object.hasOwnProperty.call(message, "pixelHeight"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.pixelHeight);
            if (message.remHeight != null && $Object.hasOwnProperty.call(message, "remHeight"))
                writer.uint32(/* id 4, wireType 5 =*/37).float(message.remHeight);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes an HeightConfig message from the specified reader or buffer.
         * @function decode
         * @memberof streamlit.HeightConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {streamlit.HeightConfig & streamlit.HeightConfig.$Shape} HeightConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HeightConfig.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.streamlit.HeightConfig();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        message.useStretch = reader.bool();
                        message.heightSpec = "useStretch";
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        message.useContent = reader.bool();
                        message.heightSpec = "useContent";
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        message.pixelHeight = reader.uint32();
                        message.heightSpec = "pixelHeight";
                        continue;
                    }
                case 4: {
                        if (wireType !== 5)
                            break;
                        message.remHeight = reader.float();
                        message.heightSpec = "remHeight";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates an HeightConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof streamlit.HeightConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {streamlit.HeightConfig} HeightConfig
         */
        HeightConfig.fromObject = function (object, _depth) {
            if (object instanceof $root.streamlit.HeightConfig)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".streamlit.HeightConfig: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.streamlit.HeightConfig();
            if (object.useStretch != null)
                message.useStretch = $Boolean(object.useStretch);
            if (object.useContent != null)
                message.useContent = $Boolean(object.useContent);
            if (object.pixelHeight != null)
                message.pixelHeight = object.pixelHeight >>> 0;
            if (object.remHeight != null)
                message.remHeight = $Number(object.remHeight);
            return message;
        };

        /**
         * Creates a plain object from an HeightConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof streamlit.HeightConfig
         * @static
         * @param {streamlit.HeightConfig} message HeightConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HeightConfig.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (message.useStretch != null && $Object.hasOwnProperty.call(message, "useStretch")) {
                object.useStretch = message.useStretch;
                if (options.oneofs)
                    object.heightSpec = "useStretch";
            }
            if (message.useContent != null && $Object.hasOwnProperty.call(message, "useContent")) {
                object.useContent = message.useContent;
                if (options.oneofs)
                    object.heightSpec = "useContent";
            }
            if (message.pixelHeight != null && $Object.hasOwnProperty.call(message, "pixelHeight")) {
                object.pixelHeight = message.pixelHeight;
                if (options.oneofs)
                    object.heightSpec = "pixelHeight";
            }
            if (message.remHeight != null && $Object.hasOwnProperty.call(message, "remHeight")) {
                object.remHeight = options.json && !$isFinite(message.remHeight) ? $String(message.remHeight) : message.remHeight;
                if (options.oneofs)
                    object.heightSpec = "remHeight";
            }
            return object;
        };

        /**
         * Converts this HeightConfig to JSON.
         * @function toJSON
         * @memberof streamlit.HeightConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HeightConfig.prototype.toJSON = function() {
            return HeightConfig.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for HeightConfig
         * @function getTypeUrl
         * @memberof streamlit.HeightConfig
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        HeightConfig.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/streamlit.HeightConfig";
        };

        return HeightConfig;
    })();

    /**
     * ButtonLikeIconPosition enum.
     * @name streamlit.ButtonLikeIconPosition
     * @enum {number}
     * @property {number} LEFT=0 LEFT value
     * @property {number} RIGHT=1 RIGHT value
     */
    streamlit.ButtonLikeIconPosition = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "LEFT"] = 0;
        values[valuesById[1] = "RIGHT"] = 1;
        return values;
    })();

    /**
     * SelectWidgetFilterMode enum.
     * @name streamlit.SelectWidgetFilterMode
     * @enum {number}
     * @property {number} FILTER_MODE_FUZZY=0 FILTER_MODE_FUZZY value
     * @property {number} FILTER_MODE_CONTAINS=1 FILTER_MODE_CONTAINS value
     * @property {number} FILTER_MODE_PREFIX=2 FILTER_MODE_PREFIX value
     * @property {number} FILTER_MODE_NONE=3 FILTER_MODE_NONE value
     */
    streamlit.SelectWidgetFilterMode = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "FILTER_MODE_FUZZY"] = 0;
        values[valuesById[1] = "FILTER_MODE_CONTAINS"] = 1;
        values[valuesById[2] = "FILTER_MODE_PREFIX"] = 2;
        values[valuesById[3] = "FILTER_MODE_NONE"] = 3;
        return values;
    })();

    streamlit.TextAlignmentConfig = (function() {

        /**
         * Properties of a TextAlignmentConfig.
         * @typedef {Object} streamlit.TextAlignmentConfig.$Properties
         * @property {streamlit.TextAlignmentConfig.Alignment|null} [alignment] TextAlignmentConfig alignment
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a TextAlignmentConfig.
         * @memberof streamlit
         * @interface ITextAlignmentConfig
         * @augments streamlit.TextAlignmentConfig.$Properties
         * @deprecated Use streamlit.TextAlignmentConfig.$Properties instead.
         */

        /**
         * Shape of a TextAlignmentConfig.
         * @typedef {streamlit.TextAlignmentConfig.$Properties} streamlit.TextAlignmentConfig.$Shape
         */

        /**
         * Constructs a new TextAlignmentConfig.
         * @memberof streamlit
         * @classdesc Represents a TextAlignmentConfig.
         * @constructor
         * @param {streamlit.TextAlignmentConfig.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const TextAlignmentConfig = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * TextAlignmentConfig alignment.
         * @member {streamlit.TextAlignmentConfig.Alignment} alignment
         * @memberof streamlit.TextAlignmentConfig
         * @instance
         */
        TextAlignmentConfig.prototype.alignment = 0;

        /**
         * Creates a new TextAlignmentConfig instance using the specified properties.
         * @function create
         * @memberof streamlit.TextAlignmentConfig
         * @static
         * @param {streamlit.TextAlignmentConfig.$Properties=} [properties] Properties to set
         * @returns {streamlit.TextAlignmentConfig} TextAlignmentConfig instance
         * @type {{
         *   (properties: streamlit.TextAlignmentConfig.$Shape): streamlit.TextAlignmentConfig & streamlit.TextAlignmentConfig.$Shape;
         *   (properties?: streamlit.TextAlignmentConfig.$Properties): streamlit.TextAlignmentConfig;
         * }}
         */
        TextAlignmentConfig.create = function(properties) {
            return new TextAlignmentConfig(properties);
        };

        /**
         * Encodes the specified TextAlignmentConfig message. Does not implicitly {@link streamlit.TextAlignmentConfig.verify|verify} messages.
         * @function encode
         * @memberof streamlit.TextAlignmentConfig
         * @static
         * @param {streamlit.TextAlignmentConfig.$Properties} message TextAlignmentConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TextAlignmentConfig.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.alignment != null && $Object.hasOwnProperty.call(message, "alignment") && message.alignment !== 0)
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.alignment);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a TextAlignmentConfig message from the specified reader or buffer.
         * @function decode
         * @memberof streamlit.TextAlignmentConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {streamlit.TextAlignmentConfig & streamlit.TextAlignmentConfig.$Shape} TextAlignmentConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TextAlignmentConfig.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.streamlit.TextAlignmentConfig();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.alignment = value;
                        else
                            delete message.alignment;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a TextAlignmentConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof streamlit.TextAlignmentConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {streamlit.TextAlignmentConfig} TextAlignmentConfig
         */
        TextAlignmentConfig.fromObject = function (object, _depth) {
            if (object instanceof $root.streamlit.TextAlignmentConfig)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".streamlit.TextAlignmentConfig: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.streamlit.TextAlignmentConfig();
            if (object.alignment !== 0 && (typeof object.alignment !== "string" || $root.streamlit.TextAlignmentConfig.Alignment[object.alignment] !== 0))
                switch (object.alignment) {
                case "UNSPECIFIED":
                case 0:
                    message.alignment = 0;
                    break;
                case "LEFT":
                case 1:
                    message.alignment = 1;
                    break;
                case "CENTER":
                case 2:
                    message.alignment = 2;
                    break;
                case "RIGHT":
                case 3:
                    message.alignment = 3;
                    break;
                case "JUSTIFY":
                case 4:
                    message.alignment = 4;
                    break;
                default:
                    if (typeof object.alignment === "number" && (object.alignment | 0) === object.alignment)
                        message.alignment = object.alignment;
                }
            return message;
        };

        /**
         * Creates a plain object from a TextAlignmentConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof streamlit.TextAlignmentConfig
         * @static
         * @param {streamlit.TextAlignmentConfig} message TextAlignmentConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TextAlignmentConfig.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.alignment = options.enums === $String ? "UNSPECIFIED" : 0;
            if (message.alignment != null && $Object.hasOwnProperty.call(message, "alignment"))
                object.alignment = options.enums === $String ? $root.streamlit.TextAlignmentConfig.Alignment[message.alignment] === $undefined ? message.alignment : $root.streamlit.TextAlignmentConfig.Alignment[message.alignment] : message.alignment;
            return object;
        };

        /**
         * Converts this TextAlignmentConfig to JSON.
         * @function toJSON
         * @memberof streamlit.TextAlignmentConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TextAlignmentConfig.prototype.toJSON = function() {
            return TextAlignmentConfig.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for TextAlignmentConfig
         * @function getTypeUrl
         * @memberof streamlit.TextAlignmentConfig
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        TextAlignmentConfig.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/streamlit.TextAlignmentConfig";
        };

        /**
         * Alignment enum.
         * @name streamlit.TextAlignmentConfig.Alignment
         * @enum {number}
         * @property {number} UNSPECIFIED=0 UNSPECIFIED value
         * @property {number} LEFT=1 LEFT value
         * @property {number} CENTER=2 CENTER value
         * @property {number} RIGHT=3 RIGHT value
         * @property {number} JUSTIFY=4 JUSTIFY value
         */
        TextAlignmentConfig.Alignment = (function() {
            const valuesById = $Object.create(null), values = $Object.create(valuesById);
            values[valuesById[0] = "UNSPECIFIED"] = 0;
            values[valuesById[1] = "LEFT"] = 1;
            values[valuesById[2] = "CENTER"] = 2;
            values[valuesById[3] = "RIGHT"] = 3;
            values[valuesById[4] = "JUSTIFY"] = 4;
            return values;
        })();

        return TextAlignmentConfig;
    })();

    return streamlit;
})();

export const AppPage = $root.AppPage = (() => {

    /**
     * Properties of an AppPage.
     * @typedef {Object} AppPage.$Properties
     * @property {string|null} [pageScriptHash] AppPage pageScriptHash
     * @property {string|null} [pageName] AppPage pageName
     * @property {string|null} [icon] AppPage icon
     * @property {boolean|null} [isDefault] AppPage isDefault
     * @property {string|null} [sectionHeader] AppPage sectionHeader
     * @property {string|null} [urlPathname] AppPage urlPathname
     * @property {boolean|null} [isHidden] AppPage isHidden
     * @property {string|null} [externalUrl] AppPage externalUrl
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an AppPage.
     * @exports IAppPage
     * @interface IAppPage
     * @augments AppPage.$Properties
     * @deprecated Use AppPage.$Properties instead.
     */

    /**
     * Shape of an AppPage.
     * @typedef {AppPage.$Properties} AppPage.$Shape
     */

    /**
     * Constructs a new AppPage.
     * @exports AppPage
     * @classdesc Represents an AppPage.
     * @constructor
     * @param {AppPage.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const AppPage = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * AppPage pageScriptHash.
     * @member {string} pageScriptHash
     * @memberof AppPage
     * @instance
     */
    AppPage.prototype.pageScriptHash = "";

    /**
     * AppPage pageName.
     * @member {string} pageName
     * @memberof AppPage
     * @instance
     */
    AppPage.prototype.pageName = "";

    /**
     * AppPage icon.
     * @member {string} icon
     * @memberof AppPage
     * @instance
     */
    AppPage.prototype.icon = "";

    /**
     * AppPage isDefault.
     * @member {boolean} isDefault
     * @memberof AppPage
     * @instance
     */
    AppPage.prototype.isDefault = false;

    /**
     * AppPage sectionHeader.
     * @member {string} sectionHeader
     * @memberof AppPage
     * @instance
     */
    AppPage.prototype.sectionHeader = "";

    /**
     * AppPage urlPathname.
     * @member {string} urlPathname
     * @memberof AppPage
     * @instance
     */
    AppPage.prototype.urlPathname = "";

    /**
     * AppPage isHidden.
     * @member {boolean} isHidden
     * @memberof AppPage
     * @instance
     */
    AppPage.prototype.isHidden = false;

    /**
     * AppPage externalUrl.
     * @member {string|null|undefined} externalUrl
     * @memberof AppPage
     * @instance
     */
    AppPage.prototype.externalUrl = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(AppPage.prototype, "_externalUrl", {
        get: $util.oneOfGetter($oneOfFields = ["externalUrl"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new AppPage instance using the specified properties.
     * @function create
     * @memberof AppPage
     * @static
     * @param {AppPage.$Properties=} [properties] Properties to set
     * @returns {AppPage} AppPage instance
     * @type {{
     *   (properties: AppPage.$Shape): AppPage & AppPage.$Shape;
     *   (properties?: AppPage.$Properties): AppPage;
     * }}
     */
    AppPage.create = function(properties) {
        return new AppPage(properties);
    };

    /**
     * Encodes the specified AppPage message. Does not implicitly {@link AppPage.verify|verify} messages.
     * @function encode
     * @memberof AppPage
     * @static
     * @param {AppPage.$Properties} message AppPage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AppPage.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash") && message.pageScriptHash !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.pageScriptHash);
        if (message.pageName != null && $Object.hasOwnProperty.call(message, "pageName") && message.pageName !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageName);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.icon);
        if (message.isDefault != null && $Object.hasOwnProperty.call(message, "isDefault") && message.isDefault !== false)
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isDefault);
        if (message.sectionHeader != null && $Object.hasOwnProperty.call(message, "sectionHeader") && message.sectionHeader !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.sectionHeader);
        if (message.urlPathname != null && $Object.hasOwnProperty.call(message, "urlPathname") && message.urlPathname !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.urlPathname);
        if (message.isHidden != null && $Object.hasOwnProperty.call(message, "isHidden") && message.isHidden !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isHidden);
        if (message.externalUrl != null && $Object.hasOwnProperty.call(message, "externalUrl"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.externalUrl);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an AppPage message from the specified reader or buffer.
     * @function decode
     * @memberof AppPage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AppPage & AppPage.$Shape} AppPage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AppPage.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.AppPage();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pageScriptHash = value;
                    else
                        delete message.pageScriptHash;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pageName = value;
                    else
                        delete message.pageName;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isDefault = value;
                    else
                        delete message.isDefault;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.sectionHeader = value;
                    else
                        delete message.sectionHeader;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.urlPathname = value;
                    else
                        delete message.urlPathname;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isHidden = value;
                    else
                        delete message.isHidden;
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    message.externalUrl = reader.stringVerify();
                    message._externalUrl = "externalUrl";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an AppPage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AppPage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AppPage} AppPage
     */
    AppPage.fromObject = function (object, _depth) {
        if (object instanceof $root.AppPage)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".AppPage: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.AppPage();
        if (object.pageScriptHash != null)
            if (typeof object.pageScriptHash !== "string" || object.pageScriptHash.length)
                message.pageScriptHash = $String(object.pageScriptHash);
        if (object.pageName != null)
            if (typeof object.pageName !== "string" || object.pageName.length)
                message.pageName = $String(object.pageName);
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        if (object.isDefault != null)
            if (object.isDefault)
                message.isDefault = $Boolean(object.isDefault);
        if (object.sectionHeader != null)
            if (typeof object.sectionHeader !== "string" || object.sectionHeader.length)
                message.sectionHeader = $String(object.sectionHeader);
        if (object.urlPathname != null)
            if (typeof object.urlPathname !== "string" || object.urlPathname.length)
                message.urlPathname = $String(object.urlPathname);
        if (object.isHidden != null)
            if (object.isHidden)
                message.isHidden = $Boolean(object.isHidden);
        if (object.externalUrl != null)
            message.externalUrl = $String(object.externalUrl);
        return message;
    };

    /**
     * Creates a plain object from an AppPage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AppPage
     * @static
     * @param {AppPage} message AppPage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AppPage.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.pageScriptHash = "";
            object.pageName = "";
            object.icon = "";
            object.isDefault = false;
            object.sectionHeader = "";
            object.urlPathname = "";
            object.isHidden = false;
        }
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash"))
            object.pageScriptHash = message.pageScriptHash;
        if (message.pageName != null && $Object.hasOwnProperty.call(message, "pageName"))
            object.pageName = message.pageName;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        if (message.isDefault != null && $Object.hasOwnProperty.call(message, "isDefault"))
            object.isDefault = message.isDefault;
        if (message.sectionHeader != null && $Object.hasOwnProperty.call(message, "sectionHeader"))
            object.sectionHeader = message.sectionHeader;
        if (message.urlPathname != null && $Object.hasOwnProperty.call(message, "urlPathname"))
            object.urlPathname = message.urlPathname;
        if (message.isHidden != null && $Object.hasOwnProperty.call(message, "isHidden"))
            object.isHidden = message.isHidden;
        if (message.externalUrl != null && $Object.hasOwnProperty.call(message, "externalUrl"))
            object.externalUrl = message.externalUrl;
        return object;
    };

    /**
     * Converts this AppPage to JSON.
     * @function toJSON
     * @memberof AppPage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AppPage.prototype.toJSON = function() {
        return AppPage.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for AppPage
     * @function getTypeUrl
     * @memberof AppPage
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    AppPage.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/AppPage";
    };

    return AppPage;
})();

export const ArrowData = $root.ArrowData = (() => {

    /**
     * Properties of an ArrowData.
     * @typedef {Object} ArrowData.$Properties
     * @property {Uint8Array|null} [data] ArrowData data
     * @property {ArrowData.PandasStyler.$Properties|null} [styler] ArrowData styler
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an ArrowData.
     * @exports IArrowData
     * @interface IArrowData
     * @augments ArrowData.$Properties
     * @deprecated Use ArrowData.$Properties instead.
     */

    /**
     * Shape of an ArrowData.
     * @typedef {ArrowData.$Properties} ArrowData.$Shape
     */

    /**
     * Constructs a new ArrowData.
     * @exports ArrowData
     * @classdesc Represents an ArrowData.
     * @constructor
     * @param {ArrowData.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ArrowData = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ArrowData data.
     * @member {Uint8Array} data
     * @memberof ArrowData
     * @instance
     */
    ArrowData.prototype.data = $util.newBuffer([]);

    /**
     * ArrowData styler.
     * @member {ArrowData.PandasStyler.$Properties|null|undefined} styler
     * @memberof ArrowData
     * @instance
     */
    ArrowData.prototype.styler = null;

    /**
     * Creates a new ArrowData instance using the specified properties.
     * @function create
     * @memberof ArrowData
     * @static
     * @param {ArrowData.$Properties=} [properties] Properties to set
     * @returns {ArrowData} ArrowData instance
     * @type {{
     *   (properties: ArrowData.$Shape): ArrowData & ArrowData.$Shape;
     *   (properties?: ArrowData.$Properties): ArrowData;
     * }}
     */
    ArrowData.create = function(properties) {
        return new ArrowData(properties);
    };

    /**
     * Encodes the specified ArrowData message. Does not implicitly {@link ArrowData.verify|verify} messages.
     * @function encode
     * @memberof ArrowData
     * @static
     * @param {ArrowData.$Properties} message ArrowData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ArrowData.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && $Object.hasOwnProperty.call(message, "data") && message.data.length)
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.data);
        if (message.styler != null && $Object.hasOwnProperty.call(message, "styler"))
            $root.ArrowData.PandasStyler.encode(message.styler, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an ArrowData message from the specified reader or buffer.
     * @function decode
     * @memberof ArrowData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ArrowData & ArrowData.$Shape} ArrowData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ArrowData.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ArrowData();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.bytes()).length)
                        message.data = value;
                    else
                        delete message.data;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    message.styler = $root.ArrowData.PandasStyler.decode(reader, reader.uint32(), $undefined, _depth + 1, message.styler);
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an ArrowData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ArrowData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ArrowData} ArrowData
     */
    ArrowData.fromObject = function (object, _depth) {
        if (object instanceof $root.ArrowData)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ArrowData: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ArrowData();
        if (object.data != null)
            if (object.data.length)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
        if (object.styler != null) {
            if (!$util.isObject(object.styler))
                throw $TypeError(".ArrowData.styler: object expected");
            message.styler = $root.ArrowData.PandasStyler.fromObject(object.styler, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from an ArrowData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ArrowData
     * @static
     * @param {ArrowData} message ArrowData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ArrowData.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            if (options.bytes === $String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== $Array)
                    object.data = $util.newBuffer(object.data);
            }
            object.styler = null;
        }
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            object.data = options.bytes === $String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === $Array ? $Array.prototype.slice.call(message.data) : message.data;
        if (message.styler != null && $Object.hasOwnProperty.call(message, "styler"))
            object.styler = $root.ArrowData.PandasStyler.toObject(message.styler, options, _depth + 1);
        return object;
    };

    /**
     * Converts this ArrowData to JSON.
     * @function toJSON
     * @memberof ArrowData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ArrowData.prototype.toJSON = function() {
        return ArrowData.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ArrowData
     * @function getTypeUrl
     * @memberof ArrowData
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ArrowData.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ArrowData";
    };

    ArrowData.PandasStyler = (function() {

        /**
         * Properties of a PandasStyler.
         * @typedef {Object} ArrowData.PandasStyler.$Properties
         * @property {string|null} [uuid] PandasStyler uuid
         * @property {string|null} [caption] PandasStyler caption
         * @property {string|null} [styles] PandasStyler styles
         * @property {Uint8Array|null} [displayValues] PandasStyler displayValues
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a PandasStyler.
         * @memberof ArrowData
         * @interface IPandasStyler
         * @augments ArrowData.PandasStyler.$Properties
         * @deprecated Use ArrowData.PandasStyler.$Properties instead.
         */

        /**
         * Shape of a PandasStyler.
         * @typedef {ArrowData.PandasStyler.$Properties} ArrowData.PandasStyler.$Shape
         */

        /**
         * Constructs a new PandasStyler.
         * @memberof ArrowData
         * @classdesc Represents a PandasStyler.
         * @constructor
         * @param {ArrowData.PandasStyler.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const PandasStyler = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * PandasStyler uuid.
         * @member {string} uuid
         * @memberof ArrowData.PandasStyler
         * @instance
         */
        PandasStyler.prototype.uuid = "";

        /**
         * PandasStyler caption.
         * @member {string} caption
         * @memberof ArrowData.PandasStyler
         * @instance
         */
        PandasStyler.prototype.caption = "";

        /**
         * PandasStyler styles.
         * @member {string} styles
         * @memberof ArrowData.PandasStyler
         * @instance
         */
        PandasStyler.prototype.styles = "";

        /**
         * PandasStyler displayValues.
         * @member {Uint8Array} displayValues
         * @memberof ArrowData.PandasStyler
         * @instance
         */
        PandasStyler.prototype.displayValues = $util.newBuffer([]);

        /**
         * Creates a new PandasStyler instance using the specified properties.
         * @function create
         * @memberof ArrowData.PandasStyler
         * @static
         * @param {ArrowData.PandasStyler.$Properties=} [properties] Properties to set
         * @returns {ArrowData.PandasStyler} PandasStyler instance
         * @type {{
         *   (properties: ArrowData.PandasStyler.$Shape): ArrowData.PandasStyler & ArrowData.PandasStyler.$Shape;
         *   (properties?: ArrowData.PandasStyler.$Properties): ArrowData.PandasStyler;
         * }}
         */
        PandasStyler.create = function(properties) {
            return new PandasStyler(properties);
        };

        /**
         * Encodes the specified PandasStyler message. Does not implicitly {@link ArrowData.PandasStyler.verify|verify} messages.
         * @function encode
         * @memberof ArrowData.PandasStyler
         * @static
         * @param {ArrowData.PandasStyler.$Properties} message PandasStyler message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PandasStyler.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.uuid != null && $Object.hasOwnProperty.call(message, "uuid") && message.uuid !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uuid);
            if (message.caption != null && $Object.hasOwnProperty.call(message, "caption") && message.caption !== "")
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.caption);
            if (message.styles != null && $Object.hasOwnProperty.call(message, "styles") && message.styles !== "")
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.styles);
            if (message.displayValues != null && $Object.hasOwnProperty.call(message, "displayValues") && message.displayValues.length)
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.displayValues);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a PandasStyler message from the specified reader or buffer.
         * @function decode
         * @memberof ArrowData.PandasStyler
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ArrowData.PandasStyler & ArrowData.PandasStyler.$Shape} PandasStyler
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PandasStyler.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.ArrowData.PandasStyler();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.uuid = value;
                        else
                            delete message.uuid;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.caption = value;
                        else
                            delete message.caption;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.styles = value;
                        else
                            delete message.styles;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.bytes()).length)
                            message.displayValues = value;
                        else
                            delete message.displayValues;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a PandasStyler message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ArrowData.PandasStyler
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ArrowData.PandasStyler} PandasStyler
         */
        PandasStyler.fromObject = function (object, _depth) {
            if (object instanceof $root.ArrowData.PandasStyler)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".ArrowData.PandasStyler: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.ArrowData.PandasStyler();
            if (object.uuid != null)
                if (typeof object.uuid !== "string" || object.uuid.length)
                    message.uuid = $String(object.uuid);
            if (object.caption != null)
                if (typeof object.caption !== "string" || object.caption.length)
                    message.caption = $String(object.caption);
            if (object.styles != null)
                if (typeof object.styles !== "string" || object.styles.length)
                    message.styles = $String(object.styles);
            if (object.displayValues != null)
                if (object.displayValues.length)
                    if (typeof object.displayValues === "string")
                        $util.base64.decode(object.displayValues, message.displayValues = $util.newBuffer($util.base64.length(object.displayValues)), 0);
                    else if (object.displayValues.length >= 0)
                        message.displayValues = object.displayValues;
            return message;
        };

        /**
         * Creates a plain object from a PandasStyler message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ArrowData.PandasStyler
         * @static
         * @param {ArrowData.PandasStyler} message PandasStyler
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PandasStyler.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.uuid = "";
                object.caption = "";
                object.styles = "";
                if (options.bytes === $String)
                    object.displayValues = "";
                else {
                    object.displayValues = [];
                    if (options.bytes !== $Array)
                        object.displayValues = $util.newBuffer(object.displayValues);
                }
            }
            if (message.uuid != null && $Object.hasOwnProperty.call(message, "uuid"))
                object.uuid = message.uuid;
            if (message.caption != null && $Object.hasOwnProperty.call(message, "caption"))
                object.caption = message.caption;
            if (message.styles != null && $Object.hasOwnProperty.call(message, "styles"))
                object.styles = message.styles;
            if (message.displayValues != null && $Object.hasOwnProperty.call(message, "displayValues"))
                object.displayValues = options.bytes === $String ? $util.base64.encode(message.displayValues, 0, message.displayValues.length) : options.bytes === $Array ? $Array.prototype.slice.call(message.displayValues) : message.displayValues;
            return object;
        };

        /**
         * Converts this PandasStyler to JSON.
         * @function toJSON
         * @memberof ArrowData.PandasStyler
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PandasStyler.prototype.toJSON = function() {
            return PandasStyler.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for PandasStyler
         * @function getTypeUrl
         * @memberof ArrowData.PandasStyler
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        PandasStyler.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/ArrowData.PandasStyler";
        };

        return PandasStyler;
    })();

    return ArrowData;
})();

export const ArrowNamedDataSet = $root.ArrowNamedDataSet = (() => {

    /**
     * Properties of an ArrowNamedDataSet.
     * @typedef {Object} ArrowNamedDataSet.$Properties
     * @property {string|null} [name] ArrowNamedDataSet name
     * @property {boolean|null} [hasName] ArrowNamedDataSet hasName
     * @property {ArrowData.$Properties|null} [data] ArrowNamedDataSet data
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an ArrowNamedDataSet.
     * @exports IArrowNamedDataSet
     * @interface IArrowNamedDataSet
     * @augments ArrowNamedDataSet.$Properties
     * @deprecated Use ArrowNamedDataSet.$Properties instead.
     */

    /**
     * Shape of an ArrowNamedDataSet.
     * @typedef {ArrowNamedDataSet.$Properties} ArrowNamedDataSet.$Shape
     */

    /**
     * Constructs a new ArrowNamedDataSet.
     * @exports ArrowNamedDataSet
     * @classdesc Represents an ArrowNamedDataSet.
     * @constructor
     * @param {ArrowNamedDataSet.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ArrowNamedDataSet = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ArrowNamedDataSet name.
     * @member {string} name
     * @memberof ArrowNamedDataSet
     * @instance
     */
    ArrowNamedDataSet.prototype.name = "";

    /**
     * ArrowNamedDataSet hasName.
     * @member {boolean} hasName
     * @memberof ArrowNamedDataSet
     * @instance
     */
    ArrowNamedDataSet.prototype.hasName = false;

    /**
     * ArrowNamedDataSet data.
     * @member {ArrowData.$Properties|null|undefined} data
     * @memberof ArrowNamedDataSet
     * @instance
     */
    ArrowNamedDataSet.prototype.data = null;

    /**
     * Creates a new ArrowNamedDataSet instance using the specified properties.
     * @function create
     * @memberof ArrowNamedDataSet
     * @static
     * @param {ArrowNamedDataSet.$Properties=} [properties] Properties to set
     * @returns {ArrowNamedDataSet} ArrowNamedDataSet instance
     * @type {{
     *   (properties: ArrowNamedDataSet.$Shape): ArrowNamedDataSet & ArrowNamedDataSet.$Shape;
     *   (properties?: ArrowNamedDataSet.$Properties): ArrowNamedDataSet;
     * }}
     */
    ArrowNamedDataSet.create = function(properties) {
        return new ArrowNamedDataSet(properties);
    };

    /**
     * Encodes the specified ArrowNamedDataSet message. Does not implicitly {@link ArrowNamedDataSet.verify|verify} messages.
     * @function encode
     * @memberof ArrowNamedDataSet
     * @static
     * @param {ArrowNamedDataSet.$Properties} message ArrowNamedDataSet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ArrowNamedDataSet.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            $root.ArrowData.encode(message.data, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.hasName != null && $Object.hasOwnProperty.call(message, "hasName") && message.hasName !== false)
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.hasName);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an ArrowNamedDataSet message from the specified reader or buffer.
     * @function decode
     * @memberof ArrowNamedDataSet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ArrowNamedDataSet & ArrowNamedDataSet.$Shape} ArrowNamedDataSet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ArrowNamedDataSet.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ArrowNamedDataSet();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.name = value;
                    else
                        delete message.name;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hasName = value;
                    else
                        delete message.hasName;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    message.data = $root.ArrowData.decode(reader, reader.uint32(), $undefined, _depth + 1, message.data);
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an ArrowNamedDataSet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ArrowNamedDataSet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ArrowNamedDataSet} ArrowNamedDataSet
     */
    ArrowNamedDataSet.fromObject = function (object, _depth) {
        if (object instanceof $root.ArrowNamedDataSet)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ArrowNamedDataSet: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ArrowNamedDataSet();
        if (object.name != null)
            if (typeof object.name !== "string" || object.name.length)
                message.name = $String(object.name);
        if (object.hasName != null)
            if (object.hasName)
                message.hasName = $Boolean(object.hasName);
        if (object.data != null) {
            if (!$util.isObject(object.data))
                throw $TypeError(".ArrowNamedDataSet.data: object expected");
            message.data = $root.ArrowData.fromObject(object.data, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from an ArrowNamedDataSet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ArrowNamedDataSet
     * @static
     * @param {ArrowNamedDataSet} message ArrowNamedDataSet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ArrowNamedDataSet.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.name = "";
            object.data = null;
            object.hasName = false;
        }
        if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
            object.name = message.name;
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            object.data = $root.ArrowData.toObject(message.data, options, _depth + 1);
        if (message.hasName != null && $Object.hasOwnProperty.call(message, "hasName"))
            object.hasName = message.hasName;
        return object;
    };

    /**
     * Converts this ArrowNamedDataSet to JSON.
     * @function toJSON
     * @memberof ArrowNamedDataSet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ArrowNamedDataSet.prototype.toJSON = function() {
        return ArrowNamedDataSet.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ArrowNamedDataSet
     * @function getTypeUrl
     * @memberof ArrowNamedDataSet
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ArrowNamedDataSet.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ArrowNamedDataSet";
    };

    return ArrowNamedDataSet;
})();

export const Audio = $root.Audio = (() => {

    /**
     * Properties of an Audio.
     * @typedef {Object} Audio.$Properties
     * @property {string|null} [url] Audio url
     * @property {number|null} [startTime] Audio startTime
     * @property {number|null} [endTime] Audio endTime
     * @property {boolean|null} [loop] Audio loop
     * @property {boolean|null} [autoplay] Audio autoplay
     * @property {string|null} [id] Audio id
     * @property {streamlit.WidthConfig.$Properties|null} [widthConfig] Audio widthConfig
     * @property {string|null} [alt] Audio alt
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an Audio.
     * @exports IAudio
     * @interface IAudio
     * @augments Audio.$Properties
     * @deprecated Use Audio.$Properties instead.
     */

    /**
     * Shape of an Audio.
     * @typedef {{
     *   url?: string|null;
     *   startTime?: number|null;
     *   endTime?: number|null;
     *   loop?: boolean|null;
     *   autoplay?: boolean|null;
     *   id?: string|null;
     *   widthConfig?: streamlit.WidthConfig.$Shape|null;
     *   alt?: string|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} Audio.$Shape
     */

    /**
     * Constructs a new Audio.
     * @exports Audio
     * @classdesc Represents an Audio.
     * @constructor
     * @param {Audio.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Audio = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Audio url.
     * @member {string} url
     * @memberof Audio
     * @instance
     */
    Audio.prototype.url = "";

    /**
     * Audio startTime.
     * @member {number} startTime
     * @memberof Audio
     * @instance
     */
    Audio.prototype.startTime = 0;

    /**
     * Audio endTime.
     * @member {number} endTime
     * @memberof Audio
     * @instance
     */
    Audio.prototype.endTime = 0;

    /**
     * Audio loop.
     * @member {boolean} loop
     * @memberof Audio
     * @instance
     */
    Audio.prototype.loop = false;

    /**
     * Audio autoplay.
     * @member {boolean} autoplay
     * @memberof Audio
     * @instance
     */
    Audio.prototype.autoplay = false;

    /**
     * Audio id.
     * @member {string} id
     * @memberof Audio
     * @instance
     */
    Audio.prototype.id = "";

    /**
     * Audio widthConfig.
     * @member {streamlit.WidthConfig.$Properties|null|undefined} widthConfig
     * @memberof Audio
     * @instance
     */
    Audio.prototype.widthConfig = null;

    /**
     * Audio alt.
     * @member {string|null|undefined} alt
     * @memberof Audio
     * @instance
     */
    Audio.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Audio.prototype, "_widthConfig", {
        get: $util.oneOfGetter($oneOfFields = ["widthConfig"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Audio.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Audio instance using the specified properties.
     * @function create
     * @memberof Audio
     * @static
     * @param {Audio.$Properties=} [properties] Properties to set
     * @returns {Audio} Audio instance
     * @type {{
     *   (properties: Audio.$Shape): Audio & Audio.$Shape;
     *   (properties?: Audio.$Properties): Audio;
     * }}
     */
    Audio.create = function(properties) {
        return new Audio(properties);
    };

    /**
     * Encodes the specified Audio message. Does not implicitly {@link Audio.verify|verify} messages.
     * @function encode
     * @memberof Audio
     * @static
     * @param {Audio.$Properties} message Audio message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Audio.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.startTime != null && $Object.hasOwnProperty.call(message, "startTime") && message.startTime !== 0)
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.startTime);
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.url);
        if (message.endTime != null && $Object.hasOwnProperty.call(message, "endTime") && message.endTime !== 0)
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.endTime);
        if (message.loop != null && $Object.hasOwnProperty.call(message, "loop") && message.loop !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.loop);
        if (message.autoplay != null && $Object.hasOwnProperty.call(message, "autoplay") && message.autoplay !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.autoplay);
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.id);
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            $root.streamlit.WidthConfig.encode(message.widthConfig, writer.uint32(/* id 10, wireType 2 =*/82).fork(), _depth + 1).ldelim();
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an Audio message from the specified reader or buffer.
     * @function decode
     * @memberof Audio
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Audio & Audio.$Shape} Audio
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Audio.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Audio();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.startTime = value;
                    else
                        delete message.startTime;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.endTime = value;
                    else
                        delete message.endTime;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.loop = value;
                    else
                        delete message.loop;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.autoplay = value;
                    else
                        delete message.autoplay;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.widthConfig = $root.streamlit.WidthConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.widthConfig);
                    message._widthConfig = "widthConfig";
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an Audio message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Audio
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Audio} Audio
     */
    Audio.fromObject = function (object, _depth) {
        if (object instanceof $root.Audio)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Audio: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Audio();
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        if (object.startTime != null)
            if ($Number(object.startTime) !== 0)
                message.startTime = object.startTime | 0;
        if (object.endTime != null)
            if ($Number(object.endTime) !== 0)
                message.endTime = object.endTime | 0;
        if (object.loop != null)
            if (object.loop)
                message.loop = $Boolean(object.loop);
        if (object.autoplay != null)
            if (object.autoplay)
                message.autoplay = $Boolean(object.autoplay);
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.widthConfig != null) {
            if (!$util.isObject(object.widthConfig))
                throw $TypeError(".Audio.widthConfig: object expected");
            message.widthConfig = $root.streamlit.WidthConfig.fromObject(object.widthConfig, _depth + 1);
        }
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from an Audio message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Audio
     * @static
     * @param {Audio} message Audio
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Audio.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.startTime = 0;
            object.url = "";
            object.endTime = 0;
            object.loop = false;
            object.autoplay = false;
            object.id = "";
        }
        if (message.startTime != null && $Object.hasOwnProperty.call(message, "startTime"))
            object.startTime = message.startTime;
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        if (message.endTime != null && $Object.hasOwnProperty.call(message, "endTime"))
            object.endTime = message.endTime;
        if (message.loop != null && $Object.hasOwnProperty.call(message, "loop"))
            object.loop = message.loop;
        if (message.autoplay != null && $Object.hasOwnProperty.call(message, "autoplay"))
            object.autoplay = message.autoplay;
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            object.widthConfig = $root.streamlit.WidthConfig.toObject(message.widthConfig, options, _depth + 1);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this Audio to JSON.
     * @function toJSON
     * @memberof Audio
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Audio.prototype.toJSON = function() {
        return Audio.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Audio
     * @function getTypeUrl
     * @memberof Audio
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Audio.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Audio";
    };

    return Audio;
})();

export const AudioInput = $root.AudioInput = (() => {

    /**
     * Properties of an AudioInput.
     * @typedef {Object} AudioInput.$Properties
     * @property {string|null} [id] AudioInput id
     * @property {string|null} [label] AudioInput label
     * @property {string|null} [help] AudioInput help
     * @property {string|null} [formId] AudioInput formId
     * @property {boolean|null} [disabled] AudioInput disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] AudioInput labelVisibility
     * @property {number|null} [sampleRate] AudioInput sampleRate
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an AudioInput.
     * @exports IAudioInput
     * @interface IAudioInput
     * @augments AudioInput.$Properties
     * @deprecated Use AudioInput.$Properties instead.
     */

    /**
     * Shape of an AudioInput.
     * @typedef {AudioInput.$Properties} AudioInput.$Shape
     */

    /**
     * Constructs a new AudioInput.
     * @exports AudioInput
     * @classdesc Represents an AudioInput.
     * @constructor
     * @param {AudioInput.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const AudioInput = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * AudioInput id.
     * @member {string} id
     * @memberof AudioInput
     * @instance
     */
    AudioInput.prototype.id = "";

    /**
     * AudioInput label.
     * @member {string} label
     * @memberof AudioInput
     * @instance
     */
    AudioInput.prototype.label = "";

    /**
     * AudioInput help.
     * @member {string} help
     * @memberof AudioInput
     * @instance
     */
    AudioInput.prototype.help = "";

    /**
     * AudioInput formId.
     * @member {string} formId
     * @memberof AudioInput
     * @instance
     */
    AudioInput.prototype.formId = "";

    /**
     * AudioInput disabled.
     * @member {boolean} disabled
     * @memberof AudioInput
     * @instance
     */
    AudioInput.prototype.disabled = false;

    /**
     * AudioInput labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof AudioInput
     * @instance
     */
    AudioInput.prototype.labelVisibility = null;

    /**
     * AudioInput sampleRate.
     * @member {number|null|undefined} sampleRate
     * @memberof AudioInput
     * @instance
     */
    AudioInput.prototype.sampleRate = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(AudioInput.prototype, "_sampleRate", {
        get: $util.oneOfGetter($oneOfFields = ["sampleRate"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new AudioInput instance using the specified properties.
     * @function create
     * @memberof AudioInput
     * @static
     * @param {AudioInput.$Properties=} [properties] Properties to set
     * @returns {AudioInput} AudioInput instance
     * @type {{
     *   (properties: AudioInput.$Shape): AudioInput & AudioInput.$Shape;
     *   (properties?: AudioInput.$Properties): AudioInput;
     * }}
     */
    AudioInput.create = function(properties) {
        return new AudioInput(properties);
    };

    /**
     * Encodes the specified AudioInput message. Does not implicitly {@link AudioInput.verify|verify} messages.
     * @function encode
     * @memberof AudioInput
     * @static
     * @param {AudioInput.$Properties} message AudioInput message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AudioInput.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.formId);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
        if (message.sampleRate != null && $Object.hasOwnProperty.call(message, "sampleRate"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.sampleRate);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an AudioInput message from the specified reader or buffer.
     * @function decode
     * @memberof AudioInput
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AudioInput & AudioInput.$Shape} AudioInput
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AudioInput.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.AudioInput();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    message.sampleRate = reader.int32();
                    message._sampleRate = "sampleRate";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an AudioInput message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AudioInput
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AudioInput} AudioInput
     */
    AudioInput.fromObject = function (object, _depth) {
        if (object instanceof $root.AudioInput)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".AudioInput: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.AudioInput();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".AudioInput.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.sampleRate != null)
            message.sampleRate = object.sampleRate | 0;
        return message;
    };

    /**
     * Creates a plain object from an AudioInput message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AudioInput
     * @static
     * @param {AudioInput} message AudioInput
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AudioInput.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.help = "";
            object.formId = "";
            object.disabled = false;
            object.labelVisibility = null;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.sampleRate != null && $Object.hasOwnProperty.call(message, "sampleRate"))
            object.sampleRate = message.sampleRate;
        return object;
    };

    /**
     * Converts this AudioInput to JSON.
     * @function toJSON
     * @memberof AudioInput
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AudioInput.prototype.toJSON = function() {
        return AudioInput.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for AudioInput
     * @function getTypeUrl
     * @memberof AudioInput
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    AudioInput.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/AudioInput";
    };

    return AudioInput;
})();

export const LabelVisibility = $root.LabelVisibility = (() => {

    /**
     * Properties of a LabelVisibility.
     * @typedef {Object} LabelVisibility.$Properties
     * @property {LabelVisibility.LabelVisibilityOptions|null} [value] LabelVisibility value
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a LabelVisibility.
     * @exports ILabelVisibility
     * @interface ILabelVisibility
     * @augments LabelVisibility.$Properties
     * @deprecated Use LabelVisibility.$Properties instead.
     */

    /**
     * Shape of a LabelVisibility.
     * @typedef {LabelVisibility.$Properties} LabelVisibility.$Shape
     */

    /**
     * Constructs a new LabelVisibility.
     * @exports LabelVisibility
     * @classdesc Represents a LabelVisibility.
     * @constructor
     * @param {LabelVisibility.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const LabelVisibility = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * LabelVisibility value.
     * @member {LabelVisibility.LabelVisibilityOptions} value
     * @memberof LabelVisibility
     * @instance
     */
    LabelVisibility.prototype.value = 0;

    /**
     * Creates a new LabelVisibility instance using the specified properties.
     * @function create
     * @memberof LabelVisibility
     * @static
     * @param {LabelVisibility.$Properties=} [properties] Properties to set
     * @returns {LabelVisibility} LabelVisibility instance
     * @type {{
     *   (properties: LabelVisibility.$Shape): LabelVisibility & LabelVisibility.$Shape;
     *   (properties?: LabelVisibility.$Properties): LabelVisibility;
     * }}
     */
    LabelVisibility.create = function(properties) {
        return new LabelVisibility(properties);
    };

    /**
     * Encodes the specified LabelVisibility message. Does not implicitly {@link LabelVisibility.verify|verify} messages.
     * @function encode
     * @memberof LabelVisibility
     * @static
     * @param {LabelVisibility.$Properties} message LabelVisibility message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LabelVisibility.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.value != null && $Object.hasOwnProperty.call(message, "value") && message.value !== 0)
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a LabelVisibility message from the specified reader or buffer.
     * @function decode
     * @memberof LabelVisibility
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LabelVisibility & LabelVisibility.$Shape} LabelVisibility
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LabelVisibility.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.LabelVisibility();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.value = value;
                    else
                        delete message.value;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a LabelVisibility message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LabelVisibility
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LabelVisibility} LabelVisibility
     */
    LabelVisibility.fromObject = function (object, _depth) {
        if (object instanceof $root.LabelVisibility)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".LabelVisibility: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.LabelVisibility();
        if (object.value !== 0 && (typeof object.value !== "string" || $root.LabelVisibility.LabelVisibilityOptions[object.value] !== 0))
            switch (object.value) {
            case "VISIBLE":
            case 0:
                message.value = 0;
                break;
            case "HIDDEN":
            case 1:
                message.value = 1;
                break;
            case "COLLAPSED":
            case 2:
                message.value = 2;
                break;
            default:
                if (typeof object.value === "number" && (object.value | 0) === object.value)
                    message.value = object.value;
            }
        return message;
    };

    /**
     * Creates a plain object from a LabelVisibility message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LabelVisibility
     * @static
     * @param {LabelVisibility} message LabelVisibility
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LabelVisibility.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.value = options.enums === $String ? "VISIBLE" : 0;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = options.enums === $String ? $root.LabelVisibility.LabelVisibilityOptions[message.value] === $undefined ? message.value : $root.LabelVisibility.LabelVisibilityOptions[message.value] : message.value;
        return object;
    };

    /**
     * Converts this LabelVisibility to JSON.
     * @function toJSON
     * @memberof LabelVisibility
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LabelVisibility.prototype.toJSON = function() {
        return LabelVisibility.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for LabelVisibility
     * @function getTypeUrl
     * @memberof LabelVisibility
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    LabelVisibility.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/LabelVisibility";
    };

    /**
     * LabelVisibilityOptions enum.
     * @name LabelVisibility.LabelVisibilityOptions
     * @enum {number}
     * @property {number} VISIBLE=0 VISIBLE value
     * @property {number} HIDDEN=1 HIDDEN value
     * @property {number} COLLAPSED=2 COLLAPSED value
     */
    LabelVisibility.LabelVisibilityOptions = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "VISIBLE"] = 0;
        values[valuesById[1] = "HIDDEN"] = 1;
        values[valuesById[2] = "COLLAPSED"] = 2;
        return values;
    })();

    return LabelVisibility;
})();

export const AuthRedirect = $root.AuthRedirect = (() => {

    /**
     * Properties of an AuthRedirect.
     * @typedef {Object} AuthRedirect.$Properties
     * @property {string|null} [url] AuthRedirect url
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an AuthRedirect.
     * @exports IAuthRedirect
     * @interface IAuthRedirect
     * @augments AuthRedirect.$Properties
     * @deprecated Use AuthRedirect.$Properties instead.
     */

    /**
     * Shape of an AuthRedirect.
     * @typedef {AuthRedirect.$Properties} AuthRedirect.$Shape
     */

    /**
     * Constructs a new AuthRedirect.
     * @exports AuthRedirect
     * @classdesc Represents an AuthRedirect.
     * @constructor
     * @param {AuthRedirect.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const AuthRedirect = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * AuthRedirect url.
     * @member {string} url
     * @memberof AuthRedirect
     * @instance
     */
    AuthRedirect.prototype.url = "";

    /**
     * Creates a new AuthRedirect instance using the specified properties.
     * @function create
     * @memberof AuthRedirect
     * @static
     * @param {AuthRedirect.$Properties=} [properties] Properties to set
     * @returns {AuthRedirect} AuthRedirect instance
     * @type {{
     *   (properties: AuthRedirect.$Shape): AuthRedirect & AuthRedirect.$Shape;
     *   (properties?: AuthRedirect.$Properties): AuthRedirect;
     * }}
     */
    AuthRedirect.create = function(properties) {
        return new AuthRedirect(properties);
    };

    /**
     * Encodes the specified AuthRedirect message. Does not implicitly {@link AuthRedirect.verify|verify} messages.
     * @function encode
     * @memberof AuthRedirect
     * @static
     * @param {AuthRedirect.$Properties} message AuthRedirect message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AuthRedirect.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an AuthRedirect message from the specified reader or buffer.
     * @function decode
     * @memberof AuthRedirect
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AuthRedirect & AuthRedirect.$Shape} AuthRedirect
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AuthRedirect.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.AuthRedirect();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an AuthRedirect message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AuthRedirect
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AuthRedirect} AuthRedirect
     */
    AuthRedirect.fromObject = function (object, _depth) {
        if (object instanceof $root.AuthRedirect)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".AuthRedirect: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.AuthRedirect();
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        return message;
    };

    /**
     * Creates a plain object from an AuthRedirect message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AuthRedirect
     * @static
     * @param {AuthRedirect} message AuthRedirect
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AuthRedirect.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.url = "";
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        return object;
    };

    /**
     * Converts this AuthRedirect to JSON.
     * @function toJSON
     * @memberof AuthRedirect
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AuthRedirect.prototype.toJSON = function() {
        return AuthRedirect.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for AuthRedirect
     * @function getTypeUrl
     * @memberof AuthRedirect
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    AuthRedirect.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/AuthRedirect";
    };

    return AuthRedirect;
})();

export const AutoRerun = $root.AutoRerun = (() => {

    /**
     * Properties of an AutoRerun.
     * @typedef {Object} AutoRerun.$Properties
     * @property {number|null} [interval] AutoRerun interval
     * @property {string|null} [fragmentId] AutoRerun fragmentId
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an AutoRerun.
     * @exports IAutoRerun
     * @interface IAutoRerun
     * @augments AutoRerun.$Properties
     * @deprecated Use AutoRerun.$Properties instead.
     */

    /**
     * Shape of an AutoRerun.
     * @typedef {AutoRerun.$Properties} AutoRerun.$Shape
     */

    /**
     * Constructs a new AutoRerun.
     * @exports AutoRerun
     * @classdesc Represents an AutoRerun.
     * @constructor
     * @param {AutoRerun.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const AutoRerun = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * AutoRerun interval.
     * @member {number} interval
     * @memberof AutoRerun
     * @instance
     */
    AutoRerun.prototype.interval = 0;

    /**
     * AutoRerun fragmentId.
     * @member {string} fragmentId
     * @memberof AutoRerun
     * @instance
     */
    AutoRerun.prototype.fragmentId = "";

    /**
     * Creates a new AutoRerun instance using the specified properties.
     * @function create
     * @memberof AutoRerun
     * @static
     * @param {AutoRerun.$Properties=} [properties] Properties to set
     * @returns {AutoRerun} AutoRerun instance
     * @type {{
     *   (properties: AutoRerun.$Shape): AutoRerun & AutoRerun.$Shape;
     *   (properties?: AutoRerun.$Properties): AutoRerun;
     * }}
     */
    AutoRerun.create = function(properties) {
        return new AutoRerun(properties);
    };

    /**
     * Encodes the specified AutoRerun message. Does not implicitly {@link AutoRerun.verify|verify} messages.
     * @function encode
     * @memberof AutoRerun
     * @static
     * @param {AutoRerun.$Properties} message AutoRerun message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AutoRerun.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.interval != null && $Object.hasOwnProperty.call(message, "interval") && !$Object.is(message.interval, 0))
            writer.uint32(/* id 1, wireType 5 =*/13).float(message.interval);
        if (message.fragmentId != null && $Object.hasOwnProperty.call(message, "fragmentId") && message.fragmentId !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.fragmentId);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an AutoRerun message from the specified reader or buffer.
     * @function decode
     * @memberof AutoRerun
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AutoRerun & AutoRerun.$Shape} AutoRerun
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AutoRerun.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.AutoRerun();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 5)
                        break;
                    if (!$Object.is(value = reader.float(), 0))
                        message.interval = value;
                    else
                        delete message.interval;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.fragmentId = value;
                    else
                        delete message.fragmentId;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an AutoRerun message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AutoRerun
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AutoRerun} AutoRerun
     */
    AutoRerun.fromObject = function (object, _depth) {
        if (object instanceof $root.AutoRerun)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".AutoRerun: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.AutoRerun();
        if (object.interval != null)
            if (!$Object.is($Number(object.interval), 0))
                message.interval = $Number(object.interval);
        if (object.fragmentId != null)
            if (typeof object.fragmentId !== "string" || object.fragmentId.length)
                message.fragmentId = $String(object.fragmentId);
        return message;
    };

    /**
     * Creates a plain object from an AutoRerun message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AutoRerun
     * @static
     * @param {AutoRerun} message AutoRerun
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AutoRerun.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.interval = 0;
            object.fragmentId = "";
        }
        if (message.interval != null && $Object.hasOwnProperty.call(message, "interval"))
            object.interval = options.json && !$isFinite(message.interval) ? $String(message.interval) : message.interval;
        if (message.fragmentId != null && $Object.hasOwnProperty.call(message, "fragmentId"))
            object.fragmentId = message.fragmentId;
        return object;
    };

    /**
     * Converts this AutoRerun to JSON.
     * @function toJSON
     * @memberof AutoRerun
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AutoRerun.prototype.toJSON = function() {
        return AutoRerun.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for AutoRerun
     * @function getTypeUrl
     * @memberof AutoRerun
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    AutoRerun.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/AutoRerun";
    };

    return AutoRerun;
})();

export const StopAutoRerun = $root.StopAutoRerun = (() => {

    /**
     * Properties of a StopAutoRerun.
     * @typedef {Object} StopAutoRerun.$Properties
     * @property {Array.<string>|null} [fragmentIds] StopAutoRerun fragmentIds
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a StopAutoRerun.
     * @exports IStopAutoRerun
     * @interface IStopAutoRerun
     * @augments StopAutoRerun.$Properties
     * @deprecated Use StopAutoRerun.$Properties instead.
     */

    /**
     * Shape of a StopAutoRerun.
     * @typedef {StopAutoRerun.$Properties} StopAutoRerun.$Shape
     */

    /**
     * Constructs a new StopAutoRerun.
     * @exports StopAutoRerun
     * @classdesc Represents a StopAutoRerun.
     * @constructor
     * @param {StopAutoRerun.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const StopAutoRerun = function (properties) {
        this.fragmentIds = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * StopAutoRerun fragmentIds.
     * @member {Array.<string>} fragmentIds
     * @memberof StopAutoRerun
     * @instance
     */
    StopAutoRerun.prototype.fragmentIds = $util.emptyArray;

    /**
     * Creates a new StopAutoRerun instance using the specified properties.
     * @function create
     * @memberof StopAutoRerun
     * @static
     * @param {StopAutoRerun.$Properties=} [properties] Properties to set
     * @returns {StopAutoRerun} StopAutoRerun instance
     * @type {{
     *   (properties: StopAutoRerun.$Shape): StopAutoRerun & StopAutoRerun.$Shape;
     *   (properties?: StopAutoRerun.$Properties): StopAutoRerun;
     * }}
     */
    StopAutoRerun.create = function(properties) {
        return new StopAutoRerun(properties);
    };

    /**
     * Encodes the specified StopAutoRerun message. Does not implicitly {@link StopAutoRerun.verify|verify} messages.
     * @function encode
     * @memberof StopAutoRerun
     * @static
     * @param {StopAutoRerun.$Properties} message StopAutoRerun message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StopAutoRerun.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.fragmentIds != null && message.fragmentIds.length)
            for (let i = 0; i < message.fragmentIds.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fragmentIds[i]);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a StopAutoRerun message from the specified reader or buffer.
     * @function decode
     * @memberof StopAutoRerun
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StopAutoRerun & StopAutoRerun.$Shape} StopAutoRerun
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StopAutoRerun.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.StopAutoRerun();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if (!(message.fragmentIds && message.fragmentIds.length))
                        message.fragmentIds = [];
                    message.fragmentIds.push(reader.stringVerify());
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a StopAutoRerun message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StopAutoRerun
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StopAutoRerun} StopAutoRerun
     */
    StopAutoRerun.fromObject = function (object, _depth) {
        if (object instanceof $root.StopAutoRerun)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".StopAutoRerun: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.StopAutoRerun();
        if (object.fragmentIds) {
            if (!$Array.isArray(object.fragmentIds))
                throw $TypeError(".StopAutoRerun.fragmentIds: array expected");
            message.fragmentIds = $Array(object.fragmentIds.length);
            for (let i = 0; i < object.fragmentIds.length; ++i)
                message.fragmentIds[i] = $String(object.fragmentIds[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a StopAutoRerun message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StopAutoRerun
     * @static
     * @param {StopAutoRerun} message StopAutoRerun
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StopAutoRerun.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.fragmentIds = [];
        if (message.fragmentIds && message.fragmentIds.length) {
            object.fragmentIds = $Array(message.fragmentIds.length);
            for (let j = 0; j < message.fragmentIds.length; ++j)
                object.fragmentIds[j] = message.fragmentIds[j];
        }
        return object;
    };

    /**
     * Converts this StopAutoRerun to JSON.
     * @function toJSON
     * @memberof StopAutoRerun
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StopAutoRerun.prototype.toJSON = function() {
        return StopAutoRerun.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for StopAutoRerun
     * @function getTypeUrl
     * @memberof StopAutoRerun
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    StopAutoRerun.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/StopAutoRerun";
    };

    return StopAutoRerun;
})();

export const BackMsg = $root.BackMsg = (() => {

    /**
     * Properties of a BackMsg.
     * @typedef {Object} BackMsg.$Properties
     * @property {boolean|null} [clearCache] BackMsg clearCache
     * @property {boolean|null} [setRunOnSave] BackMsg setRunOnSave
     * @property {boolean|null} [stopScript] BackMsg stopScript
     * @property {ClientState.$Properties|null} [rerunScript] BackMsg rerunScript
     * @property {boolean|null} [loadGitInfo] BackMsg loadGitInfo
     * @property {boolean|null} [debugDisconnectWebsocket] BackMsg debugDisconnectWebsocket
     * @property {boolean|null} [debugShutdownRuntime] BackMsg debugShutdownRuntime
     * @property {FileURLsRequest.$Properties|null} [fileUrlsRequest] BackMsg fileUrlsRequest
     * @property {boolean|null} [appHeartbeat] BackMsg appHeartbeat
     * @property {BackendOperationRequest.$Properties|null} [backendOperationRequest] BackMsg backendOperationRequest
     * @property {string|null} [debugLastBackmsgId] BackMsg debugLastBackmsgId
     * @property {"clearCache"|"setRunOnSave"|"stopScript"|"rerunScript"|"loadGitInfo"|"debugDisconnectWebsocket"|"debugShutdownRuntime"|"fileUrlsRequest"|"appHeartbeat"|"backendOperationRequest"} [type] BackMsg type
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a BackMsg.
     * @exports IBackMsg
     * @interface IBackMsg
     * @augments BackMsg.$Properties
     * @deprecated Use BackMsg.$Properties instead.
     */

    /**
     * Narrowed shape of a BackMsg.
     * @typedef {{
     *   clearCache?: boolean|null;
     *   setRunOnSave?: boolean|null;
     *   stopScript?: boolean|null;
     *   rerunScript?: ClientState.$Shape|null;
     *   loadGitInfo?: boolean|null;
     *   debugDisconnectWebsocket?: boolean|null;
     *   debugShutdownRuntime?: boolean|null;
     *   fileUrlsRequest?: FileURLsRequest.$Shape|null;
     *   appHeartbeat?: boolean|null;
     *   backendOperationRequest?: BackendOperationRequest.$Shape|null;
     *   debugLastBackmsgId?: string|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ type?: undefined; clearCache?: null; setRunOnSave?: null; stopScript?: null; rerunScript?: null; loadGitInfo?: null; debugDisconnectWebsocket?: null; debugShutdownRuntime?: null; fileUrlsRequest?: null; appHeartbeat?: null; backendOperationRequest?: null }|{ type?: "clearCache"; clearCache: boolean; setRunOnSave?: null; stopScript?: null; rerunScript?: null; loadGitInfo?: null; debugDisconnectWebsocket?: null; debugShutdownRuntime?: null; fileUrlsRequest?: null; appHeartbeat?: null; backendOperationRequest?: null }|{ type?: "setRunOnSave"; clearCache?: null; setRunOnSave: boolean; stopScript?: null; rerunScript?: null; loadGitInfo?: null; debugDisconnectWebsocket?: null; debugShutdownRuntime?: null; fileUrlsRequest?: null; appHeartbeat?: null; backendOperationRequest?: null }|{ type?: "stopScript"; clearCache?: null; setRunOnSave?: null; stopScript: boolean; rerunScript?: null; loadGitInfo?: null; debugDisconnectWebsocket?: null; debugShutdownRuntime?: null; fileUrlsRequest?: null; appHeartbeat?: null; backendOperationRequest?: null }|{ type?: "rerunScript"; clearCache?: null; setRunOnSave?: null; stopScript?: null; rerunScript: ClientState.$Shape; loadGitInfo?: null; debugDisconnectWebsocket?: null; debugShutdownRuntime?: null; fileUrlsRequest?: null; appHeartbeat?: null; backendOperationRequest?: null }|{ type?: "loadGitInfo"; clearCache?: null; setRunOnSave?: null; stopScript?: null; rerunScript?: null; loadGitInfo: boolean; debugDisconnectWebsocket?: null; debugShutdownRuntime?: null; fileUrlsRequest?: null; appHeartbeat?: null; backendOperationRequest?: null }|{ type?: "debugDisconnectWebsocket"; clearCache?: null; setRunOnSave?: null; stopScript?: null; rerunScript?: null; loadGitInfo?: null; debugDisconnectWebsocket: boolean; debugShutdownRuntime?: null; fileUrlsRequest?: null; appHeartbeat?: null; backendOperationRequest?: null }|{ type?: "debugShutdownRuntime"; clearCache?: null; setRunOnSave?: null; stopScript?: null; rerunScript?: null; loadGitInfo?: null; debugDisconnectWebsocket?: null; debugShutdownRuntime: boolean; fileUrlsRequest?: null; appHeartbeat?: null; backendOperationRequest?: null }|{ type?: "fileUrlsRequest"; clearCache?: null; setRunOnSave?: null; stopScript?: null; rerunScript?: null; loadGitInfo?: null; debugDisconnectWebsocket?: null; debugShutdownRuntime?: null; fileUrlsRequest: FileURLsRequest.$Shape; appHeartbeat?: null; backendOperationRequest?: null }|{ type?: "appHeartbeat"; clearCache?: null; setRunOnSave?: null; stopScript?: null; rerunScript?: null; loadGitInfo?: null; debugDisconnectWebsocket?: null; debugShutdownRuntime?: null; fileUrlsRequest?: null; appHeartbeat: boolean; backendOperationRequest?: null }|{ type?: "backendOperationRequest"; clearCache?: null; setRunOnSave?: null; stopScript?: null; rerunScript?: null; loadGitInfo?: null; debugDisconnectWebsocket?: null; debugShutdownRuntime?: null; fileUrlsRequest?: null; appHeartbeat?: null; backendOperationRequest: BackendOperationRequest.$Shape })
     * )} BackMsg.$Shape
     */

    /**
     * Constructs a new BackMsg.
     * @exports BackMsg
     * @classdesc Represents a BackMsg.
     * @constructor
     * @param {BackMsg.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const BackMsg = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * BackMsg clearCache.
     * @member {boolean|null|undefined} clearCache
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.clearCache = null;

    /**
     * BackMsg setRunOnSave.
     * @member {boolean|null|undefined} setRunOnSave
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.setRunOnSave = null;

    /**
     * BackMsg stopScript.
     * @member {boolean|null|undefined} stopScript
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.stopScript = null;

    /**
     * BackMsg rerunScript.
     * @member {ClientState.$Properties|null|undefined} rerunScript
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.rerunScript = null;

    /**
     * BackMsg loadGitInfo.
     * @member {boolean|null|undefined} loadGitInfo
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.loadGitInfo = null;

    /**
     * BackMsg debugDisconnectWebsocket.
     * @member {boolean|null|undefined} debugDisconnectWebsocket
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.debugDisconnectWebsocket = null;

    /**
     * BackMsg debugShutdownRuntime.
     * @member {boolean|null|undefined} debugShutdownRuntime
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.debugShutdownRuntime = null;

    /**
     * BackMsg fileUrlsRequest.
     * @member {FileURLsRequest.$Properties|null|undefined} fileUrlsRequest
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.fileUrlsRequest = null;

    /**
     * BackMsg appHeartbeat.
     * @member {boolean|null|undefined} appHeartbeat
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.appHeartbeat = null;

    /**
     * BackMsg backendOperationRequest.
     * @member {BackendOperationRequest.$Properties|null|undefined} backendOperationRequest
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.backendOperationRequest = null;

    /**
     * BackMsg debugLastBackmsgId.
     * @member {string} debugLastBackmsgId
     * @memberof BackMsg
     * @instance
     */
    BackMsg.prototype.debugLastBackmsgId = "";

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * BackMsg type.
     * @member {"clearCache"|"setRunOnSave"|"stopScript"|"rerunScript"|"loadGitInfo"|"debugDisconnectWebsocket"|"debugShutdownRuntime"|"fileUrlsRequest"|"appHeartbeat"|"backendOperationRequest"|undefined} type
     * @memberof BackMsg
     * @instance
     */
    $Object.defineProperty(BackMsg.prototype, "type", {
        get: $util.oneOfGetter($oneOfFields = ["clearCache", "setRunOnSave", "stopScript", "rerunScript", "loadGitInfo", "debugDisconnectWebsocket", "debugShutdownRuntime", "fileUrlsRequest", "appHeartbeat", "backendOperationRequest"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new BackMsg instance using the specified properties.
     * @function create
     * @memberof BackMsg
     * @static
     * @param {BackMsg.$Properties=} [properties] Properties to set
     * @returns {BackMsg} BackMsg instance
     * @type {{
     *   (properties: BackMsg.$Shape): BackMsg & BackMsg.$Shape;
     *   (properties?: BackMsg.$Properties): BackMsg;
     * }}
     */
    BackMsg.create = function(properties) {
        return new BackMsg(properties);
    };

    /**
     * Encodes the specified BackMsg message. Does not implicitly {@link BackMsg.verify|verify} messages.
     * @function encode
     * @memberof BackMsg
     * @static
     * @param {BackMsg.$Properties} message BackMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BackMsg.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.clearCache != null && $Object.hasOwnProperty.call(message, "clearCache"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.clearCache);
        if (message.setRunOnSave != null && $Object.hasOwnProperty.call(message, "setRunOnSave"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.setRunOnSave);
        if (message.stopScript != null && $Object.hasOwnProperty.call(message, "stopScript"))
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.stopScript);
        if (message.rerunScript != null && $Object.hasOwnProperty.call(message, "rerunScript"))
            $root.ClientState.encode(message.rerunScript, writer.uint32(/* id 11, wireType 2 =*/90).fork(), _depth + 1).ldelim();
        if (message.loadGitInfo != null && $Object.hasOwnProperty.call(message, "loadGitInfo"))
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.loadGitInfo);
        if (message.debugLastBackmsgId != null && $Object.hasOwnProperty.call(message, "debugLastBackmsgId") && message.debugLastBackmsgId !== "")
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.debugLastBackmsgId);
        if (message.debugDisconnectWebsocket != null && $Object.hasOwnProperty.call(message, "debugDisconnectWebsocket"))
            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.debugDisconnectWebsocket);
        if (message.debugShutdownRuntime != null && $Object.hasOwnProperty.call(message, "debugShutdownRuntime"))
            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.debugShutdownRuntime);
        if (message.fileUrlsRequest != null && $Object.hasOwnProperty.call(message, "fileUrlsRequest"))
            $root.FileURLsRequest.encode(message.fileUrlsRequest, writer.uint32(/* id 16, wireType 2 =*/130).fork(), _depth + 1).ldelim();
        if (message.appHeartbeat != null && $Object.hasOwnProperty.call(message, "appHeartbeat"))
            writer.uint32(/* id 17, wireType 0 =*/136).bool(message.appHeartbeat);
        if (message.backendOperationRequest != null && $Object.hasOwnProperty.call(message, "backendOperationRequest"))
            $root.BackendOperationRequest.encode(message.backendOperationRequest, writer.uint32(/* id 19, wireType 2 =*/154).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a BackMsg message from the specified reader or buffer.
     * @function decode
     * @memberof BackMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BackMsg & BackMsg.$Shape} BackMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BackMsg.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.BackMsg();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 5: {
                    if (wireType !== 0)
                        break;
                    message.clearCache = reader.bool();
                    message.type = "clearCache";
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    message.setRunOnSave = reader.bool();
                    message.type = "setRunOnSave";
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    message.stopScript = reader.bool();
                    message.type = "stopScript";
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.rerunScript = $root.ClientState.decode(reader, reader.uint32(), $undefined, _depth + 1, message.rerunScript);
                    message.type = "rerunScript";
                    continue;
                }
            case 12: {
                    if (wireType !== 0)
                        break;
                    message.loadGitInfo = reader.bool();
                    message.type = "loadGitInfo";
                    continue;
                }
            case 14: {
                    if (wireType !== 0)
                        break;
                    message.debugDisconnectWebsocket = reader.bool();
                    message.type = "debugDisconnectWebsocket";
                    continue;
                }
            case 15: {
                    if (wireType !== 0)
                        break;
                    message.debugShutdownRuntime = reader.bool();
                    message.type = "debugShutdownRuntime";
                    continue;
                }
            case 16: {
                    if (wireType !== 2)
                        break;
                    message.fileUrlsRequest = $root.FileURLsRequest.decode(reader, reader.uint32(), $undefined, _depth + 1, message.fileUrlsRequest);
                    message.type = "fileUrlsRequest";
                    continue;
                }
            case 17: {
                    if (wireType !== 0)
                        break;
                    message.appHeartbeat = reader.bool();
                    message.type = "appHeartbeat";
                    continue;
                }
            case 19: {
                    if (wireType !== 2)
                        break;
                    message.backendOperationRequest = $root.BackendOperationRequest.decode(reader, reader.uint32(), $undefined, _depth + 1, message.backendOperationRequest);
                    message.type = "backendOperationRequest";
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.debugLastBackmsgId = value;
                    else
                        delete message.debugLastBackmsgId;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a BackMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BackMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BackMsg} BackMsg
     */
    BackMsg.fromObject = function (object, _depth) {
        if (object instanceof $root.BackMsg)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".BackMsg: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.BackMsg();
        if (object.clearCache != null)
            message.clearCache = $Boolean(object.clearCache);
        if (object.setRunOnSave != null)
            message.setRunOnSave = $Boolean(object.setRunOnSave);
        if (object.stopScript != null)
            message.stopScript = $Boolean(object.stopScript);
        if (object.rerunScript != null) {
            if (!$util.isObject(object.rerunScript))
                throw $TypeError(".BackMsg.rerunScript: object expected");
            message.rerunScript = $root.ClientState.fromObject(object.rerunScript, _depth + 1);
        }
        if (object.loadGitInfo != null)
            message.loadGitInfo = $Boolean(object.loadGitInfo);
        if (object.debugDisconnectWebsocket != null)
            message.debugDisconnectWebsocket = $Boolean(object.debugDisconnectWebsocket);
        if (object.debugShutdownRuntime != null)
            message.debugShutdownRuntime = $Boolean(object.debugShutdownRuntime);
        if (object.fileUrlsRequest != null) {
            if (!$util.isObject(object.fileUrlsRequest))
                throw $TypeError(".BackMsg.fileUrlsRequest: object expected");
            message.fileUrlsRequest = $root.FileURLsRequest.fromObject(object.fileUrlsRequest, _depth + 1);
        }
        if (object.appHeartbeat != null)
            message.appHeartbeat = $Boolean(object.appHeartbeat);
        if (object.backendOperationRequest != null) {
            if (!$util.isObject(object.backendOperationRequest))
                throw $TypeError(".BackMsg.backendOperationRequest: object expected");
            message.backendOperationRequest = $root.BackendOperationRequest.fromObject(object.backendOperationRequest, _depth + 1);
        }
        if (object.debugLastBackmsgId != null)
            if (typeof object.debugLastBackmsgId !== "string" || object.debugLastBackmsgId.length)
                message.debugLastBackmsgId = $String(object.debugLastBackmsgId);
        return message;
    };

    /**
     * Creates a plain object from a BackMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BackMsg
     * @static
     * @param {BackMsg} message BackMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BackMsg.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.debugLastBackmsgId = "";
        if (message.clearCache != null && $Object.hasOwnProperty.call(message, "clearCache")) {
            object.clearCache = message.clearCache;
            if (options.oneofs)
                object.type = "clearCache";
        }
        if (message.setRunOnSave != null && $Object.hasOwnProperty.call(message, "setRunOnSave")) {
            object.setRunOnSave = message.setRunOnSave;
            if (options.oneofs)
                object.type = "setRunOnSave";
        }
        if (message.stopScript != null && $Object.hasOwnProperty.call(message, "stopScript")) {
            object.stopScript = message.stopScript;
            if (options.oneofs)
                object.type = "stopScript";
        }
        if (message.rerunScript != null && $Object.hasOwnProperty.call(message, "rerunScript")) {
            object.rerunScript = $root.ClientState.toObject(message.rerunScript, options, _depth + 1);
            if (options.oneofs)
                object.type = "rerunScript";
        }
        if (message.loadGitInfo != null && $Object.hasOwnProperty.call(message, "loadGitInfo")) {
            object.loadGitInfo = message.loadGitInfo;
            if (options.oneofs)
                object.type = "loadGitInfo";
        }
        if (message.debugLastBackmsgId != null && $Object.hasOwnProperty.call(message, "debugLastBackmsgId"))
            object.debugLastBackmsgId = message.debugLastBackmsgId;
        if (message.debugDisconnectWebsocket != null && $Object.hasOwnProperty.call(message, "debugDisconnectWebsocket")) {
            object.debugDisconnectWebsocket = message.debugDisconnectWebsocket;
            if (options.oneofs)
                object.type = "debugDisconnectWebsocket";
        }
        if (message.debugShutdownRuntime != null && $Object.hasOwnProperty.call(message, "debugShutdownRuntime")) {
            object.debugShutdownRuntime = message.debugShutdownRuntime;
            if (options.oneofs)
                object.type = "debugShutdownRuntime";
        }
        if (message.fileUrlsRequest != null && $Object.hasOwnProperty.call(message, "fileUrlsRequest")) {
            object.fileUrlsRequest = $root.FileURLsRequest.toObject(message.fileUrlsRequest, options, _depth + 1);
            if (options.oneofs)
                object.type = "fileUrlsRequest";
        }
        if (message.appHeartbeat != null && $Object.hasOwnProperty.call(message, "appHeartbeat")) {
            object.appHeartbeat = message.appHeartbeat;
            if (options.oneofs)
                object.type = "appHeartbeat";
        }
        if (message.backendOperationRequest != null && $Object.hasOwnProperty.call(message, "backendOperationRequest")) {
            object.backendOperationRequest = $root.BackendOperationRequest.toObject(message.backendOperationRequest, options, _depth + 1);
            if (options.oneofs)
                object.type = "backendOperationRequest";
        }
        return object;
    };

    /**
     * Converts this BackMsg to JSON.
     * @function toJSON
     * @memberof BackMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BackMsg.prototype.toJSON = function() {
        return BackMsg.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for BackMsg
     * @function getTypeUrl
     * @memberof BackMsg
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    BackMsg.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/BackMsg";
    };

    return BackMsg;
})();

export const BackendOperationRequest = $root.BackendOperationRequest = (() => {

    /**
     * Properties of a BackendOperationRequest.
     * @typedef {Object} BackendOperationRequest.$Properties
     * @property {string|null} [requestId] BackendOperationRequest requestId
     * @property {string|null} [sessionId] BackendOperationRequest sessionId
     * @property {DeferredFileRequestPayload.$Properties|null} [deferredFile] BackendOperationRequest deferredFile
     * @property {InstallSkillsRequestPayload.$Properties|null} [installSkills] BackendOperationRequest installSkills
     * @property {DismissSkillsNudgeRequestPayload.$Properties|null} [dismissSkillsNudge] BackendOperationRequest dismissSkillsNudge
     * @property {DataframeChunkRequestPayload.$Properties|null} [dataframeChunk] BackendOperationRequest dataframeChunk
     * @property {"deferredFile"|"installSkills"|"dismissSkillsNudge"|"dataframeChunk"} [payload] BackendOperationRequest payload
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a BackendOperationRequest.
     * @exports IBackendOperationRequest
     * @interface IBackendOperationRequest
     * @augments BackendOperationRequest.$Properties
     * @deprecated Use BackendOperationRequest.$Properties instead.
     */

    /**
     * Narrowed shape of a BackendOperationRequest.
     * @typedef {{
     *   requestId?: string|null;
     *   sessionId?: string|null;
     *   deferredFile?: DeferredFileRequestPayload.$Shape|null;
     *   installSkills?: InstallSkillsRequestPayload.$Shape|null;
     *   dismissSkillsNudge?: DismissSkillsNudgeRequestPayload.$Shape|null;
     *   dataframeChunk?: DataframeChunkRequestPayload.$Shape|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ payload?: undefined; deferredFile?: null; installSkills?: null; dismissSkillsNudge?: null; dataframeChunk?: null }|{ payload?: "deferredFile"; deferredFile: DeferredFileRequestPayload.$Shape; installSkills?: null; dismissSkillsNudge?: null; dataframeChunk?: null }|{ payload?: "installSkills"; deferredFile?: null; installSkills: InstallSkillsRequestPayload.$Shape; dismissSkillsNudge?: null; dataframeChunk?: null }|{ payload?: "dismissSkillsNudge"; deferredFile?: null; installSkills?: null; dismissSkillsNudge: DismissSkillsNudgeRequestPayload.$Shape; dataframeChunk?: null }|{ payload?: "dataframeChunk"; deferredFile?: null; installSkills?: null; dismissSkillsNudge?: null; dataframeChunk: DataframeChunkRequestPayload.$Shape })
     * )} BackendOperationRequest.$Shape
     */

    /**
     * Constructs a new BackendOperationRequest.
     * @exports BackendOperationRequest
     * @classdesc Represents a BackendOperationRequest.
     * @constructor
     * @param {BackendOperationRequest.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const BackendOperationRequest = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * BackendOperationRequest requestId.
     * @member {string} requestId
     * @memberof BackendOperationRequest
     * @instance
     */
    BackendOperationRequest.prototype.requestId = "";

    /**
     * BackendOperationRequest sessionId.
     * @member {string} sessionId
     * @memberof BackendOperationRequest
     * @instance
     */
    BackendOperationRequest.prototype.sessionId = "";

    /**
     * BackendOperationRequest deferredFile.
     * @member {DeferredFileRequestPayload.$Properties|null|undefined} deferredFile
     * @memberof BackendOperationRequest
     * @instance
     */
    BackendOperationRequest.prototype.deferredFile = null;

    /**
     * BackendOperationRequest installSkills.
     * @member {InstallSkillsRequestPayload.$Properties|null|undefined} installSkills
     * @memberof BackendOperationRequest
     * @instance
     */
    BackendOperationRequest.prototype.installSkills = null;

    /**
     * BackendOperationRequest dismissSkillsNudge.
     * @member {DismissSkillsNudgeRequestPayload.$Properties|null|undefined} dismissSkillsNudge
     * @memberof BackendOperationRequest
     * @instance
     */
    BackendOperationRequest.prototype.dismissSkillsNudge = null;

    /**
     * BackendOperationRequest dataframeChunk.
     * @member {DataframeChunkRequestPayload.$Properties|null|undefined} dataframeChunk
     * @memberof BackendOperationRequest
     * @instance
     */
    BackendOperationRequest.prototype.dataframeChunk = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * BackendOperationRequest payload.
     * @member {"deferredFile"|"installSkills"|"dismissSkillsNudge"|"dataframeChunk"|undefined} payload
     * @memberof BackendOperationRequest
     * @instance
     */
    $Object.defineProperty(BackendOperationRequest.prototype, "payload", {
        get: $util.oneOfGetter($oneOfFields = ["deferredFile", "installSkills", "dismissSkillsNudge", "dataframeChunk"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new BackendOperationRequest instance using the specified properties.
     * @function create
     * @memberof BackendOperationRequest
     * @static
     * @param {BackendOperationRequest.$Properties=} [properties] Properties to set
     * @returns {BackendOperationRequest} BackendOperationRequest instance
     * @type {{
     *   (properties: BackendOperationRequest.$Shape): BackendOperationRequest & BackendOperationRequest.$Shape;
     *   (properties?: BackendOperationRequest.$Properties): BackendOperationRequest;
     * }}
     */
    BackendOperationRequest.create = function(properties) {
        return new BackendOperationRequest(properties);
    };

    /**
     * Encodes the specified BackendOperationRequest message. Does not implicitly {@link BackendOperationRequest.verify|verify} messages.
     * @function encode
     * @memberof BackendOperationRequest
     * @static
     * @param {BackendOperationRequest.$Properties} message BackendOperationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BackendOperationRequest.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.requestId != null && $Object.hasOwnProperty.call(message, "requestId") && message.requestId !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
        if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId") && message.sessionId !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.sessionId);
        if (message.deferredFile != null && $Object.hasOwnProperty.call(message, "deferredFile"))
            $root.DeferredFileRequestPayload.encode(message.deferredFile, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
        if (message.installSkills != null && $Object.hasOwnProperty.call(message, "installSkills"))
            $root.InstallSkillsRequestPayload.encode(message.installSkills, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
        if (message.dismissSkillsNudge != null && $Object.hasOwnProperty.call(message, "dismissSkillsNudge"))
            $root.DismissSkillsNudgeRequestPayload.encode(message.dismissSkillsNudge, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
        if (message.dataframeChunk != null && $Object.hasOwnProperty.call(message, "dataframeChunk"))
            $root.DataframeChunkRequestPayload.encode(message.dataframeChunk, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a BackendOperationRequest message from the specified reader or buffer.
     * @function decode
     * @memberof BackendOperationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BackendOperationRequest & BackendOperationRequest.$Shape} BackendOperationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BackendOperationRequest.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.BackendOperationRequest();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.requestId = value;
                    else
                        delete message.requestId;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.sessionId = value;
                    else
                        delete message.sessionId;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.deferredFile = $root.DeferredFileRequestPayload.decode(reader, reader.uint32(), $undefined, _depth + 1, message.deferredFile);
                    message.payload = "deferredFile";
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.installSkills = $root.InstallSkillsRequestPayload.decode(reader, reader.uint32(), $undefined, _depth + 1, message.installSkills);
                    message.payload = "installSkills";
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.dismissSkillsNudge = $root.DismissSkillsNudgeRequestPayload.decode(reader, reader.uint32(), $undefined, _depth + 1, message.dismissSkillsNudge);
                    message.payload = "dismissSkillsNudge";
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.dataframeChunk = $root.DataframeChunkRequestPayload.decode(reader, reader.uint32(), $undefined, _depth + 1, message.dataframeChunk);
                    message.payload = "dataframeChunk";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a BackendOperationRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BackendOperationRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BackendOperationRequest} BackendOperationRequest
     */
    BackendOperationRequest.fromObject = function (object, _depth) {
        if (object instanceof $root.BackendOperationRequest)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".BackendOperationRequest: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.BackendOperationRequest();
        if (object.requestId != null)
            if (typeof object.requestId !== "string" || object.requestId.length)
                message.requestId = $String(object.requestId);
        if (object.sessionId != null)
            if (typeof object.sessionId !== "string" || object.sessionId.length)
                message.sessionId = $String(object.sessionId);
        if (object.deferredFile != null) {
            if (!$util.isObject(object.deferredFile))
                throw $TypeError(".BackendOperationRequest.deferredFile: object expected");
            message.deferredFile = $root.DeferredFileRequestPayload.fromObject(object.deferredFile, _depth + 1);
        }
        if (object.installSkills != null) {
            if (!$util.isObject(object.installSkills))
                throw $TypeError(".BackendOperationRequest.installSkills: object expected");
            message.installSkills = $root.InstallSkillsRequestPayload.fromObject(object.installSkills, _depth + 1);
        }
        if (object.dismissSkillsNudge != null) {
            if (!$util.isObject(object.dismissSkillsNudge))
                throw $TypeError(".BackendOperationRequest.dismissSkillsNudge: object expected");
            message.dismissSkillsNudge = $root.DismissSkillsNudgeRequestPayload.fromObject(object.dismissSkillsNudge, _depth + 1);
        }
        if (object.dataframeChunk != null) {
            if (!$util.isObject(object.dataframeChunk))
                throw $TypeError(".BackendOperationRequest.dataframeChunk: object expected");
            message.dataframeChunk = $root.DataframeChunkRequestPayload.fromObject(object.dataframeChunk, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a BackendOperationRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BackendOperationRequest
     * @static
     * @param {BackendOperationRequest} message BackendOperationRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BackendOperationRequest.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.requestId = "";
            object.sessionId = "";
        }
        if (message.requestId != null && $Object.hasOwnProperty.call(message, "requestId"))
            object.requestId = message.requestId;
        if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId"))
            object.sessionId = message.sessionId;
        if (message.deferredFile != null && $Object.hasOwnProperty.call(message, "deferredFile")) {
            object.deferredFile = $root.DeferredFileRequestPayload.toObject(message.deferredFile, options, _depth + 1);
            if (options.oneofs)
                object.payload = "deferredFile";
        }
        if (message.installSkills != null && $Object.hasOwnProperty.call(message, "installSkills")) {
            object.installSkills = $root.InstallSkillsRequestPayload.toObject(message.installSkills, options, _depth + 1);
            if (options.oneofs)
                object.payload = "installSkills";
        }
        if (message.dismissSkillsNudge != null && $Object.hasOwnProperty.call(message, "dismissSkillsNudge")) {
            object.dismissSkillsNudge = $root.DismissSkillsNudgeRequestPayload.toObject(message.dismissSkillsNudge, options, _depth + 1);
            if (options.oneofs)
                object.payload = "dismissSkillsNudge";
        }
        if (message.dataframeChunk != null && $Object.hasOwnProperty.call(message, "dataframeChunk")) {
            object.dataframeChunk = $root.DataframeChunkRequestPayload.toObject(message.dataframeChunk, options, _depth + 1);
            if (options.oneofs)
                object.payload = "dataframeChunk";
        }
        return object;
    };

    /**
     * Converts this BackendOperationRequest to JSON.
     * @function toJSON
     * @memberof BackendOperationRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BackendOperationRequest.prototype.toJSON = function() {
        return BackendOperationRequest.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for BackendOperationRequest
     * @function getTypeUrl
     * @memberof BackendOperationRequest
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    BackendOperationRequest.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/BackendOperationRequest";
    };

    return BackendOperationRequest;
})();

export const DeferredFileRequestPayload = $root.DeferredFileRequestPayload = (() => {

    /**
     * Properties of a DeferredFileRequestPayload.
     * @typedef {Object} DeferredFileRequestPayload.$Properties
     * @property {string|null} [fileId] DeferredFileRequestPayload fileId
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DeferredFileRequestPayload.
     * @exports IDeferredFileRequestPayload
     * @interface IDeferredFileRequestPayload
     * @augments DeferredFileRequestPayload.$Properties
     * @deprecated Use DeferredFileRequestPayload.$Properties instead.
     */

    /**
     * Shape of a DeferredFileRequestPayload.
     * @typedef {DeferredFileRequestPayload.$Properties} DeferredFileRequestPayload.$Shape
     */

    /**
     * Constructs a new DeferredFileRequestPayload.
     * @exports DeferredFileRequestPayload
     * @classdesc Represents a DeferredFileRequestPayload.
     * @constructor
     * @param {DeferredFileRequestPayload.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DeferredFileRequestPayload = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * DeferredFileRequestPayload fileId.
     * @member {string} fileId
     * @memberof DeferredFileRequestPayload
     * @instance
     */
    DeferredFileRequestPayload.prototype.fileId = "";

    /**
     * Creates a new DeferredFileRequestPayload instance using the specified properties.
     * @function create
     * @memberof DeferredFileRequestPayload
     * @static
     * @param {DeferredFileRequestPayload.$Properties=} [properties] Properties to set
     * @returns {DeferredFileRequestPayload} DeferredFileRequestPayload instance
     * @type {{
     *   (properties: DeferredFileRequestPayload.$Shape): DeferredFileRequestPayload & DeferredFileRequestPayload.$Shape;
     *   (properties?: DeferredFileRequestPayload.$Properties): DeferredFileRequestPayload;
     * }}
     */
    DeferredFileRequestPayload.create = function(properties) {
        return new DeferredFileRequestPayload(properties);
    };

    /**
     * Encodes the specified DeferredFileRequestPayload message. Does not implicitly {@link DeferredFileRequestPayload.verify|verify} messages.
     * @function encode
     * @memberof DeferredFileRequestPayload
     * @static
     * @param {DeferredFileRequestPayload.$Properties} message DeferredFileRequestPayload message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeferredFileRequestPayload.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.fileId != null && $Object.hasOwnProperty.call(message, "fileId") && message.fileId !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.fileId);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DeferredFileRequestPayload message from the specified reader or buffer.
     * @function decode
     * @memberof DeferredFileRequestPayload
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeferredFileRequestPayload & DeferredFileRequestPayload.$Shape} DeferredFileRequestPayload
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeferredFileRequestPayload.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DeferredFileRequestPayload();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.fileId = value;
                    else
                        delete message.fileId;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DeferredFileRequestPayload message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeferredFileRequestPayload
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeferredFileRequestPayload} DeferredFileRequestPayload
     */
    DeferredFileRequestPayload.fromObject = function (object, _depth) {
        if (object instanceof $root.DeferredFileRequestPayload)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DeferredFileRequestPayload: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.DeferredFileRequestPayload();
        if (object.fileId != null)
            if (typeof object.fileId !== "string" || object.fileId.length)
                message.fileId = $String(object.fileId);
        return message;
    };

    /**
     * Creates a plain object from a DeferredFileRequestPayload message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeferredFileRequestPayload
     * @static
     * @param {DeferredFileRequestPayload} message DeferredFileRequestPayload
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeferredFileRequestPayload.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.fileId = "";
        if (message.fileId != null && $Object.hasOwnProperty.call(message, "fileId"))
            object.fileId = message.fileId;
        return object;
    };

    /**
     * Converts this DeferredFileRequestPayload to JSON.
     * @function toJSON
     * @memberof DeferredFileRequestPayload
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeferredFileRequestPayload.prototype.toJSON = function() {
        return DeferredFileRequestPayload.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DeferredFileRequestPayload
     * @function getTypeUrl
     * @memberof DeferredFileRequestPayload
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DeferredFileRequestPayload.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DeferredFileRequestPayload";
    };

    return DeferredFileRequestPayload;
})();

export const InstallSkillsRequestPayload = $root.InstallSkillsRequestPayload = (() => {

    /**
     * Properties of an InstallSkillsRequestPayload.
     * @typedef {Object} InstallSkillsRequestPayload.$Properties
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an InstallSkillsRequestPayload.
     * @exports IInstallSkillsRequestPayload
     * @interface IInstallSkillsRequestPayload
     * @augments InstallSkillsRequestPayload.$Properties
     * @deprecated Use InstallSkillsRequestPayload.$Properties instead.
     */

    /**
     * Shape of an InstallSkillsRequestPayload.
     * @typedef {InstallSkillsRequestPayload.$Properties} InstallSkillsRequestPayload.$Shape
     */

    /**
     * Constructs a new InstallSkillsRequestPayload.
     * @exports InstallSkillsRequestPayload
     * @classdesc Represents an InstallSkillsRequestPayload.
     * @constructor
     * @param {InstallSkillsRequestPayload.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const InstallSkillsRequestPayload = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Creates a new InstallSkillsRequestPayload instance using the specified properties.
     * @function create
     * @memberof InstallSkillsRequestPayload
     * @static
     * @param {InstallSkillsRequestPayload.$Properties=} [properties] Properties to set
     * @returns {InstallSkillsRequestPayload} InstallSkillsRequestPayload instance
     * @type {{
     *   (properties: InstallSkillsRequestPayload.$Shape): InstallSkillsRequestPayload & InstallSkillsRequestPayload.$Shape;
     *   (properties?: InstallSkillsRequestPayload.$Properties): InstallSkillsRequestPayload;
     * }}
     */
    InstallSkillsRequestPayload.create = function(properties) {
        return new InstallSkillsRequestPayload(properties);
    };

    /**
     * Encodes the specified InstallSkillsRequestPayload message. Does not implicitly {@link InstallSkillsRequestPayload.verify|verify} messages.
     * @function encode
     * @memberof InstallSkillsRequestPayload
     * @static
     * @param {InstallSkillsRequestPayload.$Properties} message InstallSkillsRequestPayload message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstallSkillsRequestPayload.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an InstallSkillsRequestPayload message from the specified reader or buffer.
     * @function decode
     * @memberof InstallSkillsRequestPayload
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InstallSkillsRequestPayload & InstallSkillsRequestPayload.$Shape} InstallSkillsRequestPayload
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstallSkillsRequestPayload.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.InstallSkillsRequestPayload();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            reader.skipType(tag & 7, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an InstallSkillsRequestPayload message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InstallSkillsRequestPayload
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InstallSkillsRequestPayload} InstallSkillsRequestPayload
     */
    InstallSkillsRequestPayload.fromObject = function (object, _depth) {
        if (object instanceof $root.InstallSkillsRequestPayload)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".InstallSkillsRequestPayload: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        return new $root.InstallSkillsRequestPayload();
    };

    /**
     * Creates a plain object from an InstallSkillsRequestPayload message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InstallSkillsRequestPayload
     * @static
     * @param {InstallSkillsRequestPayload} message InstallSkillsRequestPayload
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InstallSkillsRequestPayload.toObject = function () {
        return {};
    };

    /**
     * Converts this InstallSkillsRequestPayload to JSON.
     * @function toJSON
     * @memberof InstallSkillsRequestPayload
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InstallSkillsRequestPayload.prototype.toJSON = function() {
        return InstallSkillsRequestPayload.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for InstallSkillsRequestPayload
     * @function getTypeUrl
     * @memberof InstallSkillsRequestPayload
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    InstallSkillsRequestPayload.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/InstallSkillsRequestPayload";
    };

    return InstallSkillsRequestPayload;
})();

export const DismissSkillsNudgeRequestPayload = $root.DismissSkillsNudgeRequestPayload = (() => {

    /**
     * Properties of a DismissSkillsNudgeRequestPayload.
     * @typedef {Object} DismissSkillsNudgeRequestPayload.$Properties
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DismissSkillsNudgeRequestPayload.
     * @exports IDismissSkillsNudgeRequestPayload
     * @interface IDismissSkillsNudgeRequestPayload
     * @augments DismissSkillsNudgeRequestPayload.$Properties
     * @deprecated Use DismissSkillsNudgeRequestPayload.$Properties instead.
     */

    /**
     * Shape of a DismissSkillsNudgeRequestPayload.
     * @typedef {DismissSkillsNudgeRequestPayload.$Properties} DismissSkillsNudgeRequestPayload.$Shape
     */

    /**
     * Constructs a new DismissSkillsNudgeRequestPayload.
     * @exports DismissSkillsNudgeRequestPayload
     * @classdesc Represents a DismissSkillsNudgeRequestPayload.
     * @constructor
     * @param {DismissSkillsNudgeRequestPayload.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DismissSkillsNudgeRequestPayload = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Creates a new DismissSkillsNudgeRequestPayload instance using the specified properties.
     * @function create
     * @memberof DismissSkillsNudgeRequestPayload
     * @static
     * @param {DismissSkillsNudgeRequestPayload.$Properties=} [properties] Properties to set
     * @returns {DismissSkillsNudgeRequestPayload} DismissSkillsNudgeRequestPayload instance
     * @type {{
     *   (properties: DismissSkillsNudgeRequestPayload.$Shape): DismissSkillsNudgeRequestPayload & DismissSkillsNudgeRequestPayload.$Shape;
     *   (properties?: DismissSkillsNudgeRequestPayload.$Properties): DismissSkillsNudgeRequestPayload;
     * }}
     */
    DismissSkillsNudgeRequestPayload.create = function(properties) {
        return new DismissSkillsNudgeRequestPayload(properties);
    };

    /**
     * Encodes the specified DismissSkillsNudgeRequestPayload message. Does not implicitly {@link DismissSkillsNudgeRequestPayload.verify|verify} messages.
     * @function encode
     * @memberof DismissSkillsNudgeRequestPayload
     * @static
     * @param {DismissSkillsNudgeRequestPayload.$Properties} message DismissSkillsNudgeRequestPayload message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DismissSkillsNudgeRequestPayload.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DismissSkillsNudgeRequestPayload message from the specified reader or buffer.
     * @function decode
     * @memberof DismissSkillsNudgeRequestPayload
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DismissSkillsNudgeRequestPayload & DismissSkillsNudgeRequestPayload.$Shape} DismissSkillsNudgeRequestPayload
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DismissSkillsNudgeRequestPayload.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DismissSkillsNudgeRequestPayload();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            reader.skipType(tag & 7, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DismissSkillsNudgeRequestPayload message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DismissSkillsNudgeRequestPayload
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DismissSkillsNudgeRequestPayload} DismissSkillsNudgeRequestPayload
     */
    DismissSkillsNudgeRequestPayload.fromObject = function (object, _depth) {
        if (object instanceof $root.DismissSkillsNudgeRequestPayload)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DismissSkillsNudgeRequestPayload: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        return new $root.DismissSkillsNudgeRequestPayload();
    };

    /**
     * Creates a plain object from a DismissSkillsNudgeRequestPayload message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DismissSkillsNudgeRequestPayload
     * @static
     * @param {DismissSkillsNudgeRequestPayload} message DismissSkillsNudgeRequestPayload
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DismissSkillsNudgeRequestPayload.toObject = function () {
        return {};
    };

    /**
     * Converts this DismissSkillsNudgeRequestPayload to JSON.
     * @function toJSON
     * @memberof DismissSkillsNudgeRequestPayload
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DismissSkillsNudgeRequestPayload.prototype.toJSON = function() {
        return DismissSkillsNudgeRequestPayload.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DismissSkillsNudgeRequestPayload
     * @function getTypeUrl
     * @memberof DismissSkillsNudgeRequestPayload
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DismissSkillsNudgeRequestPayload.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DismissSkillsNudgeRequestPayload";
    };

    return DismissSkillsNudgeRequestPayload;
})();

export const DataframeChunkRequestPayload = $root.DataframeChunkRequestPayload = (() => {

    /**
     * Properties of a DataframeChunkRequestPayload.
     * @typedef {Object} DataframeChunkRequestPayload.$Properties
     * @property {string|null} [sourceId] DataframeChunkRequestPayload sourceId
     * @property {number|Long|null} [offset] DataframeChunkRequestPayload offset
     * @property {number|null} [limit] DataframeChunkRequestPayload limit
     * @property {SortState.$Properties|null} [sort] DataframeChunkRequestPayload sort
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DataframeChunkRequestPayload.
     * @exports IDataframeChunkRequestPayload
     * @interface IDataframeChunkRequestPayload
     * @augments DataframeChunkRequestPayload.$Properties
     * @deprecated Use DataframeChunkRequestPayload.$Properties instead.
     */

    /**
     * Shape of a DataframeChunkRequestPayload.
     * @typedef {DataframeChunkRequestPayload.$Properties} DataframeChunkRequestPayload.$Shape
     */

    /**
     * Constructs a new DataframeChunkRequestPayload.
     * @exports DataframeChunkRequestPayload
     * @classdesc Represents a DataframeChunkRequestPayload.
     * @constructor
     * @param {DataframeChunkRequestPayload.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DataframeChunkRequestPayload = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * DataframeChunkRequestPayload sourceId.
     * @member {string} sourceId
     * @memberof DataframeChunkRequestPayload
     * @instance
     */
    DataframeChunkRequestPayload.prototype.sourceId = "";

    /**
     * DataframeChunkRequestPayload offset.
     * @member {number|Long} offset
     * @memberof DataframeChunkRequestPayload
     * @instance
     */
    DataframeChunkRequestPayload.prototype.offset = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * DataframeChunkRequestPayload limit.
     * @member {number} limit
     * @memberof DataframeChunkRequestPayload
     * @instance
     */
    DataframeChunkRequestPayload.prototype.limit = 0;

    /**
     * DataframeChunkRequestPayload sort.
     * @member {SortState.$Properties|null|undefined} sort
     * @memberof DataframeChunkRequestPayload
     * @instance
     */
    DataframeChunkRequestPayload.prototype.sort = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(DataframeChunkRequestPayload.prototype, "_sort", {
        get: $util.oneOfGetter($oneOfFields = ["sort"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new DataframeChunkRequestPayload instance using the specified properties.
     * @function create
     * @memberof DataframeChunkRequestPayload
     * @static
     * @param {DataframeChunkRequestPayload.$Properties=} [properties] Properties to set
     * @returns {DataframeChunkRequestPayload} DataframeChunkRequestPayload instance
     * @type {{
     *   (properties: DataframeChunkRequestPayload.$Shape): DataframeChunkRequestPayload & DataframeChunkRequestPayload.$Shape;
     *   (properties?: DataframeChunkRequestPayload.$Properties): DataframeChunkRequestPayload;
     * }}
     */
    DataframeChunkRequestPayload.create = function(properties) {
        return new DataframeChunkRequestPayload(properties);
    };

    /**
     * Encodes the specified DataframeChunkRequestPayload message. Does not implicitly {@link DataframeChunkRequestPayload.verify|verify} messages.
     * @function encode
     * @memberof DataframeChunkRequestPayload
     * @static
     * @param {DataframeChunkRequestPayload.$Properties} message DataframeChunkRequestPayload message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DataframeChunkRequestPayload.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.sourceId != null && $Object.hasOwnProperty.call(message, "sourceId") && message.sourceId !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.sourceId);
        if (message.offset != null && $Object.hasOwnProperty.call(message, "offset") && (typeof message.offset === "object" ? message.offset.low || message.offset.high : message.offset !== 0))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.offset);
        if (message.limit != null && $Object.hasOwnProperty.call(message, "limit") && message.limit !== 0)
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.limit);
        if (message.sort != null && $Object.hasOwnProperty.call(message, "sort"))
            $root.SortState.encode(message.sort, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DataframeChunkRequestPayload message from the specified reader or buffer.
     * @function decode
     * @memberof DataframeChunkRequestPayload
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DataframeChunkRequestPayload & DataframeChunkRequestPayload.$Shape} DataframeChunkRequestPayload
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DataframeChunkRequestPayload.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DataframeChunkRequestPayload();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.sourceId = value;
                    else
                        delete message.sourceId;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                        message.offset = value;
                    else
                        delete message.offset;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message.limit = value;
                    else
                        delete message.limit;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.sort = $root.SortState.decode(reader, reader.uint32(), $undefined, _depth + 1, message.sort);
                    message._sort = "sort";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DataframeChunkRequestPayload message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DataframeChunkRequestPayload
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DataframeChunkRequestPayload} DataframeChunkRequestPayload
     */
    DataframeChunkRequestPayload.fromObject = function (object, _depth) {
        if (object instanceof $root.DataframeChunkRequestPayload)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DataframeChunkRequestPayload: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.DataframeChunkRequestPayload();
        if (object.sourceId != null)
            if (typeof object.sourceId !== "string" || object.sourceId.length)
                message.sourceId = $String(object.sourceId);
        if (object.offset != null)
            if (typeof object.offset === "object" ? object.offset.low || object.offset.high : $Number(object.offset) !== 0)
                if ($util.Long)
                    message.offset = $util.Long.fromValue(object.offset, true);
                else if (typeof object.offset === "string")
                    message.offset = $parseInt(object.offset, 10);
                else if (typeof object.offset === "number")
                    message.offset = object.offset;
                else if (typeof object.offset === "object")
                    message.offset = new $util.LongBits(object.offset.low >>> 0, object.offset.high >>> 0).toNumber(true);
        if (object.limit != null)
            if ($Number(object.limit) !== 0)
                message.limit = object.limit >>> 0;
        if (object.sort != null) {
            if (!$util.isObject(object.sort))
                throw $TypeError(".DataframeChunkRequestPayload.sort: object expected");
            message.sort = $root.SortState.fromObject(object.sort, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a DataframeChunkRequestPayload message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DataframeChunkRequestPayload
     * @static
     * @param {DataframeChunkRequestPayload} message DataframeChunkRequestPayload
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DataframeChunkRequestPayload.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.sourceId = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.offset = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.offset = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            object.limit = 0;
        }
        if (message.sourceId != null && $Object.hasOwnProperty.call(message, "sourceId"))
            object.sourceId = message.sourceId;
        if (message.offset != null && $Object.hasOwnProperty.call(message, "offset"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.offset = typeof message.offset === "number" ? $BigInt(message.offset) : $util.Long.fromBits(message.offset.low >>> 0, message.offset.high >>> 0, true).toBigInt();
            else if (typeof message.offset === "number")
                object.offset = options.longs === $String ? $String(message.offset) : message.offset;
            else
                object.offset = options.longs === $String ? $util.Long.prototype.toString.call(message.offset) : options.longs === $Number ? new $util.LongBits(message.offset.low >>> 0, message.offset.high >>> 0).toNumber(true) : message.offset;
        if (message.limit != null && $Object.hasOwnProperty.call(message, "limit"))
            object.limit = message.limit;
        if (message.sort != null && $Object.hasOwnProperty.call(message, "sort"))
            object.sort = $root.SortState.toObject(message.sort, options, _depth + 1);
        return object;
    };

    /**
     * Converts this DataframeChunkRequestPayload to JSON.
     * @function toJSON
     * @memberof DataframeChunkRequestPayload
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DataframeChunkRequestPayload.prototype.toJSON = function() {
        return DataframeChunkRequestPayload.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DataframeChunkRequestPayload
     * @function getTypeUrl
     * @memberof DataframeChunkRequestPayload
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DataframeChunkRequestPayload.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DataframeChunkRequestPayload";
    };

    return DataframeChunkRequestPayload;
})();

export const ContextInfo = $root.ContextInfo = (() => {

    /**
     * Properties of a ContextInfo.
     * @typedef {Object} ContextInfo.$Properties
     * @property {string|null} [timezone] ContextInfo timezone
     * @property {number|null} [timezoneOffset] ContextInfo timezoneOffset
     * @property {string|null} [locale] ContextInfo locale
     * @property {string|null} [url] ContextInfo url
     * @property {boolean|null} [isEmbedded] ContextInfo isEmbedded
     * @property {string|null} [colorScheme] ContextInfo colorScheme
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ContextInfo.
     * @exports IContextInfo
     * @interface IContextInfo
     * @augments ContextInfo.$Properties
     * @deprecated Use ContextInfo.$Properties instead.
     */

    /**
     * Shape of a ContextInfo.
     * @typedef {ContextInfo.$Properties} ContextInfo.$Shape
     */

    /**
     * Constructs a new ContextInfo.
     * @exports ContextInfo
     * @classdesc Represents a ContextInfo.
     * @constructor
     * @param {ContextInfo.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ContextInfo = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ContextInfo timezone.
     * @member {string|null|undefined} timezone
     * @memberof ContextInfo
     * @instance
     */
    ContextInfo.prototype.timezone = null;

    /**
     * ContextInfo timezoneOffset.
     * @member {number|null|undefined} timezoneOffset
     * @memberof ContextInfo
     * @instance
     */
    ContextInfo.prototype.timezoneOffset = null;

    /**
     * ContextInfo locale.
     * @member {string|null|undefined} locale
     * @memberof ContextInfo
     * @instance
     */
    ContextInfo.prototype.locale = null;

    /**
     * ContextInfo url.
     * @member {string|null|undefined} url
     * @memberof ContextInfo
     * @instance
     */
    ContextInfo.prototype.url = null;

    /**
     * ContextInfo isEmbedded.
     * @member {boolean|null|undefined} isEmbedded
     * @memberof ContextInfo
     * @instance
     */
    ContextInfo.prototype.isEmbedded = null;

    /**
     * ContextInfo colorScheme.
     * @member {string|null|undefined} colorScheme
     * @memberof ContextInfo
     * @instance
     */
    ContextInfo.prototype.colorScheme = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ContextInfo.prototype, "_timezone", {
        get: $util.oneOfGetter($oneOfFields = ["timezone"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ContextInfo.prototype, "_timezoneOffset", {
        get: $util.oneOfGetter($oneOfFields = ["timezoneOffset"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ContextInfo.prototype, "_locale", {
        get: $util.oneOfGetter($oneOfFields = ["locale"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ContextInfo.prototype, "_url", {
        get: $util.oneOfGetter($oneOfFields = ["url"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ContextInfo.prototype, "_isEmbedded", {
        get: $util.oneOfGetter($oneOfFields = ["isEmbedded"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ContextInfo.prototype, "_colorScheme", {
        get: $util.oneOfGetter($oneOfFields = ["colorScheme"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ContextInfo instance using the specified properties.
     * @function create
     * @memberof ContextInfo
     * @static
     * @param {ContextInfo.$Properties=} [properties] Properties to set
     * @returns {ContextInfo} ContextInfo instance
     * @type {{
     *   (properties: ContextInfo.$Shape): ContextInfo & ContextInfo.$Shape;
     *   (properties?: ContextInfo.$Properties): ContextInfo;
     * }}
     */
    ContextInfo.create = function(properties) {
        return new ContextInfo(properties);
    };

    /**
     * Encodes the specified ContextInfo message. Does not implicitly {@link ContextInfo.verify|verify} messages.
     * @function encode
     * @memberof ContextInfo
     * @static
     * @param {ContextInfo.$Properties} message ContextInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContextInfo.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.timezone != null && $Object.hasOwnProperty.call(message, "timezone"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.timezone);
        if (message.timezoneOffset != null && $Object.hasOwnProperty.call(message, "timezoneOffset"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.timezoneOffset);
        if (message.locale != null && $Object.hasOwnProperty.call(message, "locale"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.locale);
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.url);
        if (message.isEmbedded != null && $Object.hasOwnProperty.call(message, "isEmbedded"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isEmbedded);
        if (message.colorScheme != null && $Object.hasOwnProperty.call(message, "colorScheme"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.colorScheme);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ContextInfo message from the specified reader or buffer.
     * @function decode
     * @memberof ContextInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ContextInfo & ContextInfo.$Shape} ContextInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContextInfo.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ContextInfo();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.timezone = reader.stringVerify();
                    message._timezone = "timezone";
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    message.timezoneOffset = reader.int32();
                    message._timezoneOffset = "timezoneOffset";
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.locale = reader.stringVerify();
                    message._locale = "locale";
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.url = reader.stringVerify();
                    message._url = "url";
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    message.isEmbedded = reader.bool();
                    message._isEmbedded = "isEmbedded";
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.colorScheme = reader.stringVerify();
                    message._colorScheme = "colorScheme";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ContextInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ContextInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ContextInfo} ContextInfo
     */
    ContextInfo.fromObject = function (object, _depth) {
        if (object instanceof $root.ContextInfo)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ContextInfo: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ContextInfo();
        if (object.timezone != null)
            message.timezone = $String(object.timezone);
        if (object.timezoneOffset != null)
            message.timezoneOffset = object.timezoneOffset | 0;
        if (object.locale != null)
            message.locale = $String(object.locale);
        if (object.url != null)
            message.url = $String(object.url);
        if (object.isEmbedded != null)
            message.isEmbedded = $Boolean(object.isEmbedded);
        if (object.colorScheme != null)
            message.colorScheme = $String(object.colorScheme);
        return message;
    };

    /**
     * Creates a plain object from a ContextInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ContextInfo
     * @static
     * @param {ContextInfo} message ContextInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ContextInfo.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (message.timezone != null && $Object.hasOwnProperty.call(message, "timezone"))
            object.timezone = message.timezone;
        if (message.timezoneOffset != null && $Object.hasOwnProperty.call(message, "timezoneOffset"))
            object.timezoneOffset = message.timezoneOffset;
        if (message.locale != null && $Object.hasOwnProperty.call(message, "locale"))
            object.locale = message.locale;
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        if (message.isEmbedded != null && $Object.hasOwnProperty.call(message, "isEmbedded"))
            object.isEmbedded = message.isEmbedded;
        if (message.colorScheme != null && $Object.hasOwnProperty.call(message, "colorScheme"))
            object.colorScheme = message.colorScheme;
        return object;
    };

    /**
     * Converts this ContextInfo to JSON.
     * @function toJSON
     * @memberof ContextInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ContextInfo.prototype.toJSON = function() {
        return ContextInfo.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ContextInfo
     * @function getTypeUrl
     * @memberof ContextInfo
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ContextInfo.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ContextInfo";
    };

    return ContextInfo;
})();

export const ClientState = $root.ClientState = (() => {

    /**
     * Properties of a ClientState.
     * @typedef {Object} ClientState.$Properties
     * @property {string|null} [queryString] ClientState queryString
     * @property {WidgetStates.$Properties|null} [widgetStates] ClientState widgetStates
     * @property {string|null} [pageScriptHash] ClientState pageScriptHash
     * @property {string|null} [pageName] ClientState pageName
     * @property {string|null} [fragmentId] ClientState fragmentId
     * @property {boolean|null} [isAutoRerun] ClientState isAutoRerun
     * @property {Array.<string>|null} [cachedMessageHashes] ClientState cachedMessageHashes
     * @property {ContextInfo.$Properties|null} [contextInfo] ClientState contextInfo
     * @property {boolean|null} [isHistoryNavigation] ClientState isHistoryNavigation
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ClientState.
     * @exports IClientState
     * @interface IClientState
     * @augments ClientState.$Properties
     * @deprecated Use ClientState.$Properties instead.
     */

    /**
     * Shape of a ClientState.
     * @typedef {{
     *   queryString?: string|null;
     *   widgetStates?: WidgetStates.$Shape|null;
     *   pageScriptHash?: string|null;
     *   pageName?: string|null;
     *   fragmentId?: string|null;
     *   isAutoRerun?: boolean|null;
     *   cachedMessageHashes?: Array.<string>|null;
     *   contextInfo?: ContextInfo.$Shape|null;
     *   isHistoryNavigation?: boolean|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} ClientState.$Shape
     */

    /**
     * Constructs a new ClientState.
     * @exports ClientState
     * @classdesc Represents a ClientState.
     * @constructor
     * @param {ClientState.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ClientState = function (properties) {
        this.cachedMessageHashes = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ClientState queryString.
     * @member {string} queryString
     * @memberof ClientState
     * @instance
     */
    ClientState.prototype.queryString = "";

    /**
     * ClientState widgetStates.
     * @member {WidgetStates.$Properties|null|undefined} widgetStates
     * @memberof ClientState
     * @instance
     */
    ClientState.prototype.widgetStates = null;

    /**
     * ClientState pageScriptHash.
     * @member {string} pageScriptHash
     * @memberof ClientState
     * @instance
     */
    ClientState.prototype.pageScriptHash = "";

    /**
     * ClientState pageName.
     * @member {string} pageName
     * @memberof ClientState
     * @instance
     */
    ClientState.prototype.pageName = "";

    /**
     * ClientState fragmentId.
     * @member {string} fragmentId
     * @memberof ClientState
     * @instance
     */
    ClientState.prototype.fragmentId = "";

    /**
     * ClientState isAutoRerun.
     * @member {boolean} isAutoRerun
     * @memberof ClientState
     * @instance
     */
    ClientState.prototype.isAutoRerun = false;

    /**
     * ClientState cachedMessageHashes.
     * @member {Array.<string>} cachedMessageHashes
     * @memberof ClientState
     * @instance
     */
    ClientState.prototype.cachedMessageHashes = $util.emptyArray;

    /**
     * ClientState contextInfo.
     * @member {ContextInfo.$Properties|null|undefined} contextInfo
     * @memberof ClientState
     * @instance
     */
    ClientState.prototype.contextInfo = null;

    /**
     * ClientState isHistoryNavigation.
     * @member {boolean} isHistoryNavigation
     * @memberof ClientState
     * @instance
     */
    ClientState.prototype.isHistoryNavigation = false;

    /**
     * Creates a new ClientState instance using the specified properties.
     * @function create
     * @memberof ClientState
     * @static
     * @param {ClientState.$Properties=} [properties] Properties to set
     * @returns {ClientState} ClientState instance
     * @type {{
     *   (properties: ClientState.$Shape): ClientState & ClientState.$Shape;
     *   (properties?: ClientState.$Properties): ClientState;
     * }}
     */
    ClientState.create = function(properties) {
        return new ClientState(properties);
    };

    /**
     * Encodes the specified ClientState message. Does not implicitly {@link ClientState.verify|verify} messages.
     * @function encode
     * @memberof ClientState
     * @static
     * @param {ClientState.$Properties} message ClientState message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientState.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.queryString != null && $Object.hasOwnProperty.call(message, "queryString") && message.queryString !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.queryString);
        if (message.widgetStates != null && $Object.hasOwnProperty.call(message, "widgetStates"))
            $root.WidgetStates.encode(message.widgetStates, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash") && message.pageScriptHash !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageScriptHash);
        if (message.pageName != null && $Object.hasOwnProperty.call(message, "pageName") && message.pageName !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageName);
        if (message.fragmentId != null && $Object.hasOwnProperty.call(message, "fragmentId") && message.fragmentId !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.fragmentId);
        if (message.isAutoRerun != null && $Object.hasOwnProperty.call(message, "isAutoRerun") && message.isAutoRerun !== false)
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isAutoRerun);
        if (message.cachedMessageHashes != null && message.cachedMessageHashes.length)
            for (let i = 0; i < message.cachedMessageHashes.length; ++i)
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.cachedMessageHashes[i]);
        if (message.contextInfo != null && $Object.hasOwnProperty.call(message, "contextInfo"))
            $root.ContextInfo.encode(message.contextInfo, writer.uint32(/* id 8, wireType 2 =*/66).fork(), _depth + 1).ldelim();
        if (message.isHistoryNavigation != null && $Object.hasOwnProperty.call(message, "isHistoryNavigation") && message.isHistoryNavigation !== false)
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isHistoryNavigation);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ClientState message from the specified reader or buffer.
     * @function decode
     * @memberof ClientState
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientState & ClientState.$Shape} ClientState
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientState.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ClientState();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.queryString = value;
                    else
                        delete message.queryString;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    message.widgetStates = $root.WidgetStates.decode(reader, reader.uint32(), $undefined, _depth + 1, message.widgetStates);
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pageScriptHash = value;
                    else
                        delete message.pageScriptHash;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pageName = value;
                    else
                        delete message.pageName;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.fragmentId = value;
                    else
                        delete message.fragmentId;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isAutoRerun = value;
                    else
                        delete message.isAutoRerun;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if (!(message.cachedMessageHashes && message.cachedMessageHashes.length))
                        message.cachedMessageHashes = [];
                    message.cachedMessageHashes.push(reader.stringVerify());
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    message.contextInfo = $root.ContextInfo.decode(reader, reader.uint32(), $undefined, _depth + 1, message.contextInfo);
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isHistoryNavigation = value;
                    else
                        delete message.isHistoryNavigation;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ClientState message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientState
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientState} ClientState
     */
    ClientState.fromObject = function (object, _depth) {
        if (object instanceof $root.ClientState)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ClientState: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ClientState();
        if (object.queryString != null)
            if (typeof object.queryString !== "string" || object.queryString.length)
                message.queryString = $String(object.queryString);
        if (object.widgetStates != null) {
            if (!$util.isObject(object.widgetStates))
                throw $TypeError(".ClientState.widgetStates: object expected");
            message.widgetStates = $root.WidgetStates.fromObject(object.widgetStates, _depth + 1);
        }
        if (object.pageScriptHash != null)
            if (typeof object.pageScriptHash !== "string" || object.pageScriptHash.length)
                message.pageScriptHash = $String(object.pageScriptHash);
        if (object.pageName != null)
            if (typeof object.pageName !== "string" || object.pageName.length)
                message.pageName = $String(object.pageName);
        if (object.fragmentId != null)
            if (typeof object.fragmentId !== "string" || object.fragmentId.length)
                message.fragmentId = $String(object.fragmentId);
        if (object.isAutoRerun != null)
            if (object.isAutoRerun)
                message.isAutoRerun = $Boolean(object.isAutoRerun);
        if (object.cachedMessageHashes) {
            if (!$Array.isArray(object.cachedMessageHashes))
                throw $TypeError(".ClientState.cachedMessageHashes: array expected");
            message.cachedMessageHashes = $Array(object.cachedMessageHashes.length);
            for (let i = 0; i < object.cachedMessageHashes.length; ++i)
                message.cachedMessageHashes[i] = $String(object.cachedMessageHashes[i]);
        }
        if (object.contextInfo != null) {
            if (!$util.isObject(object.contextInfo))
                throw $TypeError(".ClientState.contextInfo: object expected");
            message.contextInfo = $root.ContextInfo.fromObject(object.contextInfo, _depth + 1);
        }
        if (object.isHistoryNavigation != null)
            if (object.isHistoryNavigation)
                message.isHistoryNavigation = $Boolean(object.isHistoryNavigation);
        return message;
    };

    /**
     * Creates a plain object from a ClientState message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientState
     * @static
     * @param {ClientState} message ClientState
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientState.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.cachedMessageHashes = [];
        if (options.defaults) {
            object.queryString = "";
            object.widgetStates = null;
            object.pageScriptHash = "";
            object.pageName = "";
            object.fragmentId = "";
            object.isAutoRerun = false;
            object.contextInfo = null;
            object.isHistoryNavigation = false;
        }
        if (message.queryString != null && $Object.hasOwnProperty.call(message, "queryString"))
            object.queryString = message.queryString;
        if (message.widgetStates != null && $Object.hasOwnProperty.call(message, "widgetStates"))
            object.widgetStates = $root.WidgetStates.toObject(message.widgetStates, options, _depth + 1);
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash"))
            object.pageScriptHash = message.pageScriptHash;
        if (message.pageName != null && $Object.hasOwnProperty.call(message, "pageName"))
            object.pageName = message.pageName;
        if (message.fragmentId != null && $Object.hasOwnProperty.call(message, "fragmentId"))
            object.fragmentId = message.fragmentId;
        if (message.isAutoRerun != null && $Object.hasOwnProperty.call(message, "isAutoRerun"))
            object.isAutoRerun = message.isAutoRerun;
        if (message.cachedMessageHashes && message.cachedMessageHashes.length) {
            object.cachedMessageHashes = $Array(message.cachedMessageHashes.length);
            for (let j = 0; j < message.cachedMessageHashes.length; ++j)
                object.cachedMessageHashes[j] = message.cachedMessageHashes[j];
        }
        if (message.contextInfo != null && $Object.hasOwnProperty.call(message, "contextInfo"))
            object.contextInfo = $root.ContextInfo.toObject(message.contextInfo, options, _depth + 1);
        if (message.isHistoryNavigation != null && $Object.hasOwnProperty.call(message, "isHistoryNavigation"))
            object.isHistoryNavigation = message.isHistoryNavigation;
        return object;
    };

    /**
     * Converts this ClientState to JSON.
     * @function toJSON
     * @memberof ClientState
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientState.prototype.toJSON = function() {
        return ClientState.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ClientState
     * @function getTypeUrl
     * @memberof ClientState
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ClientState.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ClientState";
    };

    return ClientState;
})();

export const WidgetStates = $root.WidgetStates = (() => {

    /**
     * Properties of a WidgetStates.
     * @typedef {Object} WidgetStates.$Properties
     * @property {Array.<WidgetState.$Properties>|null} [widgets] WidgetStates widgets
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a WidgetStates.
     * @exports IWidgetStates
     * @interface IWidgetStates
     * @augments WidgetStates.$Properties
     * @deprecated Use WidgetStates.$Properties instead.
     */

    /**
     * Shape of a WidgetStates.
     * @typedef {{
     *   widgets?: Array.<WidgetState.$Shape>|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} WidgetStates.$Shape
     */

    /**
     * Constructs a new WidgetStates.
     * @exports WidgetStates
     * @classdesc Represents a WidgetStates.
     * @constructor
     * @param {WidgetStates.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const WidgetStates = function (properties) {
        this.widgets = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * WidgetStates widgets.
     * @member {Array.<WidgetState.$Properties>} widgets
     * @memberof WidgetStates
     * @instance
     */
    WidgetStates.prototype.widgets = $util.emptyArray;

    /**
     * Creates a new WidgetStates instance using the specified properties.
     * @function create
     * @memberof WidgetStates
     * @static
     * @param {WidgetStates.$Properties=} [properties] Properties to set
     * @returns {WidgetStates} WidgetStates instance
     * @type {{
     *   (properties: WidgetStates.$Shape): WidgetStates & WidgetStates.$Shape;
     *   (properties?: WidgetStates.$Properties): WidgetStates;
     * }}
     */
    WidgetStates.create = function(properties) {
        return new WidgetStates(properties);
    };

    /**
     * Encodes the specified WidgetStates message. Does not implicitly {@link WidgetStates.verify|verify} messages.
     * @function encode
     * @memberof WidgetStates
     * @static
     * @param {WidgetStates.$Properties} message WidgetStates message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WidgetStates.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.widgets != null && message.widgets.length)
            for (let i = 0; i < message.widgets.length; ++i)
                $root.WidgetState.encode(message.widgets[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a WidgetStates message from the specified reader or buffer.
     * @function decode
     * @memberof WidgetStates
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WidgetStates & WidgetStates.$Shape} WidgetStates
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WidgetStates.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.WidgetStates();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if (!(message.widgets && message.widgets.length))
                        message.widgets = [];
                    message.widgets.push($root.WidgetState.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a WidgetStates message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WidgetStates
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WidgetStates} WidgetStates
     */
    WidgetStates.fromObject = function (object, _depth) {
        if (object instanceof $root.WidgetStates)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".WidgetStates: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.WidgetStates();
        if (object.widgets) {
            if (!$Array.isArray(object.widgets))
                throw $TypeError(".WidgetStates.widgets: array expected");
            message.widgets = $Array(object.widgets.length);
            for (let i = 0; i < object.widgets.length; ++i) {
                if (!$util.isObject(object.widgets[i]))
                    throw $TypeError(".WidgetStates.widgets: object expected");
                message.widgets[i] = $root.WidgetState.fromObject(object.widgets[i], _depth + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a WidgetStates message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WidgetStates
     * @static
     * @param {WidgetStates} message WidgetStates
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WidgetStates.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.widgets = [];
        if (message.widgets && message.widgets.length) {
            object.widgets = $Array(message.widgets.length);
            for (let j = 0; j < message.widgets.length; ++j)
                object.widgets[j] = $root.WidgetState.toObject(message.widgets[j], options, _depth + 1);
        }
        return object;
    };

    /**
     * Converts this WidgetStates to JSON.
     * @function toJSON
     * @memberof WidgetStates
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WidgetStates.prototype.toJSON = function() {
        return WidgetStates.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for WidgetStates
     * @function getTypeUrl
     * @memberof WidgetStates
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    WidgetStates.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/WidgetStates";
    };

    return WidgetStates;
})();

export const WidgetState = $root.WidgetState = (() => {

    /**
     * Properties of a WidgetState.
     * @typedef {Object} WidgetState.$Properties
     * @property {string|null} [id] WidgetState id
     * @property {boolean|null} [triggerValue] WidgetState triggerValue
     * @property {boolean|null} [boolValue] WidgetState boolValue
     * @property {number|null} [doubleValue] WidgetState doubleValue
     * @property {number|Long|null} [intValue] WidgetState intValue
     * @property {string|null} [stringValue] WidgetState stringValue
     * @property {DoubleArray.$Properties|null} [doubleArrayValue] WidgetState doubleArrayValue
     * @property {SInt64Array.$Properties|null} [intArrayValue] WidgetState intArrayValue
     * @property {StringArray.$Properties|null} [stringArrayValue] WidgetState stringArrayValue
     * @property {string|null} [jsonValue] WidgetState jsonValue
     * @property {ArrowTable.$Properties|null} [arrowValue] WidgetState arrowValue
     * @property {Uint8Array|null} [bytesValue] WidgetState bytesValue
     * @property {FileUploaderState.$Properties|null} [fileUploaderStateValue] WidgetState fileUploaderStateValue
     * @property {StringTriggerValue.$Properties|null} [stringTriggerValue] WidgetState stringTriggerValue
     * @property {ChatInputValue.$Properties|null} [chatInputValue] WidgetState chatInputValue
     * @property {string|null} [jsonTriggerValue] WidgetState jsonTriggerValue
     * @property {"triggerValue"|"boolValue"|"doubleValue"|"intValue"|"stringValue"|"doubleArrayValue"|"intArrayValue"|"stringArrayValue"|"jsonValue"|"arrowValue"|"bytesValue"|"fileUploaderStateValue"|"stringTriggerValue"|"chatInputValue"|"jsonTriggerValue"} [value] WidgetState value
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a WidgetState.
     * @exports IWidgetState
     * @interface IWidgetState
     * @augments WidgetState.$Properties
     * @deprecated Use WidgetState.$Properties instead.
     */

    /**
     * Narrowed shape of a WidgetState.
     * @typedef {{
     *   id?: string|null;
     *   triggerValue?: boolean|null;
     *   boolValue?: boolean|null;
     *   doubleValue?: number|null;
     *   intValue?: number|Long|null;
     *   stringValue?: string|null;
     *   doubleArrayValue?: DoubleArray.$Shape|null;
     *   intArrayValue?: SInt64Array.$Shape|null;
     *   stringArrayValue?: StringArray.$Shape|null;
     *   jsonValue?: string|null;
     *   arrowValue?: ArrowTable.$Shape|null;
     *   bytesValue?: Uint8Array|null;
     *   fileUploaderStateValue?: FileUploaderState.$Shape|null;
     *   stringTriggerValue?: StringTriggerValue.$Shape|null;
     *   chatInputValue?: ChatInputValue.$Shape|null;
     *   jsonTriggerValue?: string|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ value?: undefined; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "triggerValue"; triggerValue: boolean; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "boolValue"; triggerValue?: null; boolValue: boolean; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "doubleValue"; triggerValue?: null; boolValue?: null; doubleValue: number; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "intValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue: number|Long; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "stringValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue: string; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "doubleArrayValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue: DoubleArray.$Shape; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "intArrayValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue: SInt64Array.$Shape; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "stringArrayValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue: StringArray.$Shape; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "jsonValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue: string; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "arrowValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue: ArrowTable.$Shape; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "bytesValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue: Uint8Array; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "fileUploaderStateValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue: FileUploaderState.$Shape; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "stringTriggerValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue: StringTriggerValue.$Shape; chatInputValue?: null; jsonTriggerValue?: null }|{ value?: "chatInputValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue: ChatInputValue.$Shape; jsonTriggerValue?: null }|{ value?: "jsonTriggerValue"; triggerValue?: null; boolValue?: null; doubleValue?: null; intValue?: null; stringValue?: null; doubleArrayValue?: null; intArrayValue?: null; stringArrayValue?: null; jsonValue?: null; arrowValue?: null; bytesValue?: null; fileUploaderStateValue?: null; stringTriggerValue?: null; chatInputValue?: null; jsonTriggerValue: string })
     * )} WidgetState.$Shape
     */

    /**
     * Constructs a new WidgetState.
     * @exports WidgetState
     * @classdesc Represents a WidgetState.
     * @constructor
     * @param {WidgetState.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const WidgetState = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * WidgetState id.
     * @member {string} id
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.id = "";

    /**
     * WidgetState triggerValue.
     * @member {boolean|null|undefined} triggerValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.triggerValue = null;

    /**
     * WidgetState boolValue.
     * @member {boolean|null|undefined} boolValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.boolValue = null;

    /**
     * WidgetState doubleValue.
     * @member {number|null|undefined} doubleValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.doubleValue = null;

    /**
     * WidgetState intValue.
     * @member {number|Long|null|undefined} intValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.intValue = null;

    /**
     * WidgetState stringValue.
     * @member {string|null|undefined} stringValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.stringValue = null;

    /**
     * WidgetState doubleArrayValue.
     * @member {DoubleArray.$Properties|null|undefined} doubleArrayValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.doubleArrayValue = null;

    /**
     * WidgetState intArrayValue.
     * @member {SInt64Array.$Properties|null|undefined} intArrayValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.intArrayValue = null;

    /**
     * WidgetState stringArrayValue.
     * @member {StringArray.$Properties|null|undefined} stringArrayValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.stringArrayValue = null;

    /**
     * WidgetState jsonValue.
     * @member {string|null|undefined} jsonValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.jsonValue = null;

    /**
     * WidgetState arrowValue.
     * @member {ArrowTable.$Properties|null|undefined} arrowValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.arrowValue = null;

    /**
     * WidgetState bytesValue.
     * @member {Uint8Array|null|undefined} bytesValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.bytesValue = null;

    /**
     * WidgetState fileUploaderStateValue.
     * @member {FileUploaderState.$Properties|null|undefined} fileUploaderStateValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.fileUploaderStateValue = null;

    /**
     * WidgetState stringTriggerValue.
     * @member {StringTriggerValue.$Properties|null|undefined} stringTriggerValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.stringTriggerValue = null;

    /**
     * WidgetState chatInputValue.
     * @member {ChatInputValue.$Properties|null|undefined} chatInputValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.chatInputValue = null;

    /**
     * WidgetState jsonTriggerValue.
     * @member {string|null|undefined} jsonTriggerValue
     * @memberof WidgetState
     * @instance
     */
    WidgetState.prototype.jsonTriggerValue = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * WidgetState value.
     * @member {"triggerValue"|"boolValue"|"doubleValue"|"intValue"|"stringValue"|"doubleArrayValue"|"intArrayValue"|"stringArrayValue"|"jsonValue"|"arrowValue"|"bytesValue"|"fileUploaderStateValue"|"stringTriggerValue"|"chatInputValue"|"jsonTriggerValue"|undefined} value
     * @memberof WidgetState
     * @instance
     */
    $Object.defineProperty(WidgetState.prototype, "value", {
        get: $util.oneOfGetter($oneOfFields = ["triggerValue", "boolValue", "doubleValue", "intValue", "stringValue", "doubleArrayValue", "intArrayValue", "stringArrayValue", "jsonValue", "arrowValue", "bytesValue", "fileUploaderStateValue", "stringTriggerValue", "chatInputValue", "jsonTriggerValue"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new WidgetState instance using the specified properties.
     * @function create
     * @memberof WidgetState
     * @static
     * @param {WidgetState.$Properties=} [properties] Properties to set
     * @returns {WidgetState} WidgetState instance
     * @type {{
     *   (properties: WidgetState.$Shape): WidgetState & WidgetState.$Shape;
     *   (properties?: WidgetState.$Properties): WidgetState;
     * }}
     */
    WidgetState.create = function(properties) {
        return new WidgetState(properties);
    };

    /**
     * Encodes the specified WidgetState message. Does not implicitly {@link WidgetState.verify|verify} messages.
     * @function encode
     * @memberof WidgetState
     * @static
     * @param {WidgetState.$Properties} message WidgetState message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WidgetState.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.triggerValue != null && $Object.hasOwnProperty.call(message, "triggerValue"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.triggerValue);
        if (message.boolValue != null && $Object.hasOwnProperty.call(message, "boolValue"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.boolValue);
        if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue"))
            writer.uint32(/* id 4, wireType 1 =*/33).double(message.doubleValue);
        if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue"))
            writer.uint32(/* id 5, wireType 0 =*/40).sint64(message.intValue);
        if (message.stringValue != null && $Object.hasOwnProperty.call(message, "stringValue"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.stringValue);
        if (message.doubleArrayValue != null && $Object.hasOwnProperty.call(message, "doubleArrayValue"))
            $root.DoubleArray.encode(message.doubleArrayValue, writer.uint32(/* id 7, wireType 2 =*/58).fork(), _depth + 1).ldelim();
        if (message.intArrayValue != null && $Object.hasOwnProperty.call(message, "intArrayValue"))
            $root.SInt64Array.encode(message.intArrayValue, writer.uint32(/* id 8, wireType 2 =*/66).fork(), _depth + 1).ldelim();
        if (message.stringArrayValue != null && $Object.hasOwnProperty.call(message, "stringArrayValue"))
            $root.StringArray.encode(message.stringArrayValue, writer.uint32(/* id 9, wireType 2 =*/74).fork(), _depth + 1).ldelim();
        if (message.jsonValue != null && $Object.hasOwnProperty.call(message, "jsonValue"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.jsonValue);
        if (message.arrowValue != null && $Object.hasOwnProperty.call(message, "arrowValue"))
            $root.ArrowTable.encode(message.arrowValue, writer.uint32(/* id 11, wireType 2 =*/90).fork(), _depth + 1).ldelim();
        if (message.bytesValue != null && $Object.hasOwnProperty.call(message, "bytesValue"))
            writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.bytesValue);
        if (message.fileUploaderStateValue != null && $Object.hasOwnProperty.call(message, "fileUploaderStateValue"))
            $root.FileUploaderState.encode(message.fileUploaderStateValue, writer.uint32(/* id 13, wireType 2 =*/106).fork(), _depth + 1).ldelim();
        if (message.stringTriggerValue != null && $Object.hasOwnProperty.call(message, "stringTriggerValue"))
            $root.StringTriggerValue.encode(message.stringTriggerValue, writer.uint32(/* id 14, wireType 2 =*/114).fork(), _depth + 1).ldelim();
        if (message.chatInputValue != null && $Object.hasOwnProperty.call(message, "chatInputValue"))
            $root.ChatInputValue.encode(message.chatInputValue, writer.uint32(/* id 15, wireType 2 =*/122).fork(), _depth + 1).ldelim();
        if (message.jsonTriggerValue != null && $Object.hasOwnProperty.call(message, "jsonTriggerValue"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.jsonTriggerValue);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a WidgetState message from the specified reader or buffer.
     * @function decode
     * @memberof WidgetState
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WidgetState & WidgetState.$Shape} WidgetState
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WidgetState.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.WidgetState();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    message.triggerValue = reader.bool();
                    message.value = "triggerValue";
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    message.boolValue = reader.bool();
                    message.value = "boolValue";
                    continue;
                }
            case 4: {
                    if (wireType !== 1)
                        break;
                    message.doubleValue = reader.double();
                    message.value = "doubleValue";
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    message.intValue = reader.sint64();
                    message.value = "intValue";
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.stringValue = reader.stringVerify();
                    message.value = "stringValue";
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    message.doubleArrayValue = $root.DoubleArray.decode(reader, reader.uint32(), $undefined, _depth + 1, message.doubleArrayValue);
                    message.value = "doubleArrayValue";
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    message.intArrayValue = $root.SInt64Array.decode(reader, reader.uint32(), $undefined, _depth + 1, message.intArrayValue);
                    message.value = "intArrayValue";
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    message.stringArrayValue = $root.StringArray.decode(reader, reader.uint32(), $undefined, _depth + 1, message.stringArrayValue);
                    message.value = "stringArrayValue";
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.jsonValue = reader.stringVerify();
                    message.value = "jsonValue";
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.arrowValue = $root.ArrowTable.decode(reader, reader.uint32(), $undefined, _depth + 1, message.arrowValue);
                    message.value = "arrowValue";
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.bytesValue = reader.bytes();
                    message.value = "bytesValue";
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.fileUploaderStateValue = $root.FileUploaderState.decode(reader, reader.uint32(), $undefined, _depth + 1, message.fileUploaderStateValue);
                    message.value = "fileUploaderStateValue";
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    message.stringTriggerValue = $root.StringTriggerValue.decode(reader, reader.uint32(), $undefined, _depth + 1, message.stringTriggerValue);
                    message.value = "stringTriggerValue";
                    continue;
                }
            case 15: {
                    if (wireType !== 2)
                        break;
                    message.chatInputValue = $root.ChatInputValue.decode(reader, reader.uint32(), $undefined, _depth + 1, message.chatInputValue);
                    message.value = "chatInputValue";
                    continue;
                }
            case 16: {
                    if (wireType !== 2)
                        break;
                    message.jsonTriggerValue = reader.stringVerify();
                    message.value = "jsonTriggerValue";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a WidgetState message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WidgetState
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WidgetState} WidgetState
     */
    WidgetState.fromObject = function (object, _depth) {
        if (object instanceof $root.WidgetState)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".WidgetState: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.WidgetState();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.triggerValue != null)
            message.triggerValue = $Boolean(object.triggerValue);
        if (object.boolValue != null)
            message.boolValue = $Boolean(object.boolValue);
        if (object.doubleValue != null)
            message.doubleValue = $Number(object.doubleValue);
        if (object.intValue != null)
            if ($util.Long)
                message.intValue = $util.Long.fromValue(object.intValue, false);
            else if (typeof object.intValue === "string")
                message.intValue = $parseInt(object.intValue, 10);
            else if (typeof object.intValue === "number")
                message.intValue = object.intValue;
            else if (typeof object.intValue === "object")
                message.intValue = new $util.LongBits(object.intValue.low >>> 0, object.intValue.high >>> 0).toNumber();
        if (object.stringValue != null)
            message.stringValue = $String(object.stringValue);
        if (object.doubleArrayValue != null) {
            if (!$util.isObject(object.doubleArrayValue))
                throw $TypeError(".WidgetState.doubleArrayValue: object expected");
            message.doubleArrayValue = $root.DoubleArray.fromObject(object.doubleArrayValue, _depth + 1);
        }
        if (object.intArrayValue != null) {
            if (!$util.isObject(object.intArrayValue))
                throw $TypeError(".WidgetState.intArrayValue: object expected");
            message.intArrayValue = $root.SInt64Array.fromObject(object.intArrayValue, _depth + 1);
        }
        if (object.stringArrayValue != null) {
            if (!$util.isObject(object.stringArrayValue))
                throw $TypeError(".WidgetState.stringArrayValue: object expected");
            message.stringArrayValue = $root.StringArray.fromObject(object.stringArrayValue, _depth + 1);
        }
        if (object.jsonValue != null)
            message.jsonValue = $String(object.jsonValue);
        if (object.arrowValue != null) {
            if (!$util.isObject(object.arrowValue))
                throw $TypeError(".WidgetState.arrowValue: object expected");
            message.arrowValue = $root.ArrowTable.fromObject(object.arrowValue, _depth + 1);
        }
        if (object.bytesValue != null)
            if (typeof object.bytesValue === "string")
                $util.base64.decode(object.bytesValue, message.bytesValue = $util.newBuffer($util.base64.length(object.bytesValue)), 0);
            else if (object.bytesValue.length >= 0)
                message.bytesValue = object.bytesValue;
        if (object.fileUploaderStateValue != null) {
            if (!$util.isObject(object.fileUploaderStateValue))
                throw $TypeError(".WidgetState.fileUploaderStateValue: object expected");
            message.fileUploaderStateValue = $root.FileUploaderState.fromObject(object.fileUploaderStateValue, _depth + 1);
        }
        if (object.stringTriggerValue != null) {
            if (!$util.isObject(object.stringTriggerValue))
                throw $TypeError(".WidgetState.stringTriggerValue: object expected");
            message.stringTriggerValue = $root.StringTriggerValue.fromObject(object.stringTriggerValue, _depth + 1);
        }
        if (object.chatInputValue != null) {
            if (!$util.isObject(object.chatInputValue))
                throw $TypeError(".WidgetState.chatInputValue: object expected");
            message.chatInputValue = $root.ChatInputValue.fromObject(object.chatInputValue, _depth + 1);
        }
        if (object.jsonTriggerValue != null)
            message.jsonTriggerValue = $String(object.jsonTriggerValue);
        return message;
    };

    /**
     * Creates a plain object from a WidgetState message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WidgetState
     * @static
     * @param {WidgetState} message WidgetState
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WidgetState.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.id = "";
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.triggerValue != null && $Object.hasOwnProperty.call(message, "triggerValue")) {
            object.triggerValue = message.triggerValue;
            if (options.oneofs)
                object.value = "triggerValue";
        }
        if (message.boolValue != null && $Object.hasOwnProperty.call(message, "boolValue")) {
            object.boolValue = message.boolValue;
            if (options.oneofs)
                object.value = "boolValue";
        }
        if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue")) {
            object.doubleValue = options.json && !$isFinite(message.doubleValue) ? $String(message.doubleValue) : message.doubleValue;
            if (options.oneofs)
                object.value = "doubleValue";
        }
        if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue")) {
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.intValue = typeof message.intValue === "number" ? $BigInt(message.intValue) : $util.Long.fromBits(message.intValue.low >>> 0, message.intValue.high >>> 0, false).toBigInt();
            else if (typeof message.intValue === "number")
                object.intValue = options.longs === $String ? $String(message.intValue) : message.intValue;
            else
                object.intValue = options.longs === $String ? $util.Long.prototype.toString.call(message.intValue) : options.longs === $Number ? new $util.LongBits(message.intValue.low >>> 0, message.intValue.high >>> 0).toNumber() : message.intValue;
            if (options.oneofs)
                object.value = "intValue";
        }
        if (message.stringValue != null && $Object.hasOwnProperty.call(message, "stringValue")) {
            object.stringValue = message.stringValue;
            if (options.oneofs)
                object.value = "stringValue";
        }
        if (message.doubleArrayValue != null && $Object.hasOwnProperty.call(message, "doubleArrayValue")) {
            object.doubleArrayValue = $root.DoubleArray.toObject(message.doubleArrayValue, options, _depth + 1);
            if (options.oneofs)
                object.value = "doubleArrayValue";
        }
        if (message.intArrayValue != null && $Object.hasOwnProperty.call(message, "intArrayValue")) {
            object.intArrayValue = $root.SInt64Array.toObject(message.intArrayValue, options, _depth + 1);
            if (options.oneofs)
                object.value = "intArrayValue";
        }
        if (message.stringArrayValue != null && $Object.hasOwnProperty.call(message, "stringArrayValue")) {
            object.stringArrayValue = $root.StringArray.toObject(message.stringArrayValue, options, _depth + 1);
            if (options.oneofs)
                object.value = "stringArrayValue";
        }
        if (message.jsonValue != null && $Object.hasOwnProperty.call(message, "jsonValue")) {
            object.jsonValue = message.jsonValue;
            if (options.oneofs)
                object.value = "jsonValue";
        }
        if (message.arrowValue != null && $Object.hasOwnProperty.call(message, "arrowValue")) {
            object.arrowValue = $root.ArrowTable.toObject(message.arrowValue, options, _depth + 1);
            if (options.oneofs)
                object.value = "arrowValue";
        }
        if (message.bytesValue != null && $Object.hasOwnProperty.call(message, "bytesValue")) {
            object.bytesValue = options.bytes === $String ? $util.base64.encode(message.bytesValue, 0, message.bytesValue.length) : options.bytes === $Array ? $Array.prototype.slice.call(message.bytesValue) : message.bytesValue;
            if (options.oneofs)
                object.value = "bytesValue";
        }
        if (message.fileUploaderStateValue != null && $Object.hasOwnProperty.call(message, "fileUploaderStateValue")) {
            object.fileUploaderStateValue = $root.FileUploaderState.toObject(message.fileUploaderStateValue, options, _depth + 1);
            if (options.oneofs)
                object.value = "fileUploaderStateValue";
        }
        if (message.stringTriggerValue != null && $Object.hasOwnProperty.call(message, "stringTriggerValue")) {
            object.stringTriggerValue = $root.StringTriggerValue.toObject(message.stringTriggerValue, options, _depth + 1);
            if (options.oneofs)
                object.value = "stringTriggerValue";
        }
        if (message.chatInputValue != null && $Object.hasOwnProperty.call(message, "chatInputValue")) {
            object.chatInputValue = $root.ChatInputValue.toObject(message.chatInputValue, options, _depth + 1);
            if (options.oneofs)
                object.value = "chatInputValue";
        }
        if (message.jsonTriggerValue != null && $Object.hasOwnProperty.call(message, "jsonTriggerValue")) {
            object.jsonTriggerValue = message.jsonTriggerValue;
            if (options.oneofs)
                object.value = "jsonTriggerValue";
        }
        return object;
    };

    /**
     * Converts this WidgetState to JSON.
     * @function toJSON
     * @memberof WidgetState
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WidgetState.prototype.toJSON = function() {
        return WidgetState.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for WidgetState
     * @function getTypeUrl
     * @memberof WidgetState
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    WidgetState.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/WidgetState";
    };

    return WidgetState;
})();

export const StringArray = $root.StringArray = (() => {

    /**
     * Properties of a StringArray.
     * @typedef {Object} StringArray.$Properties
     * @property {Array.<string>|null} [data] StringArray data
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a StringArray.
     * @exports IStringArray
     * @interface IStringArray
     * @augments StringArray.$Properties
     * @deprecated Use StringArray.$Properties instead.
     */

    /**
     * Shape of a StringArray.
     * @typedef {StringArray.$Properties} StringArray.$Shape
     */

    /**
     * Constructs a new StringArray.
     * @exports StringArray
     * @classdesc Represents a StringArray.
     * @constructor
     * @param {StringArray.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const StringArray = function (properties) {
        this.data = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * StringArray data.
     * @member {Array.<string>} data
     * @memberof StringArray
     * @instance
     */
    StringArray.prototype.data = $util.emptyArray;

    /**
     * Creates a new StringArray instance using the specified properties.
     * @function create
     * @memberof StringArray
     * @static
     * @param {StringArray.$Properties=} [properties] Properties to set
     * @returns {StringArray} StringArray instance
     * @type {{
     *   (properties: StringArray.$Shape): StringArray & StringArray.$Shape;
     *   (properties?: StringArray.$Properties): StringArray;
     * }}
     */
    StringArray.create = function(properties) {
        return new StringArray(properties);
    };

    /**
     * Encodes the specified StringArray message. Does not implicitly {@link StringArray.verify|verify} messages.
     * @function encode
     * @memberof StringArray
     * @static
     * @param {StringArray.$Properties} message StringArray message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StringArray.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && message.data.length)
            for (let i = 0; i < message.data.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.data[i]);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a StringArray message from the specified reader or buffer.
     * @function decode
     * @memberof StringArray
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StringArray & StringArray.$Shape} StringArray
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StringArray.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.StringArray();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if (!(message.data && message.data.length))
                        message.data = [];
                    message.data.push(reader.stringVerify());
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a StringArray message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StringArray
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StringArray} StringArray
     */
    StringArray.fromObject = function (object, _depth) {
        if (object instanceof $root.StringArray)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".StringArray: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.StringArray();
        if (object.data) {
            if (!$Array.isArray(object.data))
                throw $TypeError(".StringArray.data: array expected");
            message.data = $Array(object.data.length);
            for (let i = 0; i < object.data.length; ++i)
                message.data[i] = $String(object.data[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a StringArray message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StringArray
     * @static
     * @param {StringArray} message StringArray
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StringArray.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.data = [];
        if (message.data && message.data.length) {
            object.data = $Array(message.data.length);
            for (let j = 0; j < message.data.length; ++j)
                object.data[j] = message.data[j];
        }
        return object;
    };

    /**
     * Converts this StringArray to JSON.
     * @function toJSON
     * @memberof StringArray
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StringArray.prototype.toJSON = function() {
        return StringArray.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for StringArray
     * @function getTypeUrl
     * @memberof StringArray
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    StringArray.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/StringArray";
    };

    return StringArray;
})();

export const DoubleArray = $root.DoubleArray = (() => {

    /**
     * Properties of a DoubleArray.
     * @typedef {Object} DoubleArray.$Properties
     * @property {Array.<number>|null} [data] DoubleArray data
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DoubleArray.
     * @exports IDoubleArray
     * @interface IDoubleArray
     * @augments DoubleArray.$Properties
     * @deprecated Use DoubleArray.$Properties instead.
     */

    /**
     * Shape of a DoubleArray.
     * @typedef {DoubleArray.$Properties} DoubleArray.$Shape
     */

    /**
     * Constructs a new DoubleArray.
     * @exports DoubleArray
     * @classdesc Represents a DoubleArray.
     * @constructor
     * @param {DoubleArray.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DoubleArray = function (properties) {
        this.data = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * DoubleArray data.
     * @member {Array.<number>} data
     * @memberof DoubleArray
     * @instance
     */
    DoubleArray.prototype.data = $util.emptyArray;

    /**
     * Creates a new DoubleArray instance using the specified properties.
     * @function create
     * @memberof DoubleArray
     * @static
     * @param {DoubleArray.$Properties=} [properties] Properties to set
     * @returns {DoubleArray} DoubleArray instance
     * @type {{
     *   (properties: DoubleArray.$Shape): DoubleArray & DoubleArray.$Shape;
     *   (properties?: DoubleArray.$Properties): DoubleArray;
     * }}
     */
    DoubleArray.create = function(properties) {
        return new DoubleArray(properties);
    };

    /**
     * Encodes the specified DoubleArray message. Does not implicitly {@link DoubleArray.verify|verify} messages.
     * @function encode
     * @memberof DoubleArray
     * @static
     * @param {DoubleArray.$Properties} message DoubleArray message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DoubleArray.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && message.data.length)
            writer.uint32(/* id 1, wireType 2 =*/10).doubles(message.data);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DoubleArray message from the specified reader or buffer.
     * @function decode
     * @memberof DoubleArray
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DoubleArray & DoubleArray.$Shape} DoubleArray
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DoubleArray.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DoubleArray();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType === 2) {
                        if (!(message.data && message.data.length))
                            message.data = [];
                        reader.doubles(message.data);
                        continue;
                    }
                    if (wireType !== 1)
                        break;
                    if (!(message.data && message.data.length))
                        message.data = [];
                    message.data.push(reader.double());
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DoubleArray message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DoubleArray
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DoubleArray} DoubleArray
     */
    DoubleArray.fromObject = function (object, _depth) {
        if (object instanceof $root.DoubleArray)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DoubleArray: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.DoubleArray();
        if (object.data) {
            if (!$Array.isArray(object.data))
                throw $TypeError(".DoubleArray.data: array expected");
            message.data = $Array(object.data.length);
            for (let i = 0; i < object.data.length; ++i)
                message.data[i] = $Number(object.data[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a DoubleArray message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DoubleArray
     * @static
     * @param {DoubleArray} message DoubleArray
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DoubleArray.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.data = [];
        if (message.data && message.data.length) {
            object.data = $Array(message.data.length);
            for (let j = 0; j < message.data.length; ++j)
                object.data[j] = options.json && !$isFinite(message.data[j]) ? $String(message.data[j]) : message.data[j];
        }
        return object;
    };

    /**
     * Converts this DoubleArray to JSON.
     * @function toJSON
     * @memberof DoubleArray
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DoubleArray.prototype.toJSON = function() {
        return DoubleArray.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DoubleArray
     * @function getTypeUrl
     * @memberof DoubleArray
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DoubleArray.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DoubleArray";
    };

    return DoubleArray;
})();

export const Int32Array = $root.Int32Array = (() => {

    /**
     * Properties of an Int32Array.
     * @typedef {Object} Int32Array.$Properties
     * @property {Array.<number>|null} [data] Int32Array data
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an Int32Array.
     * @exports IInt32Array
     * @interface IInt32Array
     * @augments Int32Array.$Properties
     * @deprecated Use Int32Array.$Properties instead.
     */

    /**
     * Shape of an Int32Array.
     * @typedef {Int32Array.$Properties} Int32Array.$Shape
     */

    /**
     * Constructs a new Int32Array.
     * @exports Int32Array
     * @classdesc Represents an Int32Array.
     * @constructor
     * @param {Int32Array.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Int32Array = function (properties) {
        this.data = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Int32Array data.
     * @member {Array.<number>} data
     * @memberof Int32Array
     * @instance
     */
    Int32Array.prototype.data = $util.emptyArray;

    /**
     * Creates a new Int32Array instance using the specified properties.
     * @function create
     * @memberof Int32Array
     * @static
     * @param {Int32Array.$Properties=} [properties] Properties to set
     * @returns {Int32Array} Int32Array instance
     * @type {{
     *   (properties: Int32Array.$Shape): Int32Array & Int32Array.$Shape;
     *   (properties?: Int32Array.$Properties): Int32Array;
     * }}
     */
    Int32Array.create = function(properties) {
        return new Int32Array(properties);
    };

    /**
     * Encodes the specified Int32Array message. Does not implicitly {@link Int32Array.verify|verify} messages.
     * @function encode
     * @memberof Int32Array
     * @static
     * @param {Int32Array.$Properties} message Int32Array message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Int32Array.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && message.data.length)
            writer.uint32(/* id 1, wireType 2 =*/10).int32s(message.data);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an Int32Array message from the specified reader or buffer.
     * @function decode
     * @memberof Int32Array
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Int32Array & Int32Array.$Shape} Int32Array
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Int32Array.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Int32Array();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType === 2) {
                        if (!(message.data && message.data.length))
                            message.data = [];
                        reader.int32s(message.data);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message.data && message.data.length))
                        message.data = [];
                    message.data.push(reader.int32());
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an Int32Array message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Int32Array
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Int32Array} Int32Array
     */
    Int32Array.fromObject = function (object, _depth) {
        if (object instanceof $root.Int32Array)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Int32Array: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Int32Array();
        if (object.data) {
            if (!$Array.isArray(object.data))
                throw $TypeError(".Int32Array.data: array expected");
            message.data = $Array(object.data.length);
            for (let i = 0; i < object.data.length; ++i)
                message.data[i] = object.data[i] | 0;
        }
        return message;
    };

    /**
     * Creates a plain object from an Int32Array message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Int32Array
     * @static
     * @param {Int32Array} message Int32Array
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Int32Array.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.data = [];
        if (message.data && message.data.length) {
            object.data = $Array(message.data.length);
            for (let j = 0; j < message.data.length; ++j)
                object.data[j] = message.data[j];
        }
        return object;
    };

    /**
     * Converts this Int32Array to JSON.
     * @function toJSON
     * @memberof Int32Array
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Int32Array.prototype.toJSON = function() {
        return Int32Array.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Int32Array
     * @function getTypeUrl
     * @memberof Int32Array
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Int32Array.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Int32Array";
    };

    return Int32Array;
})();

export const Int64Array = $root.Int64Array = (() => {

    /**
     * Properties of an Int64Array.
     * @typedef {Object} Int64Array.$Properties
     * @property {Array.<number|Long>|null} [data] Int64Array data
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an Int64Array.
     * @exports IInt64Array
     * @interface IInt64Array
     * @augments Int64Array.$Properties
     * @deprecated Use Int64Array.$Properties instead.
     */

    /**
     * Shape of an Int64Array.
     * @typedef {Int64Array.$Properties} Int64Array.$Shape
     */

    /**
     * Constructs a new Int64Array.
     * @exports Int64Array
     * @classdesc Represents an Int64Array.
     * @constructor
     * @param {Int64Array.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Int64Array = function (properties) {
        this.data = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Int64Array data.
     * @member {Array.<number|Long>} data
     * @memberof Int64Array
     * @instance
     */
    Int64Array.prototype.data = $util.emptyArray;

    /**
     * Creates a new Int64Array instance using the specified properties.
     * @function create
     * @memberof Int64Array
     * @static
     * @param {Int64Array.$Properties=} [properties] Properties to set
     * @returns {Int64Array} Int64Array instance
     * @type {{
     *   (properties: Int64Array.$Shape): Int64Array & Int64Array.$Shape;
     *   (properties?: Int64Array.$Properties): Int64Array;
     * }}
     */
    Int64Array.create = function(properties) {
        return new Int64Array(properties);
    };

    /**
     * Encodes the specified Int64Array message. Does not implicitly {@link Int64Array.verify|verify} messages.
     * @function encode
     * @memberof Int64Array
     * @static
     * @param {Int64Array.$Properties} message Int64Array message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Int64Array.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && message.data.length)
            writer.uint32(/* id 1, wireType 2 =*/10).int64s(message.data);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an Int64Array message from the specified reader or buffer.
     * @function decode
     * @memberof Int64Array
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Int64Array & Int64Array.$Shape} Int64Array
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Int64Array.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Int64Array();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType === 2) {
                        if (!(message.data && message.data.length))
                            message.data = [];
                        reader.int64s(message.data);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message.data && message.data.length))
                        message.data = [];
                    message.data.push(reader.int64());
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an Int64Array message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Int64Array
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Int64Array} Int64Array
     */
    Int64Array.fromObject = function (object, _depth) {
        if (object instanceof $root.Int64Array)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Int64Array: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Int64Array();
        if (object.data) {
            if (!$Array.isArray(object.data))
                throw $TypeError(".Int64Array.data: array expected");
            message.data = $Array(object.data.length);
            for (let i = 0; i < object.data.length; ++i)
                if ($util.Long)
                    message.data[i] = $util.Long.fromValue(object.data[i], false);
                else if (typeof object.data[i] === "string")
                    message.data[i] = $parseInt(object.data[i], 10);
                else if (typeof object.data[i] === "number")
                    message.data[i] = object.data[i];
                else if (typeof object.data[i] === "object")
                    message.data[i] = new $util.LongBits(object.data[i].low >>> 0, object.data[i].high >>> 0).toNumber();
        }
        return message;
    };

    /**
     * Creates a plain object from an Int64Array message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Int64Array
     * @static
     * @param {Int64Array} message Int64Array
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Int64Array.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.data = [];
        if (message.data && message.data.length) {
            object.data = $Array(message.data.length);
            for (let j = 0; j < message.data.length; ++j)
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.data[j] = typeof message.data[j] === "number" ? $BigInt(message.data[j]) : $util.Long.fromBits(message.data[j].low >>> 0, message.data[j].high >>> 0, false).toBigInt();
                else if (typeof message.data[j] === "number")
                    object.data[j] = options.longs === $String ? $String(message.data[j]) : message.data[j];
                else
                    object.data[j] = options.longs === $String ? $util.Long.prototype.toString.call(message.data[j]) : options.longs === $Number ? new $util.LongBits(message.data[j].low >>> 0, message.data[j].high >>> 0).toNumber() : message.data[j];
        }
        return object;
    };

    /**
     * Converts this Int64Array to JSON.
     * @function toJSON
     * @memberof Int64Array
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Int64Array.prototype.toJSON = function() {
        return Int64Array.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Int64Array
     * @function getTypeUrl
     * @memberof Int64Array
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Int64Array.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Int64Array";
    };

    return Int64Array;
})();

export const SInt64Array = $root.SInt64Array = (() => {

    /**
     * Properties of a SInt64Array.
     * @typedef {Object} SInt64Array.$Properties
     * @property {Array.<number|Long>|null} [data] SInt64Array data
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a SInt64Array.
     * @exports ISInt64Array
     * @interface ISInt64Array
     * @augments SInt64Array.$Properties
     * @deprecated Use SInt64Array.$Properties instead.
     */

    /**
     * Shape of a SInt64Array.
     * @typedef {SInt64Array.$Properties} SInt64Array.$Shape
     */

    /**
     * Constructs a new SInt64Array.
     * @exports SInt64Array
     * @classdesc Represents a SInt64Array.
     * @constructor
     * @param {SInt64Array.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const SInt64Array = function (properties) {
        this.data = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * SInt64Array data.
     * @member {Array.<number|Long>} data
     * @memberof SInt64Array
     * @instance
     */
    SInt64Array.prototype.data = $util.emptyArray;

    /**
     * Creates a new SInt64Array instance using the specified properties.
     * @function create
     * @memberof SInt64Array
     * @static
     * @param {SInt64Array.$Properties=} [properties] Properties to set
     * @returns {SInt64Array} SInt64Array instance
     * @type {{
     *   (properties: SInt64Array.$Shape): SInt64Array & SInt64Array.$Shape;
     *   (properties?: SInt64Array.$Properties): SInt64Array;
     * }}
     */
    SInt64Array.create = function(properties) {
        return new SInt64Array(properties);
    };

    /**
     * Encodes the specified SInt64Array message. Does not implicitly {@link SInt64Array.verify|verify} messages.
     * @function encode
     * @memberof SInt64Array
     * @static
     * @param {SInt64Array.$Properties} message SInt64Array message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SInt64Array.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && message.data.length)
            writer.uint32(/* id 1, wireType 2 =*/10).sint64s(message.data);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a SInt64Array message from the specified reader or buffer.
     * @function decode
     * @memberof SInt64Array
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SInt64Array & SInt64Array.$Shape} SInt64Array
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SInt64Array.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.SInt64Array();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType === 2) {
                        if (!(message.data && message.data.length))
                            message.data = [];
                        reader.sint64s(message.data);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message.data && message.data.length))
                        message.data = [];
                    message.data.push(reader.sint64());
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a SInt64Array message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SInt64Array
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SInt64Array} SInt64Array
     */
    SInt64Array.fromObject = function (object, _depth) {
        if (object instanceof $root.SInt64Array)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".SInt64Array: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.SInt64Array();
        if (object.data) {
            if (!$Array.isArray(object.data))
                throw $TypeError(".SInt64Array.data: array expected");
            message.data = $Array(object.data.length);
            for (let i = 0; i < object.data.length; ++i)
                if ($util.Long)
                    message.data[i] = $util.Long.fromValue(object.data[i], false);
                else if (typeof object.data[i] === "string")
                    message.data[i] = $parseInt(object.data[i], 10);
                else if (typeof object.data[i] === "number")
                    message.data[i] = object.data[i];
                else if (typeof object.data[i] === "object")
                    message.data[i] = new $util.LongBits(object.data[i].low >>> 0, object.data[i].high >>> 0).toNumber();
        }
        return message;
    };

    /**
     * Creates a plain object from a SInt64Array message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SInt64Array
     * @static
     * @param {SInt64Array} message SInt64Array
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SInt64Array.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.data = [];
        if (message.data && message.data.length) {
            object.data = $Array(message.data.length);
            for (let j = 0; j < message.data.length; ++j)
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.data[j] = typeof message.data[j] === "number" ? $BigInt(message.data[j]) : $util.Long.fromBits(message.data[j].low >>> 0, message.data[j].high >>> 0, false).toBigInt();
                else if (typeof message.data[j] === "number")
                    object.data[j] = options.longs === $String ? $String(message.data[j]) : message.data[j];
                else
                    object.data[j] = options.longs === $String ? $util.Long.prototype.toString.call(message.data[j]) : options.longs === $Number ? new $util.LongBits(message.data[j].low >>> 0, message.data[j].high >>> 0).toNumber() : message.data[j];
        }
        return object;
    };

    /**
     * Converts this SInt64Array to JSON.
     * @function toJSON
     * @memberof SInt64Array
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SInt64Array.prototype.toJSON = function() {
        return SInt64Array.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for SInt64Array
     * @function getTypeUrl
     * @memberof SInt64Array
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    SInt64Array.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/SInt64Array";
    };

    return SInt64Array;
})();

export const UInt32Array = $root.UInt32Array = (() => {

    /**
     * Properties of a UInt32Array.
     * @typedef {Object} UInt32Array.$Properties
     * @property {Array.<number>|null} [data] UInt32Array data
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a UInt32Array.
     * @exports IUInt32Array
     * @interface IUInt32Array
     * @augments UInt32Array.$Properties
     * @deprecated Use UInt32Array.$Properties instead.
     */

    /**
     * Shape of a UInt32Array.
     * @typedef {UInt32Array.$Properties} UInt32Array.$Shape
     */

    /**
     * Constructs a new UInt32Array.
     * @exports UInt32Array
     * @classdesc Represents a UInt32Array.
     * @constructor
     * @param {UInt32Array.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const UInt32Array = function (properties) {
        this.data = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * UInt32Array data.
     * @member {Array.<number>} data
     * @memberof UInt32Array
     * @instance
     */
    UInt32Array.prototype.data = $util.emptyArray;

    /**
     * Creates a new UInt32Array instance using the specified properties.
     * @function create
     * @memberof UInt32Array
     * @static
     * @param {UInt32Array.$Properties=} [properties] Properties to set
     * @returns {UInt32Array} UInt32Array instance
     * @type {{
     *   (properties: UInt32Array.$Shape): UInt32Array & UInt32Array.$Shape;
     *   (properties?: UInt32Array.$Properties): UInt32Array;
     * }}
     */
    UInt32Array.create = function(properties) {
        return new UInt32Array(properties);
    };

    /**
     * Encodes the specified UInt32Array message. Does not implicitly {@link UInt32Array.verify|verify} messages.
     * @function encode
     * @memberof UInt32Array
     * @static
     * @param {UInt32Array.$Properties} message UInt32Array message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UInt32Array.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && message.data.length)
            writer.uint32(/* id 1, wireType 2 =*/10).uint32s(message.data);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a UInt32Array message from the specified reader or buffer.
     * @function decode
     * @memberof UInt32Array
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UInt32Array & UInt32Array.$Shape} UInt32Array
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UInt32Array.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.UInt32Array();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType === 2) {
                        if (!(message.data && message.data.length))
                            message.data = [];
                        reader.uint32s(message.data);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message.data && message.data.length))
                        message.data = [];
                    message.data.push(reader.uint32());
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a UInt32Array message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UInt32Array
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UInt32Array} UInt32Array
     */
    UInt32Array.fromObject = function (object, _depth) {
        if (object instanceof $root.UInt32Array)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".UInt32Array: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.UInt32Array();
        if (object.data) {
            if (!$Array.isArray(object.data))
                throw $TypeError(".UInt32Array.data: array expected");
            message.data = $Array(object.data.length);
            for (let i = 0; i < object.data.length; ++i)
                message.data[i] = object.data[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a UInt32Array message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UInt32Array
     * @static
     * @param {UInt32Array} message UInt32Array
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UInt32Array.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.data = [];
        if (message.data && message.data.length) {
            object.data = $Array(message.data.length);
            for (let j = 0; j < message.data.length; ++j)
                object.data[j] = message.data[j];
        }
        return object;
    };

    /**
     * Converts this UInt32Array to JSON.
     * @function toJSON
     * @memberof UInt32Array
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UInt32Array.prototype.toJSON = function() {
        return UInt32Array.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for UInt32Array
     * @function getTypeUrl
     * @memberof UInt32Array
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    UInt32Array.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/UInt32Array";
    };

    return UInt32Array;
})();

export const StringTriggerValue = $root.StringTriggerValue = (() => {

    /**
     * Properties of a StringTriggerValue.
     * @typedef {Object} StringTriggerValue.$Properties
     * @property {string|null} [data] StringTriggerValue data
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a StringTriggerValue.
     * @exports IStringTriggerValue
     * @interface IStringTriggerValue
     * @augments StringTriggerValue.$Properties
     * @deprecated Use StringTriggerValue.$Properties instead.
     */

    /**
     * Shape of a StringTriggerValue.
     * @typedef {StringTriggerValue.$Properties} StringTriggerValue.$Shape
     */

    /**
     * Constructs a new StringTriggerValue.
     * @exports StringTriggerValue
     * @classdesc Represents a StringTriggerValue.
     * @constructor
     * @param {StringTriggerValue.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const StringTriggerValue = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * StringTriggerValue data.
     * @member {string|null|undefined} data
     * @memberof StringTriggerValue
     * @instance
     */
    StringTriggerValue.prototype.data = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(StringTriggerValue.prototype, "_data", {
        get: $util.oneOfGetter($oneOfFields = ["data"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new StringTriggerValue instance using the specified properties.
     * @function create
     * @memberof StringTriggerValue
     * @static
     * @param {StringTriggerValue.$Properties=} [properties] Properties to set
     * @returns {StringTriggerValue} StringTriggerValue instance
     * @type {{
     *   (properties: StringTriggerValue.$Shape): StringTriggerValue & StringTriggerValue.$Shape;
     *   (properties?: StringTriggerValue.$Properties): StringTriggerValue;
     * }}
     */
    StringTriggerValue.create = function(properties) {
        return new StringTriggerValue(properties);
    };

    /**
     * Encodes the specified StringTriggerValue message. Does not implicitly {@link StringTriggerValue.verify|verify} messages.
     * @function encode
     * @memberof StringTriggerValue
     * @static
     * @param {StringTriggerValue.$Properties} message StringTriggerValue message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StringTriggerValue.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a StringTriggerValue message from the specified reader or buffer.
     * @function decode
     * @memberof StringTriggerValue
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StringTriggerValue & StringTriggerValue.$Shape} StringTriggerValue
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StringTriggerValue.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.StringTriggerValue();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.data = reader.stringVerify();
                    message._data = "data";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a StringTriggerValue message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StringTriggerValue
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StringTriggerValue} StringTriggerValue
     */
    StringTriggerValue.fromObject = function (object, _depth) {
        if (object instanceof $root.StringTriggerValue)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".StringTriggerValue: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.StringTriggerValue();
        if (object.data != null)
            message.data = $String(object.data);
        return message;
    };

    /**
     * Creates a plain object from a StringTriggerValue message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StringTriggerValue
     * @static
     * @param {StringTriggerValue} message StringTriggerValue
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StringTriggerValue.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            object.data = message.data;
        return object;
    };

    /**
     * Converts this StringTriggerValue to JSON.
     * @function toJSON
     * @memberof StringTriggerValue
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StringTriggerValue.prototype.toJSON = function() {
        return StringTriggerValue.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for StringTriggerValue
     * @function getTypeUrl
     * @memberof StringTriggerValue
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    StringTriggerValue.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/StringTriggerValue";
    };

    return StringTriggerValue;
})();

export const FileURLsRequest = $root.FileURLsRequest = (() => {

    /**
     * Properties of a FileURLsRequest.
     * @typedef {Object} FileURLsRequest.$Properties
     * @property {string|null} [requestId] FileURLsRequest requestId
     * @property {Array.<string>|null} [fileNames] FileURLsRequest fileNames
     * @property {string|null} [sessionId] FileURLsRequest sessionId
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a FileURLsRequest.
     * @exports IFileURLsRequest
     * @interface IFileURLsRequest
     * @augments FileURLsRequest.$Properties
     * @deprecated Use FileURLsRequest.$Properties instead.
     */

    /**
     * Shape of a FileURLsRequest.
     * @typedef {FileURLsRequest.$Properties} FileURLsRequest.$Shape
     */

    /**
     * Constructs a new FileURLsRequest.
     * @exports FileURLsRequest
     * @classdesc Represents a FileURLsRequest.
     * @constructor
     * @param {FileURLsRequest.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const FileURLsRequest = function (properties) {
        this.fileNames = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * FileURLsRequest requestId.
     * @member {string} requestId
     * @memberof FileURLsRequest
     * @instance
     */
    FileURLsRequest.prototype.requestId = "";

    /**
     * FileURLsRequest fileNames.
     * @member {Array.<string>} fileNames
     * @memberof FileURLsRequest
     * @instance
     */
    FileURLsRequest.prototype.fileNames = $util.emptyArray;

    /**
     * FileURLsRequest sessionId.
     * @member {string} sessionId
     * @memberof FileURLsRequest
     * @instance
     */
    FileURLsRequest.prototype.sessionId = "";

    /**
     * Creates a new FileURLsRequest instance using the specified properties.
     * @function create
     * @memberof FileURLsRequest
     * @static
     * @param {FileURLsRequest.$Properties=} [properties] Properties to set
     * @returns {FileURLsRequest} FileURLsRequest instance
     * @type {{
     *   (properties: FileURLsRequest.$Shape): FileURLsRequest & FileURLsRequest.$Shape;
     *   (properties?: FileURLsRequest.$Properties): FileURLsRequest;
     * }}
     */
    FileURLsRequest.create = function(properties) {
        return new FileURLsRequest(properties);
    };

    /**
     * Encodes the specified FileURLsRequest message. Does not implicitly {@link FileURLsRequest.verify|verify} messages.
     * @function encode
     * @memberof FileURLsRequest
     * @static
     * @param {FileURLsRequest.$Properties} message FileURLsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FileURLsRequest.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.requestId != null && $Object.hasOwnProperty.call(message, "requestId") && message.requestId !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
        if (message.fileNames != null && message.fileNames.length)
            for (let i = 0; i < message.fileNames.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileNames[i]);
        if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId") && message.sessionId !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.sessionId);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a FileURLsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof FileURLsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FileURLsRequest & FileURLsRequest.$Shape} FileURLsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FileURLsRequest.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.FileURLsRequest();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.requestId = value;
                    else
                        delete message.requestId;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if (!(message.fileNames && message.fileNames.length))
                        message.fileNames = [];
                    message.fileNames.push(reader.stringVerify());
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.sessionId = value;
                    else
                        delete message.sessionId;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a FileURLsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FileURLsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FileURLsRequest} FileURLsRequest
     */
    FileURLsRequest.fromObject = function (object, _depth) {
        if (object instanceof $root.FileURLsRequest)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".FileURLsRequest: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.FileURLsRequest();
        if (object.requestId != null)
            if (typeof object.requestId !== "string" || object.requestId.length)
                message.requestId = $String(object.requestId);
        if (object.fileNames) {
            if (!$Array.isArray(object.fileNames))
                throw $TypeError(".FileURLsRequest.fileNames: array expected");
            message.fileNames = $Array(object.fileNames.length);
            for (let i = 0; i < object.fileNames.length; ++i)
                message.fileNames[i] = $String(object.fileNames[i]);
        }
        if (object.sessionId != null)
            if (typeof object.sessionId !== "string" || object.sessionId.length)
                message.sessionId = $String(object.sessionId);
        return message;
    };

    /**
     * Creates a plain object from a FileURLsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FileURLsRequest
     * @static
     * @param {FileURLsRequest} message FileURLsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FileURLsRequest.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.fileNames = [];
        if (options.defaults) {
            object.requestId = "";
            object.sessionId = "";
        }
        if (message.requestId != null && $Object.hasOwnProperty.call(message, "requestId"))
            object.requestId = message.requestId;
        if (message.fileNames && message.fileNames.length) {
            object.fileNames = $Array(message.fileNames.length);
            for (let j = 0; j < message.fileNames.length; ++j)
                object.fileNames[j] = message.fileNames[j];
        }
        if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId"))
            object.sessionId = message.sessionId;
        return object;
    };

    /**
     * Converts this FileURLsRequest to JSON.
     * @function toJSON
     * @memberof FileURLsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FileURLsRequest.prototype.toJSON = function() {
        return FileURLsRequest.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for FileURLsRequest
     * @function getTypeUrl
     * @memberof FileURLsRequest
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    FileURLsRequest.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/FileURLsRequest";
    };

    return FileURLsRequest;
})();

export const FileURLs = $root.FileURLs = (() => {

    /**
     * Properties of a FileURLs.
     * @typedef {Object} FileURLs.$Properties
     * @property {string|null} [fileId] FileURLs fileId
     * @property {string|null} [uploadUrl] FileURLs uploadUrl
     * @property {string|null} [deleteUrl] FileURLs deleteUrl
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a FileURLs.
     * @exports IFileURLs
     * @interface IFileURLs
     * @augments FileURLs.$Properties
     * @deprecated Use FileURLs.$Properties instead.
     */

    /**
     * Shape of a FileURLs.
     * @typedef {FileURLs.$Properties} FileURLs.$Shape
     */

    /**
     * Constructs a new FileURLs.
     * @exports FileURLs
     * @classdesc Represents a FileURLs.
     * @constructor
     * @param {FileURLs.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const FileURLs = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * FileURLs fileId.
     * @member {string} fileId
     * @memberof FileURLs
     * @instance
     */
    FileURLs.prototype.fileId = "";

    /**
     * FileURLs uploadUrl.
     * @member {string} uploadUrl
     * @memberof FileURLs
     * @instance
     */
    FileURLs.prototype.uploadUrl = "";

    /**
     * FileURLs deleteUrl.
     * @member {string} deleteUrl
     * @memberof FileURLs
     * @instance
     */
    FileURLs.prototype.deleteUrl = "";

    /**
     * Creates a new FileURLs instance using the specified properties.
     * @function create
     * @memberof FileURLs
     * @static
     * @param {FileURLs.$Properties=} [properties] Properties to set
     * @returns {FileURLs} FileURLs instance
     * @type {{
     *   (properties: FileURLs.$Shape): FileURLs & FileURLs.$Shape;
     *   (properties?: FileURLs.$Properties): FileURLs;
     * }}
     */
    FileURLs.create = function(properties) {
        return new FileURLs(properties);
    };

    /**
     * Encodes the specified FileURLs message. Does not implicitly {@link FileURLs.verify|verify} messages.
     * @function encode
     * @memberof FileURLs
     * @static
     * @param {FileURLs.$Properties} message FileURLs message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FileURLs.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.fileId != null && $Object.hasOwnProperty.call(message, "fileId") && message.fileId !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.fileId);
        if (message.uploadUrl != null && $Object.hasOwnProperty.call(message, "uploadUrl") && message.uploadUrl !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.uploadUrl);
        if (message.deleteUrl != null && $Object.hasOwnProperty.call(message, "deleteUrl") && message.deleteUrl !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.deleteUrl);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a FileURLs message from the specified reader or buffer.
     * @function decode
     * @memberof FileURLs
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FileURLs & FileURLs.$Shape} FileURLs
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FileURLs.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.FileURLs();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.fileId = value;
                    else
                        delete message.fileId;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.uploadUrl = value;
                    else
                        delete message.uploadUrl;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.deleteUrl = value;
                    else
                        delete message.deleteUrl;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a FileURLs message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FileURLs
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FileURLs} FileURLs
     */
    FileURLs.fromObject = function (object, _depth) {
        if (object instanceof $root.FileURLs)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".FileURLs: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.FileURLs();
        if (object.fileId != null)
            if (typeof object.fileId !== "string" || object.fileId.length)
                message.fileId = $String(object.fileId);
        if (object.uploadUrl != null)
            if (typeof object.uploadUrl !== "string" || object.uploadUrl.length)
                message.uploadUrl = $String(object.uploadUrl);
        if (object.deleteUrl != null)
            if (typeof object.deleteUrl !== "string" || object.deleteUrl.length)
                message.deleteUrl = $String(object.deleteUrl);
        return message;
    };

    /**
     * Creates a plain object from a FileURLs message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FileURLs
     * @static
     * @param {FileURLs} message FileURLs
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FileURLs.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.fileId = "";
            object.uploadUrl = "";
            object.deleteUrl = "";
        }
        if (message.fileId != null && $Object.hasOwnProperty.call(message, "fileId"))
            object.fileId = message.fileId;
        if (message.uploadUrl != null && $Object.hasOwnProperty.call(message, "uploadUrl"))
            object.uploadUrl = message.uploadUrl;
        if (message.deleteUrl != null && $Object.hasOwnProperty.call(message, "deleteUrl"))
            object.deleteUrl = message.deleteUrl;
        return object;
    };

    /**
     * Converts this FileURLs to JSON.
     * @function toJSON
     * @memberof FileURLs
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FileURLs.prototype.toJSON = function() {
        return FileURLs.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for FileURLs
     * @function getTypeUrl
     * @memberof FileURLs
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    FileURLs.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/FileURLs";
    };

    return FileURLs;
})();

export const FileURLsResponse = $root.FileURLsResponse = (() => {

    /**
     * Properties of a FileURLsResponse.
     * @typedef {Object} FileURLsResponse.$Properties
     * @property {string|null} [responseId] FileURLsResponse responseId
     * @property {Array.<FileURLs.$Properties>|null} [fileUrls] FileURLsResponse fileUrls
     * @property {string|null} [errorMsg] FileURLsResponse errorMsg
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a FileURLsResponse.
     * @exports IFileURLsResponse
     * @interface IFileURLsResponse
     * @augments FileURLsResponse.$Properties
     * @deprecated Use FileURLsResponse.$Properties instead.
     */

    /**
     * Shape of a FileURLsResponse.
     * @typedef {FileURLsResponse.$Properties} FileURLsResponse.$Shape
     */

    /**
     * Constructs a new FileURLsResponse.
     * @exports FileURLsResponse
     * @classdesc Represents a FileURLsResponse.
     * @constructor
     * @param {FileURLsResponse.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const FileURLsResponse = function (properties) {
        this.fileUrls = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * FileURLsResponse responseId.
     * @member {string} responseId
     * @memberof FileURLsResponse
     * @instance
     */
    FileURLsResponse.prototype.responseId = "";

    /**
     * FileURLsResponse fileUrls.
     * @member {Array.<FileURLs.$Properties>} fileUrls
     * @memberof FileURLsResponse
     * @instance
     */
    FileURLsResponse.prototype.fileUrls = $util.emptyArray;

    /**
     * FileURLsResponse errorMsg.
     * @member {string} errorMsg
     * @memberof FileURLsResponse
     * @instance
     */
    FileURLsResponse.prototype.errorMsg = "";

    /**
     * Creates a new FileURLsResponse instance using the specified properties.
     * @function create
     * @memberof FileURLsResponse
     * @static
     * @param {FileURLsResponse.$Properties=} [properties] Properties to set
     * @returns {FileURLsResponse} FileURLsResponse instance
     * @type {{
     *   (properties: FileURLsResponse.$Shape): FileURLsResponse & FileURLsResponse.$Shape;
     *   (properties?: FileURLsResponse.$Properties): FileURLsResponse;
     * }}
     */
    FileURLsResponse.create = function(properties) {
        return new FileURLsResponse(properties);
    };

    /**
     * Encodes the specified FileURLsResponse message. Does not implicitly {@link FileURLsResponse.verify|verify} messages.
     * @function encode
     * @memberof FileURLsResponse
     * @static
     * @param {FileURLsResponse.$Properties} message FileURLsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FileURLsResponse.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.responseId != null && $Object.hasOwnProperty.call(message, "responseId") && message.responseId !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.responseId);
        if (message.fileUrls != null && message.fileUrls.length)
            for (let i = 0; i < message.fileUrls.length; ++i)
                $root.FileURLs.encode(message.fileUrls[i], writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.errorMsg != null && $Object.hasOwnProperty.call(message, "errorMsg") && message.errorMsg !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.errorMsg);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a FileURLsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof FileURLsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FileURLsResponse & FileURLsResponse.$Shape} FileURLsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FileURLsResponse.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.FileURLsResponse();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.responseId = value;
                    else
                        delete message.responseId;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if (!(message.fileUrls && message.fileUrls.length))
                        message.fileUrls = [];
                    message.fileUrls.push($root.FileURLs.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.errorMsg = value;
                    else
                        delete message.errorMsg;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a FileURLsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FileURLsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FileURLsResponse} FileURLsResponse
     */
    FileURLsResponse.fromObject = function (object, _depth) {
        if (object instanceof $root.FileURLsResponse)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".FileURLsResponse: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.FileURLsResponse();
        if (object.responseId != null)
            if (typeof object.responseId !== "string" || object.responseId.length)
                message.responseId = $String(object.responseId);
        if (object.fileUrls) {
            if (!$Array.isArray(object.fileUrls))
                throw $TypeError(".FileURLsResponse.fileUrls: array expected");
            message.fileUrls = $Array(object.fileUrls.length);
            for (let i = 0; i < object.fileUrls.length; ++i) {
                if (!$util.isObject(object.fileUrls[i]))
                    throw $TypeError(".FileURLsResponse.fileUrls: object expected");
                message.fileUrls[i] = $root.FileURLs.fromObject(object.fileUrls[i], _depth + 1);
            }
        }
        if (object.errorMsg != null)
            if (typeof object.errorMsg !== "string" || object.errorMsg.length)
                message.errorMsg = $String(object.errorMsg);
        return message;
    };

    /**
     * Creates a plain object from a FileURLsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FileURLsResponse
     * @static
     * @param {FileURLsResponse} message FileURLsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FileURLsResponse.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.fileUrls = [];
        if (options.defaults) {
            object.responseId = "";
            object.errorMsg = "";
        }
        if (message.responseId != null && $Object.hasOwnProperty.call(message, "responseId"))
            object.responseId = message.responseId;
        if (message.fileUrls && message.fileUrls.length) {
            object.fileUrls = $Array(message.fileUrls.length);
            for (let j = 0; j < message.fileUrls.length; ++j)
                object.fileUrls[j] = $root.FileURLs.toObject(message.fileUrls[j], options, _depth + 1);
        }
        if (message.errorMsg != null && $Object.hasOwnProperty.call(message, "errorMsg"))
            object.errorMsg = message.errorMsg;
        return object;
    };

    /**
     * Converts this FileURLsResponse to JSON.
     * @function toJSON
     * @memberof FileURLsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FileURLsResponse.prototype.toJSON = function() {
        return FileURLsResponse.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for FileURLsResponse
     * @function getTypeUrl
     * @memberof FileURLsResponse
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    FileURLsResponse.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/FileURLsResponse";
    };

    return FileURLsResponse;
})();

export const UploadedFileInfo = $root.UploadedFileInfo = (() => {

    /**
     * Properties of an UploadedFileInfo.
     * @typedef {Object} UploadedFileInfo.$Properties
     * @property {string|null} [name] UploadedFileInfo name
     * @property {number|Long|null} [size] UploadedFileInfo size
     * @property {string|null} [fileId] UploadedFileInfo fileId
     * @property {FileURLs.$Properties|null} [fileUrls] UploadedFileInfo fileUrls
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an UploadedFileInfo.
     * @exports IUploadedFileInfo
     * @interface IUploadedFileInfo
     * @augments UploadedFileInfo.$Properties
     * @deprecated Use UploadedFileInfo.$Properties instead.
     */

    /**
     * Shape of an UploadedFileInfo.
     * @typedef {UploadedFileInfo.$Properties} UploadedFileInfo.$Shape
     */

    /**
     * Constructs a new UploadedFileInfo.
     * @exports UploadedFileInfo
     * @classdesc Represents an UploadedFileInfo.
     * @constructor
     * @param {UploadedFileInfo.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const UploadedFileInfo = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * UploadedFileInfo name.
     * @member {string} name
     * @memberof UploadedFileInfo
     * @instance
     */
    UploadedFileInfo.prototype.name = "";

    /**
     * UploadedFileInfo size.
     * @member {number|Long} size
     * @memberof UploadedFileInfo
     * @instance
     */
    UploadedFileInfo.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * UploadedFileInfo fileId.
     * @member {string} fileId
     * @memberof UploadedFileInfo
     * @instance
     */
    UploadedFileInfo.prototype.fileId = "";

    /**
     * UploadedFileInfo fileUrls.
     * @member {FileURLs.$Properties|null|undefined} fileUrls
     * @memberof UploadedFileInfo
     * @instance
     */
    UploadedFileInfo.prototype.fileUrls = null;

    /**
     * Creates a new UploadedFileInfo instance using the specified properties.
     * @function create
     * @memberof UploadedFileInfo
     * @static
     * @param {UploadedFileInfo.$Properties=} [properties] Properties to set
     * @returns {UploadedFileInfo} UploadedFileInfo instance
     * @type {{
     *   (properties: UploadedFileInfo.$Shape): UploadedFileInfo & UploadedFileInfo.$Shape;
     *   (properties?: UploadedFileInfo.$Properties): UploadedFileInfo;
     * }}
     */
    UploadedFileInfo.create = function(properties) {
        return new UploadedFileInfo(properties);
    };

    /**
     * Encodes the specified UploadedFileInfo message. Does not implicitly {@link UploadedFileInfo.verify|verify} messages.
     * @function encode
     * @memberof UploadedFileInfo
     * @static
     * @param {UploadedFileInfo.$Properties} message UploadedFileInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UploadedFileInfo.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
        if (message.size != null && $Object.hasOwnProperty.call(message, "size") && (typeof message.size === "object" ? message.size.low || message.size.high : message.size !== 0))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.size);
        if (message.fileId != null && $Object.hasOwnProperty.call(message, "fileId") && message.fileId !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fileId);
        if (message.fileUrls != null && $Object.hasOwnProperty.call(message, "fileUrls"))
            $root.FileURLs.encode(message.fileUrls, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an UploadedFileInfo message from the specified reader or buffer.
     * @function decode
     * @memberof UploadedFileInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UploadedFileInfo & UploadedFileInfo.$Shape} UploadedFileInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UploadedFileInfo.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.UploadedFileInfo();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.name = value;
                    else
                        delete message.name;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                        message.size = value;
                    else
                        delete message.size;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.fileId = value;
                    else
                        delete message.fileId;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.fileUrls = $root.FileURLs.decode(reader, reader.uint32(), $undefined, _depth + 1, message.fileUrls);
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an UploadedFileInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UploadedFileInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UploadedFileInfo} UploadedFileInfo
     */
    UploadedFileInfo.fromObject = function (object, _depth) {
        if (object instanceof $root.UploadedFileInfo)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".UploadedFileInfo: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.UploadedFileInfo();
        if (object.name != null)
            if (typeof object.name !== "string" || object.name.length)
                message.name = $String(object.name);
        if (object.size != null)
            if (typeof object.size === "object" ? object.size.low || object.size.high : $Number(object.size) !== 0)
                if ($util.Long)
                    message.size = $util.Long.fromValue(object.size, true);
                else if (typeof object.size === "string")
                    message.size = $parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
        if (object.fileId != null)
            if (typeof object.fileId !== "string" || object.fileId.length)
                message.fileId = $String(object.fileId);
        if (object.fileUrls != null) {
            if (!$util.isObject(object.fileUrls))
                throw $TypeError(".UploadedFileInfo.fileUrls: object expected");
            message.fileUrls = $root.FileURLs.fromObject(object.fileUrls, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from an UploadedFileInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UploadedFileInfo
     * @static
     * @param {UploadedFileInfo} message UploadedFileInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UploadedFileInfo.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.name = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.size = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.size = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            object.fileId = "";
            object.fileUrls = null;
        }
        if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
            object.name = message.name;
        if (message.size != null && $Object.hasOwnProperty.call(message, "size"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.size = typeof message.size === "number" ? $BigInt(message.size) : $util.Long.fromBits(message.size.low >>> 0, message.size.high >>> 0, true).toBigInt();
            else if (typeof message.size === "number")
                object.size = options.longs === $String ? $String(message.size) : message.size;
            else
                object.size = options.longs === $String ? $util.Long.prototype.toString.call(message.size) : options.longs === $Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
        if (message.fileId != null && $Object.hasOwnProperty.call(message, "fileId"))
            object.fileId = message.fileId;
        if (message.fileUrls != null && $Object.hasOwnProperty.call(message, "fileUrls"))
            object.fileUrls = $root.FileURLs.toObject(message.fileUrls, options, _depth + 1);
        return object;
    };

    /**
     * Converts this UploadedFileInfo to JSON.
     * @function toJSON
     * @memberof UploadedFileInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UploadedFileInfo.prototype.toJSON = function() {
        return UploadedFileInfo.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for UploadedFileInfo
     * @function getTypeUrl
     * @memberof UploadedFileInfo
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    UploadedFileInfo.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/UploadedFileInfo";
    };

    return UploadedFileInfo;
})();

export const FileUploaderState = $root.FileUploaderState = (() => {

    /**
     * Properties of a FileUploaderState.
     * @typedef {Object} FileUploaderState.$Properties
     * @property {Array.<UploadedFileInfo.$Properties>|null} [uploadedFileInfo] FileUploaderState uploadedFileInfo
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a FileUploaderState.
     * @exports IFileUploaderState
     * @interface IFileUploaderState
     * @augments FileUploaderState.$Properties
     * @deprecated Use FileUploaderState.$Properties instead.
     */

    /**
     * Shape of a FileUploaderState.
     * @typedef {FileUploaderState.$Properties} FileUploaderState.$Shape
     */

    /**
     * Constructs a new FileUploaderState.
     * @exports FileUploaderState
     * @classdesc Represents a FileUploaderState.
     * @constructor
     * @param {FileUploaderState.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const FileUploaderState = function (properties) {
        this.uploadedFileInfo = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * FileUploaderState uploadedFileInfo.
     * @member {Array.<UploadedFileInfo.$Properties>} uploadedFileInfo
     * @memberof FileUploaderState
     * @instance
     */
    FileUploaderState.prototype.uploadedFileInfo = $util.emptyArray;

    /**
     * Creates a new FileUploaderState instance using the specified properties.
     * @function create
     * @memberof FileUploaderState
     * @static
     * @param {FileUploaderState.$Properties=} [properties] Properties to set
     * @returns {FileUploaderState} FileUploaderState instance
     * @type {{
     *   (properties: FileUploaderState.$Shape): FileUploaderState & FileUploaderState.$Shape;
     *   (properties?: FileUploaderState.$Properties): FileUploaderState;
     * }}
     */
    FileUploaderState.create = function(properties) {
        return new FileUploaderState(properties);
    };

    /**
     * Encodes the specified FileUploaderState message. Does not implicitly {@link FileUploaderState.verify|verify} messages.
     * @function encode
     * @memberof FileUploaderState
     * @static
     * @param {FileUploaderState.$Properties} message FileUploaderState message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FileUploaderState.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.uploadedFileInfo != null && message.uploadedFileInfo.length)
            for (let i = 0; i < message.uploadedFileInfo.length; ++i)
                $root.UploadedFileInfo.encode(message.uploadedFileInfo[i], writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a FileUploaderState message from the specified reader or buffer.
     * @function decode
     * @memberof FileUploaderState
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FileUploaderState & FileUploaderState.$Shape} FileUploaderState
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FileUploaderState.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.FileUploaderState();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 2: {
                    if (wireType !== 2)
                        break;
                    if (!(message.uploadedFileInfo && message.uploadedFileInfo.length))
                        message.uploadedFileInfo = [];
                    message.uploadedFileInfo.push($root.UploadedFileInfo.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a FileUploaderState message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FileUploaderState
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FileUploaderState} FileUploaderState
     */
    FileUploaderState.fromObject = function (object, _depth) {
        if (object instanceof $root.FileUploaderState)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".FileUploaderState: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.FileUploaderState();
        if (object.uploadedFileInfo) {
            if (!$Array.isArray(object.uploadedFileInfo))
                throw $TypeError(".FileUploaderState.uploadedFileInfo: array expected");
            message.uploadedFileInfo = $Array(object.uploadedFileInfo.length);
            for (let i = 0; i < object.uploadedFileInfo.length; ++i) {
                if (!$util.isObject(object.uploadedFileInfo[i]))
                    throw $TypeError(".FileUploaderState.uploadedFileInfo: object expected");
                message.uploadedFileInfo[i] = $root.UploadedFileInfo.fromObject(object.uploadedFileInfo[i], _depth + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a FileUploaderState message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FileUploaderState
     * @static
     * @param {FileUploaderState} message FileUploaderState
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FileUploaderState.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.uploadedFileInfo = [];
        if (message.uploadedFileInfo && message.uploadedFileInfo.length) {
            object.uploadedFileInfo = $Array(message.uploadedFileInfo.length);
            for (let j = 0; j < message.uploadedFileInfo.length; ++j)
                object.uploadedFileInfo[j] = $root.UploadedFileInfo.toObject(message.uploadedFileInfo[j], options, _depth + 1);
        }
        return object;
    };

    /**
     * Converts this FileUploaderState to JSON.
     * @function toJSON
     * @memberof FileUploaderState
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FileUploaderState.prototype.toJSON = function() {
        return FileUploaderState.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for FileUploaderState
     * @function getTypeUrl
     * @memberof FileUploaderState
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    FileUploaderState.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/FileUploaderState";
    };

    return FileUploaderState;
})();

export const ChatInputValue = $root.ChatInputValue = (() => {

    /**
     * Properties of a ChatInputValue.
     * @typedef {Object} ChatInputValue.$Properties
     * @property {string|null} [data] ChatInputValue data
     * @property {FileUploaderState.$Properties|null} [fileUploaderState] ChatInputValue fileUploaderState
     * @property {UploadedFileInfo.$Properties|null} [audioFileInfo] ChatInputValue audioFileInfo
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ChatInputValue.
     * @exports IChatInputValue
     * @interface IChatInputValue
     * @augments ChatInputValue.$Properties
     * @deprecated Use ChatInputValue.$Properties instead.
     */

    /**
     * Shape of a ChatInputValue.
     * @typedef {ChatInputValue.$Properties} ChatInputValue.$Shape
     */

    /**
     * Constructs a new ChatInputValue.
     * @exports ChatInputValue
     * @classdesc Represents a ChatInputValue.
     * @constructor
     * @param {ChatInputValue.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ChatInputValue = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ChatInputValue data.
     * @member {string|null|undefined} data
     * @memberof ChatInputValue
     * @instance
     */
    ChatInputValue.prototype.data = null;

    /**
     * ChatInputValue fileUploaderState.
     * @member {FileUploaderState.$Properties|null|undefined} fileUploaderState
     * @memberof ChatInputValue
     * @instance
     */
    ChatInputValue.prototype.fileUploaderState = null;

    /**
     * ChatInputValue audioFileInfo.
     * @member {UploadedFileInfo.$Properties|null|undefined} audioFileInfo
     * @memberof ChatInputValue
     * @instance
     */
    ChatInputValue.prototype.audioFileInfo = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ChatInputValue.prototype, "_data", {
        get: $util.oneOfGetter($oneOfFields = ["data"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ChatInputValue.prototype, "_fileUploaderState", {
        get: $util.oneOfGetter($oneOfFields = ["fileUploaderState"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ChatInputValue.prototype, "_audioFileInfo", {
        get: $util.oneOfGetter($oneOfFields = ["audioFileInfo"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ChatInputValue instance using the specified properties.
     * @function create
     * @memberof ChatInputValue
     * @static
     * @param {ChatInputValue.$Properties=} [properties] Properties to set
     * @returns {ChatInputValue} ChatInputValue instance
     * @type {{
     *   (properties: ChatInputValue.$Shape): ChatInputValue & ChatInputValue.$Shape;
     *   (properties?: ChatInputValue.$Properties): ChatInputValue;
     * }}
     */
    ChatInputValue.create = function(properties) {
        return new ChatInputValue(properties);
    };

    /**
     * Encodes the specified ChatInputValue message. Does not implicitly {@link ChatInputValue.verify|verify} messages.
     * @function encode
     * @memberof ChatInputValue
     * @static
     * @param {ChatInputValue.$Properties} message ChatInputValue message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChatInputValue.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
        if (message.fileUploaderState != null && $Object.hasOwnProperty.call(message, "fileUploaderState"))
            $root.FileUploaderState.encode(message.fileUploaderState, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.audioFileInfo != null && $Object.hasOwnProperty.call(message, "audioFileInfo"))
            $root.UploadedFileInfo.encode(message.audioFileInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ChatInputValue message from the specified reader or buffer.
     * @function decode
     * @memberof ChatInputValue
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ChatInputValue & ChatInputValue.$Shape} ChatInputValue
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChatInputValue.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ChatInputValue();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.data = reader.stringVerify();
                    message._data = "data";
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    message.fileUploaderState = $root.FileUploaderState.decode(reader, reader.uint32(), $undefined, _depth + 1, message.fileUploaderState);
                    message._fileUploaderState = "fileUploaderState";
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.audioFileInfo = $root.UploadedFileInfo.decode(reader, reader.uint32(), $undefined, _depth + 1, message.audioFileInfo);
                    message._audioFileInfo = "audioFileInfo";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ChatInputValue message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ChatInputValue
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ChatInputValue} ChatInputValue
     */
    ChatInputValue.fromObject = function (object, _depth) {
        if (object instanceof $root.ChatInputValue)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ChatInputValue: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ChatInputValue();
        if (object.data != null)
            message.data = $String(object.data);
        if (object.fileUploaderState != null) {
            if (!$util.isObject(object.fileUploaderState))
                throw $TypeError(".ChatInputValue.fileUploaderState: object expected");
            message.fileUploaderState = $root.FileUploaderState.fromObject(object.fileUploaderState, _depth + 1);
        }
        if (object.audioFileInfo != null) {
            if (!$util.isObject(object.audioFileInfo))
                throw $TypeError(".ChatInputValue.audioFileInfo: object expected");
            message.audioFileInfo = $root.UploadedFileInfo.fromObject(object.audioFileInfo, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a ChatInputValue message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ChatInputValue
     * @static
     * @param {ChatInputValue} message ChatInputValue
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ChatInputValue.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            object.data = message.data;
        if (message.fileUploaderState != null && $Object.hasOwnProperty.call(message, "fileUploaderState"))
            object.fileUploaderState = $root.FileUploaderState.toObject(message.fileUploaderState, options, _depth + 1);
        if (message.audioFileInfo != null && $Object.hasOwnProperty.call(message, "audioFileInfo"))
            object.audioFileInfo = $root.UploadedFileInfo.toObject(message.audioFileInfo, options, _depth + 1);
        return object;
    };

    /**
     * Converts this ChatInputValue to JSON.
     * @function toJSON
     * @memberof ChatInputValue
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ChatInputValue.prototype.toJSON = function() {
        return ChatInputValue.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ChatInputValue
     * @function getTypeUrl
     * @memberof ChatInputValue
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ChatInputValue.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ChatInputValue";
    };

    return ChatInputValue;
})();

export const ComponentInstance = $root.ComponentInstance = (() => {

    /**
     * Properties of a ComponentInstance.
     * @typedef {Object} ComponentInstance.$Properties
     * @property {string|null} [id] ComponentInstance id
     * @property {string|null} [jsonArgs] ComponentInstance jsonArgs
     * @property {Array.<SpecialArg.$Properties>|null} [specialArgs] ComponentInstance specialArgs
     * @property {string|null} [componentName] ComponentInstance componentName
     * @property {string|null} [url] ComponentInstance url
     * @property {string|null} [formId] ComponentInstance formId
     * @property {number|null} [tabIndex] ComponentInstance tabIndex
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ComponentInstance.
     * @exports IComponentInstance
     * @interface IComponentInstance
     * @augments ComponentInstance.$Properties
     * @deprecated Use ComponentInstance.$Properties instead.
     */

    /**
     * Shape of a ComponentInstance.
     * @typedef {{
     *   id?: string|null;
     *   jsonArgs?: string|null;
     *   specialArgs?: Array.<SpecialArg.$Shape>|null;
     *   componentName?: string|null;
     *   url?: string|null;
     *   formId?: string|null;
     *   tabIndex?: number|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} ComponentInstance.$Shape
     */

    /**
     * Constructs a new ComponentInstance.
     * @exports ComponentInstance
     * @classdesc Represents a ComponentInstance.
     * @constructor
     * @param {ComponentInstance.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ComponentInstance = function (properties) {
        this.specialArgs = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ComponentInstance id.
     * @member {string} id
     * @memberof ComponentInstance
     * @instance
     */
    ComponentInstance.prototype.id = "";

    /**
     * ComponentInstance jsonArgs.
     * @member {string} jsonArgs
     * @memberof ComponentInstance
     * @instance
     */
    ComponentInstance.prototype.jsonArgs = "";

    /**
     * ComponentInstance specialArgs.
     * @member {Array.<SpecialArg.$Properties>} specialArgs
     * @memberof ComponentInstance
     * @instance
     */
    ComponentInstance.prototype.specialArgs = $util.emptyArray;

    /**
     * ComponentInstance componentName.
     * @member {string} componentName
     * @memberof ComponentInstance
     * @instance
     */
    ComponentInstance.prototype.componentName = "";

    /**
     * ComponentInstance url.
     * @member {string} url
     * @memberof ComponentInstance
     * @instance
     */
    ComponentInstance.prototype.url = "";

    /**
     * ComponentInstance formId.
     * @member {string} formId
     * @memberof ComponentInstance
     * @instance
     */
    ComponentInstance.prototype.formId = "";

    /**
     * ComponentInstance tabIndex.
     * @member {number|null|undefined} tabIndex
     * @memberof ComponentInstance
     * @instance
     */
    ComponentInstance.prototype.tabIndex = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ComponentInstance.prototype, "_tabIndex", {
        get: $util.oneOfGetter($oneOfFields = ["tabIndex"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ComponentInstance instance using the specified properties.
     * @function create
     * @memberof ComponentInstance
     * @static
     * @param {ComponentInstance.$Properties=} [properties] Properties to set
     * @returns {ComponentInstance} ComponentInstance instance
     * @type {{
     *   (properties: ComponentInstance.$Shape): ComponentInstance & ComponentInstance.$Shape;
     *   (properties?: ComponentInstance.$Properties): ComponentInstance;
     * }}
     */
    ComponentInstance.create = function(properties) {
        return new ComponentInstance(properties);
    };

    /**
     * Encodes the specified ComponentInstance message. Does not implicitly {@link ComponentInstance.verify|verify} messages.
     * @function encode
     * @memberof ComponentInstance
     * @static
     * @param {ComponentInstance.$Properties} message ComponentInstance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ComponentInstance.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.jsonArgs != null && $Object.hasOwnProperty.call(message, "jsonArgs") && message.jsonArgs !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.jsonArgs);
        if (message.specialArgs != null && message.specialArgs.length)
            for (let i = 0; i < message.specialArgs.length; ++i)
                $root.SpecialArg.encode(message.specialArgs[i], writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
        if (message.componentName != null && $Object.hasOwnProperty.call(message, "componentName") && message.componentName !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.componentName);
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.url);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.formId);
        if (message.tabIndex != null && $Object.hasOwnProperty.call(message, "tabIndex"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.tabIndex);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ComponentInstance message from the specified reader or buffer.
     * @function decode
     * @memberof ComponentInstance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ComponentInstance & ComponentInstance.$Shape} ComponentInstance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ComponentInstance.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ComponentInstance();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.jsonArgs = value;
                    else
                        delete message.jsonArgs;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if (!(message.specialArgs && message.specialArgs.length))
                        message.specialArgs = [];
                    message.specialArgs.push($root.SpecialArg.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.componentName = value;
                    else
                        delete message.componentName;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    message.tabIndex = reader.int32();
                    message._tabIndex = "tabIndex";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ComponentInstance message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ComponentInstance
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ComponentInstance} ComponentInstance
     */
    ComponentInstance.fromObject = function (object, _depth) {
        if (object instanceof $root.ComponentInstance)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ComponentInstance: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ComponentInstance();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.jsonArgs != null)
            if (typeof object.jsonArgs !== "string" || object.jsonArgs.length)
                message.jsonArgs = $String(object.jsonArgs);
        if (object.specialArgs) {
            if (!$Array.isArray(object.specialArgs))
                throw $TypeError(".ComponentInstance.specialArgs: array expected");
            message.specialArgs = $Array(object.specialArgs.length);
            for (let i = 0; i < object.specialArgs.length; ++i) {
                if (!$util.isObject(object.specialArgs[i]))
                    throw $TypeError(".ComponentInstance.specialArgs: object expected");
                message.specialArgs[i] = $root.SpecialArg.fromObject(object.specialArgs[i], _depth + 1);
            }
        }
        if (object.componentName != null)
            if (typeof object.componentName !== "string" || object.componentName.length)
                message.componentName = $String(object.componentName);
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.tabIndex != null)
            message.tabIndex = object.tabIndex | 0;
        return message;
    };

    /**
     * Creates a plain object from a ComponentInstance message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ComponentInstance
     * @static
     * @param {ComponentInstance} message ComponentInstance
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ComponentInstance.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.specialArgs = [];
        if (options.defaults) {
            object.id = "";
            object.jsonArgs = "";
            object.componentName = "";
            object.url = "";
            object.formId = "";
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.jsonArgs != null && $Object.hasOwnProperty.call(message, "jsonArgs"))
            object.jsonArgs = message.jsonArgs;
        if (message.specialArgs && message.specialArgs.length) {
            object.specialArgs = $Array(message.specialArgs.length);
            for (let j = 0; j < message.specialArgs.length; ++j)
                object.specialArgs[j] = $root.SpecialArg.toObject(message.specialArgs[j], options, _depth + 1);
        }
        if (message.componentName != null && $Object.hasOwnProperty.call(message, "componentName"))
            object.componentName = message.componentName;
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.tabIndex != null && $Object.hasOwnProperty.call(message, "tabIndex"))
            object.tabIndex = message.tabIndex;
        return object;
    };

    /**
     * Converts this ComponentInstance to JSON.
     * @function toJSON
     * @memberof ComponentInstance
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ComponentInstance.prototype.toJSON = function() {
        return ComponentInstance.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ComponentInstance
     * @function getTypeUrl
     * @memberof ComponentInstance
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ComponentInstance.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ComponentInstance";
    };

    return ComponentInstance;
})();

export const SpecialArg = $root.SpecialArg = (() => {

    /**
     * Properties of a SpecialArg.
     * @typedef {Object} SpecialArg.$Properties
     * @property {string|null} [key] SpecialArg key
     * @property {ArrowDataframe.$Properties|null} [arrowDataframe] SpecialArg arrowDataframe
     * @property {Uint8Array|null} [bytes] SpecialArg bytes
     * @property {"arrowDataframe"|"bytes"} [value] SpecialArg value
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a SpecialArg.
     * @exports ISpecialArg
     * @interface ISpecialArg
     * @augments SpecialArg.$Properties
     * @deprecated Use SpecialArg.$Properties instead.
     */

    /**
     * Narrowed shape of a SpecialArg.
     * @typedef {{
     *   key?: string|null;
     *   arrowDataframe?: ArrowDataframe.$Shape|null;
     *   bytes?: Uint8Array|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ value?: undefined; arrowDataframe?: null; bytes?: null }|{ value?: "arrowDataframe"; arrowDataframe: ArrowDataframe.$Shape; bytes?: null }|{ value?: "bytes"; arrowDataframe?: null; bytes: Uint8Array })
     * )} SpecialArg.$Shape
     */

    /**
     * Constructs a new SpecialArg.
     * @exports SpecialArg
     * @classdesc Represents a SpecialArg.
     * @constructor
     * @param {SpecialArg.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const SpecialArg = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * SpecialArg key.
     * @member {string} key
     * @memberof SpecialArg
     * @instance
     */
    SpecialArg.prototype.key = "";

    /**
     * SpecialArg arrowDataframe.
     * @member {ArrowDataframe.$Properties|null|undefined} arrowDataframe
     * @memberof SpecialArg
     * @instance
     */
    SpecialArg.prototype.arrowDataframe = null;

    /**
     * SpecialArg bytes.
     * @member {Uint8Array|null|undefined} bytes
     * @memberof SpecialArg
     * @instance
     */
    SpecialArg.prototype.bytes = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * SpecialArg value.
     * @member {"arrowDataframe"|"bytes"|undefined} value
     * @memberof SpecialArg
     * @instance
     */
    $Object.defineProperty(SpecialArg.prototype, "value", {
        get: $util.oneOfGetter($oneOfFields = ["arrowDataframe", "bytes"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new SpecialArg instance using the specified properties.
     * @function create
     * @memberof SpecialArg
     * @static
     * @param {SpecialArg.$Properties=} [properties] Properties to set
     * @returns {SpecialArg} SpecialArg instance
     * @type {{
     *   (properties: SpecialArg.$Shape): SpecialArg & SpecialArg.$Shape;
     *   (properties?: SpecialArg.$Properties): SpecialArg;
     * }}
     */
    SpecialArg.create = function(properties) {
        return new SpecialArg(properties);
    };

    /**
     * Encodes the specified SpecialArg message. Does not implicitly {@link SpecialArg.verify|verify} messages.
     * @function encode
     * @memberof SpecialArg
     * @static
     * @param {SpecialArg.$Properties} message SpecialArg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpecialArg.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.key != null && $Object.hasOwnProperty.call(message, "key") && message.key !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
        if (message.arrowDataframe != null && $Object.hasOwnProperty.call(message, "arrowDataframe"))
            $root.ArrowDataframe.encode(message.arrowDataframe, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.bytes != null && $Object.hasOwnProperty.call(message, "bytes"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.bytes);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a SpecialArg message from the specified reader or buffer.
     * @function decode
     * @memberof SpecialArg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SpecialArg & SpecialArg.$Shape} SpecialArg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpecialArg.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.SpecialArg();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.key = value;
                    else
                        delete message.key;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    message.arrowDataframe = $root.ArrowDataframe.decode(reader, reader.uint32(), $undefined, _depth + 1, message.arrowDataframe);
                    message.value = "arrowDataframe";
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.bytes = reader.bytes();
                    message.value = "bytes";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a SpecialArg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SpecialArg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SpecialArg} SpecialArg
     */
    SpecialArg.fromObject = function (object, _depth) {
        if (object instanceof $root.SpecialArg)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".SpecialArg: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.SpecialArg();
        if (object.key != null)
            if (typeof object.key !== "string" || object.key.length)
                message.key = $String(object.key);
        if (object.arrowDataframe != null) {
            if (!$util.isObject(object.arrowDataframe))
                throw $TypeError(".SpecialArg.arrowDataframe: object expected");
            message.arrowDataframe = $root.ArrowDataframe.fromObject(object.arrowDataframe, _depth + 1);
        }
        if (object.bytes != null)
            if (typeof object.bytes === "string")
                $util.base64.decode(object.bytes, message.bytes = $util.newBuffer($util.base64.length(object.bytes)), 0);
            else if (object.bytes.length >= 0)
                message.bytes = object.bytes;
        return message;
    };

    /**
     * Creates a plain object from a SpecialArg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SpecialArg
     * @static
     * @param {SpecialArg} message SpecialArg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SpecialArg.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.key = "";
        if (message.key != null && $Object.hasOwnProperty.call(message, "key"))
            object.key = message.key;
        if (message.arrowDataframe != null && $Object.hasOwnProperty.call(message, "arrowDataframe")) {
            object.arrowDataframe = $root.ArrowDataframe.toObject(message.arrowDataframe, options, _depth + 1);
            if (options.oneofs)
                object.value = "arrowDataframe";
        }
        if (message.bytes != null && $Object.hasOwnProperty.call(message, "bytes")) {
            object.bytes = options.bytes === $String ? $util.base64.encode(message.bytes, 0, message.bytes.length) : options.bytes === $Array ? $Array.prototype.slice.call(message.bytes) : message.bytes;
            if (options.oneofs)
                object.value = "bytes";
        }
        return object;
    };

    /**
     * Converts this SpecialArg to JSON.
     * @function toJSON
     * @memberof SpecialArg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SpecialArg.prototype.toJSON = function() {
        return SpecialArg.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for SpecialArg
     * @function getTypeUrl
     * @memberof SpecialArg
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    SpecialArg.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/SpecialArg";
    };

    return SpecialArg;
})();

export const ArrowDataframe = $root.ArrowDataframe = (() => {

    /**
     * Properties of an ArrowDataframe.
     * @typedef {Object} ArrowDataframe.$Properties
     * @property {ArrowTable.$Properties|null} [data] ArrowDataframe data
     * @property {number|null} [height] ArrowDataframe height
     * @property {number|null} [width] ArrowDataframe width
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an ArrowDataframe.
     * @exports IArrowDataframe
     * @interface IArrowDataframe
     * @augments ArrowDataframe.$Properties
     * @deprecated Use ArrowDataframe.$Properties instead.
     */

    /**
     * Shape of an ArrowDataframe.
     * @typedef {ArrowDataframe.$Properties} ArrowDataframe.$Shape
     */

    /**
     * Constructs a new ArrowDataframe.
     * @exports ArrowDataframe
     * @classdesc Represents an ArrowDataframe.
     * @constructor
     * @param {ArrowDataframe.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ArrowDataframe = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ArrowDataframe data.
     * @member {ArrowTable.$Properties|null|undefined} data
     * @memberof ArrowDataframe
     * @instance
     */
    ArrowDataframe.prototype.data = null;

    /**
     * ArrowDataframe height.
     * @member {number} height
     * @memberof ArrowDataframe
     * @instance
     */
    ArrowDataframe.prototype.height = 0;

    /**
     * ArrowDataframe width.
     * @member {number} width
     * @memberof ArrowDataframe
     * @instance
     */
    ArrowDataframe.prototype.width = 0;

    /**
     * Creates a new ArrowDataframe instance using the specified properties.
     * @function create
     * @memberof ArrowDataframe
     * @static
     * @param {ArrowDataframe.$Properties=} [properties] Properties to set
     * @returns {ArrowDataframe} ArrowDataframe instance
     * @type {{
     *   (properties: ArrowDataframe.$Shape): ArrowDataframe & ArrowDataframe.$Shape;
     *   (properties?: ArrowDataframe.$Properties): ArrowDataframe;
     * }}
     */
    ArrowDataframe.create = function(properties) {
        return new ArrowDataframe(properties);
    };

    /**
     * Encodes the specified ArrowDataframe message. Does not implicitly {@link ArrowDataframe.verify|verify} messages.
     * @function encode
     * @memberof ArrowDataframe
     * @static
     * @param {ArrowDataframe.$Properties} message ArrowDataframe message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ArrowDataframe.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            $root.ArrowTable.encode(message.data, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.height != null && $Object.hasOwnProperty.call(message, "height") && message.height !== 0)
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.height);
        if (message.width != null && $Object.hasOwnProperty.call(message, "width") && message.width !== 0)
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.width);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an ArrowDataframe message from the specified reader or buffer.
     * @function decode
     * @memberof ArrowDataframe
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ArrowDataframe & ArrowDataframe.$Shape} ArrowDataframe
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ArrowDataframe.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ArrowDataframe();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.data = $root.ArrowTable.decode(reader, reader.uint32(), $undefined, _depth + 1, message.data);
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message.height = value;
                    else
                        delete message.height;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message.width = value;
                    else
                        delete message.width;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an ArrowDataframe message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ArrowDataframe
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ArrowDataframe} ArrowDataframe
     */
    ArrowDataframe.fromObject = function (object, _depth) {
        if (object instanceof $root.ArrowDataframe)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ArrowDataframe: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ArrowDataframe();
        if (object.data != null) {
            if (!$util.isObject(object.data))
                throw $TypeError(".ArrowDataframe.data: object expected");
            message.data = $root.ArrowTable.fromObject(object.data, _depth + 1);
        }
        if (object.height != null)
            if ($Number(object.height) !== 0)
                message.height = object.height >>> 0;
        if (object.width != null)
            if ($Number(object.width) !== 0)
                message.width = object.width >>> 0;
        return message;
    };

    /**
     * Creates a plain object from an ArrowDataframe message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ArrowDataframe
     * @static
     * @param {ArrowDataframe} message ArrowDataframe
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ArrowDataframe.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.data = null;
            object.height = 0;
            object.width = 0;
        }
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            object.data = $root.ArrowTable.toObject(message.data, options, _depth + 1);
        if (message.height != null && $Object.hasOwnProperty.call(message, "height"))
            object.height = message.height;
        if (message.width != null && $Object.hasOwnProperty.call(message, "width"))
            object.width = message.width;
        return object;
    };

    /**
     * Converts this ArrowDataframe to JSON.
     * @function toJSON
     * @memberof ArrowDataframe
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ArrowDataframe.prototype.toJSON = function() {
        return ArrowDataframe.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ArrowDataframe
     * @function getTypeUrl
     * @memberof ArrowDataframe
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ArrowDataframe.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ArrowDataframe";
    };

    return ArrowDataframe;
})();

export const ArrowTable = $root.ArrowTable = (() => {

    /**
     * Properties of an ArrowTable.
     * @typedef {Object} ArrowTable.$Properties
     * @property {Uint8Array|null} [data] ArrowTable data
     * @property {Uint8Array|null} [index] ArrowTable index
     * @property {Uint8Array|null} [columns] ArrowTable columns
     * @property {ArrowTableStyler.$Properties|null} [styler] ArrowTable styler
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an ArrowTable.
     * @exports IArrowTable
     * @interface IArrowTable
     * @augments ArrowTable.$Properties
     * @deprecated Use ArrowTable.$Properties instead.
     */

    /**
     * Shape of an ArrowTable.
     * @typedef {ArrowTable.$Properties} ArrowTable.$Shape
     */

    /**
     * Constructs a new ArrowTable.
     * @exports ArrowTable
     * @classdesc Represents an ArrowTable.
     * @constructor
     * @param {ArrowTable.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ArrowTable = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ArrowTable data.
     * @member {Uint8Array} data
     * @memberof ArrowTable
     * @instance
     */
    ArrowTable.prototype.data = $util.newBuffer([]);

    /**
     * ArrowTable index.
     * @member {Uint8Array} index
     * @memberof ArrowTable
     * @instance
     */
    ArrowTable.prototype.index = $util.newBuffer([]);

    /**
     * ArrowTable columns.
     * @member {Uint8Array} columns
     * @memberof ArrowTable
     * @instance
     */
    ArrowTable.prototype.columns = $util.newBuffer([]);

    /**
     * ArrowTable styler.
     * @member {ArrowTableStyler.$Properties|null|undefined} styler
     * @memberof ArrowTable
     * @instance
     */
    ArrowTable.prototype.styler = null;

    /**
     * Creates a new ArrowTable instance using the specified properties.
     * @function create
     * @memberof ArrowTable
     * @static
     * @param {ArrowTable.$Properties=} [properties] Properties to set
     * @returns {ArrowTable} ArrowTable instance
     * @type {{
     *   (properties: ArrowTable.$Shape): ArrowTable & ArrowTable.$Shape;
     *   (properties?: ArrowTable.$Properties): ArrowTable;
     * }}
     */
    ArrowTable.create = function(properties) {
        return new ArrowTable(properties);
    };

    /**
     * Encodes the specified ArrowTable message. Does not implicitly {@link ArrowTable.verify|verify} messages.
     * @function encode
     * @memberof ArrowTable
     * @static
     * @param {ArrowTable.$Properties} message ArrowTable message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ArrowTable.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.data != null && $Object.hasOwnProperty.call(message, "data") && message.data.length)
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.data);
        if (message.index != null && $Object.hasOwnProperty.call(message, "index") && message.index.length)
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.index);
        if (message.columns != null && $Object.hasOwnProperty.call(message, "columns") && message.columns.length)
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.columns);
        if (message.styler != null && $Object.hasOwnProperty.call(message, "styler"))
            $root.ArrowTableStyler.encode(message.styler, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an ArrowTable message from the specified reader or buffer.
     * @function decode
     * @memberof ArrowTable
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ArrowTable & ArrowTable.$Shape} ArrowTable
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ArrowTable.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ArrowTable();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.bytes()).length)
                        message.data = value;
                    else
                        delete message.data;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.bytes()).length)
                        message.index = value;
                    else
                        delete message.index;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.bytes()).length)
                        message.columns = value;
                    else
                        delete message.columns;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.styler = $root.ArrowTableStyler.decode(reader, reader.uint32(), $undefined, _depth + 1, message.styler);
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an ArrowTable message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ArrowTable
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ArrowTable} ArrowTable
     */
    ArrowTable.fromObject = function (object, _depth) {
        if (object instanceof $root.ArrowTable)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ArrowTable: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ArrowTable();
        if (object.data != null)
            if (object.data.length)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
        if (object.index != null)
            if (object.index.length)
                if (typeof object.index === "string")
                    $util.base64.decode(object.index, message.index = $util.newBuffer($util.base64.length(object.index)), 0);
                else if (object.index.length >= 0)
                    message.index = object.index;
        if (object.columns != null)
            if (object.columns.length)
                if (typeof object.columns === "string")
                    $util.base64.decode(object.columns, message.columns = $util.newBuffer($util.base64.length(object.columns)), 0);
                else if (object.columns.length >= 0)
                    message.columns = object.columns;
        if (object.styler != null) {
            if (!$util.isObject(object.styler))
                throw $TypeError(".ArrowTable.styler: object expected");
            message.styler = $root.ArrowTableStyler.fromObject(object.styler, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from an ArrowTable message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ArrowTable
     * @static
     * @param {ArrowTable} message ArrowTable
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ArrowTable.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            if (options.bytes === $String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== $Array)
                    object.data = $util.newBuffer(object.data);
            }
            if (options.bytes === $String)
                object.index = "";
            else {
                object.index = [];
                if (options.bytes !== $Array)
                    object.index = $util.newBuffer(object.index);
            }
            if (options.bytes === $String)
                object.columns = "";
            else {
                object.columns = [];
                if (options.bytes !== $Array)
                    object.columns = $util.newBuffer(object.columns);
            }
            object.styler = null;
        }
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            object.data = options.bytes === $String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === $Array ? $Array.prototype.slice.call(message.data) : message.data;
        if (message.index != null && $Object.hasOwnProperty.call(message, "index"))
            object.index = options.bytes === $String ? $util.base64.encode(message.index, 0, message.index.length) : options.bytes === $Array ? $Array.prototype.slice.call(message.index) : message.index;
        if (message.columns != null && $Object.hasOwnProperty.call(message, "columns"))
            object.columns = options.bytes === $String ? $util.base64.encode(message.columns, 0, message.columns.length) : options.bytes === $Array ? $Array.prototype.slice.call(message.columns) : message.columns;
        if (message.styler != null && $Object.hasOwnProperty.call(message, "styler"))
            object.styler = $root.ArrowTableStyler.toObject(message.styler, options, _depth + 1);
        return object;
    };

    /**
     * Converts this ArrowTable to JSON.
     * @function toJSON
     * @memberof ArrowTable
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ArrowTable.prototype.toJSON = function() {
        return ArrowTable.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ArrowTable
     * @function getTypeUrl
     * @memberof ArrowTable
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ArrowTable.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ArrowTable";
    };

    return ArrowTable;
})();

export const ArrowTableStyler = $root.ArrowTableStyler = (() => {

    /**
     * Properties of an ArrowTableStyler.
     * @typedef {Object} ArrowTableStyler.$Properties
     * @property {string|null} [uuid] ArrowTableStyler uuid
     * @property {string|null} [caption] ArrowTableStyler caption
     * @property {string|null} [styles] ArrowTableStyler styles
     * @property {Uint8Array|null} [displayValues] ArrowTableStyler displayValues
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an ArrowTableStyler.
     * @exports IArrowTableStyler
     * @interface IArrowTableStyler
     * @augments ArrowTableStyler.$Properties
     * @deprecated Use ArrowTableStyler.$Properties instead.
     */

    /**
     * Shape of an ArrowTableStyler.
     * @typedef {ArrowTableStyler.$Properties} ArrowTableStyler.$Shape
     */

    /**
     * Constructs a new ArrowTableStyler.
     * @exports ArrowTableStyler
     * @classdesc Represents an ArrowTableStyler.
     * @constructor
     * @param {ArrowTableStyler.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ArrowTableStyler = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ArrowTableStyler uuid.
     * @member {string} uuid
     * @memberof ArrowTableStyler
     * @instance
     */
    ArrowTableStyler.prototype.uuid = "";

    /**
     * ArrowTableStyler caption.
     * @member {string} caption
     * @memberof ArrowTableStyler
     * @instance
     */
    ArrowTableStyler.prototype.caption = "";

    /**
     * ArrowTableStyler styles.
     * @member {string} styles
     * @memberof ArrowTableStyler
     * @instance
     */
    ArrowTableStyler.prototype.styles = "";

    /**
     * ArrowTableStyler displayValues.
     * @member {Uint8Array} displayValues
     * @memberof ArrowTableStyler
     * @instance
     */
    ArrowTableStyler.prototype.displayValues = $util.newBuffer([]);

    /**
     * Creates a new ArrowTableStyler instance using the specified properties.
     * @function create
     * @memberof ArrowTableStyler
     * @static
     * @param {ArrowTableStyler.$Properties=} [properties] Properties to set
     * @returns {ArrowTableStyler} ArrowTableStyler instance
     * @type {{
     *   (properties: ArrowTableStyler.$Shape): ArrowTableStyler & ArrowTableStyler.$Shape;
     *   (properties?: ArrowTableStyler.$Properties): ArrowTableStyler;
     * }}
     */
    ArrowTableStyler.create = function(properties) {
        return new ArrowTableStyler(properties);
    };

    /**
     * Encodes the specified ArrowTableStyler message. Does not implicitly {@link ArrowTableStyler.verify|verify} messages.
     * @function encode
     * @memberof ArrowTableStyler
     * @static
     * @param {ArrowTableStyler.$Properties} message ArrowTableStyler message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ArrowTableStyler.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.uuid != null && $Object.hasOwnProperty.call(message, "uuid") && message.uuid !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.uuid);
        if (message.caption != null && $Object.hasOwnProperty.call(message, "caption") && message.caption !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.caption);
        if (message.styles != null && $Object.hasOwnProperty.call(message, "styles") && message.styles !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.styles);
        if (message.displayValues != null && $Object.hasOwnProperty.call(message, "displayValues") && message.displayValues.length)
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.displayValues);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an ArrowTableStyler message from the specified reader or buffer.
     * @function decode
     * @memberof ArrowTableStyler
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ArrowTableStyler & ArrowTableStyler.$Shape} ArrowTableStyler
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ArrowTableStyler.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ArrowTableStyler();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.uuid = value;
                    else
                        delete message.uuid;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.caption = value;
                    else
                        delete message.caption;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.styles = value;
                    else
                        delete message.styles;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.bytes()).length)
                        message.displayValues = value;
                    else
                        delete message.displayValues;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an ArrowTableStyler message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ArrowTableStyler
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ArrowTableStyler} ArrowTableStyler
     */
    ArrowTableStyler.fromObject = function (object, _depth) {
        if (object instanceof $root.ArrowTableStyler)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ArrowTableStyler: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ArrowTableStyler();
        if (object.uuid != null)
            if (typeof object.uuid !== "string" || object.uuid.length)
                message.uuid = $String(object.uuid);
        if (object.caption != null)
            if (typeof object.caption !== "string" || object.caption.length)
                message.caption = $String(object.caption);
        if (object.styles != null)
            if (typeof object.styles !== "string" || object.styles.length)
                message.styles = $String(object.styles);
        if (object.displayValues != null)
            if (object.displayValues.length)
                if (typeof object.displayValues === "string")
                    $util.base64.decode(object.displayValues, message.displayValues = $util.newBuffer($util.base64.length(object.displayValues)), 0);
                else if (object.displayValues.length >= 0)
                    message.displayValues = object.displayValues;
        return message;
    };

    /**
     * Creates a plain object from an ArrowTableStyler message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ArrowTableStyler
     * @static
     * @param {ArrowTableStyler} message ArrowTableStyler
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ArrowTableStyler.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.uuid = "";
            object.caption = "";
            object.styles = "";
            if (options.bytes === $String)
                object.displayValues = "";
            else {
                object.displayValues = [];
                if (options.bytes !== $Array)
                    object.displayValues = $util.newBuffer(object.displayValues);
            }
        }
        if (message.uuid != null && $Object.hasOwnProperty.call(message, "uuid"))
            object.uuid = message.uuid;
        if (message.caption != null && $Object.hasOwnProperty.call(message, "caption"))
            object.caption = message.caption;
        if (message.styles != null && $Object.hasOwnProperty.call(message, "styles"))
            object.styles = message.styles;
        if (message.displayValues != null && $Object.hasOwnProperty.call(message, "displayValues"))
            object.displayValues = options.bytes === $String ? $util.base64.encode(message.displayValues, 0, message.displayValues.length) : options.bytes === $Array ? $Array.prototype.slice.call(message.displayValues) : message.displayValues;
        return object;
    };

    /**
     * Converts this ArrowTableStyler to JSON.
     * @function toJSON
     * @memberof ArrowTableStyler
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ArrowTableStyler.prototype.toJSON = function() {
        return ArrowTableStyler.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ArrowTableStyler
     * @function getTypeUrl
     * @memberof ArrowTableStyler
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ArrowTableStyler.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ArrowTableStyler";
    };

    return ArrowTableStyler;
})();

export const Dataframe = $root.Dataframe = (() => {

    /**
     * Properties of a Dataframe.
     * @typedef {Object} Dataframe.$Properties
     * @property {ArrowData.$Properties|null} [arrowData] Dataframe arrowData
     * @property {string|null} [id] Dataframe id
     * @property {string|null} [columns] Dataframe columns
     * @property {Dataframe.EditingMode|null} [editingMode] Dataframe editingMode
     * @property {boolean|null} [disabled] Dataframe disabled
     * @property {string|null} [formId] Dataframe formId
     * @property {Array.<string>|null} [columnOrder] Dataframe columnOrder
     * @property {Array.<Dataframe.SelectionMode>|null} [selectionMode] Dataframe selectionMode
     * @property {number|null} [rowHeight] Dataframe rowHeight
     * @property {string|null} [placeholder] Dataframe placeholder
     * @property {string|null} [selectionState] Dataframe selectionState
     * @property {string|null} [selectionDefault] Dataframe selectionDefault
     * @property {Object.<string,string>|null} [buttonClickWidgets] Dataframe buttonClickWidgets
     * @property {LazyDataframe.$Properties|null} [lazyData] Dataframe lazyData
     * @property {string|null} [alt] Dataframe alt
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Dataframe.
     * @exports IDataframe
     * @interface IDataframe
     * @augments Dataframe.$Properties
     * @deprecated Use Dataframe.$Properties instead.
     */

    /**
     * Shape of a Dataframe.
     * @typedef {Dataframe.$Properties} Dataframe.$Shape
     */

    /**
     * Constructs a new Dataframe.
     * @exports Dataframe
     * @classdesc Represents a Dataframe.
     * @constructor
     * @param {Dataframe.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Dataframe = function (properties) {
        this.columnOrder = [];
        this.selectionMode = [];
        this.buttonClickWidgets = {};
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Dataframe arrowData.
     * @member {ArrowData.$Properties|null|undefined} arrowData
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.arrowData = null;

    /**
     * Dataframe id.
     * @member {string} id
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.id = "";

    /**
     * Dataframe columns.
     * @member {string} columns
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.columns = "";

    /**
     * Dataframe editingMode.
     * @member {Dataframe.EditingMode} editingMode
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.editingMode = 0;

    /**
     * Dataframe disabled.
     * @member {boolean} disabled
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.disabled = false;

    /**
     * Dataframe formId.
     * @member {string} formId
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.formId = "";

    /**
     * Dataframe columnOrder.
     * @member {Array.<string>} columnOrder
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.columnOrder = $util.emptyArray;

    /**
     * Dataframe selectionMode.
     * @member {Array.<Dataframe.SelectionMode>} selectionMode
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.selectionMode = $util.emptyArray;

    /**
     * Dataframe rowHeight.
     * @member {number|null|undefined} rowHeight
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.rowHeight = null;

    /**
     * Dataframe placeholder.
     * @member {string|null|undefined} placeholder
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.placeholder = null;

    /**
     * Dataframe selectionState.
     * @member {string|null|undefined} selectionState
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.selectionState = null;

    /**
     * Dataframe selectionDefault.
     * @member {string|null|undefined} selectionDefault
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.selectionDefault = null;

    /**
     * Dataframe buttonClickWidgets.
     * @member {Object.<string,string>} buttonClickWidgets
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.buttonClickWidgets = $util.emptyObject;

    /**
     * Dataframe lazyData.
     * @member {LazyDataframe.$Properties|null|undefined} lazyData
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.lazyData = null;

    /**
     * Dataframe alt.
     * @member {string|null|undefined} alt
     * @memberof Dataframe
     * @instance
     */
    Dataframe.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Dataframe.prototype, "_rowHeight", {
        get: $util.oneOfGetter($oneOfFields = ["rowHeight"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Dataframe.prototype, "_placeholder", {
        get: $util.oneOfGetter($oneOfFields = ["placeholder"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Dataframe.prototype, "_selectionState", {
        get: $util.oneOfGetter($oneOfFields = ["selectionState"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Dataframe.prototype, "_selectionDefault", {
        get: $util.oneOfGetter($oneOfFields = ["selectionDefault"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Dataframe.prototype, "_lazyData", {
        get: $util.oneOfGetter($oneOfFields = ["lazyData"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Dataframe.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Dataframe instance using the specified properties.
     * @function create
     * @memberof Dataframe
     * @static
     * @param {Dataframe.$Properties=} [properties] Properties to set
     * @returns {Dataframe} Dataframe instance
     * @type {{
     *   (properties: Dataframe.$Shape): Dataframe & Dataframe.$Shape;
     *   (properties?: Dataframe.$Properties): Dataframe;
     * }}
     */
    Dataframe.create = function(properties) {
        return new Dataframe(properties);
    };

    /**
     * Encodes the specified Dataframe message. Does not implicitly {@link Dataframe.verify|verify} messages.
     * @function encode
     * @memberof Dataframe
     * @static
     * @param {Dataframe.$Properties} message Dataframe message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Dataframe.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.arrowData != null && $Object.hasOwnProperty.call(message, "arrowData"))
            $root.ArrowData.encode(message.arrowData, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.id);
        if (message.columns != null && $Object.hasOwnProperty.call(message, "columns") && message.columns !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.columns);
        if (message.editingMode != null && $Object.hasOwnProperty.call(message, "editingMode") && message.editingMode !== 0)
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.editingMode);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.disabled);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.formId);
        if (message.columnOrder != null && message.columnOrder.length)
            for (let i = 0; i < message.columnOrder.length; ++i)
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.columnOrder[i]);
        if (message.selectionMode != null && message.selectionMode.length)
            writer.uint32(/* id 8, wireType 2 =*/66).int32s(message.selectionMode);
        if (message.rowHeight != null && $Object.hasOwnProperty.call(message, "rowHeight"))
            writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.rowHeight);
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.placeholder);
        if (message.selectionState != null && $Object.hasOwnProperty.call(message, "selectionState"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.selectionState);
        if (message.selectionDefault != null && $Object.hasOwnProperty.call(message, "selectionDefault"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.selectionDefault);
        if (message.buttonClickWidgets != null && $Object.hasOwnProperty.call(message, "buttonClickWidgets"))
            for (let keys = $Object.keys(message.buttonClickWidgets), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 13, wireType 2 =*/106).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.buttonClickWidgets[keys[i]]).ldelim();
        if (message.lazyData != null && $Object.hasOwnProperty.call(message, "lazyData"))
            $root.LazyDataframe.encode(message.lazyData, writer.uint32(/* id 14, wireType 2 =*/114).fork(), _depth + 1).ldelim();
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Dataframe message from the specified reader or buffer.
     * @function decode
     * @memberof Dataframe
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Dataframe & Dataframe.$Shape} Dataframe
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Dataframe.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, key, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Dataframe();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.arrowData = $root.ArrowData.decode(reader, reader.uint32(), $undefined, _depth + 1, message.arrowData);
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.columns = value;
                    else
                        delete message.columns;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.editingMode = value;
                    else
                        delete message.editingMode;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if (!(message.columnOrder && message.columnOrder.length))
                        message.columnOrder = [];
                    message.columnOrder.push(reader.stringVerify());
                    continue;
                }
            case 8: {
                    if (wireType === 2) {
                        if (!(message.selectionMode && message.selectionMode.length))
                            message.selectionMode = [];
                        reader.int32s(message.selectionMode);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message.selectionMode && message.selectionMode.length))
                        message.selectionMode = [];
                    message.selectionMode.push(reader.int32());
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    message.rowHeight = reader.uint32();
                    message._rowHeight = "rowHeight";
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.placeholder = reader.stringVerify();
                    message._placeholder = "placeholder";
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.selectionState = reader.stringVerify();
                    message._selectionState = "selectionState";
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.selectionDefault = reader.stringVerify();
                    message._selectionDefault = "selectionDefault";
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    if (message.buttonClickWidgets === $util.emptyObject)
                        message.buttonClickWidgets = {};
                    let end2 = reader.uint32() + reader.pos;
                    if (end2 > reader.len)
                        throw $RangeError("index out of range");
                    reader.len = end2;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.tag();
                        wireType = tag2 & 7;
                        switch (tag2 >>>= 3) {
                        case 1:
                            if (wireType !== 2)
                                break;
                            key = reader.stringVerify();
                            continue;
                        case 2:
                            if (wireType !== 2)
                                break;
                            value = reader.stringVerify();
                            continue;
                        }
                        reader.skipType(wireType, _depth, tag2);
                    }
                    if (reader.pos !== end2)
                        throw $RangeError("index out of range");
                    reader.len = end;
                    if (key === "__proto__")
                        $util.makeProp(message.buttonClickWidgets, key);
                    message.buttonClickWidgets[key] = value;
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    message.lazyData = $root.LazyDataframe.decode(reader, reader.uint32(), $undefined, _depth + 1, message.lazyData);
                    message._lazyData = "lazyData";
                    continue;
                }
            case 15: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Dataframe message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Dataframe
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Dataframe} Dataframe
     */
    Dataframe.fromObject = function (object, _depth) {
        if (object instanceof $root.Dataframe)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Dataframe: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Dataframe();
        if (object.arrowData != null) {
            if (!$util.isObject(object.arrowData))
                throw $TypeError(".Dataframe.arrowData: object expected");
            message.arrowData = $root.ArrowData.fromObject(object.arrowData, _depth + 1);
        }
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.columns != null)
            if (typeof object.columns !== "string" || object.columns.length)
                message.columns = $String(object.columns);
        if (object.editingMode !== 0 && (typeof object.editingMode !== "string" || $root.Dataframe.EditingMode[object.editingMode] !== 0))
            switch (object.editingMode) {
            case "READ_ONLY":
            case 0:
                message.editingMode = 0;
                break;
            case "FIXED":
            case 1:
                message.editingMode = 1;
                break;
            case "DYNAMIC":
            case 2:
                message.editingMode = 2;
                break;
            case "ADD_ONLY":
            case 3:
                message.editingMode = 3;
                break;
            case "DELETE_ONLY":
            case 4:
                message.editingMode = 4;
                break;
            default:
                if (typeof object.editingMode === "number" && (object.editingMode | 0) === object.editingMode)
                    message.editingMode = object.editingMode;
            }
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.columnOrder) {
            if (!$Array.isArray(object.columnOrder))
                throw $TypeError(".Dataframe.columnOrder: array expected");
            message.columnOrder = $Array(object.columnOrder.length);
            for (let i = 0; i < object.columnOrder.length; ++i)
                message.columnOrder[i] = $String(object.columnOrder[i]);
        }
        if (object.selectionMode) {
            if (!$Array.isArray(object.selectionMode))
                throw $TypeError(".Dataframe.selectionMode: array expected");
            message.selectionMode = [];
            for (let i = 0; i < object.selectionMode.length; ++i)
                switch (object.selectionMode[i]) {
                case "SINGLE_ROW":
                case 0:
                    message.selectionMode[message.selectionMode.length] = 0;
                    break;
                case "MULTI_ROW":
                case 1:
                    message.selectionMode[message.selectionMode.length] = 1;
                    break;
                case "SINGLE_COLUMN":
                case 2:
                    message.selectionMode[message.selectionMode.length] = 2;
                    break;
                case "MULTI_COLUMN":
                case 3:
                    message.selectionMode[message.selectionMode.length] = 3;
                    break;
                case "SINGLE_CELL":
                case 4:
                    message.selectionMode[message.selectionMode.length] = 4;
                    break;
                case "MULTI_CELL":
                case 5:
                    message.selectionMode[message.selectionMode.length] = 5;
                    break;
                case "SINGLE_ROW_REQUIRED":
                case 6:
                    message.selectionMode[message.selectionMode.length] = 6;
                    break;
                default:
                    if (typeof object.selectionMode[i] === "number" && (object.selectionMode[i] | 0) === object.selectionMode[i])
                        message.selectionMode[message.selectionMode.length] = object.selectionMode[i];
                }
        }
        if (object.rowHeight != null)
            message.rowHeight = object.rowHeight >>> 0;
        if (object.placeholder != null)
            message.placeholder = $String(object.placeholder);
        if (object.selectionState != null)
            message.selectionState = $String(object.selectionState);
        if (object.selectionDefault != null)
            message.selectionDefault = $String(object.selectionDefault);
        if (object.buttonClickWidgets) {
            if (!$util.isObject(object.buttonClickWidgets))
                throw $TypeError(".Dataframe.buttonClickWidgets: object expected");
            message.buttonClickWidgets = {};
            for (let keys = $Object.keys(object.buttonClickWidgets), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.buttonClickWidgets, keys[i]);
                message.buttonClickWidgets[keys[i]] = $String(object.buttonClickWidgets[keys[i]]);
            }
        }
        if (object.lazyData != null) {
            if (!$util.isObject(object.lazyData))
                throw $TypeError(".Dataframe.lazyData: object expected");
            message.lazyData = $root.LazyDataframe.fromObject(object.lazyData, _depth + 1);
        }
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from a Dataframe message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Dataframe
     * @static
     * @param {Dataframe} message Dataframe
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Dataframe.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object.columnOrder = [];
            object.selectionMode = [];
        }
        if (options.objects || options.defaults)
            object.buttonClickWidgets = {};
        if (options.defaults) {
            object.arrowData = null;
            object.id = "";
            object.columns = "";
            object.editingMode = options.enums === $String ? "READ_ONLY" : 0;
            object.disabled = false;
            object.formId = "";
        }
        if (message.arrowData != null && $Object.hasOwnProperty.call(message, "arrowData"))
            object.arrowData = $root.ArrowData.toObject(message.arrowData, options, _depth + 1);
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.columns != null && $Object.hasOwnProperty.call(message, "columns"))
            object.columns = message.columns;
        if (message.editingMode != null && $Object.hasOwnProperty.call(message, "editingMode"))
            object.editingMode = options.enums === $String ? $root.Dataframe.EditingMode[message.editingMode] === $undefined ? message.editingMode : $root.Dataframe.EditingMode[message.editingMode] : message.editingMode;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.columnOrder && message.columnOrder.length) {
            object.columnOrder = $Array(message.columnOrder.length);
            for (let j = 0; j < message.columnOrder.length; ++j)
                object.columnOrder[j] = message.columnOrder[j];
        }
        if (message.selectionMode && message.selectionMode.length) {
            object.selectionMode = $Array(message.selectionMode.length);
            for (let j = 0; j < message.selectionMode.length; ++j)
                object.selectionMode[j] = options.enums === $String ? $root.Dataframe.SelectionMode[message.selectionMode[j]] === $undefined ? message.selectionMode[j] : $root.Dataframe.SelectionMode[message.selectionMode[j]] : message.selectionMode[j];
        }
        if (message.rowHeight != null && $Object.hasOwnProperty.call(message, "rowHeight"))
            object.rowHeight = message.rowHeight;
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder"))
            object.placeholder = message.placeholder;
        if (message.selectionState != null && $Object.hasOwnProperty.call(message, "selectionState"))
            object.selectionState = message.selectionState;
        if (message.selectionDefault != null && $Object.hasOwnProperty.call(message, "selectionDefault"))
            object.selectionDefault = message.selectionDefault;
        let keys2;
        if (message.buttonClickWidgets && (keys2 = $Object.keys(message.buttonClickWidgets)).length) {
            object.buttonClickWidgets = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.buttonClickWidgets, keys2[j]);
                object.buttonClickWidgets[keys2[j]] = message.buttonClickWidgets[keys2[j]];
            }
        }
        if (message.lazyData != null && $Object.hasOwnProperty.call(message, "lazyData"))
            object.lazyData = $root.LazyDataframe.toObject(message.lazyData, options, _depth + 1);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this Dataframe to JSON.
     * @function toJSON
     * @memberof Dataframe
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Dataframe.prototype.toJSON = function() {
        return Dataframe.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Dataframe
     * @function getTypeUrl
     * @memberof Dataframe
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Dataframe.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Dataframe";
    };

    /**
     * EditingMode enum.
     * @name Dataframe.EditingMode
     * @enum {number}
     * @property {number} READ_ONLY=0 READ_ONLY value
     * @property {number} FIXED=1 FIXED value
     * @property {number} DYNAMIC=2 DYNAMIC value
     * @property {number} ADD_ONLY=3 ADD_ONLY value
     * @property {number} DELETE_ONLY=4 DELETE_ONLY value
     */
    Dataframe.EditingMode = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "READ_ONLY"] = 0;
        values[valuesById[1] = "FIXED"] = 1;
        values[valuesById[2] = "DYNAMIC"] = 2;
        values[valuesById[3] = "ADD_ONLY"] = 3;
        values[valuesById[4] = "DELETE_ONLY"] = 4;
        return values;
    })();

    /**
     * SelectionMode enum.
     * @name Dataframe.SelectionMode
     * @enum {number}
     * @property {number} SINGLE_ROW=0 SINGLE_ROW value
     * @property {number} MULTI_ROW=1 MULTI_ROW value
     * @property {number} SINGLE_COLUMN=2 SINGLE_COLUMN value
     * @property {number} MULTI_COLUMN=3 MULTI_COLUMN value
     * @property {number} SINGLE_CELL=4 SINGLE_CELL value
     * @property {number} MULTI_CELL=5 MULTI_CELL value
     * @property {number} SINGLE_ROW_REQUIRED=6 SINGLE_ROW_REQUIRED value
     */
    Dataframe.SelectionMode = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "SINGLE_ROW"] = 0;
        values[valuesById[1] = "MULTI_ROW"] = 1;
        values[valuesById[2] = "SINGLE_COLUMN"] = 2;
        values[valuesById[3] = "MULTI_COLUMN"] = 3;
        values[valuesById[4] = "SINGLE_CELL"] = 4;
        values[valuesById[5] = "MULTI_CELL"] = 5;
        values[valuesById[6] = "SINGLE_ROW_REQUIRED"] = 6;
        return values;
    })();

    return Dataframe;
})();

export const LazyDataframe = $root.LazyDataframe = (() => {

    /**
     * Properties of a LazyDataframe.
     * @typedef {Object} LazyDataframe.$Properties
     * @property {string|null} [sourceId] LazyDataframe sourceId
     * @property {number|Long|null} [rowCount] LazyDataframe rowCount
     * @property {number|null} [pageSize] LazyDataframe pageSize
     * @property {LazyDataframe.AccessMode|null} [accessMode] LazyDataframe accessMode
     * @property {ArrowData.$Properties|null} [initialChunk] LazyDataframe initialChunk
     * @property {boolean|null} [sortable] LazyDataframe sortable
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a LazyDataframe.
     * @exports ILazyDataframe
     * @interface ILazyDataframe
     * @augments LazyDataframe.$Properties
     * @deprecated Use LazyDataframe.$Properties instead.
     */

    /**
     * Shape of a LazyDataframe.
     * @typedef {LazyDataframe.$Properties} LazyDataframe.$Shape
     */

    /**
     * Constructs a new LazyDataframe.
     * @exports LazyDataframe
     * @classdesc Represents a LazyDataframe.
     * @constructor
     * @param {LazyDataframe.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const LazyDataframe = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * LazyDataframe sourceId.
     * @member {string} sourceId
     * @memberof LazyDataframe
     * @instance
     */
    LazyDataframe.prototype.sourceId = "";

    /**
     * LazyDataframe rowCount.
     * @member {number|Long|null|undefined} rowCount
     * @memberof LazyDataframe
     * @instance
     */
    LazyDataframe.prototype.rowCount = null;

    /**
     * LazyDataframe pageSize.
     * @member {number} pageSize
     * @memberof LazyDataframe
     * @instance
     */
    LazyDataframe.prototype.pageSize = 0;

    /**
     * LazyDataframe accessMode.
     * @member {LazyDataframe.AccessMode} accessMode
     * @memberof LazyDataframe
     * @instance
     */
    LazyDataframe.prototype.accessMode = 0;

    /**
     * LazyDataframe initialChunk.
     * @member {ArrowData.$Properties|null|undefined} initialChunk
     * @memberof LazyDataframe
     * @instance
     */
    LazyDataframe.prototype.initialChunk = null;

    /**
     * LazyDataframe sortable.
     * @member {boolean} sortable
     * @memberof LazyDataframe
     * @instance
     */
    LazyDataframe.prototype.sortable = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(LazyDataframe.prototype, "_rowCount", {
        get: $util.oneOfGetter($oneOfFields = ["rowCount"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new LazyDataframe instance using the specified properties.
     * @function create
     * @memberof LazyDataframe
     * @static
     * @param {LazyDataframe.$Properties=} [properties] Properties to set
     * @returns {LazyDataframe} LazyDataframe instance
     * @type {{
     *   (properties: LazyDataframe.$Shape): LazyDataframe & LazyDataframe.$Shape;
     *   (properties?: LazyDataframe.$Properties): LazyDataframe;
     * }}
     */
    LazyDataframe.create = function(properties) {
        return new LazyDataframe(properties);
    };

    /**
     * Encodes the specified LazyDataframe message. Does not implicitly {@link LazyDataframe.verify|verify} messages.
     * @function encode
     * @memberof LazyDataframe
     * @static
     * @param {LazyDataframe.$Properties} message LazyDataframe message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LazyDataframe.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.sourceId != null && $Object.hasOwnProperty.call(message, "sourceId") && message.sourceId !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.sourceId);
        if (message.rowCount != null && $Object.hasOwnProperty.call(message, "rowCount"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.rowCount);
        if (message.pageSize != null && $Object.hasOwnProperty.call(message, "pageSize") && message.pageSize !== 0)
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.pageSize);
        if (message.accessMode != null && $Object.hasOwnProperty.call(message, "accessMode") && message.accessMode !== 0)
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.accessMode);
        if (message.initialChunk != null && $Object.hasOwnProperty.call(message, "initialChunk"))
            $root.ArrowData.encode(message.initialChunk, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
        if (message.sortable != null && $Object.hasOwnProperty.call(message, "sortable") && message.sortable !== false)
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.sortable);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a LazyDataframe message from the specified reader or buffer.
     * @function decode
     * @memberof LazyDataframe
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LazyDataframe & LazyDataframe.$Shape} LazyDataframe
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LazyDataframe.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.LazyDataframe();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.sourceId = value;
                    else
                        delete message.sourceId;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    message.rowCount = reader.uint64();
                    message._rowCount = "rowCount";
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message.pageSize = value;
                    else
                        delete message.pageSize;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.accessMode = value;
                    else
                        delete message.accessMode;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.initialChunk = $root.ArrowData.decode(reader, reader.uint32(), $undefined, _depth + 1, message.initialChunk);
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.sortable = value;
                    else
                        delete message.sortable;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a LazyDataframe message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LazyDataframe
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LazyDataframe} LazyDataframe
     */
    LazyDataframe.fromObject = function (object, _depth) {
        if (object instanceof $root.LazyDataframe)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".LazyDataframe: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.LazyDataframe();
        if (object.sourceId != null)
            if (typeof object.sourceId !== "string" || object.sourceId.length)
                message.sourceId = $String(object.sourceId);
        if (object.rowCount != null)
            if ($util.Long)
                message.rowCount = $util.Long.fromValue(object.rowCount, true);
            else if (typeof object.rowCount === "string")
                message.rowCount = $parseInt(object.rowCount, 10);
            else if (typeof object.rowCount === "number")
                message.rowCount = object.rowCount;
            else if (typeof object.rowCount === "object")
                message.rowCount = new $util.LongBits(object.rowCount.low >>> 0, object.rowCount.high >>> 0).toNumber(true);
        if (object.pageSize != null)
            if ($Number(object.pageSize) !== 0)
                message.pageSize = object.pageSize >>> 0;
        if (object.accessMode !== 0 && (typeof object.accessMode !== "string" || $root.LazyDataframe.AccessMode[object.accessMode] !== 0))
            switch (object.accessMode) {
            case "ACCESS_MODE_UNSPECIFIED":
            case 0:
                message.accessMode = 0;
                break;
            case "RANDOM_ACCESS":
            case 1:
                message.accessMode = 1;
                break;
            case "SEQUENTIAL":
            case 2:
                message.accessMode = 2;
                break;
            default:
                if (typeof object.accessMode === "number" && (object.accessMode | 0) === object.accessMode)
                    message.accessMode = object.accessMode;
            }
        if (object.initialChunk != null) {
            if (!$util.isObject(object.initialChunk))
                throw $TypeError(".LazyDataframe.initialChunk: object expected");
            message.initialChunk = $root.ArrowData.fromObject(object.initialChunk, _depth + 1);
        }
        if (object.sortable != null)
            if (object.sortable)
                message.sortable = $Boolean(object.sortable);
        return message;
    };

    /**
     * Creates a plain object from a LazyDataframe message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LazyDataframe
     * @static
     * @param {LazyDataframe} message LazyDataframe
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LazyDataframe.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.sourceId = "";
            object.pageSize = 0;
            object.accessMode = options.enums === $String ? "ACCESS_MODE_UNSPECIFIED" : 0;
            object.initialChunk = null;
            object.sortable = false;
        }
        if (message.sourceId != null && $Object.hasOwnProperty.call(message, "sourceId"))
            object.sourceId = message.sourceId;
        if (message.rowCount != null && $Object.hasOwnProperty.call(message, "rowCount"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.rowCount = typeof message.rowCount === "number" ? $BigInt(message.rowCount) : $util.Long.fromBits(message.rowCount.low >>> 0, message.rowCount.high >>> 0, true).toBigInt();
            else if (typeof message.rowCount === "number")
                object.rowCount = options.longs === $String ? $String(message.rowCount) : message.rowCount;
            else
                object.rowCount = options.longs === $String ? $util.Long.prototype.toString.call(message.rowCount) : options.longs === $Number ? new $util.LongBits(message.rowCount.low >>> 0, message.rowCount.high >>> 0).toNumber(true) : message.rowCount;
        if (message.pageSize != null && $Object.hasOwnProperty.call(message, "pageSize"))
            object.pageSize = message.pageSize;
        if (message.accessMode != null && $Object.hasOwnProperty.call(message, "accessMode"))
            object.accessMode = options.enums === $String ? $root.LazyDataframe.AccessMode[message.accessMode] === $undefined ? message.accessMode : $root.LazyDataframe.AccessMode[message.accessMode] : message.accessMode;
        if (message.initialChunk != null && $Object.hasOwnProperty.call(message, "initialChunk"))
            object.initialChunk = $root.ArrowData.toObject(message.initialChunk, options, _depth + 1);
        if (message.sortable != null && $Object.hasOwnProperty.call(message, "sortable"))
            object.sortable = message.sortable;
        return object;
    };

    /**
     * Converts this LazyDataframe to JSON.
     * @function toJSON
     * @memberof LazyDataframe
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LazyDataframe.prototype.toJSON = function() {
        return LazyDataframe.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for LazyDataframe
     * @function getTypeUrl
     * @memberof LazyDataframe
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    LazyDataframe.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/LazyDataframe";
    };

    /**
     * AccessMode enum.
     * @name LazyDataframe.AccessMode
     * @enum {number}
     * @property {number} ACCESS_MODE_UNSPECIFIED=0 ACCESS_MODE_UNSPECIFIED value
     * @property {number} RANDOM_ACCESS=1 RANDOM_ACCESS value
     * @property {number} SEQUENTIAL=2 SEQUENTIAL value
     */
    LazyDataframe.AccessMode = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "ACCESS_MODE_UNSPECIFIED"] = 0;
        values[valuesById[1] = "RANDOM_ACCESS"] = 1;
        values[valuesById[2] = "SEQUENTIAL"] = 2;
        return values;
    })();

    return LazyDataframe;
})();

export const SortState = $root.SortState = (() => {

    /**
     * Properties of a SortState.
     * @typedef {Object} SortState.$Properties
     * @property {string|null} [column] SortState column
     * @property {SortState.SortDirection|null} [direction] SortState direction
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a SortState.
     * @exports ISortState
     * @interface ISortState
     * @augments SortState.$Properties
     * @deprecated Use SortState.$Properties instead.
     */

    /**
     * Shape of a SortState.
     * @typedef {SortState.$Properties} SortState.$Shape
     */

    /**
     * Constructs a new SortState.
     * @exports SortState
     * @classdesc Represents a SortState.
     * @constructor
     * @param {SortState.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const SortState = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * SortState column.
     * @member {string} column
     * @memberof SortState
     * @instance
     */
    SortState.prototype.column = "";

    /**
     * SortState direction.
     * @member {SortState.SortDirection} direction
     * @memberof SortState
     * @instance
     */
    SortState.prototype.direction = 0;

    /**
     * Creates a new SortState instance using the specified properties.
     * @function create
     * @memberof SortState
     * @static
     * @param {SortState.$Properties=} [properties] Properties to set
     * @returns {SortState} SortState instance
     * @type {{
     *   (properties: SortState.$Shape): SortState & SortState.$Shape;
     *   (properties?: SortState.$Properties): SortState;
     * }}
     */
    SortState.create = function(properties) {
        return new SortState(properties);
    };

    /**
     * Encodes the specified SortState message. Does not implicitly {@link SortState.verify|verify} messages.
     * @function encode
     * @memberof SortState
     * @static
     * @param {SortState.$Properties} message SortState message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SortState.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.column != null && $Object.hasOwnProperty.call(message, "column") && message.column !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.column);
        if (message.direction != null && $Object.hasOwnProperty.call(message, "direction") && message.direction !== 0)
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.direction);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a SortState message from the specified reader or buffer.
     * @function decode
     * @memberof SortState
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SortState & SortState.$Shape} SortState
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SortState.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.SortState();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.column = value;
                    else
                        delete message.column;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.direction = value;
                    else
                        delete message.direction;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a SortState message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SortState
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SortState} SortState
     */
    SortState.fromObject = function (object, _depth) {
        if (object instanceof $root.SortState)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".SortState: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.SortState();
        if (object.column != null)
            if (typeof object.column !== "string" || object.column.length)
                message.column = $String(object.column);
        if (object.direction !== 0 && (typeof object.direction !== "string" || $root.SortState.SortDirection[object.direction] !== 0))
            switch (object.direction) {
            case "SORT_DIRECTION_UNSPECIFIED":
            case 0:
                message.direction = 0;
                break;
            case "ASCENDING":
            case 1:
                message.direction = 1;
                break;
            case "DESCENDING":
            case 2:
                message.direction = 2;
                break;
            default:
                if (typeof object.direction === "number" && (object.direction | 0) === object.direction)
                    message.direction = object.direction;
            }
        return message;
    };

    /**
     * Creates a plain object from a SortState message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SortState
     * @static
     * @param {SortState} message SortState
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SortState.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.column = "";
            object.direction = options.enums === $String ? "SORT_DIRECTION_UNSPECIFIED" : 0;
        }
        if (message.column != null && $Object.hasOwnProperty.call(message, "column"))
            object.column = message.column;
        if (message.direction != null && $Object.hasOwnProperty.call(message, "direction"))
            object.direction = options.enums === $String ? $root.SortState.SortDirection[message.direction] === $undefined ? message.direction : $root.SortState.SortDirection[message.direction] : message.direction;
        return object;
    };

    /**
     * Converts this SortState to JSON.
     * @function toJSON
     * @memberof SortState
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SortState.prototype.toJSON = function() {
        return SortState.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for SortState
     * @function getTypeUrl
     * @memberof SortState
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    SortState.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/SortState";
    };

    /**
     * SortDirection enum.
     * @name SortState.SortDirection
     * @enum {number}
     * @property {number} SORT_DIRECTION_UNSPECIFIED=0 SORT_DIRECTION_UNSPECIFIED value
     * @property {number} ASCENDING=1 ASCENDING value
     * @property {number} DESCENDING=2 DESCENDING value
     */
    SortState.SortDirection = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "SORT_DIRECTION_UNSPECIFIED"] = 0;
        values[valuesById[1] = "ASCENDING"] = 1;
        values[valuesById[2] = "DESCENDING"] = 2;
        return values;
    })();

    return SortState;
})();

export const Balloons = $root.Balloons = (() => {

    /**
     * Properties of a Balloons.
     * @typedef {Object} Balloons.$Properties
     * @property {boolean|null} [show] Balloons show
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Balloons.
     * @exports IBalloons
     * @interface IBalloons
     * @augments Balloons.$Properties
     * @deprecated Use Balloons.$Properties instead.
     */

    /**
     * Shape of a Balloons.
     * @typedef {Balloons.$Properties} Balloons.$Shape
     */

    /**
     * Constructs a new Balloons.
     * @exports Balloons
     * @classdesc Represents a Balloons.
     * @constructor
     * @param {Balloons.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Balloons = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Balloons show.
     * @member {boolean} show
     * @memberof Balloons
     * @instance
     */
    Balloons.prototype.show = false;

    /**
     * Creates a new Balloons instance using the specified properties.
     * @function create
     * @memberof Balloons
     * @static
     * @param {Balloons.$Properties=} [properties] Properties to set
     * @returns {Balloons} Balloons instance
     * @type {{
     *   (properties: Balloons.$Shape): Balloons & Balloons.$Shape;
     *   (properties?: Balloons.$Properties): Balloons;
     * }}
     */
    Balloons.create = function(properties) {
        return new Balloons(properties);
    };

    /**
     * Encodes the specified Balloons message. Does not implicitly {@link Balloons.verify|verify} messages.
     * @function encode
     * @memberof Balloons
     * @static
     * @param {Balloons.$Properties} message Balloons message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Balloons.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.show != null && $Object.hasOwnProperty.call(message, "show") && message.show !== false)
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.show);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Balloons message from the specified reader or buffer.
     * @function decode
     * @memberof Balloons
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Balloons & Balloons.$Shape} Balloons
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Balloons.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Balloons();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.show = value;
                    else
                        delete message.show;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Balloons message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Balloons
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Balloons} Balloons
     */
    Balloons.fromObject = function (object, _depth) {
        if (object instanceof $root.Balloons)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Balloons: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Balloons();
        if (object.show != null)
            if (object.show)
                message.show = $Boolean(object.show);
        return message;
    };

    /**
     * Creates a plain object from a Balloons message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Balloons
     * @static
     * @param {Balloons} message Balloons
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Balloons.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.show = false;
        if (message.show != null && $Object.hasOwnProperty.call(message, "show"))
            object.show = message.show;
        return object;
    };

    /**
     * Converts this Balloons to JSON.
     * @function toJSON
     * @memberof Balloons
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Balloons.prototype.toJSON = function() {
        return Balloons.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Balloons
     * @function getTypeUrl
     * @memberof Balloons
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Balloons.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Balloons";
    };

    return Balloons;
})();

export const MixedData = $root.MixedData = (() => {

    /**
     * Properties of a MixedData.
     * @typedef {Object} MixedData.$Properties
     * @property {string|null} [json] MixedData json
     * @property {Object.<string,ArrowData.$Properties>|null} [arrowBlobs] MixedData arrowBlobs
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a MixedData.
     * @exports IMixedData
     * @interface IMixedData
     * @augments MixedData.$Properties
     * @deprecated Use MixedData.$Properties instead.
     */

    /**
     * Shape of a MixedData.
     * @typedef {MixedData.$Properties} MixedData.$Shape
     */

    /**
     * Constructs a new MixedData.
     * @exports MixedData
     * @classdesc Represents a MixedData.
     * @constructor
     * @param {MixedData.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const MixedData = function (properties) {
        this.arrowBlobs = {};
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * MixedData json.
     * @member {string} json
     * @memberof MixedData
     * @instance
     */
    MixedData.prototype.json = "";

    /**
     * MixedData arrowBlobs.
     * @member {Object.<string,ArrowData.$Properties>} arrowBlobs
     * @memberof MixedData
     * @instance
     */
    MixedData.prototype.arrowBlobs = $util.emptyObject;

    /**
     * Creates a new MixedData instance using the specified properties.
     * @function create
     * @memberof MixedData
     * @static
     * @param {MixedData.$Properties=} [properties] Properties to set
     * @returns {MixedData} MixedData instance
     * @type {{
     *   (properties: MixedData.$Shape): MixedData & MixedData.$Shape;
     *   (properties?: MixedData.$Properties): MixedData;
     * }}
     */
    MixedData.create = function(properties) {
        return new MixedData(properties);
    };

    /**
     * Encodes the specified MixedData message. Does not implicitly {@link MixedData.verify|verify} messages.
     * @function encode
     * @memberof MixedData
     * @static
     * @param {MixedData.$Properties} message MixedData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MixedData.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.json != null && $Object.hasOwnProperty.call(message, "json") && message.json !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.json);
        if (message.arrowBlobs != null && $Object.hasOwnProperty.call(message, "arrowBlobs"))
            for (let keys = $Object.keys(message.arrowBlobs), i = 0; i < keys.length; ++i) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                $root.ArrowData.encode(message.arrowBlobs[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim().ldelim();
            }
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a MixedData message from the specified reader or buffer.
     * @function decode
     * @memberof MixedData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MixedData & MixedData.$Shape} MixedData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MixedData.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, key, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.MixedData();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.json = value;
                    else
                        delete message.json;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if (message.arrowBlobs === $util.emptyObject)
                        message.arrowBlobs = {};
                    let end2 = reader.uint32() + reader.pos;
                    if (end2 > reader.len)
                        throw $RangeError("index out of range");
                    reader.len = end2;
                    key = "";
                    value = null;
                    while (reader.pos < end2) {
                        let tag2 = reader.tag();
                        wireType = tag2 & 7;
                        switch (tag2 >>>= 3) {
                        case 1:
                            if (wireType !== 2)
                                break;
                            key = reader.stringVerify();
                            continue;
                        case 2:
                            if (wireType !== 2)
                                break;
                            value = $root.ArrowData.decode(reader, reader.uint32(), $undefined, _depth + 1, value);
                            continue;
                        }
                        reader.skipType(wireType, _depth, tag2);
                    }
                    if (reader.pos !== end2)
                        throw $RangeError("index out of range");
                    reader.len = end;
                    if (key === "__proto__")
                        $util.makeProp(message.arrowBlobs, key);
                    message.arrowBlobs[key] = value || new $root.ArrowData();
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a MixedData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MixedData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MixedData} MixedData
     */
    MixedData.fromObject = function (object, _depth) {
        if (object instanceof $root.MixedData)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".MixedData: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.MixedData();
        if (object.json != null)
            if (typeof object.json !== "string" || object.json.length)
                message.json = $String(object.json);
        if (object.arrowBlobs) {
            if (!$util.isObject(object.arrowBlobs))
                throw $TypeError(".MixedData.arrowBlobs: object expected");
            message.arrowBlobs = {};
            for (let keys = $Object.keys(object.arrowBlobs), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.arrowBlobs, keys[i]);
                if (!$util.isObject(object.arrowBlobs[keys[i]]))
                    throw $TypeError(".MixedData.arrowBlobs: object expected");
                message.arrowBlobs[keys[i]] = $root.ArrowData.fromObject(object.arrowBlobs[keys[i]], _depth + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a MixedData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MixedData
     * @static
     * @param {MixedData} message MixedData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MixedData.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.objects || options.defaults)
            object.arrowBlobs = {};
        if (options.defaults)
            object.json = "";
        if (message.json != null && $Object.hasOwnProperty.call(message, "json"))
            object.json = message.json;
        let keys2;
        if (message.arrowBlobs && (keys2 = $Object.keys(message.arrowBlobs)).length) {
            object.arrowBlobs = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.arrowBlobs, keys2[j]);
                object.arrowBlobs[keys2[j]] = $root.ArrowData.toObject(message.arrowBlobs[keys2[j]], options, _depth + 1);
            }
        }
        return object;
    };

    /**
     * Converts this MixedData to JSON.
     * @function toJSON
     * @memberof MixedData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MixedData.prototype.toJSON = function() {
        return MixedData.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for MixedData
     * @function getTypeUrl
     * @memberof MixedData
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    MixedData.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/MixedData";
    };

    return MixedData;
})();

export const BidiComponent = $root.BidiComponent = (() => {

    /**
     * Properties of a BidiComponent.
     * @typedef {Object} BidiComponent.$Properties
     * @property {string|null} [id] BidiComponent id
     * @property {string|null} [componentName] BidiComponent componentName
     * @property {string|null} [jsContent] BidiComponent jsContent
     * @property {string|null} [jsSourcePath] BidiComponent jsSourcePath
     * @property {string|null} [formId] BidiComponent formId
     * @property {string|null} [htmlContent] BidiComponent htmlContent
     * @property {string|null} [cssContent] BidiComponent cssContent
     * @property {string|null} [cssSourcePath] BidiComponent cssSourcePath
     * @property {boolean|null} [isolateStyles] BidiComponent isolateStyles
     * @property {string|null} [json] BidiComponent json
     * @property {ArrowData.$Properties|null} [arrowData] BidiComponent arrowData
     * @property {Uint8Array|null} [bytes] BidiComponent bytes
     * @property {MixedData.$Properties|null} [mixed] BidiComponent mixed
     * @property {"json"|"arrowData"|"bytes"|"mixed"} [data] BidiComponent data
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a BidiComponent.
     * @exports IBidiComponent
     * @interface IBidiComponent
     * @augments BidiComponent.$Properties
     * @deprecated Use BidiComponent.$Properties instead.
     */

    /**
     * Narrowed shape of a BidiComponent.
     * @typedef {{
     *   id?: string|null;
     *   componentName?: string|null;
     *   jsContent?: string|null;
     *   jsSourcePath?: string|null;
     *   formId?: string|null;
     *   htmlContent?: string|null;
     *   cssContent?: string|null;
     *   cssSourcePath?: string|null;
     *   isolateStyles?: boolean|null;
     *   json?: string|null;
     *   arrowData?: ArrowData.$Shape|null;
     *   bytes?: Uint8Array|null;
     *   mixed?: MixedData.$Shape|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ data?: undefined; json?: null; arrowData?: null; bytes?: null; mixed?: null }|{ data?: "json"; json: string; arrowData?: null; bytes?: null; mixed?: null }|{ data?: "arrowData"; json?: null; arrowData: ArrowData.$Shape; bytes?: null; mixed?: null }|{ data?: "bytes"; json?: null; arrowData?: null; bytes: Uint8Array; mixed?: null }|{ data?: "mixed"; json?: null; arrowData?: null; bytes?: null; mixed: MixedData.$Shape })
     * )} BidiComponent.$Shape
     */

    /**
     * Constructs a new BidiComponent.
     * @exports BidiComponent
     * @classdesc Represents a BidiComponent.
     * @constructor
     * @param {BidiComponent.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const BidiComponent = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * BidiComponent id.
     * @member {string} id
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.id = "";

    /**
     * BidiComponent componentName.
     * @member {string} componentName
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.componentName = "";

    /**
     * BidiComponent jsContent.
     * @member {string|null|undefined} jsContent
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.jsContent = null;

    /**
     * BidiComponent jsSourcePath.
     * @member {string|null|undefined} jsSourcePath
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.jsSourcePath = null;

    /**
     * BidiComponent formId.
     * @member {string} formId
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.formId = "";

    /**
     * BidiComponent htmlContent.
     * @member {string|null|undefined} htmlContent
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.htmlContent = null;

    /**
     * BidiComponent cssContent.
     * @member {string|null|undefined} cssContent
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.cssContent = null;

    /**
     * BidiComponent cssSourcePath.
     * @member {string|null|undefined} cssSourcePath
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.cssSourcePath = null;

    /**
     * BidiComponent isolateStyles.
     * @member {boolean} isolateStyles
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.isolateStyles = false;

    /**
     * BidiComponent json.
     * @member {string|null|undefined} json
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.json = null;

    /**
     * BidiComponent arrowData.
     * @member {ArrowData.$Properties|null|undefined} arrowData
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.arrowData = null;

    /**
     * BidiComponent bytes.
     * @member {Uint8Array|null|undefined} bytes
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.bytes = null;

    /**
     * BidiComponent mixed.
     * @member {MixedData.$Properties|null|undefined} mixed
     * @memberof BidiComponent
     * @instance
     */
    BidiComponent.prototype.mixed = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(BidiComponent.prototype, "_jsContent", {
        get: $util.oneOfGetter($oneOfFields = ["jsContent"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(BidiComponent.prototype, "_jsSourcePath", {
        get: $util.oneOfGetter($oneOfFields = ["jsSourcePath"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(BidiComponent.prototype, "_htmlContent", {
        get: $util.oneOfGetter($oneOfFields = ["htmlContent"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(BidiComponent.prototype, "_cssContent", {
        get: $util.oneOfGetter($oneOfFields = ["cssContent"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(BidiComponent.prototype, "_cssSourcePath", {
        get: $util.oneOfGetter($oneOfFields = ["cssSourcePath"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * BidiComponent data.
     * @member {"json"|"arrowData"|"bytes"|"mixed"|undefined} data
     * @memberof BidiComponent
     * @instance
     */
    $Object.defineProperty(BidiComponent.prototype, "data", {
        get: $util.oneOfGetter($oneOfFields = ["json", "arrowData", "bytes", "mixed"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new BidiComponent instance using the specified properties.
     * @function create
     * @memberof BidiComponent
     * @static
     * @param {BidiComponent.$Properties=} [properties] Properties to set
     * @returns {BidiComponent} BidiComponent instance
     * @type {{
     *   (properties: BidiComponent.$Shape): BidiComponent & BidiComponent.$Shape;
     *   (properties?: BidiComponent.$Properties): BidiComponent;
     * }}
     */
    BidiComponent.create = function(properties) {
        return new BidiComponent(properties);
    };

    /**
     * Encodes the specified BidiComponent message. Does not implicitly {@link BidiComponent.verify|verify} messages.
     * @function encode
     * @memberof BidiComponent
     * @static
     * @param {BidiComponent.$Properties} message BidiComponent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BidiComponent.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.componentName != null && $Object.hasOwnProperty.call(message, "componentName") && message.componentName !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.componentName);
        if (message.jsContent != null && $Object.hasOwnProperty.call(message, "jsContent"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.jsContent);
        if (message.jsSourcePath != null && $Object.hasOwnProperty.call(message, "jsSourcePath"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.jsSourcePath);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.formId);
        if (message.htmlContent != null && $Object.hasOwnProperty.call(message, "htmlContent"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.htmlContent);
        if (message.cssContent != null && $Object.hasOwnProperty.call(message, "cssContent"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.cssContent);
        if (message.cssSourcePath != null && $Object.hasOwnProperty.call(message, "cssSourcePath"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.cssSourcePath);
        if (message.isolateStyles != null && $Object.hasOwnProperty.call(message, "isolateStyles") && message.isolateStyles !== false)
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isolateStyles);
        if (message.json != null && $Object.hasOwnProperty.call(message, "json"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.json);
        if (message.arrowData != null && $Object.hasOwnProperty.call(message, "arrowData"))
            $root.ArrowData.encode(message.arrowData, writer.uint32(/* id 11, wireType 2 =*/90).fork(), _depth + 1).ldelim();
        if (message.bytes != null && $Object.hasOwnProperty.call(message, "bytes"))
            writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.bytes);
        if (message.mixed != null && $Object.hasOwnProperty.call(message, "mixed"))
            $root.MixedData.encode(message.mixed, writer.uint32(/* id 13, wireType 2 =*/106).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a BidiComponent message from the specified reader or buffer.
     * @function decode
     * @memberof BidiComponent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BidiComponent & BidiComponent.$Shape} BidiComponent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BidiComponent.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.BidiComponent();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.componentName = value;
                    else
                        delete message.componentName;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.jsContent = reader.stringVerify();
                    message._jsContent = "jsContent";
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.jsSourcePath = reader.stringVerify();
                    message._jsSourcePath = "jsSourcePath";
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.htmlContent = reader.stringVerify();
                    message._htmlContent = "htmlContent";
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    message.cssContent = reader.stringVerify();
                    message._cssContent = "cssContent";
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    message.cssSourcePath = reader.stringVerify();
                    message._cssSourcePath = "cssSourcePath";
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isolateStyles = value;
                    else
                        delete message.isolateStyles;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.json = reader.stringVerify();
                    message.data = "json";
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.arrowData = $root.ArrowData.decode(reader, reader.uint32(), $undefined, _depth + 1, message.arrowData);
                    message.data = "arrowData";
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.bytes = reader.bytes();
                    message.data = "bytes";
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.mixed = $root.MixedData.decode(reader, reader.uint32(), $undefined, _depth + 1, message.mixed);
                    message.data = "mixed";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a BidiComponent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BidiComponent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BidiComponent} BidiComponent
     */
    BidiComponent.fromObject = function (object, _depth) {
        if (object instanceof $root.BidiComponent)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".BidiComponent: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.BidiComponent();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.componentName != null)
            if (typeof object.componentName !== "string" || object.componentName.length)
                message.componentName = $String(object.componentName);
        if (object.jsContent != null)
            message.jsContent = $String(object.jsContent);
        if (object.jsSourcePath != null)
            message.jsSourcePath = $String(object.jsSourcePath);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.htmlContent != null)
            message.htmlContent = $String(object.htmlContent);
        if (object.cssContent != null)
            message.cssContent = $String(object.cssContent);
        if (object.cssSourcePath != null)
            message.cssSourcePath = $String(object.cssSourcePath);
        if (object.isolateStyles != null)
            if (object.isolateStyles)
                message.isolateStyles = $Boolean(object.isolateStyles);
        if (object.json != null)
            message.json = $String(object.json);
        if (object.arrowData != null) {
            if (!$util.isObject(object.arrowData))
                throw $TypeError(".BidiComponent.arrowData: object expected");
            message.arrowData = $root.ArrowData.fromObject(object.arrowData, _depth + 1);
        }
        if (object.bytes != null)
            if (typeof object.bytes === "string")
                $util.base64.decode(object.bytes, message.bytes = $util.newBuffer($util.base64.length(object.bytes)), 0);
            else if (object.bytes.length >= 0)
                message.bytes = object.bytes;
        if (object.mixed != null) {
            if (!$util.isObject(object.mixed))
                throw $TypeError(".BidiComponent.mixed: object expected");
            message.mixed = $root.MixedData.fromObject(object.mixed, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a BidiComponent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BidiComponent
     * @static
     * @param {BidiComponent} message BidiComponent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BidiComponent.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.componentName = "";
            object.formId = "";
            object.isolateStyles = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.componentName != null && $Object.hasOwnProperty.call(message, "componentName"))
            object.componentName = message.componentName;
        if (message.jsContent != null && $Object.hasOwnProperty.call(message, "jsContent"))
            object.jsContent = message.jsContent;
        if (message.jsSourcePath != null && $Object.hasOwnProperty.call(message, "jsSourcePath"))
            object.jsSourcePath = message.jsSourcePath;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.htmlContent != null && $Object.hasOwnProperty.call(message, "htmlContent"))
            object.htmlContent = message.htmlContent;
        if (message.cssContent != null && $Object.hasOwnProperty.call(message, "cssContent"))
            object.cssContent = message.cssContent;
        if (message.cssSourcePath != null && $Object.hasOwnProperty.call(message, "cssSourcePath"))
            object.cssSourcePath = message.cssSourcePath;
        if (message.isolateStyles != null && $Object.hasOwnProperty.call(message, "isolateStyles"))
            object.isolateStyles = message.isolateStyles;
        if (message.json != null && $Object.hasOwnProperty.call(message, "json")) {
            object.json = message.json;
            if (options.oneofs)
                object.data = "json";
        }
        if (message.arrowData != null && $Object.hasOwnProperty.call(message, "arrowData")) {
            object.arrowData = $root.ArrowData.toObject(message.arrowData, options, _depth + 1);
            if (options.oneofs)
                object.data = "arrowData";
        }
        if (message.bytes != null && $Object.hasOwnProperty.call(message, "bytes")) {
            object.bytes = options.bytes === $String ? $util.base64.encode(message.bytes, 0, message.bytes.length) : options.bytes === $Array ? $Array.prototype.slice.call(message.bytes) : message.bytes;
            if (options.oneofs)
                object.data = "bytes";
        }
        if (message.mixed != null && $Object.hasOwnProperty.call(message, "mixed")) {
            object.mixed = $root.MixedData.toObject(message.mixed, options, _depth + 1);
            if (options.oneofs)
                object.data = "mixed";
        }
        return object;
    };

    /**
     * Converts this BidiComponent to JSON.
     * @function toJSON
     * @memberof BidiComponent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BidiComponent.prototype.toJSON = function() {
        return BidiComponent.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for BidiComponent
     * @function getTypeUrl
     * @memberof BidiComponent
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    BidiComponent.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/BidiComponent";
    };

    return BidiComponent;
})();

export const Block = $root.Block = (() => {

    /**
     * Properties of a Block.
     * @typedef {Object} Block.$Properties
     * @property {Block.Vertical.$Properties|null} [vertical] Block vertical
     * @property {Block.Horizontal.$Properties|null} [horizontal] Block horizontal
     * @property {Block.Column.$Properties|null} [column] Block column
     * @property {Block.Expandable.$Properties|null} [expandable] Block expandable
     * @property {Block.Form.$Properties|null} [form] Block form
     * @property {Block.TabContainer.$Properties|null} [tabContainer] Block tabContainer
     * @property {Block.Tab.$Properties|null} [tab] Block tab
     * @property {Block.ChatMessage.$Properties|null} [chatMessage] Block chatMessage
     * @property {Block.Popover.$Properties|null} [popover] Block popover
     * @property {Block.Dialog.$Properties|null} [dialog] Block dialog
     * @property {Block.FlexContainer.$Properties|null} [flexContainer] Block flexContainer
     * @property {Block.Transparent.$Properties|null} [transparent] Block transparent
     * @property {boolean|null} [allowEmpty] Block allowEmpty
     * @property {string|null} [id] Block id
     * @property {streamlit.HeightConfig.$Properties|null} [heightConfig] Block heightConfig
     * @property {streamlit.WidthConfig.$Properties|null} [widthConfig] Block widthConfig
     * @property {boolean|null} [autoscroll] Block autoscroll
     * @property {"vertical"|"horizontal"|"column"|"expandable"|"form"|"tabContainer"|"tab"|"chatMessage"|"popover"|"dialog"|"flexContainer"|"transparent"} [type] Block type
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Block.
     * @exports IBlock
     * @interface IBlock
     * @augments Block.$Properties
     * @deprecated Use Block.$Properties instead.
     */

    /**
     * Narrowed shape of a Block.
     * @typedef {{
     *   vertical?: Block.Vertical.$Shape|null;
     *   horizontal?: Block.Horizontal.$Shape|null;
     *   column?: Block.Column.$Shape|null;
     *   expandable?: Block.Expandable.$Shape|null;
     *   form?: Block.Form.$Shape|null;
     *   tabContainer?: Block.TabContainer.$Shape|null;
     *   tab?: Block.Tab.$Shape|null;
     *   chatMessage?: Block.ChatMessage.$Shape|null;
     *   popover?: Block.Popover.$Shape|null;
     *   dialog?: Block.Dialog.$Shape|null;
     *   flexContainer?: Block.FlexContainer.$Shape|null;
     *   transparent?: Block.Transparent.$Shape|null;
     *   allowEmpty?: boolean|null;
     *   id?: string|null;
     *   heightConfig?: streamlit.HeightConfig.$Shape|null;
     *   widthConfig?: streamlit.WidthConfig.$Shape|null;
     *   autoscroll?: boolean|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ type?: undefined; vertical?: null; horizontal?: null; column?: null; expandable?: null; form?: null; tabContainer?: null; tab?: null; chatMessage?: null; popover?: null; dialog?: null; flexContainer?: null; transparent?: null }|{ type?: "vertical"; vertical: Block.Vertical.$Shape; horizontal?: null; column?: null; expandable?: null; form?: null; tabContainer?: null; tab?: null; chatMessage?: null; popover?: null; dialog?: null; flexContainer?: null; transparent?: null }|{ type?: "horizontal"; vertical?: null; horizontal: Block.Horizontal.$Shape; column?: null; expandable?: null; form?: null; tabContainer?: null; tab?: null; chatMessage?: null; popover?: null; dialog?: null; flexContainer?: null; transparent?: null }|{ type?: "column"; vertical?: null; horizontal?: null; column: Block.Column.$Shape; expandable?: null; form?: null; tabContainer?: null; tab?: null; chatMessage?: null; popover?: null; dialog?: null; flexContainer?: null; transparent?: null }|{ type?: "expandable"; vertical?: null; horizontal?: null; column?: null; expandable: Block.Expandable.$Shape; form?: null; tabContainer?: null; tab?: null; chatMessage?: null; popover?: null; dialog?: null; flexContainer?: null; transparent?: null }|{ type?: "form"; vertical?: null; horizontal?: null; column?: null; expandable?: null; form: Block.Form.$Shape; tabContainer?: null; tab?: null; chatMessage?: null; popover?: null; dialog?: null; flexContainer?: null; transparent?: null }|{ type?: "tabContainer"; vertical?: null; horizontal?: null; column?: null; expandable?: null; form?: null; tabContainer: Block.TabContainer.$Shape; tab?: null; chatMessage?: null; popover?: null; dialog?: null; flexContainer?: null; transparent?: null }|{ type?: "tab"; vertical?: null; horizontal?: null; column?: null; expandable?: null; form?: null; tabContainer?: null; tab: Block.Tab.$Shape; chatMessage?: null; popover?: null; dialog?: null; flexContainer?: null; transparent?: null }|{ type?: "chatMessage"; vertical?: null; horizontal?: null; column?: null; expandable?: null; form?: null; tabContainer?: null; tab?: null; chatMessage: Block.ChatMessage.$Shape; popover?: null; dialog?: null; flexContainer?: null; transparent?: null }|{ type?: "popover"; vertical?: null; horizontal?: null; column?: null; expandable?: null; form?: null; tabContainer?: null; tab?: null; chatMessage?: null; popover: Block.Popover.$Shape; dialog?: null; flexContainer?: null; transparent?: null }|{ type?: "dialog"; vertical?: null; horizontal?: null; column?: null; expandable?: null; form?: null; tabContainer?: null; tab?: null; chatMessage?: null; popover?: null; dialog: Block.Dialog.$Shape; flexContainer?: null; transparent?: null }|{ type?: "flexContainer"; vertical?: null; horizontal?: null; column?: null; expandable?: null; form?: null; tabContainer?: null; tab?: null; chatMessage?: null; popover?: null; dialog?: null; flexContainer: Block.FlexContainer.$Shape; transparent?: null }|{ type?: "transparent"; vertical?: null; horizontal?: null; column?: null; expandable?: null; form?: null; tabContainer?: null; tab?: null; chatMessage?: null; popover?: null; dialog?: null; flexContainer?: null; transparent: Block.Transparent.$Shape })
     * )} Block.$Shape
     */

    /**
     * Constructs a new Block.
     * @exports Block
     * @classdesc Represents a Block.
     * @constructor
     * @param {Block.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Block = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Block vertical.
     * @member {Block.Vertical.$Properties|null|undefined} vertical
     * @memberof Block
     * @instance
     */
    Block.prototype.vertical = null;

    /**
     * Block horizontal.
     * @member {Block.Horizontal.$Properties|null|undefined} horizontal
     * @memberof Block
     * @instance
     */
    Block.prototype.horizontal = null;

    /**
     * Block column.
     * @member {Block.Column.$Properties|null|undefined} column
     * @memberof Block
     * @instance
     */
    Block.prototype.column = null;

    /**
     * Block expandable.
     * @member {Block.Expandable.$Properties|null|undefined} expandable
     * @memberof Block
     * @instance
     */
    Block.prototype.expandable = null;

    /**
     * Block form.
     * @member {Block.Form.$Properties|null|undefined} form
     * @memberof Block
     * @instance
     */
    Block.prototype.form = null;

    /**
     * Block tabContainer.
     * @member {Block.TabContainer.$Properties|null|undefined} tabContainer
     * @memberof Block
     * @instance
     */
    Block.prototype.tabContainer = null;

    /**
     * Block tab.
     * @member {Block.Tab.$Properties|null|undefined} tab
     * @memberof Block
     * @instance
     */
    Block.prototype.tab = null;

    /**
     * Block chatMessage.
     * @member {Block.ChatMessage.$Properties|null|undefined} chatMessage
     * @memberof Block
     * @instance
     */
    Block.prototype.chatMessage = null;

    /**
     * Block popover.
     * @member {Block.Popover.$Properties|null|undefined} popover
     * @memberof Block
     * @instance
     */
    Block.prototype.popover = null;

    /**
     * Block dialog.
     * @member {Block.Dialog.$Properties|null|undefined} dialog
     * @memberof Block
     * @instance
     */
    Block.prototype.dialog = null;

    /**
     * Block flexContainer.
     * @member {Block.FlexContainer.$Properties|null|undefined} flexContainer
     * @memberof Block
     * @instance
     */
    Block.prototype.flexContainer = null;

    /**
     * Block transparent.
     * @member {Block.Transparent.$Properties|null|undefined} transparent
     * @memberof Block
     * @instance
     */
    Block.prototype.transparent = null;

    /**
     * Block allowEmpty.
     * @member {boolean} allowEmpty
     * @memberof Block
     * @instance
     */
    Block.prototype.allowEmpty = false;

    /**
     * Block id.
     * @member {string|null|undefined} id
     * @memberof Block
     * @instance
     */
    Block.prototype.id = null;

    /**
     * Block heightConfig.
     * @member {streamlit.HeightConfig.$Properties|null|undefined} heightConfig
     * @memberof Block
     * @instance
     */
    Block.prototype.heightConfig = null;

    /**
     * Block widthConfig.
     * @member {streamlit.WidthConfig.$Properties|null|undefined} widthConfig
     * @memberof Block
     * @instance
     */
    Block.prototype.widthConfig = null;

    /**
     * Block autoscroll.
     * @member {boolean|null|undefined} autoscroll
     * @memberof Block
     * @instance
     */
    Block.prototype.autoscroll = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Block type.
     * @member {"vertical"|"horizontal"|"column"|"expandable"|"form"|"tabContainer"|"tab"|"chatMessage"|"popover"|"dialog"|"flexContainer"|"transparent"|undefined} type
     * @memberof Block
     * @instance
     */
    $Object.defineProperty(Block.prototype, "type", {
        get: $util.oneOfGetter($oneOfFields = ["vertical", "horizontal", "column", "expandable", "form", "tabContainer", "tab", "chatMessage", "popover", "dialog", "flexContainer", "transparent"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Block.prototype, "_id", {
        get: $util.oneOfGetter($oneOfFields = ["id"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Block.prototype, "_heightConfig", {
        get: $util.oneOfGetter($oneOfFields = ["heightConfig"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Block.prototype, "_widthConfig", {
        get: $util.oneOfGetter($oneOfFields = ["widthConfig"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Block.prototype, "_autoscroll", {
        get: $util.oneOfGetter($oneOfFields = ["autoscroll"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Block instance using the specified properties.
     * @function create
     * @memberof Block
     * @static
     * @param {Block.$Properties=} [properties] Properties to set
     * @returns {Block} Block instance
     * @type {{
     *   (properties: Block.$Shape): Block & Block.$Shape;
     *   (properties?: Block.$Properties): Block;
     * }}
     */
    Block.create = function(properties) {
        return new Block(properties);
    };

    /**
     * Encodes the specified Block message. Does not implicitly {@link Block.verify|verify} messages.
     * @function encode
     * @memberof Block
     * @static
     * @param {Block.$Properties} message Block message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Block.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.vertical != null && $Object.hasOwnProperty.call(message, "vertical"))
            $root.Block.Vertical.encode(message.vertical, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.horizontal != null && $Object.hasOwnProperty.call(message, "horizontal"))
            $root.Block.Horizontal.encode(message.horizontal, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.column != null && $Object.hasOwnProperty.call(message, "column"))
            $root.Block.Column.encode(message.column, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
        if (message.expandable != null && $Object.hasOwnProperty.call(message, "expandable"))
            $root.Block.Expandable.encode(message.expandable, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
        if (message.form != null && $Object.hasOwnProperty.call(message, "form"))
            $root.Block.Form.encode(message.form, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
        if (message.tabContainer != null && $Object.hasOwnProperty.call(message, "tabContainer"))
            $root.Block.TabContainer.encode(message.tabContainer, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
        if (message.tab != null && $Object.hasOwnProperty.call(message, "tab"))
            $root.Block.Tab.encode(message.tab, writer.uint32(/* id 7, wireType 2 =*/58).fork(), _depth + 1).ldelim();
        if (message.allowEmpty != null && $Object.hasOwnProperty.call(message, "allowEmpty") && message.allowEmpty !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.allowEmpty);
        if (message.chatMessage != null && $Object.hasOwnProperty.call(message, "chatMessage"))
            $root.Block.ChatMessage.encode(message.chatMessage, writer.uint32(/* id 9, wireType 2 =*/74).fork(), _depth + 1).ldelim();
        if (message.popover != null && $Object.hasOwnProperty.call(message, "popover"))
            $root.Block.Popover.encode(message.popover, writer.uint32(/* id 10, wireType 2 =*/82).fork(), _depth + 1).ldelim();
        if (message.dialog != null && $Object.hasOwnProperty.call(message, "dialog"))
            $root.Block.Dialog.encode(message.dialog, writer.uint32(/* id 11, wireType 2 =*/90).fork(), _depth + 1).ldelim();
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.id);
        if (message.flexContainer != null && $Object.hasOwnProperty.call(message, "flexContainer"))
            $root.Block.FlexContainer.encode(message.flexContainer, writer.uint32(/* id 13, wireType 2 =*/106).fork(), _depth + 1).ldelim();
        if (message.heightConfig != null && $Object.hasOwnProperty.call(message, "heightConfig"))
            $root.streamlit.HeightConfig.encode(message.heightConfig, writer.uint32(/* id 14, wireType 2 =*/114).fork(), _depth + 1).ldelim();
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            $root.streamlit.WidthConfig.encode(message.widthConfig, writer.uint32(/* id 15, wireType 2 =*/122).fork(), _depth + 1).ldelim();
        if (message.autoscroll != null && $Object.hasOwnProperty.call(message, "autoscroll"))
            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.autoscroll);
        if (message.transparent != null && $Object.hasOwnProperty.call(message, "transparent"))
            $root.Block.Transparent.encode(message.transparent, writer.uint32(/* id 17, wireType 2 =*/138).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Block message from the specified reader or buffer.
     * @function decode
     * @memberof Block
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Block & Block.$Shape} Block
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Block.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Block();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.vertical = $root.Block.Vertical.decode(reader, reader.uint32(), $undefined, _depth + 1, message.vertical);
                    message.type = "vertical";
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    message.horizontal = $root.Block.Horizontal.decode(reader, reader.uint32(), $undefined, _depth + 1, message.horizontal);
                    message.type = "horizontal";
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.column = $root.Block.Column.decode(reader, reader.uint32(), $undefined, _depth + 1, message.column);
                    message.type = "column";
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.expandable = $root.Block.Expandable.decode(reader, reader.uint32(), $undefined, _depth + 1, message.expandable);
                    message.type = "expandable";
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.form = $root.Block.Form.decode(reader, reader.uint32(), $undefined, _depth + 1, message.form);
                    message.type = "form";
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.tabContainer = $root.Block.TabContainer.decode(reader, reader.uint32(), $undefined, _depth + 1, message.tabContainer);
                    message.type = "tabContainer";
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    message.tab = $root.Block.Tab.decode(reader, reader.uint32(), $undefined, _depth + 1, message.tab);
                    message.type = "tab";
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    message.chatMessage = $root.Block.ChatMessage.decode(reader, reader.uint32(), $undefined, _depth + 1, message.chatMessage);
                    message.type = "chatMessage";
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.popover = $root.Block.Popover.decode(reader, reader.uint32(), $undefined, _depth + 1, message.popover);
                    message.type = "popover";
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.dialog = $root.Block.Dialog.decode(reader, reader.uint32(), $undefined, _depth + 1, message.dialog);
                    message.type = "dialog";
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.flexContainer = $root.Block.FlexContainer.decode(reader, reader.uint32(), $undefined, _depth + 1, message.flexContainer);
                    message.type = "flexContainer";
                    continue;
                }
            case 17: {
                    if (wireType !== 2)
                        break;
                    message.transparent = $root.Block.Transparent.decode(reader, reader.uint32(), $undefined, _depth + 1, message.transparent);
                    message.type = "transparent";
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.allowEmpty = value;
                    else
                        delete message.allowEmpty;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.id = reader.stringVerify();
                    message._id = "id";
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    message.heightConfig = $root.streamlit.HeightConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.heightConfig);
                    message._heightConfig = "heightConfig";
                    continue;
                }
            case 15: {
                    if (wireType !== 2)
                        break;
                    message.widthConfig = $root.streamlit.WidthConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.widthConfig);
                    message._widthConfig = "widthConfig";
                    continue;
                }
            case 16: {
                    if (wireType !== 0)
                        break;
                    message.autoscroll = reader.bool();
                    message._autoscroll = "autoscroll";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Block message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Block
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Block} Block
     */
    Block.fromObject = function (object, _depth) {
        if (object instanceof $root.Block)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Block: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Block();
        if (object.vertical != null) {
            if (!$util.isObject(object.vertical))
                throw $TypeError(".Block.vertical: object expected");
            message.vertical = $root.Block.Vertical.fromObject(object.vertical, _depth + 1);
        }
        if (object.horizontal != null) {
            if (!$util.isObject(object.horizontal))
                throw $TypeError(".Block.horizontal: object expected");
            message.horizontal = $root.Block.Horizontal.fromObject(object.horizontal, _depth + 1);
        }
        if (object.column != null) {
            if (!$util.isObject(object.column))
                throw $TypeError(".Block.column: object expected");
            message.column = $root.Block.Column.fromObject(object.column, _depth + 1);
        }
        if (object.expandable != null) {
            if (!$util.isObject(object.expandable))
                throw $TypeError(".Block.expandable: object expected");
            message.expandable = $root.Block.Expandable.fromObject(object.expandable, _depth + 1);
        }
        if (object.form != null) {
            if (!$util.isObject(object.form))
                throw $TypeError(".Block.form: object expected");
            message.form = $root.Block.Form.fromObject(object.form, _depth + 1);
        }
        if (object.tabContainer != null) {
            if (!$util.isObject(object.tabContainer))
                throw $TypeError(".Block.tabContainer: object expected");
            message.tabContainer = $root.Block.TabContainer.fromObject(object.tabContainer, _depth + 1);
        }
        if (object.tab != null) {
            if (!$util.isObject(object.tab))
                throw $TypeError(".Block.tab: object expected");
            message.tab = $root.Block.Tab.fromObject(object.tab, _depth + 1);
        }
        if (object.chatMessage != null) {
            if (!$util.isObject(object.chatMessage))
                throw $TypeError(".Block.chatMessage: object expected");
            message.chatMessage = $root.Block.ChatMessage.fromObject(object.chatMessage, _depth + 1);
        }
        if (object.popover != null) {
            if (!$util.isObject(object.popover))
                throw $TypeError(".Block.popover: object expected");
            message.popover = $root.Block.Popover.fromObject(object.popover, _depth + 1);
        }
        if (object.dialog != null) {
            if (!$util.isObject(object.dialog))
                throw $TypeError(".Block.dialog: object expected");
            message.dialog = $root.Block.Dialog.fromObject(object.dialog, _depth + 1);
        }
        if (object.flexContainer != null) {
            if (!$util.isObject(object.flexContainer))
                throw $TypeError(".Block.flexContainer: object expected");
            message.flexContainer = $root.Block.FlexContainer.fromObject(object.flexContainer, _depth + 1);
        }
        if (object.transparent != null) {
            if (!$util.isObject(object.transparent))
                throw $TypeError(".Block.transparent: object expected");
            message.transparent = $root.Block.Transparent.fromObject(object.transparent, _depth + 1);
        }
        if (object.allowEmpty != null)
            if (object.allowEmpty)
                message.allowEmpty = $Boolean(object.allowEmpty);
        if (object.id != null)
            message.id = $String(object.id);
        if (object.heightConfig != null) {
            if (!$util.isObject(object.heightConfig))
                throw $TypeError(".Block.heightConfig: object expected");
            message.heightConfig = $root.streamlit.HeightConfig.fromObject(object.heightConfig, _depth + 1);
        }
        if (object.widthConfig != null) {
            if (!$util.isObject(object.widthConfig))
                throw $TypeError(".Block.widthConfig: object expected");
            message.widthConfig = $root.streamlit.WidthConfig.fromObject(object.widthConfig, _depth + 1);
        }
        if (object.autoscroll != null)
            message.autoscroll = $Boolean(object.autoscroll);
        return message;
    };

    /**
     * Creates a plain object from a Block message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Block
     * @static
     * @param {Block} message Block
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Block.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.allowEmpty = false;
        if (message.vertical != null && $Object.hasOwnProperty.call(message, "vertical")) {
            object.vertical = $root.Block.Vertical.toObject(message.vertical, options, _depth + 1);
            if (options.oneofs)
                object.type = "vertical";
        }
        if (message.horizontal != null && $Object.hasOwnProperty.call(message, "horizontal")) {
            object.horizontal = $root.Block.Horizontal.toObject(message.horizontal, options, _depth + 1);
            if (options.oneofs)
                object.type = "horizontal";
        }
        if (message.column != null && $Object.hasOwnProperty.call(message, "column")) {
            object.column = $root.Block.Column.toObject(message.column, options, _depth + 1);
            if (options.oneofs)
                object.type = "column";
        }
        if (message.expandable != null && $Object.hasOwnProperty.call(message, "expandable")) {
            object.expandable = $root.Block.Expandable.toObject(message.expandable, options, _depth + 1);
            if (options.oneofs)
                object.type = "expandable";
        }
        if (message.form != null && $Object.hasOwnProperty.call(message, "form")) {
            object.form = $root.Block.Form.toObject(message.form, options, _depth + 1);
            if (options.oneofs)
                object.type = "form";
        }
        if (message.tabContainer != null && $Object.hasOwnProperty.call(message, "tabContainer")) {
            object.tabContainer = $root.Block.TabContainer.toObject(message.tabContainer, options, _depth + 1);
            if (options.oneofs)
                object.type = "tabContainer";
        }
        if (message.tab != null && $Object.hasOwnProperty.call(message, "tab")) {
            object.tab = $root.Block.Tab.toObject(message.tab, options, _depth + 1);
            if (options.oneofs)
                object.type = "tab";
        }
        if (message.allowEmpty != null && $Object.hasOwnProperty.call(message, "allowEmpty"))
            object.allowEmpty = message.allowEmpty;
        if (message.chatMessage != null && $Object.hasOwnProperty.call(message, "chatMessage")) {
            object.chatMessage = $root.Block.ChatMessage.toObject(message.chatMessage, options, _depth + 1);
            if (options.oneofs)
                object.type = "chatMessage";
        }
        if (message.popover != null && $Object.hasOwnProperty.call(message, "popover")) {
            object.popover = $root.Block.Popover.toObject(message.popover, options, _depth + 1);
            if (options.oneofs)
                object.type = "popover";
        }
        if (message.dialog != null && $Object.hasOwnProperty.call(message, "dialog")) {
            object.dialog = $root.Block.Dialog.toObject(message.dialog, options, _depth + 1);
            if (options.oneofs)
                object.type = "dialog";
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.flexContainer != null && $Object.hasOwnProperty.call(message, "flexContainer")) {
            object.flexContainer = $root.Block.FlexContainer.toObject(message.flexContainer, options, _depth + 1);
            if (options.oneofs)
                object.type = "flexContainer";
        }
        if (message.heightConfig != null && $Object.hasOwnProperty.call(message, "heightConfig"))
            object.heightConfig = $root.streamlit.HeightConfig.toObject(message.heightConfig, options, _depth + 1);
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            object.widthConfig = $root.streamlit.WidthConfig.toObject(message.widthConfig, options, _depth + 1);
        if (message.autoscroll != null && $Object.hasOwnProperty.call(message, "autoscroll"))
            object.autoscroll = message.autoscroll;
        if (message.transparent != null && $Object.hasOwnProperty.call(message, "transparent")) {
            object.transparent = $root.Block.Transparent.toObject(message.transparent, options, _depth + 1);
            if (options.oneofs)
                object.type = "transparent";
        }
        return object;
    };

    /**
     * Converts this Block to JSON.
     * @function toJSON
     * @memberof Block
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Block.prototype.toJSON = function() {
        return Block.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Block
     * @function getTypeUrl
     * @memberof Block
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Block.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Block";
    };

    Block.Vertical = (function() {

        /**
         * Properties of a Vertical.
         * @typedef {Object} Block.Vertical.$Properties
         * @property {boolean|null} [border] Vertical border
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Vertical.
         * @memberof Block
         * @interface IVertical
         * @augments Block.Vertical.$Properties
         * @deprecated Use Block.Vertical.$Properties instead.
         */

        /**
         * Shape of a Vertical.
         * @typedef {Block.Vertical.$Properties} Block.Vertical.$Shape
         */

        /**
         * Constructs a new Vertical.
         * @memberof Block
         * @classdesc Represents a Vertical.
         * @constructor
         * @param {Block.Vertical.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Vertical = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Vertical border.
         * @member {boolean} border
         * @memberof Block.Vertical
         * @instance
         */
        Vertical.prototype.border = false;

        /**
         * Creates a new Vertical instance using the specified properties.
         * @function create
         * @memberof Block.Vertical
         * @static
         * @param {Block.Vertical.$Properties=} [properties] Properties to set
         * @returns {Block.Vertical} Vertical instance
         * @type {{
         *   (properties: Block.Vertical.$Shape): Block.Vertical & Block.Vertical.$Shape;
         *   (properties?: Block.Vertical.$Properties): Block.Vertical;
         * }}
         */
        Vertical.create = function(properties) {
            return new Vertical(properties);
        };

        /**
         * Encodes the specified Vertical message. Does not implicitly {@link Block.Vertical.verify|verify} messages.
         * @function encode
         * @memberof Block.Vertical
         * @static
         * @param {Block.Vertical.$Properties} message Vertical message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Vertical.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.border != null && $Object.hasOwnProperty.call(message, "border") && message.border !== false)
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.border);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a Vertical message from the specified reader or buffer.
         * @function decode
         * @memberof Block.Vertical
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.Vertical & Block.Vertical.$Shape} Vertical
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Vertical.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.Vertical();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.border = value;
                        else
                            delete message.border;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a Vertical message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.Vertical
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.Vertical} Vertical
         */
        Vertical.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.Vertical)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.Vertical: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.Vertical();
            if (object.border != null)
                if (object.border)
                    message.border = $Boolean(object.border);
            return message;
        };

        /**
         * Creates a plain object from a Vertical message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.Vertical
         * @static
         * @param {Block.Vertical} message Vertical
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Vertical.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.border = false;
            if (message.border != null && $Object.hasOwnProperty.call(message, "border"))
                object.border = message.border;
            return object;
        };

        /**
         * Converts this Vertical to JSON.
         * @function toJSON
         * @memberof Block.Vertical
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Vertical.prototype.toJSON = function() {
            return Vertical.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Vertical
         * @function getTypeUrl
         * @memberof Block.Vertical
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Vertical.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.Vertical";
        };

        return Vertical;
    })();

    Block.Horizontal = (function() {

        /**
         * Properties of a Horizontal.
         * @typedef {Object} Block.Horizontal.$Properties
         * @property {string|null} [gap] Horizontal gap
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Horizontal.
         * @memberof Block
         * @interface IHorizontal
         * @augments Block.Horizontal.$Properties
         * @deprecated Use Block.Horizontal.$Properties instead.
         */

        /**
         * Shape of a Horizontal.
         * @typedef {Block.Horizontal.$Properties} Block.Horizontal.$Shape
         */

        /**
         * Constructs a new Horizontal.
         * @memberof Block
         * @classdesc Represents a Horizontal.
         * @constructor
         * @param {Block.Horizontal.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Horizontal = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Horizontal gap.
         * @member {string} gap
         * @memberof Block.Horizontal
         * @instance
         */
        Horizontal.prototype.gap = "";

        /**
         * Creates a new Horizontal instance using the specified properties.
         * @function create
         * @memberof Block.Horizontal
         * @static
         * @param {Block.Horizontal.$Properties=} [properties] Properties to set
         * @returns {Block.Horizontal} Horizontal instance
         * @type {{
         *   (properties: Block.Horizontal.$Shape): Block.Horizontal & Block.Horizontal.$Shape;
         *   (properties?: Block.Horizontal.$Properties): Block.Horizontal;
         * }}
         */
        Horizontal.create = function(properties) {
            return new Horizontal(properties);
        };

        /**
         * Encodes the specified Horizontal message. Does not implicitly {@link Block.Horizontal.verify|verify} messages.
         * @function encode
         * @memberof Block.Horizontal
         * @static
         * @param {Block.Horizontal.$Properties} message Horizontal message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Horizontal.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.gap != null && $Object.hasOwnProperty.call(message, "gap") && message.gap !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.gap);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a Horizontal message from the specified reader or buffer.
         * @function decode
         * @memberof Block.Horizontal
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.Horizontal & Block.Horizontal.$Shape} Horizontal
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Horizontal.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.Horizontal();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.gap = value;
                        else
                            delete message.gap;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a Horizontal message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.Horizontal
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.Horizontal} Horizontal
         */
        Horizontal.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.Horizontal)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.Horizontal: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.Horizontal();
            if (object.gap != null)
                if (typeof object.gap !== "string" || object.gap.length)
                    message.gap = $String(object.gap);
            return message;
        };

        /**
         * Creates a plain object from a Horizontal message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.Horizontal
         * @static
         * @param {Block.Horizontal} message Horizontal
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Horizontal.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.gap = "";
            if (message.gap != null && $Object.hasOwnProperty.call(message, "gap"))
                object.gap = message.gap;
            return object;
        };

        /**
         * Converts this Horizontal to JSON.
         * @function toJSON
         * @memberof Block.Horizontal
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Horizontal.prototype.toJSON = function() {
            return Horizontal.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Horizontal
         * @function getTypeUrl
         * @memberof Block.Horizontal
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Horizontal.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.Horizontal";
        };

        return Horizontal;
    })();

    Block.FlexContainer = (function() {

        /**
         * Properties of a FlexContainer.
         * @typedef {Object} Block.FlexContainer.$Properties
         * @property {boolean|null} [border] FlexContainer border
         * @property {streamlit.GapConfig.$Properties|null} [gapConfig] FlexContainer gapConfig
         * @property {number|null} [scale] FlexContainer scale
         * @property {Block.FlexContainer.Direction|null} [direction] FlexContainer direction
         * @property {boolean|null} [wrap] FlexContainer wrap
         * @property {Block.FlexContainer.Justify|null} [justify] FlexContainer justify
         * @property {Block.FlexContainer.Align|null} [align] FlexContainer align
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a FlexContainer.
         * @memberof Block
         * @interface IFlexContainer
         * @augments Block.FlexContainer.$Properties
         * @deprecated Use Block.FlexContainer.$Properties instead.
         */

        /**
         * Shape of a FlexContainer.
         * @typedef {{
         *   border?: boolean|null;
         *   gapConfig?: streamlit.GapConfig.$Shape|null;
         *   scale?: number|null;
         *   direction?: Block.FlexContainer.Direction|null;
         *   wrap?: boolean|null;
         *   justify?: Block.FlexContainer.Justify|null;
         *   align?: Block.FlexContainer.Align|null;
         *   $unknowns?: Array.<Uint8Array>;
         * }} Block.FlexContainer.$Shape
         */

        /**
         * Constructs a new FlexContainer.
         * @memberof Block
         * @classdesc Represents a FlexContainer.
         * @constructor
         * @param {Block.FlexContainer.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const FlexContainer = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * FlexContainer border.
         * @member {boolean} border
         * @memberof Block.FlexContainer
         * @instance
         */
        FlexContainer.prototype.border = false;

        /**
         * FlexContainer gapConfig.
         * @member {streamlit.GapConfig.$Properties|null|undefined} gapConfig
         * @memberof Block.FlexContainer
         * @instance
         */
        FlexContainer.prototype.gapConfig = null;

        /**
         * FlexContainer scale.
         * @member {number} scale
         * @memberof Block.FlexContainer
         * @instance
         */
        FlexContainer.prototype.scale = 0;

        /**
         * FlexContainer direction.
         * @member {Block.FlexContainer.Direction} direction
         * @memberof Block.FlexContainer
         * @instance
         */
        FlexContainer.prototype.direction = 0;

        /**
         * FlexContainer wrap.
         * @member {boolean} wrap
         * @memberof Block.FlexContainer
         * @instance
         */
        FlexContainer.prototype.wrap = false;

        /**
         * FlexContainer justify.
         * @member {Block.FlexContainer.Justify} justify
         * @memberof Block.FlexContainer
         * @instance
         */
        FlexContainer.prototype.justify = 0;

        /**
         * FlexContainer align.
         * @member {Block.FlexContainer.Align} align
         * @memberof Block.FlexContainer
         * @instance
         */
        FlexContainer.prototype.align = 0;

        /**
         * Creates a new FlexContainer instance using the specified properties.
         * @function create
         * @memberof Block.FlexContainer
         * @static
         * @param {Block.FlexContainer.$Properties=} [properties] Properties to set
         * @returns {Block.FlexContainer} FlexContainer instance
         * @type {{
         *   (properties: Block.FlexContainer.$Shape): Block.FlexContainer & Block.FlexContainer.$Shape;
         *   (properties?: Block.FlexContainer.$Properties): Block.FlexContainer;
         * }}
         */
        FlexContainer.create = function(properties) {
            return new FlexContainer(properties);
        };

        /**
         * Encodes the specified FlexContainer message. Does not implicitly {@link Block.FlexContainer.verify|verify} messages.
         * @function encode
         * @memberof Block.FlexContainer
         * @static
         * @param {Block.FlexContainer.$Properties} message FlexContainer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FlexContainer.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.border != null && $Object.hasOwnProperty.call(message, "border") && message.border !== false)
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.border);
            if (message.gapConfig != null && $Object.hasOwnProperty.call(message, "gapConfig"))
                $root.streamlit.GapConfig.encode(message.gapConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
            if (message.scale != null && $Object.hasOwnProperty.call(message, "scale") && !$Object.is(message.scale, 0))
                writer.uint32(/* id 3, wireType 5 =*/29).float(message.scale);
            if (message.direction != null && $Object.hasOwnProperty.call(message, "direction") && message.direction !== 0)
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.direction);
            if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap") && message.wrap !== false)
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.wrap);
            if (message.justify != null && $Object.hasOwnProperty.call(message, "justify") && message.justify !== 0)
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.justify);
            if (message.align != null && $Object.hasOwnProperty.call(message, "align") && message.align !== 0)
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.align);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a FlexContainer message from the specified reader or buffer.
         * @function decode
         * @memberof Block.FlexContainer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.FlexContainer & Block.FlexContainer.$Shape} FlexContainer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FlexContainer.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.FlexContainer();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.border = value;
                        else
                            delete message.border;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        message.gapConfig = $root.streamlit.GapConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.gapConfig);
                        continue;
                    }
                case 3: {
                        if (wireType !== 5)
                            break;
                        if (!$Object.is(value = reader.float(), 0))
                            message.scale = value;
                        else
                            delete message.scale;
                        continue;
                    }
                case 4: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.direction = value;
                        else
                            delete message.direction;
                        continue;
                    }
                case 5: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.wrap = value;
                        else
                            delete message.wrap;
                        continue;
                    }
                case 7: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.justify = value;
                        else
                            delete message.justify;
                        continue;
                    }
                case 8: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.align = value;
                        else
                            delete message.align;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a FlexContainer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.FlexContainer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.FlexContainer} FlexContainer
         */
        FlexContainer.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.FlexContainer)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.FlexContainer: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.FlexContainer();
            if (object.border != null)
                if (object.border)
                    message.border = $Boolean(object.border);
            if (object.gapConfig != null) {
                if (!$util.isObject(object.gapConfig))
                    throw $TypeError(".Block.FlexContainer.gapConfig: object expected");
                message.gapConfig = $root.streamlit.GapConfig.fromObject(object.gapConfig, _depth + 1);
            }
            if (object.scale != null)
                if (!$Object.is($Number(object.scale), 0))
                    message.scale = $Number(object.scale);
            if (object.direction !== 0 && (typeof object.direction !== "string" || $root.Block.FlexContainer.Direction[object.direction] !== 0))
                switch (object.direction) {
                case "DIRECTION_UNDEFINED":
                case 0:
                    message.direction = 0;
                    break;
                case "VERTICAL":
                case 1:
                    message.direction = 1;
                    break;
                case "HORIZONTAL":
                case 2:
                    message.direction = 2;
                    break;
                default:
                    if (typeof object.direction === "number" && (object.direction | 0) === object.direction)
                        message.direction = object.direction;
                }
            if (object.wrap != null)
                if (object.wrap)
                    message.wrap = $Boolean(object.wrap);
            if (object.justify !== 0 && (typeof object.justify !== "string" || $root.Block.FlexContainer.Justify[object.justify] !== 0))
                switch (object.justify) {
                case "JUSTIFY_UNDEFINED":
                case 0:
                    message.justify = 0;
                    break;
                case "JUSTIFY_START":
                case 1:
                    message.justify = 1;
                    break;
                case "JUSTIFY_END":
                case 2:
                    message.justify = 2;
                    break;
                case "JUSTIFY_CENTER":
                case 3:
                    message.justify = 3;
                    break;
                case "SPACE_BETWEEN":
                case 4:
                    message.justify = 4;
                    break;
                default:
                    if (typeof object.justify === "number" && (object.justify | 0) === object.justify)
                        message.justify = object.justify;
                }
            if (object.align !== 0 && (typeof object.align !== "string" || $root.Block.FlexContainer.Align[object.align] !== 0))
                switch (object.align) {
                case "ALIGN_UNDEFINED":
                case 0:
                    message.align = 0;
                    break;
                case "ALIGN_START":
                case 1:
                    message.align = 1;
                    break;
                case "ALIGN_END":
                case 2:
                    message.align = 2;
                    break;
                case "ALIGN_CENTER":
                case 3:
                    message.align = 3;
                    break;
                case "STRETCH":
                case 4:
                    message.align = 4;
                    break;
                default:
                    if (typeof object.align === "number" && (object.align | 0) === object.align)
                        message.align = object.align;
                }
            return message;
        };

        /**
         * Creates a plain object from a FlexContainer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.FlexContainer
         * @static
         * @param {Block.FlexContainer} message FlexContainer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FlexContainer.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.border = false;
                object.gapConfig = null;
                object.scale = 0;
                object.direction = options.enums === $String ? "DIRECTION_UNDEFINED" : 0;
                object.wrap = false;
                object.justify = options.enums === $String ? "JUSTIFY_UNDEFINED" : 0;
                object.align = options.enums === $String ? "ALIGN_UNDEFINED" : 0;
            }
            if (message.border != null && $Object.hasOwnProperty.call(message, "border"))
                object.border = message.border;
            if (message.gapConfig != null && $Object.hasOwnProperty.call(message, "gapConfig"))
                object.gapConfig = $root.streamlit.GapConfig.toObject(message.gapConfig, options, _depth + 1);
            if (message.scale != null && $Object.hasOwnProperty.call(message, "scale"))
                object.scale = options.json && !$isFinite(message.scale) ? $String(message.scale) : message.scale;
            if (message.direction != null && $Object.hasOwnProperty.call(message, "direction"))
                object.direction = options.enums === $String ? $root.Block.FlexContainer.Direction[message.direction] === $undefined ? message.direction : $root.Block.FlexContainer.Direction[message.direction] : message.direction;
            if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
                object.wrap = message.wrap;
            if (message.justify != null && $Object.hasOwnProperty.call(message, "justify"))
                object.justify = options.enums === $String ? $root.Block.FlexContainer.Justify[message.justify] === $undefined ? message.justify : $root.Block.FlexContainer.Justify[message.justify] : message.justify;
            if (message.align != null && $Object.hasOwnProperty.call(message, "align"))
                object.align = options.enums === $String ? $root.Block.FlexContainer.Align[message.align] === $undefined ? message.align : $root.Block.FlexContainer.Align[message.align] : message.align;
            return object;
        };

        /**
         * Converts this FlexContainer to JSON.
         * @function toJSON
         * @memberof Block.FlexContainer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FlexContainer.prototype.toJSON = function() {
            return FlexContainer.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for FlexContainer
         * @function getTypeUrl
         * @memberof Block.FlexContainer
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        FlexContainer.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.FlexContainer";
        };

        /**
         * Direction enum.
         * @name Block.FlexContainer.Direction
         * @enum {number}
         * @property {number} DIRECTION_UNDEFINED=0 DIRECTION_UNDEFINED value
         * @property {number} VERTICAL=1 VERTICAL value
         * @property {number} HORIZONTAL=2 HORIZONTAL value
         */
        FlexContainer.Direction = (function() {
            const valuesById = $Object.create(null), values = $Object.create(valuesById);
            values[valuesById[0] = "DIRECTION_UNDEFINED"] = 0;
            values[valuesById[1] = "VERTICAL"] = 1;
            values[valuesById[2] = "HORIZONTAL"] = 2;
            return values;
        })();

        /**
         * Justify enum.
         * @name Block.FlexContainer.Justify
         * @enum {number}
         * @property {number} JUSTIFY_UNDEFINED=0 JUSTIFY_UNDEFINED value
         * @property {number} JUSTIFY_START=1 JUSTIFY_START value
         * @property {number} JUSTIFY_END=2 JUSTIFY_END value
         * @property {number} JUSTIFY_CENTER=3 JUSTIFY_CENTER value
         * @property {number} SPACE_BETWEEN=4 SPACE_BETWEEN value
         */
        FlexContainer.Justify = (function() {
            const valuesById = $Object.create(null), values = $Object.create(valuesById);
            values[valuesById[0] = "JUSTIFY_UNDEFINED"] = 0;
            values[valuesById[1] = "JUSTIFY_START"] = 1;
            values[valuesById[2] = "JUSTIFY_END"] = 2;
            values[valuesById[3] = "JUSTIFY_CENTER"] = 3;
            values[valuesById[4] = "SPACE_BETWEEN"] = 4;
            return values;
        })();

        /**
         * Align enum.
         * @name Block.FlexContainer.Align
         * @enum {number}
         * @property {number} ALIGN_UNDEFINED=0 ALIGN_UNDEFINED value
         * @property {number} ALIGN_START=1 ALIGN_START value
         * @property {number} ALIGN_END=2 ALIGN_END value
         * @property {number} ALIGN_CENTER=3 ALIGN_CENTER value
         * @property {number} STRETCH=4 STRETCH value
         */
        FlexContainer.Align = (function() {
            const valuesById = $Object.create(null), values = $Object.create(valuesById);
            values[valuesById[0] = "ALIGN_UNDEFINED"] = 0;
            values[valuesById[1] = "ALIGN_START"] = 1;
            values[valuesById[2] = "ALIGN_END"] = 2;
            values[valuesById[3] = "ALIGN_CENTER"] = 3;
            values[valuesById[4] = "STRETCH"] = 4;
            return values;
        })();

        return FlexContainer;
    })();

    Block.Column = (function() {

        /**
         * Properties of a Column.
         * @typedef {Object} Block.Column.$Properties
         * @property {number|null} [weight] Column weight
         * @property {Block.Column.VerticalAlignment|null} [verticalAlignment] Column verticalAlignment
         * @property {boolean|null} [showBorder] Column showBorder
         * @property {streamlit.GapConfig.$Properties|null} [gapConfig] Column gapConfig
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Column.
         * @memberof Block
         * @interface IColumn
         * @augments Block.Column.$Properties
         * @deprecated Use Block.Column.$Properties instead.
         */

        /**
         * Shape of a Column.
         * @typedef {{
         *   weight?: number|null;
         *   verticalAlignment?: Block.Column.VerticalAlignment|null;
         *   showBorder?: boolean|null;
         *   gapConfig?: streamlit.GapConfig.$Shape|null;
         *   $unknowns?: Array.<Uint8Array>;
         * }} Block.Column.$Shape
         */

        /**
         * Constructs a new Column.
         * @memberof Block
         * @classdesc Represents a Column.
         * @constructor
         * @param {Block.Column.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Column = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Column weight.
         * @member {number} weight
         * @memberof Block.Column
         * @instance
         */
        Column.prototype.weight = 0;

        /**
         * Column verticalAlignment.
         * @member {Block.Column.VerticalAlignment} verticalAlignment
         * @memberof Block.Column
         * @instance
         */
        Column.prototype.verticalAlignment = 0;

        /**
         * Column showBorder.
         * @member {boolean} showBorder
         * @memberof Block.Column
         * @instance
         */
        Column.prototype.showBorder = false;

        /**
         * Column gapConfig.
         * @member {streamlit.GapConfig.$Properties|null|undefined} gapConfig
         * @memberof Block.Column
         * @instance
         */
        Column.prototype.gapConfig = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(Column.prototype, "_gapConfig", {
            get: $util.oneOfGetter($oneOfFields = ["gapConfig"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Column instance using the specified properties.
         * @function create
         * @memberof Block.Column
         * @static
         * @param {Block.Column.$Properties=} [properties] Properties to set
         * @returns {Block.Column} Column instance
         * @type {{
         *   (properties: Block.Column.$Shape): Block.Column & Block.Column.$Shape;
         *   (properties?: Block.Column.$Properties): Block.Column;
         * }}
         */
        Column.create = function(properties) {
            return new Column(properties);
        };

        /**
         * Encodes the specified Column message. Does not implicitly {@link Block.Column.verify|verify} messages.
         * @function encode
         * @memberof Block.Column
         * @static
         * @param {Block.Column.$Properties} message Column message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Column.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.weight != null && $Object.hasOwnProperty.call(message, "weight") && !$Object.is(message.weight, 0))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.weight);
            if (message.verticalAlignment != null && $Object.hasOwnProperty.call(message, "verticalAlignment") && message.verticalAlignment !== 0)
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.verticalAlignment);
            if (message.showBorder != null && $Object.hasOwnProperty.call(message, "showBorder") && message.showBorder !== false)
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.showBorder);
            if (message.gapConfig != null && $Object.hasOwnProperty.call(message, "gapConfig"))
                $root.streamlit.GapConfig.encode(message.gapConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a Column message from the specified reader or buffer.
         * @function decode
         * @memberof Block.Column
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.Column & Block.Column.$Shape} Column
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Column.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.Column();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 1)
                            break;
                        if (!$Object.is(value = reader.double(), 0))
                            message.weight = value;
                        else
                            delete message.weight;
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.verticalAlignment = value;
                        else
                            delete message.verticalAlignment;
                        continue;
                    }
                case 4: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.showBorder = value;
                        else
                            delete message.showBorder;
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        message.gapConfig = $root.streamlit.GapConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.gapConfig);
                        message._gapConfig = "gapConfig";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a Column message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.Column
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.Column} Column
         */
        Column.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.Column)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.Column: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.Column();
            if (object.weight != null)
                if (!$Object.is($Number(object.weight), 0))
                    message.weight = $Number(object.weight);
            if (object.verticalAlignment !== 0 && (typeof object.verticalAlignment !== "string" || $root.Block.Column.VerticalAlignment[object.verticalAlignment] !== 0))
                switch (object.verticalAlignment) {
                case "TOP":
                case 0:
                    message.verticalAlignment = 0;
                    break;
                case "CENTER":
                case 1:
                    message.verticalAlignment = 1;
                    break;
                case "BOTTOM":
                case 2:
                    message.verticalAlignment = 2;
                    break;
                default:
                    if (typeof object.verticalAlignment === "number" && (object.verticalAlignment | 0) === object.verticalAlignment)
                        message.verticalAlignment = object.verticalAlignment;
                }
            if (object.showBorder != null)
                if (object.showBorder)
                    message.showBorder = $Boolean(object.showBorder);
            if (object.gapConfig != null) {
                if (!$util.isObject(object.gapConfig))
                    throw $TypeError(".Block.Column.gapConfig: object expected");
                message.gapConfig = $root.streamlit.GapConfig.fromObject(object.gapConfig, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a Column message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.Column
         * @static
         * @param {Block.Column} message Column
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Column.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.weight = 0;
                object.verticalAlignment = options.enums === $String ? "TOP" : 0;
                object.showBorder = false;
            }
            if (message.weight != null && $Object.hasOwnProperty.call(message, "weight"))
                object.weight = options.json && !$isFinite(message.weight) ? $String(message.weight) : message.weight;
            if (message.verticalAlignment != null && $Object.hasOwnProperty.call(message, "verticalAlignment"))
                object.verticalAlignment = options.enums === $String ? $root.Block.Column.VerticalAlignment[message.verticalAlignment] === $undefined ? message.verticalAlignment : $root.Block.Column.VerticalAlignment[message.verticalAlignment] : message.verticalAlignment;
            if (message.showBorder != null && $Object.hasOwnProperty.call(message, "showBorder"))
                object.showBorder = message.showBorder;
            if (message.gapConfig != null && $Object.hasOwnProperty.call(message, "gapConfig"))
                object.gapConfig = $root.streamlit.GapConfig.toObject(message.gapConfig, options, _depth + 1);
            return object;
        };

        /**
         * Converts this Column to JSON.
         * @function toJSON
         * @memberof Block.Column
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Column.prototype.toJSON = function() {
            return Column.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Column
         * @function getTypeUrl
         * @memberof Block.Column
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Column.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.Column";
        };

        /**
         * VerticalAlignment enum.
         * @name Block.Column.VerticalAlignment
         * @enum {number}
         * @property {number} TOP=0 TOP value
         * @property {number} CENTER=1 CENTER value
         * @property {number} BOTTOM=2 BOTTOM value
         */
        Column.VerticalAlignment = (function() {
            const valuesById = $Object.create(null), values = $Object.create(valuesById);
            values[valuesById[0] = "TOP"] = 0;
            values[valuesById[1] = "CENTER"] = 1;
            values[valuesById[2] = "BOTTOM"] = 2;
            return values;
        })();

        return Column;
    })();

    Block.Expandable = (function() {

        /**
         * Properties of an Expandable.
         * @typedef {Object} Block.Expandable.$Properties
         * @property {string|null} [label] Expandable label
         * @property {boolean|null} [expanded] Expandable expanded
         * @property {string|null} [icon] Expandable icon
         * @property {string|null} [id] Expandable id
         * @property {Block.Expandable.Type|null} [type] Expandable type
         * @property {Block.Expandable.State|null} [state] Expandable state
         * @property {string|null} [queryParamKey] Expandable queryParamKey
         * @property {boolean|null} [defaultExpanded] Expandable defaultExpanded
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an Expandable.
         * @memberof Block
         * @interface IExpandable
         * @augments Block.Expandable.$Properties
         * @deprecated Use Block.Expandable.$Properties instead.
         */

        /**
         * Shape of an Expandable.
         * @typedef {Block.Expandable.$Properties} Block.Expandable.$Shape
         */

        /**
         * Constructs a new Expandable.
         * @memberof Block
         * @classdesc Represents an Expandable.
         * @constructor
         * @param {Block.Expandable.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Expandable = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Expandable label.
         * @member {string} label
         * @memberof Block.Expandable
         * @instance
         */
        Expandable.prototype.label = "";

        /**
         * Expandable expanded.
         * @member {boolean|null|undefined} expanded
         * @memberof Block.Expandable
         * @instance
         */
        Expandable.prototype.expanded = null;

        /**
         * Expandable icon.
         * @member {string} icon
         * @memberof Block.Expandable
         * @instance
         */
        Expandable.prototype.icon = "";

        /**
         * Expandable id.
         * @member {string|null|undefined} id
         * @memberof Block.Expandable
         * @instance
         */
        Expandable.prototype.id = null;

        /**
         * Expandable type.
         * @member {Block.Expandable.Type} type
         * @memberof Block.Expandable
         * @instance
         */
        Expandable.prototype.type = 0;

        /**
         * Expandable state.
         * @member {Block.Expandable.State} state
         * @memberof Block.Expandable
         * @instance
         */
        Expandable.prototype.state = 0;

        /**
         * Expandable queryParamKey.
         * @member {string|null|undefined} queryParamKey
         * @memberof Block.Expandable
         * @instance
         */
        Expandable.prototype.queryParamKey = null;

        /**
         * Expandable defaultExpanded.
         * @member {boolean|null|undefined} defaultExpanded
         * @memberof Block.Expandable
         * @instance
         */
        Expandable.prototype.defaultExpanded = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(Expandable.prototype, "_expanded", {
            get: $util.oneOfGetter($oneOfFields = ["expanded"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(Expandable.prototype, "_id", {
            get: $util.oneOfGetter($oneOfFields = ["id"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(Expandable.prototype, "_queryParamKey", {
            get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(Expandable.prototype, "_defaultExpanded", {
            get: $util.oneOfGetter($oneOfFields = ["defaultExpanded"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Expandable instance using the specified properties.
         * @function create
         * @memberof Block.Expandable
         * @static
         * @param {Block.Expandable.$Properties=} [properties] Properties to set
         * @returns {Block.Expandable} Expandable instance
         * @type {{
         *   (properties: Block.Expandable.$Shape): Block.Expandable & Block.Expandable.$Shape;
         *   (properties?: Block.Expandable.$Properties): Block.Expandable;
         * }}
         */
        Expandable.create = function(properties) {
            return new Expandable(properties);
        };

        /**
         * Encodes the specified Expandable message. Does not implicitly {@link Block.Expandable.verify|verify} messages.
         * @function encode
         * @memberof Block.Expandable
         * @static
         * @param {Block.Expandable.$Properties} message Expandable message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Expandable.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.label);
            if (message.expanded != null && $Object.hasOwnProperty.call(message, "expanded"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.expanded);
            if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.icon);
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.id);
            if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== 0)
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
            if (message.state != null && $Object.hasOwnProperty.call(message, "state") && message.state !== 0)
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.state);
            if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.queryParamKey);
            if (message.defaultExpanded != null && $Object.hasOwnProperty.call(message, "defaultExpanded"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.defaultExpanded);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes an Expandable message from the specified reader or buffer.
         * @function decode
         * @memberof Block.Expandable
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.Expandable & Block.Expandable.$Shape} Expandable
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Expandable.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.Expandable();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.label = value;
                        else
                            delete message.label;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        message.expanded = reader.bool();
                        message._expanded = "expanded";
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.icon = value;
                        else
                            delete message.icon;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.id = reader.stringVerify();
                        message._id = "id";
                        continue;
                    }
                case 5: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.type = value;
                        else
                            delete message.type;
                        continue;
                    }
                case 6: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.state = value;
                        else
                            delete message.state;
                        continue;
                    }
                case 7: {
                        if (wireType !== 2)
                            break;
                        message.queryParamKey = reader.stringVerify();
                        message._queryParamKey = "queryParamKey";
                        continue;
                    }
                case 8: {
                        if (wireType !== 0)
                            break;
                        message.defaultExpanded = reader.bool();
                        message._defaultExpanded = "defaultExpanded";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates an Expandable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.Expandable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.Expandable} Expandable
         */
        Expandable.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.Expandable)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.Expandable: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.Expandable();
            if (object.label != null)
                if (typeof object.label !== "string" || object.label.length)
                    message.label = $String(object.label);
            if (object.expanded != null)
                message.expanded = $Boolean(object.expanded);
            if (object.icon != null)
                if (typeof object.icon !== "string" || object.icon.length)
                    message.icon = $String(object.icon);
            if (object.id != null)
                message.id = $String(object.id);
            if (object.type !== 0 && (typeof object.type !== "string" || $root.Block.Expandable.Type[object.type] !== 0))
                switch (object.type) {
                case "DEFAULT":
                case 0:
                    message.type = 0;
                    break;
                case "COMPACT":
                case 1:
                    message.type = 1;
                    break;
                case "STEP":
                case 2:
                    message.type = 2;
                    break;
                default:
                    if (typeof object.type === "number" && (object.type | 0) === object.type)
                        message.type = object.type;
                }
            if (object.state !== 0 && (typeof object.state !== "string" || $root.Block.Expandable.State[object.state] !== 0))
                switch (object.state) {
                case "STATE_UNDEFINED":
                case 0:
                    message.state = 0;
                    break;
                case "RUNNING":
                case 1:
                    message.state = 1;
                    break;
                case "COMPLETE":
                case 2:
                    message.state = 2;
                    break;
                case "ERROR":
                case 3:
                    message.state = 3;
                    break;
                default:
                    if (typeof object.state === "number" && (object.state | 0) === object.state)
                        message.state = object.state;
                }
            if (object.queryParamKey != null)
                message.queryParamKey = $String(object.queryParamKey);
            if (object.defaultExpanded != null)
                message.defaultExpanded = $Boolean(object.defaultExpanded);
            return message;
        };

        /**
         * Creates a plain object from an Expandable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.Expandable
         * @static
         * @param {Block.Expandable} message Expandable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Expandable.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.label = "";
                object.icon = "";
                object.type = options.enums === $String ? "DEFAULT" : 0;
                object.state = options.enums === $String ? "STATE_UNDEFINED" : 0;
            }
            if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
                object.label = message.label;
            if (message.expanded != null && $Object.hasOwnProperty.call(message, "expanded"))
                object.expanded = message.expanded;
            if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
                object.icon = message.icon;
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                object.id = message.id;
            if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
                object.type = options.enums === $String ? $root.Block.Expandable.Type[message.type] === $undefined ? message.type : $root.Block.Expandable.Type[message.type] : message.type;
            if (message.state != null && $Object.hasOwnProperty.call(message, "state"))
                object.state = options.enums === $String ? $root.Block.Expandable.State[message.state] === $undefined ? message.state : $root.Block.Expandable.State[message.state] : message.state;
            if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
                object.queryParamKey = message.queryParamKey;
            if (message.defaultExpanded != null && $Object.hasOwnProperty.call(message, "defaultExpanded"))
                object.defaultExpanded = message.defaultExpanded;
            return object;
        };

        /**
         * Converts this Expandable to JSON.
         * @function toJSON
         * @memberof Block.Expandable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Expandable.prototype.toJSON = function() {
            return Expandable.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Expandable
         * @function getTypeUrl
         * @memberof Block.Expandable
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Expandable.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.Expandable";
        };

        /**
         * Type enum.
         * @name Block.Expandable.Type
         * @enum {number}
         * @property {number} DEFAULT=0 DEFAULT value
         * @property {number} COMPACT=1 COMPACT value
         * @property {number} STEP=2 STEP value
         */
        Expandable.Type = (function() {
            const valuesById = $Object.create(null), values = $Object.create(valuesById);
            values[valuesById[0] = "DEFAULT"] = 0;
            values[valuesById[1] = "COMPACT"] = 1;
            values[valuesById[2] = "STEP"] = 2;
            return values;
        })();

        /**
         * State enum.
         * @name Block.Expandable.State
         * @enum {number}
         * @property {number} STATE_UNDEFINED=0 STATE_UNDEFINED value
         * @property {number} RUNNING=1 RUNNING value
         * @property {number} COMPLETE=2 COMPLETE value
         * @property {number} ERROR=3 ERROR value
         */
        Expandable.State = (function() {
            const valuesById = $Object.create(null), values = $Object.create(valuesById);
            values[valuesById[0] = "STATE_UNDEFINED"] = 0;
            values[valuesById[1] = "RUNNING"] = 1;
            values[valuesById[2] = "COMPLETE"] = 2;
            values[valuesById[3] = "ERROR"] = 3;
            return values;
        })();

        return Expandable;
    })();

    Block.Dialog = (function() {

        /**
         * Properties of a Dialog.
         * @typedef {Object} Block.Dialog.$Properties
         * @property {string|null} [title] Dialog title
         * @property {boolean|null} [dismissible] Dialog dismissible
         * @property {Block.Dialog.DialogWidth|null} [width] Dialog width
         * @property {boolean|null} [isOpen] Dialog isOpen
         * @property {string|null} [id] Dialog id
         * @property {string|null} [icon] Dialog icon
         * @property {Block.Dialog.DialogPosition|null} [position] Dialog position
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Dialog.
         * @memberof Block
         * @interface IDialog
         * @augments Block.Dialog.$Properties
         * @deprecated Use Block.Dialog.$Properties instead.
         */

        /**
         * Shape of a Dialog.
         * @typedef {Block.Dialog.$Properties} Block.Dialog.$Shape
         */

        /**
         * Constructs a new Dialog.
         * @memberof Block
         * @classdesc Represents a Dialog.
         * @constructor
         * @param {Block.Dialog.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Dialog = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Dialog title.
         * @member {string} title
         * @memberof Block.Dialog
         * @instance
         */
        Dialog.prototype.title = "";

        /**
         * Dialog dismissible.
         * @member {boolean} dismissible
         * @memberof Block.Dialog
         * @instance
         */
        Dialog.prototype.dismissible = false;

        /**
         * Dialog width.
         * @member {Block.Dialog.DialogWidth} width
         * @memberof Block.Dialog
         * @instance
         */
        Dialog.prototype.width = 0;

        /**
         * Dialog isOpen.
         * @member {boolean|null|undefined} isOpen
         * @memberof Block.Dialog
         * @instance
         */
        Dialog.prototype.isOpen = null;

        /**
         * Dialog id.
         * @member {string} id
         * @memberof Block.Dialog
         * @instance
         */
        Dialog.prototype.id = "";

        /**
         * Dialog icon.
         * @member {string} icon
         * @memberof Block.Dialog
         * @instance
         */
        Dialog.prototype.icon = "";

        /**
         * Dialog position.
         * @member {Block.Dialog.DialogPosition} position
         * @memberof Block.Dialog
         * @instance
         */
        Dialog.prototype.position = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(Dialog.prototype, "_isOpen", {
            get: $util.oneOfGetter($oneOfFields = ["isOpen"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Dialog instance using the specified properties.
         * @function create
         * @memberof Block.Dialog
         * @static
         * @param {Block.Dialog.$Properties=} [properties] Properties to set
         * @returns {Block.Dialog} Dialog instance
         * @type {{
         *   (properties: Block.Dialog.$Shape): Block.Dialog & Block.Dialog.$Shape;
         *   (properties?: Block.Dialog.$Properties): Block.Dialog;
         * }}
         */
        Dialog.create = function(properties) {
            return new Dialog(properties);
        };

        /**
         * Encodes the specified Dialog message. Does not implicitly {@link Block.Dialog.verify|verify} messages.
         * @function encode
         * @memberof Block.Dialog
         * @static
         * @param {Block.Dialog.$Properties} message Dialog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Dialog.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.title != null && $Object.hasOwnProperty.call(message, "title") && message.title !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
            if (message.dismissible != null && $Object.hasOwnProperty.call(message, "dismissible") && message.dismissible !== false)
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.dismissible);
            if (message.width != null && $Object.hasOwnProperty.call(message, "width") && message.width !== 0)
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.width);
            if (message.isOpen != null && $Object.hasOwnProperty.call(message, "isOpen"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isOpen);
            if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.id);
            if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.icon);
            if (message.position != null && $Object.hasOwnProperty.call(message, "position") && message.position !== 0)
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.position);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a Dialog message from the specified reader or buffer.
         * @function decode
         * @memberof Block.Dialog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.Dialog & Block.Dialog.$Shape} Dialog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Dialog.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.Dialog();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.title = value;
                        else
                            delete message.title;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.dismissible = value;
                        else
                            delete message.dismissible;
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.width = value;
                        else
                            delete message.width;
                        continue;
                    }
                case 4: {
                        if (wireType !== 0)
                            break;
                        message.isOpen = reader.bool();
                        message._isOpen = "isOpen";
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.id = value;
                        else
                            delete message.id;
                        continue;
                    }
                case 6: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.icon = value;
                        else
                            delete message.icon;
                        continue;
                    }
                case 7: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.position = value;
                        else
                            delete message.position;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a Dialog message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.Dialog
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.Dialog} Dialog
         */
        Dialog.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.Dialog)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.Dialog: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.Dialog();
            if (object.title != null)
                if (typeof object.title !== "string" || object.title.length)
                    message.title = $String(object.title);
            if (object.dismissible != null)
                if (object.dismissible)
                    message.dismissible = $Boolean(object.dismissible);
            if (object.width !== 0 && (typeof object.width !== "string" || $root.Block.Dialog.DialogWidth[object.width] !== 0))
                switch (object.width) {
                case "SMALL":
                case 0:
                    message.width = 0;
                    break;
                case "LARGE":
                case 1:
                    message.width = 1;
                    break;
                case "MEDIUM":
                case 2:
                    message.width = 2;
                    break;
                default:
                    if (typeof object.width === "number" && (object.width | 0) === object.width)
                        message.width = object.width;
                }
            if (object.isOpen != null)
                message.isOpen = $Boolean(object.isOpen);
            if (object.id != null)
                if (typeof object.id !== "string" || object.id.length)
                    message.id = $String(object.id);
            if (object.icon != null)
                if (typeof object.icon !== "string" || object.icon.length)
                    message.icon = $String(object.icon);
            if (object.position !== 0 && (typeof object.position !== "string" || $root.Block.Dialog.DialogPosition[object.position] !== 0))
                switch (object.position) {
                case "CENTER":
                case 0:
                    message.position = 0;
                    break;
                case "LEFT":
                case 1:
                    message.position = 1;
                    break;
                case "RIGHT":
                case 2:
                    message.position = 2;
                    break;
                default:
                    if (typeof object.position === "number" && (object.position | 0) === object.position)
                        message.position = object.position;
                }
            return message;
        };

        /**
         * Creates a plain object from a Dialog message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.Dialog
         * @static
         * @param {Block.Dialog} message Dialog
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Dialog.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.title = "";
                object.dismissible = false;
                object.width = options.enums === $String ? "SMALL" : 0;
                object.id = "";
                object.icon = "";
                object.position = options.enums === $String ? "CENTER" : 0;
            }
            if (message.title != null && $Object.hasOwnProperty.call(message, "title"))
                object.title = message.title;
            if (message.dismissible != null && $Object.hasOwnProperty.call(message, "dismissible"))
                object.dismissible = message.dismissible;
            if (message.width != null && $Object.hasOwnProperty.call(message, "width"))
                object.width = options.enums === $String ? $root.Block.Dialog.DialogWidth[message.width] === $undefined ? message.width : $root.Block.Dialog.DialogWidth[message.width] : message.width;
            if (message.isOpen != null && $Object.hasOwnProperty.call(message, "isOpen"))
                object.isOpen = message.isOpen;
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                object.id = message.id;
            if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
                object.icon = message.icon;
            if (message.position != null && $Object.hasOwnProperty.call(message, "position"))
                object.position = options.enums === $String ? $root.Block.Dialog.DialogPosition[message.position] === $undefined ? message.position : $root.Block.Dialog.DialogPosition[message.position] : message.position;
            return object;
        };

        /**
         * Converts this Dialog to JSON.
         * @function toJSON
         * @memberof Block.Dialog
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Dialog.prototype.toJSON = function() {
            return Dialog.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Dialog
         * @function getTypeUrl
         * @memberof Block.Dialog
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Dialog.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.Dialog";
        };

        /**
         * DialogWidth enum.
         * @name Block.Dialog.DialogWidth
         * @enum {number}
         * @property {number} SMALL=0 SMALL value
         * @property {number} LARGE=1 LARGE value
         * @property {number} MEDIUM=2 MEDIUM value
         */
        Dialog.DialogWidth = (function() {
            const valuesById = $Object.create(null), values = $Object.create(valuesById);
            values[valuesById[0] = "SMALL"] = 0;
            values[valuesById[1] = "LARGE"] = 1;
            values[valuesById[2] = "MEDIUM"] = 2;
            return values;
        })();

        /**
         * DialogPosition enum.
         * @name Block.Dialog.DialogPosition
         * @enum {number}
         * @property {number} CENTER=0 CENTER value
         * @property {number} LEFT=1 LEFT value
         * @property {number} RIGHT=2 RIGHT value
         */
        Dialog.DialogPosition = (function() {
            const valuesById = $Object.create(null), values = $Object.create(valuesById);
            values[valuesById[0] = "CENTER"] = 0;
            values[valuesById[1] = "LEFT"] = 1;
            values[valuesById[2] = "RIGHT"] = 2;
            return values;
        })();

        return Dialog;
    })();

    Block.Form = (function() {

        /**
         * Properties of a Form.
         * @typedef {Object} Block.Form.$Properties
         * @property {string|null} [formId] Form formId
         * @property {boolean|null} [clearOnSubmit] Form clearOnSubmit
         * @property {boolean|null} [border] Form border
         * @property {boolean|null} [enterToSubmit] Form enterToSubmit
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Form.
         * @memberof Block
         * @interface IForm
         * @augments Block.Form.$Properties
         * @deprecated Use Block.Form.$Properties instead.
         */

        /**
         * Shape of a Form.
         * @typedef {Block.Form.$Properties} Block.Form.$Shape
         */

        /**
         * Constructs a new Form.
         * @memberof Block
         * @classdesc Represents a Form.
         * @constructor
         * @param {Block.Form.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Form = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Form formId.
         * @member {string} formId
         * @memberof Block.Form
         * @instance
         */
        Form.prototype.formId = "";

        /**
         * Form clearOnSubmit.
         * @member {boolean} clearOnSubmit
         * @memberof Block.Form
         * @instance
         */
        Form.prototype.clearOnSubmit = false;

        /**
         * Form border.
         * @member {boolean} border
         * @memberof Block.Form
         * @instance
         */
        Form.prototype.border = false;

        /**
         * Form enterToSubmit.
         * @member {boolean} enterToSubmit
         * @memberof Block.Form
         * @instance
         */
        Form.prototype.enterToSubmit = false;

        /**
         * Creates a new Form instance using the specified properties.
         * @function create
         * @memberof Block.Form
         * @static
         * @param {Block.Form.$Properties=} [properties] Properties to set
         * @returns {Block.Form} Form instance
         * @type {{
         *   (properties: Block.Form.$Shape): Block.Form & Block.Form.$Shape;
         *   (properties?: Block.Form.$Properties): Block.Form;
         * }}
         */
        Form.create = function(properties) {
            return new Form(properties);
        };

        /**
         * Encodes the specified Form message. Does not implicitly {@link Block.Form.verify|verify} messages.
         * @function encode
         * @memberof Block.Form
         * @static
         * @param {Block.Form.$Properties} message Form message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Form.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.formId);
            if (message.clearOnSubmit != null && $Object.hasOwnProperty.call(message, "clearOnSubmit") && message.clearOnSubmit !== false)
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.clearOnSubmit);
            if (message.border != null && $Object.hasOwnProperty.call(message, "border") && message.border !== false)
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.border);
            if (message.enterToSubmit != null && $Object.hasOwnProperty.call(message, "enterToSubmit") && message.enterToSubmit !== false)
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.enterToSubmit);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a Form message from the specified reader or buffer.
         * @function decode
         * @memberof Block.Form
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.Form & Block.Form.$Shape} Form
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Form.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.Form();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.formId = value;
                        else
                            delete message.formId;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.clearOnSubmit = value;
                        else
                            delete message.clearOnSubmit;
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.border = value;
                        else
                            delete message.border;
                        continue;
                    }
                case 4: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.enterToSubmit = value;
                        else
                            delete message.enterToSubmit;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a Form message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.Form
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.Form} Form
         */
        Form.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.Form)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.Form: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.Form();
            if (object.formId != null)
                if (typeof object.formId !== "string" || object.formId.length)
                    message.formId = $String(object.formId);
            if (object.clearOnSubmit != null)
                if (object.clearOnSubmit)
                    message.clearOnSubmit = $Boolean(object.clearOnSubmit);
            if (object.border != null)
                if (object.border)
                    message.border = $Boolean(object.border);
            if (object.enterToSubmit != null)
                if (object.enterToSubmit)
                    message.enterToSubmit = $Boolean(object.enterToSubmit);
            return message;
        };

        /**
         * Creates a plain object from a Form message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.Form
         * @static
         * @param {Block.Form} message Form
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Form.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.formId = "";
                object.clearOnSubmit = false;
                object.border = false;
                object.enterToSubmit = false;
            }
            if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
                object.formId = message.formId;
            if (message.clearOnSubmit != null && $Object.hasOwnProperty.call(message, "clearOnSubmit"))
                object.clearOnSubmit = message.clearOnSubmit;
            if (message.border != null && $Object.hasOwnProperty.call(message, "border"))
                object.border = message.border;
            if (message.enterToSubmit != null && $Object.hasOwnProperty.call(message, "enterToSubmit"))
                object.enterToSubmit = message.enterToSubmit;
            return object;
        };

        /**
         * Converts this Form to JSON.
         * @function toJSON
         * @memberof Block.Form
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Form.prototype.toJSON = function() {
            return Form.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Form
         * @function getTypeUrl
         * @memberof Block.Form
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Form.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.Form";
        };

        return Form;
    })();

    Block.TabContainer = (function() {

        /**
         * Properties of a TabContainer.
         * @typedef {Object} Block.TabContainer.$Properties
         * @property {number|null} [defaultTabIndex] TabContainer defaultTabIndex
         * @property {string|null} [id] TabContainer id
         * @property {string|null} [queryParamKey] TabContainer queryParamKey
         * @property {string|null} [defaultTabLabel] TabContainer defaultTabLabel
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a TabContainer.
         * @memberof Block
         * @interface ITabContainer
         * @augments Block.TabContainer.$Properties
         * @deprecated Use Block.TabContainer.$Properties instead.
         */

        /**
         * Shape of a TabContainer.
         * @typedef {Block.TabContainer.$Properties} Block.TabContainer.$Shape
         */

        /**
         * Constructs a new TabContainer.
         * @memberof Block
         * @classdesc Represents a TabContainer.
         * @constructor
         * @param {Block.TabContainer.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const TabContainer = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * TabContainer defaultTabIndex.
         * @member {number} defaultTabIndex
         * @memberof Block.TabContainer
         * @instance
         */
        TabContainer.prototype.defaultTabIndex = 0;

        /**
         * TabContainer id.
         * @member {string|null|undefined} id
         * @memberof Block.TabContainer
         * @instance
         */
        TabContainer.prototype.id = null;

        /**
         * TabContainer queryParamKey.
         * @member {string|null|undefined} queryParamKey
         * @memberof Block.TabContainer
         * @instance
         */
        TabContainer.prototype.queryParamKey = null;

        /**
         * TabContainer defaultTabLabel.
         * @member {string|null|undefined} defaultTabLabel
         * @memberof Block.TabContainer
         * @instance
         */
        TabContainer.prototype.defaultTabLabel = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(TabContainer.prototype, "_id", {
            get: $util.oneOfGetter($oneOfFields = ["id"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(TabContainer.prototype, "_queryParamKey", {
            get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(TabContainer.prototype, "_defaultTabLabel", {
            get: $util.oneOfGetter($oneOfFields = ["defaultTabLabel"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new TabContainer instance using the specified properties.
         * @function create
         * @memberof Block.TabContainer
         * @static
         * @param {Block.TabContainer.$Properties=} [properties] Properties to set
         * @returns {Block.TabContainer} TabContainer instance
         * @type {{
         *   (properties: Block.TabContainer.$Shape): Block.TabContainer & Block.TabContainer.$Shape;
         *   (properties?: Block.TabContainer.$Properties): Block.TabContainer;
         * }}
         */
        TabContainer.create = function(properties) {
            return new TabContainer(properties);
        };

        /**
         * Encodes the specified TabContainer message. Does not implicitly {@link Block.TabContainer.verify|verify} messages.
         * @function encode
         * @memberof Block.TabContainer
         * @static
         * @param {Block.TabContainer.$Properties} message TabContainer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TabContainer.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.defaultTabIndex != null && $Object.hasOwnProperty.call(message, "defaultTabIndex") && message.defaultTabIndex !== 0)
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.defaultTabIndex);
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.id);
            if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.queryParamKey);
            if (message.defaultTabLabel != null && $Object.hasOwnProperty.call(message, "defaultTabLabel"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.defaultTabLabel);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a TabContainer message from the specified reader or buffer.
         * @function decode
         * @memberof Block.TabContainer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.TabContainer & Block.TabContainer.$Shape} TabContainer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TabContainer.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.TabContainer();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.defaultTabIndex = value;
                        else
                            delete message.defaultTabIndex;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        message.id = reader.stringVerify();
                        message._id = "id";
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        message.queryParamKey = reader.stringVerify();
                        message._queryParamKey = "queryParamKey";
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.defaultTabLabel = reader.stringVerify();
                        message._defaultTabLabel = "defaultTabLabel";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a TabContainer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.TabContainer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.TabContainer} TabContainer
         */
        TabContainer.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.TabContainer)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.TabContainer: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.TabContainer();
            if (object.defaultTabIndex != null)
                if ($Number(object.defaultTabIndex) !== 0)
                    message.defaultTabIndex = object.defaultTabIndex | 0;
            if (object.id != null)
                message.id = $String(object.id);
            if (object.queryParamKey != null)
                message.queryParamKey = $String(object.queryParamKey);
            if (object.defaultTabLabel != null)
                message.defaultTabLabel = $String(object.defaultTabLabel);
            return message;
        };

        /**
         * Creates a plain object from a TabContainer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.TabContainer
         * @static
         * @param {Block.TabContainer} message TabContainer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TabContainer.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.defaultTabIndex = 0;
            if (message.defaultTabIndex != null && $Object.hasOwnProperty.call(message, "defaultTabIndex"))
                object.defaultTabIndex = message.defaultTabIndex;
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                object.id = message.id;
            if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
                object.queryParamKey = message.queryParamKey;
            if (message.defaultTabLabel != null && $Object.hasOwnProperty.call(message, "defaultTabLabel"))
                object.defaultTabLabel = message.defaultTabLabel;
            return object;
        };

        /**
         * Converts this TabContainer to JSON.
         * @function toJSON
         * @memberof Block.TabContainer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TabContainer.prototype.toJSON = function() {
            return TabContainer.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for TabContainer
         * @function getTypeUrl
         * @memberof Block.TabContainer
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        TabContainer.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.TabContainer";
        };

        return TabContainer;
    })();

    Block.Tab = (function() {

        /**
         * Properties of a Tab.
         * @typedef {Object} Block.Tab.$Properties
         * @property {string|null} [label] Tab label
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Tab.
         * @memberof Block
         * @interface ITab
         * @augments Block.Tab.$Properties
         * @deprecated Use Block.Tab.$Properties instead.
         */

        /**
         * Shape of a Tab.
         * @typedef {Block.Tab.$Properties} Block.Tab.$Shape
         */

        /**
         * Constructs a new Tab.
         * @memberof Block
         * @classdesc Represents a Tab.
         * @constructor
         * @param {Block.Tab.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Tab = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Tab label.
         * @member {string} label
         * @memberof Block.Tab
         * @instance
         */
        Tab.prototype.label = "";

        /**
         * Creates a new Tab instance using the specified properties.
         * @function create
         * @memberof Block.Tab
         * @static
         * @param {Block.Tab.$Properties=} [properties] Properties to set
         * @returns {Block.Tab} Tab instance
         * @type {{
         *   (properties: Block.Tab.$Shape): Block.Tab & Block.Tab.$Shape;
         *   (properties?: Block.Tab.$Properties): Block.Tab;
         * }}
         */
        Tab.create = function(properties) {
            return new Tab(properties);
        };

        /**
         * Encodes the specified Tab message. Does not implicitly {@link Block.Tab.verify|verify} messages.
         * @function encode
         * @memberof Block.Tab
         * @static
         * @param {Block.Tab.$Properties} message Tab message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Tab.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.label);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a Tab message from the specified reader or buffer.
         * @function decode
         * @memberof Block.Tab
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.Tab & Block.Tab.$Shape} Tab
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Tab.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.Tab();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.label = value;
                        else
                            delete message.label;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a Tab message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.Tab
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.Tab} Tab
         */
        Tab.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.Tab)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.Tab: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.Tab();
            if (object.label != null)
                if (typeof object.label !== "string" || object.label.length)
                    message.label = $String(object.label);
            return message;
        };

        /**
         * Creates a plain object from a Tab message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.Tab
         * @static
         * @param {Block.Tab} message Tab
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Tab.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.label = "";
            if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
                object.label = message.label;
            return object;
        };

        /**
         * Converts this Tab to JSON.
         * @function toJSON
         * @memberof Block.Tab
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Tab.prototype.toJSON = function() {
            return Tab.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Tab
         * @function getTypeUrl
         * @memberof Block.Tab
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Tab.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.Tab";
        };

        return Tab;
    })();

    Block.Popover = (function() {

        /**
         * Properties of a Popover.
         * @typedef {Object} Block.Popover.$Properties
         * @property {string|null} [label] Popover label
         * @property {string|null} [help] Popover help
         * @property {boolean|null} [disabled] Popover disabled
         * @property {string|null} [icon] Popover icon
         * @property {string|null} [type] Popover type
         * @property {boolean|null} [open] Popover open
         * @property {string|null} [id] Popover id
         * @property {boolean|null} [wrap] Popover wrap
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Popover.
         * @memberof Block
         * @interface IPopover
         * @augments Block.Popover.$Properties
         * @deprecated Use Block.Popover.$Properties instead.
         */

        /**
         * Shape of a Popover.
         * @typedef {Block.Popover.$Properties} Block.Popover.$Shape
         */

        /**
         * Constructs a new Popover.
         * @memberof Block
         * @classdesc Represents a Popover.
         * @constructor
         * @param {Block.Popover.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Popover = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Popover label.
         * @member {string} label
         * @memberof Block.Popover
         * @instance
         */
        Popover.prototype.label = "";

        /**
         * Popover help.
         * @member {string} help
         * @memberof Block.Popover
         * @instance
         */
        Popover.prototype.help = "";

        /**
         * Popover disabled.
         * @member {boolean} disabled
         * @memberof Block.Popover
         * @instance
         */
        Popover.prototype.disabled = false;

        /**
         * Popover icon.
         * @member {string} icon
         * @memberof Block.Popover
         * @instance
         */
        Popover.prototype.icon = "";

        /**
         * Popover type.
         * @member {string} type
         * @memberof Block.Popover
         * @instance
         */
        Popover.prototype.type = "";

        /**
         * Popover open.
         * @member {boolean|null|undefined} open
         * @memberof Block.Popover
         * @instance
         */
        Popover.prototype.open = null;

        /**
         * Popover id.
         * @member {string|null|undefined} id
         * @memberof Block.Popover
         * @instance
         */
        Popover.prototype.id = null;

        /**
         * Popover wrap.
         * @member {boolean|null|undefined} wrap
         * @memberof Block.Popover
         * @instance
         */
        Popover.prototype.wrap = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(Popover.prototype, "_open", {
            get: $util.oneOfGetter($oneOfFields = ["open"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(Popover.prototype, "_id", {
            get: $util.oneOfGetter($oneOfFields = ["id"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(Popover.prototype, "_wrap", {
            get: $util.oneOfGetter($oneOfFields = ["wrap"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Popover instance using the specified properties.
         * @function create
         * @memberof Block.Popover
         * @static
         * @param {Block.Popover.$Properties=} [properties] Properties to set
         * @returns {Block.Popover} Popover instance
         * @type {{
         *   (properties: Block.Popover.$Shape): Block.Popover & Block.Popover.$Shape;
         *   (properties?: Block.Popover.$Properties): Block.Popover;
         * }}
         */
        Popover.create = function(properties) {
            return new Popover(properties);
        };

        /**
         * Encodes the specified Popover message. Does not implicitly {@link Block.Popover.verify|verify} messages.
         * @function encode
         * @memberof Block.Popover
         * @static
         * @param {Block.Popover.$Properties} message Popover message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Popover.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.label);
            if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.help);
            if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.disabled);
            if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.icon);
            if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== "")
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.type);
            if (message.open != null && $Object.hasOwnProperty.call(message, "open"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.open);
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.id);
            if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.wrap);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a Popover message from the specified reader or buffer.
         * @function decode
         * @memberof Block.Popover
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.Popover & Block.Popover.$Shape} Popover
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Popover.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.Popover();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.label = value;
                        else
                            delete message.label;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.help = value;
                        else
                            delete message.help;
                        continue;
                    }
                case 4: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.disabled = value;
                        else
                            delete message.disabled;
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.icon = value;
                        else
                            delete message.icon;
                        continue;
                    }
                case 6: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.type = value;
                        else
                            delete message.type;
                        continue;
                    }
                case 7: {
                        if (wireType !== 0)
                            break;
                        message.open = reader.bool();
                        message._open = "open";
                        continue;
                    }
                case 8: {
                        if (wireType !== 2)
                            break;
                        message.id = reader.stringVerify();
                        message._id = "id";
                        continue;
                    }
                case 9: {
                        if (wireType !== 0)
                            break;
                        message.wrap = reader.bool();
                        message._wrap = "wrap";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a Popover message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.Popover
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.Popover} Popover
         */
        Popover.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.Popover)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.Popover: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.Popover();
            if (object.label != null)
                if (typeof object.label !== "string" || object.label.length)
                    message.label = $String(object.label);
            if (object.help != null)
                if (typeof object.help !== "string" || object.help.length)
                    message.help = $String(object.help);
            if (object.disabled != null)
                if (object.disabled)
                    message.disabled = $Boolean(object.disabled);
            if (object.icon != null)
                if (typeof object.icon !== "string" || object.icon.length)
                    message.icon = $String(object.icon);
            if (object.type != null)
                if (typeof object.type !== "string" || object.type.length)
                    message.type = $String(object.type);
            if (object.open != null)
                message.open = $Boolean(object.open);
            if (object.id != null)
                message.id = $String(object.id);
            if (object.wrap != null)
                message.wrap = $Boolean(object.wrap);
            return message;
        };

        /**
         * Creates a plain object from a Popover message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.Popover
         * @static
         * @param {Block.Popover} message Popover
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Popover.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.label = "";
                object.help = "";
                object.disabled = false;
                object.icon = "";
                object.type = "";
            }
            if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
                object.label = message.label;
            if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
                object.help = message.help;
            if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
                object.disabled = message.disabled;
            if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
                object.icon = message.icon;
            if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
                object.type = message.type;
            if (message.open != null && $Object.hasOwnProperty.call(message, "open"))
                object.open = message.open;
            if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
                object.id = message.id;
            if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
                object.wrap = message.wrap;
            return object;
        };

        /**
         * Converts this Popover to JSON.
         * @function toJSON
         * @memberof Block.Popover
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Popover.prototype.toJSON = function() {
            return Popover.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Popover
         * @function getTypeUrl
         * @memberof Block.Popover
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Popover.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.Popover";
        };

        return Popover;
    })();

    Block.ChatMessage = (function() {

        /**
         * Properties of a ChatMessage.
         * @typedef {Object} Block.ChatMessage.$Properties
         * @property {string|null} [name] ChatMessage name
         * @property {string|null} [avatar] ChatMessage avatar
         * @property {Block.ChatMessage.AvatarType|null} [avatarType] ChatMessage avatarType
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a ChatMessage.
         * @memberof Block
         * @interface IChatMessage
         * @augments Block.ChatMessage.$Properties
         * @deprecated Use Block.ChatMessage.$Properties instead.
         */

        /**
         * Shape of a ChatMessage.
         * @typedef {Block.ChatMessage.$Properties} Block.ChatMessage.$Shape
         */

        /**
         * Constructs a new ChatMessage.
         * @memberof Block
         * @classdesc Represents a ChatMessage.
         * @constructor
         * @param {Block.ChatMessage.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const ChatMessage = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * ChatMessage name.
         * @member {string} name
         * @memberof Block.ChatMessage
         * @instance
         */
        ChatMessage.prototype.name = "";

        /**
         * ChatMessage avatar.
         * @member {string} avatar
         * @memberof Block.ChatMessage
         * @instance
         */
        ChatMessage.prototype.avatar = "";

        /**
         * ChatMessage avatarType.
         * @member {Block.ChatMessage.AvatarType} avatarType
         * @memberof Block.ChatMessage
         * @instance
         */
        ChatMessage.prototype.avatarType = 0;

        /**
         * Creates a new ChatMessage instance using the specified properties.
         * @function create
         * @memberof Block.ChatMessage
         * @static
         * @param {Block.ChatMessage.$Properties=} [properties] Properties to set
         * @returns {Block.ChatMessage} ChatMessage instance
         * @type {{
         *   (properties: Block.ChatMessage.$Shape): Block.ChatMessage & Block.ChatMessage.$Shape;
         *   (properties?: Block.ChatMessage.$Properties): Block.ChatMessage;
         * }}
         */
        ChatMessage.create = function(properties) {
            return new ChatMessage(properties);
        };

        /**
         * Encodes the specified ChatMessage message. Does not implicitly {@link Block.ChatMessage.verify|verify} messages.
         * @function encode
         * @memberof Block.ChatMessage
         * @static
         * @param {Block.ChatMessage.$Properties} message ChatMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMessage.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.avatar != null && $Object.hasOwnProperty.call(message, "avatar") && message.avatar !== "")
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
            if (message.avatarType != null && $Object.hasOwnProperty.call(message, "avatarType") && message.avatarType !== 0)
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.avatarType);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a ChatMessage message from the specified reader or buffer.
         * @function decode
         * @memberof Block.ChatMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.ChatMessage & Block.ChatMessage.$Shape} ChatMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMessage.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.ChatMessage();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.name = value;
                        else
                            delete message.name;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.avatar = value;
                        else
                            delete message.avatar;
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.avatarType = value;
                        else
                            delete message.avatarType;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a ChatMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.ChatMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.ChatMessage} ChatMessage
         */
        ChatMessage.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.ChatMessage)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.ChatMessage: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.Block.ChatMessage();
            if (object.name != null)
                if (typeof object.name !== "string" || object.name.length)
                    message.name = $String(object.name);
            if (object.avatar != null)
                if (typeof object.avatar !== "string" || object.avatar.length)
                    message.avatar = $String(object.avatar);
            if (object.avatarType !== 0 && (typeof object.avatarType !== "string" || $root.Block.ChatMessage.AvatarType[object.avatarType] !== 0))
                switch (object.avatarType) {
                case "IMAGE":
                case 0:
                    message.avatarType = 0;
                    break;
                case "EMOJI":
                case 1:
                    message.avatarType = 1;
                    break;
                case "ICON":
                case 2:
                    message.avatarType = 2;
                    break;
                default:
                    if (typeof object.avatarType === "number" && (object.avatarType | 0) === object.avatarType)
                        message.avatarType = object.avatarType;
                }
            return message;
        };

        /**
         * Creates a plain object from a ChatMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.ChatMessage
         * @static
         * @param {Block.ChatMessage} message ChatMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatMessage.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.name = "";
                object.avatar = "";
                object.avatarType = options.enums === $String ? "IMAGE" : 0;
            }
            if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
                object.name = message.name;
            if (message.avatar != null && $Object.hasOwnProperty.call(message, "avatar"))
                object.avatar = message.avatar;
            if (message.avatarType != null && $Object.hasOwnProperty.call(message, "avatarType"))
                object.avatarType = options.enums === $String ? $root.Block.ChatMessage.AvatarType[message.avatarType] === $undefined ? message.avatarType : $root.Block.ChatMessage.AvatarType[message.avatarType] : message.avatarType;
            return object;
        };

        /**
         * Converts this ChatMessage to JSON.
         * @function toJSON
         * @memberof Block.ChatMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatMessage.prototype.toJSON = function() {
            return ChatMessage.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for ChatMessage
         * @function getTypeUrl
         * @memberof Block.ChatMessage
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        ChatMessage.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.ChatMessage";
        };

        /**
         * AvatarType enum.
         * @name Block.ChatMessage.AvatarType
         * @enum {number}
         * @property {number} IMAGE=0 IMAGE value
         * @property {number} EMOJI=1 EMOJI value
         * @property {number} ICON=2 ICON value
         */
        ChatMessage.AvatarType = (function() {
            const valuesById = $Object.create(null), values = $Object.create(valuesById);
            values[valuesById[0] = "IMAGE"] = 0;
            values[valuesById[1] = "EMOJI"] = 1;
            values[valuesById[2] = "ICON"] = 2;
            return values;
        })();

        return ChatMessage;
    })();

    Block.Transparent = (function() {

        /**
         * Properties of a Transparent.
         * @typedef {Object} Block.Transparent.$Properties
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Transparent.
         * @memberof Block
         * @interface ITransparent
         * @augments Block.Transparent.$Properties
         * @deprecated Use Block.Transparent.$Properties instead.
         */

        /**
         * Shape of a Transparent.
         * @typedef {Block.Transparent.$Properties} Block.Transparent.$Shape
         */

        /**
         * Constructs a new Transparent.
         * @memberof Block
         * @classdesc Represents a Transparent.
         * @constructor
         * @param {Block.Transparent.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Transparent = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Creates a new Transparent instance using the specified properties.
         * @function create
         * @memberof Block.Transparent
         * @static
         * @param {Block.Transparent.$Properties=} [properties] Properties to set
         * @returns {Block.Transparent} Transparent instance
         * @type {{
         *   (properties: Block.Transparent.$Shape): Block.Transparent & Block.Transparent.$Shape;
         *   (properties?: Block.Transparent.$Properties): Block.Transparent;
         * }}
         */
        Transparent.create = function(properties) {
            return new Transparent(properties);
        };

        /**
         * Encodes the specified Transparent message. Does not implicitly {@link Block.Transparent.verify|verify} messages.
         * @function encode
         * @memberof Block.Transparent
         * @static
         * @param {Block.Transparent.$Properties} message Transparent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Transparent.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a Transparent message from the specified reader or buffer.
         * @function decode
         * @memberof Block.Transparent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Block.Transparent & Block.Transparent.$Shape} Transparent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Transparent.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.Block.Transparent();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                reader.skipType(tag & 7, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a Transparent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Block.Transparent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Block.Transparent} Transparent
         */
        Transparent.fromObject = function (object, _depth) {
            if (object instanceof $root.Block.Transparent)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".Block.Transparent: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            return new $root.Block.Transparent();
        };

        /**
         * Creates a plain object from a Transparent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Block.Transparent
         * @static
         * @param {Block.Transparent} message Transparent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Transparent.toObject = function () {
            return {};
        };

        /**
         * Converts this Transparent to JSON.
         * @function toJSON
         * @memberof Block.Transparent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Transparent.prototype.toJSON = function() {
            return Transparent.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Transparent
         * @function getTypeUrl
         * @memberof Block.Transparent
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Transparent.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/Block.Transparent";
        };

        return Transparent;
    })();

    return Block;
})();

export const Button = $root.Button = (() => {

    /**
     * Properties of a Button.
     * @typedef {Object} Button.$Properties
     * @property {string|null} [id] Button id
     * @property {string|null} [label] Button label
     * @property {boolean|null} ["default"] Button default
     * @property {string|null} [help] Button help
     * @property {string|null} [formId] Button formId
     * @property {boolean|null} [isFormSubmitter] Button isFormSubmitter
     * @property {string|null} [type] Button type
     * @property {boolean|null} [disabled] Button disabled
     * @property {string|null} [icon] Button icon
     * @property {string|null} [shortcut] Button shortcut
     * @property {streamlit.ButtonLikeIconPosition|null} [iconPosition] Button iconPosition
     * @property {boolean|null} [wrap] Button wrap
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Button.
     * @exports IButton
     * @interface IButton
     * @augments Button.$Properties
     * @deprecated Use Button.$Properties instead.
     */

    /**
     * Shape of a Button.
     * @typedef {Button.$Properties} Button.$Shape
     */

    /**
     * Constructs a new Button.
     * @exports Button
     * @classdesc Represents a Button.
     * @constructor
     * @param {Button.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Button = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Button id.
     * @member {string} id
     * @memberof Button
     * @instance
     */
    Button.prototype.id = "";

    /**
     * Button label.
     * @member {string} label
     * @memberof Button
     * @instance
     */
    Button.prototype.label = "";

    /**
     * Button default.
     * @member {boolean} default
     * @memberof Button
     * @instance
     */
    Button.prototype["default"] = false;

    /**
     * Button help.
     * @member {string} help
     * @memberof Button
     * @instance
     */
    Button.prototype.help = "";

    /**
     * Button formId.
     * @member {string} formId
     * @memberof Button
     * @instance
     */
    Button.prototype.formId = "";

    /**
     * Button isFormSubmitter.
     * @member {boolean} isFormSubmitter
     * @memberof Button
     * @instance
     */
    Button.prototype.isFormSubmitter = false;

    /**
     * Button type.
     * @member {string} type
     * @memberof Button
     * @instance
     */
    Button.prototype.type = "";

    /**
     * Button disabled.
     * @member {boolean} disabled
     * @memberof Button
     * @instance
     */
    Button.prototype.disabled = false;

    /**
     * Button icon.
     * @member {string} icon
     * @memberof Button
     * @instance
     */
    Button.prototype.icon = "";

    /**
     * Button shortcut.
     * @member {string} shortcut
     * @memberof Button
     * @instance
     */
    Button.prototype.shortcut = "";

    /**
     * Button iconPosition.
     * @member {streamlit.ButtonLikeIconPosition} iconPosition
     * @memberof Button
     * @instance
     */
    Button.prototype.iconPosition = 0;

    /**
     * Button wrap.
     * @member {boolean|null|undefined} wrap
     * @memberof Button
     * @instance
     */
    Button.prototype.wrap = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Button.prototype, "_wrap", {
        get: $util.oneOfGetter($oneOfFields = ["wrap"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Button instance using the specified properties.
     * @function create
     * @memberof Button
     * @static
     * @param {Button.$Properties=} [properties] Properties to set
     * @returns {Button} Button instance
     * @type {{
     *   (properties: Button.$Shape): Button & Button.$Shape;
     *   (properties?: Button.$Properties): Button;
     * }}
     */
    Button.create = function(properties) {
        return new Button(properties);
    };

    /**
     * Encodes the specified Button message. Does not implicitly {@link Button.verify|verify} messages.
     * @function encode
     * @memberof Button
     * @static
     * @param {Button.$Properties} message Button message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Button.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default") && message["default"] !== false)
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message["default"]);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.formId);
        if (message.isFormSubmitter != null && $Object.hasOwnProperty.call(message, "isFormSubmitter") && message.isFormSubmitter !== false)
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isFormSubmitter);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.type);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.disabled);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.icon);
        if (message.shortcut != null && $Object.hasOwnProperty.call(message, "shortcut") && message.shortcut !== "")
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.shortcut);
        if (message.iconPosition != null && $Object.hasOwnProperty.call(message, "iconPosition") && message.iconPosition !== 0)
            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.iconPosition);
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.wrap);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Button message from the specified reader or buffer.
     * @function decode
     * @memberof Button
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Button & Button.$Shape} Button
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Button.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Button();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message["default"] = value;
                    else
                        delete message["default"];
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isFormSubmitter = value;
                    else
                        delete message.isFormSubmitter;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.shortcut = value;
                    else
                        delete message.shortcut;
                    continue;
                }
            case 12: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.iconPosition = value;
                    else
                        delete message.iconPosition;
                    continue;
                }
            case 13: {
                    if (wireType !== 0)
                        break;
                    message.wrap = reader.bool();
                    message._wrap = "wrap";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Button message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Button
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Button} Button
     */
    Button.fromObject = function (object, _depth) {
        if (object instanceof $root.Button)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Button: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Button();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"] != null)
            if (object["default"])
                message["default"] = $Boolean(object["default"]);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.isFormSubmitter != null)
            if (object.isFormSubmitter)
                message.isFormSubmitter = $Boolean(object.isFormSubmitter);
        if (object.type != null)
            if (typeof object.type !== "string" || object.type.length)
                message.type = $String(object.type);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        if (object.shortcut != null)
            if (typeof object.shortcut !== "string" || object.shortcut.length)
                message.shortcut = $String(object.shortcut);
        if (object.iconPosition !== 0 && (typeof object.iconPosition !== "string" || $root.streamlit.ButtonLikeIconPosition[object.iconPosition] !== 0))
            switch (object.iconPosition) {
            case "LEFT":
            case 0:
                message.iconPosition = 0;
                break;
            case "RIGHT":
            case 1:
                message.iconPosition = 1;
                break;
            default:
                if (typeof object.iconPosition === "number" && (object.iconPosition | 0) === object.iconPosition)
                    message.iconPosition = object.iconPosition;
            }
        if (object.wrap != null)
            message.wrap = $Boolean(object.wrap);
        return message;
    };

    /**
     * Creates a plain object from a Button message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Button
     * @static
     * @param {Button} message Button
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Button.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object["default"] = false;
            object.help = "";
            object.formId = "";
            object.isFormSubmitter = false;
            object.type = "";
            object.disabled = false;
            object.icon = "";
            object.shortcut = "";
            object.iconPosition = options.enums === $String ? "LEFT" : 0;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.isFormSubmitter != null && $Object.hasOwnProperty.call(message, "isFormSubmitter"))
            object.isFormSubmitter = message.isFormSubmitter;
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = message.type;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        if (message.shortcut != null && $Object.hasOwnProperty.call(message, "shortcut"))
            object.shortcut = message.shortcut;
        if (message.iconPosition != null && $Object.hasOwnProperty.call(message, "iconPosition"))
            object.iconPosition = options.enums === $String ? $root.streamlit.ButtonLikeIconPosition[message.iconPosition] === $undefined ? message.iconPosition : $root.streamlit.ButtonLikeIconPosition[message.iconPosition] : message.iconPosition;
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            object.wrap = message.wrap;
        return object;
    };

    /**
     * Converts this Button to JSON.
     * @function toJSON
     * @memberof Button
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Button.prototype.toJSON = function() {
        return Button.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Button
     * @function getTypeUrl
     * @memberof Button
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Button.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Button";
    };

    return Button;
})();

export const ButtonGroup = $root.ButtonGroup = (() => {

    /**
     * Properties of a ButtonGroup.
     * @typedef {Object} ButtonGroup.$Properties
     * @property {string|null} [id] ButtonGroup id
     * @property {Array.<ButtonGroup.Option.$Properties>|null} [options] ButtonGroup options
     * @property {Array.<number>|null} ["default"] ButtonGroup default
     * @property {boolean|null} [disabled] ButtonGroup disabled
     * @property {ButtonGroup.ClickMode|null} [clickMode] ButtonGroup clickMode
     * @property {string|null} [formId] ButtonGroup formId
     * @property {boolean|null} [setValue] ButtonGroup setValue
     * @property {ButtonGroup.Style|null} [style] ButtonGroup style
     * @property {string|null} [label] ButtonGroup label
     * @property {LabelVisibility.$Properties|null} [labelVisibility] ButtonGroup labelVisibility
     * @property {string|null} [help] ButtonGroup help
     * @property {Array.<string>|null} [rawValues] ButtonGroup rawValues
     * @property {string|null} [queryParamKey] ButtonGroup queryParamKey
     * @property {boolean|null} [required] ButtonGroup required
     * @property {boolean|null} [wrap] ButtonGroup wrap
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ButtonGroup.
     * @exports IButtonGroup
     * @interface IButtonGroup
     * @augments ButtonGroup.$Properties
     * @deprecated Use ButtonGroup.$Properties instead.
     */

    /**
     * Shape of a ButtonGroup.
     * @typedef {ButtonGroup.$Properties} ButtonGroup.$Shape
     */

    /**
     * Constructs a new ButtonGroup.
     * @exports ButtonGroup
     * @classdesc Represents a ButtonGroup.
     * @constructor
     * @param {ButtonGroup.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ButtonGroup = function (properties) {
        this.options = [];
        this["default"] = [];
        this.rawValues = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ButtonGroup id.
     * @member {string} id
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.id = "";

    /**
     * ButtonGroup options.
     * @member {Array.<ButtonGroup.Option.$Properties>} options
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.options = $util.emptyArray;

    /**
     * ButtonGroup default.
     * @member {Array.<number>} default
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype["default"] = $util.emptyArray;

    /**
     * ButtonGroup disabled.
     * @member {boolean} disabled
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.disabled = false;

    /**
     * ButtonGroup clickMode.
     * @member {ButtonGroup.ClickMode} clickMode
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.clickMode = 0;

    /**
     * ButtonGroup formId.
     * @member {string} formId
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.formId = "";

    /**
     * ButtonGroup setValue.
     * @member {boolean} setValue
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.setValue = false;

    /**
     * ButtonGroup style.
     * @member {ButtonGroup.Style} style
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.style = 0;

    /**
     * ButtonGroup label.
     * @member {string} label
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.label = "";

    /**
     * ButtonGroup labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.labelVisibility = null;

    /**
     * ButtonGroup help.
     * @member {string|null|undefined} help
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.help = null;

    /**
     * ButtonGroup rawValues.
     * @member {Array.<string>} rawValues
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.rawValues = $util.emptyArray;

    /**
     * ButtonGroup queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.queryParamKey = null;

    /**
     * ButtonGroup required.
     * @member {boolean} required
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.required = false;

    /**
     * ButtonGroup wrap.
     * @member {boolean|null|undefined} wrap
     * @memberof ButtonGroup
     * @instance
     */
    ButtonGroup.prototype.wrap = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ButtonGroup.prototype, "_help", {
        get: $util.oneOfGetter($oneOfFields = ["help"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ButtonGroup.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ButtonGroup.prototype, "_wrap", {
        get: $util.oneOfGetter($oneOfFields = ["wrap"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ButtonGroup instance using the specified properties.
     * @function create
     * @memberof ButtonGroup
     * @static
     * @param {ButtonGroup.$Properties=} [properties] Properties to set
     * @returns {ButtonGroup} ButtonGroup instance
     * @type {{
     *   (properties: ButtonGroup.$Shape): ButtonGroup & ButtonGroup.$Shape;
     *   (properties?: ButtonGroup.$Properties): ButtonGroup;
     * }}
     */
    ButtonGroup.create = function(properties) {
        return new ButtonGroup(properties);
    };

    /**
     * Encodes the specified ButtonGroup message. Does not implicitly {@link ButtonGroup.verify|verify} messages.
     * @function encode
     * @memberof ButtonGroup
     * @static
     * @param {ButtonGroup.$Properties} message ButtonGroup message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ButtonGroup.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.options != null && message.options.length)
            for (let i = 0; i < message.options.length; ++i)
                $root.ButtonGroup.Option.encode(message.options[i], writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message["default"] != null && message["default"].length)
            writer.uint32(/* id 3, wireType 2 =*/26).uint32s(message["default"]);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.disabled);
        if (message.clickMode != null && $Object.hasOwnProperty.call(message, "clickMode") && message.clickMode !== 0)
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.clickMode);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.formId);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.setValue);
        if (message.style != null && $Object.hasOwnProperty.call(message, "style") && message.style !== 0)
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.style);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.label);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 12, wireType 2 =*/98).fork(), _depth + 1).ldelim();
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.help);
        if (message.rawValues != null && message.rawValues.length)
            for (let i = 0; i < message.rawValues.length; ++i)
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.rawValues[i]);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.queryParamKey);
        if (message.required != null && $Object.hasOwnProperty.call(message, "required") && message.required !== false)
            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.required);
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            writer.uint32(/* id 17, wireType 0 =*/136).bool(message.wrap);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ButtonGroup message from the specified reader or buffer.
     * @function decode
     * @memberof ButtonGroup
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ButtonGroup & ButtonGroup.$Shape} ButtonGroup
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ButtonGroup.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ButtonGroup();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if (!(message.options && message.options.length))
                        message.options = [];
                    message.options.push($root.ButtonGroup.Option.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 3: {
                    if (wireType === 2) {
                        if (!(message["default"] && message["default"].length))
                            message["default"] = [];
                        reader.uint32s(message["default"]);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message["default"] && message["default"].length))
                        message["default"] = [];
                    message["default"].push(reader.uint32());
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.clickMode = value;
                    else
                        delete message.clickMode;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.style = value;
                    else
                        delete message.style;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.help = reader.stringVerify();
                    message._help = "help";
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    if (!(message.rawValues && message.rawValues.length))
                        message.rawValues = [];
                    message.rawValues.push(reader.stringVerify());
                    continue;
                }
            case 15: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 16: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.required = value;
                    else
                        delete message.required;
                    continue;
                }
            case 17: {
                    if (wireType !== 0)
                        break;
                    message.wrap = reader.bool();
                    message._wrap = "wrap";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ButtonGroup message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ButtonGroup
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ButtonGroup} ButtonGroup
     */
    ButtonGroup.fromObject = function (object, _depth) {
        if (object instanceof $root.ButtonGroup)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ButtonGroup: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ButtonGroup();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.options) {
            if (!$Array.isArray(object.options))
                throw $TypeError(".ButtonGroup.options: array expected");
            message.options = $Array(object.options.length);
            for (let i = 0; i < object.options.length; ++i) {
                if (!$util.isObject(object.options[i]))
                    throw $TypeError(".ButtonGroup.options: object expected");
                message.options[i] = $root.ButtonGroup.Option.fromObject(object.options[i], _depth + 1);
            }
        }
        if (object["default"]) {
            if (!$Array.isArray(object["default"]))
                throw $TypeError(".ButtonGroup.default: array expected");
            message["default"] = $Array(object["default"].length);
            for (let i = 0; i < object["default"].length; ++i)
                message["default"][i] = object["default"][i] >>> 0;
        }
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.clickMode !== 0 && (typeof object.clickMode !== "string" || $root.ButtonGroup.ClickMode[object.clickMode] !== 0))
            switch (object.clickMode) {
            case "SINGLE_SELECT":
            case 0:
                message.clickMode = 0;
                break;
            case "MULTI_SELECT":
            case 1:
                message.clickMode = 1;
                break;
            default:
                if (typeof object.clickMode === "number" && (object.clickMode | 0) === object.clickMode)
                    message.clickMode = object.clickMode;
            }
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.style !== 0 && (typeof object.style !== "string" || $root.ButtonGroup.Style[object.style] !== 0))
            switch (object.style) {
            case "SEGMENTED_CONTROL":
            case 0:
                message.style = 0;
                break;
            case "PILLS":
            case 1:
                message.style = 1;
                break;
            default:
                if (typeof object.style === "number" && (object.style | 0) === object.style)
                    message.style = object.style;
            }
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".ButtonGroup.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.help != null)
            message.help = $String(object.help);
        if (object.rawValues) {
            if (!$Array.isArray(object.rawValues))
                throw $TypeError(".ButtonGroup.rawValues: array expected");
            message.rawValues = $Array(object.rawValues.length);
            for (let i = 0; i < object.rawValues.length; ++i)
                message.rawValues[i] = $String(object.rawValues[i]);
        }
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.required != null)
            if (object.required)
                message.required = $Boolean(object.required);
        if (object.wrap != null)
            message.wrap = $Boolean(object.wrap);
        return message;
    };

    /**
     * Creates a plain object from a ButtonGroup message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ButtonGroup
     * @static
     * @param {ButtonGroup} message ButtonGroup
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ButtonGroup.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object.options = [];
            object["default"] = [];
            object.rawValues = [];
        }
        if (options.defaults) {
            object.id = "";
            object.disabled = false;
            object.clickMode = options.enums === $String ? "SINGLE_SELECT" : 0;
            object.formId = "";
            object.setValue = false;
            object.style = options.enums === $String ? "SEGMENTED_CONTROL" : 0;
            object.label = "";
            object.labelVisibility = null;
            object.required = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.options && message.options.length) {
            object.options = $Array(message.options.length);
            for (let j = 0; j < message.options.length; ++j)
                object.options[j] = $root.ButtonGroup.Option.toObject(message.options[j], options, _depth + 1);
        }
        if (message["default"] && message["default"].length) {
            object["default"] = $Array(message["default"].length);
            for (let j = 0; j < message["default"].length; ++j)
                object["default"][j] = message["default"][j];
        }
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.clickMode != null && $Object.hasOwnProperty.call(message, "clickMode"))
            object.clickMode = options.enums === $String ? $root.ButtonGroup.ClickMode[message.clickMode] === $undefined ? message.clickMode : $root.ButtonGroup.ClickMode[message.clickMode] : message.clickMode;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.style != null && $Object.hasOwnProperty.call(message, "style"))
            object.style = options.enums === $String ? $root.ButtonGroup.Style[message.style] === $undefined ? message.style : $root.ButtonGroup.Style[message.style] : message.style;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.rawValues && message.rawValues.length) {
            object.rawValues = $Array(message.rawValues.length);
            for (let j = 0; j < message.rawValues.length; ++j)
                object.rawValues[j] = message.rawValues[j];
        }
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.required != null && $Object.hasOwnProperty.call(message, "required"))
            object.required = message.required;
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            object.wrap = message.wrap;
        return object;
    };

    /**
     * Converts this ButtonGroup to JSON.
     * @function toJSON
     * @memberof ButtonGroup
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ButtonGroup.prototype.toJSON = function() {
        return ButtonGroup.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ButtonGroup
     * @function getTypeUrl
     * @memberof ButtonGroup
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ButtonGroup.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ButtonGroup";
    };

    /**
     * ClickMode enum.
     * @name ButtonGroup.ClickMode
     * @enum {number}
     * @property {number} SINGLE_SELECT=0 SINGLE_SELECT value
     * @property {number} MULTI_SELECT=1 MULTI_SELECT value
     */
    ButtonGroup.ClickMode = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "SINGLE_SELECT"] = 0;
        values[valuesById[1] = "MULTI_SELECT"] = 1;
        return values;
    })();

    ButtonGroup.Option = (function() {

        /**
         * Properties of an Option.
         * @typedef {Object} ButtonGroup.Option.$Properties
         * @property {string|null} [content] Option content
         * @property {string|null} [contentIcon] Option contentIcon
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an Option.
         * @memberof ButtonGroup
         * @interface IOption
         * @augments ButtonGroup.Option.$Properties
         * @deprecated Use ButtonGroup.Option.$Properties instead.
         */

        /**
         * Shape of an Option.
         * @typedef {ButtonGroup.Option.$Properties} ButtonGroup.Option.$Shape
         */

        /**
         * Constructs a new Option.
         * @memberof ButtonGroup
         * @classdesc Represents an Option.
         * @constructor
         * @param {ButtonGroup.Option.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Option = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Option content.
         * @member {string} content
         * @memberof ButtonGroup.Option
         * @instance
         */
        Option.prototype.content = "";

        /**
         * Option contentIcon.
         * @member {string|null|undefined} contentIcon
         * @memberof ButtonGroup.Option
         * @instance
         */
        Option.prototype.contentIcon = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        $Object.defineProperty(Option.prototype, "_contentIcon", {
            get: $util.oneOfGetter($oneOfFields = ["contentIcon"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Option instance using the specified properties.
         * @function create
         * @memberof ButtonGroup.Option
         * @static
         * @param {ButtonGroup.Option.$Properties=} [properties] Properties to set
         * @returns {ButtonGroup.Option} Option instance
         * @type {{
         *   (properties: ButtonGroup.Option.$Shape): ButtonGroup.Option & ButtonGroup.Option.$Shape;
         *   (properties?: ButtonGroup.Option.$Properties): ButtonGroup.Option;
         * }}
         */
        Option.create = function(properties) {
            return new Option(properties);
        };

        /**
         * Encodes the specified Option message. Does not implicitly {@link ButtonGroup.Option.verify|verify} messages.
         * @function encode
         * @memberof ButtonGroup.Option
         * @static
         * @param {ButtonGroup.Option.$Properties} message Option message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Option.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.content != null && $Object.hasOwnProperty.call(message, "content") && message.content !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.content);
            if (message.contentIcon != null && $Object.hasOwnProperty.call(message, "contentIcon"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.contentIcon);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes an Option message from the specified reader or buffer.
         * @function decode
         * @memberof ButtonGroup.Option
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ButtonGroup.Option & ButtonGroup.Option.$Shape} Option
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Option.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.ButtonGroup.Option();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.content = value;
                        else
                            delete message.content;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        message.contentIcon = reader.stringVerify();
                        message._contentIcon = "contentIcon";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates an Option message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ButtonGroup.Option
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ButtonGroup.Option} Option
         */
        Option.fromObject = function (object, _depth) {
            if (object instanceof $root.ButtonGroup.Option)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".ButtonGroup.Option: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.ButtonGroup.Option();
            if (object.content != null)
                if (typeof object.content !== "string" || object.content.length)
                    message.content = $String(object.content);
            if (object.contentIcon != null)
                message.contentIcon = $String(object.contentIcon);
            return message;
        };

        /**
         * Creates a plain object from an Option message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ButtonGroup.Option
         * @static
         * @param {ButtonGroup.Option} message Option
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Option.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.content = "";
            if (message.content != null && $Object.hasOwnProperty.call(message, "content"))
                object.content = message.content;
            if (message.contentIcon != null && $Object.hasOwnProperty.call(message, "contentIcon"))
                object.contentIcon = message.contentIcon;
            return object;
        };

        /**
         * Converts this Option to JSON.
         * @function toJSON
         * @memberof ButtonGroup.Option
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Option.prototype.toJSON = function() {
            return Option.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Option
         * @function getTypeUrl
         * @memberof ButtonGroup.Option
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Option.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/ButtonGroup.Option";
        };

        return Option;
    })();

    /**
     * Style enum.
     * @name ButtonGroup.Style
     * @enum {number}
     * @property {number} SEGMENTED_CONTROL=0 SEGMENTED_CONTROL value
     * @property {number} PILLS=1 PILLS value
     */
    ButtonGroup.Style = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "SEGMENTED_CONTROL"] = 0;
        values[valuesById[1] = "PILLS"] = 1;
        return values;
    })();

    return ButtonGroup;
})();

export const CameraInput = $root.CameraInput = (() => {

    /**
     * Properties of a CameraInput.
     * @typedef {Object} CameraInput.$Properties
     * @property {string|null} [id] CameraInput id
     * @property {string|null} [label] CameraInput label
     * @property {string|null} [help] CameraInput help
     * @property {string|null} [formId] CameraInput formId
     * @property {boolean|null} [disabled] CameraInput disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] CameraInput labelVisibility
     * @property {number|null} [resolutionHeight] CameraInput resolutionHeight
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a CameraInput.
     * @exports ICameraInput
     * @interface ICameraInput
     * @augments CameraInput.$Properties
     * @deprecated Use CameraInput.$Properties instead.
     */

    /**
     * Shape of a CameraInput.
     * @typedef {CameraInput.$Properties} CameraInput.$Shape
     */

    /**
     * Constructs a new CameraInput.
     * @exports CameraInput
     * @classdesc Represents a CameraInput.
     * @constructor
     * @param {CameraInput.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const CameraInput = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * CameraInput id.
     * @member {string} id
     * @memberof CameraInput
     * @instance
     */
    CameraInput.prototype.id = "";

    /**
     * CameraInput label.
     * @member {string} label
     * @memberof CameraInput
     * @instance
     */
    CameraInput.prototype.label = "";

    /**
     * CameraInput help.
     * @member {string} help
     * @memberof CameraInput
     * @instance
     */
    CameraInput.prototype.help = "";

    /**
     * CameraInput formId.
     * @member {string} formId
     * @memberof CameraInput
     * @instance
     */
    CameraInput.prototype.formId = "";

    /**
     * CameraInput disabled.
     * @member {boolean} disabled
     * @memberof CameraInput
     * @instance
     */
    CameraInput.prototype.disabled = false;

    /**
     * CameraInput labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof CameraInput
     * @instance
     */
    CameraInput.prototype.labelVisibility = null;

    /**
     * CameraInput resolutionHeight.
     * @member {number|null|undefined} resolutionHeight
     * @memberof CameraInput
     * @instance
     */
    CameraInput.prototype.resolutionHeight = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CameraInput.prototype, "_resolutionHeight", {
        get: $util.oneOfGetter($oneOfFields = ["resolutionHeight"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new CameraInput instance using the specified properties.
     * @function create
     * @memberof CameraInput
     * @static
     * @param {CameraInput.$Properties=} [properties] Properties to set
     * @returns {CameraInput} CameraInput instance
     * @type {{
     *   (properties: CameraInput.$Shape): CameraInput & CameraInput.$Shape;
     *   (properties?: CameraInput.$Properties): CameraInput;
     * }}
     */
    CameraInput.create = function(properties) {
        return new CameraInput(properties);
    };

    /**
     * Encodes the specified CameraInput message. Does not implicitly {@link CameraInput.verify|verify} messages.
     * @function encode
     * @memberof CameraInput
     * @static
     * @param {CameraInput.$Properties} message CameraInput message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CameraInput.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.formId);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
        if (message.resolutionHeight != null && $Object.hasOwnProperty.call(message, "resolutionHeight"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.resolutionHeight);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a CameraInput message from the specified reader or buffer.
     * @function decode
     * @memberof CameraInput
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CameraInput & CameraInput.$Shape} CameraInput
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CameraInput.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.CameraInput();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    message.resolutionHeight = reader.int32();
                    message._resolutionHeight = "resolutionHeight";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a CameraInput message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CameraInput
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CameraInput} CameraInput
     */
    CameraInput.fromObject = function (object, _depth) {
        if (object instanceof $root.CameraInput)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".CameraInput: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.CameraInput();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".CameraInput.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.resolutionHeight != null)
            message.resolutionHeight = object.resolutionHeight | 0;
        return message;
    };

    /**
     * Creates a plain object from a CameraInput message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CameraInput
     * @static
     * @param {CameraInput} message CameraInput
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CameraInput.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.help = "";
            object.formId = "";
            object.disabled = false;
            object.labelVisibility = null;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.resolutionHeight != null && $Object.hasOwnProperty.call(message, "resolutionHeight"))
            object.resolutionHeight = message.resolutionHeight;
        return object;
    };

    /**
     * Converts this CameraInput to JSON.
     * @function toJSON
     * @memberof CameraInput
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CameraInput.prototype.toJSON = function() {
        return CameraInput.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for CameraInput
     * @function getTypeUrl
     * @memberof CameraInput
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    CameraInput.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/CameraInput";
    };

    return CameraInput;
})();

export const ChatInput = $root.ChatInput = (() => {

    /**
     * Properties of a ChatInput.
     * @typedef {Object} ChatInput.$Properties
     * @property {string|null} [id] ChatInput id
     * @property {string|null} [placeholder] ChatInput placeholder
     * @property {number|null} [maxChars] ChatInput maxChars
     * @property {boolean|null} [disabled] ChatInput disabled
     * @property {string|null} [value] ChatInput value
     * @property {boolean|null} [setValue] ChatInput setValue
     * @property {string|null} ["default"] ChatInput default
     * @property {ChatInput.AcceptFile|null} [acceptFile] ChatInput acceptFile
     * @property {Array.<string>|null} [fileType] ChatInput fileType
     * @property {number|null} [maxUploadSizeMb] ChatInput maxUploadSizeMb
     * @property {boolean|null} [acceptAudio] ChatInput acceptAudio
     * @property {number|null} [audioSampleRate] ChatInput audioSampleRate
     * @property {ChatInput.SubmitMode|null} [submitMode] ChatInput submitMode
     * @property {boolean|null} [isAutoPositionedAtBottom] ChatInput isAutoPositionedAtBottom
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ChatInput.
     * @exports IChatInput
     * @interface IChatInput
     * @augments ChatInput.$Properties
     * @deprecated Use ChatInput.$Properties instead.
     */

    /**
     * Shape of a ChatInput.
     * @typedef {ChatInput.$Properties} ChatInput.$Shape
     */

    /**
     * Constructs a new ChatInput.
     * @exports ChatInput
     * @classdesc Represents a ChatInput.
     * @constructor
     * @param {ChatInput.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ChatInput = function (properties) {
        this.fileType = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ChatInput id.
     * @member {string} id
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.id = "";

    /**
     * ChatInput placeholder.
     * @member {string} placeholder
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.placeholder = "";

    /**
     * ChatInput maxChars.
     * @member {number} maxChars
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.maxChars = 0;

    /**
     * ChatInput disabled.
     * @member {boolean} disabled
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.disabled = false;

    /**
     * ChatInput value.
     * @member {string} value
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.value = "";

    /**
     * ChatInput setValue.
     * @member {boolean} setValue
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.setValue = false;

    /**
     * ChatInput default.
     * @member {string} default
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype["default"] = "";

    /**
     * ChatInput acceptFile.
     * @member {ChatInput.AcceptFile} acceptFile
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.acceptFile = 0;

    /**
     * ChatInput fileType.
     * @member {Array.<string>} fileType
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.fileType = $util.emptyArray;

    /**
     * ChatInput maxUploadSizeMb.
     * @member {number} maxUploadSizeMb
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.maxUploadSizeMb = 0;

    /**
     * ChatInput acceptAudio.
     * @member {boolean} acceptAudio
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.acceptAudio = false;

    /**
     * ChatInput audioSampleRate.
     * @member {number|null|undefined} audioSampleRate
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.audioSampleRate = null;

    /**
     * ChatInput submitMode.
     * @member {ChatInput.SubmitMode} submitMode
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.submitMode = 0;

    /**
     * ChatInput isAutoPositionedAtBottom.
     * @member {boolean} isAutoPositionedAtBottom
     * @memberof ChatInput
     * @instance
     */
    ChatInput.prototype.isAutoPositionedAtBottom = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ChatInput.prototype, "_audioSampleRate", {
        get: $util.oneOfGetter($oneOfFields = ["audioSampleRate"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ChatInput instance using the specified properties.
     * @function create
     * @memberof ChatInput
     * @static
     * @param {ChatInput.$Properties=} [properties] Properties to set
     * @returns {ChatInput} ChatInput instance
     * @type {{
     *   (properties: ChatInput.$Shape): ChatInput & ChatInput.$Shape;
     *   (properties?: ChatInput.$Properties): ChatInput;
     * }}
     */
    ChatInput.create = function(properties) {
        return new ChatInput(properties);
    };

    /**
     * Encodes the specified ChatInput message. Does not implicitly {@link ChatInput.verify|verify} messages.
     * @function encode
     * @memberof ChatInput
     * @static
     * @param {ChatInput.$Properties} message ChatInput message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChatInput.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder") && message.placeholder !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.placeholder);
        if (message.maxChars != null && $Object.hasOwnProperty.call(message, "maxChars") && message.maxChars !== 0)
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.maxChars);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.disabled);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value") && message.value !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.value);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.setValue);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default") && message["default"] !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message["default"]);
        if (message.acceptFile != null && $Object.hasOwnProperty.call(message, "acceptFile") && message.acceptFile !== 0)
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.acceptFile);
        if (message.fileType != null && message.fileType.length)
            for (let i = 0; i < message.fileType.length; ++i)
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.fileType[i]);
        if (message.maxUploadSizeMb != null && $Object.hasOwnProperty.call(message, "maxUploadSizeMb") && message.maxUploadSizeMb !== 0)
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.maxUploadSizeMb);
        if (message.acceptAudio != null && $Object.hasOwnProperty.call(message, "acceptAudio") && message.acceptAudio !== false)
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.acceptAudio);
        if (message.audioSampleRate != null && $Object.hasOwnProperty.call(message, "audioSampleRate"))
            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.audioSampleRate);
        if (message.submitMode != null && $Object.hasOwnProperty.call(message, "submitMode") && message.submitMode !== 0)
            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.submitMode);
        if (message.isAutoPositionedAtBottom != null && $Object.hasOwnProperty.call(message, "isAutoPositionedAtBottom") && message.isAutoPositionedAtBottom !== false)
            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.isAutoPositionedAtBottom);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ChatInput message from the specified reader or buffer.
     * @function decode
     * @memberof ChatInput
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ChatInput & ChatInput.$Shape} ChatInput
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChatInput.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ChatInput();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.placeholder = value;
                    else
                        delete message.placeholder;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message.maxChars = value;
                    else
                        delete message.maxChars;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.value = value;
                    else
                        delete message.value;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message["default"] = value;
                    else
                        delete message["default"];
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.acceptFile = value;
                    else
                        delete message.acceptFile;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if (!(message.fileType && message.fileType.length))
                        message.fileType = [];
                    message.fileType.push(reader.stringVerify());
                    continue;
                }
            case 11: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.maxUploadSizeMb = value;
                    else
                        delete message.maxUploadSizeMb;
                    continue;
                }
            case 12: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.acceptAudio = value;
                    else
                        delete message.acceptAudio;
                    continue;
                }
            case 13: {
                    if (wireType !== 0)
                        break;
                    message.audioSampleRate = reader.int32();
                    message._audioSampleRate = "audioSampleRate";
                    continue;
                }
            case 14: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.submitMode = value;
                    else
                        delete message.submitMode;
                    continue;
                }
            case 15: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isAutoPositionedAtBottom = value;
                    else
                        delete message.isAutoPositionedAtBottom;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ChatInput message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ChatInput
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ChatInput} ChatInput
     */
    ChatInput.fromObject = function (object, _depth) {
        if (object instanceof $root.ChatInput)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ChatInput: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ChatInput();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.placeholder != null)
            if (typeof object.placeholder !== "string" || object.placeholder.length)
                message.placeholder = $String(object.placeholder);
        if (object.maxChars != null)
            if ($Number(object.maxChars) !== 0)
                message.maxChars = object.maxChars >>> 0;
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.value != null)
            if (typeof object.value !== "string" || object.value.length)
                message.value = $String(object.value);
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object["default"] != null)
            if (typeof object["default"] !== "string" || object["default"].length)
                message["default"] = $String(object["default"]);
        if (object.acceptFile !== 0 && (typeof object.acceptFile !== "string" || $root.ChatInput.AcceptFile[object.acceptFile] !== 0))
            switch (object.acceptFile) {
            case "NONE":
            case 0:
                message.acceptFile = 0;
                break;
            case "SINGLE":
            case 1:
                message.acceptFile = 1;
                break;
            case "MULTIPLE":
            case 2:
                message.acceptFile = 2;
                break;
            case "DIRECTORY":
            case 3:
                message.acceptFile = 3;
                break;
            default:
                if (typeof object.acceptFile === "number" && (object.acceptFile | 0) === object.acceptFile)
                    message.acceptFile = object.acceptFile;
            }
        if (object.fileType) {
            if (!$Array.isArray(object.fileType))
                throw $TypeError(".ChatInput.fileType: array expected");
            message.fileType = $Array(object.fileType.length);
            for (let i = 0; i < object.fileType.length; ++i)
                message.fileType[i] = $String(object.fileType[i]);
        }
        if (object.maxUploadSizeMb != null)
            if ($Number(object.maxUploadSizeMb) !== 0)
                message.maxUploadSizeMb = object.maxUploadSizeMb | 0;
        if (object.acceptAudio != null)
            if (object.acceptAudio)
                message.acceptAudio = $Boolean(object.acceptAudio);
        if (object.audioSampleRate != null)
            message.audioSampleRate = object.audioSampleRate | 0;
        if (object.submitMode !== 0 && (typeof object.submitMode !== "string" || $root.ChatInput.SubmitMode[object.submitMode] !== 0))
            switch (object.submitMode) {
            case "SUBMIT_MODE_SUBMIT":
            case 0:
                message.submitMode = 0;
                break;
            case "SUBMIT_MODE_DISABLE":
            case 1:
                message.submitMode = 1;
                break;
            case "SUBMIT_MODE_STOP":
            case 2:
                message.submitMode = 2;
                break;
            default:
                if (typeof object.submitMode === "number" && (object.submitMode | 0) === object.submitMode)
                    message.submitMode = object.submitMode;
            }
        if (object.isAutoPositionedAtBottom != null)
            if (object.isAutoPositionedAtBottom)
                message.isAutoPositionedAtBottom = $Boolean(object.isAutoPositionedAtBottom);
        return message;
    };

    /**
     * Creates a plain object from a ChatInput message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ChatInput
     * @static
     * @param {ChatInput} message ChatInput
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ChatInput.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.fileType = [];
        if (options.defaults) {
            object.id = "";
            object.placeholder = "";
            object.maxChars = 0;
            object.disabled = false;
            object.value = "";
            object.setValue = false;
            object["default"] = "";
            object.acceptFile = options.enums === $String ? "NONE" : 0;
            object.maxUploadSizeMb = 0;
            object.acceptAudio = false;
            object.submitMode = options.enums === $String ? "SUBMIT_MODE_SUBMIT" : 0;
            object.isAutoPositionedAtBottom = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder"))
            object.placeholder = message.placeholder;
        if (message.maxChars != null && $Object.hasOwnProperty.call(message, "maxChars"))
            object.maxChars = message.maxChars;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = message.value;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.acceptFile != null && $Object.hasOwnProperty.call(message, "acceptFile"))
            object.acceptFile = options.enums === $String ? $root.ChatInput.AcceptFile[message.acceptFile] === $undefined ? message.acceptFile : $root.ChatInput.AcceptFile[message.acceptFile] : message.acceptFile;
        if (message.fileType && message.fileType.length) {
            object.fileType = $Array(message.fileType.length);
            for (let j = 0; j < message.fileType.length; ++j)
                object.fileType[j] = message.fileType[j];
        }
        if (message.maxUploadSizeMb != null && $Object.hasOwnProperty.call(message, "maxUploadSizeMb"))
            object.maxUploadSizeMb = message.maxUploadSizeMb;
        if (message.acceptAudio != null && $Object.hasOwnProperty.call(message, "acceptAudio"))
            object.acceptAudio = message.acceptAudio;
        if (message.audioSampleRate != null && $Object.hasOwnProperty.call(message, "audioSampleRate"))
            object.audioSampleRate = message.audioSampleRate;
        if (message.submitMode != null && $Object.hasOwnProperty.call(message, "submitMode"))
            object.submitMode = options.enums === $String ? $root.ChatInput.SubmitMode[message.submitMode] === $undefined ? message.submitMode : $root.ChatInput.SubmitMode[message.submitMode] : message.submitMode;
        if (message.isAutoPositionedAtBottom != null && $Object.hasOwnProperty.call(message, "isAutoPositionedAtBottom"))
            object.isAutoPositionedAtBottom = message.isAutoPositionedAtBottom;
        return object;
    };

    /**
     * Converts this ChatInput to JSON.
     * @function toJSON
     * @memberof ChatInput
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ChatInput.prototype.toJSON = function() {
        return ChatInput.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ChatInput
     * @function getTypeUrl
     * @memberof ChatInput
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ChatInput.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ChatInput";
    };

    /**
     * AcceptFile enum.
     * @name ChatInput.AcceptFile
     * @enum {number}
     * @property {number} NONE=0 NONE value
     * @property {number} SINGLE=1 SINGLE value
     * @property {number} MULTIPLE=2 MULTIPLE value
     * @property {number} DIRECTORY=3 DIRECTORY value
     */
    ChatInput.AcceptFile = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "NONE"] = 0;
        values[valuesById[1] = "SINGLE"] = 1;
        values[valuesById[2] = "MULTIPLE"] = 2;
        values[valuesById[3] = "DIRECTORY"] = 3;
        return values;
    })();

    /**
     * SubmitMode enum.
     * @name ChatInput.SubmitMode
     * @enum {number}
     * @property {number} SUBMIT_MODE_SUBMIT=0 SUBMIT_MODE_SUBMIT value
     * @property {number} SUBMIT_MODE_DISABLE=1 SUBMIT_MODE_DISABLE value
     * @property {number} SUBMIT_MODE_STOP=2 SUBMIT_MODE_STOP value
     */
    ChatInput.SubmitMode = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "SUBMIT_MODE_SUBMIT"] = 0;
        values[valuesById[1] = "SUBMIT_MODE_DISABLE"] = 1;
        values[valuesById[2] = "SUBMIT_MODE_STOP"] = 2;
        return values;
    })();

    return ChatInput;
})();

export const Checkbox = $root.Checkbox = (() => {

    /**
     * Properties of a Checkbox.
     * @typedef {Object} Checkbox.$Properties
     * @property {string|null} [id] Checkbox id
     * @property {string|null} [label] Checkbox label
     * @property {boolean|null} ["default"] Checkbox default
     * @property {string|null} [help] Checkbox help
     * @property {string|null} [formId] Checkbox formId
     * @property {boolean|null} [value] Checkbox value
     * @property {boolean|null} [setValue] Checkbox setValue
     * @property {boolean|null} [disabled] Checkbox disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] Checkbox labelVisibility
     * @property {Checkbox.StyleType|null} [type] Checkbox type
     * @property {string|null} [queryParamKey] Checkbox queryParamKey
     * @property {boolean|null} [wrap] Checkbox wrap
     * @property {boolean|null} [ignoreRerun] Checkbox ignoreRerun
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Checkbox.
     * @exports ICheckbox
     * @interface ICheckbox
     * @augments Checkbox.$Properties
     * @deprecated Use Checkbox.$Properties instead.
     */

    /**
     * Shape of a Checkbox.
     * @typedef {Checkbox.$Properties} Checkbox.$Shape
     */

    /**
     * Constructs a new Checkbox.
     * @exports Checkbox
     * @classdesc Represents a Checkbox.
     * @constructor
     * @param {Checkbox.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Checkbox = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Checkbox id.
     * @member {string} id
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.id = "";

    /**
     * Checkbox label.
     * @member {string} label
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.label = "";

    /**
     * Checkbox default.
     * @member {boolean} default
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype["default"] = false;

    /**
     * Checkbox help.
     * @member {string} help
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.help = "";

    /**
     * Checkbox formId.
     * @member {string} formId
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.formId = "";

    /**
     * Checkbox value.
     * @member {boolean} value
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.value = false;

    /**
     * Checkbox setValue.
     * @member {boolean} setValue
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.setValue = false;

    /**
     * Checkbox disabled.
     * @member {boolean} disabled
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.disabled = false;

    /**
     * Checkbox labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.labelVisibility = null;

    /**
     * Checkbox type.
     * @member {Checkbox.StyleType} type
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.type = 0;

    /**
     * Checkbox queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.queryParamKey = null;

    /**
     * Checkbox wrap.
     * @member {boolean|null|undefined} wrap
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.wrap = null;

    /**
     * Checkbox ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof Checkbox
     * @instance
     */
    Checkbox.prototype.ignoreRerun = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Checkbox.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Checkbox.prototype, "_wrap", {
        get: $util.oneOfGetter($oneOfFields = ["wrap"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Checkbox instance using the specified properties.
     * @function create
     * @memberof Checkbox
     * @static
     * @param {Checkbox.$Properties=} [properties] Properties to set
     * @returns {Checkbox} Checkbox instance
     * @type {{
     *   (properties: Checkbox.$Shape): Checkbox & Checkbox.$Shape;
     *   (properties?: Checkbox.$Properties): Checkbox;
     * }}
     */
    Checkbox.create = function(properties) {
        return new Checkbox(properties);
    };

    /**
     * Encodes the specified Checkbox message. Does not implicitly {@link Checkbox.verify|verify} messages.
     * @function encode
     * @memberof Checkbox
     * @static
     * @param {Checkbox.$Properties} message Checkbox message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Checkbox.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default") && message["default"] !== false)
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message["default"]);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.formId);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value") && message.value !== false)
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.value);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.setValue);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 9, wireType 2 =*/74).fork(), _depth + 1).ldelim();
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== 0)
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.type);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.queryParamKey);
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.wrap);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.ignoreRerun);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Checkbox message from the specified reader or buffer.
     * @function decode
     * @memberof Checkbox
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Checkbox & Checkbox.$Shape} Checkbox
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Checkbox.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Checkbox();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message["default"] = value;
                    else
                        delete message["default"];
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.value = value;
                    else
                        delete message.value;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 12: {
                    if (wireType !== 0)
                        break;
                    message.wrap = reader.bool();
                    message._wrap = "wrap";
                    continue;
                }
            case 13: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Checkbox message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Checkbox
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Checkbox} Checkbox
     */
    Checkbox.fromObject = function (object, _depth) {
        if (object instanceof $root.Checkbox)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Checkbox: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Checkbox();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"] != null)
            if (object["default"])
                message["default"] = $Boolean(object["default"]);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.value != null)
            if (object.value)
                message.value = $Boolean(object.value);
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".Checkbox.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.type !== 0 && (typeof object.type !== "string" || $root.Checkbox.StyleType[object.type] !== 0))
            switch (object.type) {
            case "DEFAULT":
            case 0:
                message.type = 0;
                break;
            case "TOGGLE":
            case 1:
                message.type = 1;
                break;
            default:
                if (typeof object.type === "number" && (object.type | 0) === object.type)
                    message.type = object.type;
            }
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.wrap != null)
            message.wrap = $Boolean(object.wrap);
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        return message;
    };

    /**
     * Creates a plain object from a Checkbox message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Checkbox
     * @static
     * @param {Checkbox} message Checkbox
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Checkbox.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object["default"] = false;
            object.help = "";
            object.formId = "";
            object.value = false;
            object.setValue = false;
            object.disabled = false;
            object.labelVisibility = null;
            object.type = options.enums === $String ? "DEFAULT" : 0;
            object.ignoreRerun = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = message.value;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = options.enums === $String ? $root.Checkbox.StyleType[message.type] === $undefined ? message.type : $root.Checkbox.StyleType[message.type] : message.type;
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            object.wrap = message.wrap;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        return object;
    };

    /**
     * Converts this Checkbox to JSON.
     * @function toJSON
     * @memberof Checkbox
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Checkbox.prototype.toJSON = function() {
        return Checkbox.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Checkbox
     * @function getTypeUrl
     * @memberof Checkbox
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Checkbox.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Checkbox";
    };

    /**
     * StyleType enum.
     * @name Checkbox.StyleType
     * @enum {number}
     * @property {number} DEFAULT=0 DEFAULT value
     * @property {number} TOGGLE=1 TOGGLE value
     */
    Checkbox.StyleType = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "DEFAULT"] = 0;
        values[valuesById[1] = "TOGGLE"] = 1;
        return values;
    })();

    return Checkbox;
})();

export const Code = $root.Code = (() => {

    /**
     * Properties of a Code.
     * @typedef {Object} Code.$Properties
     * @property {string|null} [codeText] Code codeText
     * @property {string|null} [language] Code language
     * @property {boolean|null} [showLineNumbers] Code showLineNumbers
     * @property {boolean|null} [wrapLines] Code wrapLines
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Code.
     * @exports ICode
     * @interface ICode
     * @augments Code.$Properties
     * @deprecated Use Code.$Properties instead.
     */

    /**
     * Shape of a Code.
     * @typedef {Code.$Properties} Code.$Shape
     */

    /**
     * Constructs a new Code.
     * @exports Code
     * @classdesc Represents a Code.
     * @constructor
     * @param {Code.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Code = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Code codeText.
     * @member {string} codeText
     * @memberof Code
     * @instance
     */
    Code.prototype.codeText = "";

    /**
     * Code language.
     * @member {string} language
     * @memberof Code
     * @instance
     */
    Code.prototype.language = "";

    /**
     * Code showLineNumbers.
     * @member {boolean} showLineNumbers
     * @memberof Code
     * @instance
     */
    Code.prototype.showLineNumbers = false;

    /**
     * Code wrapLines.
     * @member {boolean} wrapLines
     * @memberof Code
     * @instance
     */
    Code.prototype.wrapLines = false;

    /**
     * Creates a new Code instance using the specified properties.
     * @function create
     * @memberof Code
     * @static
     * @param {Code.$Properties=} [properties] Properties to set
     * @returns {Code} Code instance
     * @type {{
     *   (properties: Code.$Shape): Code & Code.$Shape;
     *   (properties?: Code.$Properties): Code;
     * }}
     */
    Code.create = function(properties) {
        return new Code(properties);
    };

    /**
     * Encodes the specified Code message. Does not implicitly {@link Code.verify|verify} messages.
     * @function encode
     * @memberof Code
     * @static
     * @param {Code.$Properties} message Code message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Code.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.codeText != null && $Object.hasOwnProperty.call(message, "codeText") && message.codeText !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.codeText);
        if (message.language != null && $Object.hasOwnProperty.call(message, "language") && message.language !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.language);
        if (message.showLineNumbers != null && $Object.hasOwnProperty.call(message, "showLineNumbers") && message.showLineNumbers !== false)
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.showLineNumbers);
        if (message.wrapLines != null && $Object.hasOwnProperty.call(message, "wrapLines") && message.wrapLines !== false)
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.wrapLines);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Code message from the specified reader or buffer.
     * @function decode
     * @memberof Code
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Code & Code.$Shape} Code
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Code.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Code();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.codeText = value;
                    else
                        delete message.codeText;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.language = value;
                    else
                        delete message.language;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.showLineNumbers = value;
                    else
                        delete message.showLineNumbers;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.wrapLines = value;
                    else
                        delete message.wrapLines;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Code message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Code
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Code} Code
     */
    Code.fromObject = function (object, _depth) {
        if (object instanceof $root.Code)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Code: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Code();
        if (object.codeText != null)
            if (typeof object.codeText !== "string" || object.codeText.length)
                message.codeText = $String(object.codeText);
        if (object.language != null)
            if (typeof object.language !== "string" || object.language.length)
                message.language = $String(object.language);
        if (object.showLineNumbers != null)
            if (object.showLineNumbers)
                message.showLineNumbers = $Boolean(object.showLineNumbers);
        if (object.wrapLines != null)
            if (object.wrapLines)
                message.wrapLines = $Boolean(object.wrapLines);
        return message;
    };

    /**
     * Creates a plain object from a Code message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Code
     * @static
     * @param {Code} message Code
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Code.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.codeText = "";
            object.language = "";
            object.showLineNumbers = false;
            object.wrapLines = false;
        }
        if (message.codeText != null && $Object.hasOwnProperty.call(message, "codeText"))
            object.codeText = message.codeText;
        if (message.language != null && $Object.hasOwnProperty.call(message, "language"))
            object.language = message.language;
        if (message.showLineNumbers != null && $Object.hasOwnProperty.call(message, "showLineNumbers"))
            object.showLineNumbers = message.showLineNumbers;
        if (message.wrapLines != null && $Object.hasOwnProperty.call(message, "wrapLines"))
            object.wrapLines = message.wrapLines;
        return object;
    };

    /**
     * Converts this Code to JSON.
     * @function toJSON
     * @memberof Code
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Code.prototype.toJSON = function() {
        return Code.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Code
     * @function getTypeUrl
     * @memberof Code
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Code.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Code";
    };

    return Code;
})();

export const ColorPicker = $root.ColorPicker = (() => {

    /**
     * Properties of a ColorPicker.
     * @typedef {Object} ColorPicker.$Properties
     * @property {string|null} [id] ColorPicker id
     * @property {string|null} [label] ColorPicker label
     * @property {string|null} ["default"] ColorPicker default
     * @property {string|null} [help] ColorPicker help
     * @property {string|null} [formId] ColorPicker formId
     * @property {string|null} [value] ColorPicker value
     * @property {boolean|null} [setValue] ColorPicker setValue
     * @property {boolean|null} [disabled] ColorPicker disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] ColorPicker labelVisibility
     * @property {string|null} [queryParamKey] ColorPicker queryParamKey
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ColorPicker.
     * @exports IColorPicker
     * @interface IColorPicker
     * @augments ColorPicker.$Properties
     * @deprecated Use ColorPicker.$Properties instead.
     */

    /**
     * Shape of a ColorPicker.
     * @typedef {ColorPicker.$Properties} ColorPicker.$Shape
     */

    /**
     * Constructs a new ColorPicker.
     * @exports ColorPicker
     * @classdesc Represents a ColorPicker.
     * @constructor
     * @param {ColorPicker.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ColorPicker = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ColorPicker id.
     * @member {string} id
     * @memberof ColorPicker
     * @instance
     */
    ColorPicker.prototype.id = "";

    /**
     * ColorPicker label.
     * @member {string} label
     * @memberof ColorPicker
     * @instance
     */
    ColorPicker.prototype.label = "";

    /**
     * ColorPicker default.
     * @member {string} default
     * @memberof ColorPicker
     * @instance
     */
    ColorPicker.prototype["default"] = "";

    /**
     * ColorPicker help.
     * @member {string} help
     * @memberof ColorPicker
     * @instance
     */
    ColorPicker.prototype.help = "";

    /**
     * ColorPicker formId.
     * @member {string} formId
     * @memberof ColorPicker
     * @instance
     */
    ColorPicker.prototype.formId = "";

    /**
     * ColorPicker value.
     * @member {string} value
     * @memberof ColorPicker
     * @instance
     */
    ColorPicker.prototype.value = "";

    /**
     * ColorPicker setValue.
     * @member {boolean} setValue
     * @memberof ColorPicker
     * @instance
     */
    ColorPicker.prototype.setValue = false;

    /**
     * ColorPicker disabled.
     * @member {boolean} disabled
     * @memberof ColorPicker
     * @instance
     */
    ColorPicker.prototype.disabled = false;

    /**
     * ColorPicker labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof ColorPicker
     * @instance
     */
    ColorPicker.prototype.labelVisibility = null;

    /**
     * ColorPicker queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof ColorPicker
     * @instance
     */
    ColorPicker.prototype.queryParamKey = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(ColorPicker.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ColorPicker instance using the specified properties.
     * @function create
     * @memberof ColorPicker
     * @static
     * @param {ColorPicker.$Properties=} [properties] Properties to set
     * @returns {ColorPicker} ColorPicker instance
     * @type {{
     *   (properties: ColorPicker.$Shape): ColorPicker & ColorPicker.$Shape;
     *   (properties?: ColorPicker.$Properties): ColorPicker;
     * }}
     */
    ColorPicker.create = function(properties) {
        return new ColorPicker(properties);
    };

    /**
     * Encodes the specified ColorPicker message. Does not implicitly {@link ColorPicker.verify|verify} messages.
     * @function encode
     * @memberof ColorPicker
     * @static
     * @param {ColorPicker.$Properties} message ColorPicker message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ColorPicker.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default") && message["default"] !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message["default"]);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.formId);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value") && message.value !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.value);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.setValue);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 9, wireType 2 =*/74).fork(), _depth + 1).ldelim();
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.queryParamKey);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ColorPicker message from the specified reader or buffer.
     * @function decode
     * @memberof ColorPicker
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ColorPicker & ColorPicker.$Shape} ColorPicker
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ColorPicker.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ColorPicker();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message["default"] = value;
                    else
                        delete message["default"];
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.value = value;
                    else
                        delete message.value;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ColorPicker message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ColorPicker
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ColorPicker} ColorPicker
     */
    ColorPicker.fromObject = function (object, _depth) {
        if (object instanceof $root.ColorPicker)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ColorPicker: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ColorPicker();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"] != null)
            if (typeof object["default"] !== "string" || object["default"].length)
                message["default"] = $String(object["default"]);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.value != null)
            if (typeof object.value !== "string" || object.value.length)
                message.value = $String(object.value);
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".ColorPicker.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        return message;
    };

    /**
     * Creates a plain object from a ColorPicker message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ColorPicker
     * @static
     * @param {ColorPicker} message ColorPicker
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ColorPicker.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object["default"] = "";
            object.help = "";
            object.formId = "";
            object.value = "";
            object.setValue = false;
            object.disabled = false;
            object.labelVisibility = null;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = message.value;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        return object;
    };

    /**
     * Converts this ColorPicker to JSON.
     * @function toJSON
     * @memberof ColorPicker
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ColorPicker.prototype.toJSON = function() {
        return ColorPicker.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ColorPicker
     * @function getTypeUrl
     * @memberof ColorPicker
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ColorPicker.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ColorPicker";
    };

    return ColorPicker;
})();

export const DateInput = $root.DateInput = (() => {

    /**
     * Properties of a DateInput.
     * @typedef {Object} DateInput.$Properties
     * @property {string|null} [id] DateInput id
     * @property {string|null} [label] DateInput label
     * @property {Array.<string>|null} ["default"] DateInput default
     * @property {string|null} [min] DateInput min
     * @property {string|null} [max] DateInput max
     * @property {boolean|null} [isRange] DateInput isRange
     * @property {string|null} [help] DateInput help
     * @property {string|null} [formId] DateInput formId
     * @property {Array.<string>|null} [value] DateInput value
     * @property {boolean|null} [setValue] DateInput setValue
     * @property {boolean|null} [disabled] DateInput disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] DateInput labelVisibility
     * @property {string|null} [format] DateInput format
     * @property {string|null} [queryParamKey] DateInput queryParamKey
     * @property {boolean|null} [ignoreRerun] DateInput ignoreRerun
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DateInput.
     * @exports IDateInput
     * @interface IDateInput
     * @augments DateInput.$Properties
     * @deprecated Use DateInput.$Properties instead.
     */

    /**
     * Shape of a DateInput.
     * @typedef {DateInput.$Properties} DateInput.$Shape
     */

    /**
     * Constructs a new DateInput.
     * @exports DateInput
     * @classdesc Represents a DateInput.
     * @constructor
     * @param {DateInput.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DateInput = function (properties) {
        this["default"] = [];
        this.value = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * DateInput id.
     * @member {string} id
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.id = "";

    /**
     * DateInput label.
     * @member {string} label
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.label = "";

    /**
     * DateInput default.
     * @member {Array.<string>} default
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype["default"] = $util.emptyArray;

    /**
     * DateInput min.
     * @member {string} min
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.min = "";

    /**
     * DateInput max.
     * @member {string} max
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.max = "";

    /**
     * DateInput isRange.
     * @member {boolean} isRange
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.isRange = false;

    /**
     * DateInput help.
     * @member {string} help
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.help = "";

    /**
     * DateInput formId.
     * @member {string} formId
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.formId = "";

    /**
     * DateInput value.
     * @member {Array.<string>} value
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.value = $util.emptyArray;

    /**
     * DateInput setValue.
     * @member {boolean} setValue
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.setValue = false;

    /**
     * DateInput disabled.
     * @member {boolean} disabled
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.disabled = false;

    /**
     * DateInput labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.labelVisibility = null;

    /**
     * DateInput format.
     * @member {string} format
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.format = "";

    /**
     * DateInput queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.queryParamKey = null;

    /**
     * DateInput ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof DateInput
     * @instance
     */
    DateInput.prototype.ignoreRerun = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(DateInput.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new DateInput instance using the specified properties.
     * @function create
     * @memberof DateInput
     * @static
     * @param {DateInput.$Properties=} [properties] Properties to set
     * @returns {DateInput} DateInput instance
     * @type {{
     *   (properties: DateInput.$Shape): DateInput & DateInput.$Shape;
     *   (properties?: DateInput.$Properties): DateInput;
     * }}
     */
    DateInput.create = function(properties) {
        return new DateInput(properties);
    };

    /**
     * Encodes the specified DateInput message. Does not implicitly {@link DateInput.verify|verify} messages.
     * @function encode
     * @memberof DateInput
     * @static
     * @param {DateInput.$Properties} message DateInput message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DateInput.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && message["default"].length)
            for (let i = 0; i < message["default"].length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message["default"][i]);
        if (message.min != null && $Object.hasOwnProperty.call(message, "min") && message.min !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.min);
        if (message.max != null && $Object.hasOwnProperty.call(message, "max") && message.max !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.max);
        if (message.isRange != null && $Object.hasOwnProperty.call(message, "isRange") && message.isRange !== false)
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isRange);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.formId);
        if (message.value != null && message.value.length)
            for (let i = 0; i < message.value.length; ++i)
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.value[i]);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.setValue);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 12, wireType 2 =*/98).fork(), _depth + 1).ldelim();
        if (message.format != null && $Object.hasOwnProperty.call(message, "format") && message.format !== "")
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.format);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.queryParamKey);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.ignoreRerun);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DateInput message from the specified reader or buffer.
     * @function decode
     * @memberof DateInput
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DateInput & DateInput.$Shape} DateInput
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DateInput.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DateInput();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if (!(message["default"] && message["default"].length))
                        message["default"] = [];
                    message["default"].push(reader.stringVerify());
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.min = value;
                    else
                        delete message.min;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.max = value;
                    else
                        delete message.max;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isRange = value;
                    else
                        delete message.isRange;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    if (!(message.value && message.value.length))
                        message.value = [];
                    message.value.push(reader.stringVerify());
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 11: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.format = value;
                    else
                        delete message.format;
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 15: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DateInput message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DateInput
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DateInput} DateInput
     */
    DateInput.fromObject = function (object, _depth) {
        if (object instanceof $root.DateInput)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DateInput: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.DateInput();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"]) {
            if (!$Array.isArray(object["default"]))
                throw $TypeError(".DateInput.default: array expected");
            message["default"] = $Array(object["default"].length);
            for (let i = 0; i < object["default"].length; ++i)
                message["default"][i] = $String(object["default"][i]);
        }
        if (object.min != null)
            if (typeof object.min !== "string" || object.min.length)
                message.min = $String(object.min);
        if (object.max != null)
            if (typeof object.max !== "string" || object.max.length)
                message.max = $String(object.max);
        if (object.isRange != null)
            if (object.isRange)
                message.isRange = $Boolean(object.isRange);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.value) {
            if (!$Array.isArray(object.value))
                throw $TypeError(".DateInput.value: array expected");
            message.value = $Array(object.value.length);
            for (let i = 0; i < object.value.length; ++i)
                message.value[i] = $String(object.value[i]);
        }
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".DateInput.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.format != null)
            if (typeof object.format !== "string" || object.format.length)
                message.format = $String(object.format);
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        return message;
    };

    /**
     * Creates a plain object from a DateInput message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DateInput
     * @static
     * @param {DateInput} message DateInput
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DateInput.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object["default"] = [];
            object.value = [];
        }
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.min = "";
            object.max = "";
            object.isRange = false;
            object.help = "";
            object.formId = "";
            object.setValue = false;
            object.disabled = false;
            object.labelVisibility = null;
            object.format = "";
            object.ignoreRerun = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] && message["default"].length) {
            object["default"] = $Array(message["default"].length);
            for (let j = 0; j < message["default"].length; ++j)
                object["default"][j] = message["default"][j];
        }
        if (message.min != null && $Object.hasOwnProperty.call(message, "min"))
            object.min = message.min;
        if (message.max != null && $Object.hasOwnProperty.call(message, "max"))
            object.max = message.max;
        if (message.isRange != null && $Object.hasOwnProperty.call(message, "isRange"))
            object.isRange = message.isRange;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.value && message.value.length) {
            object.value = $Array(message.value.length);
            for (let j = 0; j < message.value.length; ++j)
                object.value[j] = message.value[j];
        }
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.format != null && $Object.hasOwnProperty.call(message, "format"))
            object.format = message.format;
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        return object;
    };

    /**
     * Converts this DateInput to JSON.
     * @function toJSON
     * @memberof DateInput
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DateInput.prototype.toJSON = function() {
        return DateInput.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DateInput
     * @function getTypeUrl
     * @memberof DateInput
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DateInput.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DateInput";
    };

    return DateInput;
})();

export const DateTimeInput = $root.DateTimeInput = (() => {

    /**
     * Properties of a DateTimeInput.
     * @typedef {Object} DateTimeInput.$Properties
     * @property {string|null} [id] DateTimeInput id
     * @property {string|null} [label] DateTimeInput label
     * @property {Array.<string>|null} ["default"] DateTimeInput default
     * @property {string|null} [min] DateTimeInput min
     * @property {string|null} [max] DateTimeInput max
     * @property {string|null} [help] DateTimeInput help
     * @property {string|null} [formId] DateTimeInput formId
     * @property {Array.<string>|null} [value] DateTimeInput value
     * @property {boolean|null} [setValue] DateTimeInput setValue
     * @property {boolean|null} [disabled] DateTimeInput disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] DateTimeInput labelVisibility
     * @property {string|null} [format] DateTimeInput format
     * @property {number|Long|null} [step] DateTimeInput step
     * @property {boolean|null} [isRange] DateTimeInput isRange
     * @property {string|null} [queryParamKey] DateTimeInput queryParamKey
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DateTimeInput.
     * @exports IDateTimeInput
     * @interface IDateTimeInput
     * @augments DateTimeInput.$Properties
     * @deprecated Use DateTimeInput.$Properties instead.
     */

    /**
     * Shape of a DateTimeInput.
     * @typedef {DateTimeInput.$Properties} DateTimeInput.$Shape
     */

    /**
     * Constructs a new DateTimeInput.
     * @exports DateTimeInput
     * @classdesc Represents a DateTimeInput.
     * @constructor
     * @param {DateTimeInput.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DateTimeInput = function (properties) {
        this["default"] = [];
        this.value = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * DateTimeInput id.
     * @member {string} id
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.id = "";

    /**
     * DateTimeInput label.
     * @member {string} label
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.label = "";

    /**
     * DateTimeInput default.
     * @member {Array.<string>} default
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype["default"] = $util.emptyArray;

    /**
     * DateTimeInput min.
     * @member {string} min
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.min = "";

    /**
     * DateTimeInput max.
     * @member {string} max
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.max = "";

    /**
     * DateTimeInput help.
     * @member {string} help
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.help = "";

    /**
     * DateTimeInput formId.
     * @member {string} formId
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.formId = "";

    /**
     * DateTimeInput value.
     * @member {Array.<string>} value
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.value = $util.emptyArray;

    /**
     * DateTimeInput setValue.
     * @member {boolean} setValue
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.setValue = false;

    /**
     * DateTimeInput disabled.
     * @member {boolean} disabled
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.disabled = false;

    /**
     * DateTimeInput labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.labelVisibility = null;

    /**
     * DateTimeInput format.
     * @member {string} format
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.format = "";

    /**
     * DateTimeInput step.
     * @member {number|Long} step
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.step = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * DateTimeInput isRange.
     * @member {boolean} isRange
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.isRange = false;

    /**
     * DateTimeInput queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof DateTimeInput
     * @instance
     */
    DateTimeInput.prototype.queryParamKey = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(DateTimeInput.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new DateTimeInput instance using the specified properties.
     * @function create
     * @memberof DateTimeInput
     * @static
     * @param {DateTimeInput.$Properties=} [properties] Properties to set
     * @returns {DateTimeInput} DateTimeInput instance
     * @type {{
     *   (properties: DateTimeInput.$Shape): DateTimeInput & DateTimeInput.$Shape;
     *   (properties?: DateTimeInput.$Properties): DateTimeInput;
     * }}
     */
    DateTimeInput.create = function(properties) {
        return new DateTimeInput(properties);
    };

    /**
     * Encodes the specified DateTimeInput message. Does not implicitly {@link DateTimeInput.verify|verify} messages.
     * @function encode
     * @memberof DateTimeInput
     * @static
     * @param {DateTimeInput.$Properties} message DateTimeInput message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DateTimeInput.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && message["default"].length)
            for (let i = 0; i < message["default"].length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message["default"][i]);
        if (message.min != null && $Object.hasOwnProperty.call(message, "min") && message.min !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.min);
        if (message.max != null && $Object.hasOwnProperty.call(message, "max") && message.max !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.max);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.formId);
        if (message.value != null && message.value.length)
            for (let i = 0; i < message.value.length; ++i)
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.value[i]);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.setValue);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 11, wireType 2 =*/90).fork(), _depth + 1).ldelim();
        if (message.format != null && $Object.hasOwnProperty.call(message, "format") && message.format !== "")
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.format);
        if (message.step != null && $Object.hasOwnProperty.call(message, "step") && (typeof message.step === "object" ? message.step.low || message.step.high : message.step !== 0))
            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.step);
        if (message.isRange != null && $Object.hasOwnProperty.call(message, "isRange") && message.isRange !== false)
            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.isRange);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.queryParamKey);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DateTimeInput message from the specified reader or buffer.
     * @function decode
     * @memberof DateTimeInput
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DateTimeInput & DateTimeInput.$Shape} DateTimeInput
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DateTimeInput.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DateTimeInput();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if (!(message["default"] && message["default"].length))
                        message["default"] = [];
                    message["default"].push(reader.stringVerify());
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.min = value;
                    else
                        delete message.min;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.max = value;
                    else
                        delete message.max;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    if (!(message.value && message.value.length))
                        message.value = [];
                    message.value.push(reader.stringVerify());
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.format = value;
                    else
                        delete message.format;
                    continue;
                }
            case 13: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                        message.step = value;
                    else
                        delete message.step;
                    continue;
                }
            case 14: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isRange = value;
                    else
                        delete message.isRange;
                    continue;
                }
            case 15: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DateTimeInput message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DateTimeInput
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DateTimeInput} DateTimeInput
     */
    DateTimeInput.fromObject = function (object, _depth) {
        if (object instanceof $root.DateTimeInput)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DateTimeInput: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.DateTimeInput();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"]) {
            if (!$Array.isArray(object["default"]))
                throw $TypeError(".DateTimeInput.default: array expected");
            message["default"] = $Array(object["default"].length);
            for (let i = 0; i < object["default"].length; ++i)
                message["default"][i] = $String(object["default"][i]);
        }
        if (object.min != null)
            if (typeof object.min !== "string" || object.min.length)
                message.min = $String(object.min);
        if (object.max != null)
            if (typeof object.max !== "string" || object.max.length)
                message.max = $String(object.max);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.value) {
            if (!$Array.isArray(object.value))
                throw $TypeError(".DateTimeInput.value: array expected");
            message.value = $Array(object.value.length);
            for (let i = 0; i < object.value.length; ++i)
                message.value[i] = $String(object.value[i]);
        }
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".DateTimeInput.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.format != null)
            if (typeof object.format !== "string" || object.format.length)
                message.format = $String(object.format);
        if (object.step != null)
            if (typeof object.step === "object" ? object.step.low || object.step.high : $Number(object.step) !== 0)
                if ($util.Long)
                    message.step = $util.Long.fromValue(object.step, false);
                else if (typeof object.step === "string")
                    message.step = $parseInt(object.step, 10);
                else if (typeof object.step === "number")
                    message.step = object.step;
                else if (typeof object.step === "object")
                    message.step = new $util.LongBits(object.step.low >>> 0, object.step.high >>> 0).toNumber();
        if (object.isRange != null)
            if (object.isRange)
                message.isRange = $Boolean(object.isRange);
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        return message;
    };

    /**
     * Creates a plain object from a DateTimeInput message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DateTimeInput
     * @static
     * @param {DateTimeInput} message DateTimeInput
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DateTimeInput.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object["default"] = [];
            object.value = [];
        }
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.min = "";
            object.max = "";
            object.help = "";
            object.formId = "";
            object.setValue = false;
            object.disabled = false;
            object.labelVisibility = null;
            object.format = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.step = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.step = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            object.isRange = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] && message["default"].length) {
            object["default"] = $Array(message["default"].length);
            for (let j = 0; j < message["default"].length; ++j)
                object["default"][j] = message["default"][j];
        }
        if (message.min != null && $Object.hasOwnProperty.call(message, "min"))
            object.min = message.min;
        if (message.max != null && $Object.hasOwnProperty.call(message, "max"))
            object.max = message.max;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.value && message.value.length) {
            object.value = $Array(message.value.length);
            for (let j = 0; j < message.value.length; ++j)
                object.value[j] = message.value[j];
        }
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.format != null && $Object.hasOwnProperty.call(message, "format"))
            object.format = message.format;
        if (message.step != null && $Object.hasOwnProperty.call(message, "step"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.step = typeof message.step === "number" ? $BigInt(message.step) : $util.Long.fromBits(message.step.low >>> 0, message.step.high >>> 0, false).toBigInt();
            else if (typeof message.step === "number")
                object.step = options.longs === $String ? $String(message.step) : message.step;
            else
                object.step = options.longs === $String ? $util.Long.prototype.toString.call(message.step) : options.longs === $Number ? new $util.LongBits(message.step.low >>> 0, message.step.high >>> 0).toNumber() : message.step;
        if (message.isRange != null && $Object.hasOwnProperty.call(message, "isRange"))
            object.isRange = message.isRange;
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        return object;
    };

    /**
     * Converts this DateTimeInput to JSON.
     * @function toJSON
     * @memberof DateTimeInput
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DateTimeInput.prototype.toJSON = function() {
        return DateTimeInput.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DateTimeInput
     * @function getTypeUrl
     * @memberof DateTimeInput
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DateTimeInput.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DateTimeInput";
    };

    return DateTimeInput;
})();

export const DeckGlJsonChart = $root.DeckGlJsonChart = (() => {

    /**
     * Properties of a DeckGlJsonChart.
     * @typedef {Object} DeckGlJsonChart.$Properties
     * @property {string|null} [json] DeckGlJsonChart json
     * @property {string|null} [tooltip] DeckGlJsonChart tooltip
     * @property {string|null} [id] DeckGlJsonChart id
     * @property {string|null} [mapboxToken] DeckGlJsonChart mapboxToken
     * @property {Array.<DeckGlJsonChart.SelectionMode>|null} [selectionMode] DeckGlJsonChart selectionMode
     * @property {string|null} [formId] DeckGlJsonChart formId
     * @property {string|null} [alt] DeckGlJsonChart alt
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DeckGlJsonChart.
     * @exports IDeckGlJsonChart
     * @interface IDeckGlJsonChart
     * @augments DeckGlJsonChart.$Properties
     * @deprecated Use DeckGlJsonChart.$Properties instead.
     */

    /**
     * Shape of a DeckGlJsonChart.
     * @typedef {DeckGlJsonChart.$Properties} DeckGlJsonChart.$Shape
     */

    /**
     * Constructs a new DeckGlJsonChart.
     * @exports DeckGlJsonChart
     * @classdesc Represents a DeckGlJsonChart.
     * @constructor
     * @param {DeckGlJsonChart.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DeckGlJsonChart = function (properties) {
        this.selectionMode = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * DeckGlJsonChart json.
     * @member {string} json
     * @memberof DeckGlJsonChart
     * @instance
     */
    DeckGlJsonChart.prototype.json = "";

    /**
     * DeckGlJsonChart tooltip.
     * @member {string} tooltip
     * @memberof DeckGlJsonChart
     * @instance
     */
    DeckGlJsonChart.prototype.tooltip = "";

    /**
     * DeckGlJsonChart id.
     * @member {string} id
     * @memberof DeckGlJsonChart
     * @instance
     */
    DeckGlJsonChart.prototype.id = "";

    /**
     * DeckGlJsonChart mapboxToken.
     * @member {string} mapboxToken
     * @memberof DeckGlJsonChart
     * @instance
     */
    DeckGlJsonChart.prototype.mapboxToken = "";

    /**
     * DeckGlJsonChart selectionMode.
     * @member {Array.<DeckGlJsonChart.SelectionMode>} selectionMode
     * @memberof DeckGlJsonChart
     * @instance
     */
    DeckGlJsonChart.prototype.selectionMode = $util.emptyArray;

    /**
     * DeckGlJsonChart formId.
     * @member {string} formId
     * @memberof DeckGlJsonChart
     * @instance
     */
    DeckGlJsonChart.prototype.formId = "";

    /**
     * DeckGlJsonChart alt.
     * @member {string|null|undefined} alt
     * @memberof DeckGlJsonChart
     * @instance
     */
    DeckGlJsonChart.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(DeckGlJsonChart.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new DeckGlJsonChart instance using the specified properties.
     * @function create
     * @memberof DeckGlJsonChart
     * @static
     * @param {DeckGlJsonChart.$Properties=} [properties] Properties to set
     * @returns {DeckGlJsonChart} DeckGlJsonChart instance
     * @type {{
     *   (properties: DeckGlJsonChart.$Shape): DeckGlJsonChart & DeckGlJsonChart.$Shape;
     *   (properties?: DeckGlJsonChart.$Properties): DeckGlJsonChart;
     * }}
     */
    DeckGlJsonChart.create = function(properties) {
        return new DeckGlJsonChart(properties);
    };

    /**
     * Encodes the specified DeckGlJsonChart message. Does not implicitly {@link DeckGlJsonChart.verify|verify} messages.
     * @function encode
     * @memberof DeckGlJsonChart
     * @static
     * @param {DeckGlJsonChart.$Properties} message DeckGlJsonChart message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeckGlJsonChart.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.json != null && $Object.hasOwnProperty.call(message, "json") && message.json !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.json);
        if (message.tooltip != null && $Object.hasOwnProperty.call(message, "tooltip") && message.tooltip !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.tooltip);
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.id);
        if (message.mapboxToken != null && $Object.hasOwnProperty.call(message, "mapboxToken") && message.mapboxToken !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.mapboxToken);
        if (message.selectionMode != null && message.selectionMode.length)
            writer.uint32(/* id 9, wireType 2 =*/74).int32s(message.selectionMode);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.formId);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DeckGlJsonChart message from the specified reader or buffer.
     * @function decode
     * @memberof DeckGlJsonChart
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeckGlJsonChart & DeckGlJsonChart.$Shape} DeckGlJsonChart
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeckGlJsonChart.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DeckGlJsonChart();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.json = value;
                    else
                        delete message.json;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.tooltip = value;
                    else
                        delete message.tooltip;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.mapboxToken = value;
                    else
                        delete message.mapboxToken;
                    continue;
                }
            case 9: {
                    if (wireType === 2) {
                        if (!(message.selectionMode && message.selectionMode.length))
                            message.selectionMode = [];
                        reader.int32s(message.selectionMode);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message.selectionMode && message.selectionMode.length))
                        message.selectionMode = [];
                    message.selectionMode.push(reader.int32());
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DeckGlJsonChart message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeckGlJsonChart
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeckGlJsonChart} DeckGlJsonChart
     */
    DeckGlJsonChart.fromObject = function (object, _depth) {
        if (object instanceof $root.DeckGlJsonChart)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DeckGlJsonChart: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.DeckGlJsonChart();
        if (object.json != null)
            if (typeof object.json !== "string" || object.json.length)
                message.json = $String(object.json);
        if (object.tooltip != null)
            if (typeof object.tooltip !== "string" || object.tooltip.length)
                message.tooltip = $String(object.tooltip);
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.mapboxToken != null)
            if (typeof object.mapboxToken !== "string" || object.mapboxToken.length)
                message.mapboxToken = $String(object.mapboxToken);
        if (object.selectionMode) {
            if (!$Array.isArray(object.selectionMode))
                throw $TypeError(".DeckGlJsonChart.selectionMode: array expected");
            message.selectionMode = [];
            for (let i = 0; i < object.selectionMode.length; ++i)
                switch (object.selectionMode[i]) {
                case "SINGLE_OBJECT":
                case 0:
                    message.selectionMode[message.selectionMode.length] = 0;
                    break;
                case "MULTI_OBJECT":
                case 1:
                    message.selectionMode[message.selectionMode.length] = 1;
                    break;
                default:
                    if (typeof object.selectionMode[i] === "number" && (object.selectionMode[i] | 0) === object.selectionMode[i])
                        message.selectionMode[message.selectionMode.length] = object.selectionMode[i];
                }
        }
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from a DeckGlJsonChart message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeckGlJsonChart
     * @static
     * @param {DeckGlJsonChart} message DeckGlJsonChart
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeckGlJsonChart.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.selectionMode = [];
        if (options.defaults) {
            object.json = "";
            object.tooltip = "";
            object.id = "";
            object.mapboxToken = "";
            object.formId = "";
        }
        if (message.json != null && $Object.hasOwnProperty.call(message, "json"))
            object.json = message.json;
        if (message.tooltip != null && $Object.hasOwnProperty.call(message, "tooltip"))
            object.tooltip = message.tooltip;
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.mapboxToken != null && $Object.hasOwnProperty.call(message, "mapboxToken"))
            object.mapboxToken = message.mapboxToken;
        if (message.selectionMode && message.selectionMode.length) {
            object.selectionMode = $Array(message.selectionMode.length);
            for (let j = 0; j < message.selectionMode.length; ++j)
                object.selectionMode[j] = options.enums === $String ? $root.DeckGlJsonChart.SelectionMode[message.selectionMode[j]] === $undefined ? message.selectionMode[j] : $root.DeckGlJsonChart.SelectionMode[message.selectionMode[j]] : message.selectionMode[j];
        }
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this DeckGlJsonChart to JSON.
     * @function toJSON
     * @memberof DeckGlJsonChart
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeckGlJsonChart.prototype.toJSON = function() {
        return DeckGlJsonChart.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DeckGlJsonChart
     * @function getTypeUrl
     * @memberof DeckGlJsonChart
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DeckGlJsonChart.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DeckGlJsonChart";
    };

    /**
     * SelectionMode enum.
     * @name DeckGlJsonChart.SelectionMode
     * @enum {number}
     * @property {number} SINGLE_OBJECT=0 SINGLE_OBJECT value
     * @property {number} MULTI_OBJECT=1 MULTI_OBJECT value
     */
    DeckGlJsonChart.SelectionMode = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "SINGLE_OBJECT"] = 0;
        values[valuesById[1] = "MULTI_OBJECT"] = 1;
        return values;
    })();

    return DeckGlJsonChart;
})();

export const Delta = $root.Delta = (() => {

    /**
     * Properties of a Delta.
     * @typedef {Object} Delta.$Properties
     * @property {Element.$Properties|null} [newElement] Delta newElement
     * @property {Block.$Properties|null} [addBlock] Delta addBlock
     * @property {Transient.$Properties|null} [newTransient] Delta newTransient
     * @property {string|null} [fragmentId] Delta fragmentId
     * @property {"newElement"|"addBlock"|"newTransient"} [type] Delta type
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Delta.
     * @exports IDelta
     * @interface IDelta
     * @augments Delta.$Properties
     * @deprecated Use Delta.$Properties instead.
     */

    /**
     * Narrowed shape of a Delta.
     * @typedef {{
     *   newElement?: Element.$Shape|null;
     *   addBlock?: Block.$Shape|null;
     *   newTransient?: Transient.$Shape|null;
     *   fragmentId?: string|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ type?: undefined; newElement?: null; addBlock?: null; newTransient?: null }|{ type?: "newElement"; newElement: Element.$Shape; addBlock?: null; newTransient?: null }|{ type?: "addBlock"; newElement?: null; addBlock: Block.$Shape; newTransient?: null }|{ type?: "newTransient"; newElement?: null; addBlock?: null; newTransient: Transient.$Shape })
     * )} Delta.$Shape
     */

    /**
     * Constructs a new Delta.
     * @exports Delta
     * @classdesc Represents a Delta.
     * @constructor
     * @param {Delta.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Delta = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Delta newElement.
     * @member {Element.$Properties|null|undefined} newElement
     * @memberof Delta
     * @instance
     */
    Delta.prototype.newElement = null;

    /**
     * Delta addBlock.
     * @member {Block.$Properties|null|undefined} addBlock
     * @memberof Delta
     * @instance
     */
    Delta.prototype.addBlock = null;

    /**
     * Delta newTransient.
     * @member {Transient.$Properties|null|undefined} newTransient
     * @memberof Delta
     * @instance
     */
    Delta.prototype.newTransient = null;

    /**
     * Delta fragmentId.
     * @member {string} fragmentId
     * @memberof Delta
     * @instance
     */
    Delta.prototype.fragmentId = "";

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Delta type.
     * @member {"newElement"|"addBlock"|"newTransient"|undefined} type
     * @memberof Delta
     * @instance
     */
    $Object.defineProperty(Delta.prototype, "type", {
        get: $util.oneOfGetter($oneOfFields = ["newElement", "addBlock", "newTransient"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Delta instance using the specified properties.
     * @function create
     * @memberof Delta
     * @static
     * @param {Delta.$Properties=} [properties] Properties to set
     * @returns {Delta} Delta instance
     * @type {{
     *   (properties: Delta.$Shape): Delta & Delta.$Shape;
     *   (properties?: Delta.$Properties): Delta;
     * }}
     */
    Delta.create = function(properties) {
        return new Delta(properties);
    };

    /**
     * Encodes the specified Delta message. Does not implicitly {@link Delta.verify|verify} messages.
     * @function encode
     * @memberof Delta
     * @static
     * @param {Delta.$Properties} message Delta message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Delta.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.newElement != null && $Object.hasOwnProperty.call(message, "newElement"))
            $root.Element.encode(message.newElement, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
        if (message.addBlock != null && $Object.hasOwnProperty.call(message, "addBlock"))
            $root.Block.encode(message.addBlock, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
        if (message.fragmentId != null && $Object.hasOwnProperty.call(message, "fragmentId") && message.fragmentId !== "")
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.fragmentId);
        if (message.newTransient != null && $Object.hasOwnProperty.call(message, "newTransient"))
            $root.Transient.encode(message.newTransient, writer.uint32(/* id 9, wireType 2 =*/74).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Delta message from the specified reader or buffer.
     * @function decode
     * @memberof Delta
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Delta & Delta.$Shape} Delta
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Delta.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Delta();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.newElement = $root.Element.decode(reader, reader.uint32(), $undefined, _depth + 1, message.newElement);
                    message.type = "newElement";
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.addBlock = $root.Block.decode(reader, reader.uint32(), $undefined, _depth + 1, message.addBlock);
                    message.type = "addBlock";
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    message.newTransient = $root.Transient.decode(reader, reader.uint32(), $undefined, _depth + 1, message.newTransient);
                    message.type = "newTransient";
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.fragmentId = value;
                    else
                        delete message.fragmentId;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Delta message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Delta
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Delta} Delta
     */
    Delta.fromObject = function (object, _depth) {
        if (object instanceof $root.Delta)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Delta: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Delta();
        if (object.newElement != null) {
            if (!$util.isObject(object.newElement))
                throw $TypeError(".Delta.newElement: object expected");
            message.newElement = $root.Element.fromObject(object.newElement, _depth + 1);
        }
        if (object.addBlock != null) {
            if (!$util.isObject(object.addBlock))
                throw $TypeError(".Delta.addBlock: object expected");
            message.addBlock = $root.Block.fromObject(object.addBlock, _depth + 1);
        }
        if (object.newTransient != null) {
            if (!$util.isObject(object.newTransient))
                throw $TypeError(".Delta.newTransient: object expected");
            message.newTransient = $root.Transient.fromObject(object.newTransient, _depth + 1);
        }
        if (object.fragmentId != null)
            if (typeof object.fragmentId !== "string" || object.fragmentId.length)
                message.fragmentId = $String(object.fragmentId);
        return message;
    };

    /**
     * Creates a plain object from a Delta message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Delta
     * @static
     * @param {Delta} message Delta
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Delta.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.fragmentId = "";
        if (message.newElement != null && $Object.hasOwnProperty.call(message, "newElement")) {
            object.newElement = $root.Element.toObject(message.newElement, options, _depth + 1);
            if (options.oneofs)
                object.type = "newElement";
        }
        if (message.addBlock != null && $Object.hasOwnProperty.call(message, "addBlock")) {
            object.addBlock = $root.Block.toObject(message.addBlock, options, _depth + 1);
            if (options.oneofs)
                object.type = "addBlock";
        }
        if (message.fragmentId != null && $Object.hasOwnProperty.call(message, "fragmentId"))
            object.fragmentId = message.fragmentId;
        if (message.newTransient != null && $Object.hasOwnProperty.call(message, "newTransient")) {
            object.newTransient = $root.Transient.toObject(message.newTransient, options, _depth + 1);
            if (options.oneofs)
                object.type = "newTransient";
        }
        return object;
    };

    /**
     * Converts this Delta to JSON.
     * @function toJSON
     * @memberof Delta
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Delta.prototype.toJSON = function() {
        return Delta.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Delta
     * @function getTypeUrl
     * @memberof Delta
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Delta.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Delta";
    };

    return Delta;
})();

export const Element = $root.Element = (() => {

    /**
     * Properties of an Element.
     * @typedef {Object} Element.$Properties
     * @property {streamlit.HeightConfig.$Properties|null} [heightConfig] Element heightConfig
     * @property {streamlit.WidthConfig.$Properties|null} [widthConfig] Element widthConfig
     * @property {streamlit.TextAlignmentConfig.$Properties|null} [textAlignmentConfig] Element textAlignmentConfig
     * @property {boolean|null} [hasOneShotEffect] Element hasOneShotEffect
     * @property {Alert.$Properties|null} [alert] Element alert
     * @property {Dataframe.$Properties|null} [dataframe] Element dataframe
     * @property {Table.$Properties|null} [table] Element table
     * @property {VegaLiteChart.$Properties|null} [vegaLiteChart] Element vegaLiteChart
     * @property {Audio.$Properties|null} [audio] Element audio
     * @property {AudioInput.$Properties|null} [audioInput] Element audioInput
     * @property {Balloons.$Properties|null} [balloons] Element balloons
     * @property {BidiComponent.$Properties|null} [bidiComponent] Element bidiComponent
     * @property {Button.$Properties|null} [button] Element button
     * @property {ButtonGroup.$Properties|null} [buttonGroup] Element buttonGroup
     * @property {DownloadButton.$Properties|null} [downloadButton] Element downloadButton
     * @property {CameraInput.$Properties|null} [cameraInput] Element cameraInput
     * @property {ChatInput.$Properties|null} [chatInput] Element chatInput
     * @property {Checkbox.$Properties|null} [checkbox] Element checkbox
     * @property {ColorPicker.$Properties|null} [colorPicker] Element colorPicker
     * @property {ComponentInstance.$Properties|null} [componentInstance] Element componentInstance
     * @property {DateInput.$Properties|null} [dateInput] Element dateInput
     * @property {DeckGlJsonChart.$Properties|null} [deckGlJsonChart] Element deckGlJsonChart
     * @property {Help.$Properties|null} [helpInfo] Element helpInfo
     * @property {Empty.$Properties|null} [empty] Element empty
     * @property {Exception.$Properties|null} [exception] Element exception
     * @property {Favicon.$Properties|null} [favicon] Element favicon
     * @property {Feedback.$Properties|null} [feedback] Element feedback
     * @property {FileUploader.$Properties|null} [fileUploader] Element fileUploader
     * @property {GraphVizChart.$Properties|null} [graphvizChart] Element graphvizChart
     * @property {Html.$Properties|null} [html] Element html
     * @property {IFrame.$Properties|null} [iframe] Element iframe
     * @property {ImageList.$Properties|null} [imgs] Element imgs
     * @property {Json.$Properties|null} [json] Element json
     * @property {LinkButton.$Properties|null} [linkButton] Element linkButton
     * @property {Markdown.$Properties|null} [markdown] Element markdown
     * @property {Metric.$Properties|null} [metric] Element metric
     * @property {MultiSelect.$Properties|null} [multiselect] Element multiselect
     * @property {NumberInput.$Properties|null} [numberInput] Element numberInput
     * @property {PageLink.$Properties|null} [pageLink] Element pageLink
     * @property {PlotlyChart.$Properties|null} [plotlyChart] Element plotlyChart
     * @property {Progress.$Properties|null} [progress] Element progress
     * @property {Radio.$Properties|null} [radio] Element radio
     * @property {Selectbox.$Properties|null} [selectbox] Element selectbox
     * @property {Skeleton.$Properties|null} [skeleton] Element skeleton
     * @property {Slider.$Properties|null} [slider] Element slider
     * @property {Snow.$Properties|null} [snow] Element snow
     * @property {Space.$Properties|null} [space] Element space
     * @property {Spinner.$Properties|null} [spinner] Element spinner
     * @property {Text.$Properties|null} [text] Element text
     * @property {TextArea.$Properties|null} [textArea] Element textArea
     * @property {TextInput.$Properties|null} [textInput] Element textInput
     * @property {TimeInput.$Properties|null} [timeInput] Element timeInput
     * @property {DateTimeInput.$Properties|null} [dateTimeInput] Element dateTimeInput
     * @property {Toast.$Properties|null} [toast] Element toast
     * @property {Video.$Properties|null} [video] Element video
     * @property {Heading.$Properties|null} [heading] Element heading
     * @property {Code.$Properties|null} [code] Element code
     * @property {MenuButton.$Properties|null} [menuButton] Element menuButton
     * @property {Pagination.$Properties|null} [pagination] Element pagination
     * @property {EChartsChart.$Properties|null} [echartsChart] Element echartsChart
     * @property {"alert"|"dataframe"|"table"|"vegaLiteChart"|"audio"|"audioInput"|"balloons"|"bidiComponent"|"button"|"buttonGroup"|"downloadButton"|"cameraInput"|"chatInput"|"checkbox"|"colorPicker"|"componentInstance"|"dateInput"|"deckGlJsonChart"|"helpInfo"|"empty"|"exception"|"favicon"|"feedback"|"fileUploader"|"graphvizChart"|"html"|"iframe"|"imgs"|"json"|"linkButton"|"markdown"|"metric"|"multiselect"|"numberInput"|"pageLink"|"plotlyChart"|"progress"|"radio"|"selectbox"|"skeleton"|"slider"|"snow"|"space"|"spinner"|"text"|"textArea"|"textInput"|"timeInput"|"dateTimeInput"|"toast"|"video"|"heading"|"code"|"menuButton"|"pagination"|"echartsChart"} [type] Element type
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an Element.
     * @exports IElement
     * @interface IElement
     * @augments Element.$Properties
     * @deprecated Use Element.$Properties instead.
     */

    /**
     * Narrowed shape of an Element.
     * @typedef {{
     *   heightConfig?: streamlit.HeightConfig.$Shape|null;
     *   widthConfig?: streamlit.WidthConfig.$Shape|null;
     *   textAlignmentConfig?: streamlit.TextAlignmentConfig.$Shape|null;
     *   hasOneShotEffect?: boolean|null;
     *   alert?: Alert.$Shape|null;
     *   dataframe?: Dataframe.$Shape|null;
     *   table?: Table.$Shape|null;
     *   vegaLiteChart?: VegaLiteChart.$Shape|null;
     *   audio?: Audio.$Shape|null;
     *   audioInput?: AudioInput.$Shape|null;
     *   balloons?: Balloons.$Shape|null;
     *   bidiComponent?: BidiComponent.$Shape|null;
     *   button?: Button.$Shape|null;
     *   buttonGroup?: ButtonGroup.$Shape|null;
     *   downloadButton?: DownloadButton.$Shape|null;
     *   cameraInput?: CameraInput.$Shape|null;
     *   chatInput?: ChatInput.$Shape|null;
     *   checkbox?: Checkbox.$Shape|null;
     *   colorPicker?: ColorPicker.$Shape|null;
     *   componentInstance?: ComponentInstance.$Shape|null;
     *   dateInput?: DateInput.$Shape|null;
     *   deckGlJsonChart?: DeckGlJsonChart.$Shape|null;
     *   helpInfo?: Help.$Shape|null;
     *   empty?: Empty.$Shape|null;
     *   exception?: Exception.$Shape|null;
     *   favicon?: Favicon.$Shape|null;
     *   feedback?: Feedback.$Shape|null;
     *   fileUploader?: FileUploader.$Shape|null;
     *   graphvizChart?: GraphVizChart.$Shape|null;
     *   html?: Html.$Shape|null;
     *   iframe?: IFrame.$Shape|null;
     *   imgs?: ImageList.$Shape|null;
     *   json?: Json.$Shape|null;
     *   linkButton?: LinkButton.$Shape|null;
     *   markdown?: Markdown.$Shape|null;
     *   metric?: Metric.$Shape|null;
     *   multiselect?: MultiSelect.$Shape|null;
     *   numberInput?: NumberInput.$Shape|null;
     *   pageLink?: PageLink.$Shape|null;
     *   plotlyChart?: PlotlyChart.$Shape|null;
     *   progress?: Progress.$Shape|null;
     *   radio?: Radio.$Shape|null;
     *   selectbox?: Selectbox.$Shape|null;
     *   skeleton?: Skeleton.$Shape|null;
     *   slider?: Slider.$Shape|null;
     *   snow?: Snow.$Shape|null;
     *   space?: Space.$Shape|null;
     *   spinner?: Spinner.$Shape|null;
     *   text?: Text.$Shape|null;
     *   textArea?: TextArea.$Shape|null;
     *   textInput?: TextInput.$Shape|null;
     *   timeInput?: TimeInput.$Shape|null;
     *   dateTimeInput?: DateTimeInput.$Shape|null;
     *   toast?: Toast.$Shape|null;
     *   video?: Video.$Shape|null;
     *   heading?: Heading.$Shape|null;
     *   code?: Code.$Shape|null;
     *   menuButton?: MenuButton.$Shape|null;
     *   pagination?: Pagination.$Shape|null;
     *   echartsChart?: EChartsChart.$Shape|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ type?: undefined; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "alert"; alert: Alert.$Shape; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "dataframe"; alert?: null; dataframe: Dataframe.$Shape; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "table"; alert?: null; dataframe?: null; table: Table.$Shape; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "vegaLiteChart"; alert?: null; dataframe?: null; table?: null; vegaLiteChart: VegaLiteChart.$Shape; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "audio"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio: Audio.$Shape; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "audioInput"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput: AudioInput.$Shape; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "balloons"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons: Balloons.$Shape; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "bidiComponent"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent: BidiComponent.$Shape; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "button"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button: Button.$Shape; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "buttonGroup"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup: ButtonGroup.$Shape; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "downloadButton"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton: DownloadButton.$Shape; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "cameraInput"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput: CameraInput.$Shape; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "chatInput"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput: ChatInput.$Shape; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "checkbox"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox: Checkbox.$Shape; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "colorPicker"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker: ColorPicker.$Shape; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "componentInstance"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance: ComponentInstance.$Shape; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "dateInput"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput: DateInput.$Shape; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "deckGlJsonChart"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart: DeckGlJsonChart.$Shape; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "helpInfo"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo: Help.$Shape; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "empty"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty: Empty.$Shape; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "exception"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception: Exception.$Shape; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "favicon"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon: Favicon.$Shape; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "feedback"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback: Feedback.$Shape; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "fileUploader"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader: FileUploader.$Shape; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "graphvizChart"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart: GraphVizChart.$Shape; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "html"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html: Html.$Shape; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "iframe"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe: IFrame.$Shape; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "imgs"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs: ImageList.$Shape; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "json"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json: Json.$Shape; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "linkButton"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton: LinkButton.$Shape; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "markdown"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown: Markdown.$Shape; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "metric"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric: Metric.$Shape; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "multiselect"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect: MultiSelect.$Shape; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "numberInput"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput: NumberInput.$Shape; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "pageLink"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink: PageLink.$Shape; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "plotlyChart"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart: PlotlyChart.$Shape; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "progress"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress: Progress.$Shape; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "radio"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio: Radio.$Shape; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "selectbox"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox: Selectbox.$Shape; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "skeleton"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton: Skeleton.$Shape; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "slider"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider: Slider.$Shape; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "snow"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow: Snow.$Shape; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "space"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space: Space.$Shape; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "spinner"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner: Spinner.$Shape; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "text"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text: Text.$Shape; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "textArea"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea: TextArea.$Shape; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "textInput"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput: TextInput.$Shape; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "timeInput"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput: TimeInput.$Shape; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "dateTimeInput"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput: DateTimeInput.$Shape; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "toast"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast: Toast.$Shape; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "video"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video: Video.$Shape; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "heading"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading: Heading.$Shape; code?: null; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "code"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code: Code.$Shape; menuButton?: null; pagination?: null; echartsChart?: null }|{ type?: "menuButton"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton: MenuButton.$Shape; pagination?: null; echartsChart?: null }|{ type?: "pagination"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination: Pagination.$Shape; echartsChart?: null }|{ type?: "echartsChart"; alert?: null; dataframe?: null; table?: null; vegaLiteChart?: null; audio?: null; audioInput?: null; balloons?: null; bidiComponent?: null; button?: null; buttonGroup?: null; downloadButton?: null; cameraInput?: null; chatInput?: null; checkbox?: null; colorPicker?: null; componentInstance?: null; dateInput?: null; deckGlJsonChart?: null; helpInfo?: null; empty?: null; exception?: null; favicon?: null; feedback?: null; fileUploader?: null; graphvizChart?: null; html?: null; iframe?: null; imgs?: null; json?: null; linkButton?: null; markdown?: null; metric?: null; multiselect?: null; numberInput?: null; pageLink?: null; plotlyChart?: null; progress?: null; radio?: null; selectbox?: null; skeleton?: null; slider?: null; snow?: null; space?: null; spinner?: null; text?: null; textArea?: null; textInput?: null; timeInput?: null; dateTimeInput?: null; toast?: null; video?: null; heading?: null; code?: null; menuButton?: null; pagination?: null; echartsChart: EChartsChart.$Shape })
     * )} Element.$Shape
     */

    /**
     * Constructs a new Element.
     * @exports Element
     * @classdesc Represents an Element.
     * @constructor
     * @param {Element.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Element = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Element heightConfig.
     * @member {streamlit.HeightConfig.$Properties|null|undefined} heightConfig
     * @memberof Element
     * @instance
     */
    Element.prototype.heightConfig = null;

    /**
     * Element widthConfig.
     * @member {streamlit.WidthConfig.$Properties|null|undefined} widthConfig
     * @memberof Element
     * @instance
     */
    Element.prototype.widthConfig = null;

    /**
     * Element textAlignmentConfig.
     * @member {streamlit.TextAlignmentConfig.$Properties|null|undefined} textAlignmentConfig
     * @memberof Element
     * @instance
     */
    Element.prototype.textAlignmentConfig = null;

    /**
     * Element hasOneShotEffect.
     * @member {boolean|null|undefined} hasOneShotEffect
     * @memberof Element
     * @instance
     */
    Element.prototype.hasOneShotEffect = null;

    /**
     * Element alert.
     * @member {Alert.$Properties|null|undefined} alert
     * @memberof Element
     * @instance
     */
    Element.prototype.alert = null;

    /**
     * Element dataframe.
     * @member {Dataframe.$Properties|null|undefined} dataframe
     * @memberof Element
     * @instance
     */
    Element.prototype.dataframe = null;

    /**
     * Element table.
     * @member {Table.$Properties|null|undefined} table
     * @memberof Element
     * @instance
     */
    Element.prototype.table = null;

    /**
     * Element vegaLiteChart.
     * @member {VegaLiteChart.$Properties|null|undefined} vegaLiteChart
     * @memberof Element
     * @instance
     */
    Element.prototype.vegaLiteChart = null;

    /**
     * Element audio.
     * @member {Audio.$Properties|null|undefined} audio
     * @memberof Element
     * @instance
     */
    Element.prototype.audio = null;

    /**
     * Element audioInput.
     * @member {AudioInput.$Properties|null|undefined} audioInput
     * @memberof Element
     * @instance
     */
    Element.prototype.audioInput = null;

    /**
     * Element balloons.
     * @member {Balloons.$Properties|null|undefined} balloons
     * @memberof Element
     * @instance
     */
    Element.prototype.balloons = null;

    /**
     * Element bidiComponent.
     * @member {BidiComponent.$Properties|null|undefined} bidiComponent
     * @memberof Element
     * @instance
     */
    Element.prototype.bidiComponent = null;

    /**
     * Element button.
     * @member {Button.$Properties|null|undefined} button
     * @memberof Element
     * @instance
     */
    Element.prototype.button = null;

    /**
     * Element buttonGroup.
     * @member {ButtonGroup.$Properties|null|undefined} buttonGroup
     * @memberof Element
     * @instance
     */
    Element.prototype.buttonGroup = null;

    /**
     * Element downloadButton.
     * @member {DownloadButton.$Properties|null|undefined} downloadButton
     * @memberof Element
     * @instance
     */
    Element.prototype.downloadButton = null;

    /**
     * Element cameraInput.
     * @member {CameraInput.$Properties|null|undefined} cameraInput
     * @memberof Element
     * @instance
     */
    Element.prototype.cameraInput = null;

    /**
     * Element chatInput.
     * @member {ChatInput.$Properties|null|undefined} chatInput
     * @memberof Element
     * @instance
     */
    Element.prototype.chatInput = null;

    /**
     * Element checkbox.
     * @member {Checkbox.$Properties|null|undefined} checkbox
     * @memberof Element
     * @instance
     */
    Element.prototype.checkbox = null;

    /**
     * Element colorPicker.
     * @member {ColorPicker.$Properties|null|undefined} colorPicker
     * @memberof Element
     * @instance
     */
    Element.prototype.colorPicker = null;

    /**
     * Element componentInstance.
     * @member {ComponentInstance.$Properties|null|undefined} componentInstance
     * @memberof Element
     * @instance
     */
    Element.prototype.componentInstance = null;

    /**
     * Element dateInput.
     * @member {DateInput.$Properties|null|undefined} dateInput
     * @memberof Element
     * @instance
     */
    Element.prototype.dateInput = null;

    /**
     * Element deckGlJsonChart.
     * @member {DeckGlJsonChart.$Properties|null|undefined} deckGlJsonChart
     * @memberof Element
     * @instance
     */
    Element.prototype.deckGlJsonChart = null;

    /**
     * Element helpInfo.
     * @member {Help.$Properties|null|undefined} helpInfo
     * @memberof Element
     * @instance
     */
    Element.prototype.helpInfo = null;

    /**
     * Element empty.
     * @member {Empty.$Properties|null|undefined} empty
     * @memberof Element
     * @instance
     */
    Element.prototype.empty = null;

    /**
     * Element exception.
     * @member {Exception.$Properties|null|undefined} exception
     * @memberof Element
     * @instance
     */
    Element.prototype.exception = null;

    /**
     * Element favicon.
     * @member {Favicon.$Properties|null|undefined} favicon
     * @memberof Element
     * @instance
     */
    Element.prototype.favicon = null;

    /**
     * Element feedback.
     * @member {Feedback.$Properties|null|undefined} feedback
     * @memberof Element
     * @instance
     */
    Element.prototype.feedback = null;

    /**
     * Element fileUploader.
     * @member {FileUploader.$Properties|null|undefined} fileUploader
     * @memberof Element
     * @instance
     */
    Element.prototype.fileUploader = null;

    /**
     * Element graphvizChart.
     * @member {GraphVizChart.$Properties|null|undefined} graphvizChart
     * @memberof Element
     * @instance
     */
    Element.prototype.graphvizChart = null;

    /**
     * Element html.
     * @member {Html.$Properties|null|undefined} html
     * @memberof Element
     * @instance
     */
    Element.prototype.html = null;

    /**
     * Element iframe.
     * @member {IFrame.$Properties|null|undefined} iframe
     * @memberof Element
     * @instance
     */
    Element.prototype.iframe = null;

    /**
     * Element imgs.
     * @member {ImageList.$Properties|null|undefined} imgs
     * @memberof Element
     * @instance
     */
    Element.prototype.imgs = null;

    /**
     * Element json.
     * @member {Json.$Properties|null|undefined} json
     * @memberof Element
     * @instance
     */
    Element.prototype.json = null;

    /**
     * Element linkButton.
     * @member {LinkButton.$Properties|null|undefined} linkButton
     * @memberof Element
     * @instance
     */
    Element.prototype.linkButton = null;

    /**
     * Element markdown.
     * @member {Markdown.$Properties|null|undefined} markdown
     * @memberof Element
     * @instance
     */
    Element.prototype.markdown = null;

    /**
     * Element metric.
     * @member {Metric.$Properties|null|undefined} metric
     * @memberof Element
     * @instance
     */
    Element.prototype.metric = null;

    /**
     * Element multiselect.
     * @member {MultiSelect.$Properties|null|undefined} multiselect
     * @memberof Element
     * @instance
     */
    Element.prototype.multiselect = null;

    /**
     * Element numberInput.
     * @member {NumberInput.$Properties|null|undefined} numberInput
     * @memberof Element
     * @instance
     */
    Element.prototype.numberInput = null;

    /**
     * Element pageLink.
     * @member {PageLink.$Properties|null|undefined} pageLink
     * @memberof Element
     * @instance
     */
    Element.prototype.pageLink = null;

    /**
     * Element plotlyChart.
     * @member {PlotlyChart.$Properties|null|undefined} plotlyChart
     * @memberof Element
     * @instance
     */
    Element.prototype.plotlyChart = null;

    /**
     * Element progress.
     * @member {Progress.$Properties|null|undefined} progress
     * @memberof Element
     * @instance
     */
    Element.prototype.progress = null;

    /**
     * Element radio.
     * @member {Radio.$Properties|null|undefined} radio
     * @memberof Element
     * @instance
     */
    Element.prototype.radio = null;

    /**
     * Element selectbox.
     * @member {Selectbox.$Properties|null|undefined} selectbox
     * @memberof Element
     * @instance
     */
    Element.prototype.selectbox = null;

    /**
     * Element skeleton.
     * @member {Skeleton.$Properties|null|undefined} skeleton
     * @memberof Element
     * @instance
     */
    Element.prototype.skeleton = null;

    /**
     * Element slider.
     * @member {Slider.$Properties|null|undefined} slider
     * @memberof Element
     * @instance
     */
    Element.prototype.slider = null;

    /**
     * Element snow.
     * @member {Snow.$Properties|null|undefined} snow
     * @memberof Element
     * @instance
     */
    Element.prototype.snow = null;

    /**
     * Element space.
     * @member {Space.$Properties|null|undefined} space
     * @memberof Element
     * @instance
     */
    Element.prototype.space = null;

    /**
     * Element spinner.
     * @member {Spinner.$Properties|null|undefined} spinner
     * @memberof Element
     * @instance
     */
    Element.prototype.spinner = null;

    /**
     * Element text.
     * @member {Text.$Properties|null|undefined} text
     * @memberof Element
     * @instance
     */
    Element.prototype.text = null;

    /**
     * Element textArea.
     * @member {TextArea.$Properties|null|undefined} textArea
     * @memberof Element
     * @instance
     */
    Element.prototype.textArea = null;

    /**
     * Element textInput.
     * @member {TextInput.$Properties|null|undefined} textInput
     * @memberof Element
     * @instance
     */
    Element.prototype.textInput = null;

    /**
     * Element timeInput.
     * @member {TimeInput.$Properties|null|undefined} timeInput
     * @memberof Element
     * @instance
     */
    Element.prototype.timeInput = null;

    /**
     * Element dateTimeInput.
     * @member {DateTimeInput.$Properties|null|undefined} dateTimeInput
     * @memberof Element
     * @instance
     */
    Element.prototype.dateTimeInput = null;

    /**
     * Element toast.
     * @member {Toast.$Properties|null|undefined} toast
     * @memberof Element
     * @instance
     */
    Element.prototype.toast = null;

    /**
     * Element video.
     * @member {Video.$Properties|null|undefined} video
     * @memberof Element
     * @instance
     */
    Element.prototype.video = null;

    /**
     * Element heading.
     * @member {Heading.$Properties|null|undefined} heading
     * @memberof Element
     * @instance
     */
    Element.prototype.heading = null;

    /**
     * Element code.
     * @member {Code.$Properties|null|undefined} code
     * @memberof Element
     * @instance
     */
    Element.prototype.code = null;

    /**
     * Element menuButton.
     * @member {MenuButton.$Properties|null|undefined} menuButton
     * @memberof Element
     * @instance
     */
    Element.prototype.menuButton = null;

    /**
     * Element pagination.
     * @member {Pagination.$Properties|null|undefined} pagination
     * @memberof Element
     * @instance
     */
    Element.prototype.pagination = null;

    /**
     * Element echartsChart.
     * @member {EChartsChart.$Properties|null|undefined} echartsChart
     * @memberof Element
     * @instance
     */
    Element.prototype.echartsChart = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Element.prototype, "_heightConfig", {
        get: $util.oneOfGetter($oneOfFields = ["heightConfig"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Element.prototype, "_widthConfig", {
        get: $util.oneOfGetter($oneOfFields = ["widthConfig"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Element.prototype, "_textAlignmentConfig", {
        get: $util.oneOfGetter($oneOfFields = ["textAlignmentConfig"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Element.prototype, "_hasOneShotEffect", {
        get: $util.oneOfGetter($oneOfFields = ["hasOneShotEffect"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Element type.
     * @member {"alert"|"dataframe"|"table"|"vegaLiteChart"|"audio"|"audioInput"|"balloons"|"bidiComponent"|"button"|"buttonGroup"|"downloadButton"|"cameraInput"|"chatInput"|"checkbox"|"colorPicker"|"componentInstance"|"dateInput"|"deckGlJsonChart"|"helpInfo"|"empty"|"exception"|"favicon"|"feedback"|"fileUploader"|"graphvizChart"|"html"|"iframe"|"imgs"|"json"|"linkButton"|"markdown"|"metric"|"multiselect"|"numberInput"|"pageLink"|"plotlyChart"|"progress"|"radio"|"selectbox"|"skeleton"|"slider"|"snow"|"space"|"spinner"|"text"|"textArea"|"textInput"|"timeInput"|"dateTimeInput"|"toast"|"video"|"heading"|"code"|"menuButton"|"pagination"|"echartsChart"|undefined} type
     * @memberof Element
     * @instance
     */
    $Object.defineProperty(Element.prototype, "type", {
        get: $util.oneOfGetter($oneOfFields = ["alert", "dataframe", "table", "vegaLiteChart", "audio", "audioInput", "balloons", "bidiComponent", "button", "buttonGroup", "downloadButton", "cameraInput", "chatInput", "checkbox", "colorPicker", "componentInstance", "dateInput", "deckGlJsonChart", "helpInfo", "empty", "exception", "favicon", "feedback", "fileUploader", "graphvizChart", "html", "iframe", "imgs", "json", "linkButton", "markdown", "metric", "multiselect", "numberInput", "pageLink", "plotlyChart", "progress", "radio", "selectbox", "skeleton", "slider", "snow", "space", "spinner", "text", "textArea", "textInput", "timeInput", "dateTimeInput", "toast", "video", "heading", "code", "menuButton", "pagination", "echartsChart"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Element instance using the specified properties.
     * @function create
     * @memberof Element
     * @static
     * @param {Element.$Properties=} [properties] Properties to set
     * @returns {Element} Element instance
     * @type {{
     *   (properties: Element.$Shape): Element & Element.$Shape;
     *   (properties?: Element.$Properties): Element;
     * }}
     */
    Element.create = function(properties) {
        return new Element(properties);
    };

    /**
     * Encodes the specified Element message. Does not implicitly {@link Element.verify|verify} messages.
     * @function encode
     * @memberof Element
     * @static
     * @param {Element.$Properties} message Element message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Element.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.text != null && $Object.hasOwnProperty.call(message, "text"))
            $root.Text.encode(message.text, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.empty != null && $Object.hasOwnProperty.call(message, "empty"))
            $root.Empty.encode(message.empty, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.progress != null && $Object.hasOwnProperty.call(message, "progress"))
            $root.Progress.encode(message.progress, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
        if (message.imgs != null && $Object.hasOwnProperty.call(message, "imgs"))
            $root.ImageList.encode(message.imgs, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
        if (message.helpInfo != null && $Object.hasOwnProperty.call(message, "helpInfo"))
            $root.Help.encode(message.helpInfo, writer.uint32(/* id 7, wireType 2 =*/58).fork(), _depth + 1).ldelim();
        if (message.exception != null && $Object.hasOwnProperty.call(message, "exception"))
            $root.Exception.encode(message.exception, writer.uint32(/* id 8, wireType 2 =*/66).fork(), _depth + 1).ldelim();
        if (message.balloons != null && $Object.hasOwnProperty.call(message, "balloons"))
            $root.Balloons.encode(message.balloons, writer.uint32(/* id 12, wireType 2 =*/98).fork(), _depth + 1).ldelim();
        if (message.audio != null && $Object.hasOwnProperty.call(message, "audio"))
            $root.Audio.encode(message.audio, writer.uint32(/* id 13, wireType 2 =*/106).fork(), _depth + 1).ldelim();
        if (message.video != null && $Object.hasOwnProperty.call(message, "video"))
            $root.Video.encode(message.video, writer.uint32(/* id 14, wireType 2 =*/114).fork(), _depth + 1).ldelim();
        if (message.plotlyChart != null && $Object.hasOwnProperty.call(message, "plotlyChart"))
            $root.PlotlyChart.encode(message.plotlyChart, writer.uint32(/* id 16, wireType 2 =*/130).fork(), _depth + 1).ldelim();
        if (message.graphvizChart != null && $Object.hasOwnProperty.call(message, "graphvizChart"))
            $root.GraphVizChart.encode(message.graphvizChart, writer.uint32(/* id 18, wireType 2 =*/146).fork(), _depth + 1).ldelim();
        if (message.button != null && $Object.hasOwnProperty.call(message, "button"))
            $root.Button.encode(message.button, writer.uint32(/* id 19, wireType 2 =*/154).fork(), _depth + 1).ldelim();
        if (message.checkbox != null && $Object.hasOwnProperty.call(message, "checkbox"))
            $root.Checkbox.encode(message.checkbox, writer.uint32(/* id 20, wireType 2 =*/162).fork(), _depth + 1).ldelim();
        if (message.slider != null && $Object.hasOwnProperty.call(message, "slider"))
            $root.Slider.encode(message.slider, writer.uint32(/* id 21, wireType 2 =*/170).fork(), _depth + 1).ldelim();
        if (message.textArea != null && $Object.hasOwnProperty.call(message, "textArea"))
            $root.TextArea.encode(message.textArea, writer.uint32(/* id 22, wireType 2 =*/178).fork(), _depth + 1).ldelim();
        if (message.radio != null && $Object.hasOwnProperty.call(message, "radio"))
            $root.Radio.encode(message.radio, writer.uint32(/* id 23, wireType 2 =*/186).fork(), _depth + 1).ldelim();
        if (message.textInput != null && $Object.hasOwnProperty.call(message, "textInput"))
            $root.TextInput.encode(message.textInput, writer.uint32(/* id 24, wireType 2 =*/194).fork(), _depth + 1).ldelim();
        if (message.selectbox != null && $Object.hasOwnProperty.call(message, "selectbox"))
            $root.Selectbox.encode(message.selectbox, writer.uint32(/* id 25, wireType 2 =*/202).fork(), _depth + 1).ldelim();
        if (message.timeInput != null && $Object.hasOwnProperty.call(message, "timeInput"))
            $root.TimeInput.encode(message.timeInput, writer.uint32(/* id 26, wireType 2 =*/210).fork(), _depth + 1).ldelim();
        if (message.dateInput != null && $Object.hasOwnProperty.call(message, "dateInput"))
            $root.DateInput.encode(message.dateInput, writer.uint32(/* id 27, wireType 2 =*/218).fork(), _depth + 1).ldelim();
        if (message.multiselect != null && $Object.hasOwnProperty.call(message, "multiselect"))
            $root.MultiSelect.encode(message.multiselect, writer.uint32(/* id 28, wireType 2 =*/226).fork(), _depth + 1).ldelim();
        if (message.markdown != null && $Object.hasOwnProperty.call(message, "markdown"))
            $root.Markdown.encode(message.markdown, writer.uint32(/* id 29, wireType 2 =*/234).fork(), _depth + 1).ldelim();
        if (message.alert != null && $Object.hasOwnProperty.call(message, "alert"))
            $root.Alert.encode(message.alert, writer.uint32(/* id 30, wireType 2 =*/242).fork(), _depth + 1).ldelim();
        if (message.json != null && $Object.hasOwnProperty.call(message, "json"))
            $root.Json.encode(message.json, writer.uint32(/* id 31, wireType 2 =*/250).fork(), _depth + 1).ldelim();
        if (message.numberInput != null && $Object.hasOwnProperty.call(message, "numberInput"))
            $root.NumberInput.encode(message.numberInput, writer.uint32(/* id 32, wireType 2 =*/258).fork(), _depth + 1).ldelim();
        if (message.fileUploader != null && $Object.hasOwnProperty.call(message, "fileUploader"))
            $root.FileUploader.encode(message.fileUploader, writer.uint32(/* id 33, wireType 2 =*/266).fork(), _depth + 1).ldelim();
        if (message.deckGlJsonChart != null && $Object.hasOwnProperty.call(message, "deckGlJsonChart"))
            $root.DeckGlJsonChart.encode(message.deckGlJsonChart, writer.uint32(/* id 34, wireType 2 =*/274).fork(), _depth + 1).ldelim();
        if (message.colorPicker != null && $Object.hasOwnProperty.call(message, "colorPicker"))
            $root.ColorPicker.encode(message.colorPicker, writer.uint32(/* id 35, wireType 2 =*/282).fork(), _depth + 1).ldelim();
        if (message.favicon != null && $Object.hasOwnProperty.call(message, "favicon"))
            $root.Favicon.encode(message.favicon, writer.uint32(/* id 36, wireType 2 =*/290).fork(), _depth + 1).ldelim();
        if (message.componentInstance != null && $Object.hasOwnProperty.call(message, "componentInstance"))
            $root.ComponentInstance.encode(message.componentInstance, writer.uint32(/* id 37, wireType 2 =*/298).fork(), _depth + 1).ldelim();
        if (message.iframe != null && $Object.hasOwnProperty.call(message, "iframe"))
            $root.IFrame.encode(message.iframe, writer.uint32(/* id 38, wireType 2 =*/306).fork(), _depth + 1).ldelim();
        if (message.table != null && $Object.hasOwnProperty.call(message, "table"))
            $root.Table.encode(message.table, writer.uint32(/* id 39, wireType 2 =*/314).fork(), _depth + 1).ldelim();
        if (message.dataframe != null && $Object.hasOwnProperty.call(message, "dataframe"))
            $root.Dataframe.encode(message.dataframe, writer.uint32(/* id 40, wireType 2 =*/322).fork(), _depth + 1).ldelim();
        if (message.vegaLiteChart != null && $Object.hasOwnProperty.call(message, "vegaLiteChart"))
            $root.VegaLiteChart.encode(message.vegaLiteChart, writer.uint32(/* id 41, wireType 2 =*/330).fork(), _depth + 1).ldelim();
        if (message.metric != null && $Object.hasOwnProperty.call(message, "metric"))
            $root.Metric.encode(message.metric, writer.uint32(/* id 42, wireType 2 =*/338).fork(), _depth + 1).ldelim();
        if (message.downloadButton != null && $Object.hasOwnProperty.call(message, "downloadButton"))
            $root.DownloadButton.encode(message.downloadButton, writer.uint32(/* id 43, wireType 2 =*/346).fork(), _depth + 1).ldelim();
        if (message.spinner != null && $Object.hasOwnProperty.call(message, "spinner"))
            $root.Spinner.encode(message.spinner, writer.uint32(/* id 44, wireType 2 =*/354).fork(), _depth + 1).ldelim();
        if (message.cameraInput != null && $Object.hasOwnProperty.call(message, "cameraInput"))
            $root.CameraInput.encode(message.cameraInput, writer.uint32(/* id 45, wireType 2 =*/362).fork(), _depth + 1).ldelim();
        if (message.snow != null && $Object.hasOwnProperty.call(message, "snow"))
            $root.Snow.encode(message.snow, writer.uint32(/* id 46, wireType 2 =*/370).fork(), _depth + 1).ldelim();
        if (message.heading != null && $Object.hasOwnProperty.call(message, "heading"))
            $root.Heading.encode(message.heading, writer.uint32(/* id 47, wireType 2 =*/378).fork(), _depth + 1).ldelim();
        if (message.code != null && $Object.hasOwnProperty.call(message, "code"))
            $root.Code.encode(message.code, writer.uint32(/* id 48, wireType 2 =*/386).fork(), _depth + 1).ldelim();
        if (message.chatInput != null && $Object.hasOwnProperty.call(message, "chatInput"))
            $root.ChatInput.encode(message.chatInput, writer.uint32(/* id 49, wireType 2 =*/394).fork(), _depth + 1).ldelim();
        if (message.toast != null && $Object.hasOwnProperty.call(message, "toast"))
            $root.Toast.encode(message.toast, writer.uint32(/* id 50, wireType 2 =*/402).fork(), _depth + 1).ldelim();
        if (message.linkButton != null && $Object.hasOwnProperty.call(message, "linkButton"))
            $root.LinkButton.encode(message.linkButton, writer.uint32(/* id 51, wireType 2 =*/410).fork(), _depth + 1).ldelim();
        if (message.skeleton != null && $Object.hasOwnProperty.call(message, "skeleton"))
            $root.Skeleton.encode(message.skeleton, writer.uint32(/* id 52, wireType 2 =*/418).fork(), _depth + 1).ldelim();
        if (message.pageLink != null && $Object.hasOwnProperty.call(message, "pageLink"))
            $root.PageLink.encode(message.pageLink, writer.uint32(/* id 53, wireType 2 =*/426).fork(), _depth + 1).ldelim();
        if (message.html != null && $Object.hasOwnProperty.call(message, "html"))
            $root.Html.encode(message.html, writer.uint32(/* id 54, wireType 2 =*/434).fork(), _depth + 1).ldelim();
        if (message.buttonGroup != null && $Object.hasOwnProperty.call(message, "buttonGroup"))
            $root.ButtonGroup.encode(message.buttonGroup, writer.uint32(/* id 55, wireType 2 =*/442).fork(), _depth + 1).ldelim();
        if (message.audioInput != null && $Object.hasOwnProperty.call(message, "audioInput"))
            $root.AudioInput.encode(message.audioInput, writer.uint32(/* id 56, wireType 2 =*/450).fork(), _depth + 1).ldelim();
        if (message.heightConfig != null && $Object.hasOwnProperty.call(message, "heightConfig"))
            $root.streamlit.HeightConfig.encode(message.heightConfig, writer.uint32(/* id 57, wireType 2 =*/458).fork(), _depth + 1).ldelim();
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            $root.streamlit.WidthConfig.encode(message.widthConfig, writer.uint32(/* id 58, wireType 2 =*/466).fork(), _depth + 1).ldelim();
        if (message.bidiComponent != null && $Object.hasOwnProperty.call(message, "bidiComponent"))
            $root.BidiComponent.encode(message.bidiComponent, writer.uint32(/* id 59, wireType 2 =*/474).fork(), _depth + 1).ldelim();
        if (message.space != null && $Object.hasOwnProperty.call(message, "space"))
            $root.Space.encode(message.space, writer.uint32(/* id 60, wireType 2 =*/482).fork(), _depth + 1).ldelim();
        if (message.textAlignmentConfig != null && $Object.hasOwnProperty.call(message, "textAlignmentConfig"))
            $root.streamlit.TextAlignmentConfig.encode(message.textAlignmentConfig, writer.uint32(/* id 61, wireType 2 =*/490).fork(), _depth + 1).ldelim();
        if (message.dateTimeInput != null && $Object.hasOwnProperty.call(message, "dateTimeInput"))
            $root.DateTimeInput.encode(message.dateTimeInput, writer.uint32(/* id 62, wireType 2 =*/498).fork(), _depth + 1).ldelim();
        if (message.feedback != null && $Object.hasOwnProperty.call(message, "feedback"))
            $root.Feedback.encode(message.feedback, writer.uint32(/* id 63, wireType 2 =*/506).fork(), _depth + 1).ldelim();
        if (message.menuButton != null && $Object.hasOwnProperty.call(message, "menuButton"))
            $root.MenuButton.encode(message.menuButton, writer.uint32(/* id 64, wireType 2 =*/514).fork(), _depth + 1).ldelim();
        if (message.hasOneShotEffect != null && $Object.hasOwnProperty.call(message, "hasOneShotEffect"))
            writer.uint32(/* id 65, wireType 0 =*/520).bool(message.hasOneShotEffect);
        if (message.pagination != null && $Object.hasOwnProperty.call(message, "pagination"))
            $root.Pagination.encode(message.pagination, writer.uint32(/* id 66, wireType 2 =*/530).fork(), _depth + 1).ldelim();
        if (message.echartsChart != null && $Object.hasOwnProperty.call(message, "echartsChart"))
            $root.EChartsChart.encode(message.echartsChart, writer.uint32(/* id 67, wireType 2 =*/538).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an Element message from the specified reader or buffer.
     * @function decode
     * @memberof Element
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Element & Element.$Shape} Element
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Element.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Element();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 57: {
                    if (wireType !== 2)
                        break;
                    message.heightConfig = $root.streamlit.HeightConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.heightConfig);
                    message._heightConfig = "heightConfig";
                    continue;
                }
            case 58: {
                    if (wireType !== 2)
                        break;
                    message.widthConfig = $root.streamlit.WidthConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.widthConfig);
                    message._widthConfig = "widthConfig";
                    continue;
                }
            case 61: {
                    if (wireType !== 2)
                        break;
                    message.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.textAlignmentConfig);
                    message._textAlignmentConfig = "textAlignmentConfig";
                    continue;
                }
            case 65: {
                    if (wireType !== 0)
                        break;
                    message.hasOneShotEffect = reader.bool();
                    message._hasOneShotEffect = "hasOneShotEffect";
                    continue;
                }
            case 30: {
                    if (wireType !== 2)
                        break;
                    message.alert = $root.Alert.decode(reader, reader.uint32(), $undefined, _depth + 1, message.alert);
                    message.type = "alert";
                    continue;
                }
            case 40: {
                    if (wireType !== 2)
                        break;
                    message.dataframe = $root.Dataframe.decode(reader, reader.uint32(), $undefined, _depth + 1, message.dataframe);
                    message.type = "dataframe";
                    continue;
                }
            case 39: {
                    if (wireType !== 2)
                        break;
                    message.table = $root.Table.decode(reader, reader.uint32(), $undefined, _depth + 1, message.table);
                    message.type = "table";
                    continue;
                }
            case 41: {
                    if (wireType !== 2)
                        break;
                    message.vegaLiteChart = $root.VegaLiteChart.decode(reader, reader.uint32(), $undefined, _depth + 1, message.vegaLiteChart);
                    message.type = "vegaLiteChart";
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.audio = $root.Audio.decode(reader, reader.uint32(), $undefined, _depth + 1, message.audio);
                    message.type = "audio";
                    continue;
                }
            case 56: {
                    if (wireType !== 2)
                        break;
                    message.audioInput = $root.AudioInput.decode(reader, reader.uint32(), $undefined, _depth + 1, message.audioInput);
                    message.type = "audioInput";
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.balloons = $root.Balloons.decode(reader, reader.uint32(), $undefined, _depth + 1, message.balloons);
                    message.type = "balloons";
                    continue;
                }
            case 59: {
                    if (wireType !== 2)
                        break;
                    message.bidiComponent = $root.BidiComponent.decode(reader, reader.uint32(), $undefined, _depth + 1, message.bidiComponent);
                    message.type = "bidiComponent";
                    continue;
                }
            case 19: {
                    if (wireType !== 2)
                        break;
                    message.button = $root.Button.decode(reader, reader.uint32(), $undefined, _depth + 1, message.button);
                    message.type = "button";
                    continue;
                }
            case 55: {
                    if (wireType !== 2)
                        break;
                    message.buttonGroup = $root.ButtonGroup.decode(reader, reader.uint32(), $undefined, _depth + 1, message.buttonGroup);
                    message.type = "buttonGroup";
                    continue;
                }
            case 43: {
                    if (wireType !== 2)
                        break;
                    message.downloadButton = $root.DownloadButton.decode(reader, reader.uint32(), $undefined, _depth + 1, message.downloadButton);
                    message.type = "downloadButton";
                    continue;
                }
            case 45: {
                    if (wireType !== 2)
                        break;
                    message.cameraInput = $root.CameraInput.decode(reader, reader.uint32(), $undefined, _depth + 1, message.cameraInput);
                    message.type = "cameraInput";
                    continue;
                }
            case 49: {
                    if (wireType !== 2)
                        break;
                    message.chatInput = $root.ChatInput.decode(reader, reader.uint32(), $undefined, _depth + 1, message.chatInput);
                    message.type = "chatInput";
                    continue;
                }
            case 20: {
                    if (wireType !== 2)
                        break;
                    message.checkbox = $root.Checkbox.decode(reader, reader.uint32(), $undefined, _depth + 1, message.checkbox);
                    message.type = "checkbox";
                    continue;
                }
            case 35: {
                    if (wireType !== 2)
                        break;
                    message.colorPicker = $root.ColorPicker.decode(reader, reader.uint32(), $undefined, _depth + 1, message.colorPicker);
                    message.type = "colorPicker";
                    continue;
                }
            case 37: {
                    if (wireType !== 2)
                        break;
                    message.componentInstance = $root.ComponentInstance.decode(reader, reader.uint32(), $undefined, _depth + 1, message.componentInstance);
                    message.type = "componentInstance";
                    continue;
                }
            case 27: {
                    if (wireType !== 2)
                        break;
                    message.dateInput = $root.DateInput.decode(reader, reader.uint32(), $undefined, _depth + 1, message.dateInput);
                    message.type = "dateInput";
                    continue;
                }
            case 34: {
                    if (wireType !== 2)
                        break;
                    message.deckGlJsonChart = $root.DeckGlJsonChart.decode(reader, reader.uint32(), $undefined, _depth + 1, message.deckGlJsonChart);
                    message.type = "deckGlJsonChart";
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    message.helpInfo = $root.Help.decode(reader, reader.uint32(), $undefined, _depth + 1, message.helpInfo);
                    message.type = "helpInfo";
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    message.empty = $root.Empty.decode(reader, reader.uint32(), $undefined, _depth + 1, message.empty);
                    message.type = "empty";
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    message.exception = $root.Exception.decode(reader, reader.uint32(), $undefined, _depth + 1, message.exception);
                    message.type = "exception";
                    continue;
                }
            case 36: {
                    if (wireType !== 2)
                        break;
                    message.favicon = $root.Favicon.decode(reader, reader.uint32(), $undefined, _depth + 1, message.favicon);
                    message.type = "favicon";
                    continue;
                }
            case 63: {
                    if (wireType !== 2)
                        break;
                    message.feedback = $root.Feedback.decode(reader, reader.uint32(), $undefined, _depth + 1, message.feedback);
                    message.type = "feedback";
                    continue;
                }
            case 33: {
                    if (wireType !== 2)
                        break;
                    message.fileUploader = $root.FileUploader.decode(reader, reader.uint32(), $undefined, _depth + 1, message.fileUploader);
                    message.type = "fileUploader";
                    continue;
                }
            case 18: {
                    if (wireType !== 2)
                        break;
                    message.graphvizChart = $root.GraphVizChart.decode(reader, reader.uint32(), $undefined, _depth + 1, message.graphvizChart);
                    message.type = "graphvizChart";
                    continue;
                }
            case 54: {
                    if (wireType !== 2)
                        break;
                    message.html = $root.Html.decode(reader, reader.uint32(), $undefined, _depth + 1, message.html);
                    message.type = "html";
                    continue;
                }
            case 38: {
                    if (wireType !== 2)
                        break;
                    message.iframe = $root.IFrame.decode(reader, reader.uint32(), $undefined, _depth + 1, message.iframe);
                    message.type = "iframe";
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.imgs = $root.ImageList.decode(reader, reader.uint32(), $undefined, _depth + 1, message.imgs);
                    message.type = "imgs";
                    continue;
                }
            case 31: {
                    if (wireType !== 2)
                        break;
                    message.json = $root.Json.decode(reader, reader.uint32(), $undefined, _depth + 1, message.json);
                    message.type = "json";
                    continue;
                }
            case 51: {
                    if (wireType !== 2)
                        break;
                    message.linkButton = $root.LinkButton.decode(reader, reader.uint32(), $undefined, _depth + 1, message.linkButton);
                    message.type = "linkButton";
                    continue;
                }
            case 29: {
                    if (wireType !== 2)
                        break;
                    message.markdown = $root.Markdown.decode(reader, reader.uint32(), $undefined, _depth + 1, message.markdown);
                    message.type = "markdown";
                    continue;
                }
            case 42: {
                    if (wireType !== 2)
                        break;
                    message.metric = $root.Metric.decode(reader, reader.uint32(), $undefined, _depth + 1, message.metric);
                    message.type = "metric";
                    continue;
                }
            case 28: {
                    if (wireType !== 2)
                        break;
                    message.multiselect = $root.MultiSelect.decode(reader, reader.uint32(), $undefined, _depth + 1, message.multiselect);
                    message.type = "multiselect";
                    continue;
                }
            case 32: {
                    if (wireType !== 2)
                        break;
                    message.numberInput = $root.NumberInput.decode(reader, reader.uint32(), $undefined, _depth + 1, message.numberInput);
                    message.type = "numberInput";
                    continue;
                }
            case 53: {
                    if (wireType !== 2)
                        break;
                    message.pageLink = $root.PageLink.decode(reader, reader.uint32(), $undefined, _depth + 1, message.pageLink);
                    message.type = "pageLink";
                    continue;
                }
            case 16: {
                    if (wireType !== 2)
                        break;
                    message.plotlyChart = $root.PlotlyChart.decode(reader, reader.uint32(), $undefined, _depth + 1, message.plotlyChart);
                    message.type = "plotlyChart";
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.progress = $root.Progress.decode(reader, reader.uint32(), $undefined, _depth + 1, message.progress);
                    message.type = "progress";
                    continue;
                }
            case 23: {
                    if (wireType !== 2)
                        break;
                    message.radio = $root.Radio.decode(reader, reader.uint32(), $undefined, _depth + 1, message.radio);
                    message.type = "radio";
                    continue;
                }
            case 25: {
                    if (wireType !== 2)
                        break;
                    message.selectbox = $root.Selectbox.decode(reader, reader.uint32(), $undefined, _depth + 1, message.selectbox);
                    message.type = "selectbox";
                    continue;
                }
            case 52: {
                    if (wireType !== 2)
                        break;
                    message.skeleton = $root.Skeleton.decode(reader, reader.uint32(), $undefined, _depth + 1, message.skeleton);
                    message.type = "skeleton";
                    continue;
                }
            case 21: {
                    if (wireType !== 2)
                        break;
                    message.slider = $root.Slider.decode(reader, reader.uint32(), $undefined, _depth + 1, message.slider);
                    message.type = "slider";
                    continue;
                }
            case 46: {
                    if (wireType !== 2)
                        break;
                    message.snow = $root.Snow.decode(reader, reader.uint32(), $undefined, _depth + 1, message.snow);
                    message.type = "snow";
                    continue;
                }
            case 60: {
                    if (wireType !== 2)
                        break;
                    message.space = $root.Space.decode(reader, reader.uint32(), $undefined, _depth + 1, message.space);
                    message.type = "space";
                    continue;
                }
            case 44: {
                    if (wireType !== 2)
                        break;
                    message.spinner = $root.Spinner.decode(reader, reader.uint32(), $undefined, _depth + 1, message.spinner);
                    message.type = "spinner";
                    continue;
                }
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.text = $root.Text.decode(reader, reader.uint32(), $undefined, _depth + 1, message.text);
                    message.type = "text";
                    continue;
                }
            case 22: {
                    if (wireType !== 2)
                        break;
                    message.textArea = $root.TextArea.decode(reader, reader.uint32(), $undefined, _depth + 1, message.textArea);
                    message.type = "textArea";
                    continue;
                }
            case 24: {
                    if (wireType !== 2)
                        break;
                    message.textInput = $root.TextInput.decode(reader, reader.uint32(), $undefined, _depth + 1, message.textInput);
                    message.type = "textInput";
                    continue;
                }
            case 26: {
                    if (wireType !== 2)
                        break;
                    message.timeInput = $root.TimeInput.decode(reader, reader.uint32(), $undefined, _depth + 1, message.timeInput);
                    message.type = "timeInput";
                    continue;
                }
            case 62: {
                    if (wireType !== 2)
                        break;
                    message.dateTimeInput = $root.DateTimeInput.decode(reader, reader.uint32(), $undefined, _depth + 1, message.dateTimeInput);
                    message.type = "dateTimeInput";
                    continue;
                }
            case 50: {
                    if (wireType !== 2)
                        break;
                    message.toast = $root.Toast.decode(reader, reader.uint32(), $undefined, _depth + 1, message.toast);
                    message.type = "toast";
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    message.video = $root.Video.decode(reader, reader.uint32(), $undefined, _depth + 1, message.video);
                    message.type = "video";
                    continue;
                }
            case 47: {
                    if (wireType !== 2)
                        break;
                    message.heading = $root.Heading.decode(reader, reader.uint32(), $undefined, _depth + 1, message.heading);
                    message.type = "heading";
                    continue;
                }
            case 48: {
                    if (wireType !== 2)
                        break;
                    message.code = $root.Code.decode(reader, reader.uint32(), $undefined, _depth + 1, message.code);
                    message.type = "code";
                    continue;
                }
            case 64: {
                    if (wireType !== 2)
                        break;
                    message.menuButton = $root.MenuButton.decode(reader, reader.uint32(), $undefined, _depth + 1, message.menuButton);
                    message.type = "menuButton";
                    continue;
                }
            case 66: {
                    if (wireType !== 2)
                        break;
                    message.pagination = $root.Pagination.decode(reader, reader.uint32(), $undefined, _depth + 1, message.pagination);
                    message.type = "pagination";
                    continue;
                }
            case 67: {
                    if (wireType !== 2)
                        break;
                    message.echartsChart = $root.EChartsChart.decode(reader, reader.uint32(), $undefined, _depth + 1, message.echartsChart);
                    message.type = "echartsChart";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an Element message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Element
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Element} Element
     */
    Element.fromObject = function (object, _depth) {
        if (object instanceof $root.Element)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Element: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Element();
        if (object.heightConfig != null) {
            if (!$util.isObject(object.heightConfig))
                throw $TypeError(".Element.heightConfig: object expected");
            message.heightConfig = $root.streamlit.HeightConfig.fromObject(object.heightConfig, _depth + 1);
        }
        if (object.widthConfig != null) {
            if (!$util.isObject(object.widthConfig))
                throw $TypeError(".Element.widthConfig: object expected");
            message.widthConfig = $root.streamlit.WidthConfig.fromObject(object.widthConfig, _depth + 1);
        }
        if (object.textAlignmentConfig != null) {
            if (!$util.isObject(object.textAlignmentConfig))
                throw $TypeError(".Element.textAlignmentConfig: object expected");
            message.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.fromObject(object.textAlignmentConfig, _depth + 1);
        }
        if (object.hasOneShotEffect != null)
            message.hasOneShotEffect = $Boolean(object.hasOneShotEffect);
        if (object.alert != null) {
            if (!$util.isObject(object.alert))
                throw $TypeError(".Element.alert: object expected");
            message.alert = $root.Alert.fromObject(object.alert, _depth + 1);
        }
        if (object.dataframe != null) {
            if (!$util.isObject(object.dataframe))
                throw $TypeError(".Element.dataframe: object expected");
            message.dataframe = $root.Dataframe.fromObject(object.dataframe, _depth + 1);
        }
        if (object.table != null) {
            if (!$util.isObject(object.table))
                throw $TypeError(".Element.table: object expected");
            message.table = $root.Table.fromObject(object.table, _depth + 1);
        }
        if (object.vegaLiteChart != null) {
            if (!$util.isObject(object.vegaLiteChart))
                throw $TypeError(".Element.vegaLiteChart: object expected");
            message.vegaLiteChart = $root.VegaLiteChart.fromObject(object.vegaLiteChart, _depth + 1);
        }
        if (object.audio != null) {
            if (!$util.isObject(object.audio))
                throw $TypeError(".Element.audio: object expected");
            message.audio = $root.Audio.fromObject(object.audio, _depth + 1);
        }
        if (object.audioInput != null) {
            if (!$util.isObject(object.audioInput))
                throw $TypeError(".Element.audioInput: object expected");
            message.audioInput = $root.AudioInput.fromObject(object.audioInput, _depth + 1);
        }
        if (object.balloons != null) {
            if (!$util.isObject(object.balloons))
                throw $TypeError(".Element.balloons: object expected");
            message.balloons = $root.Balloons.fromObject(object.balloons, _depth + 1);
        }
        if (object.bidiComponent != null) {
            if (!$util.isObject(object.bidiComponent))
                throw $TypeError(".Element.bidiComponent: object expected");
            message.bidiComponent = $root.BidiComponent.fromObject(object.bidiComponent, _depth + 1);
        }
        if (object.button != null) {
            if (!$util.isObject(object.button))
                throw $TypeError(".Element.button: object expected");
            message.button = $root.Button.fromObject(object.button, _depth + 1);
        }
        if (object.buttonGroup != null) {
            if (!$util.isObject(object.buttonGroup))
                throw $TypeError(".Element.buttonGroup: object expected");
            message.buttonGroup = $root.ButtonGroup.fromObject(object.buttonGroup, _depth + 1);
        }
        if (object.downloadButton != null) {
            if (!$util.isObject(object.downloadButton))
                throw $TypeError(".Element.downloadButton: object expected");
            message.downloadButton = $root.DownloadButton.fromObject(object.downloadButton, _depth + 1);
        }
        if (object.cameraInput != null) {
            if (!$util.isObject(object.cameraInput))
                throw $TypeError(".Element.cameraInput: object expected");
            message.cameraInput = $root.CameraInput.fromObject(object.cameraInput, _depth + 1);
        }
        if (object.chatInput != null) {
            if (!$util.isObject(object.chatInput))
                throw $TypeError(".Element.chatInput: object expected");
            message.chatInput = $root.ChatInput.fromObject(object.chatInput, _depth + 1);
        }
        if (object.checkbox != null) {
            if (!$util.isObject(object.checkbox))
                throw $TypeError(".Element.checkbox: object expected");
            message.checkbox = $root.Checkbox.fromObject(object.checkbox, _depth + 1);
        }
        if (object.colorPicker != null) {
            if (!$util.isObject(object.colorPicker))
                throw $TypeError(".Element.colorPicker: object expected");
            message.colorPicker = $root.ColorPicker.fromObject(object.colorPicker, _depth + 1);
        }
        if (object.componentInstance != null) {
            if (!$util.isObject(object.componentInstance))
                throw $TypeError(".Element.componentInstance: object expected");
            message.componentInstance = $root.ComponentInstance.fromObject(object.componentInstance, _depth + 1);
        }
        if (object.dateInput != null) {
            if (!$util.isObject(object.dateInput))
                throw $TypeError(".Element.dateInput: object expected");
            message.dateInput = $root.DateInput.fromObject(object.dateInput, _depth + 1);
        }
        if (object.deckGlJsonChart != null) {
            if (!$util.isObject(object.deckGlJsonChart))
                throw $TypeError(".Element.deckGlJsonChart: object expected");
            message.deckGlJsonChart = $root.DeckGlJsonChart.fromObject(object.deckGlJsonChart, _depth + 1);
        }
        if (object.helpInfo != null) {
            if (!$util.isObject(object.helpInfo))
                throw $TypeError(".Element.helpInfo: object expected");
            message.helpInfo = $root.Help.fromObject(object.helpInfo, _depth + 1);
        }
        if (object.empty != null) {
            if (!$util.isObject(object.empty))
                throw $TypeError(".Element.empty: object expected");
            message.empty = $root.Empty.fromObject(object.empty, _depth + 1);
        }
        if (object.exception != null) {
            if (!$util.isObject(object.exception))
                throw $TypeError(".Element.exception: object expected");
            message.exception = $root.Exception.fromObject(object.exception, _depth + 1);
        }
        if (object.favicon != null) {
            if (!$util.isObject(object.favicon))
                throw $TypeError(".Element.favicon: object expected");
            message.favicon = $root.Favicon.fromObject(object.favicon, _depth + 1);
        }
        if (object.feedback != null) {
            if (!$util.isObject(object.feedback))
                throw $TypeError(".Element.feedback: object expected");
            message.feedback = $root.Feedback.fromObject(object.feedback, _depth + 1);
        }
        if (object.fileUploader != null) {
            if (!$util.isObject(object.fileUploader))
                throw $TypeError(".Element.fileUploader: object expected");
            message.fileUploader = $root.FileUploader.fromObject(object.fileUploader, _depth + 1);
        }
        if (object.graphvizChart != null) {
            if (!$util.isObject(object.graphvizChart))
                throw $TypeError(".Element.graphvizChart: object expected");
            message.graphvizChart = $root.GraphVizChart.fromObject(object.graphvizChart, _depth + 1);
        }
        if (object.html != null) {
            if (!$util.isObject(object.html))
                throw $TypeError(".Element.html: object expected");
            message.html = $root.Html.fromObject(object.html, _depth + 1);
        }
        if (object.iframe != null) {
            if (!$util.isObject(object.iframe))
                throw $TypeError(".Element.iframe: object expected");
            message.iframe = $root.IFrame.fromObject(object.iframe, _depth + 1);
        }
        if (object.imgs != null) {
            if (!$util.isObject(object.imgs))
                throw $TypeError(".Element.imgs: object expected");
            message.imgs = $root.ImageList.fromObject(object.imgs, _depth + 1);
        }
        if (object.json != null) {
            if (!$util.isObject(object.json))
                throw $TypeError(".Element.json: object expected");
            message.json = $root.Json.fromObject(object.json, _depth + 1);
        }
        if (object.linkButton != null) {
            if (!$util.isObject(object.linkButton))
                throw $TypeError(".Element.linkButton: object expected");
            message.linkButton = $root.LinkButton.fromObject(object.linkButton, _depth + 1);
        }
        if (object.markdown != null) {
            if (!$util.isObject(object.markdown))
                throw $TypeError(".Element.markdown: object expected");
            message.markdown = $root.Markdown.fromObject(object.markdown, _depth + 1);
        }
        if (object.metric != null) {
            if (!$util.isObject(object.metric))
                throw $TypeError(".Element.metric: object expected");
            message.metric = $root.Metric.fromObject(object.metric, _depth + 1);
        }
        if (object.multiselect != null) {
            if (!$util.isObject(object.multiselect))
                throw $TypeError(".Element.multiselect: object expected");
            message.multiselect = $root.MultiSelect.fromObject(object.multiselect, _depth + 1);
        }
        if (object.numberInput != null) {
            if (!$util.isObject(object.numberInput))
                throw $TypeError(".Element.numberInput: object expected");
            message.numberInput = $root.NumberInput.fromObject(object.numberInput, _depth + 1);
        }
        if (object.pageLink != null) {
            if (!$util.isObject(object.pageLink))
                throw $TypeError(".Element.pageLink: object expected");
            message.pageLink = $root.PageLink.fromObject(object.pageLink, _depth + 1);
        }
        if (object.plotlyChart != null) {
            if (!$util.isObject(object.plotlyChart))
                throw $TypeError(".Element.plotlyChart: object expected");
            message.plotlyChart = $root.PlotlyChart.fromObject(object.plotlyChart, _depth + 1);
        }
        if (object.progress != null) {
            if (!$util.isObject(object.progress))
                throw $TypeError(".Element.progress: object expected");
            message.progress = $root.Progress.fromObject(object.progress, _depth + 1);
        }
        if (object.radio != null) {
            if (!$util.isObject(object.radio))
                throw $TypeError(".Element.radio: object expected");
            message.radio = $root.Radio.fromObject(object.radio, _depth + 1);
        }
        if (object.selectbox != null) {
            if (!$util.isObject(object.selectbox))
                throw $TypeError(".Element.selectbox: object expected");
            message.selectbox = $root.Selectbox.fromObject(object.selectbox, _depth + 1);
        }
        if (object.skeleton != null) {
            if (!$util.isObject(object.skeleton))
                throw $TypeError(".Element.skeleton: object expected");
            message.skeleton = $root.Skeleton.fromObject(object.skeleton, _depth + 1);
        }
        if (object.slider != null) {
            if (!$util.isObject(object.slider))
                throw $TypeError(".Element.slider: object expected");
            message.slider = $root.Slider.fromObject(object.slider, _depth + 1);
        }
        if (object.snow != null) {
            if (!$util.isObject(object.snow))
                throw $TypeError(".Element.snow: object expected");
            message.snow = $root.Snow.fromObject(object.snow, _depth + 1);
        }
        if (object.space != null) {
            if (!$util.isObject(object.space))
                throw $TypeError(".Element.space: object expected");
            message.space = $root.Space.fromObject(object.space, _depth + 1);
        }
        if (object.spinner != null) {
            if (!$util.isObject(object.spinner))
                throw $TypeError(".Element.spinner: object expected");
            message.spinner = $root.Spinner.fromObject(object.spinner, _depth + 1);
        }
        if (object.text != null) {
            if (!$util.isObject(object.text))
                throw $TypeError(".Element.text: object expected");
            message.text = $root.Text.fromObject(object.text, _depth + 1);
        }
        if (object.textArea != null) {
            if (!$util.isObject(object.textArea))
                throw $TypeError(".Element.textArea: object expected");
            message.textArea = $root.TextArea.fromObject(object.textArea, _depth + 1);
        }
        if (object.textInput != null) {
            if (!$util.isObject(object.textInput))
                throw $TypeError(".Element.textInput: object expected");
            message.textInput = $root.TextInput.fromObject(object.textInput, _depth + 1);
        }
        if (object.timeInput != null) {
            if (!$util.isObject(object.timeInput))
                throw $TypeError(".Element.timeInput: object expected");
            message.timeInput = $root.TimeInput.fromObject(object.timeInput, _depth + 1);
        }
        if (object.dateTimeInput != null) {
            if (!$util.isObject(object.dateTimeInput))
                throw $TypeError(".Element.dateTimeInput: object expected");
            message.dateTimeInput = $root.DateTimeInput.fromObject(object.dateTimeInput, _depth + 1);
        }
        if (object.toast != null) {
            if (!$util.isObject(object.toast))
                throw $TypeError(".Element.toast: object expected");
            message.toast = $root.Toast.fromObject(object.toast, _depth + 1);
        }
        if (object.video != null) {
            if (!$util.isObject(object.video))
                throw $TypeError(".Element.video: object expected");
            message.video = $root.Video.fromObject(object.video, _depth + 1);
        }
        if (object.heading != null) {
            if (!$util.isObject(object.heading))
                throw $TypeError(".Element.heading: object expected");
            message.heading = $root.Heading.fromObject(object.heading, _depth + 1);
        }
        if (object.code != null) {
            if (!$util.isObject(object.code))
                throw $TypeError(".Element.code: object expected");
            message.code = $root.Code.fromObject(object.code, _depth + 1);
        }
        if (object.menuButton != null) {
            if (!$util.isObject(object.menuButton))
                throw $TypeError(".Element.menuButton: object expected");
            message.menuButton = $root.MenuButton.fromObject(object.menuButton, _depth + 1);
        }
        if (object.pagination != null) {
            if (!$util.isObject(object.pagination))
                throw $TypeError(".Element.pagination: object expected");
            message.pagination = $root.Pagination.fromObject(object.pagination, _depth + 1);
        }
        if (object.echartsChart != null) {
            if (!$util.isObject(object.echartsChart))
                throw $TypeError(".Element.echartsChart: object expected");
            message.echartsChart = $root.EChartsChart.fromObject(object.echartsChart, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from an Element message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Element
     * @static
     * @param {Element} message Element
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Element.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (message.text != null && $Object.hasOwnProperty.call(message, "text")) {
            object.text = $root.Text.toObject(message.text, options, _depth + 1);
            if (options.oneofs)
                object.type = "text";
        }
        if (message.empty != null && $Object.hasOwnProperty.call(message, "empty")) {
            object.empty = $root.Empty.toObject(message.empty, options, _depth + 1);
            if (options.oneofs)
                object.type = "empty";
        }
        if (message.progress != null && $Object.hasOwnProperty.call(message, "progress")) {
            object.progress = $root.Progress.toObject(message.progress, options, _depth + 1);
            if (options.oneofs)
                object.type = "progress";
        }
        if (message.imgs != null && $Object.hasOwnProperty.call(message, "imgs")) {
            object.imgs = $root.ImageList.toObject(message.imgs, options, _depth + 1);
            if (options.oneofs)
                object.type = "imgs";
        }
        if (message.helpInfo != null && $Object.hasOwnProperty.call(message, "helpInfo")) {
            object.helpInfo = $root.Help.toObject(message.helpInfo, options, _depth + 1);
            if (options.oneofs)
                object.type = "helpInfo";
        }
        if (message.exception != null && $Object.hasOwnProperty.call(message, "exception")) {
            object.exception = $root.Exception.toObject(message.exception, options, _depth + 1);
            if (options.oneofs)
                object.type = "exception";
        }
        if (message.balloons != null && $Object.hasOwnProperty.call(message, "balloons")) {
            object.balloons = $root.Balloons.toObject(message.balloons, options, _depth + 1);
            if (options.oneofs)
                object.type = "balloons";
        }
        if (message.audio != null && $Object.hasOwnProperty.call(message, "audio")) {
            object.audio = $root.Audio.toObject(message.audio, options, _depth + 1);
            if (options.oneofs)
                object.type = "audio";
        }
        if (message.video != null && $Object.hasOwnProperty.call(message, "video")) {
            object.video = $root.Video.toObject(message.video, options, _depth + 1);
            if (options.oneofs)
                object.type = "video";
        }
        if (message.plotlyChart != null && $Object.hasOwnProperty.call(message, "plotlyChart")) {
            object.plotlyChart = $root.PlotlyChart.toObject(message.plotlyChart, options, _depth + 1);
            if (options.oneofs)
                object.type = "plotlyChart";
        }
        if (message.graphvizChart != null && $Object.hasOwnProperty.call(message, "graphvizChart")) {
            object.graphvizChart = $root.GraphVizChart.toObject(message.graphvizChart, options, _depth + 1);
            if (options.oneofs)
                object.type = "graphvizChart";
        }
        if (message.button != null && $Object.hasOwnProperty.call(message, "button")) {
            object.button = $root.Button.toObject(message.button, options, _depth + 1);
            if (options.oneofs)
                object.type = "button";
        }
        if (message.checkbox != null && $Object.hasOwnProperty.call(message, "checkbox")) {
            object.checkbox = $root.Checkbox.toObject(message.checkbox, options, _depth + 1);
            if (options.oneofs)
                object.type = "checkbox";
        }
        if (message.slider != null && $Object.hasOwnProperty.call(message, "slider")) {
            object.slider = $root.Slider.toObject(message.slider, options, _depth + 1);
            if (options.oneofs)
                object.type = "slider";
        }
        if (message.textArea != null && $Object.hasOwnProperty.call(message, "textArea")) {
            object.textArea = $root.TextArea.toObject(message.textArea, options, _depth + 1);
            if (options.oneofs)
                object.type = "textArea";
        }
        if (message.radio != null && $Object.hasOwnProperty.call(message, "radio")) {
            object.radio = $root.Radio.toObject(message.radio, options, _depth + 1);
            if (options.oneofs)
                object.type = "radio";
        }
        if (message.textInput != null && $Object.hasOwnProperty.call(message, "textInput")) {
            object.textInput = $root.TextInput.toObject(message.textInput, options, _depth + 1);
            if (options.oneofs)
                object.type = "textInput";
        }
        if (message.selectbox != null && $Object.hasOwnProperty.call(message, "selectbox")) {
            object.selectbox = $root.Selectbox.toObject(message.selectbox, options, _depth + 1);
            if (options.oneofs)
                object.type = "selectbox";
        }
        if (message.timeInput != null && $Object.hasOwnProperty.call(message, "timeInput")) {
            object.timeInput = $root.TimeInput.toObject(message.timeInput, options, _depth + 1);
            if (options.oneofs)
                object.type = "timeInput";
        }
        if (message.dateInput != null && $Object.hasOwnProperty.call(message, "dateInput")) {
            object.dateInput = $root.DateInput.toObject(message.dateInput, options, _depth + 1);
            if (options.oneofs)
                object.type = "dateInput";
        }
        if (message.multiselect != null && $Object.hasOwnProperty.call(message, "multiselect")) {
            object.multiselect = $root.MultiSelect.toObject(message.multiselect, options, _depth + 1);
            if (options.oneofs)
                object.type = "multiselect";
        }
        if (message.markdown != null && $Object.hasOwnProperty.call(message, "markdown")) {
            object.markdown = $root.Markdown.toObject(message.markdown, options, _depth + 1);
            if (options.oneofs)
                object.type = "markdown";
        }
        if (message.alert != null && $Object.hasOwnProperty.call(message, "alert")) {
            object.alert = $root.Alert.toObject(message.alert, options, _depth + 1);
            if (options.oneofs)
                object.type = "alert";
        }
        if (message.json != null && $Object.hasOwnProperty.call(message, "json")) {
            object.json = $root.Json.toObject(message.json, options, _depth + 1);
            if (options.oneofs)
                object.type = "json";
        }
        if (message.numberInput != null && $Object.hasOwnProperty.call(message, "numberInput")) {
            object.numberInput = $root.NumberInput.toObject(message.numberInput, options, _depth + 1);
            if (options.oneofs)
                object.type = "numberInput";
        }
        if (message.fileUploader != null && $Object.hasOwnProperty.call(message, "fileUploader")) {
            object.fileUploader = $root.FileUploader.toObject(message.fileUploader, options, _depth + 1);
            if (options.oneofs)
                object.type = "fileUploader";
        }
        if (message.deckGlJsonChart != null && $Object.hasOwnProperty.call(message, "deckGlJsonChart")) {
            object.deckGlJsonChart = $root.DeckGlJsonChart.toObject(message.deckGlJsonChart, options, _depth + 1);
            if (options.oneofs)
                object.type = "deckGlJsonChart";
        }
        if (message.colorPicker != null && $Object.hasOwnProperty.call(message, "colorPicker")) {
            object.colorPicker = $root.ColorPicker.toObject(message.colorPicker, options, _depth + 1);
            if (options.oneofs)
                object.type = "colorPicker";
        }
        if (message.favicon != null && $Object.hasOwnProperty.call(message, "favicon")) {
            object.favicon = $root.Favicon.toObject(message.favicon, options, _depth + 1);
            if (options.oneofs)
                object.type = "favicon";
        }
        if (message.componentInstance != null && $Object.hasOwnProperty.call(message, "componentInstance")) {
            object.componentInstance = $root.ComponentInstance.toObject(message.componentInstance, options, _depth + 1);
            if (options.oneofs)
                object.type = "componentInstance";
        }
        if (message.iframe != null && $Object.hasOwnProperty.call(message, "iframe")) {
            object.iframe = $root.IFrame.toObject(message.iframe, options, _depth + 1);
            if (options.oneofs)
                object.type = "iframe";
        }
        if (message.table != null && $Object.hasOwnProperty.call(message, "table")) {
            object.table = $root.Table.toObject(message.table, options, _depth + 1);
            if (options.oneofs)
                object.type = "table";
        }
        if (message.dataframe != null && $Object.hasOwnProperty.call(message, "dataframe")) {
            object.dataframe = $root.Dataframe.toObject(message.dataframe, options, _depth + 1);
            if (options.oneofs)
                object.type = "dataframe";
        }
        if (message.vegaLiteChart != null && $Object.hasOwnProperty.call(message, "vegaLiteChart")) {
            object.vegaLiteChart = $root.VegaLiteChart.toObject(message.vegaLiteChart, options, _depth + 1);
            if (options.oneofs)
                object.type = "vegaLiteChart";
        }
        if (message.metric != null && $Object.hasOwnProperty.call(message, "metric")) {
            object.metric = $root.Metric.toObject(message.metric, options, _depth + 1);
            if (options.oneofs)
                object.type = "metric";
        }
        if (message.downloadButton != null && $Object.hasOwnProperty.call(message, "downloadButton")) {
            object.downloadButton = $root.DownloadButton.toObject(message.downloadButton, options, _depth + 1);
            if (options.oneofs)
                object.type = "downloadButton";
        }
        if (message.spinner != null && $Object.hasOwnProperty.call(message, "spinner")) {
            object.spinner = $root.Spinner.toObject(message.spinner, options, _depth + 1);
            if (options.oneofs)
                object.type = "spinner";
        }
        if (message.cameraInput != null && $Object.hasOwnProperty.call(message, "cameraInput")) {
            object.cameraInput = $root.CameraInput.toObject(message.cameraInput, options, _depth + 1);
            if (options.oneofs)
                object.type = "cameraInput";
        }
        if (message.snow != null && $Object.hasOwnProperty.call(message, "snow")) {
            object.snow = $root.Snow.toObject(message.snow, options, _depth + 1);
            if (options.oneofs)
                object.type = "snow";
        }
        if (message.heading != null && $Object.hasOwnProperty.call(message, "heading")) {
            object.heading = $root.Heading.toObject(message.heading, options, _depth + 1);
            if (options.oneofs)
                object.type = "heading";
        }
        if (message.code != null && $Object.hasOwnProperty.call(message, "code")) {
            object.code = $root.Code.toObject(message.code, options, _depth + 1);
            if (options.oneofs)
                object.type = "code";
        }
        if (message.chatInput != null && $Object.hasOwnProperty.call(message, "chatInput")) {
            object.chatInput = $root.ChatInput.toObject(message.chatInput, options, _depth + 1);
            if (options.oneofs)
                object.type = "chatInput";
        }
        if (message.toast != null && $Object.hasOwnProperty.call(message, "toast")) {
            object.toast = $root.Toast.toObject(message.toast, options, _depth + 1);
            if (options.oneofs)
                object.type = "toast";
        }
        if (message.linkButton != null && $Object.hasOwnProperty.call(message, "linkButton")) {
            object.linkButton = $root.LinkButton.toObject(message.linkButton, options, _depth + 1);
            if (options.oneofs)
                object.type = "linkButton";
        }
        if (message.skeleton != null && $Object.hasOwnProperty.call(message, "skeleton")) {
            object.skeleton = $root.Skeleton.toObject(message.skeleton, options, _depth + 1);
            if (options.oneofs)
                object.type = "skeleton";
        }
        if (message.pageLink != null && $Object.hasOwnProperty.call(message, "pageLink")) {
            object.pageLink = $root.PageLink.toObject(message.pageLink, options, _depth + 1);
            if (options.oneofs)
                object.type = "pageLink";
        }
        if (message.html != null && $Object.hasOwnProperty.call(message, "html")) {
            object.html = $root.Html.toObject(message.html, options, _depth + 1);
            if (options.oneofs)
                object.type = "html";
        }
        if (message.buttonGroup != null && $Object.hasOwnProperty.call(message, "buttonGroup")) {
            object.buttonGroup = $root.ButtonGroup.toObject(message.buttonGroup, options, _depth + 1);
            if (options.oneofs)
                object.type = "buttonGroup";
        }
        if (message.audioInput != null && $Object.hasOwnProperty.call(message, "audioInput")) {
            object.audioInput = $root.AudioInput.toObject(message.audioInput, options, _depth + 1);
            if (options.oneofs)
                object.type = "audioInput";
        }
        if (message.heightConfig != null && $Object.hasOwnProperty.call(message, "heightConfig"))
            object.heightConfig = $root.streamlit.HeightConfig.toObject(message.heightConfig, options, _depth + 1);
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            object.widthConfig = $root.streamlit.WidthConfig.toObject(message.widthConfig, options, _depth + 1);
        if (message.bidiComponent != null && $Object.hasOwnProperty.call(message, "bidiComponent")) {
            object.bidiComponent = $root.BidiComponent.toObject(message.bidiComponent, options, _depth + 1);
            if (options.oneofs)
                object.type = "bidiComponent";
        }
        if (message.space != null && $Object.hasOwnProperty.call(message, "space")) {
            object.space = $root.Space.toObject(message.space, options, _depth + 1);
            if (options.oneofs)
                object.type = "space";
        }
        if (message.textAlignmentConfig != null && $Object.hasOwnProperty.call(message, "textAlignmentConfig"))
            object.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.toObject(message.textAlignmentConfig, options, _depth + 1);
        if (message.dateTimeInput != null && $Object.hasOwnProperty.call(message, "dateTimeInput")) {
            object.dateTimeInput = $root.DateTimeInput.toObject(message.dateTimeInput, options, _depth + 1);
            if (options.oneofs)
                object.type = "dateTimeInput";
        }
        if (message.feedback != null && $Object.hasOwnProperty.call(message, "feedback")) {
            object.feedback = $root.Feedback.toObject(message.feedback, options, _depth + 1);
            if (options.oneofs)
                object.type = "feedback";
        }
        if (message.menuButton != null && $Object.hasOwnProperty.call(message, "menuButton")) {
            object.menuButton = $root.MenuButton.toObject(message.menuButton, options, _depth + 1);
            if (options.oneofs)
                object.type = "menuButton";
        }
        if (message.hasOneShotEffect != null && $Object.hasOwnProperty.call(message, "hasOneShotEffect"))
            object.hasOneShotEffect = message.hasOneShotEffect;
        if (message.pagination != null && $Object.hasOwnProperty.call(message, "pagination")) {
            object.pagination = $root.Pagination.toObject(message.pagination, options, _depth + 1);
            if (options.oneofs)
                object.type = "pagination";
        }
        if (message.echartsChart != null && $Object.hasOwnProperty.call(message, "echartsChart")) {
            object.echartsChart = $root.EChartsChart.toObject(message.echartsChart, options, _depth + 1);
            if (options.oneofs)
                object.type = "echartsChart";
        }
        return object;
    };

    /**
     * Converts this Element to JSON.
     * @function toJSON
     * @memberof Element
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Element.prototype.toJSON = function() {
        return Element.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Element
     * @function getTypeUrl
     * @memberof Element
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Element.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Element";
    };

    return Element;
})();

export const DownloadButton = $root.DownloadButton = (() => {

    /**
     * Properties of a DownloadButton.
     * @typedef {Object} DownloadButton.$Properties
     * @property {string|null} [id] DownloadButton id
     * @property {string|null} [label] DownloadButton label
     * @property {boolean|null} ["default"] DownloadButton default
     * @property {string|null} [help] DownloadButton help
     * @property {string|null} [formId] DownloadButton formId
     * @property {string|null} [url] DownloadButton url
     * @property {boolean|null} [disabled] DownloadButton disabled
     * @property {boolean|null} [useContainerWidth] DownloadButton useContainerWidth
     * @property {string|null} [type] DownloadButton type
     * @property {string|null} [icon] DownloadButton icon
     * @property {boolean|null} [ignoreRerun] DownloadButton ignoreRerun
     * @property {string|null} [deferredFileId] DownloadButton deferredFileId
     * @property {string|null} [shortcut] DownloadButton shortcut
     * @property {streamlit.ButtonLikeIconPosition|null} [iconPosition] DownloadButton iconPosition
     * @property {boolean|null} [wrap] DownloadButton wrap
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DownloadButton.
     * @exports IDownloadButton
     * @interface IDownloadButton
     * @augments DownloadButton.$Properties
     * @deprecated Use DownloadButton.$Properties instead.
     */

    /**
     * Shape of a DownloadButton.
     * @typedef {DownloadButton.$Properties} DownloadButton.$Shape
     */

    /**
     * Constructs a new DownloadButton.
     * @exports DownloadButton
     * @classdesc Represents a DownloadButton.
     * @constructor
     * @param {DownloadButton.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DownloadButton = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * DownloadButton id.
     * @member {string} id
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.id = "";

    /**
     * DownloadButton label.
     * @member {string} label
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.label = "";

    /**
     * DownloadButton default.
     * @member {boolean} default
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype["default"] = false;

    /**
     * DownloadButton help.
     * @member {string} help
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.help = "";

    /**
     * DownloadButton formId.
     * @member {string} formId
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.formId = "";

    /**
     * DownloadButton url.
     * @member {string} url
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.url = "";

    /**
     * DownloadButton disabled.
     * @member {boolean} disabled
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.disabled = false;

    /**
     * DownloadButton useContainerWidth.
     * @member {boolean} useContainerWidth
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.useContainerWidth = false;

    /**
     * DownloadButton type.
     * @member {string} type
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.type = "";

    /**
     * DownloadButton icon.
     * @member {string} icon
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.icon = "";

    /**
     * DownloadButton ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.ignoreRerun = false;

    /**
     * DownloadButton deferredFileId.
     * @member {string|null|undefined} deferredFileId
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.deferredFileId = null;

    /**
     * DownloadButton shortcut.
     * @member {string} shortcut
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.shortcut = "";

    /**
     * DownloadButton iconPosition.
     * @member {streamlit.ButtonLikeIconPosition} iconPosition
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.iconPosition = 0;

    /**
     * DownloadButton wrap.
     * @member {boolean|null|undefined} wrap
     * @memberof DownloadButton
     * @instance
     */
    DownloadButton.prototype.wrap = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(DownloadButton.prototype, "_deferredFileId", {
        get: $util.oneOfGetter($oneOfFields = ["deferredFileId"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(DownloadButton.prototype, "_wrap", {
        get: $util.oneOfGetter($oneOfFields = ["wrap"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new DownloadButton instance using the specified properties.
     * @function create
     * @memberof DownloadButton
     * @static
     * @param {DownloadButton.$Properties=} [properties] Properties to set
     * @returns {DownloadButton} DownloadButton instance
     * @type {{
     *   (properties: DownloadButton.$Shape): DownloadButton & DownloadButton.$Shape;
     *   (properties?: DownloadButton.$Properties): DownloadButton;
     * }}
     */
    DownloadButton.create = function(properties) {
        return new DownloadButton(properties);
    };

    /**
     * Encodes the specified DownloadButton message. Does not implicitly {@link DownloadButton.verify|verify} messages.
     * @function encode
     * @memberof DownloadButton
     * @static
     * @param {DownloadButton.$Properties} message DownloadButton message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DownloadButton.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default") && message["default"] !== false)
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message["default"]);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.formId);
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.url);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.disabled);
        if (message.useContainerWidth != null && $Object.hasOwnProperty.call(message, "useContainerWidth") && message.useContainerWidth !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.useContainerWidth);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== "")
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.type);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.icon);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.ignoreRerun);
        if (message.deferredFileId != null && $Object.hasOwnProperty.call(message, "deferredFileId"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.deferredFileId);
        if (message.shortcut != null && $Object.hasOwnProperty.call(message, "shortcut") && message.shortcut !== "")
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.shortcut);
        if (message.iconPosition != null && $Object.hasOwnProperty.call(message, "iconPosition") && message.iconPosition !== 0)
            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.iconPosition);
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.wrap);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DownloadButton message from the specified reader or buffer.
     * @function decode
     * @memberof DownloadButton
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DownloadButton & DownloadButton.$Shape} DownloadButton
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DownloadButton.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DownloadButton();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message["default"] = value;
                    else
                        delete message["default"];
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.useContainerWidth = value;
                    else
                        delete message.useContainerWidth;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            case 11: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.deferredFileId = reader.stringVerify();
                    message._deferredFileId = "deferredFileId";
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.shortcut = value;
                    else
                        delete message.shortcut;
                    continue;
                }
            case 14: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.iconPosition = value;
                    else
                        delete message.iconPosition;
                    continue;
                }
            case 15: {
                    if (wireType !== 0)
                        break;
                    message.wrap = reader.bool();
                    message._wrap = "wrap";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DownloadButton message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DownloadButton
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DownloadButton} DownloadButton
     */
    DownloadButton.fromObject = function (object, _depth) {
        if (object instanceof $root.DownloadButton)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DownloadButton: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.DownloadButton();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"] != null)
            if (object["default"])
                message["default"] = $Boolean(object["default"]);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.useContainerWidth != null)
            if (object.useContainerWidth)
                message.useContainerWidth = $Boolean(object.useContainerWidth);
        if (object.type != null)
            if (typeof object.type !== "string" || object.type.length)
                message.type = $String(object.type);
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        if (object.deferredFileId != null)
            message.deferredFileId = $String(object.deferredFileId);
        if (object.shortcut != null)
            if (typeof object.shortcut !== "string" || object.shortcut.length)
                message.shortcut = $String(object.shortcut);
        if (object.iconPosition !== 0 && (typeof object.iconPosition !== "string" || $root.streamlit.ButtonLikeIconPosition[object.iconPosition] !== 0))
            switch (object.iconPosition) {
            case "LEFT":
            case 0:
                message.iconPosition = 0;
                break;
            case "RIGHT":
            case 1:
                message.iconPosition = 1;
                break;
            default:
                if (typeof object.iconPosition === "number" && (object.iconPosition | 0) === object.iconPosition)
                    message.iconPosition = object.iconPosition;
            }
        if (object.wrap != null)
            message.wrap = $Boolean(object.wrap);
        return message;
    };

    /**
     * Creates a plain object from a DownloadButton message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DownloadButton
     * @static
     * @param {DownloadButton} message DownloadButton
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DownloadButton.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object["default"] = false;
            object.help = "";
            object.formId = "";
            object.url = "";
            object.disabled = false;
            object.useContainerWidth = false;
            object.type = "";
            object.icon = "";
            object.ignoreRerun = false;
            object.shortcut = "";
            object.iconPosition = options.enums === $String ? "LEFT" : 0;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.useContainerWidth != null && $Object.hasOwnProperty.call(message, "useContainerWidth"))
            object.useContainerWidth = message.useContainerWidth;
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = message.type;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        if (message.deferredFileId != null && $Object.hasOwnProperty.call(message, "deferredFileId"))
            object.deferredFileId = message.deferredFileId;
        if (message.shortcut != null && $Object.hasOwnProperty.call(message, "shortcut"))
            object.shortcut = message.shortcut;
        if (message.iconPosition != null && $Object.hasOwnProperty.call(message, "iconPosition"))
            object.iconPosition = options.enums === $String ? $root.streamlit.ButtonLikeIconPosition[message.iconPosition] === $undefined ? message.iconPosition : $root.streamlit.ButtonLikeIconPosition[message.iconPosition] : message.iconPosition;
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            object.wrap = message.wrap;
        return object;
    };

    /**
     * Converts this DownloadButton to JSON.
     * @function toJSON
     * @memberof DownloadButton
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DownloadButton.prototype.toJSON = function() {
        return DownloadButton.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DownloadButton
     * @function getTypeUrl
     * @memberof DownloadButton
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DownloadButton.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DownloadButton";
    };

    return DownloadButton;
})();

export const EChartsChart = $root.EChartsChart = (() => {

    /**
     * Properties of a EChartsChart.
     * @typedef {Object} EChartsChart.$Properties
     * @property {string|null} [spec] EChartsChart spec
     * @property {string|null} [theme] EChartsChart theme
     * @property {string|null} [id] EChartsChart id
     * @property {EChartsChart.Renderer|null} [renderer] EChartsChart renderer
     * @property {string|null} [alt] EChartsChart alt
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a EChartsChart.
     * @exports IEChartsChart
     * @interface IEChartsChart
     * @augments EChartsChart.$Properties
     * @deprecated Use EChartsChart.$Properties instead.
     */

    /**
     * Shape of a EChartsChart.
     * @typedef {EChartsChart.$Properties} EChartsChart.$Shape
     */

    /**
     * Constructs a new EChartsChart.
     * @exports EChartsChart
     * @classdesc Represents a EChartsChart.
     * @constructor
     * @param {EChartsChart.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const EChartsChart = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * EChartsChart spec.
     * @member {string} spec
     * @memberof EChartsChart
     * @instance
     */
    EChartsChart.prototype.spec = "";

    /**
     * EChartsChart theme.
     * @member {string} theme
     * @memberof EChartsChart
     * @instance
     */
    EChartsChart.prototype.theme = "";

    /**
     * EChartsChart id.
     * @member {string} id
     * @memberof EChartsChart
     * @instance
     */
    EChartsChart.prototype.id = "";

    /**
     * EChartsChart renderer.
     * @member {EChartsChart.Renderer} renderer
     * @memberof EChartsChart
     * @instance
     */
    EChartsChart.prototype.renderer = 0;

    /**
     * EChartsChart alt.
     * @member {string|null|undefined} alt
     * @memberof EChartsChart
     * @instance
     */
    EChartsChart.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(EChartsChart.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new EChartsChart instance using the specified properties.
     * @function create
     * @memberof EChartsChart
     * @static
     * @param {EChartsChart.$Properties=} [properties] Properties to set
     * @returns {EChartsChart} EChartsChart instance
     * @type {{
     *   (properties: EChartsChart.$Shape): EChartsChart & EChartsChart.$Shape;
     *   (properties?: EChartsChart.$Properties): EChartsChart;
     * }}
     */
    EChartsChart.create = function(properties) {
        return new EChartsChart(properties);
    };

    /**
     * Encodes the specified EChartsChart message. Does not implicitly {@link EChartsChart.verify|verify} messages.
     * @function encode
     * @memberof EChartsChart
     * @static
     * @param {EChartsChart.$Properties} message EChartsChart message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EChartsChart.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.spec != null && $Object.hasOwnProperty.call(message, "spec") && message.spec !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.spec);
        if (message.theme != null && $Object.hasOwnProperty.call(message, "theme") && message.theme !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.theme);
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.id);
        if (message.renderer != null && $Object.hasOwnProperty.call(message, "renderer") && message.renderer !== 0)
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.renderer);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a EChartsChart message from the specified reader or buffer.
     * @function decode
     * @memberof EChartsChart
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EChartsChart & EChartsChart.$Shape} EChartsChart
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EChartsChart.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.EChartsChart();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.spec = value;
                    else
                        delete message.spec;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.theme = value;
                    else
                        delete message.theme;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.renderer = value;
                    else
                        delete message.renderer;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a EChartsChart message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EChartsChart
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EChartsChart} EChartsChart
     */
    EChartsChart.fromObject = function (object, _depth) {
        if (object instanceof $root.EChartsChart)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".EChartsChart: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.EChartsChart();
        if (object.spec != null)
            if (typeof object.spec !== "string" || object.spec.length)
                message.spec = $String(object.spec);
        if (object.theme != null)
            if (typeof object.theme !== "string" || object.theme.length)
                message.theme = $String(object.theme);
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.renderer !== 0 && (typeof object.renderer !== "string" || $root.EChartsChart.Renderer[object.renderer] !== 0))
            switch (object.renderer) {
            case "CANVAS":
            case 0:
                message.renderer = 0;
                break;
            case "SVG":
            case 1:
                message.renderer = 1;
                break;
            default:
                if (typeof object.renderer === "number" && (object.renderer | 0) === object.renderer)
                    message.renderer = object.renderer;
            }
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from a EChartsChart message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EChartsChart
     * @static
     * @param {EChartsChart} message EChartsChart
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EChartsChart.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.spec = "";
            object.theme = "";
            object.id = "";
            object.renderer = options.enums === $String ? "CANVAS" : 0;
        }
        if (message.spec != null && $Object.hasOwnProperty.call(message, "spec"))
            object.spec = message.spec;
        if (message.theme != null && $Object.hasOwnProperty.call(message, "theme"))
            object.theme = message.theme;
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.renderer != null && $Object.hasOwnProperty.call(message, "renderer"))
            object.renderer = options.enums === $String ? $root.EChartsChart.Renderer[message.renderer] === $undefined ? message.renderer : $root.EChartsChart.Renderer[message.renderer] : message.renderer;
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this EChartsChart to JSON.
     * @function toJSON
     * @memberof EChartsChart
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EChartsChart.prototype.toJSON = function() {
        return EChartsChart.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for EChartsChart
     * @function getTypeUrl
     * @memberof EChartsChart
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    EChartsChart.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/EChartsChart";
    };

    /**
     * Renderer enum.
     * @name EChartsChart.Renderer
     * @enum {number}
     * @property {number} CANVAS=0 CANVAS value
     * @property {number} SVG=1 SVG value
     */
    EChartsChart.Renderer = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "CANVAS"] = 0;
        values[valuesById[1] = "SVG"] = 1;
        return values;
    })();

    return EChartsChart;
})();

export const Empty = $root.Empty = (() => {

    /**
     * Properties of an Empty.
     * @typedef {Object} Empty.$Properties
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an Empty.
     * @exports IEmpty
     * @interface IEmpty
     * @augments Empty.$Properties
     * @deprecated Use Empty.$Properties instead.
     */

    /**
     * Shape of an Empty.
     * @typedef {Empty.$Properties} Empty.$Shape
     */

    /**
     * Constructs a new Empty.
     * @exports Empty
     * @classdesc Represents an Empty.
     * @constructor
     * @param {Empty.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Empty = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Creates a new Empty instance using the specified properties.
     * @function create
     * @memberof Empty
     * @static
     * @param {Empty.$Properties=} [properties] Properties to set
     * @returns {Empty} Empty instance
     * @type {{
     *   (properties: Empty.$Shape): Empty & Empty.$Shape;
     *   (properties?: Empty.$Properties): Empty;
     * }}
     */
    Empty.create = function(properties) {
        return new Empty(properties);
    };

    /**
     * Encodes the specified Empty message. Does not implicitly {@link Empty.verify|verify} messages.
     * @function encode
     * @memberof Empty
     * @static
     * @param {Empty.$Properties} message Empty message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Empty.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an Empty message from the specified reader or buffer.
     * @function decode
     * @memberof Empty
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Empty & Empty.$Shape} Empty
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Empty.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Empty();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            reader.skipType(tag & 7, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an Empty message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Empty
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Empty} Empty
     */
    Empty.fromObject = function (object, _depth) {
        if (object instanceof $root.Empty)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Empty: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        return new $root.Empty();
    };

    /**
     * Creates a plain object from an Empty message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Empty
     * @static
     * @param {Empty} message Empty
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Empty.toObject = function () {
        return {};
    };

    /**
     * Converts this Empty to JSON.
     * @function toJSON
     * @memberof Empty
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Empty.prototype.toJSON = function() {
        return Empty.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Empty
     * @function getTypeUrl
     * @memberof Empty
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Empty.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Empty";
    };

    return Empty;
})();

export const Exception = $root.Exception = (() => {

    /**
     * Properties of an Exception.
     * @typedef {Object} Exception.$Properties
     * @property {string|null} [type] Exception type
     * @property {string|null} [message] Exception message
     * @property {boolean|null} [messageIsMarkdown] Exception messageIsMarkdown
     * @property {Array.<string>|null} [stackTrace] Exception stackTrace
     * @property {boolean|null} [isWarning] Exception isWarning
     * @property {streamlit.WidthConfig.$Properties|null} [widthConfig] Exception widthConfig
     * @property {boolean|null} [isStreamlitException] Exception isStreamlitException
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an Exception.
     * @exports IException
     * @interface IException
     * @augments Exception.$Properties
     * @deprecated Use Exception.$Properties instead.
     */

    /**
     * Shape of an Exception.
     * @typedef {{
     *   type?: string|null;
     *   message?: string|null;
     *   messageIsMarkdown?: boolean|null;
     *   stackTrace?: Array.<string>|null;
     *   isWarning?: boolean|null;
     *   widthConfig?: streamlit.WidthConfig.$Shape|null;
     *   isStreamlitException?: boolean|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} Exception.$Shape
     */

    /**
     * Constructs a new Exception.
     * @exports Exception
     * @classdesc Represents an Exception.
     * @constructor
     * @param {Exception.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Exception = function (properties) {
        this.stackTrace = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Exception type.
     * @member {string} type
     * @memberof Exception
     * @instance
     */
    Exception.prototype.type = "";

    /**
     * Exception message.
     * @member {string} message
     * @memberof Exception
     * @instance
     */
    Exception.prototype.message = "";

    /**
     * Exception messageIsMarkdown.
     * @member {boolean} messageIsMarkdown
     * @memberof Exception
     * @instance
     */
    Exception.prototype.messageIsMarkdown = false;

    /**
     * Exception stackTrace.
     * @member {Array.<string>} stackTrace
     * @memberof Exception
     * @instance
     */
    Exception.prototype.stackTrace = $util.emptyArray;

    /**
     * Exception isWarning.
     * @member {boolean} isWarning
     * @memberof Exception
     * @instance
     */
    Exception.prototype.isWarning = false;

    /**
     * Exception widthConfig.
     * @member {streamlit.WidthConfig.$Properties|null|undefined} widthConfig
     * @memberof Exception
     * @instance
     */
    Exception.prototype.widthConfig = null;

    /**
     * Exception isStreamlitException.
     * @member {boolean} isStreamlitException
     * @memberof Exception
     * @instance
     */
    Exception.prototype.isStreamlitException = false;

    /**
     * Creates a new Exception instance using the specified properties.
     * @function create
     * @memberof Exception
     * @static
     * @param {Exception.$Properties=} [properties] Properties to set
     * @returns {Exception} Exception instance
     * @type {{
     *   (properties: Exception.$Shape): Exception & Exception.$Shape;
     *   (properties?: Exception.$Properties): Exception;
     * }}
     */
    Exception.create = function(properties) {
        return new Exception(properties);
    };

    /**
     * Encodes the specified Exception message. Does not implicitly {@link Exception.verify|verify} messages.
     * @function encode
     * @memberof Exception
     * @static
     * @param {Exception.$Properties} message Exception message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Exception.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
        if (message.message != null && $Object.hasOwnProperty.call(message, "message") && message.message !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
        if (message.stackTrace != null && message.stackTrace.length)
            for (let i = 0; i < message.stackTrace.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.stackTrace[i]);
        if (message.messageIsMarkdown != null && $Object.hasOwnProperty.call(message, "messageIsMarkdown") && message.messageIsMarkdown !== false)
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.messageIsMarkdown);
        if (message.isWarning != null && $Object.hasOwnProperty.call(message, "isWarning") && message.isWarning !== false)
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isWarning);
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            $root.streamlit.WidthConfig.encode(message.widthConfig, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
        if (message.isStreamlitException != null && $Object.hasOwnProperty.call(message, "isStreamlitException") && message.isStreamlitException !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isStreamlitException);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an Exception message from the specified reader or buffer.
     * @function decode
     * @memberof Exception
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Exception & Exception.$Shape} Exception
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Exception.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Exception();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.message = value;
                    else
                        delete message.message;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.messageIsMarkdown = value;
                    else
                        delete message.messageIsMarkdown;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if (!(message.stackTrace && message.stackTrace.length))
                        message.stackTrace = [];
                    message.stackTrace.push(reader.stringVerify());
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isWarning = value;
                    else
                        delete message.isWarning;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.widthConfig = $root.streamlit.WidthConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.widthConfig);
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isStreamlitException = value;
                    else
                        delete message.isStreamlitException;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an Exception message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Exception
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Exception} Exception
     */
    Exception.fromObject = function (object, _depth) {
        if (object instanceof $root.Exception)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Exception: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Exception();
        if (object.type != null)
            if (typeof object.type !== "string" || object.type.length)
                message.type = $String(object.type);
        if (object.message != null)
            if (typeof object.message !== "string" || object.message.length)
                message.message = $String(object.message);
        if (object.messageIsMarkdown != null)
            if (object.messageIsMarkdown)
                message.messageIsMarkdown = $Boolean(object.messageIsMarkdown);
        if (object.stackTrace) {
            if (!$Array.isArray(object.stackTrace))
                throw $TypeError(".Exception.stackTrace: array expected");
            message.stackTrace = $Array(object.stackTrace.length);
            for (let i = 0; i < object.stackTrace.length; ++i)
                message.stackTrace[i] = $String(object.stackTrace[i]);
        }
        if (object.isWarning != null)
            if (object.isWarning)
                message.isWarning = $Boolean(object.isWarning);
        if (object.widthConfig != null) {
            if (!$util.isObject(object.widthConfig))
                throw $TypeError(".Exception.widthConfig: object expected");
            message.widthConfig = $root.streamlit.WidthConfig.fromObject(object.widthConfig, _depth + 1);
        }
        if (object.isStreamlitException != null)
            if (object.isStreamlitException)
                message.isStreamlitException = $Boolean(object.isStreamlitException);
        return message;
    };

    /**
     * Creates a plain object from an Exception message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Exception
     * @static
     * @param {Exception} message Exception
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Exception.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.stackTrace = [];
        if (options.defaults) {
            object.type = "";
            object.message = "";
            object.messageIsMarkdown = false;
            object.isWarning = false;
            object.widthConfig = null;
            object.isStreamlitException = false;
        }
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = message.type;
        if (message.message != null && $Object.hasOwnProperty.call(message, "message"))
            object.message = message.message;
        if (message.stackTrace && message.stackTrace.length) {
            object.stackTrace = $Array(message.stackTrace.length);
            for (let j = 0; j < message.stackTrace.length; ++j)
                object.stackTrace[j] = message.stackTrace[j];
        }
        if (message.messageIsMarkdown != null && $Object.hasOwnProperty.call(message, "messageIsMarkdown"))
            object.messageIsMarkdown = message.messageIsMarkdown;
        if (message.isWarning != null && $Object.hasOwnProperty.call(message, "isWarning"))
            object.isWarning = message.isWarning;
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            object.widthConfig = $root.streamlit.WidthConfig.toObject(message.widthConfig, options, _depth + 1);
        if (message.isStreamlitException != null && $Object.hasOwnProperty.call(message, "isStreamlitException"))
            object.isStreamlitException = message.isStreamlitException;
        return object;
    };

    /**
     * Converts this Exception to JSON.
     * @function toJSON
     * @memberof Exception
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Exception.prototype.toJSON = function() {
        return Exception.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Exception
     * @function getTypeUrl
     * @memberof Exception
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Exception.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Exception";
    };

    return Exception;
})();

export const Favicon = $root.Favicon = (() => {

    /**
     * Properties of a Favicon.
     * @typedef {Object} Favicon.$Properties
     * @property {string|null} [url] Favicon url
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Favicon.
     * @exports IFavicon
     * @interface IFavicon
     * @augments Favicon.$Properties
     * @deprecated Use Favicon.$Properties instead.
     */

    /**
     * Shape of a Favicon.
     * @typedef {Favicon.$Properties} Favicon.$Shape
     */

    /**
     * Constructs a new Favicon.
     * @exports Favicon
     * @classdesc Represents a Favicon.
     * @constructor
     * @param {Favicon.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Favicon = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Favicon url.
     * @member {string} url
     * @memberof Favicon
     * @instance
     */
    Favicon.prototype.url = "";

    /**
     * Creates a new Favicon instance using the specified properties.
     * @function create
     * @memberof Favicon
     * @static
     * @param {Favicon.$Properties=} [properties] Properties to set
     * @returns {Favicon} Favicon instance
     * @type {{
     *   (properties: Favicon.$Shape): Favicon & Favicon.$Shape;
     *   (properties?: Favicon.$Properties): Favicon;
     * }}
     */
    Favicon.create = function(properties) {
        return new Favicon(properties);
    };

    /**
     * Encodes the specified Favicon message. Does not implicitly {@link Favicon.verify|verify} messages.
     * @function encode
     * @memberof Favicon
     * @static
     * @param {Favicon.$Properties} message Favicon message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Favicon.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Favicon message from the specified reader or buffer.
     * @function decode
     * @memberof Favicon
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Favicon & Favicon.$Shape} Favicon
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Favicon.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Favicon();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Favicon message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Favicon
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Favicon} Favicon
     */
    Favicon.fromObject = function (object, _depth) {
        if (object instanceof $root.Favicon)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Favicon: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Favicon();
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        return message;
    };

    /**
     * Creates a plain object from a Favicon message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Favicon
     * @static
     * @param {Favicon} message Favicon
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Favicon.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.url = "";
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        return object;
    };

    /**
     * Converts this Favicon to JSON.
     * @function toJSON
     * @memberof Favicon
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Favicon.prototype.toJSON = function() {
        return Favicon.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Favicon
     * @function getTypeUrl
     * @memberof Favicon
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Favicon.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Favicon";
    };

    return Favicon;
})();

export const Feedback = $root.Feedback = (() => {

    /**
     * Properties of a Feedback.
     * @typedef {Object} Feedback.$Properties
     * @property {string|null} [id] Feedback id
     * @property {Feedback.FeedbackType|null} [type] Feedback type
     * @property {number|null} ["default"] Feedback default
     * @property {boolean|null} [disabled] Feedback disabled
     * @property {string|null} [formId] Feedback formId
     * @property {number|null} [value] Feedback value
     * @property {boolean|null} [setValue] Feedback setValue
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Feedback.
     * @exports IFeedback
     * @interface IFeedback
     * @augments Feedback.$Properties
     * @deprecated Use Feedback.$Properties instead.
     */

    /**
     * Shape of a Feedback.
     * @typedef {Feedback.$Properties} Feedback.$Shape
     */

    /**
     * Constructs a new Feedback.
     * @exports Feedback
     * @classdesc Represents a Feedback.
     * @constructor
     * @param {Feedback.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Feedback = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Feedback id.
     * @member {string} id
     * @memberof Feedback
     * @instance
     */
    Feedback.prototype.id = "";

    /**
     * Feedback type.
     * @member {Feedback.FeedbackType} type
     * @memberof Feedback
     * @instance
     */
    Feedback.prototype.type = 0;

    /**
     * Feedback default.
     * @member {number|null|undefined} default
     * @memberof Feedback
     * @instance
     */
    Feedback.prototype["default"] = null;

    /**
     * Feedback disabled.
     * @member {boolean} disabled
     * @memberof Feedback
     * @instance
     */
    Feedback.prototype.disabled = false;

    /**
     * Feedback formId.
     * @member {string} formId
     * @memberof Feedback
     * @instance
     */
    Feedback.prototype.formId = "";

    /**
     * Feedback value.
     * @member {number|null|undefined} value
     * @memberof Feedback
     * @instance
     */
    Feedback.prototype.value = null;

    /**
     * Feedback setValue.
     * @member {boolean} setValue
     * @memberof Feedback
     * @instance
     */
    Feedback.prototype.setValue = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Feedback.prototype, "_default", {
        get: $util.oneOfGetter($oneOfFields = ["default"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Feedback.prototype, "_value", {
        get: $util.oneOfGetter($oneOfFields = ["value"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Feedback instance using the specified properties.
     * @function create
     * @memberof Feedback
     * @static
     * @param {Feedback.$Properties=} [properties] Properties to set
     * @returns {Feedback} Feedback instance
     * @type {{
     *   (properties: Feedback.$Shape): Feedback & Feedback.$Shape;
     *   (properties?: Feedback.$Properties): Feedback;
     * }}
     */
    Feedback.create = function(properties) {
        return new Feedback(properties);
    };

    /**
     * Encodes the specified Feedback message. Does not implicitly {@link Feedback.verify|verify} messages.
     * @function encode
     * @memberof Feedback
     * @static
     * @param {Feedback.$Properties} message Feedback message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Feedback.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== 0)
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message["default"]);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.disabled);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.formId);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.value);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.setValue);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Feedback message from the specified reader or buffer.
     * @function decode
     * @memberof Feedback
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Feedback & Feedback.$Shape} Feedback
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Feedback.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Feedback();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    message["default"] = reader.uint32();
                    message._default = "default";
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    message.value = reader.uint32();
                    message._value = "value";
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Feedback message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Feedback
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Feedback} Feedback
     */
    Feedback.fromObject = function (object, _depth) {
        if (object instanceof $root.Feedback)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Feedback: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Feedback();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.type !== 0 && (typeof object.type !== "string" || $root.Feedback.FeedbackType[object.type] !== 0))
            switch (object.type) {
            case "THUMBS":
            case 0:
                message.type = 0;
                break;
            case "FACES":
            case 1:
                message.type = 1;
                break;
            case "STARS":
            case 2:
                message.type = 2;
                break;
            default:
                if (typeof object.type === "number" && (object.type | 0) === object.type)
                    message.type = object.type;
            }
        if (object["default"] != null)
            message["default"] = object["default"] >>> 0;
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.value != null)
            message.value = object.value >>> 0;
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        return message;
    };

    /**
     * Creates a plain object from a Feedback message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Feedback
     * @static
     * @param {Feedback} message Feedback
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Feedback.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.type = options.enums === $String ? "THUMBS" : 0;
            object.disabled = false;
            object.formId = "";
            object.setValue = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = options.enums === $String ? $root.Feedback.FeedbackType[message.type] === $undefined ? message.type : $root.Feedback.FeedbackType[message.type] : message.type;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = message.value;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        return object;
    };

    /**
     * Converts this Feedback to JSON.
     * @function toJSON
     * @memberof Feedback
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Feedback.prototype.toJSON = function() {
        return Feedback.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Feedback
     * @function getTypeUrl
     * @memberof Feedback
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Feedback.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Feedback";
    };

    /**
     * FeedbackType enum.
     * @name Feedback.FeedbackType
     * @enum {number}
     * @property {number} THUMBS=0 THUMBS value
     * @property {number} FACES=1 FACES value
     * @property {number} STARS=2 STARS value
     */
    Feedback.FeedbackType = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "THUMBS"] = 0;
        values[valuesById[1] = "FACES"] = 1;
        values[valuesById[2] = "STARS"] = 2;
        return values;
    })();

    return Feedback;
})();

export const FileUploader = $root.FileUploader = (() => {

    /**
     * Properties of a FileUploader.
     * @typedef {Object} FileUploader.$Properties
     * @property {string|null} [id] FileUploader id
     * @property {string|null} [label] FileUploader label
     * @property {Array.<string>|null} [type] FileUploader type
     * @property {number|null} [maxUploadSizeMb] FileUploader maxUploadSizeMb
     * @property {boolean|null} [multipleFiles] FileUploader multipleFiles
     * @property {string|null} [help] FileUploader help
     * @property {string|null} [formId] FileUploader formId
     * @property {boolean|null} [disabled] FileUploader disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] FileUploader labelVisibility
     * @property {boolean|null} [acceptDirectory] FileUploader acceptDirectory
     * @property {boolean|null} [ignoreRerun] FileUploader ignoreRerun
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a FileUploader.
     * @exports IFileUploader
     * @interface IFileUploader
     * @augments FileUploader.$Properties
     * @deprecated Use FileUploader.$Properties instead.
     */

    /**
     * Shape of a FileUploader.
     * @typedef {FileUploader.$Properties} FileUploader.$Shape
     */

    /**
     * Constructs a new FileUploader.
     * @exports FileUploader
     * @classdesc Represents a FileUploader.
     * @constructor
     * @param {FileUploader.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const FileUploader = function (properties) {
        this.type = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * FileUploader id.
     * @member {string} id
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.id = "";

    /**
     * FileUploader label.
     * @member {string} label
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.label = "";

    /**
     * FileUploader type.
     * @member {Array.<string>} type
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.type = $util.emptyArray;

    /**
     * FileUploader maxUploadSizeMb.
     * @member {number} maxUploadSizeMb
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.maxUploadSizeMb = 0;

    /**
     * FileUploader multipleFiles.
     * @member {boolean} multipleFiles
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.multipleFiles = false;

    /**
     * FileUploader help.
     * @member {string} help
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.help = "";

    /**
     * FileUploader formId.
     * @member {string} formId
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.formId = "";

    /**
     * FileUploader disabled.
     * @member {boolean} disabled
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.disabled = false;

    /**
     * FileUploader labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.labelVisibility = null;

    /**
     * FileUploader acceptDirectory.
     * @member {boolean} acceptDirectory
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.acceptDirectory = false;

    /**
     * FileUploader ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof FileUploader
     * @instance
     */
    FileUploader.prototype.ignoreRerun = false;

    /**
     * Creates a new FileUploader instance using the specified properties.
     * @function create
     * @memberof FileUploader
     * @static
     * @param {FileUploader.$Properties=} [properties] Properties to set
     * @returns {FileUploader} FileUploader instance
     * @type {{
     *   (properties: FileUploader.$Shape): FileUploader & FileUploader.$Shape;
     *   (properties?: FileUploader.$Properties): FileUploader;
     * }}
     */
    FileUploader.create = function(properties) {
        return new FileUploader(properties);
    };

    /**
     * Encodes the specified FileUploader message. Does not implicitly {@link FileUploader.verify|verify} messages.
     * @function encode
     * @memberof FileUploader
     * @static
     * @param {FileUploader.$Properties} message FileUploader message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FileUploader.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message.type != null && message.type.length)
            for (let i = 0; i < message.type.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.type[i]);
        if (message.maxUploadSizeMb != null && $Object.hasOwnProperty.call(message, "maxUploadSizeMb") && message.maxUploadSizeMb !== 0)
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.maxUploadSizeMb);
        if (message.multipleFiles != null && $Object.hasOwnProperty.call(message, "multipleFiles") && message.multipleFiles !== false)
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.multipleFiles);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.formId);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 10, wireType 2 =*/82).fork(), _depth + 1).ldelim();
        if (message.acceptDirectory != null && $Object.hasOwnProperty.call(message, "acceptDirectory") && message.acceptDirectory !== false)
            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.acceptDirectory);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.ignoreRerun);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a FileUploader message from the specified reader or buffer.
     * @function decode
     * @memberof FileUploader
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FileUploader & FileUploader.$Shape} FileUploader
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FileUploader.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.FileUploader();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if (!(message.type && message.type.length))
                        message.type = [];
                    message.type.push(reader.stringVerify());
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.maxUploadSizeMb = value;
                    else
                        delete message.maxUploadSizeMb;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.multipleFiles = value;
                    else
                        delete message.multipleFiles;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 11: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.acceptDirectory = value;
                    else
                        delete message.acceptDirectory;
                    continue;
                }
            case 12: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a FileUploader message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FileUploader
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FileUploader} FileUploader
     */
    FileUploader.fromObject = function (object, _depth) {
        if (object instanceof $root.FileUploader)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".FileUploader: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.FileUploader();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.type) {
            if (!$Array.isArray(object.type))
                throw $TypeError(".FileUploader.type: array expected");
            message.type = $Array(object.type.length);
            for (let i = 0; i < object.type.length; ++i)
                message.type[i] = $String(object.type[i]);
        }
        if (object.maxUploadSizeMb != null)
            if ($Number(object.maxUploadSizeMb) !== 0)
                message.maxUploadSizeMb = object.maxUploadSizeMb | 0;
        if (object.multipleFiles != null)
            if (object.multipleFiles)
                message.multipleFiles = $Boolean(object.multipleFiles);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".FileUploader.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.acceptDirectory != null)
            if (object.acceptDirectory)
                message.acceptDirectory = $Boolean(object.acceptDirectory);
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        return message;
    };

    /**
     * Creates a plain object from a FileUploader message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FileUploader
     * @static
     * @param {FileUploader} message FileUploader
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FileUploader.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.type = [];
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.maxUploadSizeMb = 0;
            object.multipleFiles = false;
            object.help = "";
            object.formId = "";
            object.disabled = false;
            object.labelVisibility = null;
            object.acceptDirectory = false;
            object.ignoreRerun = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.type && message.type.length) {
            object.type = $Array(message.type.length);
            for (let j = 0; j < message.type.length; ++j)
                object.type[j] = message.type[j];
        }
        if (message.maxUploadSizeMb != null && $Object.hasOwnProperty.call(message, "maxUploadSizeMb"))
            object.maxUploadSizeMb = message.maxUploadSizeMb;
        if (message.multipleFiles != null && $Object.hasOwnProperty.call(message, "multipleFiles"))
            object.multipleFiles = message.multipleFiles;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.acceptDirectory != null && $Object.hasOwnProperty.call(message, "acceptDirectory"))
            object.acceptDirectory = message.acceptDirectory;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        return object;
    };

    /**
     * Converts this FileUploader to JSON.
     * @function toJSON
     * @memberof FileUploader
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FileUploader.prototype.toJSON = function() {
        return FileUploader.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for FileUploader
     * @function getTypeUrl
     * @memberof FileUploader
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    FileUploader.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/FileUploader";
    };

    return FileUploader;
})();

export const GraphVizChart = $root.GraphVizChart = (() => {

    /**
     * Properties of a GraphVizChart.
     * @typedef {Object} GraphVizChart.$Properties
     * @property {string|null} [spec] GraphVizChart spec
     * @property {string|null} [elementId] GraphVizChart elementId
     * @property {string|null} [engine] GraphVizChart engine
     * @property {string|null} [alt] GraphVizChart alt
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a GraphVizChart.
     * @exports IGraphVizChart
     * @interface IGraphVizChart
     * @augments GraphVizChart.$Properties
     * @deprecated Use GraphVizChart.$Properties instead.
     */

    /**
     * Shape of a GraphVizChart.
     * @typedef {GraphVizChart.$Properties} GraphVizChart.$Shape
     */

    /**
     * Constructs a new GraphVizChart.
     * @exports GraphVizChart
     * @classdesc Represents a GraphVizChart.
     * @constructor
     * @param {GraphVizChart.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const GraphVizChart = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * GraphVizChart spec.
     * @member {string} spec
     * @memberof GraphVizChart
     * @instance
     */
    GraphVizChart.prototype.spec = "";

    /**
     * GraphVizChart elementId.
     * @member {string} elementId
     * @memberof GraphVizChart
     * @instance
     */
    GraphVizChart.prototype.elementId = "";

    /**
     * GraphVizChart engine.
     * @member {string} engine
     * @memberof GraphVizChart
     * @instance
     */
    GraphVizChart.prototype.engine = "";

    /**
     * GraphVizChart alt.
     * @member {string|null|undefined} alt
     * @memberof GraphVizChart
     * @instance
     */
    GraphVizChart.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(GraphVizChart.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new GraphVizChart instance using the specified properties.
     * @function create
     * @memberof GraphVizChart
     * @static
     * @param {GraphVizChart.$Properties=} [properties] Properties to set
     * @returns {GraphVizChart} GraphVizChart instance
     * @type {{
     *   (properties: GraphVizChart.$Shape): GraphVizChart & GraphVizChart.$Shape;
     *   (properties?: GraphVizChart.$Properties): GraphVizChart;
     * }}
     */
    GraphVizChart.create = function(properties) {
        return new GraphVizChart(properties);
    };

    /**
     * Encodes the specified GraphVizChart message. Does not implicitly {@link GraphVizChart.verify|verify} messages.
     * @function encode
     * @memberof GraphVizChart
     * @static
     * @param {GraphVizChart.$Properties} message GraphVizChart message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GraphVizChart.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.spec != null && $Object.hasOwnProperty.call(message, "spec") && message.spec !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.spec);
        if (message.elementId != null && $Object.hasOwnProperty.call(message, "elementId") && message.elementId !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.elementId);
        if (message.engine != null && $Object.hasOwnProperty.call(message, "engine") && message.engine !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.engine);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a GraphVizChart message from the specified reader or buffer.
     * @function decode
     * @memberof GraphVizChart
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GraphVizChart & GraphVizChart.$Shape} GraphVizChart
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GraphVizChart.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.GraphVizChart();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.spec = value;
                    else
                        delete message.spec;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.elementId = value;
                    else
                        delete message.elementId;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.engine = value;
                    else
                        delete message.engine;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a GraphVizChart message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GraphVizChart
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GraphVizChart} GraphVizChart
     */
    GraphVizChart.fromObject = function (object, _depth) {
        if (object instanceof $root.GraphVizChart)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".GraphVizChart: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.GraphVizChart();
        if (object.spec != null)
            if (typeof object.spec !== "string" || object.spec.length)
                message.spec = $String(object.spec);
        if (object.elementId != null)
            if (typeof object.elementId !== "string" || object.elementId.length)
                message.elementId = $String(object.elementId);
        if (object.engine != null)
            if (typeof object.engine !== "string" || object.engine.length)
                message.engine = $String(object.engine);
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from a GraphVizChart message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GraphVizChart
     * @static
     * @param {GraphVizChart} message GraphVizChart
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GraphVizChart.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.spec = "";
            object.elementId = "";
            object.engine = "";
        }
        if (message.spec != null && $Object.hasOwnProperty.call(message, "spec"))
            object.spec = message.spec;
        if (message.elementId != null && $Object.hasOwnProperty.call(message, "elementId"))
            object.elementId = message.elementId;
        if (message.engine != null && $Object.hasOwnProperty.call(message, "engine"))
            object.engine = message.engine;
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this GraphVizChart to JSON.
     * @function toJSON
     * @memberof GraphVizChart
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GraphVizChart.prototype.toJSON = function() {
        return GraphVizChart.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for GraphVizChart
     * @function getTypeUrl
     * @memberof GraphVizChart
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    GraphVizChart.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/GraphVizChart";
    };

    return GraphVizChart;
})();

export const Heading = $root.Heading = (() => {

    /**
     * Properties of a Heading.
     * @typedef {Object} Heading.$Properties
     * @property {string|null} [tag] Heading tag
     * @property {string|null} [anchor] Heading anchor
     * @property {string|null} [body] Heading body
     * @property {string|null} [help] Heading help
     * @property {boolean|null} [hideAnchor] Heading hideAnchor
     * @property {string|null} [divider] Heading divider
     * @property {boolean|null} [wrap] Heading wrap
     * @property {string|null} [icon] Heading icon
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Heading.
     * @exports IHeading
     * @interface IHeading
     * @augments Heading.$Properties
     * @deprecated Use Heading.$Properties instead.
     */

    /**
     * Shape of a Heading.
     * @typedef {Heading.$Properties} Heading.$Shape
     */

    /**
     * Constructs a new Heading.
     * @exports Heading
     * @classdesc Represents a Heading.
     * @constructor
     * @param {Heading.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Heading = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Heading tag.
     * @member {string} tag
     * @memberof Heading
     * @instance
     */
    Heading.prototype.tag = "";

    /**
     * Heading anchor.
     * @member {string} anchor
     * @memberof Heading
     * @instance
     */
    Heading.prototype.anchor = "";

    /**
     * Heading body.
     * @member {string} body
     * @memberof Heading
     * @instance
     */
    Heading.prototype.body = "";

    /**
     * Heading help.
     * @member {string} help
     * @memberof Heading
     * @instance
     */
    Heading.prototype.help = "";

    /**
     * Heading hideAnchor.
     * @member {boolean} hideAnchor
     * @memberof Heading
     * @instance
     */
    Heading.prototype.hideAnchor = false;

    /**
     * Heading divider.
     * @member {string} divider
     * @memberof Heading
     * @instance
     */
    Heading.prototype.divider = "";

    /**
     * Heading wrap.
     * @member {boolean|null|undefined} wrap
     * @memberof Heading
     * @instance
     */
    Heading.prototype.wrap = null;

    /**
     * Heading icon.
     * @member {string} icon
     * @memberof Heading
     * @instance
     */
    Heading.prototype.icon = "";

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Heading.prototype, "_wrap", {
        get: $util.oneOfGetter($oneOfFields = ["wrap"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Heading instance using the specified properties.
     * @function create
     * @memberof Heading
     * @static
     * @param {Heading.$Properties=} [properties] Properties to set
     * @returns {Heading} Heading instance
     * @type {{
     *   (properties: Heading.$Shape): Heading & Heading.$Shape;
     *   (properties?: Heading.$Properties): Heading;
     * }}
     */
    Heading.create = function(properties) {
        return new Heading(properties);
    };

    /**
     * Encodes the specified Heading message. Does not implicitly {@link Heading.verify|verify} messages.
     * @function encode
     * @memberof Heading
     * @static
     * @param {Heading.$Properties} message Heading message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Heading.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.tag != null && $Object.hasOwnProperty.call(message, "tag") && message.tag !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.tag);
        if (message.anchor != null && $Object.hasOwnProperty.call(message, "anchor") && message.anchor !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.anchor);
        if (message.body != null && $Object.hasOwnProperty.call(message, "body") && message.body !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.body);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.help);
        if (message.hideAnchor != null && $Object.hasOwnProperty.call(message, "hideAnchor") && message.hideAnchor !== false)
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.hideAnchor);
        if (message.divider != null && $Object.hasOwnProperty.call(message, "divider") && message.divider !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.divider);
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.wrap);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.icon);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Heading message from the specified reader or buffer.
     * @function decode
     * @memberof Heading
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Heading & Heading.$Shape} Heading
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Heading.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Heading();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.tag = value;
                    else
                        delete message.tag;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.anchor = value;
                    else
                        delete message.anchor;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.body = value;
                    else
                        delete message.body;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hideAnchor = value;
                    else
                        delete message.hideAnchor;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.divider = value;
                    else
                        delete message.divider;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    message.wrap = reader.bool();
                    message._wrap = "wrap";
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Heading message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Heading
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Heading} Heading
     */
    Heading.fromObject = function (object, _depth) {
        if (object instanceof $root.Heading)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Heading: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Heading();
        if (object.tag != null)
            if (typeof object.tag !== "string" || object.tag.length)
                message.tag = $String(object.tag);
        if (object.anchor != null)
            if (typeof object.anchor !== "string" || object.anchor.length)
                message.anchor = $String(object.anchor);
        if (object.body != null)
            if (typeof object.body !== "string" || object.body.length)
                message.body = $String(object.body);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.hideAnchor != null)
            if (object.hideAnchor)
                message.hideAnchor = $Boolean(object.hideAnchor);
        if (object.divider != null)
            if (typeof object.divider !== "string" || object.divider.length)
                message.divider = $String(object.divider);
        if (object.wrap != null)
            message.wrap = $Boolean(object.wrap);
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        return message;
    };

    /**
     * Creates a plain object from a Heading message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Heading
     * @static
     * @param {Heading} message Heading
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Heading.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.tag = "";
            object.anchor = "";
            object.body = "";
            object.help = "";
            object.hideAnchor = false;
            object.divider = "";
            object.icon = "";
        }
        if (message.tag != null && $Object.hasOwnProperty.call(message, "tag"))
            object.tag = message.tag;
        if (message.anchor != null && $Object.hasOwnProperty.call(message, "anchor"))
            object.anchor = message.anchor;
        if (message.body != null && $Object.hasOwnProperty.call(message, "body"))
            object.body = message.body;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.hideAnchor != null && $Object.hasOwnProperty.call(message, "hideAnchor"))
            object.hideAnchor = message.hideAnchor;
        if (message.divider != null && $Object.hasOwnProperty.call(message, "divider"))
            object.divider = message.divider;
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            object.wrap = message.wrap;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        return object;
    };

    /**
     * Converts this Heading to JSON.
     * @function toJSON
     * @memberof Heading
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Heading.prototype.toJSON = function() {
        return Heading.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Heading
     * @function getTypeUrl
     * @memberof Heading
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Heading.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Heading";
    };

    return Heading;
})();

export const Help = $root.Help = (() => {

    /**
     * Properties of a Help.
     * @typedef {Object} Help.$Properties
     * @property {string|null} [docString] Help docString
     * @property {string|null} [type] Help type
     * @property {string|null} [name] Help name
     * @property {string|null} [value] Help value
     * @property {Array.<Member.$Properties>|null} [members] Help members
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Help.
     * @exports IHelp
     * @interface IHelp
     * @augments Help.$Properties
     * @deprecated Use Help.$Properties instead.
     */

    /**
     * Shape of a Help.
     * @typedef {{
     *   docString?: string|null;
     *   type?: string|null;
     *   name?: string|null;
     *   value?: string|null;
     *   members?: Array.<Member.$Shape>|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} Help.$Shape
     */

    /**
     * Constructs a new Help.
     * @exports Help
     * @classdesc Represents a Help.
     * @constructor
     * @param {Help.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Help = function (properties) {
        this.members = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Help docString.
     * @member {string} docString
     * @memberof Help
     * @instance
     */
    Help.prototype.docString = "";

    /**
     * Help type.
     * @member {string} type
     * @memberof Help
     * @instance
     */
    Help.prototype.type = "";

    /**
     * Help name.
     * @member {string} name
     * @memberof Help
     * @instance
     */
    Help.prototype.name = "";

    /**
     * Help value.
     * @member {string} value
     * @memberof Help
     * @instance
     */
    Help.prototype.value = "";

    /**
     * Help members.
     * @member {Array.<Member.$Properties>} members
     * @memberof Help
     * @instance
     */
    Help.prototype.members = $util.emptyArray;

    /**
     * Creates a new Help instance using the specified properties.
     * @function create
     * @memberof Help
     * @static
     * @param {Help.$Properties=} [properties] Properties to set
     * @returns {Help} Help instance
     * @type {{
     *   (properties: Help.$Shape): Help & Help.$Shape;
     *   (properties?: Help.$Properties): Help;
     * }}
     */
    Help.create = function(properties) {
        return new Help(properties);
    };

    /**
     * Encodes the specified Help message. Does not implicitly {@link Help.verify|verify} messages.
     * @function encode
     * @memberof Help
     * @static
     * @param {Help.$Properties} message Help message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Help.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.docString != null && $Object.hasOwnProperty.call(message, "docString") && message.docString !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.docString);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.type);
        if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.name);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value") && message.value !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.value);
        if (message.members != null && message.members.length)
            for (let i = 0; i < message.members.length; ++i)
                $root.Member.encode(message.members[i], writer.uint32(/* id 8, wireType 2 =*/66).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Help message from the specified reader or buffer.
     * @function decode
     * @memberof Help
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Help & Help.$Shape} Help
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Help.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Help();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.docString = value;
                    else
                        delete message.docString;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.name = value;
                    else
                        delete message.name;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.value = value;
                    else
                        delete message.value;
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    if (!(message.members && message.members.length))
                        message.members = [];
                    message.members.push($root.Member.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Help message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Help
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Help} Help
     */
    Help.fromObject = function (object, _depth) {
        if (object instanceof $root.Help)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Help: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Help();
        if (object.docString != null)
            if (typeof object.docString !== "string" || object.docString.length)
                message.docString = $String(object.docString);
        if (object.type != null)
            if (typeof object.type !== "string" || object.type.length)
                message.type = $String(object.type);
        if (object.name != null)
            if (typeof object.name !== "string" || object.name.length)
                message.name = $String(object.name);
        if (object.value != null)
            if (typeof object.value !== "string" || object.value.length)
                message.value = $String(object.value);
        if (object.members) {
            if (!$Array.isArray(object.members))
                throw $TypeError(".Help.members: array expected");
            message.members = $Array(object.members.length);
            for (let i = 0; i < object.members.length; ++i) {
                if (!$util.isObject(object.members[i]))
                    throw $TypeError(".Help.members: object expected");
                message.members[i] = $root.Member.fromObject(object.members[i], _depth + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Help message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Help
     * @static
     * @param {Help} message Help
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Help.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.members = [];
        if (options.defaults) {
            object.docString = "";
            object.type = "";
            object.name = "";
            object.value = "";
        }
        if (message.docString != null && $Object.hasOwnProperty.call(message, "docString"))
            object.docString = message.docString;
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = message.type;
        if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
            object.name = message.name;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = message.value;
        if (message.members && message.members.length) {
            object.members = $Array(message.members.length);
            for (let j = 0; j < message.members.length; ++j)
                object.members[j] = $root.Member.toObject(message.members[j], options, _depth + 1);
        }
        return object;
    };

    /**
     * Converts this Help to JSON.
     * @function toJSON
     * @memberof Help
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Help.prototype.toJSON = function() {
        return Help.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Help
     * @function getTypeUrl
     * @memberof Help
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Help.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Help";
    };

    return Help;
})();

export const Member = $root.Member = (() => {

    /**
     * Properties of a Member.
     * @typedef {Object} Member.$Properties
     * @property {string|null} [name] Member name
     * @property {string|null} [type] Member type
     * @property {string|null} [value] Member value
     * @property {string|null} [docString] Member docString
     * @property {"value"|"docString"} [contents] Member contents
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Member.
     * @exports IMember
     * @interface IMember
     * @augments Member.$Properties
     * @deprecated Use Member.$Properties instead.
     */

    /**
     * Narrowed shape of a Member.
     * @typedef {{
     *   name?: string|null;
     *   type?: string|null;
     *   value?: string|null;
     *   docString?: string|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ contents?: undefined; value?: null; docString?: null }|{ contents?: "value"; value: string; docString?: null }|{ contents?: "docString"; value?: null; docString: string })
     * )} Member.$Shape
     */

    /**
     * Constructs a new Member.
     * @exports Member
     * @classdesc Represents a Member.
     * @constructor
     * @param {Member.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Member = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Member name.
     * @member {string} name
     * @memberof Member
     * @instance
     */
    Member.prototype.name = "";

    /**
     * Member type.
     * @member {string} type
     * @memberof Member
     * @instance
     */
    Member.prototype.type = "";

    /**
     * Member value.
     * @member {string|null|undefined} value
     * @memberof Member
     * @instance
     */
    Member.prototype.value = null;

    /**
     * Member docString.
     * @member {string|null|undefined} docString
     * @memberof Member
     * @instance
     */
    Member.prototype.docString = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Member contents.
     * @member {"value"|"docString"|undefined} contents
     * @memberof Member
     * @instance
     */
    $Object.defineProperty(Member.prototype, "contents", {
        get: $util.oneOfGetter($oneOfFields = ["value", "docString"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Member instance using the specified properties.
     * @function create
     * @memberof Member
     * @static
     * @param {Member.$Properties=} [properties] Properties to set
     * @returns {Member} Member instance
     * @type {{
     *   (properties: Member.$Shape): Member & Member.$Shape;
     *   (properties?: Member.$Properties): Member;
     * }}
     */
    Member.create = function(properties) {
        return new Member(properties);
    };

    /**
     * Encodes the specified Member message. Does not implicitly {@link Member.verify|verify} messages.
     * @function encode
     * @memberof Member
     * @static
     * @param {Member.$Properties} message Member message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Member.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.value);
        if (message.docString != null && $Object.hasOwnProperty.call(message, "docString"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.docString);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Member message from the specified reader or buffer.
     * @function decode
     * @memberof Member
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Member & Member.$Shape} Member
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Member.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Member();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.name = value;
                    else
                        delete message.name;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.value = reader.stringVerify();
                    message.contents = "value";
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.docString = reader.stringVerify();
                    message.contents = "docString";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Member message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Member
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Member} Member
     */
    Member.fromObject = function (object, _depth) {
        if (object instanceof $root.Member)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Member: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Member();
        if (object.name != null)
            if (typeof object.name !== "string" || object.name.length)
                message.name = $String(object.name);
        if (object.type != null)
            if (typeof object.type !== "string" || object.type.length)
                message.type = $String(object.type);
        if (object.value != null)
            message.value = $String(object.value);
        if (object.docString != null)
            message.docString = $String(object.docString);
        return message;
    };

    /**
     * Creates a plain object from a Member message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Member
     * @static
     * @param {Member} message Member
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Member.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.name = "";
            object.type = "";
        }
        if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
            object.name = message.name;
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = message.type;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value")) {
            object.value = message.value;
            if (options.oneofs)
                object.contents = "value";
        }
        if (message.docString != null && $Object.hasOwnProperty.call(message, "docString")) {
            object.docString = message.docString;
            if (options.oneofs)
                object.contents = "docString";
        }
        return object;
    };

    /**
     * Converts this Member to JSON.
     * @function toJSON
     * @memberof Member
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Member.prototype.toJSON = function() {
        return Member.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Member
     * @function getTypeUrl
     * @memberof Member
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Member.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Member";
    };

    return Member;
})();

export const Html = $root.Html = (() => {

    /**
     * Properties of a Html.
     * @typedef {Object} Html.$Properties
     * @property {string|null} [body] Html body
     * @property {boolean|null} [unsafeAllowJavascript] Html unsafeAllowJavascript
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Html.
     * @exports IHtml
     * @interface IHtml
     * @augments Html.$Properties
     * @deprecated Use Html.$Properties instead.
     */

    /**
     * Shape of a Html.
     * @typedef {Html.$Properties} Html.$Shape
     */

    /**
     * Constructs a new Html.
     * @exports Html
     * @classdesc Represents a Html.
     * @constructor
     * @param {Html.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Html = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Html body.
     * @member {string} body
     * @memberof Html
     * @instance
     */
    Html.prototype.body = "";

    /**
     * Html unsafeAllowJavascript.
     * @member {boolean} unsafeAllowJavascript
     * @memberof Html
     * @instance
     */
    Html.prototype.unsafeAllowJavascript = false;

    /**
     * Creates a new Html instance using the specified properties.
     * @function create
     * @memberof Html
     * @static
     * @param {Html.$Properties=} [properties] Properties to set
     * @returns {Html} Html instance
     * @type {{
     *   (properties: Html.$Shape): Html & Html.$Shape;
     *   (properties?: Html.$Properties): Html;
     * }}
     */
    Html.create = function(properties) {
        return new Html(properties);
    };

    /**
     * Encodes the specified Html message. Does not implicitly {@link Html.verify|verify} messages.
     * @function encode
     * @memberof Html
     * @static
     * @param {Html.$Properties} message Html message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Html.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.body != null && $Object.hasOwnProperty.call(message, "body") && message.body !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.body);
        if (message.unsafeAllowJavascript != null && $Object.hasOwnProperty.call(message, "unsafeAllowJavascript") && message.unsafeAllowJavascript !== false)
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.unsafeAllowJavascript);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Html message from the specified reader or buffer.
     * @function decode
     * @memberof Html
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Html & Html.$Shape} Html
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Html.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Html();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.body = value;
                    else
                        delete message.body;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.unsafeAllowJavascript = value;
                    else
                        delete message.unsafeAllowJavascript;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Html message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Html
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Html} Html
     */
    Html.fromObject = function (object, _depth) {
        if (object instanceof $root.Html)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Html: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Html();
        if (object.body != null)
            if (typeof object.body !== "string" || object.body.length)
                message.body = $String(object.body);
        if (object.unsafeAllowJavascript != null)
            if (object.unsafeAllowJavascript)
                message.unsafeAllowJavascript = $Boolean(object.unsafeAllowJavascript);
        return message;
    };

    /**
     * Creates a plain object from a Html message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Html
     * @static
     * @param {Html} message Html
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Html.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.body = "";
            object.unsafeAllowJavascript = false;
        }
        if (message.body != null && $Object.hasOwnProperty.call(message, "body"))
            object.body = message.body;
        if (message.unsafeAllowJavascript != null && $Object.hasOwnProperty.call(message, "unsafeAllowJavascript"))
            object.unsafeAllowJavascript = message.unsafeAllowJavascript;
        return object;
    };

    /**
     * Converts this Html to JSON.
     * @function toJSON
     * @memberof Html
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Html.prototype.toJSON = function() {
        return Html.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Html
     * @function getTypeUrl
     * @memberof Html
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Html.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Html";
    };

    return Html;
})();

export const IFrame = $root.IFrame = (() => {

    /**
     * Properties of a IFrame.
     * @typedef {Object} IFrame.$Properties
     * @property {string|null} [src] IFrame src
     * @property {string|null} [srcdoc] IFrame srcdoc
     * @property {boolean|null} [scrolling] IFrame scrolling
     * @property {number|null} [tabIndex] IFrame tabIndex
     * @property {string|null} [alt] IFrame alt
     * @property {"src"|"srcdoc"} [type] IFrame type
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a IFrame.
     * @exports IIFrame
     * @interface IIFrame
     * @augments IFrame.$Properties
     * @deprecated Use IFrame.$Properties instead.
     */

    /**
     * Narrowed shape of a IFrame.
     * @typedef {{
     *   src?: string|null;
     *   srcdoc?: string|null;
     *   scrolling?: boolean|null;
     *   tabIndex?: number|null;
     *   alt?: string|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ type?: undefined; src?: null; srcdoc?: null }|{ type?: "src"; src: string; srcdoc?: null }|{ type?: "srcdoc"; src?: null; srcdoc: string })
     * )} IFrame.$Shape
     */

    /**
     * Constructs a new IFrame.
     * @exports IFrame
     * @classdesc Represents a IFrame.
     * @constructor
     * @param {IFrame.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const IFrame = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * IFrame src.
     * @member {string|null|undefined} src
     * @memberof IFrame
     * @instance
     */
    IFrame.prototype.src = null;

    /**
     * IFrame srcdoc.
     * @member {string|null|undefined} srcdoc
     * @memberof IFrame
     * @instance
     */
    IFrame.prototype.srcdoc = null;

    /**
     * IFrame scrolling.
     * @member {boolean} scrolling
     * @memberof IFrame
     * @instance
     */
    IFrame.prototype.scrolling = false;

    /**
     * IFrame tabIndex.
     * @member {number|null|undefined} tabIndex
     * @memberof IFrame
     * @instance
     */
    IFrame.prototype.tabIndex = null;

    /**
     * IFrame alt.
     * @member {string|null|undefined} alt
     * @memberof IFrame
     * @instance
     */
    IFrame.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * IFrame type.
     * @member {"src"|"srcdoc"|undefined} type
     * @memberof IFrame
     * @instance
     */
    $Object.defineProperty(IFrame.prototype, "type", {
        get: $util.oneOfGetter($oneOfFields = ["src", "srcdoc"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(IFrame.prototype, "_tabIndex", {
        get: $util.oneOfGetter($oneOfFields = ["tabIndex"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(IFrame.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new IFrame instance using the specified properties.
     * @function create
     * @memberof IFrame
     * @static
     * @param {IFrame.$Properties=} [properties] Properties to set
     * @returns {IFrame} IFrame instance
     * @type {{
     *   (properties: IFrame.$Shape): IFrame & IFrame.$Shape;
     *   (properties?: IFrame.$Properties): IFrame;
     * }}
     */
    IFrame.create = function(properties) {
        return new IFrame(properties);
    };

    /**
     * Encodes the specified IFrame message. Does not implicitly {@link IFrame.verify|verify} messages.
     * @function encode
     * @memberof IFrame
     * @static
     * @param {IFrame.$Properties} message IFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    IFrame.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.src != null && $Object.hasOwnProperty.call(message, "src"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.src);
        if (message.srcdoc != null && $Object.hasOwnProperty.call(message, "srcdoc"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.srcdoc);
        if (message.scrolling != null && $Object.hasOwnProperty.call(message, "scrolling") && message.scrolling !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.scrolling);
        if (message.tabIndex != null && $Object.hasOwnProperty.call(message, "tabIndex"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.tabIndex);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a IFrame message from the specified reader or buffer.
     * @function decode
     * @memberof IFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {IFrame & IFrame.$Shape} IFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    IFrame.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.IFrame();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.src = reader.stringVerify();
                    message.type = "src";
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    message.srcdoc = reader.stringVerify();
                    message.type = "srcdoc";
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.scrolling = value;
                    else
                        delete message.scrolling;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    message.tabIndex = reader.int32();
                    message._tabIndex = "tabIndex";
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a IFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof IFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {IFrame} IFrame
     */
    IFrame.fromObject = function (object, _depth) {
        if (object instanceof $root.IFrame)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".IFrame: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.IFrame();
        if (object.src != null)
            message.src = $String(object.src);
        if (object.srcdoc != null)
            message.srcdoc = $String(object.srcdoc);
        if (object.scrolling != null)
            if (object.scrolling)
                message.scrolling = $Boolean(object.scrolling);
        if (object.tabIndex != null)
            message.tabIndex = object.tabIndex | 0;
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from a IFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof IFrame
     * @static
     * @param {IFrame} message IFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    IFrame.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.scrolling = false;
        if (message.src != null && $Object.hasOwnProperty.call(message, "src")) {
            object.src = message.src;
            if (options.oneofs)
                object.type = "src";
        }
        if (message.srcdoc != null && $Object.hasOwnProperty.call(message, "srcdoc")) {
            object.srcdoc = message.srcdoc;
            if (options.oneofs)
                object.type = "srcdoc";
        }
        if (message.scrolling != null && $Object.hasOwnProperty.call(message, "scrolling"))
            object.scrolling = message.scrolling;
        if (message.tabIndex != null && $Object.hasOwnProperty.call(message, "tabIndex"))
            object.tabIndex = message.tabIndex;
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this IFrame to JSON.
     * @function toJSON
     * @memberof IFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    IFrame.prototype.toJSON = function() {
        return IFrame.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for IFrame
     * @function getTypeUrl
     * @memberof IFrame
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    IFrame.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/IFrame";
    };

    return IFrame;
})();

export const Image = $root.Image = (() => {

    /**
     * Properties of an Image.
     * @typedef {Object} Image.$Properties
     * @property {string|null} [url] Image url
     * @property {string|null} [caption] Image caption
     * @property {string|null} [alt] Image alt
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an Image.
     * @exports IImage
     * @interface IImage
     * @augments Image.$Properties
     * @deprecated Use Image.$Properties instead.
     */

    /**
     * Shape of an Image.
     * @typedef {Image.$Properties} Image.$Shape
     */

    /**
     * Constructs a new Image.
     * @exports Image
     * @classdesc Represents an Image.
     * @constructor
     * @param {Image.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Image = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Image url.
     * @member {string} url
     * @memberof Image
     * @instance
     */
    Image.prototype.url = "";

    /**
     * Image caption.
     * @member {string} caption
     * @memberof Image
     * @instance
     */
    Image.prototype.caption = "";

    /**
     * Image alt.
     * @member {string|null|undefined} alt
     * @memberof Image
     * @instance
     */
    Image.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Image.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Image instance using the specified properties.
     * @function create
     * @memberof Image
     * @static
     * @param {Image.$Properties=} [properties] Properties to set
     * @returns {Image} Image instance
     * @type {{
     *   (properties: Image.$Shape): Image & Image.$Shape;
     *   (properties?: Image.$Properties): Image;
     * }}
     */
    Image.create = function(properties) {
        return new Image(properties);
    };

    /**
     * Encodes the specified Image message. Does not implicitly {@link Image.verify|verify} messages.
     * @function encode
     * @memberof Image
     * @static
     * @param {Image.$Properties} message Image message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Image.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.caption != null && $Object.hasOwnProperty.call(message, "caption") && message.caption !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.caption);
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.url);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an Image message from the specified reader or buffer.
     * @function decode
     * @memberof Image
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Image & Image.$Shape} Image
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Image.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Image();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.caption = value;
                    else
                        delete message.caption;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an Image message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Image
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Image} Image
     */
    Image.fromObject = function (object, _depth) {
        if (object instanceof $root.Image)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Image: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Image();
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        if (object.caption != null)
            if (typeof object.caption !== "string" || object.caption.length)
                message.caption = $String(object.caption);
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from an Image message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Image
     * @static
     * @param {Image} message Image
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Image.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.caption = "";
            object.url = "";
        }
        if (message.caption != null && $Object.hasOwnProperty.call(message, "caption"))
            object.caption = message.caption;
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this Image to JSON.
     * @function toJSON
     * @memberof Image
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Image.prototype.toJSON = function() {
        return Image.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Image
     * @function getTypeUrl
     * @memberof Image
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Image.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Image";
    };

    return Image;
})();

export const ImageList = $root.ImageList = (() => {

    /**
     * Properties of an ImageList.
     * @typedef {Object} ImageList.$Properties
     * @property {Array.<Image.$Properties>|null} [imgs] ImageList imgs
     * @property {string|null} [link] ImageList link
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an ImageList.
     * @exports IImageList
     * @interface IImageList
     * @augments ImageList.$Properties
     * @deprecated Use ImageList.$Properties instead.
     */

    /**
     * Shape of an ImageList.
     * @typedef {ImageList.$Properties} ImageList.$Shape
     */

    /**
     * Constructs a new ImageList.
     * @exports ImageList
     * @classdesc Represents an ImageList.
     * @constructor
     * @param {ImageList.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ImageList = function (properties) {
        this.imgs = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ImageList imgs.
     * @member {Array.<Image.$Properties>} imgs
     * @memberof ImageList
     * @instance
     */
    ImageList.prototype.imgs = $util.emptyArray;

    /**
     * ImageList link.
     * @member {string} link
     * @memberof ImageList
     * @instance
     */
    ImageList.prototype.link = "";

    /**
     * Creates a new ImageList instance using the specified properties.
     * @function create
     * @memberof ImageList
     * @static
     * @param {ImageList.$Properties=} [properties] Properties to set
     * @returns {ImageList} ImageList instance
     * @type {{
     *   (properties: ImageList.$Shape): ImageList & ImageList.$Shape;
     *   (properties?: ImageList.$Properties): ImageList;
     * }}
     */
    ImageList.create = function(properties) {
        return new ImageList(properties);
    };

    /**
     * Encodes the specified ImageList message. Does not implicitly {@link ImageList.verify|verify} messages.
     * @function encode
     * @memberof ImageList
     * @static
     * @param {ImageList.$Properties} message ImageList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ImageList.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.imgs != null && message.imgs.length)
            for (let i = 0; i < message.imgs.length; ++i)
                $root.Image.encode(message.imgs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.link != null && $Object.hasOwnProperty.call(message, "link") && message.link !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.link);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an ImageList message from the specified reader or buffer.
     * @function decode
     * @memberof ImageList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ImageList & ImageList.$Shape} ImageList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ImageList.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ImageList();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if (!(message.imgs && message.imgs.length))
                        message.imgs = [];
                    message.imgs.push($root.Image.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.link = value;
                    else
                        delete message.link;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an ImageList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ImageList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ImageList} ImageList
     */
    ImageList.fromObject = function (object, _depth) {
        if (object instanceof $root.ImageList)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ImageList: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ImageList();
        if (object.imgs) {
            if (!$Array.isArray(object.imgs))
                throw $TypeError(".ImageList.imgs: array expected");
            message.imgs = $Array(object.imgs.length);
            for (let i = 0; i < object.imgs.length; ++i) {
                if (!$util.isObject(object.imgs[i]))
                    throw $TypeError(".ImageList.imgs: object expected");
                message.imgs[i] = $root.Image.fromObject(object.imgs[i], _depth + 1);
            }
        }
        if (object.link != null)
            if (typeof object.link !== "string" || object.link.length)
                message.link = $String(object.link);
        return message;
    };

    /**
     * Creates a plain object from an ImageList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ImageList
     * @static
     * @param {ImageList} message ImageList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ImageList.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.imgs = [];
        if (options.defaults)
            object.link = "";
        if (message.imgs && message.imgs.length) {
            object.imgs = $Array(message.imgs.length);
            for (let j = 0; j < message.imgs.length; ++j)
                object.imgs[j] = $root.Image.toObject(message.imgs[j], options, _depth + 1);
        }
        if (message.link != null && $Object.hasOwnProperty.call(message, "link"))
            object.link = message.link;
        return object;
    };

    /**
     * Converts this ImageList to JSON.
     * @function toJSON
     * @memberof ImageList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ImageList.prototype.toJSON = function() {
        return ImageList.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ImageList
     * @function getTypeUrl
     * @memberof ImageList
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ImageList.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ImageList";
    };

    return ImageList;
})();

export const Json = $root.Json = (() => {

    /**
     * Properties of a Json.
     * @typedef {Object} Json.$Properties
     * @property {string|null} [body] Json body
     * @property {boolean|null} [expanded] Json expanded
     * @property {number|null} [maxExpandDepth] Json maxExpandDepth
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Json.
     * @exports IJson
     * @interface IJson
     * @augments Json.$Properties
     * @deprecated Use Json.$Properties instead.
     */

    /**
     * Shape of a Json.
     * @typedef {Json.$Properties} Json.$Shape
     */

    /**
     * Constructs a new Json.
     * @exports Json
     * @classdesc Represents a Json.
     * @constructor
     * @param {Json.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Json = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Json body.
     * @member {string} body
     * @memberof Json
     * @instance
     */
    Json.prototype.body = "";

    /**
     * Json expanded.
     * @member {boolean} expanded
     * @memberof Json
     * @instance
     */
    Json.prototype.expanded = false;

    /**
     * Json maxExpandDepth.
     * @member {number|null|undefined} maxExpandDepth
     * @memberof Json
     * @instance
     */
    Json.prototype.maxExpandDepth = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Json.prototype, "_maxExpandDepth", {
        get: $util.oneOfGetter($oneOfFields = ["maxExpandDepth"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Json instance using the specified properties.
     * @function create
     * @memberof Json
     * @static
     * @param {Json.$Properties=} [properties] Properties to set
     * @returns {Json} Json instance
     * @type {{
     *   (properties: Json.$Shape): Json & Json.$Shape;
     *   (properties?: Json.$Properties): Json;
     * }}
     */
    Json.create = function(properties) {
        return new Json(properties);
    };

    /**
     * Encodes the specified Json message. Does not implicitly {@link Json.verify|verify} messages.
     * @function encode
     * @memberof Json
     * @static
     * @param {Json.$Properties} message Json message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Json.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.body != null && $Object.hasOwnProperty.call(message, "body") && message.body !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.body);
        if (message.expanded != null && $Object.hasOwnProperty.call(message, "expanded") && message.expanded !== false)
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.expanded);
        if (message.maxExpandDepth != null && $Object.hasOwnProperty.call(message, "maxExpandDepth"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxExpandDepth);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Json message from the specified reader or buffer.
     * @function decode
     * @memberof Json
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Json & Json.$Shape} Json
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Json.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Json();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.body = value;
                    else
                        delete message.body;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.expanded = value;
                    else
                        delete message.expanded;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    message.maxExpandDepth = reader.int32();
                    message._maxExpandDepth = "maxExpandDepth";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Json message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Json
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Json} Json
     */
    Json.fromObject = function (object, _depth) {
        if (object instanceof $root.Json)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Json: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Json();
        if (object.body != null)
            if (typeof object.body !== "string" || object.body.length)
                message.body = $String(object.body);
        if (object.expanded != null)
            if (object.expanded)
                message.expanded = $Boolean(object.expanded);
        if (object.maxExpandDepth != null)
            message.maxExpandDepth = object.maxExpandDepth | 0;
        return message;
    };

    /**
     * Creates a plain object from a Json message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Json
     * @static
     * @param {Json} message Json
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Json.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.body = "";
            object.expanded = false;
        }
        if (message.body != null && $Object.hasOwnProperty.call(message, "body"))
            object.body = message.body;
        if (message.expanded != null && $Object.hasOwnProperty.call(message, "expanded"))
            object.expanded = message.expanded;
        if (message.maxExpandDepth != null && $Object.hasOwnProperty.call(message, "maxExpandDepth"))
            object.maxExpandDepth = message.maxExpandDepth;
        return object;
    };

    /**
     * Converts this Json to JSON.
     * @function toJSON
     * @memberof Json
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Json.prototype.toJSON = function() {
        return Json.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Json
     * @function getTypeUrl
     * @memberof Json
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Json.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Json";
    };

    return Json;
})();

export const LinkButton = $root.LinkButton = (() => {

    /**
     * Properties of a LinkButton.
     * @typedef {Object} LinkButton.$Properties
     * @property {string|null} [id] LinkButton id
     * @property {string|null} [label] LinkButton label
     * @property {string|null} [help] LinkButton help
     * @property {string|null} [url] LinkButton url
     * @property {boolean|null} [disabled] LinkButton disabled
     * @property {boolean|null} [useContainerWidth] LinkButton useContainerWidth
     * @property {string|null} [type] LinkButton type
     * @property {string|null} [icon] LinkButton icon
     * @property {string|null} [shortcut] LinkButton shortcut
     * @property {streamlit.ButtonLikeIconPosition|null} [iconPosition] LinkButton iconPosition
     * @property {boolean|null} [ignoreRerun] LinkButton ignoreRerun
     * @property {boolean|null} [wrap] LinkButton wrap
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a LinkButton.
     * @exports ILinkButton
     * @interface ILinkButton
     * @augments LinkButton.$Properties
     * @deprecated Use LinkButton.$Properties instead.
     */

    /**
     * Shape of a LinkButton.
     * @typedef {LinkButton.$Properties} LinkButton.$Shape
     */

    /**
     * Constructs a new LinkButton.
     * @exports LinkButton
     * @classdesc Represents a LinkButton.
     * @constructor
     * @param {LinkButton.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const LinkButton = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * LinkButton id.
     * @member {string} id
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.id = "";

    /**
     * LinkButton label.
     * @member {string} label
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.label = "";

    /**
     * LinkButton help.
     * @member {string} help
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.help = "";

    /**
     * LinkButton url.
     * @member {string} url
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.url = "";

    /**
     * LinkButton disabled.
     * @member {boolean} disabled
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.disabled = false;

    /**
     * LinkButton useContainerWidth.
     * @member {boolean} useContainerWidth
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.useContainerWidth = false;

    /**
     * LinkButton type.
     * @member {string} type
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.type = "";

    /**
     * LinkButton icon.
     * @member {string} icon
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.icon = "";

    /**
     * LinkButton shortcut.
     * @member {string} shortcut
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.shortcut = "";

    /**
     * LinkButton iconPosition.
     * @member {streamlit.ButtonLikeIconPosition} iconPosition
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.iconPosition = 0;

    /**
     * LinkButton ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.ignoreRerun = false;

    /**
     * LinkButton wrap.
     * @member {boolean|null|undefined} wrap
     * @memberof LinkButton
     * @instance
     */
    LinkButton.prototype.wrap = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(LinkButton.prototype, "_wrap", {
        get: $util.oneOfGetter($oneOfFields = ["wrap"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new LinkButton instance using the specified properties.
     * @function create
     * @memberof LinkButton
     * @static
     * @param {LinkButton.$Properties=} [properties] Properties to set
     * @returns {LinkButton} LinkButton instance
     * @type {{
     *   (properties: LinkButton.$Shape): LinkButton & LinkButton.$Shape;
     *   (properties?: LinkButton.$Properties): LinkButton;
     * }}
     */
    LinkButton.create = function(properties) {
        return new LinkButton(properties);
    };

    /**
     * Encodes the specified LinkButton message. Does not implicitly {@link LinkButton.verify|verify} messages.
     * @function encode
     * @memberof LinkButton
     * @static
     * @param {LinkButton.$Properties} message LinkButton message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LinkButton.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.help);
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.url);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.disabled);
        if (message.useContainerWidth != null && $Object.hasOwnProperty.call(message, "useContainerWidth") && message.useContainerWidth !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.useContainerWidth);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== "")
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.type);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.icon);
        if (message.shortcut != null && $Object.hasOwnProperty.call(message, "shortcut") && message.shortcut !== "")
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.shortcut);
        if (message.iconPosition != null && $Object.hasOwnProperty.call(message, "iconPosition") && message.iconPosition !== 0)
            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.iconPosition);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.ignoreRerun);
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.wrap);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a LinkButton message from the specified reader or buffer.
     * @function decode
     * @memberof LinkButton
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LinkButton & LinkButton.$Shape} LinkButton
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LinkButton.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.LinkButton();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.useContainerWidth = value;
                    else
                        delete message.useContainerWidth;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.shortcut = value;
                    else
                        delete message.shortcut;
                    continue;
                }
            case 12: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.iconPosition = value;
                    else
                        delete message.iconPosition;
                    continue;
                }
            case 13: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            case 14: {
                    if (wireType !== 0)
                        break;
                    message.wrap = reader.bool();
                    message._wrap = "wrap";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a LinkButton message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LinkButton
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LinkButton} LinkButton
     */
    LinkButton.fromObject = function (object, _depth) {
        if (object instanceof $root.LinkButton)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".LinkButton: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.LinkButton();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.useContainerWidth != null)
            if (object.useContainerWidth)
                message.useContainerWidth = $Boolean(object.useContainerWidth);
        if (object.type != null)
            if (typeof object.type !== "string" || object.type.length)
                message.type = $String(object.type);
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        if (object.shortcut != null)
            if (typeof object.shortcut !== "string" || object.shortcut.length)
                message.shortcut = $String(object.shortcut);
        if (object.iconPosition !== 0 && (typeof object.iconPosition !== "string" || $root.streamlit.ButtonLikeIconPosition[object.iconPosition] !== 0))
            switch (object.iconPosition) {
            case "LEFT":
            case 0:
                message.iconPosition = 0;
                break;
            case "RIGHT":
            case 1:
                message.iconPosition = 1;
                break;
            default:
                if (typeof object.iconPosition === "number" && (object.iconPosition | 0) === object.iconPosition)
                    message.iconPosition = object.iconPosition;
            }
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        if (object.wrap != null)
            message.wrap = $Boolean(object.wrap);
        return message;
    };

    /**
     * Creates a plain object from a LinkButton message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LinkButton
     * @static
     * @param {LinkButton} message LinkButton
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LinkButton.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.help = "";
            object.url = "";
            object.disabled = false;
            object.useContainerWidth = false;
            object.type = "";
            object.icon = "";
            object.shortcut = "";
            object.iconPosition = options.enums === $String ? "LEFT" : 0;
            object.ignoreRerun = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.useContainerWidth != null && $Object.hasOwnProperty.call(message, "useContainerWidth"))
            object.useContainerWidth = message.useContainerWidth;
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = message.type;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        if (message.shortcut != null && $Object.hasOwnProperty.call(message, "shortcut"))
            object.shortcut = message.shortcut;
        if (message.iconPosition != null && $Object.hasOwnProperty.call(message, "iconPosition"))
            object.iconPosition = options.enums === $String ? $root.streamlit.ButtonLikeIconPosition[message.iconPosition] === $undefined ? message.iconPosition : $root.streamlit.ButtonLikeIconPosition[message.iconPosition] : message.iconPosition;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            object.wrap = message.wrap;
        return object;
    };

    /**
     * Converts this LinkButton to JSON.
     * @function toJSON
     * @memberof LinkButton
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LinkButton.prototype.toJSON = function() {
        return LinkButton.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for LinkButton
     * @function getTypeUrl
     * @memberof LinkButton
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    LinkButton.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/LinkButton";
    };

    return LinkButton;
})();

export const Markdown = $root.Markdown = (() => {

    /**
     * Properties of a Markdown.
     * @typedef {Object} Markdown.$Properties
     * @property {string|null} [body] Markdown body
     * @property {boolean|null} [allowHtml] Markdown allowHtml
     * @property {Markdown.Type|null} [elementType] Markdown elementType
     * @property {string|null} [help] Markdown help
     * @property {boolean|null} [unterminatedParsing] Markdown unterminatedParsing
     * @property {boolean|null} [hideAnchors] Markdown hideAnchors
     * @property {boolean|null} [wrap] Markdown wrap
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Markdown.
     * @exports IMarkdown
     * @interface IMarkdown
     * @augments Markdown.$Properties
     * @deprecated Use Markdown.$Properties instead.
     */

    /**
     * Shape of a Markdown.
     * @typedef {Markdown.$Properties} Markdown.$Shape
     */

    /**
     * Constructs a new Markdown.
     * @exports Markdown
     * @classdesc Represents a Markdown.
     * @constructor
     * @param {Markdown.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Markdown = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Markdown body.
     * @member {string} body
     * @memberof Markdown
     * @instance
     */
    Markdown.prototype.body = "";

    /**
     * Markdown allowHtml.
     * @member {boolean} allowHtml
     * @memberof Markdown
     * @instance
     */
    Markdown.prototype.allowHtml = false;

    /**
     * Markdown elementType.
     * @member {Markdown.Type} elementType
     * @memberof Markdown
     * @instance
     */
    Markdown.prototype.elementType = 0;

    /**
     * Markdown help.
     * @member {string} help
     * @memberof Markdown
     * @instance
     */
    Markdown.prototype.help = "";

    /**
     * Markdown unterminatedParsing.
     * @member {boolean} unterminatedParsing
     * @memberof Markdown
     * @instance
     */
    Markdown.prototype.unterminatedParsing = false;

    /**
     * Markdown hideAnchors.
     * @member {boolean} hideAnchors
     * @memberof Markdown
     * @instance
     */
    Markdown.prototype.hideAnchors = false;

    /**
     * Markdown wrap.
     * @member {boolean|null|undefined} wrap
     * @memberof Markdown
     * @instance
     */
    Markdown.prototype.wrap = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Markdown.prototype, "_wrap", {
        get: $util.oneOfGetter($oneOfFields = ["wrap"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Markdown instance using the specified properties.
     * @function create
     * @memberof Markdown
     * @static
     * @param {Markdown.$Properties=} [properties] Properties to set
     * @returns {Markdown} Markdown instance
     * @type {{
     *   (properties: Markdown.$Shape): Markdown & Markdown.$Shape;
     *   (properties?: Markdown.$Properties): Markdown;
     * }}
     */
    Markdown.create = function(properties) {
        return new Markdown(properties);
    };

    /**
     * Encodes the specified Markdown message. Does not implicitly {@link Markdown.verify|verify} messages.
     * @function encode
     * @memberof Markdown
     * @static
     * @param {Markdown.$Properties} message Markdown message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Markdown.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.body != null && $Object.hasOwnProperty.call(message, "body") && message.body !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.body);
        if (message.allowHtml != null && $Object.hasOwnProperty.call(message, "allowHtml") && message.allowHtml !== false)
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.allowHtml);
        if (message.elementType != null && $Object.hasOwnProperty.call(message, "elementType") && message.elementType !== 0)
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.elementType);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.help);
        if (message.unterminatedParsing != null && $Object.hasOwnProperty.call(message, "unterminatedParsing") && message.unterminatedParsing !== false)
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.unterminatedParsing);
        if (message.hideAnchors != null && $Object.hasOwnProperty.call(message, "hideAnchors") && message.hideAnchors !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.hideAnchors);
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.wrap);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Markdown message from the specified reader or buffer.
     * @function decode
     * @memberof Markdown
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Markdown & Markdown.$Shape} Markdown
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Markdown.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Markdown();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.body = value;
                    else
                        delete message.body;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.allowHtml = value;
                    else
                        delete message.allowHtml;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.elementType = value;
                    else
                        delete message.elementType;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.unterminatedParsing = value;
                    else
                        delete message.unterminatedParsing;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hideAnchors = value;
                    else
                        delete message.hideAnchors;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    message.wrap = reader.bool();
                    message._wrap = "wrap";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Markdown message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Markdown
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Markdown} Markdown
     */
    Markdown.fromObject = function (object, _depth) {
        if (object instanceof $root.Markdown)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Markdown: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Markdown();
        if (object.body != null)
            if (typeof object.body !== "string" || object.body.length)
                message.body = $String(object.body);
        if (object.allowHtml != null)
            if (object.allowHtml)
                message.allowHtml = $Boolean(object.allowHtml);
        if (object.elementType !== 0 && (typeof object.elementType !== "string" || $root.Markdown.Type[object.elementType] !== 0))
            switch (object.elementType) {
            case "UNSPECIFIED":
            case 0:
                message.elementType = 0;
                break;
            case "NATIVE":
            case 1:
                message.elementType = 1;
                break;
            case "CAPTION":
            case 2:
                message.elementType = 2;
                break;
            case "CODE":
            case 3:
                message.elementType = 3;
                break;
            case "LATEX":
            case 4:
                message.elementType = 4;
                break;
            case "DIVIDER":
            case 5:
                message.elementType = 5;
                break;
            default:
                if (typeof object.elementType === "number" && (object.elementType | 0) === object.elementType)
                    message.elementType = object.elementType;
            }
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.unterminatedParsing != null)
            if (object.unterminatedParsing)
                message.unterminatedParsing = $Boolean(object.unterminatedParsing);
        if (object.hideAnchors != null)
            if (object.hideAnchors)
                message.hideAnchors = $Boolean(object.hideAnchors);
        if (object.wrap != null)
            message.wrap = $Boolean(object.wrap);
        return message;
    };

    /**
     * Creates a plain object from a Markdown message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Markdown
     * @static
     * @param {Markdown} message Markdown
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Markdown.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.body = "";
            object.allowHtml = false;
            object.elementType = options.enums === $String ? "UNSPECIFIED" : 0;
            object.help = "";
            object.unterminatedParsing = false;
            object.hideAnchors = false;
        }
        if (message.body != null && $Object.hasOwnProperty.call(message, "body"))
            object.body = message.body;
        if (message.allowHtml != null && $Object.hasOwnProperty.call(message, "allowHtml"))
            object.allowHtml = message.allowHtml;
        if (message.elementType != null && $Object.hasOwnProperty.call(message, "elementType"))
            object.elementType = options.enums === $String ? $root.Markdown.Type[message.elementType] === $undefined ? message.elementType : $root.Markdown.Type[message.elementType] : message.elementType;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.unterminatedParsing != null && $Object.hasOwnProperty.call(message, "unterminatedParsing"))
            object.unterminatedParsing = message.unterminatedParsing;
        if (message.hideAnchors != null && $Object.hasOwnProperty.call(message, "hideAnchors"))
            object.hideAnchors = message.hideAnchors;
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            object.wrap = message.wrap;
        return object;
    };

    /**
     * Converts this Markdown to JSON.
     * @function toJSON
     * @memberof Markdown
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Markdown.prototype.toJSON = function() {
        return Markdown.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Markdown
     * @function getTypeUrl
     * @memberof Markdown
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Markdown.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Markdown";
    };

    /**
     * Type enum.
     * @name Markdown.Type
     * @enum {number}
     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
     * @property {number} NATIVE=1 NATIVE value
     * @property {number} CAPTION=2 CAPTION value
     * @property {number} CODE=3 CODE value
     * @property {number} LATEX=4 LATEX value
     * @property {number} DIVIDER=5 DIVIDER value
     */
    Markdown.Type = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "UNSPECIFIED"] = 0;
        values[valuesById[1] = "NATIVE"] = 1;
        values[valuesById[2] = "CAPTION"] = 2;
        values[valuesById[3] = "CODE"] = 3;
        values[valuesById[4] = "LATEX"] = 4;
        values[valuesById[5] = "DIVIDER"] = 5;
        return values;
    })();

    return Markdown;
})();

export const MenuButton = $root.MenuButton = (() => {

    /**
     * Properties of a MenuButton.
     * @typedef {Object} MenuButton.$Properties
     * @property {string|null} [id] MenuButton id
     * @property {string|null} [label] MenuButton label
     * @property {Array.<string>|null} [options] MenuButton options
     * @property {string|null} [help] MenuButton help
     * @property {string|null} [type] MenuButton type
     * @property {boolean|null} [disabled] MenuButton disabled
     * @property {string|null} [icon] MenuButton icon
     * @property {boolean|null} [wrap] MenuButton wrap
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a MenuButton.
     * @exports IMenuButton
     * @interface IMenuButton
     * @augments MenuButton.$Properties
     * @deprecated Use MenuButton.$Properties instead.
     */

    /**
     * Shape of a MenuButton.
     * @typedef {MenuButton.$Properties} MenuButton.$Shape
     */

    /**
     * Constructs a new MenuButton.
     * @exports MenuButton
     * @classdesc Represents a MenuButton.
     * @constructor
     * @param {MenuButton.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const MenuButton = function (properties) {
        this.options = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * MenuButton id.
     * @member {string} id
     * @memberof MenuButton
     * @instance
     */
    MenuButton.prototype.id = "";

    /**
     * MenuButton label.
     * @member {string} label
     * @memberof MenuButton
     * @instance
     */
    MenuButton.prototype.label = "";

    /**
     * MenuButton options.
     * @member {Array.<string>} options
     * @memberof MenuButton
     * @instance
     */
    MenuButton.prototype.options = $util.emptyArray;

    /**
     * MenuButton help.
     * @member {string} help
     * @memberof MenuButton
     * @instance
     */
    MenuButton.prototype.help = "";

    /**
     * MenuButton type.
     * @member {string} type
     * @memberof MenuButton
     * @instance
     */
    MenuButton.prototype.type = "";

    /**
     * MenuButton disabled.
     * @member {boolean} disabled
     * @memberof MenuButton
     * @instance
     */
    MenuButton.prototype.disabled = false;

    /**
     * MenuButton icon.
     * @member {string} icon
     * @memberof MenuButton
     * @instance
     */
    MenuButton.prototype.icon = "";

    /**
     * MenuButton wrap.
     * @member {boolean|null|undefined} wrap
     * @memberof MenuButton
     * @instance
     */
    MenuButton.prototype.wrap = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(MenuButton.prototype, "_wrap", {
        get: $util.oneOfGetter($oneOfFields = ["wrap"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new MenuButton instance using the specified properties.
     * @function create
     * @memberof MenuButton
     * @static
     * @param {MenuButton.$Properties=} [properties] Properties to set
     * @returns {MenuButton} MenuButton instance
     * @type {{
     *   (properties: MenuButton.$Shape): MenuButton & MenuButton.$Shape;
     *   (properties?: MenuButton.$Properties): MenuButton;
     * }}
     */
    MenuButton.create = function(properties) {
        return new MenuButton(properties);
    };

    /**
     * Encodes the specified MenuButton message. Does not implicitly {@link MenuButton.verify|verify} messages.
     * @function encode
     * @memberof MenuButton
     * @static
     * @param {MenuButton.$Properties} message MenuButton message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MenuButton.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message.options != null && message.options.length)
            for (let i = 0; i < message.options.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.options[i]);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.help);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.type);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.disabled);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.icon);
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.wrap);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a MenuButton message from the specified reader or buffer.
     * @function decode
     * @memberof MenuButton
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MenuButton & MenuButton.$Shape} MenuButton
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MenuButton.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.MenuButton();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if (!(message.options && message.options.length))
                        message.options = [];
                    message.options.push(reader.stringVerify());
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    message.wrap = reader.bool();
                    message._wrap = "wrap";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a MenuButton message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MenuButton
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MenuButton} MenuButton
     */
    MenuButton.fromObject = function (object, _depth) {
        if (object instanceof $root.MenuButton)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".MenuButton: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.MenuButton();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.options) {
            if (!$Array.isArray(object.options))
                throw $TypeError(".MenuButton.options: array expected");
            message.options = $Array(object.options.length);
            for (let i = 0; i < object.options.length; ++i)
                message.options[i] = $String(object.options[i]);
        }
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.type != null)
            if (typeof object.type !== "string" || object.type.length)
                message.type = $String(object.type);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        if (object.wrap != null)
            message.wrap = $Boolean(object.wrap);
        return message;
    };

    /**
     * Creates a plain object from a MenuButton message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MenuButton
     * @static
     * @param {MenuButton} message MenuButton
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MenuButton.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.options = [];
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.help = "";
            object.type = "";
            object.disabled = false;
            object.icon = "";
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.options && message.options.length) {
            object.options = $Array(message.options.length);
            for (let j = 0; j < message.options.length; ++j)
                object.options[j] = message.options[j];
        }
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = message.type;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            object.wrap = message.wrap;
        return object;
    };

    /**
     * Converts this MenuButton to JSON.
     * @function toJSON
     * @memberof MenuButton
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MenuButton.prototype.toJSON = function() {
        return MenuButton.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for MenuButton
     * @function getTypeUrl
     * @memberof MenuButton
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    MenuButton.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/MenuButton";
    };

    return MenuButton;
})();

export const Metric = $root.Metric = (() => {

    /**
     * Properties of a Metric.
     * @typedef {Object} Metric.$Properties
     * @property {string|null} [label] Metric label
     * @property {string|null} [body] Metric body
     * @property {string|null} [delta] Metric delta
     * @property {Metric.MetricDirection|null} [direction] Metric direction
     * @property {Metric.MetricColor|null} [color] Metric color
     * @property {string|null} [help] Metric help
     * @property {LabelVisibility.$Properties|null} [labelVisibility] Metric labelVisibility
     * @property {boolean|null} [showBorder] Metric showBorder
     * @property {Array.<number>|null} [chartData] Metric chartData
     * @property {Metric.ChartType|null} [chartType] Metric chartType
     * @property {string|null} [format] Metric format
     * @property {string|null} [deltaDescription] Metric deltaDescription
     * @property {string|null} [icon] Metric icon
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Metric.
     * @exports IMetric
     * @interface IMetric
     * @augments Metric.$Properties
     * @deprecated Use Metric.$Properties instead.
     */

    /**
     * Shape of a Metric.
     * @typedef {Metric.$Properties} Metric.$Shape
     */

    /**
     * Constructs a new Metric.
     * @exports Metric
     * @classdesc Represents a Metric.
     * @constructor
     * @param {Metric.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Metric = function (properties) {
        this.chartData = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Metric label.
     * @member {string} label
     * @memberof Metric
     * @instance
     */
    Metric.prototype.label = "";

    /**
     * Metric body.
     * @member {string} body
     * @memberof Metric
     * @instance
     */
    Metric.prototype.body = "";

    /**
     * Metric delta.
     * @member {string} delta
     * @memberof Metric
     * @instance
     */
    Metric.prototype.delta = "";

    /**
     * Metric direction.
     * @member {Metric.MetricDirection} direction
     * @memberof Metric
     * @instance
     */
    Metric.prototype.direction = 0;

    /**
     * Metric color.
     * @member {Metric.MetricColor} color
     * @memberof Metric
     * @instance
     */
    Metric.prototype.color = 0;

    /**
     * Metric help.
     * @member {string} help
     * @memberof Metric
     * @instance
     */
    Metric.prototype.help = "";

    /**
     * Metric labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof Metric
     * @instance
     */
    Metric.prototype.labelVisibility = null;

    /**
     * Metric showBorder.
     * @member {boolean} showBorder
     * @memberof Metric
     * @instance
     */
    Metric.prototype.showBorder = false;

    /**
     * Metric chartData.
     * @member {Array.<number>} chartData
     * @memberof Metric
     * @instance
     */
    Metric.prototype.chartData = $util.emptyArray;

    /**
     * Metric chartType.
     * @member {Metric.ChartType} chartType
     * @memberof Metric
     * @instance
     */
    Metric.prototype.chartType = 0;

    /**
     * Metric format.
     * @member {string} format
     * @memberof Metric
     * @instance
     */
    Metric.prototype.format = "";

    /**
     * Metric deltaDescription.
     * @member {string} deltaDescription
     * @memberof Metric
     * @instance
     */
    Metric.prototype.deltaDescription = "";

    /**
     * Metric icon.
     * @member {string} icon
     * @memberof Metric
     * @instance
     */
    Metric.prototype.icon = "";

    /**
     * Creates a new Metric instance using the specified properties.
     * @function create
     * @memberof Metric
     * @static
     * @param {Metric.$Properties=} [properties] Properties to set
     * @returns {Metric} Metric instance
     * @type {{
     *   (properties: Metric.$Shape): Metric & Metric.$Shape;
     *   (properties?: Metric.$Properties): Metric;
     * }}
     */
    Metric.create = function(properties) {
        return new Metric(properties);
    };

    /**
     * Encodes the specified Metric message. Does not implicitly {@link Metric.verify|verify} messages.
     * @function encode
     * @memberof Metric
     * @static
     * @param {Metric.$Properties} message Metric message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Metric.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.label);
        if (message.body != null && $Object.hasOwnProperty.call(message, "body") && message.body !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.body);
        if (message.delta != null && $Object.hasOwnProperty.call(message, "delta") && message.delta !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.delta);
        if (message.direction != null && $Object.hasOwnProperty.call(message, "direction") && message.direction !== 0)
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.direction);
        if (message.color != null && $Object.hasOwnProperty.call(message, "color") && message.color !== 0)
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.color);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.help);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 7, wireType 2 =*/58).fork(), _depth + 1).ldelim();
        if (message.showBorder != null && $Object.hasOwnProperty.call(message, "showBorder") && message.showBorder !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.showBorder);
        if (message.chartData != null && message.chartData.length)
            writer.uint32(/* id 9, wireType 2 =*/74).doubles(message.chartData);
        if (message.chartType != null && $Object.hasOwnProperty.call(message, "chartType") && message.chartType !== 0)
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.chartType);
        if (message.format != null && $Object.hasOwnProperty.call(message, "format") && message.format !== "")
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.format);
        if (message.deltaDescription != null && $Object.hasOwnProperty.call(message, "deltaDescription") && message.deltaDescription !== "")
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.deltaDescription);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.icon);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Metric message from the specified reader or buffer.
     * @function decode
     * @memberof Metric
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Metric & Metric.$Shape} Metric
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Metric.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Metric();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.body = value;
                    else
                        delete message.body;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.delta = value;
                    else
                        delete message.delta;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.direction = value;
                    else
                        delete message.direction;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.color = value;
                    else
                        delete message.color;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.showBorder = value;
                    else
                        delete message.showBorder;
                    continue;
                }
            case 9: {
                    if (wireType === 2) {
                        if (!(message.chartData && message.chartData.length))
                            message.chartData = [];
                        reader.doubles(message.chartData);
                        continue;
                    }
                    if (wireType !== 1)
                        break;
                    if (!(message.chartData && message.chartData.length))
                        message.chartData = [];
                    message.chartData.push(reader.double());
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.chartType = value;
                    else
                        delete message.chartType;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.format = value;
                    else
                        delete message.format;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.deltaDescription = value;
                    else
                        delete message.deltaDescription;
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Metric message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Metric
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Metric} Metric
     */
    Metric.fromObject = function (object, _depth) {
        if (object instanceof $root.Metric)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Metric: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Metric();
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.body != null)
            if (typeof object.body !== "string" || object.body.length)
                message.body = $String(object.body);
        if (object.delta != null)
            if (typeof object.delta !== "string" || object.delta.length)
                message.delta = $String(object.delta);
        if (object.direction !== 0 && (typeof object.direction !== "string" || $root.Metric.MetricDirection[object.direction] !== 0))
            switch (object.direction) {
            case "DOWN":
            case 0:
                message.direction = 0;
                break;
            case "UP":
            case 1:
                message.direction = 1;
                break;
            case "NONE":
            case 2:
                message.direction = 2;
                break;
            default:
                if (typeof object.direction === "number" && (object.direction | 0) === object.direction)
                    message.direction = object.direction;
            }
        if (object.color !== 0 && (typeof object.color !== "string" || $root.Metric.MetricColor[object.color] !== 0))
            switch (object.color) {
            case "RED":
            case 0:
                message.color = 0;
                break;
            case "GREEN":
            case 1:
                message.color = 1;
                break;
            case "GRAY":
            case 2:
                message.color = 2;
                break;
            case "ORANGE":
            case 3:
                message.color = 3;
                break;
            case "YELLOW":
            case 4:
                message.color = 4;
                break;
            case "BLUE":
            case 5:
                message.color = 5;
                break;
            case "VIOLET":
            case 6:
                message.color = 6;
                break;
            case "PRIMARY":
            case 7:
                message.color = 7;
                break;
            default:
                if (typeof object.color === "number" && (object.color | 0) === object.color)
                    message.color = object.color;
            }
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".Metric.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.showBorder != null)
            if (object.showBorder)
                message.showBorder = $Boolean(object.showBorder);
        if (object.chartData) {
            if (!$Array.isArray(object.chartData))
                throw $TypeError(".Metric.chartData: array expected");
            message.chartData = $Array(object.chartData.length);
            for (let i = 0; i < object.chartData.length; ++i)
                message.chartData[i] = $Number(object.chartData[i]);
        }
        if (object.chartType !== 0 && (typeof object.chartType !== "string" || $root.Metric.ChartType[object.chartType] !== 0))
            switch (object.chartType) {
            case "LINE":
            case 0:
                message.chartType = 0;
                break;
            case "BAR":
            case 1:
                message.chartType = 1;
                break;
            case "AREA":
            case 2:
                message.chartType = 2;
                break;
            default:
                if (typeof object.chartType === "number" && (object.chartType | 0) === object.chartType)
                    message.chartType = object.chartType;
            }
        if (object.format != null)
            if (typeof object.format !== "string" || object.format.length)
                message.format = $String(object.format);
        if (object.deltaDescription != null)
            if (typeof object.deltaDescription !== "string" || object.deltaDescription.length)
                message.deltaDescription = $String(object.deltaDescription);
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        return message;
    };

    /**
     * Creates a plain object from a Metric message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Metric
     * @static
     * @param {Metric} message Metric
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Metric.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.chartData = [];
        if (options.defaults) {
            object.label = "";
            object.body = "";
            object.delta = "";
            object.direction = options.enums === $String ? "DOWN" : 0;
            object.color = options.enums === $String ? "RED" : 0;
            object.help = "";
            object.labelVisibility = null;
            object.showBorder = false;
            object.chartType = options.enums === $String ? "LINE" : 0;
            object.format = "";
            object.deltaDescription = "";
            object.icon = "";
        }
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.body != null && $Object.hasOwnProperty.call(message, "body"))
            object.body = message.body;
        if (message.delta != null && $Object.hasOwnProperty.call(message, "delta"))
            object.delta = message.delta;
        if (message.direction != null && $Object.hasOwnProperty.call(message, "direction"))
            object.direction = options.enums === $String ? $root.Metric.MetricDirection[message.direction] === $undefined ? message.direction : $root.Metric.MetricDirection[message.direction] : message.direction;
        if (message.color != null && $Object.hasOwnProperty.call(message, "color"))
            object.color = options.enums === $String ? $root.Metric.MetricColor[message.color] === $undefined ? message.color : $root.Metric.MetricColor[message.color] : message.color;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.showBorder != null && $Object.hasOwnProperty.call(message, "showBorder"))
            object.showBorder = message.showBorder;
        if (message.chartData && message.chartData.length) {
            object.chartData = $Array(message.chartData.length);
            for (let j = 0; j < message.chartData.length; ++j)
                object.chartData[j] = options.json && !$isFinite(message.chartData[j]) ? $String(message.chartData[j]) : message.chartData[j];
        }
        if (message.chartType != null && $Object.hasOwnProperty.call(message, "chartType"))
            object.chartType = options.enums === $String ? $root.Metric.ChartType[message.chartType] === $undefined ? message.chartType : $root.Metric.ChartType[message.chartType] : message.chartType;
        if (message.format != null && $Object.hasOwnProperty.call(message, "format"))
            object.format = message.format;
        if (message.deltaDescription != null && $Object.hasOwnProperty.call(message, "deltaDescription"))
            object.deltaDescription = message.deltaDescription;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        return object;
    };

    /**
     * Converts this Metric to JSON.
     * @function toJSON
     * @memberof Metric
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Metric.prototype.toJSON = function() {
        return Metric.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Metric
     * @function getTypeUrl
     * @memberof Metric
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Metric.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Metric";
    };

    /**
     * MetricDirection enum.
     * @name Metric.MetricDirection
     * @enum {number}
     * @property {number} DOWN=0 DOWN value
     * @property {number} UP=1 UP value
     * @property {number} NONE=2 NONE value
     */
    Metric.MetricDirection = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "DOWN"] = 0;
        values[valuesById[1] = "UP"] = 1;
        values[valuesById[2] = "NONE"] = 2;
        return values;
    })();

    /**
     * MetricColor enum.
     * @name Metric.MetricColor
     * @enum {number}
     * @property {number} RED=0 RED value
     * @property {number} GREEN=1 GREEN value
     * @property {number} GRAY=2 GRAY value
     * @property {number} ORANGE=3 ORANGE value
     * @property {number} YELLOW=4 YELLOW value
     * @property {number} BLUE=5 BLUE value
     * @property {number} VIOLET=6 VIOLET value
     * @property {number} PRIMARY=7 PRIMARY value
     */
    Metric.MetricColor = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "RED"] = 0;
        values[valuesById[1] = "GREEN"] = 1;
        values[valuesById[2] = "GRAY"] = 2;
        values[valuesById[3] = "ORANGE"] = 3;
        values[valuesById[4] = "YELLOW"] = 4;
        values[valuesById[5] = "BLUE"] = 5;
        values[valuesById[6] = "VIOLET"] = 6;
        values[valuesById[7] = "PRIMARY"] = 7;
        return values;
    })();

    /**
     * ChartType enum.
     * @name Metric.ChartType
     * @enum {number}
     * @property {number} LINE=0 LINE value
     * @property {number} BAR=1 BAR value
     * @property {number} AREA=2 AREA value
     */
    Metric.ChartType = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "LINE"] = 0;
        values[valuesById[1] = "BAR"] = 1;
        values[valuesById[2] = "AREA"] = 2;
        return values;
    })();

    return Metric;
})();

export const MultiSelect = $root.MultiSelect = (() => {

    /**
     * Properties of a MultiSelect.
     * @typedef {Object} MultiSelect.$Properties
     * @property {string|null} [id] MultiSelect id
     * @property {string|null} [label] MultiSelect label
     * @property {Array.<number>|null} ["default"] MultiSelect default
     * @property {Array.<string>|null} [options] MultiSelect options
     * @property {string|null} [help] MultiSelect help
     * @property {string|null} [formId] MultiSelect formId
     * @property {Array.<string>|null} [rawValues] MultiSelect rawValues
     * @property {boolean|null} [setValue] MultiSelect setValue
     * @property {boolean|null} [disabled] MultiSelect disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] MultiSelect labelVisibility
     * @property {number|null} [maxSelections] MultiSelect maxSelections
     * @property {string|null} [placeholder] MultiSelect placeholder
     * @property {boolean|null} [acceptNewOptions] MultiSelect acceptNewOptions
     * @property {string|null} [queryParamKey] MultiSelect queryParamKey
     * @property {streamlit.SelectWidgetFilterMode|null} [filterMode] MultiSelect filterMode
     * @property {boolean|null} [wrap] MultiSelect wrap
     * @property {number|null} [selectAll] MultiSelect selectAll
     * @property {boolean|null} [ignoreRerun] MultiSelect ignoreRerun
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a MultiSelect.
     * @exports IMultiSelect
     * @interface IMultiSelect
     * @augments MultiSelect.$Properties
     * @deprecated Use MultiSelect.$Properties instead.
     */

    /**
     * Shape of a MultiSelect.
     * @typedef {MultiSelect.$Properties} MultiSelect.$Shape
     */

    /**
     * Constructs a new MultiSelect.
     * @exports MultiSelect
     * @classdesc Represents a MultiSelect.
     * @constructor
     * @param {MultiSelect.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const MultiSelect = function (properties) {
        this["default"] = [];
        this.options = [];
        this.rawValues = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * MultiSelect id.
     * @member {string} id
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.id = "";

    /**
     * MultiSelect label.
     * @member {string} label
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.label = "";

    /**
     * MultiSelect default.
     * @member {Array.<number>} default
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype["default"] = $util.emptyArray;

    /**
     * MultiSelect options.
     * @member {Array.<string>} options
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.options = $util.emptyArray;

    /**
     * MultiSelect help.
     * @member {string} help
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.help = "";

    /**
     * MultiSelect formId.
     * @member {string} formId
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.formId = "";

    /**
     * MultiSelect rawValues.
     * @member {Array.<string>} rawValues
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.rawValues = $util.emptyArray;

    /**
     * MultiSelect setValue.
     * @member {boolean} setValue
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.setValue = false;

    /**
     * MultiSelect disabled.
     * @member {boolean} disabled
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.disabled = false;

    /**
     * MultiSelect labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.labelVisibility = null;

    /**
     * MultiSelect maxSelections.
     * @member {number} maxSelections
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.maxSelections = 0;

    /**
     * MultiSelect placeholder.
     * @member {string} placeholder
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.placeholder = "";

    /**
     * MultiSelect acceptNewOptions.
     * @member {boolean|null|undefined} acceptNewOptions
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.acceptNewOptions = null;

    /**
     * MultiSelect queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.queryParamKey = null;

    /**
     * MultiSelect filterMode.
     * @member {streamlit.SelectWidgetFilterMode} filterMode
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.filterMode = 0;

    /**
     * MultiSelect wrap.
     * @member {boolean|null|undefined} wrap
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.wrap = null;

    /**
     * MultiSelect selectAll.
     * @member {number|null|undefined} selectAll
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.selectAll = null;

    /**
     * MultiSelect ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof MultiSelect
     * @instance
     */
    MultiSelect.prototype.ignoreRerun = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(MultiSelect.prototype, "_acceptNewOptions", {
        get: $util.oneOfGetter($oneOfFields = ["acceptNewOptions"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(MultiSelect.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(MultiSelect.prototype, "_wrap", {
        get: $util.oneOfGetter($oneOfFields = ["wrap"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(MultiSelect.prototype, "_selectAll", {
        get: $util.oneOfGetter($oneOfFields = ["selectAll"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new MultiSelect instance using the specified properties.
     * @function create
     * @memberof MultiSelect
     * @static
     * @param {MultiSelect.$Properties=} [properties] Properties to set
     * @returns {MultiSelect} MultiSelect instance
     * @type {{
     *   (properties: MultiSelect.$Shape): MultiSelect & MultiSelect.$Shape;
     *   (properties?: MultiSelect.$Properties): MultiSelect;
     * }}
     */
    MultiSelect.create = function(properties) {
        return new MultiSelect(properties);
    };

    /**
     * Encodes the specified MultiSelect message. Does not implicitly {@link MultiSelect.verify|verify} messages.
     * @function encode
     * @memberof MultiSelect
     * @static
     * @param {MultiSelect.$Properties} message MultiSelect message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MultiSelect.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && message["default"].length)
            writer.uint32(/* id 3, wireType 2 =*/26).int32s(message["default"]);
        if (message.options != null && message.options.length)
            for (let i = 0; i < message.options.length; ++i)
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.options[i]);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.formId);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.setValue);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 10, wireType 2 =*/82).fork(), _depth + 1).ldelim();
        if (message.maxSelections != null && $Object.hasOwnProperty.call(message, "maxSelections") && message.maxSelections !== 0)
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.maxSelections);
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder") && message.placeholder !== "")
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.placeholder);
        if (message.acceptNewOptions != null && $Object.hasOwnProperty.call(message, "acceptNewOptions"))
            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.acceptNewOptions);
        if (message.rawValues != null && message.rawValues.length)
            for (let i = 0; i < message.rawValues.length; ++i)
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.rawValues[i]);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.queryParamKey);
        if (message.filterMode != null && $Object.hasOwnProperty.call(message, "filterMode") && message.filterMode !== 0)
            writer.uint32(/* id 16, wireType 0 =*/128).int32(message.filterMode);
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            writer.uint32(/* id 17, wireType 0 =*/136).bool(message.wrap);
        if (message.selectAll != null && $Object.hasOwnProperty.call(message, "selectAll"))
            writer.uint32(/* id 18, wireType 0 =*/144).int32(message.selectAll);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 19, wireType 0 =*/152).bool(message.ignoreRerun);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a MultiSelect message from the specified reader or buffer.
     * @function decode
     * @memberof MultiSelect
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MultiSelect & MultiSelect.$Shape} MultiSelect
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MultiSelect.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.MultiSelect();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType === 2) {
                        if (!(message["default"] && message["default"].length))
                            message["default"] = [];
                        reader.int32s(message["default"]);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message["default"] && message["default"].length))
                        message["default"] = [];
                    message["default"].push(reader.int32());
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if (!(message.options && message.options.length))
                        message.options = [];
                    message.options.push(reader.stringVerify());
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    if (!(message.rawValues && message.rawValues.length))
                        message.rawValues = [];
                    message.rawValues.push(reader.stringVerify());
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 11: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.maxSelections = value;
                    else
                        delete message.maxSelections;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.placeholder = value;
                    else
                        delete message.placeholder;
                    continue;
                }
            case 13: {
                    if (wireType !== 0)
                        break;
                    message.acceptNewOptions = reader.bool();
                    message._acceptNewOptions = "acceptNewOptions";
                    continue;
                }
            case 15: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 16: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.filterMode = value;
                    else
                        delete message.filterMode;
                    continue;
                }
            case 17: {
                    if (wireType !== 0)
                        break;
                    message.wrap = reader.bool();
                    message._wrap = "wrap";
                    continue;
                }
            case 18: {
                    if (wireType !== 0)
                        break;
                    message.selectAll = reader.int32();
                    message._selectAll = "selectAll";
                    continue;
                }
            case 19: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a MultiSelect message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MultiSelect
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MultiSelect} MultiSelect
     */
    MultiSelect.fromObject = function (object, _depth) {
        if (object instanceof $root.MultiSelect)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".MultiSelect: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.MultiSelect();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"]) {
            if (!$Array.isArray(object["default"]))
                throw $TypeError(".MultiSelect.default: array expected");
            message["default"] = $Array(object["default"].length);
            for (let i = 0; i < object["default"].length; ++i)
                message["default"][i] = object["default"][i] | 0;
        }
        if (object.options) {
            if (!$Array.isArray(object.options))
                throw $TypeError(".MultiSelect.options: array expected");
            message.options = $Array(object.options.length);
            for (let i = 0; i < object.options.length; ++i)
                message.options[i] = $String(object.options[i]);
        }
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.rawValues) {
            if (!$Array.isArray(object.rawValues))
                throw $TypeError(".MultiSelect.rawValues: array expected");
            message.rawValues = $Array(object.rawValues.length);
            for (let i = 0; i < object.rawValues.length; ++i)
                message.rawValues[i] = $String(object.rawValues[i]);
        }
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".MultiSelect.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.maxSelections != null)
            if ($Number(object.maxSelections) !== 0)
                message.maxSelections = object.maxSelections | 0;
        if (object.placeholder != null)
            if (typeof object.placeholder !== "string" || object.placeholder.length)
                message.placeholder = $String(object.placeholder);
        if (object.acceptNewOptions != null)
            message.acceptNewOptions = $Boolean(object.acceptNewOptions);
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.filterMode !== 0 && (typeof object.filterMode !== "string" || $root.streamlit.SelectWidgetFilterMode[object.filterMode] !== 0))
            switch (object.filterMode) {
            case "FILTER_MODE_FUZZY":
            case 0:
                message.filterMode = 0;
                break;
            case "FILTER_MODE_CONTAINS":
            case 1:
                message.filterMode = 1;
                break;
            case "FILTER_MODE_PREFIX":
            case 2:
                message.filterMode = 2;
                break;
            case "FILTER_MODE_NONE":
            case 3:
                message.filterMode = 3;
                break;
            default:
                if (typeof object.filterMode === "number" && (object.filterMode | 0) === object.filterMode)
                    message.filterMode = object.filterMode;
            }
        if (object.wrap != null)
            message.wrap = $Boolean(object.wrap);
        if (object.selectAll != null)
            message.selectAll = object.selectAll | 0;
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        return message;
    };

    /**
     * Creates a plain object from a MultiSelect message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MultiSelect
     * @static
     * @param {MultiSelect} message MultiSelect
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MultiSelect.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object["default"] = [];
            object.options = [];
            object.rawValues = [];
        }
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.help = "";
            object.formId = "";
            object.setValue = false;
            object.disabled = false;
            object.labelVisibility = null;
            object.maxSelections = 0;
            object.placeholder = "";
            object.filterMode = options.enums === $String ? "FILTER_MODE_FUZZY" : 0;
            object.ignoreRerun = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] && message["default"].length) {
            object["default"] = $Array(message["default"].length);
            for (let j = 0; j < message["default"].length; ++j)
                object["default"][j] = message["default"][j];
        }
        if (message.options && message.options.length) {
            object.options = $Array(message.options.length);
            for (let j = 0; j < message.options.length; ++j)
                object.options[j] = message.options[j];
        }
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.maxSelections != null && $Object.hasOwnProperty.call(message, "maxSelections"))
            object.maxSelections = message.maxSelections;
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder"))
            object.placeholder = message.placeholder;
        if (message.acceptNewOptions != null && $Object.hasOwnProperty.call(message, "acceptNewOptions"))
            object.acceptNewOptions = message.acceptNewOptions;
        if (message.rawValues && message.rawValues.length) {
            object.rawValues = $Array(message.rawValues.length);
            for (let j = 0; j < message.rawValues.length; ++j)
                object.rawValues[j] = message.rawValues[j];
        }
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.filterMode != null && $Object.hasOwnProperty.call(message, "filterMode"))
            object.filterMode = options.enums === $String ? $root.streamlit.SelectWidgetFilterMode[message.filterMode] === $undefined ? message.filterMode : $root.streamlit.SelectWidgetFilterMode[message.filterMode] : message.filterMode;
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            object.wrap = message.wrap;
        if (message.selectAll != null && $Object.hasOwnProperty.call(message, "selectAll"))
            object.selectAll = message.selectAll;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        return object;
    };

    /**
     * Converts this MultiSelect to JSON.
     * @function toJSON
     * @memberof MultiSelect
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MultiSelect.prototype.toJSON = function() {
        return MultiSelect.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for MultiSelect
     * @function getTypeUrl
     * @memberof MultiSelect
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    MultiSelect.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/MultiSelect";
    };

    return MultiSelect;
})();

export const NumberInput = $root.NumberInput = (() => {

    /**
     * Properties of a NumberInput.
     * @typedef {Object} NumberInput.$Properties
     * @property {string|null} [id] NumberInput id
     * @property {string|null} [label] NumberInput label
     * @property {string|null} [formId] NumberInput formId
     * @property {string|null} [format] NumberInput format
     * @property {boolean|null} [hasMin] NumberInput hasMin
     * @property {boolean|null} [hasMax] NumberInput hasMax
     * @property {NumberInput.DataType|null} [dataType] NumberInput dataType
     * @property {number|null} ["default"] NumberInput default
     * @property {number|null} [step] NumberInput step
     * @property {number|null} [min] NumberInput min
     * @property {number|null} [max] NumberInput max
     * @property {string|null} [help] NumberInput help
     * @property {number|null} [value] NumberInput value
     * @property {boolean|null} [setValue] NumberInput setValue
     * @property {boolean|null} [disabled] NumberInput disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] NumberInput labelVisibility
     * @property {string|null} [placeholder] NumberInput placeholder
     * @property {string|null} [icon] NumberInput icon
     * @property {string|null} [queryParamKey] NumberInput queryParamKey
     * @property {boolean|null} [ignoreRerun] NumberInput ignoreRerun
     * @property {boolean|null} [required] NumberInput required
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a NumberInput.
     * @exports INumberInput
     * @interface INumberInput
     * @augments NumberInput.$Properties
     * @deprecated Use NumberInput.$Properties instead.
     */

    /**
     * Shape of a NumberInput.
     * @typedef {NumberInput.$Properties} NumberInput.$Shape
     */

    /**
     * Constructs a new NumberInput.
     * @exports NumberInput
     * @classdesc Represents a NumberInput.
     * @constructor
     * @param {NumberInput.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const NumberInput = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * NumberInput id.
     * @member {string} id
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.id = "";

    /**
     * NumberInput label.
     * @member {string} label
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.label = "";

    /**
     * NumberInput formId.
     * @member {string} formId
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.formId = "";

    /**
     * NumberInput format.
     * @member {string} format
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.format = "";

    /**
     * NumberInput hasMin.
     * @member {boolean} hasMin
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.hasMin = false;

    /**
     * NumberInput hasMax.
     * @member {boolean} hasMax
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.hasMax = false;

    /**
     * NumberInput dataType.
     * @member {NumberInput.DataType} dataType
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.dataType = 0;

    /**
     * NumberInput default.
     * @member {number|null|undefined} default
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype["default"] = null;

    /**
     * NumberInput step.
     * @member {number} step
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.step = 0;

    /**
     * NumberInput min.
     * @member {number} min
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.min = 0;

    /**
     * NumberInput max.
     * @member {number} max
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.max = 0;

    /**
     * NumberInput help.
     * @member {string} help
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.help = "";

    /**
     * NumberInput value.
     * @member {number|null|undefined} value
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.value = null;

    /**
     * NumberInput setValue.
     * @member {boolean} setValue
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.setValue = false;

    /**
     * NumberInput disabled.
     * @member {boolean} disabled
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.disabled = false;

    /**
     * NumberInput labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.labelVisibility = null;

    /**
     * NumberInput placeholder.
     * @member {string} placeholder
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.placeholder = "";

    /**
     * NumberInput icon.
     * @member {string} icon
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.icon = "";

    /**
     * NumberInput queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.queryParamKey = null;

    /**
     * NumberInput ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.ignoreRerun = false;

    /**
     * NumberInput required.
     * @member {boolean} required
     * @memberof NumberInput
     * @instance
     */
    NumberInput.prototype.required = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(NumberInput.prototype, "_default", {
        get: $util.oneOfGetter($oneOfFields = ["default"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(NumberInput.prototype, "_value", {
        get: $util.oneOfGetter($oneOfFields = ["value"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(NumberInput.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new NumberInput instance using the specified properties.
     * @function create
     * @memberof NumberInput
     * @static
     * @param {NumberInput.$Properties=} [properties] Properties to set
     * @returns {NumberInput} NumberInput instance
     * @type {{
     *   (properties: NumberInput.$Shape): NumberInput & NumberInput.$Shape;
     *   (properties?: NumberInput.$Properties): NumberInput;
     * }}
     */
    NumberInput.create = function(properties) {
        return new NumberInput(properties);
    };

    /**
     * Encodes the specified NumberInput message. Does not implicitly {@link NumberInput.verify|verify} messages.
     * @function encode
     * @memberof NumberInput
     * @static
     * @param {NumberInput.$Properties} message NumberInput message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NumberInput.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.formId);
        if (message.format != null && $Object.hasOwnProperty.call(message, "format") && message.format !== "")
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.format);
        if (message.hasMin != null && $Object.hasOwnProperty.call(message, "hasMin") && message.hasMin !== false)
            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.hasMin);
        if (message.hasMax != null && $Object.hasOwnProperty.call(message, "hasMax") && message.hasMax !== false)
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.hasMax);
        if (message.dataType != null && $Object.hasOwnProperty.call(message, "dataType") && message.dataType !== 0)
            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.dataType);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            writer.uint32(/* id 14, wireType 1 =*/113).double(message["default"]);
        if (message.step != null && $Object.hasOwnProperty.call(message, "step") && !$Object.is(message.step, 0))
            writer.uint32(/* id 15, wireType 1 =*/121).double(message.step);
        if (message.min != null && $Object.hasOwnProperty.call(message, "min") && !$Object.is(message.min, 0))
            writer.uint32(/* id 16, wireType 1 =*/129).double(message.min);
        if (message.max != null && $Object.hasOwnProperty.call(message, "max") && !$Object.is(message.max, 0))
            writer.uint32(/* id 17, wireType 1 =*/137).double(message.max);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.help);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 19, wireType 1 =*/153).double(message.value);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 20, wireType 0 =*/160).bool(message.setValue);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 21, wireType 0 =*/168).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 22, wireType 2 =*/178).fork(), _depth + 1).ldelim();
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder") && message.placeholder !== "")
            writer.uint32(/* id 23, wireType 2 =*/186).string(message.placeholder);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 24, wireType 2 =*/194).string(message.icon);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 25, wireType 2 =*/202).string(message.queryParamKey);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 26, wireType 0 =*/208).bool(message.ignoreRerun);
        if (message.required != null && $Object.hasOwnProperty.call(message, "required") && message.required !== false)
            writer.uint32(/* id 27, wireType 0 =*/216).bool(message.required);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a NumberInput message from the specified reader or buffer.
     * @function decode
     * @memberof NumberInput
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NumberInput & NumberInput.$Shape} NumberInput
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NumberInput.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.NumberInput();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.format = value;
                    else
                        delete message.format;
                    continue;
                }
            case 11: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hasMin = value;
                    else
                        delete message.hasMin;
                    continue;
                }
            case 12: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hasMax = value;
                    else
                        delete message.hasMax;
                    continue;
                }
            case 13: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.dataType = value;
                    else
                        delete message.dataType;
                    continue;
                }
            case 14: {
                    if (wireType !== 1)
                        break;
                    message["default"] = reader.double();
                    message._default = "default";
                    continue;
                }
            case 15: {
                    if (wireType !== 1)
                        break;
                    if (!$Object.is(value = reader.double(), 0))
                        message.step = value;
                    else
                        delete message.step;
                    continue;
                }
            case 16: {
                    if (wireType !== 1)
                        break;
                    if (!$Object.is(value = reader.double(), 0))
                        message.min = value;
                    else
                        delete message.min;
                    continue;
                }
            case 17: {
                    if (wireType !== 1)
                        break;
                    if (!$Object.is(value = reader.double(), 0))
                        message.max = value;
                    else
                        delete message.max;
                    continue;
                }
            case 18: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 19: {
                    if (wireType !== 1)
                        break;
                    message.value = reader.double();
                    message._value = "value";
                    continue;
                }
            case 20: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 21: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 22: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 23: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.placeholder = value;
                    else
                        delete message.placeholder;
                    continue;
                }
            case 24: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            case 25: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 26: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            case 27: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.required = value;
                    else
                        delete message.required;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a NumberInput message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NumberInput
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NumberInput} NumberInput
     */
    NumberInput.fromObject = function (object, _depth) {
        if (object instanceof $root.NumberInput)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".NumberInput: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.NumberInput();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.format != null)
            if (typeof object.format !== "string" || object.format.length)
                message.format = $String(object.format);
        if (object.hasMin != null)
            if (object.hasMin)
                message.hasMin = $Boolean(object.hasMin);
        if (object.hasMax != null)
            if (object.hasMax)
                message.hasMax = $Boolean(object.hasMax);
        if (object.dataType !== 0 && (typeof object.dataType !== "string" || $root.NumberInput.DataType[object.dataType] !== 0))
            switch (object.dataType) {
            case "INT":
            case 0:
                message.dataType = 0;
                break;
            case "FLOAT":
            case 1:
                message.dataType = 1;
                break;
            default:
                if (typeof object.dataType === "number" && (object.dataType | 0) === object.dataType)
                    message.dataType = object.dataType;
            }
        if (object["default"] != null)
            message["default"] = $Number(object["default"]);
        if (object.step != null)
            if (!$Object.is($Number(object.step), 0))
                message.step = $Number(object.step);
        if (object.min != null)
            if (!$Object.is($Number(object.min), 0))
                message.min = $Number(object.min);
        if (object.max != null)
            if (!$Object.is($Number(object.max), 0))
                message.max = $Number(object.max);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.value != null)
            message.value = $Number(object.value);
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".NumberInput.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.placeholder != null)
            if (typeof object.placeholder !== "string" || object.placeholder.length)
                message.placeholder = $String(object.placeholder);
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        if (object.required != null)
            if (object.required)
                message.required = $Boolean(object.required);
        return message;
    };

    /**
     * Creates a plain object from a NumberInput message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NumberInput
     * @static
     * @param {NumberInput} message NumberInput
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NumberInput.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.formId = "";
            object.format = "";
            object.hasMin = false;
            object.hasMax = false;
            object.dataType = options.enums === $String ? "INT" : 0;
            object.step = 0;
            object.min = 0;
            object.max = 0;
            object.help = "";
            object.setValue = false;
            object.disabled = false;
            object.labelVisibility = null;
            object.placeholder = "";
            object.icon = "";
            object.ignoreRerun = false;
            object.required = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.format != null && $Object.hasOwnProperty.call(message, "format"))
            object.format = message.format;
        if (message.hasMin != null && $Object.hasOwnProperty.call(message, "hasMin"))
            object.hasMin = message.hasMin;
        if (message.hasMax != null && $Object.hasOwnProperty.call(message, "hasMax"))
            object.hasMax = message.hasMax;
        if (message.dataType != null && $Object.hasOwnProperty.call(message, "dataType"))
            object.dataType = options.enums === $String ? $root.NumberInput.DataType[message.dataType] === $undefined ? message.dataType : $root.NumberInput.DataType[message.dataType] : message.dataType;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = options.json && !$isFinite(message["default"]) ? $String(message["default"]) : message["default"];
        if (message.step != null && $Object.hasOwnProperty.call(message, "step"))
            object.step = options.json && !$isFinite(message.step) ? $String(message.step) : message.step;
        if (message.min != null && $Object.hasOwnProperty.call(message, "min"))
            object.min = options.json && !$isFinite(message.min) ? $String(message.min) : message.min;
        if (message.max != null && $Object.hasOwnProperty.call(message, "max"))
            object.max = options.json && !$isFinite(message.max) ? $String(message.max) : message.max;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = options.json && !$isFinite(message.value) ? $String(message.value) : message.value;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder"))
            object.placeholder = message.placeholder;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        if (message.required != null && $Object.hasOwnProperty.call(message, "required"))
            object.required = message.required;
        return object;
    };

    /**
     * Converts this NumberInput to JSON.
     * @function toJSON
     * @memberof NumberInput
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NumberInput.prototype.toJSON = function() {
        return NumberInput.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for NumberInput
     * @function getTypeUrl
     * @memberof NumberInput
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    NumberInput.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/NumberInput";
    };

    /**
     * DataType enum.
     * @name NumberInput.DataType
     * @enum {number}
     * @property {number} INT=0 INT value
     * @property {number} FLOAT=1 FLOAT value
     */
    NumberInput.DataType = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "INT"] = 0;
        values[valuesById[1] = "FLOAT"] = 1;
        return values;
    })();

    return NumberInput;
})();

export const PageLink = $root.PageLink = (() => {

    /**
     * Properties of a PageLink.
     * @typedef {Object} PageLink.$Properties
     * @property {string|null} [page] PageLink page
     * @property {string|null} [label] PageLink label
     * @property {string|null} [icon] PageLink icon
     * @property {string|null} [pageScriptHash] PageLink pageScriptHash
     * @property {string|null} [help] PageLink help
     * @property {boolean|null} [useContainerWidth] PageLink useContainerWidth
     * @property {boolean|null} [disabled] PageLink disabled
     * @property {boolean|null} [external] PageLink external
     * @property {string|null} [queryString] PageLink queryString
     * @property {streamlit.ButtonLikeIconPosition|null} [iconPosition] PageLink iconPosition
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a PageLink.
     * @exports IPageLink
     * @interface IPageLink
     * @augments PageLink.$Properties
     * @deprecated Use PageLink.$Properties instead.
     */

    /**
     * Shape of a PageLink.
     * @typedef {PageLink.$Properties} PageLink.$Shape
     */

    /**
     * Constructs a new PageLink.
     * @exports PageLink
     * @classdesc Represents a PageLink.
     * @constructor
     * @param {PageLink.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const PageLink = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * PageLink page.
     * @member {string} page
     * @memberof PageLink
     * @instance
     */
    PageLink.prototype.page = "";

    /**
     * PageLink label.
     * @member {string} label
     * @memberof PageLink
     * @instance
     */
    PageLink.prototype.label = "";

    /**
     * PageLink icon.
     * @member {string} icon
     * @memberof PageLink
     * @instance
     */
    PageLink.prototype.icon = "";

    /**
     * PageLink pageScriptHash.
     * @member {string} pageScriptHash
     * @memberof PageLink
     * @instance
     */
    PageLink.prototype.pageScriptHash = "";

    /**
     * PageLink help.
     * @member {string} help
     * @memberof PageLink
     * @instance
     */
    PageLink.prototype.help = "";

    /**
     * PageLink useContainerWidth.
     * @member {boolean|null|undefined} useContainerWidth
     * @memberof PageLink
     * @instance
     */
    PageLink.prototype.useContainerWidth = null;

    /**
     * PageLink disabled.
     * @member {boolean} disabled
     * @memberof PageLink
     * @instance
     */
    PageLink.prototype.disabled = false;

    /**
     * PageLink external.
     * @member {boolean} external
     * @memberof PageLink
     * @instance
     */
    PageLink.prototype.external = false;

    /**
     * PageLink queryString.
     * @member {string} queryString
     * @memberof PageLink
     * @instance
     */
    PageLink.prototype.queryString = "";

    /**
     * PageLink iconPosition.
     * @member {streamlit.ButtonLikeIconPosition} iconPosition
     * @memberof PageLink
     * @instance
     */
    PageLink.prototype.iconPosition = 0;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(PageLink.prototype, "_useContainerWidth", {
        get: $util.oneOfGetter($oneOfFields = ["useContainerWidth"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new PageLink instance using the specified properties.
     * @function create
     * @memberof PageLink
     * @static
     * @param {PageLink.$Properties=} [properties] Properties to set
     * @returns {PageLink} PageLink instance
     * @type {{
     *   (properties: PageLink.$Shape): PageLink & PageLink.$Shape;
     *   (properties?: PageLink.$Properties): PageLink;
     * }}
     */
    PageLink.create = function(properties) {
        return new PageLink(properties);
    };

    /**
     * Encodes the specified PageLink message. Does not implicitly {@link PageLink.verify|verify} messages.
     * @function encode
     * @memberof PageLink
     * @static
     * @param {PageLink.$Properties} message PageLink message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageLink.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.page != null && $Object.hasOwnProperty.call(message, "page") && message.page !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.page);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.icon);
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash") && message.pageScriptHash !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageScriptHash);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.help);
        if (message.useContainerWidth != null && $Object.hasOwnProperty.call(message, "useContainerWidth"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.useContainerWidth);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.disabled);
        if (message.external != null && $Object.hasOwnProperty.call(message, "external") && message.external !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.external);
        if (message.queryString != null && $Object.hasOwnProperty.call(message, "queryString") && message.queryString !== "")
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.queryString);
        if (message.iconPosition != null && $Object.hasOwnProperty.call(message, "iconPosition") && message.iconPosition !== 0)
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.iconPosition);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a PageLink message from the specified reader or buffer.
     * @function decode
     * @memberof PageLink
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PageLink & PageLink.$Shape} PageLink
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageLink.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.PageLink();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.page = value;
                    else
                        delete message.page;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pageScriptHash = value;
                    else
                        delete message.pageScriptHash;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    message.useContainerWidth = reader.bool();
                    message._useContainerWidth = "useContainerWidth";
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.external = value;
                    else
                        delete message.external;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.queryString = value;
                    else
                        delete message.queryString;
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.iconPosition = value;
                    else
                        delete message.iconPosition;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a PageLink message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PageLink
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PageLink} PageLink
     */
    PageLink.fromObject = function (object, _depth) {
        if (object instanceof $root.PageLink)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".PageLink: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.PageLink();
        if (object.page != null)
            if (typeof object.page !== "string" || object.page.length)
                message.page = $String(object.page);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        if (object.pageScriptHash != null)
            if (typeof object.pageScriptHash !== "string" || object.pageScriptHash.length)
                message.pageScriptHash = $String(object.pageScriptHash);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.useContainerWidth != null)
            message.useContainerWidth = $Boolean(object.useContainerWidth);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.external != null)
            if (object.external)
                message.external = $Boolean(object.external);
        if (object.queryString != null)
            if (typeof object.queryString !== "string" || object.queryString.length)
                message.queryString = $String(object.queryString);
        if (object.iconPosition !== 0 && (typeof object.iconPosition !== "string" || $root.streamlit.ButtonLikeIconPosition[object.iconPosition] !== 0))
            switch (object.iconPosition) {
            case "LEFT":
            case 0:
                message.iconPosition = 0;
                break;
            case "RIGHT":
            case 1:
                message.iconPosition = 1;
                break;
            default:
                if (typeof object.iconPosition === "number" && (object.iconPosition | 0) === object.iconPosition)
                    message.iconPosition = object.iconPosition;
            }
        return message;
    };

    /**
     * Creates a plain object from a PageLink message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PageLink
     * @static
     * @param {PageLink} message PageLink
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PageLink.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.page = "";
            object.label = "";
            object.icon = "";
            object.pageScriptHash = "";
            object.help = "";
            object.disabled = false;
            object.external = false;
            object.queryString = "";
            object.iconPosition = options.enums === $String ? "LEFT" : 0;
        }
        if (message.page != null && $Object.hasOwnProperty.call(message, "page"))
            object.page = message.page;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash"))
            object.pageScriptHash = message.pageScriptHash;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.useContainerWidth != null && $Object.hasOwnProperty.call(message, "useContainerWidth"))
            object.useContainerWidth = message.useContainerWidth;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.external != null && $Object.hasOwnProperty.call(message, "external"))
            object.external = message.external;
        if (message.queryString != null && $Object.hasOwnProperty.call(message, "queryString"))
            object.queryString = message.queryString;
        if (message.iconPosition != null && $Object.hasOwnProperty.call(message, "iconPosition"))
            object.iconPosition = options.enums === $String ? $root.streamlit.ButtonLikeIconPosition[message.iconPosition] === $undefined ? message.iconPosition : $root.streamlit.ButtonLikeIconPosition[message.iconPosition] : message.iconPosition;
        return object;
    };

    /**
     * Converts this PageLink to JSON.
     * @function toJSON
     * @memberof PageLink
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PageLink.prototype.toJSON = function() {
        return PageLink.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for PageLink
     * @function getTypeUrl
     * @memberof PageLink
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    PageLink.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/PageLink";
    };

    return PageLink;
})();

export const Pagination = $root.Pagination = (() => {

    /**
     * Properties of a Pagination.
     * @typedef {Object} Pagination.$Properties
     * @property {string|null} [id] Pagination id
     * @property {number|null} [numPages] Pagination numPages
     * @property {number|null} ["default"] Pagination default
     * @property {number|null} [maxVisiblePages] Pagination maxVisiblePages
     * @property {boolean|null} [disabled] Pagination disabled
     * @property {string|null} [formId] Pagination formId
     * @property {number|null} [value] Pagination value
     * @property {boolean|null} [setValue] Pagination setValue
     * @property {string|null} [queryParamKey] Pagination queryParamKey
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Pagination.
     * @exports IPagination
     * @interface IPagination
     * @augments Pagination.$Properties
     * @deprecated Use Pagination.$Properties instead.
     */

    /**
     * Shape of a Pagination.
     * @typedef {Pagination.$Properties} Pagination.$Shape
     */

    /**
     * Constructs a new Pagination.
     * @exports Pagination
     * @classdesc Represents a Pagination.
     * @constructor
     * @param {Pagination.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Pagination = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Pagination id.
     * @member {string} id
     * @memberof Pagination
     * @instance
     */
    Pagination.prototype.id = "";

    /**
     * Pagination numPages.
     * @member {number} numPages
     * @memberof Pagination
     * @instance
     */
    Pagination.prototype.numPages = 0;

    /**
     * Pagination default.
     * @member {number} default
     * @memberof Pagination
     * @instance
     */
    Pagination.prototype["default"] = 0;

    /**
     * Pagination maxVisiblePages.
     * @member {number|null|undefined} maxVisiblePages
     * @memberof Pagination
     * @instance
     */
    Pagination.prototype.maxVisiblePages = null;

    /**
     * Pagination disabled.
     * @member {boolean} disabled
     * @memberof Pagination
     * @instance
     */
    Pagination.prototype.disabled = false;

    /**
     * Pagination formId.
     * @member {string} formId
     * @memberof Pagination
     * @instance
     */
    Pagination.prototype.formId = "";

    /**
     * Pagination value.
     * @member {number} value
     * @memberof Pagination
     * @instance
     */
    Pagination.prototype.value = 0;

    /**
     * Pagination setValue.
     * @member {boolean} setValue
     * @memberof Pagination
     * @instance
     */
    Pagination.prototype.setValue = false;

    /**
     * Pagination queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof Pagination
     * @instance
     */
    Pagination.prototype.queryParamKey = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Pagination.prototype, "_maxVisiblePages", {
        get: $util.oneOfGetter($oneOfFields = ["maxVisiblePages"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Pagination.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Pagination instance using the specified properties.
     * @function create
     * @memberof Pagination
     * @static
     * @param {Pagination.$Properties=} [properties] Properties to set
     * @returns {Pagination} Pagination instance
     * @type {{
     *   (properties: Pagination.$Shape): Pagination & Pagination.$Shape;
     *   (properties?: Pagination.$Properties): Pagination;
     * }}
     */
    Pagination.create = function(properties) {
        return new Pagination(properties);
    };

    /**
     * Encodes the specified Pagination message. Does not implicitly {@link Pagination.verify|verify} messages.
     * @function encode
     * @memberof Pagination
     * @static
     * @param {Pagination.$Properties} message Pagination message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Pagination.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.numPages != null && $Object.hasOwnProperty.call(message, "numPages") && message.numPages !== 0)
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.numPages);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default") && message["default"] !== 0)
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message["default"]);
        if (message.maxVisiblePages != null && $Object.hasOwnProperty.call(message, "maxVisiblePages"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.maxVisiblePages);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.disabled);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.formId);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value") && message.value !== 0)
            writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.value);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.setValue);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.queryParamKey);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Pagination message from the specified reader or buffer.
     * @function decode
     * @memberof Pagination
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Pagination & Pagination.$Shape} Pagination
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Pagination.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Pagination();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message.numPages = value;
                    else
                        delete message.numPages;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message["default"] = value;
                    else
                        delete message["default"];
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    message.maxVisiblePages = reader.uint32();
                    message._maxVisiblePages = "maxVisiblePages";
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message.value = value;
                    else
                        delete message.value;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Pagination message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Pagination
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Pagination} Pagination
     */
    Pagination.fromObject = function (object, _depth) {
        if (object instanceof $root.Pagination)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Pagination: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Pagination();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.numPages != null)
            if ($Number(object.numPages) !== 0)
                message.numPages = object.numPages >>> 0;
        if (object["default"] != null)
            if ($Number(object["default"]) !== 0)
                message["default"] = object["default"] >>> 0;
        if (object.maxVisiblePages != null)
            message.maxVisiblePages = object.maxVisiblePages >>> 0;
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.value != null)
            if ($Number(object.value) !== 0)
                message.value = object.value >>> 0;
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        return message;
    };

    /**
     * Creates a plain object from a Pagination message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Pagination
     * @static
     * @param {Pagination} message Pagination
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Pagination.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.numPages = 0;
            object["default"] = 0;
            object.disabled = false;
            object.formId = "";
            object.value = 0;
            object.setValue = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.numPages != null && $Object.hasOwnProperty.call(message, "numPages"))
            object.numPages = message.numPages;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.maxVisiblePages != null && $Object.hasOwnProperty.call(message, "maxVisiblePages"))
            object.maxVisiblePages = message.maxVisiblePages;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = message.value;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        return object;
    };

    /**
     * Converts this Pagination to JSON.
     * @function toJSON
     * @memberof Pagination
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Pagination.prototype.toJSON = function() {
        return Pagination.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Pagination
     * @function getTypeUrl
     * @memberof Pagination
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Pagination.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Pagination";
    };

    return Pagination;
})();

export const PlotlyChart = $root.PlotlyChart = (() => {

    /**
     * Properties of a PlotlyChart.
     * @typedef {Object} PlotlyChart.$Properties
     * @property {string|null} [theme] PlotlyChart theme
     * @property {string|null} [id] PlotlyChart id
     * @property {Array.<PlotlyChart.SelectionMode>|null} [selectionMode] PlotlyChart selectionMode
     * @property {string|null} [formId] PlotlyChart formId
     * @property {string|null} [spec] PlotlyChart spec
     * @property {string|null} [config] PlotlyChart config
     * @property {string|null} [alt] PlotlyChart alt
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a PlotlyChart.
     * @exports IPlotlyChart
     * @interface IPlotlyChart
     * @augments PlotlyChart.$Properties
     * @deprecated Use PlotlyChart.$Properties instead.
     */

    /**
     * Shape of a PlotlyChart.
     * @typedef {PlotlyChart.$Properties} PlotlyChart.$Shape
     */

    /**
     * Constructs a new PlotlyChart.
     * @exports PlotlyChart
     * @classdesc Represents a PlotlyChart.
     * @constructor
     * @param {PlotlyChart.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const PlotlyChart = function (properties) {
        this.selectionMode = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * PlotlyChart theme.
     * @member {string} theme
     * @memberof PlotlyChart
     * @instance
     */
    PlotlyChart.prototype.theme = "";

    /**
     * PlotlyChart id.
     * @member {string} id
     * @memberof PlotlyChart
     * @instance
     */
    PlotlyChart.prototype.id = "";

    /**
     * PlotlyChart selectionMode.
     * @member {Array.<PlotlyChart.SelectionMode>} selectionMode
     * @memberof PlotlyChart
     * @instance
     */
    PlotlyChart.prototype.selectionMode = $util.emptyArray;

    /**
     * PlotlyChart formId.
     * @member {string} formId
     * @memberof PlotlyChart
     * @instance
     */
    PlotlyChart.prototype.formId = "";

    /**
     * PlotlyChart spec.
     * @member {string} spec
     * @memberof PlotlyChart
     * @instance
     */
    PlotlyChart.prototype.spec = "";

    /**
     * PlotlyChart config.
     * @member {string} config
     * @memberof PlotlyChart
     * @instance
     */
    PlotlyChart.prototype.config = "";

    /**
     * PlotlyChart alt.
     * @member {string|null|undefined} alt
     * @memberof PlotlyChart
     * @instance
     */
    PlotlyChart.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(PlotlyChart.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new PlotlyChart instance using the specified properties.
     * @function create
     * @memberof PlotlyChart
     * @static
     * @param {PlotlyChart.$Properties=} [properties] Properties to set
     * @returns {PlotlyChart} PlotlyChart instance
     * @type {{
     *   (properties: PlotlyChart.$Shape): PlotlyChart & PlotlyChart.$Shape;
     *   (properties?: PlotlyChart.$Properties): PlotlyChart;
     * }}
     */
    PlotlyChart.create = function(properties) {
        return new PlotlyChart(properties);
    };

    /**
     * Encodes the specified PlotlyChart message. Does not implicitly {@link PlotlyChart.verify|verify} messages.
     * @function encode
     * @memberof PlotlyChart
     * @static
     * @param {PlotlyChart.$Properties} message PlotlyChart message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlotlyChart.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.theme != null && $Object.hasOwnProperty.call(message, "theme") && message.theme !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.theme);
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.id);
        if (message.selectionMode != null && message.selectionMode.length)
            writer.uint32(/* id 8, wireType 2 =*/66).int32s(message.selectionMode);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.formId);
        if (message.spec != null && $Object.hasOwnProperty.call(message, "spec") && message.spec !== "")
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.spec);
        if (message.config != null && $Object.hasOwnProperty.call(message, "config") && message.config !== "")
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.config);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a PlotlyChart message from the specified reader or buffer.
     * @function decode
     * @memberof PlotlyChart
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlotlyChart & PlotlyChart.$Shape} PlotlyChart
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlotlyChart.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.PlotlyChart();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.theme = value;
                    else
                        delete message.theme;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 8: {
                    if (wireType === 2) {
                        if (!(message.selectionMode && message.selectionMode.length))
                            message.selectionMode = [];
                        reader.int32s(message.selectionMode);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message.selectionMode && message.selectionMode.length))
                        message.selectionMode = [];
                    message.selectionMode.push(reader.int32());
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.spec = value;
                    else
                        delete message.spec;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.config = value;
                    else
                        delete message.config;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a PlotlyChart message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlotlyChart
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlotlyChart} PlotlyChart
     */
    PlotlyChart.fromObject = function (object, _depth) {
        if (object instanceof $root.PlotlyChart)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".PlotlyChart: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.PlotlyChart();
        if (object.theme != null)
            if (typeof object.theme !== "string" || object.theme.length)
                message.theme = $String(object.theme);
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.selectionMode) {
            if (!$Array.isArray(object.selectionMode))
                throw $TypeError(".PlotlyChart.selectionMode: array expected");
            message.selectionMode = [];
            for (let i = 0; i < object.selectionMode.length; ++i)
                switch (object.selectionMode[i]) {
                case "POINTS":
                case 0:
                    message.selectionMode[message.selectionMode.length] = 0;
                    break;
                case "BOX":
                case 1:
                    message.selectionMode[message.selectionMode.length] = 1;
                    break;
                case "LASSO":
                case 2:
                    message.selectionMode[message.selectionMode.length] = 2;
                    break;
                default:
                    if (typeof object.selectionMode[i] === "number" && (object.selectionMode[i] | 0) === object.selectionMode[i])
                        message.selectionMode[message.selectionMode.length] = object.selectionMode[i];
                }
        }
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.spec != null)
            if (typeof object.spec !== "string" || object.spec.length)
                message.spec = $String(object.spec);
        if (object.config != null)
            if (typeof object.config !== "string" || object.config.length)
                message.config = $String(object.config);
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from a PlotlyChart message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlotlyChart
     * @static
     * @param {PlotlyChart} message PlotlyChart
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlotlyChart.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.selectionMode = [];
        if (options.defaults) {
            object.theme = "";
            object.id = "";
            object.formId = "";
            object.spec = "";
            object.config = "";
        }
        if (message.theme != null && $Object.hasOwnProperty.call(message, "theme"))
            object.theme = message.theme;
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.selectionMode && message.selectionMode.length) {
            object.selectionMode = $Array(message.selectionMode.length);
            for (let j = 0; j < message.selectionMode.length; ++j)
                object.selectionMode[j] = options.enums === $String ? $root.PlotlyChart.SelectionMode[message.selectionMode[j]] === $undefined ? message.selectionMode[j] : $root.PlotlyChart.SelectionMode[message.selectionMode[j]] : message.selectionMode[j];
        }
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.spec != null && $Object.hasOwnProperty.call(message, "spec"))
            object.spec = message.spec;
        if (message.config != null && $Object.hasOwnProperty.call(message, "config"))
            object.config = message.config;
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this PlotlyChart to JSON.
     * @function toJSON
     * @memberof PlotlyChart
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlotlyChart.prototype.toJSON = function() {
        return PlotlyChart.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for PlotlyChart
     * @function getTypeUrl
     * @memberof PlotlyChart
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    PlotlyChart.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/PlotlyChart";
    };

    /**
     * SelectionMode enum.
     * @name PlotlyChart.SelectionMode
     * @enum {number}
     * @property {number} POINTS=0 POINTS value
     * @property {number} BOX=1 BOX value
     * @property {number} LASSO=2 LASSO value
     */
    PlotlyChart.SelectionMode = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "POINTS"] = 0;
        values[valuesById[1] = "BOX"] = 1;
        values[valuesById[2] = "LASSO"] = 2;
        return values;
    })();

    return PlotlyChart;
})();

export const Progress = $root.Progress = (() => {

    /**
     * Properties of a Progress.
     * @typedef {Object} Progress.$Properties
     * @property {number|null} [value] Progress value
     * @property {string|null} [text] Progress text
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Progress.
     * @exports IProgress
     * @interface IProgress
     * @augments Progress.$Properties
     * @deprecated Use Progress.$Properties instead.
     */

    /**
     * Shape of a Progress.
     * @typedef {Progress.$Properties} Progress.$Shape
     */

    /**
     * Constructs a new Progress.
     * @exports Progress
     * @classdesc Represents a Progress.
     * @constructor
     * @param {Progress.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Progress = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Progress value.
     * @member {number} value
     * @memberof Progress
     * @instance
     */
    Progress.prototype.value = 0;

    /**
     * Progress text.
     * @member {string} text
     * @memberof Progress
     * @instance
     */
    Progress.prototype.text = "";

    /**
     * Creates a new Progress instance using the specified properties.
     * @function create
     * @memberof Progress
     * @static
     * @param {Progress.$Properties=} [properties] Properties to set
     * @returns {Progress} Progress instance
     * @type {{
     *   (properties: Progress.$Shape): Progress & Progress.$Shape;
     *   (properties?: Progress.$Properties): Progress;
     * }}
     */
    Progress.create = function(properties) {
        return new Progress(properties);
    };

    /**
     * Encodes the specified Progress message. Does not implicitly {@link Progress.verify|verify} messages.
     * @function encode
     * @memberof Progress
     * @static
     * @param {Progress.$Properties} message Progress message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Progress.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.value != null && $Object.hasOwnProperty.call(message, "value") && message.value !== 0)
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.value);
        if (message.text != null && $Object.hasOwnProperty.call(message, "text") && message.text !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.text);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Progress message from the specified reader or buffer.
     * @function decode
     * @memberof Progress
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Progress & Progress.$Shape} Progress
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Progress.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Progress();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message.value = value;
                    else
                        delete message.value;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.text = value;
                    else
                        delete message.text;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Progress message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Progress
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Progress} Progress
     */
    Progress.fromObject = function (object, _depth) {
        if (object instanceof $root.Progress)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Progress: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Progress();
        if (object.value != null)
            if ($Number(object.value) !== 0)
                message.value = object.value >>> 0;
        if (object.text != null)
            if (typeof object.text !== "string" || object.text.length)
                message.text = $String(object.text);
        return message;
    };

    /**
     * Creates a plain object from a Progress message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Progress
     * @static
     * @param {Progress} message Progress
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Progress.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.value = 0;
            object.text = "";
        }
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = message.value;
        if (message.text != null && $Object.hasOwnProperty.call(message, "text"))
            object.text = message.text;
        return object;
    };

    /**
     * Converts this Progress to JSON.
     * @function toJSON
     * @memberof Progress
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Progress.prototype.toJSON = function() {
        return Progress.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Progress
     * @function getTypeUrl
     * @memberof Progress
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Progress.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Progress";
    };

    return Progress;
})();

export const Radio = $root.Radio = (() => {

    /**
     * Properties of a Radio.
     * @typedef {Object} Radio.$Properties
     * @property {string|null} [id] Radio id
     * @property {string|null} [label] Radio label
     * @property {number|null} ["default"] Radio default
     * @property {Array.<string>|null} [options] Radio options
     * @property {string|null} [help] Radio help
     * @property {string|null} [formId] Radio formId
     * @property {string|null} [rawValue] Radio rawValue
     * @property {boolean|null} [setValue] Radio setValue
     * @property {boolean|null} [disabled] Radio disabled
     * @property {boolean|null} [horizontal] Radio horizontal
     * @property {LabelVisibility.$Properties|null} [labelVisibility] Radio labelVisibility
     * @property {Array.<string>|null} [captions] Radio captions
     * @property {string|null} [queryParamKey] Radio queryParamKey
     * @property {boolean|null} [ignoreRerun] Radio ignoreRerun
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Radio.
     * @exports IRadio
     * @interface IRadio
     * @augments Radio.$Properties
     * @deprecated Use Radio.$Properties instead.
     */

    /**
     * Shape of a Radio.
     * @typedef {Radio.$Properties} Radio.$Shape
     */

    /**
     * Constructs a new Radio.
     * @exports Radio
     * @classdesc Represents a Radio.
     * @constructor
     * @param {Radio.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Radio = function (properties) {
        this.options = [];
        this.captions = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Radio id.
     * @member {string} id
     * @memberof Radio
     * @instance
     */
    Radio.prototype.id = "";

    /**
     * Radio label.
     * @member {string} label
     * @memberof Radio
     * @instance
     */
    Radio.prototype.label = "";

    /**
     * Radio default.
     * @member {number|null|undefined} default
     * @memberof Radio
     * @instance
     */
    Radio.prototype["default"] = null;

    /**
     * Radio options.
     * @member {Array.<string>} options
     * @memberof Radio
     * @instance
     */
    Radio.prototype.options = $util.emptyArray;

    /**
     * Radio help.
     * @member {string} help
     * @memberof Radio
     * @instance
     */
    Radio.prototype.help = "";

    /**
     * Radio formId.
     * @member {string} formId
     * @memberof Radio
     * @instance
     */
    Radio.prototype.formId = "";

    /**
     * Radio rawValue.
     * @member {string|null|undefined} rawValue
     * @memberof Radio
     * @instance
     */
    Radio.prototype.rawValue = null;

    /**
     * Radio setValue.
     * @member {boolean} setValue
     * @memberof Radio
     * @instance
     */
    Radio.prototype.setValue = false;

    /**
     * Radio disabled.
     * @member {boolean} disabled
     * @memberof Radio
     * @instance
     */
    Radio.prototype.disabled = false;

    /**
     * Radio horizontal.
     * @member {boolean} horizontal
     * @memberof Radio
     * @instance
     */
    Radio.prototype.horizontal = false;

    /**
     * Radio labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof Radio
     * @instance
     */
    Radio.prototype.labelVisibility = null;

    /**
     * Radio captions.
     * @member {Array.<string>} captions
     * @memberof Radio
     * @instance
     */
    Radio.prototype.captions = $util.emptyArray;

    /**
     * Radio queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof Radio
     * @instance
     */
    Radio.prototype.queryParamKey = null;

    /**
     * Radio ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof Radio
     * @instance
     */
    Radio.prototype.ignoreRerun = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Radio.prototype, "_default", {
        get: $util.oneOfGetter($oneOfFields = ["default"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Radio.prototype, "_rawValue", {
        get: $util.oneOfGetter($oneOfFields = ["rawValue"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Radio.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Radio instance using the specified properties.
     * @function create
     * @memberof Radio
     * @static
     * @param {Radio.$Properties=} [properties] Properties to set
     * @returns {Radio} Radio instance
     * @type {{
     *   (properties: Radio.$Shape): Radio & Radio.$Shape;
     *   (properties?: Radio.$Properties): Radio;
     * }}
     */
    Radio.create = function(properties) {
        return new Radio(properties);
    };

    /**
     * Encodes the specified Radio message. Does not implicitly {@link Radio.verify|verify} messages.
     * @function encode
     * @memberof Radio
     * @static
     * @param {Radio.$Properties} message Radio message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Radio.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message["default"]);
        if (message.options != null && message.options.length)
            for (let i = 0; i < message.options.length; ++i)
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.options[i]);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.formId);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.setValue);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.disabled);
        if (message.horizontal != null && $Object.hasOwnProperty.call(message, "horizontal") && message.horizontal !== false)
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.horizontal);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 11, wireType 2 =*/90).fork(), _depth + 1).ldelim();
        if (message.captions != null && message.captions.length)
            for (let i = 0; i < message.captions.length; ++i)
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.captions[i]);
        if (message.rawValue != null && $Object.hasOwnProperty.call(message, "rawValue"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.rawValue);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.queryParamKey);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.ignoreRerun);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Radio message from the specified reader or buffer.
     * @function decode
     * @memberof Radio
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Radio & Radio.$Shape} Radio
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Radio.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Radio();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    message["default"] = reader.int32();
                    message._default = "default";
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if (!(message.options && message.options.length))
                        message.options = [];
                    message.options.push(reader.stringVerify());
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.rawValue = reader.stringVerify();
                    message._rawValue = "rawValue";
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.horizontal = value;
                    else
                        delete message.horizontal;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    if (!(message.captions && message.captions.length))
                        message.captions = [];
                    message.captions.push(reader.stringVerify());
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 15: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Radio message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Radio
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Radio} Radio
     */
    Radio.fromObject = function (object, _depth) {
        if (object instanceof $root.Radio)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Radio: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Radio();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"] != null)
            message["default"] = object["default"] | 0;
        if (object.options) {
            if (!$Array.isArray(object.options))
                throw $TypeError(".Radio.options: array expected");
            message.options = $Array(object.options.length);
            for (let i = 0; i < object.options.length; ++i)
                message.options[i] = $String(object.options[i]);
        }
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.rawValue != null)
            message.rawValue = $String(object.rawValue);
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.horizontal != null)
            if (object.horizontal)
                message.horizontal = $Boolean(object.horizontal);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".Radio.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.captions) {
            if (!$Array.isArray(object.captions))
                throw $TypeError(".Radio.captions: array expected");
            message.captions = $Array(object.captions.length);
            for (let i = 0; i < object.captions.length; ++i)
                message.captions[i] = $String(object.captions[i]);
        }
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        return message;
    };

    /**
     * Creates a plain object from a Radio message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Radio
     * @static
     * @param {Radio} message Radio
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Radio.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object.options = [];
            object.captions = [];
        }
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.help = "";
            object.formId = "";
            object.setValue = false;
            object.disabled = false;
            object.horizontal = false;
            object.labelVisibility = null;
            object.ignoreRerun = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.options && message.options.length) {
            object.options = $Array(message.options.length);
            for (let j = 0; j < message.options.length; ++j)
                object.options[j] = message.options[j];
        }
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.horizontal != null && $Object.hasOwnProperty.call(message, "horizontal"))
            object.horizontal = message.horizontal;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.captions && message.captions.length) {
            object.captions = $Array(message.captions.length);
            for (let j = 0; j < message.captions.length; ++j)
                object.captions[j] = message.captions[j];
        }
        if (message.rawValue != null && $Object.hasOwnProperty.call(message, "rawValue"))
            object.rawValue = message.rawValue;
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        return object;
    };

    /**
     * Converts this Radio to JSON.
     * @function toJSON
     * @memberof Radio
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Radio.prototype.toJSON = function() {
        return Radio.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Radio
     * @function getTypeUrl
     * @memberof Radio
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Radio.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Radio";
    };

    return Radio;
})();

export const Selectbox = $root.Selectbox = (() => {

    /**
     * Properties of a Selectbox.
     * @typedef {Object} Selectbox.$Properties
     * @property {string|null} [id] Selectbox id
     * @property {string|null} [label] Selectbox label
     * @property {number|null} ["default"] Selectbox default
     * @property {Array.<string>|null} [options] Selectbox options
     * @property {string|null} [help] Selectbox help
     * @property {string|null} [formId] Selectbox formId
     * @property {string|null} [rawValue] Selectbox rawValue
     * @property {boolean|null} [setValue] Selectbox setValue
     * @property {boolean|null} [disabled] Selectbox disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] Selectbox labelVisibility
     * @property {string|null} [placeholder] Selectbox placeholder
     * @property {boolean|null} [acceptNewOptions] Selectbox acceptNewOptions
     * @property {string|null} [queryParamKey] Selectbox queryParamKey
     * @property {streamlit.SelectWidgetFilterMode|null} [filterMode] Selectbox filterMode
     * @property {boolean|null} [ignoreRerun] Selectbox ignoreRerun
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Selectbox.
     * @exports ISelectbox
     * @interface ISelectbox
     * @augments Selectbox.$Properties
     * @deprecated Use Selectbox.$Properties instead.
     */

    /**
     * Shape of a Selectbox.
     * @typedef {Selectbox.$Properties} Selectbox.$Shape
     */

    /**
     * Constructs a new Selectbox.
     * @exports Selectbox
     * @classdesc Represents a Selectbox.
     * @constructor
     * @param {Selectbox.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Selectbox = function (properties) {
        this.options = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Selectbox id.
     * @member {string} id
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.id = "";

    /**
     * Selectbox label.
     * @member {string} label
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.label = "";

    /**
     * Selectbox default.
     * @member {number|null|undefined} default
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype["default"] = null;

    /**
     * Selectbox options.
     * @member {Array.<string>} options
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.options = $util.emptyArray;

    /**
     * Selectbox help.
     * @member {string} help
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.help = "";

    /**
     * Selectbox formId.
     * @member {string} formId
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.formId = "";

    /**
     * Selectbox rawValue.
     * @member {string|null|undefined} rawValue
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.rawValue = null;

    /**
     * Selectbox setValue.
     * @member {boolean} setValue
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.setValue = false;

    /**
     * Selectbox disabled.
     * @member {boolean} disabled
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.disabled = false;

    /**
     * Selectbox labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.labelVisibility = null;

    /**
     * Selectbox placeholder.
     * @member {string} placeholder
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.placeholder = "";

    /**
     * Selectbox acceptNewOptions.
     * @member {boolean|null|undefined} acceptNewOptions
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.acceptNewOptions = null;

    /**
     * Selectbox queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.queryParamKey = null;

    /**
     * Selectbox filterMode.
     * @member {streamlit.SelectWidgetFilterMode} filterMode
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.filterMode = 0;

    /**
     * Selectbox ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof Selectbox
     * @instance
     */
    Selectbox.prototype.ignoreRerun = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Selectbox.prototype, "_default", {
        get: $util.oneOfGetter($oneOfFields = ["default"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Selectbox.prototype, "_rawValue", {
        get: $util.oneOfGetter($oneOfFields = ["rawValue"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Selectbox.prototype, "_acceptNewOptions", {
        get: $util.oneOfGetter($oneOfFields = ["acceptNewOptions"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Selectbox.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Selectbox instance using the specified properties.
     * @function create
     * @memberof Selectbox
     * @static
     * @param {Selectbox.$Properties=} [properties] Properties to set
     * @returns {Selectbox} Selectbox instance
     * @type {{
     *   (properties: Selectbox.$Shape): Selectbox & Selectbox.$Shape;
     *   (properties?: Selectbox.$Properties): Selectbox;
     * }}
     */
    Selectbox.create = function(properties) {
        return new Selectbox(properties);
    };

    /**
     * Encodes the specified Selectbox message. Does not implicitly {@link Selectbox.verify|verify} messages.
     * @function encode
     * @memberof Selectbox
     * @static
     * @param {Selectbox.$Properties} message Selectbox message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Selectbox.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message["default"]);
        if (message.options != null && message.options.length)
            for (let i = 0; i < message.options.length; ++i)
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.options[i]);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.formId);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.setValue);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 10, wireType 2 =*/82).fork(), _depth + 1).ldelim();
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder") && message.placeholder !== "")
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.placeholder);
        if (message.acceptNewOptions != null && $Object.hasOwnProperty.call(message, "acceptNewOptions"))
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.acceptNewOptions);
        if (message.rawValue != null && $Object.hasOwnProperty.call(message, "rawValue"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.rawValue);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.queryParamKey);
        if (message.filterMode != null && $Object.hasOwnProperty.call(message, "filterMode") && message.filterMode !== 0)
            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.filterMode);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.ignoreRerun);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Selectbox message from the specified reader or buffer.
     * @function decode
     * @memberof Selectbox
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Selectbox & Selectbox.$Shape} Selectbox
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Selectbox.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Selectbox();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    message["default"] = reader.int32();
                    message._default = "default";
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if (!(message.options && message.options.length))
                        message.options = [];
                    message.options.push(reader.stringVerify());
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.rawValue = reader.stringVerify();
                    message._rawValue = "rawValue";
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.placeholder = value;
                    else
                        delete message.placeholder;
                    continue;
                }
            case 12: {
                    if (wireType !== 0)
                        break;
                    message.acceptNewOptions = reader.bool();
                    message._acceptNewOptions = "acceptNewOptions";
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 15: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.filterMode = value;
                    else
                        delete message.filterMode;
                    continue;
                }
            case 16: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Selectbox message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Selectbox
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Selectbox} Selectbox
     */
    Selectbox.fromObject = function (object, _depth) {
        if (object instanceof $root.Selectbox)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Selectbox: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Selectbox();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"] != null)
            message["default"] = object["default"] | 0;
        if (object.options) {
            if (!$Array.isArray(object.options))
                throw $TypeError(".Selectbox.options: array expected");
            message.options = $Array(object.options.length);
            for (let i = 0; i < object.options.length; ++i)
                message.options[i] = $String(object.options[i]);
        }
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.rawValue != null)
            message.rawValue = $String(object.rawValue);
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".Selectbox.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.placeholder != null)
            if (typeof object.placeholder !== "string" || object.placeholder.length)
                message.placeholder = $String(object.placeholder);
        if (object.acceptNewOptions != null)
            message.acceptNewOptions = $Boolean(object.acceptNewOptions);
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.filterMode !== 0 && (typeof object.filterMode !== "string" || $root.streamlit.SelectWidgetFilterMode[object.filterMode] !== 0))
            switch (object.filterMode) {
            case "FILTER_MODE_FUZZY":
            case 0:
                message.filterMode = 0;
                break;
            case "FILTER_MODE_CONTAINS":
            case 1:
                message.filterMode = 1;
                break;
            case "FILTER_MODE_PREFIX":
            case 2:
                message.filterMode = 2;
                break;
            case "FILTER_MODE_NONE":
            case 3:
                message.filterMode = 3;
                break;
            default:
                if (typeof object.filterMode === "number" && (object.filterMode | 0) === object.filterMode)
                    message.filterMode = object.filterMode;
            }
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        return message;
    };

    /**
     * Creates a plain object from a Selectbox message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Selectbox
     * @static
     * @param {Selectbox} message Selectbox
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Selectbox.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.options = [];
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.help = "";
            object.formId = "";
            object.setValue = false;
            object.disabled = false;
            object.labelVisibility = null;
            object.placeholder = "";
            object.filterMode = options.enums === $String ? "FILTER_MODE_FUZZY" : 0;
            object.ignoreRerun = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.options && message.options.length) {
            object.options = $Array(message.options.length);
            for (let j = 0; j < message.options.length; ++j)
                object.options[j] = message.options[j];
        }
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder"))
            object.placeholder = message.placeholder;
        if (message.acceptNewOptions != null && $Object.hasOwnProperty.call(message, "acceptNewOptions"))
            object.acceptNewOptions = message.acceptNewOptions;
        if (message.rawValue != null && $Object.hasOwnProperty.call(message, "rawValue"))
            object.rawValue = message.rawValue;
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.filterMode != null && $Object.hasOwnProperty.call(message, "filterMode"))
            object.filterMode = options.enums === $String ? $root.streamlit.SelectWidgetFilterMode[message.filterMode] === $undefined ? message.filterMode : $root.streamlit.SelectWidgetFilterMode[message.filterMode] : message.filterMode;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        return object;
    };

    /**
     * Converts this Selectbox to JSON.
     * @function toJSON
     * @memberof Selectbox
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Selectbox.prototype.toJSON = function() {
        return Selectbox.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Selectbox
     * @function getTypeUrl
     * @memberof Selectbox
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Selectbox.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Selectbox";
    };

    return Selectbox;
})();

export const Skeleton = $root.Skeleton = (() => {

    /**
     * Properties of a Skeleton.
     * @typedef {Object} Skeleton.$Properties
     * @property {Skeleton.SkeletonStyle|null} [style] Skeleton style
     * @property {number|null} [height] Skeleton height
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Skeleton.
     * @exports ISkeleton
     * @interface ISkeleton
     * @augments Skeleton.$Properties
     * @deprecated Use Skeleton.$Properties instead.
     */

    /**
     * Shape of a Skeleton.
     * @typedef {Skeleton.$Properties} Skeleton.$Shape
     */

    /**
     * Constructs a new Skeleton.
     * @exports Skeleton
     * @classdesc Represents a Skeleton.
     * @constructor
     * @param {Skeleton.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Skeleton = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Skeleton style.
     * @member {Skeleton.SkeletonStyle} style
     * @memberof Skeleton
     * @instance
     */
    Skeleton.prototype.style = 0;

    /**
     * Skeleton height.
     * @member {number|null|undefined} height
     * @memberof Skeleton
     * @instance
     */
    Skeleton.prototype.height = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Skeleton.prototype, "_height", {
        get: $util.oneOfGetter($oneOfFields = ["height"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Skeleton instance using the specified properties.
     * @function create
     * @memberof Skeleton
     * @static
     * @param {Skeleton.$Properties=} [properties] Properties to set
     * @returns {Skeleton} Skeleton instance
     * @type {{
     *   (properties: Skeleton.$Shape): Skeleton & Skeleton.$Shape;
     *   (properties?: Skeleton.$Properties): Skeleton;
     * }}
     */
    Skeleton.create = function(properties) {
        return new Skeleton(properties);
    };

    /**
     * Encodes the specified Skeleton message. Does not implicitly {@link Skeleton.verify|verify} messages.
     * @function encode
     * @memberof Skeleton
     * @static
     * @param {Skeleton.$Properties} message Skeleton message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Skeleton.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.style != null && $Object.hasOwnProperty.call(message, "style") && message.style !== 0)
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.style);
        if (message.height != null && $Object.hasOwnProperty.call(message, "height"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.height);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Skeleton message from the specified reader or buffer.
     * @function decode
     * @memberof Skeleton
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Skeleton & Skeleton.$Shape} Skeleton
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Skeleton.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Skeleton();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.style = value;
                    else
                        delete message.style;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    message.height = reader.int32();
                    message._height = "height";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Skeleton message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Skeleton
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Skeleton} Skeleton
     */
    Skeleton.fromObject = function (object, _depth) {
        if (object instanceof $root.Skeleton)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Skeleton: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Skeleton();
        if (object.style !== 0 && (typeof object.style !== "string" || $root.Skeleton.SkeletonStyle[object.style] !== 0))
            switch (object.style) {
            case "ELEMENT":
            case 0:
                message.style = 0;
                break;
            case "APP":
            case 1:
                message.style = 1;
                break;
            default:
                if (typeof object.style === "number" && (object.style | 0) === object.style)
                    message.style = object.style;
            }
        if (object.height != null)
            message.height = object.height | 0;
        return message;
    };

    /**
     * Creates a plain object from a Skeleton message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Skeleton
     * @static
     * @param {Skeleton} message Skeleton
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Skeleton.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.style = options.enums === $String ? "ELEMENT" : 0;
        if (message.style != null && $Object.hasOwnProperty.call(message, "style"))
            object.style = options.enums === $String ? $root.Skeleton.SkeletonStyle[message.style] === $undefined ? message.style : $root.Skeleton.SkeletonStyle[message.style] : message.style;
        if (message.height != null && $Object.hasOwnProperty.call(message, "height"))
            object.height = message.height;
        return object;
    };

    /**
     * Converts this Skeleton to JSON.
     * @function toJSON
     * @memberof Skeleton
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Skeleton.prototype.toJSON = function() {
        return Skeleton.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Skeleton
     * @function getTypeUrl
     * @memberof Skeleton
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Skeleton.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Skeleton";
    };

    /**
     * SkeletonStyle enum.
     * @name Skeleton.SkeletonStyle
     * @enum {number}
     * @property {number} ELEMENT=0 ELEMENT value
     * @property {number} APP=1 APP value
     */
    Skeleton.SkeletonStyle = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "ELEMENT"] = 0;
        values[valuesById[1] = "APP"] = 1;
        return values;
    })();

    return Skeleton;
})();

export const Slider = $root.Slider = (() => {

    /**
     * Properties of a Slider.
     * @typedef {Object} Slider.$Properties
     * @property {string|null} [id] Slider id
     * @property {string|null} [formId] Slider formId
     * @property {string|null} [label] Slider label
     * @property {string|null} [format] Slider format
     * @property {Slider.DataType|null} [dataType] Slider dataType
     * @property {Array.<number>|null} ["default"] Slider default
     * @property {number|null} [min] Slider min
     * @property {number|null} [max] Slider max
     * @property {number|null} [step] Slider step
     * @property {Array.<number>|null} [value] Slider value
     * @property {boolean|null} [setValue] Slider setValue
     * @property {Array.<string>|null} [options] Slider options
     * @property {string|null} [help] Slider help
     * @property {boolean|null} [disabled] Slider disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] Slider labelVisibility
     * @property {Slider.Type|null} [type] Slider type
     * @property {Array.<string>|null} [rawValue] Slider rawValue
     * @property {string|null} [queryParamKey] Slider queryParamKey
     * @property {boolean|null} [ignoreRerun] Slider ignoreRerun
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Slider.
     * @exports ISlider
     * @interface ISlider
     * @augments Slider.$Properties
     * @deprecated Use Slider.$Properties instead.
     */

    /**
     * Shape of a Slider.
     * @typedef {Slider.$Properties} Slider.$Shape
     */

    /**
     * Constructs a new Slider.
     * @exports Slider
     * @classdesc Represents a Slider.
     * @constructor
     * @param {Slider.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Slider = function (properties) {
        this["default"] = [];
        this.value = [];
        this.options = [];
        this.rawValue = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Slider id.
     * @member {string} id
     * @memberof Slider
     * @instance
     */
    Slider.prototype.id = "";

    /**
     * Slider formId.
     * @member {string} formId
     * @memberof Slider
     * @instance
     */
    Slider.prototype.formId = "";

    /**
     * Slider label.
     * @member {string} label
     * @memberof Slider
     * @instance
     */
    Slider.prototype.label = "";

    /**
     * Slider format.
     * @member {string} format
     * @memberof Slider
     * @instance
     */
    Slider.prototype.format = "";

    /**
     * Slider dataType.
     * @member {Slider.DataType} dataType
     * @memberof Slider
     * @instance
     */
    Slider.prototype.dataType = 0;

    /**
     * Slider default.
     * @member {Array.<number>} default
     * @memberof Slider
     * @instance
     */
    Slider.prototype["default"] = $util.emptyArray;

    /**
     * Slider min.
     * @member {number} min
     * @memberof Slider
     * @instance
     */
    Slider.prototype.min = 0;

    /**
     * Slider max.
     * @member {number} max
     * @memberof Slider
     * @instance
     */
    Slider.prototype.max = 0;

    /**
     * Slider step.
     * @member {number} step
     * @memberof Slider
     * @instance
     */
    Slider.prototype.step = 0;

    /**
     * Slider value.
     * @member {Array.<number>} value
     * @memberof Slider
     * @instance
     */
    Slider.prototype.value = $util.emptyArray;

    /**
     * Slider setValue.
     * @member {boolean} setValue
     * @memberof Slider
     * @instance
     */
    Slider.prototype.setValue = false;

    /**
     * Slider options.
     * @member {Array.<string>} options
     * @memberof Slider
     * @instance
     */
    Slider.prototype.options = $util.emptyArray;

    /**
     * Slider help.
     * @member {string} help
     * @memberof Slider
     * @instance
     */
    Slider.prototype.help = "";

    /**
     * Slider disabled.
     * @member {boolean} disabled
     * @memberof Slider
     * @instance
     */
    Slider.prototype.disabled = false;

    /**
     * Slider labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof Slider
     * @instance
     */
    Slider.prototype.labelVisibility = null;

    /**
     * Slider type.
     * @member {Slider.Type} type
     * @memberof Slider
     * @instance
     */
    Slider.prototype.type = 0;

    /**
     * Slider rawValue.
     * @member {Array.<string>} rawValue
     * @memberof Slider
     * @instance
     */
    Slider.prototype.rawValue = $util.emptyArray;

    /**
     * Slider queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof Slider
     * @instance
     */
    Slider.prototype.queryParamKey = null;

    /**
     * Slider ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof Slider
     * @instance
     */
    Slider.prototype.ignoreRerun = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Slider.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Slider instance using the specified properties.
     * @function create
     * @memberof Slider
     * @static
     * @param {Slider.$Properties=} [properties] Properties to set
     * @returns {Slider} Slider instance
     * @type {{
     *   (properties: Slider.$Shape): Slider & Slider.$Shape;
     *   (properties?: Slider.$Properties): Slider;
     * }}
     */
    Slider.create = function(properties) {
        return new Slider(properties);
    };

    /**
     * Encodes the specified Slider message. Does not implicitly {@link Slider.verify|verify} messages.
     * @function encode
     * @memberof Slider
     * @static
     * @param {Slider.$Properties} message Slider message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Slider.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.formId);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.label);
        if (message.format != null && $Object.hasOwnProperty.call(message, "format") && message.format !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.format);
        if (message.dataType != null && $Object.hasOwnProperty.call(message, "dataType") && message.dataType !== 0)
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.dataType);
        if (message["default"] != null && message["default"].length)
            writer.uint32(/* id 6, wireType 2 =*/50).doubles(message["default"]);
        if (message.min != null && $Object.hasOwnProperty.call(message, "min") && !$Object.is(message.min, 0))
            writer.uint32(/* id 7, wireType 1 =*/57).double(message.min);
        if (message.max != null && $Object.hasOwnProperty.call(message, "max") && !$Object.is(message.max, 0))
            writer.uint32(/* id 8, wireType 1 =*/65).double(message.max);
        if (message.step != null && $Object.hasOwnProperty.call(message, "step") && !$Object.is(message.step, 0))
            writer.uint32(/* id 9, wireType 1 =*/73).double(message.step);
        if (message.value != null && message.value.length)
            writer.uint32(/* id 10, wireType 2 =*/82).doubles(message.value);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.setValue);
        if (message.options != null && message.options.length)
            for (let i = 0; i < message.options.length; ++i)
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.options[i]);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.help);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 16, wireType 2 =*/130).fork(), _depth + 1).ldelim();
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== 0)
            writer.uint32(/* id 17, wireType 0 =*/136).int32(message.type);
        if (message.rawValue != null && message.rawValue.length)
            for (let i = 0; i < message.rawValue.length; ++i)
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.rawValue[i]);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 19, wireType 2 =*/154).string(message.queryParamKey);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 20, wireType 0 =*/160).bool(message.ignoreRerun);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Slider message from the specified reader or buffer.
     * @function decode
     * @memberof Slider
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Slider & Slider.$Shape} Slider
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Slider.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Slider();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.format = value;
                    else
                        delete message.format;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.dataType = value;
                    else
                        delete message.dataType;
                    continue;
                }
            case 6: {
                    if (wireType === 2) {
                        if (!(message["default"] && message["default"].length))
                            message["default"] = [];
                        reader.doubles(message["default"]);
                        continue;
                    }
                    if (wireType !== 1)
                        break;
                    if (!(message["default"] && message["default"].length))
                        message["default"] = [];
                    message["default"].push(reader.double());
                    continue;
                }
            case 7: {
                    if (wireType !== 1)
                        break;
                    if (!$Object.is(value = reader.double(), 0))
                        message.min = value;
                    else
                        delete message.min;
                    continue;
                }
            case 8: {
                    if (wireType !== 1)
                        break;
                    if (!$Object.is(value = reader.double(), 0))
                        message.max = value;
                    else
                        delete message.max;
                    continue;
                }
            case 9: {
                    if (wireType !== 1)
                        break;
                    if (!$Object.is(value = reader.double(), 0))
                        message.step = value;
                    else
                        delete message.step;
                    continue;
                }
            case 10: {
                    if (wireType === 2) {
                        if (!(message.value && message.value.length))
                            message.value = [];
                        reader.doubles(message.value);
                        continue;
                    }
                    if (wireType !== 1)
                        break;
                    if (!(message.value && message.value.length))
                        message.value = [];
                    message.value.push(reader.double());
                    continue;
                }
            case 11: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    if (!(message.options && message.options.length))
                        message.options = [];
                    message.options.push(reader.stringVerify());
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 15: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 16: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 17: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 18: {
                    if (wireType !== 2)
                        break;
                    if (!(message.rawValue && message.rawValue.length))
                        message.rawValue = [];
                    message.rawValue.push(reader.stringVerify());
                    continue;
                }
            case 19: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 20: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Slider message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Slider
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Slider} Slider
     */
    Slider.fromObject = function (object, _depth) {
        if (object instanceof $root.Slider)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Slider: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Slider();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.format != null)
            if (typeof object.format !== "string" || object.format.length)
                message.format = $String(object.format);
        if (object.dataType !== 0 && (typeof object.dataType !== "string" || $root.Slider.DataType[object.dataType] !== 0))
            switch (object.dataType) {
            case "INT":
            case 0:
                message.dataType = 0;
                break;
            case "FLOAT":
            case 1:
                message.dataType = 1;
                break;
            case "DATETIME":
            case 2:
                message.dataType = 2;
                break;
            case "DATE":
            case 3:
                message.dataType = 3;
                break;
            case "TIME":
            case 4:
                message.dataType = 4;
                break;
            default:
                if (typeof object.dataType === "number" && (object.dataType | 0) === object.dataType)
                    message.dataType = object.dataType;
            }
        if (object["default"]) {
            if (!$Array.isArray(object["default"]))
                throw $TypeError(".Slider.default: array expected");
            message["default"] = $Array(object["default"].length);
            for (let i = 0; i < object["default"].length; ++i)
                message["default"][i] = $Number(object["default"][i]);
        }
        if (object.min != null)
            if (!$Object.is($Number(object.min), 0))
                message.min = $Number(object.min);
        if (object.max != null)
            if (!$Object.is($Number(object.max), 0))
                message.max = $Number(object.max);
        if (object.step != null)
            if (!$Object.is($Number(object.step), 0))
                message.step = $Number(object.step);
        if (object.value) {
            if (!$Array.isArray(object.value))
                throw $TypeError(".Slider.value: array expected");
            message.value = $Array(object.value.length);
            for (let i = 0; i < object.value.length; ++i)
                message.value[i] = $Number(object.value[i]);
        }
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.options) {
            if (!$Array.isArray(object.options))
                throw $TypeError(".Slider.options: array expected");
            message.options = $Array(object.options.length);
            for (let i = 0; i < object.options.length; ++i)
                message.options[i] = $String(object.options[i]);
        }
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".Slider.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.type !== 0 && (typeof object.type !== "string" || $root.Slider.Type[object.type] !== 0))
            switch (object.type) {
            case "UNSPECIFIED":
            case 0:
                message.type = 0;
                break;
            case "SLIDER":
            case 1:
                message.type = 1;
                break;
            case "SELECT_SLIDER":
            case 2:
                message.type = 2;
                break;
            default:
                if (typeof object.type === "number" && (object.type | 0) === object.type)
                    message.type = object.type;
            }
        if (object.rawValue) {
            if (!$Array.isArray(object.rawValue))
                throw $TypeError(".Slider.rawValue: array expected");
            message.rawValue = $Array(object.rawValue.length);
            for (let i = 0; i < object.rawValue.length; ++i)
                message.rawValue[i] = $String(object.rawValue[i]);
        }
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        return message;
    };

    /**
     * Creates a plain object from a Slider message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Slider
     * @static
     * @param {Slider} message Slider
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Slider.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object["default"] = [];
            object.value = [];
            object.options = [];
            object.rawValue = [];
        }
        if (options.defaults) {
            object.id = "";
            object.formId = "";
            object.label = "";
            object.format = "";
            object.dataType = options.enums === $String ? "INT" : 0;
            object.min = 0;
            object.max = 0;
            object.step = 0;
            object.setValue = false;
            object.help = "";
            object.disabled = false;
            object.labelVisibility = null;
            object.type = options.enums === $String ? "UNSPECIFIED" : 0;
            object.ignoreRerun = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.format != null && $Object.hasOwnProperty.call(message, "format"))
            object.format = message.format;
        if (message.dataType != null && $Object.hasOwnProperty.call(message, "dataType"))
            object.dataType = options.enums === $String ? $root.Slider.DataType[message.dataType] === $undefined ? message.dataType : $root.Slider.DataType[message.dataType] : message.dataType;
        if (message["default"] && message["default"].length) {
            object["default"] = $Array(message["default"].length);
            for (let j = 0; j < message["default"].length; ++j)
                object["default"][j] = options.json && !$isFinite(message["default"][j]) ? $String(message["default"][j]) : message["default"][j];
        }
        if (message.min != null && $Object.hasOwnProperty.call(message, "min"))
            object.min = options.json && !$isFinite(message.min) ? $String(message.min) : message.min;
        if (message.max != null && $Object.hasOwnProperty.call(message, "max"))
            object.max = options.json && !$isFinite(message.max) ? $String(message.max) : message.max;
        if (message.step != null && $Object.hasOwnProperty.call(message, "step"))
            object.step = options.json && !$isFinite(message.step) ? $String(message.step) : message.step;
        if (message.value && message.value.length) {
            object.value = $Array(message.value.length);
            for (let j = 0; j < message.value.length; ++j)
                object.value[j] = options.json && !$isFinite(message.value[j]) ? $String(message.value[j]) : message.value[j];
        }
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.options && message.options.length) {
            object.options = $Array(message.options.length);
            for (let j = 0; j < message.options.length; ++j)
                object.options[j] = message.options[j];
        }
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = options.enums === $String ? $root.Slider.Type[message.type] === $undefined ? message.type : $root.Slider.Type[message.type] : message.type;
        if (message.rawValue && message.rawValue.length) {
            object.rawValue = $Array(message.rawValue.length);
            for (let j = 0; j < message.rawValue.length; ++j)
                object.rawValue[j] = message.rawValue[j];
        }
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        return object;
    };

    /**
     * Converts this Slider to JSON.
     * @function toJSON
     * @memberof Slider
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Slider.prototype.toJSON = function() {
        return Slider.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Slider
     * @function getTypeUrl
     * @memberof Slider
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Slider.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Slider";
    };

    /**
     * DataType enum.
     * @name Slider.DataType
     * @enum {number}
     * @property {number} INT=0 INT value
     * @property {number} FLOAT=1 FLOAT value
     * @property {number} DATETIME=2 DATETIME value
     * @property {number} DATE=3 DATE value
     * @property {number} TIME=4 TIME value
     */
    Slider.DataType = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "INT"] = 0;
        values[valuesById[1] = "FLOAT"] = 1;
        values[valuesById[2] = "DATETIME"] = 2;
        values[valuesById[3] = "DATE"] = 3;
        values[valuesById[4] = "TIME"] = 4;
        return values;
    })();

    /**
     * Type enum.
     * @name Slider.Type
     * @enum {number}
     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
     * @property {number} SLIDER=1 SLIDER value
     * @property {number} SELECT_SLIDER=2 SELECT_SLIDER value
     */
    Slider.Type = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "UNSPECIFIED"] = 0;
        values[valuesById[1] = "SLIDER"] = 1;
        values[valuesById[2] = "SELECT_SLIDER"] = 2;
        return values;
    })();

    return Slider;
})();

export const Snow = $root.Snow = (() => {

    /**
     * Properties of a Snow.
     * @typedef {Object} Snow.$Properties
     * @property {boolean|null} [show] Snow show
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Snow.
     * @exports ISnow
     * @interface ISnow
     * @augments Snow.$Properties
     * @deprecated Use Snow.$Properties instead.
     */

    /**
     * Shape of a Snow.
     * @typedef {Snow.$Properties} Snow.$Shape
     */

    /**
     * Constructs a new Snow.
     * @exports Snow
     * @classdesc Represents a Snow.
     * @constructor
     * @param {Snow.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Snow = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Snow show.
     * @member {boolean} show
     * @memberof Snow
     * @instance
     */
    Snow.prototype.show = false;

    /**
     * Creates a new Snow instance using the specified properties.
     * @function create
     * @memberof Snow
     * @static
     * @param {Snow.$Properties=} [properties] Properties to set
     * @returns {Snow} Snow instance
     * @type {{
     *   (properties: Snow.$Shape): Snow & Snow.$Shape;
     *   (properties?: Snow.$Properties): Snow;
     * }}
     */
    Snow.create = function(properties) {
        return new Snow(properties);
    };

    /**
     * Encodes the specified Snow message. Does not implicitly {@link Snow.verify|verify} messages.
     * @function encode
     * @memberof Snow
     * @static
     * @param {Snow.$Properties} message Snow message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Snow.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.show != null && $Object.hasOwnProperty.call(message, "show") && message.show !== false)
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.show);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Snow message from the specified reader or buffer.
     * @function decode
     * @memberof Snow
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Snow & Snow.$Shape} Snow
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Snow.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Snow();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.show = value;
                    else
                        delete message.show;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Snow message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Snow
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Snow} Snow
     */
    Snow.fromObject = function (object, _depth) {
        if (object instanceof $root.Snow)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Snow: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Snow();
        if (object.show != null)
            if (object.show)
                message.show = $Boolean(object.show);
        return message;
    };

    /**
     * Creates a plain object from a Snow message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Snow
     * @static
     * @param {Snow} message Snow
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Snow.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.show = false;
        if (message.show != null && $Object.hasOwnProperty.call(message, "show"))
            object.show = message.show;
        return object;
    };

    /**
     * Converts this Snow to JSON.
     * @function toJSON
     * @memberof Snow
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Snow.prototype.toJSON = function() {
        return Snow.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Snow
     * @function getTypeUrl
     * @memberof Snow
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Snow.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Snow";
    };

    return Snow;
})();

export const Space = $root.Space = (() => {

    /**
     * Properties of a Space.
     * @typedef {Object} Space.$Properties
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Space.
     * @exports ISpace
     * @interface ISpace
     * @augments Space.$Properties
     * @deprecated Use Space.$Properties instead.
     */

    /**
     * Shape of a Space.
     * @typedef {Space.$Properties} Space.$Shape
     */

    /**
     * Constructs a new Space.
     * @exports Space
     * @classdesc Represents a Space.
     * @constructor
     * @param {Space.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Space = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Creates a new Space instance using the specified properties.
     * @function create
     * @memberof Space
     * @static
     * @param {Space.$Properties=} [properties] Properties to set
     * @returns {Space} Space instance
     * @type {{
     *   (properties: Space.$Shape): Space & Space.$Shape;
     *   (properties?: Space.$Properties): Space;
     * }}
     */
    Space.create = function(properties) {
        return new Space(properties);
    };

    /**
     * Encodes the specified Space message. Does not implicitly {@link Space.verify|verify} messages.
     * @function encode
     * @memberof Space
     * @static
     * @param {Space.$Properties} message Space message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Space.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Space message from the specified reader or buffer.
     * @function decode
     * @memberof Space
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Space & Space.$Shape} Space
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Space.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Space();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            reader.skipType(tag & 7, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Space message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Space
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Space} Space
     */
    Space.fromObject = function (object, _depth) {
        if (object instanceof $root.Space)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Space: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        return new $root.Space();
    };

    /**
     * Creates a plain object from a Space message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Space
     * @static
     * @param {Space} message Space
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Space.toObject = function () {
        return {};
    };

    /**
     * Converts this Space to JSON.
     * @function toJSON
     * @memberof Space
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Space.prototype.toJSON = function() {
        return Space.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Space
     * @function getTypeUrl
     * @memberof Space
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Space.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Space";
    };

    return Space;
})();

export const Spinner = $root.Spinner = (() => {

    /**
     * Properties of a Spinner.
     * @typedef {Object} Spinner.$Properties
     * @property {string|null} [text] Spinner text
     * @property {boolean|null} [cache] Spinner cache
     * @property {boolean|null} [showTime] Spinner showTime
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Spinner.
     * @exports ISpinner
     * @interface ISpinner
     * @augments Spinner.$Properties
     * @deprecated Use Spinner.$Properties instead.
     */

    /**
     * Shape of a Spinner.
     * @typedef {Spinner.$Properties} Spinner.$Shape
     */

    /**
     * Constructs a new Spinner.
     * @exports Spinner
     * @classdesc Represents a Spinner.
     * @constructor
     * @param {Spinner.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Spinner = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Spinner text.
     * @member {string} text
     * @memberof Spinner
     * @instance
     */
    Spinner.prototype.text = "";

    /**
     * Spinner cache.
     * @member {boolean} cache
     * @memberof Spinner
     * @instance
     */
    Spinner.prototype.cache = false;

    /**
     * Spinner showTime.
     * @member {boolean} showTime
     * @memberof Spinner
     * @instance
     */
    Spinner.prototype.showTime = false;

    /**
     * Creates a new Spinner instance using the specified properties.
     * @function create
     * @memberof Spinner
     * @static
     * @param {Spinner.$Properties=} [properties] Properties to set
     * @returns {Spinner} Spinner instance
     * @type {{
     *   (properties: Spinner.$Shape): Spinner & Spinner.$Shape;
     *   (properties?: Spinner.$Properties): Spinner;
     * }}
     */
    Spinner.create = function(properties) {
        return new Spinner(properties);
    };

    /**
     * Encodes the specified Spinner message. Does not implicitly {@link Spinner.verify|verify} messages.
     * @function encode
     * @memberof Spinner
     * @static
     * @param {Spinner.$Properties} message Spinner message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Spinner.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.text != null && $Object.hasOwnProperty.call(message, "text") && message.text !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.text);
        if (message.cache != null && $Object.hasOwnProperty.call(message, "cache") && message.cache !== false)
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.cache);
        if (message.showTime != null && $Object.hasOwnProperty.call(message, "showTime") && message.showTime !== false)
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.showTime);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Spinner message from the specified reader or buffer.
     * @function decode
     * @memberof Spinner
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Spinner & Spinner.$Shape} Spinner
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Spinner.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Spinner();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.text = value;
                    else
                        delete message.text;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.cache = value;
                    else
                        delete message.cache;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.showTime = value;
                    else
                        delete message.showTime;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Spinner message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Spinner
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Spinner} Spinner
     */
    Spinner.fromObject = function (object, _depth) {
        if (object instanceof $root.Spinner)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Spinner: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Spinner();
        if (object.text != null)
            if (typeof object.text !== "string" || object.text.length)
                message.text = $String(object.text);
        if (object.cache != null)
            if (object.cache)
                message.cache = $Boolean(object.cache);
        if (object.showTime != null)
            if (object.showTime)
                message.showTime = $Boolean(object.showTime);
        return message;
    };

    /**
     * Creates a plain object from a Spinner message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Spinner
     * @static
     * @param {Spinner} message Spinner
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Spinner.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.text = "";
            object.cache = false;
            object.showTime = false;
        }
        if (message.text != null && $Object.hasOwnProperty.call(message, "text"))
            object.text = message.text;
        if (message.cache != null && $Object.hasOwnProperty.call(message, "cache"))
            object.cache = message.cache;
        if (message.showTime != null && $Object.hasOwnProperty.call(message, "showTime"))
            object.showTime = message.showTime;
        return object;
    };

    /**
     * Converts this Spinner to JSON.
     * @function toJSON
     * @memberof Spinner
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Spinner.prototype.toJSON = function() {
        return Spinner.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Spinner
     * @function getTypeUrl
     * @memberof Spinner
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Spinner.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Spinner";
    };

    return Spinner;
})();

export const Table = $root.Table = (() => {

    /**
     * Properties of a Table.
     * @typedef {Object} Table.$Properties
     * @property {ArrowData.$Properties|null} [arrowData] Table arrowData
     * @property {Table.BorderMode|null} [borderMode] Table borderMode
     * @property {boolean|null} [hideIndex] Table hideIndex
     * @property {boolean|null} [hideHeader] Table hideHeader
     * @property {string|null} [alt] Table alt
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Table.
     * @exports ITable
     * @interface ITable
     * @augments Table.$Properties
     * @deprecated Use Table.$Properties instead.
     */

    /**
     * Shape of a Table.
     * @typedef {Table.$Properties} Table.$Shape
     */

    /**
     * Constructs a new Table.
     * @exports Table
     * @classdesc Represents a Table.
     * @constructor
     * @param {Table.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Table = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Table arrowData.
     * @member {ArrowData.$Properties|null|undefined} arrowData
     * @memberof Table
     * @instance
     */
    Table.prototype.arrowData = null;

    /**
     * Table borderMode.
     * @member {Table.BorderMode} borderMode
     * @memberof Table
     * @instance
     */
    Table.prototype.borderMode = 0;

    /**
     * Table hideIndex.
     * @member {boolean} hideIndex
     * @memberof Table
     * @instance
     */
    Table.prototype.hideIndex = false;

    /**
     * Table hideHeader.
     * @member {boolean} hideHeader
     * @memberof Table
     * @instance
     */
    Table.prototype.hideHeader = false;

    /**
     * Table alt.
     * @member {string|null|undefined} alt
     * @memberof Table
     * @instance
     */
    Table.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Table.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Table instance using the specified properties.
     * @function create
     * @memberof Table
     * @static
     * @param {Table.$Properties=} [properties] Properties to set
     * @returns {Table} Table instance
     * @type {{
     *   (properties: Table.$Shape): Table & Table.$Shape;
     *   (properties?: Table.$Properties): Table;
     * }}
     */
    Table.create = function(properties) {
        return new Table(properties);
    };

    /**
     * Encodes the specified Table message. Does not implicitly {@link Table.verify|verify} messages.
     * @function encode
     * @memberof Table
     * @static
     * @param {Table.$Properties} message Table message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Table.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.arrowData != null && $Object.hasOwnProperty.call(message, "arrowData"))
            $root.ArrowData.encode(message.arrowData, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.borderMode != null && $Object.hasOwnProperty.call(message, "borderMode") && message.borderMode !== 0)
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.borderMode);
        if (message.hideIndex != null && $Object.hasOwnProperty.call(message, "hideIndex") && message.hideIndex !== false)
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.hideIndex);
        if (message.hideHeader != null && $Object.hasOwnProperty.call(message, "hideHeader") && message.hideHeader !== false)
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.hideHeader);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Table message from the specified reader or buffer.
     * @function decode
     * @memberof Table
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Table & Table.$Shape} Table
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Table.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Table();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.arrowData = $root.ArrowData.decode(reader, reader.uint32(), $undefined, _depth + 1, message.arrowData);
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.borderMode = value;
                    else
                        delete message.borderMode;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hideIndex = value;
                    else
                        delete message.hideIndex;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hideHeader = value;
                    else
                        delete message.hideHeader;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Table message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Table
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Table} Table
     */
    Table.fromObject = function (object, _depth) {
        if (object instanceof $root.Table)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Table: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Table();
        if (object.arrowData != null) {
            if (!$util.isObject(object.arrowData))
                throw $TypeError(".Table.arrowData: object expected");
            message.arrowData = $root.ArrowData.fromObject(object.arrowData, _depth + 1);
        }
        if (object.borderMode !== 0 && (typeof object.borderMode !== "string" || $root.Table.BorderMode[object.borderMode] !== 0))
            switch (object.borderMode) {
            case "ALL":
            case 0:
                message.borderMode = 0;
                break;
            case "NONE":
            case 1:
                message.borderMode = 1;
                break;
            case "HORIZONTAL":
            case 2:
                message.borderMode = 2;
                break;
            default:
                if (typeof object.borderMode === "number" && (object.borderMode | 0) === object.borderMode)
                    message.borderMode = object.borderMode;
            }
        if (object.hideIndex != null)
            if (object.hideIndex)
                message.hideIndex = $Boolean(object.hideIndex);
        if (object.hideHeader != null)
            if (object.hideHeader)
                message.hideHeader = $Boolean(object.hideHeader);
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from a Table message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Table
     * @static
     * @param {Table} message Table
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Table.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.arrowData = null;
            object.borderMode = options.enums === $String ? "ALL" : 0;
            object.hideIndex = false;
            object.hideHeader = false;
        }
        if (message.arrowData != null && $Object.hasOwnProperty.call(message, "arrowData"))
            object.arrowData = $root.ArrowData.toObject(message.arrowData, options, _depth + 1);
        if (message.borderMode != null && $Object.hasOwnProperty.call(message, "borderMode"))
            object.borderMode = options.enums === $String ? $root.Table.BorderMode[message.borderMode] === $undefined ? message.borderMode : $root.Table.BorderMode[message.borderMode] : message.borderMode;
        if (message.hideIndex != null && $Object.hasOwnProperty.call(message, "hideIndex"))
            object.hideIndex = message.hideIndex;
        if (message.hideHeader != null && $Object.hasOwnProperty.call(message, "hideHeader"))
            object.hideHeader = message.hideHeader;
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this Table to JSON.
     * @function toJSON
     * @memberof Table
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Table.prototype.toJSON = function() {
        return Table.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Table
     * @function getTypeUrl
     * @memberof Table
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Table.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Table";
    };

    /**
     * BorderMode enum.
     * @name Table.BorderMode
     * @enum {number}
     * @property {number} ALL=0 ALL value
     * @property {number} NONE=1 NONE value
     * @property {number} HORIZONTAL=2 HORIZONTAL value
     */
    Table.BorderMode = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "ALL"] = 0;
        values[valuesById[1] = "NONE"] = 1;
        values[valuesById[2] = "HORIZONTAL"] = 2;
        return values;
    })();

    return Table;
})();

export const Text = $root.Text = (() => {

    /**
     * Properties of a Text.
     * @typedef {Object} Text.$Properties
     * @property {string|null} [body] Text body
     * @property {string|null} [help] Text help
     * @property {boolean|null} [wrap] Text wrap
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Text.
     * @exports IText
     * @interface IText
     * @augments Text.$Properties
     * @deprecated Use Text.$Properties instead.
     */

    /**
     * Shape of a Text.
     * @typedef {Text.$Properties} Text.$Shape
     */

    /**
     * Constructs a new Text.
     * @exports Text
     * @classdesc Represents a Text.
     * @constructor
     * @param {Text.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Text = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Text body.
     * @member {string} body
     * @memberof Text
     * @instance
     */
    Text.prototype.body = "";

    /**
     * Text help.
     * @member {string} help
     * @memberof Text
     * @instance
     */
    Text.prototype.help = "";

    /**
     * Text wrap.
     * @member {boolean|null|undefined} wrap
     * @memberof Text
     * @instance
     */
    Text.prototype.wrap = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Text.prototype, "_wrap", {
        get: $util.oneOfGetter($oneOfFields = ["wrap"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Text instance using the specified properties.
     * @function create
     * @memberof Text
     * @static
     * @param {Text.$Properties=} [properties] Properties to set
     * @returns {Text} Text instance
     * @type {{
     *   (properties: Text.$Shape): Text & Text.$Shape;
     *   (properties?: Text.$Properties): Text;
     * }}
     */
    Text.create = function(properties) {
        return new Text(properties);
    };

    /**
     * Encodes the specified Text message. Does not implicitly {@link Text.verify|verify} messages.
     * @function encode
     * @memberof Text
     * @static
     * @param {Text.$Properties} message Text message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Text.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.body != null && $Object.hasOwnProperty.call(message, "body") && message.body !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.body);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.help);
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.wrap);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Text message from the specified reader or buffer.
     * @function decode
     * @memberof Text
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Text & Text.$Shape} Text
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Text.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Text();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.body = value;
                    else
                        delete message.body;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    message.wrap = reader.bool();
                    message._wrap = "wrap";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Text message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Text
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Text} Text
     */
    Text.fromObject = function (object, _depth) {
        if (object instanceof $root.Text)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Text: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Text();
        if (object.body != null)
            if (typeof object.body !== "string" || object.body.length)
                message.body = $String(object.body);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.wrap != null)
            message.wrap = $Boolean(object.wrap);
        return message;
    };

    /**
     * Creates a plain object from a Text message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Text
     * @static
     * @param {Text} message Text
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Text.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.body = "";
            object.help = "";
        }
        if (message.body != null && $Object.hasOwnProperty.call(message, "body"))
            object.body = message.body;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.wrap != null && $Object.hasOwnProperty.call(message, "wrap"))
            object.wrap = message.wrap;
        return object;
    };

    /**
     * Converts this Text to JSON.
     * @function toJSON
     * @memberof Text
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Text.prototype.toJSON = function() {
        return Text.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Text
     * @function getTypeUrl
     * @memberof Text
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Text.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Text";
    };

    return Text;
})();

export const TextArea = $root.TextArea = (() => {

    /**
     * Properties of a TextArea.
     * @typedef {Object} TextArea.$Properties
     * @property {string|null} [id] TextArea id
     * @property {string|null} [label] TextArea label
     * @property {string|null} ["default"] TextArea default
     * @property {number|null} [maxChars] TextArea maxChars
     * @property {string|null} [help] TextArea help
     * @property {string|null} [formId] TextArea formId
     * @property {string|null} [value] TextArea value
     * @property {boolean|null} [setValue] TextArea setValue
     * @property {string|null} [placeholder] TextArea placeholder
     * @property {boolean|null} [disabled] TextArea disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] TextArea labelVisibility
     * @property {string|null} [queryParamKey] TextArea queryParamKey
     * @property {boolean|null} [ignoreRerun] TextArea ignoreRerun
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a TextArea.
     * @exports ITextArea
     * @interface ITextArea
     * @augments TextArea.$Properties
     * @deprecated Use TextArea.$Properties instead.
     */

    /**
     * Shape of a TextArea.
     * @typedef {TextArea.$Properties} TextArea.$Shape
     */

    /**
     * Constructs a new TextArea.
     * @exports TextArea
     * @classdesc Represents a TextArea.
     * @constructor
     * @param {TextArea.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const TextArea = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * TextArea id.
     * @member {string} id
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.id = "";

    /**
     * TextArea label.
     * @member {string} label
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.label = "";

    /**
     * TextArea default.
     * @member {string|null|undefined} default
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype["default"] = null;

    /**
     * TextArea maxChars.
     * @member {number} maxChars
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.maxChars = 0;

    /**
     * TextArea help.
     * @member {string} help
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.help = "";

    /**
     * TextArea formId.
     * @member {string} formId
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.formId = "";

    /**
     * TextArea value.
     * @member {string|null|undefined} value
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.value = null;

    /**
     * TextArea setValue.
     * @member {boolean} setValue
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.setValue = false;

    /**
     * TextArea placeholder.
     * @member {string} placeholder
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.placeholder = "";

    /**
     * TextArea disabled.
     * @member {boolean} disabled
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.disabled = false;

    /**
     * TextArea labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.labelVisibility = null;

    /**
     * TextArea queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.queryParamKey = null;

    /**
     * TextArea ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof TextArea
     * @instance
     */
    TextArea.prototype.ignoreRerun = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TextArea.prototype, "_default", {
        get: $util.oneOfGetter($oneOfFields = ["default"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TextArea.prototype, "_value", {
        get: $util.oneOfGetter($oneOfFields = ["value"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TextArea.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new TextArea instance using the specified properties.
     * @function create
     * @memberof TextArea
     * @static
     * @param {TextArea.$Properties=} [properties] Properties to set
     * @returns {TextArea} TextArea instance
     * @type {{
     *   (properties: TextArea.$Shape): TextArea & TextArea.$Shape;
     *   (properties?: TextArea.$Properties): TextArea;
     * }}
     */
    TextArea.create = function(properties) {
        return new TextArea(properties);
    };

    /**
     * Encodes the specified TextArea message. Does not implicitly {@link TextArea.verify|verify} messages.
     * @function encode
     * @memberof TextArea
     * @static
     * @param {TextArea.$Properties} message TextArea message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TextArea.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message["default"]);
        if (message.maxChars != null && $Object.hasOwnProperty.call(message, "maxChars") && message.maxChars !== 0)
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.maxChars);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.formId);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.value);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.setValue);
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder") && message.placeholder !== "")
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.placeholder);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 12, wireType 2 =*/98).fork(), _depth + 1).ldelim();
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.queryParamKey);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.ignoreRerun);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a TextArea message from the specified reader or buffer.
     * @function decode
     * @memberof TextArea
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TextArea & TextArea.$Shape} TextArea
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TextArea.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.TextArea();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message["default"] = reader.stringVerify();
                    message._default = "default";
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message.maxChars = value;
                    else
                        delete message.maxChars;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    message.value = reader.stringVerify();
                    message._value = "value";
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.placeholder = value;
                    else
                        delete message.placeholder;
                    continue;
                }
            case 11: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 14: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a TextArea message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TextArea
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TextArea} TextArea
     */
    TextArea.fromObject = function (object, _depth) {
        if (object instanceof $root.TextArea)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".TextArea: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.TextArea();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"] != null)
            message["default"] = $String(object["default"]);
        if (object.maxChars != null)
            if ($Number(object.maxChars) !== 0)
                message.maxChars = object.maxChars >>> 0;
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.value != null)
            message.value = $String(object.value);
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.placeholder != null)
            if (typeof object.placeholder !== "string" || object.placeholder.length)
                message.placeholder = $String(object.placeholder);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".TextArea.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        return message;
    };

    /**
     * Creates a plain object from a TextArea message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TextArea
     * @static
     * @param {TextArea} message TextArea
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TextArea.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.maxChars = 0;
            object.help = "";
            object.formId = "";
            object.setValue = false;
            object.placeholder = "";
            object.disabled = false;
            object.labelVisibility = null;
            object.ignoreRerun = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.maxChars != null && $Object.hasOwnProperty.call(message, "maxChars"))
            object.maxChars = message.maxChars;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = message.value;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder"))
            object.placeholder = message.placeholder;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        return object;
    };

    /**
     * Converts this TextArea to JSON.
     * @function toJSON
     * @memberof TextArea
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TextArea.prototype.toJSON = function() {
        return TextArea.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for TextArea
     * @function getTypeUrl
     * @memberof TextArea
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    TextArea.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/TextArea";
    };

    return TextArea;
})();

export const TextInput = $root.TextInput = (() => {

    /**
     * Properties of a TextInput.
     * @typedef {Object} TextInput.$Properties
     * @property {string|null} [id] TextInput id
     * @property {string|null} [label] TextInput label
     * @property {string|null} ["default"] TextInput default
     * @property {TextInput.Type|null} [type] TextInput type
     * @property {number|null} [maxChars] TextInput maxChars
     * @property {string|null} [help] TextInput help
     * @property {string|null} [formId] TextInput formId
     * @property {string|null} [value] TextInput value
     * @property {boolean|null} [setValue] TextInput setValue
     * @property {string|null} [autocomplete] TextInput autocomplete
     * @property {string|null} [placeholder] TextInput placeholder
     * @property {boolean|null} [disabled] TextInput disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] TextInput labelVisibility
     * @property {string|null} [icon] TextInput icon
     * @property {string|null} [queryParamKey] TextInput queryParamKey
     * @property {string|null} [validateRegex] TextInput validateRegex
     * @property {string|null} [validateMessage] TextInput validateMessage
     * @property {boolean|null} [ignoreRerun] TextInput ignoreRerun
     * @property {number|null} [liveDebounceMs] TextInput liveDebounceMs
     * @property {boolean|null} [required] TextInput required
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a TextInput.
     * @exports ITextInput
     * @interface ITextInput
     * @augments TextInput.$Properties
     * @deprecated Use TextInput.$Properties instead.
     */

    /**
     * Shape of a TextInput.
     * @typedef {TextInput.$Properties} TextInput.$Shape
     */

    /**
     * Constructs a new TextInput.
     * @exports TextInput
     * @classdesc Represents a TextInput.
     * @constructor
     * @param {TextInput.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const TextInput = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * TextInput id.
     * @member {string} id
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.id = "";

    /**
     * TextInput label.
     * @member {string} label
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.label = "";

    /**
     * TextInput default.
     * @member {string|null|undefined} default
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype["default"] = null;

    /**
     * TextInput type.
     * @member {TextInput.Type} type
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.type = 0;

    /**
     * TextInput maxChars.
     * @member {number} maxChars
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.maxChars = 0;

    /**
     * TextInput help.
     * @member {string} help
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.help = "";

    /**
     * TextInput formId.
     * @member {string} formId
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.formId = "";

    /**
     * TextInput value.
     * @member {string|null|undefined} value
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.value = null;

    /**
     * TextInput setValue.
     * @member {boolean} setValue
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.setValue = false;

    /**
     * TextInput autocomplete.
     * @member {string} autocomplete
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.autocomplete = "";

    /**
     * TextInput placeholder.
     * @member {string} placeholder
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.placeholder = "";

    /**
     * TextInput disabled.
     * @member {boolean} disabled
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.disabled = false;

    /**
     * TextInput labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.labelVisibility = null;

    /**
     * TextInput icon.
     * @member {string} icon
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.icon = "";

    /**
     * TextInput queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.queryParamKey = null;

    /**
     * TextInput validateRegex.
     * @member {string|null|undefined} validateRegex
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.validateRegex = null;

    /**
     * TextInput validateMessage.
     * @member {string|null|undefined} validateMessage
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.validateMessage = null;

    /**
     * TextInput ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.ignoreRerun = false;

    /**
     * TextInput liveDebounceMs.
     * @member {number|null|undefined} liveDebounceMs
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.liveDebounceMs = null;

    /**
     * TextInput required.
     * @member {boolean} required
     * @memberof TextInput
     * @instance
     */
    TextInput.prototype.required = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TextInput.prototype, "_default", {
        get: $util.oneOfGetter($oneOfFields = ["default"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TextInput.prototype, "_value", {
        get: $util.oneOfGetter($oneOfFields = ["value"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TextInput.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TextInput.prototype, "_validateRegex", {
        get: $util.oneOfGetter($oneOfFields = ["validateRegex"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TextInput.prototype, "_validateMessage", {
        get: $util.oneOfGetter($oneOfFields = ["validateMessage"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TextInput.prototype, "_liveDebounceMs", {
        get: $util.oneOfGetter($oneOfFields = ["liveDebounceMs"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new TextInput instance using the specified properties.
     * @function create
     * @memberof TextInput
     * @static
     * @param {TextInput.$Properties=} [properties] Properties to set
     * @returns {TextInput} TextInput instance
     * @type {{
     *   (properties: TextInput.$Shape): TextInput & TextInput.$Shape;
     *   (properties?: TextInput.$Properties): TextInput;
     * }}
     */
    TextInput.create = function(properties) {
        return new TextInput(properties);
    };

    /**
     * Encodes the specified TextInput message. Does not implicitly {@link TextInput.verify|verify} messages.
     * @function encode
     * @memberof TextInput
     * @static
     * @param {TextInput.$Properties} message TextInput message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TextInput.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message["default"]);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== 0)
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
        if (message.maxChars != null && $Object.hasOwnProperty.call(message, "maxChars") && message.maxChars !== 0)
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.maxChars);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.formId);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.value);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.setValue);
        if (message.autocomplete != null && $Object.hasOwnProperty.call(message, "autocomplete") && message.autocomplete !== "")
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.autocomplete);
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder") && message.placeholder !== "")
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.placeholder);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 13, wireType 2 =*/106).fork(), _depth + 1).ldelim();
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.icon);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.queryParamKey);
        if (message.validateRegex != null && $Object.hasOwnProperty.call(message, "validateRegex"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.validateRegex);
        if (message.validateMessage != null && $Object.hasOwnProperty.call(message, "validateMessage"))
            writer.uint32(/* id 17, wireType 2 =*/138).string(message.validateMessage);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 18, wireType 0 =*/144).bool(message.ignoreRerun);
        if (message.liveDebounceMs != null && $Object.hasOwnProperty.call(message, "liveDebounceMs"))
            writer.uint32(/* id 19, wireType 0 =*/152).uint32(message.liveDebounceMs);
        if (message.required != null && $Object.hasOwnProperty.call(message, "required") && message.required !== false)
            writer.uint32(/* id 20, wireType 0 =*/160).bool(message.required);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a TextInput message from the specified reader or buffer.
     * @function decode
     * @memberof TextInput
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TextInput & TextInput.$Shape} TextInput
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TextInput.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.TextInput();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message["default"] = reader.stringVerify();
                    message._default = "default";
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.uint32())
                        message.maxChars = value;
                    else
                        delete message.maxChars;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    message.value = reader.stringVerify();
                    message._value = "value";
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.autocomplete = value;
                    else
                        delete message.autocomplete;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.placeholder = value;
                    else
                        delete message.placeholder;
                    continue;
                }
            case 12: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            case 15: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 16: {
                    if (wireType !== 2)
                        break;
                    message.validateRegex = reader.stringVerify();
                    message._validateRegex = "validateRegex";
                    continue;
                }
            case 17: {
                    if (wireType !== 2)
                        break;
                    message.validateMessage = reader.stringVerify();
                    message._validateMessage = "validateMessage";
                    continue;
                }
            case 18: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            case 19: {
                    if (wireType !== 0)
                        break;
                    message.liveDebounceMs = reader.uint32();
                    message._liveDebounceMs = "liveDebounceMs";
                    continue;
                }
            case 20: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.required = value;
                    else
                        delete message.required;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a TextInput message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TextInput
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TextInput} TextInput
     */
    TextInput.fromObject = function (object, _depth) {
        if (object instanceof $root.TextInput)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".TextInput: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.TextInput();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"] != null)
            message["default"] = $String(object["default"]);
        if (object.type !== 0 && (typeof object.type !== "string" || $root.TextInput.Type[object.type] !== 0))
            switch (object.type) {
            case "DEFAULT":
            case 0:
                message.type = 0;
                break;
            case "PASSWORD":
            case 1:
                message.type = 1;
                break;
            case "EMAIL":
            case 2:
                message.type = 2;
                break;
            case "URL":
            case 3:
                message.type = 3;
                break;
            case "PHONE":
            case 4:
                message.type = 4;
                break;
            case "SEARCH":
            case 5:
                message.type = 5;
                break;
            default:
                if (typeof object.type === "number" && (object.type | 0) === object.type)
                    message.type = object.type;
            }
        if (object.maxChars != null)
            if ($Number(object.maxChars) !== 0)
                message.maxChars = object.maxChars >>> 0;
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.value != null)
            message.value = $String(object.value);
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.autocomplete != null)
            if (typeof object.autocomplete !== "string" || object.autocomplete.length)
                message.autocomplete = $String(object.autocomplete);
        if (object.placeholder != null)
            if (typeof object.placeholder !== "string" || object.placeholder.length)
                message.placeholder = $String(object.placeholder);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".TextInput.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.validateRegex != null)
            message.validateRegex = $String(object.validateRegex);
        if (object.validateMessage != null)
            message.validateMessage = $String(object.validateMessage);
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        if (object.liveDebounceMs != null)
            message.liveDebounceMs = object.liveDebounceMs >>> 0;
        if (object.required != null)
            if (object.required)
                message.required = $Boolean(object.required);
        return message;
    };

    /**
     * Creates a plain object from a TextInput message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TextInput
     * @static
     * @param {TextInput} message TextInput
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TextInput.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.type = options.enums === $String ? "DEFAULT" : 0;
            object.maxChars = 0;
            object.help = "";
            object.formId = "";
            object.setValue = false;
            object.autocomplete = "";
            object.placeholder = "";
            object.disabled = false;
            object.labelVisibility = null;
            object.icon = "";
            object.ignoreRerun = false;
            object.required = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = options.enums === $String ? $root.TextInput.Type[message.type] === $undefined ? message.type : $root.TextInput.Type[message.type] : message.type;
        if (message.maxChars != null && $Object.hasOwnProperty.call(message, "maxChars"))
            object.maxChars = message.maxChars;
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = message.value;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.autocomplete != null && $Object.hasOwnProperty.call(message, "autocomplete"))
            object.autocomplete = message.autocomplete;
        if (message.placeholder != null && $Object.hasOwnProperty.call(message, "placeholder"))
            object.placeholder = message.placeholder;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.validateRegex != null && $Object.hasOwnProperty.call(message, "validateRegex"))
            object.validateRegex = message.validateRegex;
        if (message.validateMessage != null && $Object.hasOwnProperty.call(message, "validateMessage"))
            object.validateMessage = message.validateMessage;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        if (message.liveDebounceMs != null && $Object.hasOwnProperty.call(message, "liveDebounceMs"))
            object.liveDebounceMs = message.liveDebounceMs;
        if (message.required != null && $Object.hasOwnProperty.call(message, "required"))
            object.required = message.required;
        return object;
    };

    /**
     * Converts this TextInput to JSON.
     * @function toJSON
     * @memberof TextInput
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TextInput.prototype.toJSON = function() {
        return TextInput.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for TextInput
     * @function getTypeUrl
     * @memberof TextInput
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    TextInput.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/TextInput";
    };

    /**
     * Type enum.
     * @name TextInput.Type
     * @enum {number}
     * @property {number} DEFAULT=0 DEFAULT value
     * @property {number} PASSWORD=1 PASSWORD value
     * @property {number} EMAIL=2 EMAIL value
     * @property {number} URL=3 URL value
     * @property {number} PHONE=4 PHONE value
     * @property {number} SEARCH=5 SEARCH value
     */
    TextInput.Type = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "DEFAULT"] = 0;
        values[valuesById[1] = "PASSWORD"] = 1;
        values[valuesById[2] = "EMAIL"] = 2;
        values[valuesById[3] = "URL"] = 3;
        values[valuesById[4] = "PHONE"] = 4;
        values[valuesById[5] = "SEARCH"] = 5;
        return values;
    })();

    return TextInput;
})();

export const TimeInput = $root.TimeInput = (() => {

    /**
     * Properties of a TimeInput.
     * @typedef {Object} TimeInput.$Properties
     * @property {string|null} [id] TimeInput id
     * @property {string|null} [label] TimeInput label
     * @property {string|null} ["default"] TimeInput default
     * @property {string|null} [help] TimeInput help
     * @property {string|null} [formId] TimeInput formId
     * @property {string|null} [value] TimeInput value
     * @property {boolean|null} [setValue] TimeInput setValue
     * @property {boolean|null} [disabled] TimeInput disabled
     * @property {LabelVisibility.$Properties|null} [labelVisibility] TimeInput labelVisibility
     * @property {number|Long|null} [step] TimeInput step
     * @property {string|null} [queryParamKey] TimeInput queryParamKey
     * @property {string|null} [format] TimeInput format
     * @property {boolean|null} [ignoreRerun] TimeInput ignoreRerun
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a TimeInput.
     * @exports ITimeInput
     * @interface ITimeInput
     * @augments TimeInput.$Properties
     * @deprecated Use TimeInput.$Properties instead.
     */

    /**
     * Shape of a TimeInput.
     * @typedef {TimeInput.$Properties} TimeInput.$Shape
     */

    /**
     * Constructs a new TimeInput.
     * @exports TimeInput
     * @classdesc Represents a TimeInput.
     * @constructor
     * @param {TimeInput.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const TimeInput = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * TimeInput id.
     * @member {string} id
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.id = "";

    /**
     * TimeInput label.
     * @member {string} label
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.label = "";

    /**
     * TimeInput default.
     * @member {string|null|undefined} default
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype["default"] = null;

    /**
     * TimeInput help.
     * @member {string} help
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.help = "";

    /**
     * TimeInput formId.
     * @member {string} formId
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.formId = "";

    /**
     * TimeInput value.
     * @member {string|null|undefined} value
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.value = null;

    /**
     * TimeInput setValue.
     * @member {boolean} setValue
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.setValue = false;

    /**
     * TimeInput disabled.
     * @member {boolean} disabled
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.disabled = false;

    /**
     * TimeInput labelVisibility.
     * @member {LabelVisibility.$Properties|null|undefined} labelVisibility
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.labelVisibility = null;

    /**
     * TimeInput step.
     * @member {number|Long} step
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.step = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * TimeInput queryParamKey.
     * @member {string|null|undefined} queryParamKey
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.queryParamKey = null;

    /**
     * TimeInput format.
     * @member {string|null|undefined} format
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.format = null;

    /**
     * TimeInput ignoreRerun.
     * @member {boolean} ignoreRerun
     * @memberof TimeInput
     * @instance
     */
    TimeInput.prototype.ignoreRerun = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TimeInput.prototype, "_default", {
        get: $util.oneOfGetter($oneOfFields = ["default"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TimeInput.prototype, "_value", {
        get: $util.oneOfGetter($oneOfFields = ["value"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TimeInput.prototype, "_queryParamKey", {
        get: $util.oneOfGetter($oneOfFields = ["queryParamKey"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(TimeInput.prototype, "_format", {
        get: $util.oneOfGetter($oneOfFields = ["format"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new TimeInput instance using the specified properties.
     * @function create
     * @memberof TimeInput
     * @static
     * @param {TimeInput.$Properties=} [properties] Properties to set
     * @returns {TimeInput} TimeInput instance
     * @type {{
     *   (properties: TimeInput.$Shape): TimeInput & TimeInput.$Shape;
     *   (properties?: TimeInput.$Properties): TimeInput;
     * }}
     */
    TimeInput.create = function(properties) {
        return new TimeInput(properties);
    };

    /**
     * Encodes the specified TimeInput message. Does not implicitly {@link TimeInput.verify|verify} messages.
     * @function encode
     * @memberof TimeInput
     * @static
     * @param {TimeInput.$Properties} message TimeInput message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TimeInput.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message["default"]);
        if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.help);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.formId);
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.value);
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue") && message.setValue !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.setValue);
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled") && message.disabled !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.disabled);
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            $root.LabelVisibility.encode(message.labelVisibility, writer.uint32(/* id 9, wireType 2 =*/74).fork(), _depth + 1).ldelim();
        if (message.step != null && $Object.hasOwnProperty.call(message, "step") && (typeof message.step === "object" ? message.step.low || message.step.high : message.step !== 0))
            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.step);
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.queryParamKey);
        if (message.format != null && $Object.hasOwnProperty.call(message, "format"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.format);
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun") && message.ignoreRerun !== false)
            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.ignoreRerun);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a TimeInput message from the specified reader or buffer.
     * @function decode
     * @memberof TimeInput
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TimeInput & TimeInput.$Shape} TimeInput
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TimeInput.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.TimeInput();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message["default"] = reader.stringVerify();
                    message._default = "default";
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.help = value;
                    else
                        delete message.help;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.value = reader.stringVerify();
                    message._value = "value";
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.setValue = value;
                    else
                        delete message.setValue;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disabled = value;
                    else
                        delete message.disabled;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    message.labelVisibility = $root.LabelVisibility.decode(reader, reader.uint32(), $undefined, _depth + 1, message.labelVisibility);
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                        message.step = value;
                    else
                        delete message.step;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.queryParamKey = reader.stringVerify();
                    message._queryParamKey = "queryParamKey";
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.format = reader.stringVerify();
                    message._format = "format";
                    continue;
                }
            case 13: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.ignoreRerun = value;
                    else
                        delete message.ignoreRerun;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a TimeInput message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TimeInput
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TimeInput} TimeInput
     */
    TimeInput.fromObject = function (object, _depth) {
        if (object instanceof $root.TimeInput)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".TimeInput: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.TimeInput();
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object["default"] != null)
            message["default"] = $String(object["default"]);
        if (object.help != null)
            if (typeof object.help !== "string" || object.help.length)
                message.help = $String(object.help);
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.value != null)
            message.value = $String(object.value);
        if (object.setValue != null)
            if (object.setValue)
                message.setValue = $Boolean(object.setValue);
        if (object.disabled != null)
            if (object.disabled)
                message.disabled = $Boolean(object.disabled);
        if (object.labelVisibility != null) {
            if (!$util.isObject(object.labelVisibility))
                throw $TypeError(".TimeInput.labelVisibility: object expected");
            message.labelVisibility = $root.LabelVisibility.fromObject(object.labelVisibility, _depth + 1);
        }
        if (object.step != null)
            if (typeof object.step === "object" ? object.step.low || object.step.high : $Number(object.step) !== 0)
                if ($util.Long)
                    message.step = $util.Long.fromValue(object.step, false);
                else if (typeof object.step === "string")
                    message.step = $parseInt(object.step, 10);
                else if (typeof object.step === "number")
                    message.step = object.step;
                else if (typeof object.step === "object")
                    message.step = new $util.LongBits(object.step.low >>> 0, object.step.high >>> 0).toNumber();
        if (object.queryParamKey != null)
            message.queryParamKey = $String(object.queryParamKey);
        if (object.format != null)
            message.format = $String(object.format);
        if (object.ignoreRerun != null)
            if (object.ignoreRerun)
                message.ignoreRerun = $Boolean(object.ignoreRerun);
        return message;
    };

    /**
     * Creates a plain object from a TimeInput message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TimeInput
     * @static
     * @param {TimeInput} message TimeInput
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TimeInput.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.label = "";
            object.help = "";
            object.formId = "";
            object.setValue = false;
            object.disabled = false;
            object.labelVisibility = null;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.step = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.step = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            object.ignoreRerun = false;
        }
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message["default"] != null && $Object.hasOwnProperty.call(message, "default"))
            object["default"] = message["default"];
        if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
            object.help = message.help;
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
            object.value = message.value;
        if (message.setValue != null && $Object.hasOwnProperty.call(message, "setValue"))
            object.setValue = message.setValue;
        if (message.disabled != null && $Object.hasOwnProperty.call(message, "disabled"))
            object.disabled = message.disabled;
        if (message.labelVisibility != null && $Object.hasOwnProperty.call(message, "labelVisibility"))
            object.labelVisibility = $root.LabelVisibility.toObject(message.labelVisibility, options, _depth + 1);
        if (message.step != null && $Object.hasOwnProperty.call(message, "step"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.step = typeof message.step === "number" ? $BigInt(message.step) : $util.Long.fromBits(message.step.low >>> 0, message.step.high >>> 0, false).toBigInt();
            else if (typeof message.step === "number")
                object.step = options.longs === $String ? $String(message.step) : message.step;
            else
                object.step = options.longs === $String ? $util.Long.prototype.toString.call(message.step) : options.longs === $Number ? new $util.LongBits(message.step.low >>> 0, message.step.high >>> 0).toNumber() : message.step;
        if (message.queryParamKey != null && $Object.hasOwnProperty.call(message, "queryParamKey"))
            object.queryParamKey = message.queryParamKey;
        if (message.format != null && $Object.hasOwnProperty.call(message, "format"))
            object.format = message.format;
        if (message.ignoreRerun != null && $Object.hasOwnProperty.call(message, "ignoreRerun"))
            object.ignoreRerun = message.ignoreRerun;
        return object;
    };

    /**
     * Converts this TimeInput to JSON.
     * @function toJSON
     * @memberof TimeInput
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TimeInput.prototype.toJSON = function() {
        return TimeInput.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for TimeInput
     * @function getTypeUrl
     * @memberof TimeInput
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    TimeInput.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/TimeInput";
    };

    return TimeInput;
})();

export const Toast = $root.Toast = (() => {

    /**
     * Properties of a Toast.
     * @typedef {Object} Toast.$Properties
     * @property {string|null} [body] Toast body
     * @property {string|null} [icon] Toast icon
     * @property {number|null} [duration] Toast duration
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Toast.
     * @exports IToast
     * @interface IToast
     * @augments Toast.$Properties
     * @deprecated Use Toast.$Properties instead.
     */

    /**
     * Shape of a Toast.
     * @typedef {Toast.$Properties} Toast.$Shape
     */

    /**
     * Constructs a new Toast.
     * @exports Toast
     * @classdesc Represents a Toast.
     * @constructor
     * @param {Toast.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Toast = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Toast body.
     * @member {string} body
     * @memberof Toast
     * @instance
     */
    Toast.prototype.body = "";

    /**
     * Toast icon.
     * @member {string} icon
     * @memberof Toast
     * @instance
     */
    Toast.prototype.icon = "";

    /**
     * Toast duration.
     * @member {number|null|undefined} duration
     * @memberof Toast
     * @instance
     */
    Toast.prototype.duration = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Toast.prototype, "_duration", {
        get: $util.oneOfGetter($oneOfFields = ["duration"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Toast instance using the specified properties.
     * @function create
     * @memberof Toast
     * @static
     * @param {Toast.$Properties=} [properties] Properties to set
     * @returns {Toast} Toast instance
     * @type {{
     *   (properties: Toast.$Shape): Toast & Toast.$Shape;
     *   (properties?: Toast.$Properties): Toast;
     * }}
     */
    Toast.create = function(properties) {
        return new Toast(properties);
    };

    /**
     * Encodes the specified Toast message. Does not implicitly {@link Toast.verify|verify} messages.
     * @function encode
     * @memberof Toast
     * @static
     * @param {Toast.$Properties} message Toast message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Toast.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.body != null && $Object.hasOwnProperty.call(message, "body") && message.body !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.body);
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon") && message.icon !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.icon);
        if (message.duration != null && $Object.hasOwnProperty.call(message, "duration"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.duration);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Toast message from the specified reader or buffer.
     * @function decode
     * @memberof Toast
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Toast & Toast.$Shape} Toast
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Toast.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Toast();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.body = value;
                    else
                        delete message.body;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.icon = value;
                    else
                        delete message.icon;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    message.duration = reader.int32();
                    message._duration = "duration";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Toast message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Toast
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Toast} Toast
     */
    Toast.fromObject = function (object, _depth) {
        if (object instanceof $root.Toast)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Toast: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Toast();
        if (object.body != null)
            if (typeof object.body !== "string" || object.body.length)
                message.body = $String(object.body);
        if (object.icon != null)
            if (typeof object.icon !== "string" || object.icon.length)
                message.icon = $String(object.icon);
        if (object.duration != null)
            message.duration = object.duration | 0;
        return message;
    };

    /**
     * Creates a plain object from a Toast message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Toast
     * @static
     * @param {Toast} message Toast
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Toast.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.body = "";
            object.icon = "";
        }
        if (message.body != null && $Object.hasOwnProperty.call(message, "body"))
            object.body = message.body;
        if (message.icon != null && $Object.hasOwnProperty.call(message, "icon"))
            object.icon = message.icon;
        if (message.duration != null && $Object.hasOwnProperty.call(message, "duration"))
            object.duration = message.duration;
        return object;
    };

    /**
     * Converts this Toast to JSON.
     * @function toJSON
     * @memberof Toast
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Toast.prototype.toJSON = function() {
        return Toast.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Toast
     * @function getTypeUrl
     * @memberof Toast
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Toast.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Toast";
    };

    return Toast;
})();

export const VegaLiteChart = $root.VegaLiteChart = (() => {

    /**
     * Properties of a VegaLiteChart.
     * @typedef {Object} VegaLiteChart.$Properties
     * @property {string|null} [spec] VegaLiteChart spec
     * @property {ArrowData.$Properties|null} [data] VegaLiteChart data
     * @property {Array.<ArrowNamedDataSet.$Properties>|null} [datasets] VegaLiteChart datasets
     * @property {boolean|null} [useContainerWidth] VegaLiteChart useContainerWidth
     * @property {string|null} [theme] VegaLiteChart theme
     * @property {string|null} [id] VegaLiteChart id
     * @property {Array.<string>|null} [selectionMode] VegaLiteChart selectionMode
     * @property {string|null} [formId] VegaLiteChart formId
     * @property {string|null} [alt] VegaLiteChart alt
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a VegaLiteChart.
     * @exports IVegaLiteChart
     * @interface IVegaLiteChart
     * @augments VegaLiteChart.$Properties
     * @deprecated Use VegaLiteChart.$Properties instead.
     */

    /**
     * Shape of a VegaLiteChart.
     * @typedef {VegaLiteChart.$Properties} VegaLiteChart.$Shape
     */

    /**
     * Constructs a new VegaLiteChart.
     * @exports VegaLiteChart
     * @classdesc Represents a VegaLiteChart.
     * @constructor
     * @param {VegaLiteChart.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const VegaLiteChart = function (properties) {
        this.datasets = [];
        this.selectionMode = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * VegaLiteChart spec.
     * @member {string} spec
     * @memberof VegaLiteChart
     * @instance
     */
    VegaLiteChart.prototype.spec = "";

    /**
     * VegaLiteChart data.
     * @member {ArrowData.$Properties|null|undefined} data
     * @memberof VegaLiteChart
     * @instance
     */
    VegaLiteChart.prototype.data = null;

    /**
     * VegaLiteChart datasets.
     * @member {Array.<ArrowNamedDataSet.$Properties>} datasets
     * @memberof VegaLiteChart
     * @instance
     */
    VegaLiteChart.prototype.datasets = $util.emptyArray;

    /**
     * VegaLiteChart useContainerWidth.
     * @member {boolean} useContainerWidth
     * @memberof VegaLiteChart
     * @instance
     */
    VegaLiteChart.prototype.useContainerWidth = false;

    /**
     * VegaLiteChart theme.
     * @member {string} theme
     * @memberof VegaLiteChart
     * @instance
     */
    VegaLiteChart.prototype.theme = "";

    /**
     * VegaLiteChart id.
     * @member {string} id
     * @memberof VegaLiteChart
     * @instance
     */
    VegaLiteChart.prototype.id = "";

    /**
     * VegaLiteChart selectionMode.
     * @member {Array.<string>} selectionMode
     * @memberof VegaLiteChart
     * @instance
     */
    VegaLiteChart.prototype.selectionMode = $util.emptyArray;

    /**
     * VegaLiteChart formId.
     * @member {string} formId
     * @memberof VegaLiteChart
     * @instance
     */
    VegaLiteChart.prototype.formId = "";

    /**
     * VegaLiteChart alt.
     * @member {string|null|undefined} alt
     * @memberof VegaLiteChart
     * @instance
     */
    VegaLiteChart.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(VegaLiteChart.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new VegaLiteChart instance using the specified properties.
     * @function create
     * @memberof VegaLiteChart
     * @static
     * @param {VegaLiteChart.$Properties=} [properties] Properties to set
     * @returns {VegaLiteChart} VegaLiteChart instance
     * @type {{
     *   (properties: VegaLiteChart.$Shape): VegaLiteChart & VegaLiteChart.$Shape;
     *   (properties?: VegaLiteChart.$Properties): VegaLiteChart;
     * }}
     */
    VegaLiteChart.create = function(properties) {
        return new VegaLiteChart(properties);
    };

    /**
     * Encodes the specified VegaLiteChart message. Does not implicitly {@link VegaLiteChart.verify|verify} messages.
     * @function encode
     * @memberof VegaLiteChart
     * @static
     * @param {VegaLiteChart.$Properties} message VegaLiteChart message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VegaLiteChart.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.spec != null && $Object.hasOwnProperty.call(message, "spec") && message.spec !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.spec);
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            $root.ArrowData.encode(message.data, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.datasets != null && message.datasets.length)
            for (let i = 0; i < message.datasets.length; ++i)
                $root.ArrowNamedDataSet.encode(message.datasets[i], writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
        if (message.useContainerWidth != null && $Object.hasOwnProperty.call(message, "useContainerWidth") && message.useContainerWidth !== false)
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.useContainerWidth);
        if (message.theme != null && $Object.hasOwnProperty.call(message, "theme") && message.theme !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.theme);
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.id);
        if (message.selectionMode != null && message.selectionMode.length)
            for (let i = 0; i < message.selectionMode.length; ++i)
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.selectionMode[i]);
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId") && message.formId !== "")
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.formId);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a VegaLiteChart message from the specified reader or buffer.
     * @function decode
     * @memberof VegaLiteChart
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {VegaLiteChart & VegaLiteChart.$Shape} VegaLiteChart
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VegaLiteChart.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.VegaLiteChart();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.spec = value;
                    else
                        delete message.spec;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    message.data = $root.ArrowData.decode(reader, reader.uint32(), $undefined, _depth + 1, message.data);
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if (!(message.datasets && message.datasets.length))
                        message.datasets = [];
                    message.datasets.push($root.ArrowNamedDataSet.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.useContainerWidth = value;
                    else
                        delete message.useContainerWidth;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.theme = value;
                    else
                        delete message.theme;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    if (!(message.selectionMode && message.selectionMode.length))
                        message.selectionMode = [];
                    message.selectionMode.push(reader.stringVerify());
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.formId = value;
                    else
                        delete message.formId;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a VegaLiteChart message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof VegaLiteChart
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {VegaLiteChart} VegaLiteChart
     */
    VegaLiteChart.fromObject = function (object, _depth) {
        if (object instanceof $root.VegaLiteChart)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".VegaLiteChart: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.VegaLiteChart();
        if (object.spec != null)
            if (typeof object.spec !== "string" || object.spec.length)
                message.spec = $String(object.spec);
        if (object.data != null) {
            if (!$util.isObject(object.data))
                throw $TypeError(".VegaLiteChart.data: object expected");
            message.data = $root.ArrowData.fromObject(object.data, _depth + 1);
        }
        if (object.datasets) {
            if (!$Array.isArray(object.datasets))
                throw $TypeError(".VegaLiteChart.datasets: array expected");
            message.datasets = $Array(object.datasets.length);
            for (let i = 0; i < object.datasets.length; ++i) {
                if (!$util.isObject(object.datasets[i]))
                    throw $TypeError(".VegaLiteChart.datasets: object expected");
                message.datasets[i] = $root.ArrowNamedDataSet.fromObject(object.datasets[i], _depth + 1);
            }
        }
        if (object.useContainerWidth != null)
            if (object.useContainerWidth)
                message.useContainerWidth = $Boolean(object.useContainerWidth);
        if (object.theme != null)
            if (typeof object.theme !== "string" || object.theme.length)
                message.theme = $String(object.theme);
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.selectionMode) {
            if (!$Array.isArray(object.selectionMode))
                throw $TypeError(".VegaLiteChart.selectionMode: array expected");
            message.selectionMode = $Array(object.selectionMode.length);
            for (let i = 0; i < object.selectionMode.length; ++i)
                message.selectionMode[i] = $String(object.selectionMode[i]);
        }
        if (object.formId != null)
            if (typeof object.formId !== "string" || object.formId.length)
                message.formId = $String(object.formId);
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from a VegaLiteChart message. Also converts values to other types if specified.
     * @function toObject
     * @memberof VegaLiteChart
     * @static
     * @param {VegaLiteChart} message VegaLiteChart
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    VegaLiteChart.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object.datasets = [];
            object.selectionMode = [];
        }
        if (options.defaults) {
            object.spec = "";
            object.data = null;
            object.useContainerWidth = false;
            object.theme = "";
            object.id = "";
            object.formId = "";
        }
        if (message.spec != null && $Object.hasOwnProperty.call(message, "spec"))
            object.spec = message.spec;
        if (message.data != null && $Object.hasOwnProperty.call(message, "data"))
            object.data = $root.ArrowData.toObject(message.data, options, _depth + 1);
        if (message.datasets && message.datasets.length) {
            object.datasets = $Array(message.datasets.length);
            for (let j = 0; j < message.datasets.length; ++j)
                object.datasets[j] = $root.ArrowNamedDataSet.toObject(message.datasets[j], options, _depth + 1);
        }
        if (message.useContainerWidth != null && $Object.hasOwnProperty.call(message, "useContainerWidth"))
            object.useContainerWidth = message.useContainerWidth;
        if (message.theme != null && $Object.hasOwnProperty.call(message, "theme"))
            object.theme = message.theme;
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.selectionMode && message.selectionMode.length) {
            object.selectionMode = $Array(message.selectionMode.length);
            for (let j = 0; j < message.selectionMode.length; ++j)
                object.selectionMode[j] = message.selectionMode[j];
        }
        if (message.formId != null && $Object.hasOwnProperty.call(message, "formId"))
            object.formId = message.formId;
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this VegaLiteChart to JSON.
     * @function toJSON
     * @memberof VegaLiteChart
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    VegaLiteChart.prototype.toJSON = function() {
        return VegaLiteChart.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for VegaLiteChart
     * @function getTypeUrl
     * @memberof VegaLiteChart
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    VegaLiteChart.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/VegaLiteChart";
    };

    return VegaLiteChart;
})();

export const SubtitleTrack = $root.SubtitleTrack = (() => {

    /**
     * Properties of a SubtitleTrack.
     * @typedef {Object} SubtitleTrack.$Properties
     * @property {string|null} [label] SubtitleTrack label
     * @property {string|null} [url] SubtitleTrack url
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a SubtitleTrack.
     * @exports ISubtitleTrack
     * @interface ISubtitleTrack
     * @augments SubtitleTrack.$Properties
     * @deprecated Use SubtitleTrack.$Properties instead.
     */

    /**
     * Shape of a SubtitleTrack.
     * @typedef {SubtitleTrack.$Properties} SubtitleTrack.$Shape
     */

    /**
     * Constructs a new SubtitleTrack.
     * @exports SubtitleTrack
     * @classdesc Represents a SubtitleTrack.
     * @constructor
     * @param {SubtitleTrack.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const SubtitleTrack = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * SubtitleTrack label.
     * @member {string} label
     * @memberof SubtitleTrack
     * @instance
     */
    SubtitleTrack.prototype.label = "";

    /**
     * SubtitleTrack url.
     * @member {string} url
     * @memberof SubtitleTrack
     * @instance
     */
    SubtitleTrack.prototype.url = "";

    /**
     * Creates a new SubtitleTrack instance using the specified properties.
     * @function create
     * @memberof SubtitleTrack
     * @static
     * @param {SubtitleTrack.$Properties=} [properties] Properties to set
     * @returns {SubtitleTrack} SubtitleTrack instance
     * @type {{
     *   (properties: SubtitleTrack.$Shape): SubtitleTrack & SubtitleTrack.$Shape;
     *   (properties?: SubtitleTrack.$Properties): SubtitleTrack;
     * }}
     */
    SubtitleTrack.create = function(properties) {
        return new SubtitleTrack(properties);
    };

    /**
     * Encodes the specified SubtitleTrack message. Does not implicitly {@link SubtitleTrack.verify|verify} messages.
     * @function encode
     * @memberof SubtitleTrack
     * @static
     * @param {SubtitleTrack.$Properties} message SubtitleTrack message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubtitleTrack.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.label);
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.url);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a SubtitleTrack message from the specified reader or buffer.
     * @function decode
     * @memberof SubtitleTrack
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SubtitleTrack & SubtitleTrack.$Shape} SubtitleTrack
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubtitleTrack.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.SubtitleTrack();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a SubtitleTrack message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SubtitleTrack
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SubtitleTrack} SubtitleTrack
     */
    SubtitleTrack.fromObject = function (object, _depth) {
        if (object instanceof $root.SubtitleTrack)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".SubtitleTrack: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.SubtitleTrack();
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        return message;
    };

    /**
     * Creates a plain object from a SubtitleTrack message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SubtitleTrack
     * @static
     * @param {SubtitleTrack} message SubtitleTrack
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SubtitleTrack.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.label = "";
            object.url = "";
        }
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        return object;
    };

    /**
     * Converts this SubtitleTrack to JSON.
     * @function toJSON
     * @memberof SubtitleTrack
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SubtitleTrack.prototype.toJSON = function() {
        return SubtitleTrack.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for SubtitleTrack
     * @function getTypeUrl
     * @memberof SubtitleTrack
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    SubtitleTrack.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/SubtitleTrack";
    };

    return SubtitleTrack;
})();

export const Video = $root.Video = (() => {

    /**
     * Properties of a Video.
     * @typedef {Object} Video.$Properties
     * @property {string|null} [url] Video url
     * @property {number|null} [startTime] Video startTime
     * @property {Video.Type|null} [type] Video type
     * @property {Array.<SubtitleTrack.$Properties>|null} [subtitles] Video subtitles
     * @property {number|null} [endTime] Video endTime
     * @property {boolean|null} [loop] Video loop
     * @property {boolean|null} [autoplay] Video autoplay
     * @property {boolean|null} [muted] Video muted
     * @property {string|null} [id] Video id
     * @property {streamlit.WidthConfig.$Properties|null} [widthConfig] Video widthConfig
     * @property {string|null} [alt] Video alt
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Video.
     * @exports IVideo
     * @interface IVideo
     * @augments Video.$Properties
     * @deprecated Use Video.$Properties instead.
     */

    /**
     * Shape of a Video.
     * @typedef {{
     *   url?: string|null;
     *   startTime?: number|null;
     *   type?: Video.Type|null;
     *   subtitles?: Array.<SubtitleTrack.$Shape>|null;
     *   endTime?: number|null;
     *   loop?: boolean|null;
     *   autoplay?: boolean|null;
     *   muted?: boolean|null;
     *   id?: string|null;
     *   widthConfig?: streamlit.WidthConfig.$Shape|null;
     *   alt?: string|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} Video.$Shape
     */

    /**
     * Constructs a new Video.
     * @exports Video
     * @classdesc Represents a Video.
     * @constructor
     * @param {Video.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Video = function (properties) {
        this.subtitles = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Video url.
     * @member {string} url
     * @memberof Video
     * @instance
     */
    Video.prototype.url = "";

    /**
     * Video startTime.
     * @member {number} startTime
     * @memberof Video
     * @instance
     */
    Video.prototype.startTime = 0;

    /**
     * Video type.
     * @member {Video.Type} type
     * @memberof Video
     * @instance
     */
    Video.prototype.type = 0;

    /**
     * Video subtitles.
     * @member {Array.<SubtitleTrack.$Properties>} subtitles
     * @memberof Video
     * @instance
     */
    Video.prototype.subtitles = $util.emptyArray;

    /**
     * Video endTime.
     * @member {number} endTime
     * @memberof Video
     * @instance
     */
    Video.prototype.endTime = 0;

    /**
     * Video loop.
     * @member {boolean} loop
     * @memberof Video
     * @instance
     */
    Video.prototype.loop = false;

    /**
     * Video autoplay.
     * @member {boolean} autoplay
     * @memberof Video
     * @instance
     */
    Video.prototype.autoplay = false;

    /**
     * Video muted.
     * @member {boolean} muted
     * @memberof Video
     * @instance
     */
    Video.prototype.muted = false;

    /**
     * Video id.
     * @member {string} id
     * @memberof Video
     * @instance
     */
    Video.prototype.id = "";

    /**
     * Video widthConfig.
     * @member {streamlit.WidthConfig.$Properties|null|undefined} widthConfig
     * @memberof Video
     * @instance
     */
    Video.prototype.widthConfig = null;

    /**
     * Video alt.
     * @member {string|null|undefined} alt
     * @memberof Video
     * @instance
     */
    Video.prototype.alt = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Video.prototype, "_widthConfig", {
        get: $util.oneOfGetter($oneOfFields = ["widthConfig"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Video.prototype, "_alt", {
        get: $util.oneOfGetter($oneOfFields = ["alt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Video instance using the specified properties.
     * @function create
     * @memberof Video
     * @static
     * @param {Video.$Properties=} [properties] Properties to set
     * @returns {Video} Video instance
     * @type {{
     *   (properties: Video.$Shape): Video & Video.$Shape;
     *   (properties?: Video.$Properties): Video;
     * }}
     */
    Video.create = function(properties) {
        return new Video(properties);
    };

    /**
     * Encodes the specified Video message. Does not implicitly {@link Video.verify|verify} messages.
     * @function encode
     * @memberof Video
     * @static
     * @param {Video.$Properties} message Video message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Video.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.startTime != null && $Object.hasOwnProperty.call(message, "startTime") && message.startTime !== 0)
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.startTime);
        if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== 0)
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.url);
        if (message.subtitles != null && message.subtitles.length)
            for (let i = 0; i < message.subtitles.length; ++i)
                $root.SubtitleTrack.encode(message.subtitles[i], writer.uint32(/* id 7, wireType 2 =*/58).fork(), _depth + 1).ldelim();
        if (message.endTime != null && $Object.hasOwnProperty.call(message, "endTime") && message.endTime !== 0)
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.endTime);
        if (message.loop != null && $Object.hasOwnProperty.call(message, "loop") && message.loop !== false)
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.loop);
        if (message.autoplay != null && $Object.hasOwnProperty.call(message, "autoplay") && message.autoplay !== false)
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.autoplay);
        if (message.muted != null && $Object.hasOwnProperty.call(message, "muted") && message.muted !== false)
            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.muted);
        if (message.id != null && $Object.hasOwnProperty.call(message, "id") && message.id !== "")
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.id);
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            $root.streamlit.WidthConfig.encode(message.widthConfig, writer.uint32(/* id 13, wireType 2 =*/106).fork(), _depth + 1).ldelim();
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.alt);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Video message from the specified reader or buffer.
     * @function decode
     * @memberof Video
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Video & Video.$Shape} Video
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Video.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Video();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.startTime = value;
                    else
                        delete message.startTime;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.type = value;
                    else
                        delete message.type;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if (!(message.subtitles && message.subtitles.length))
                        message.subtitles = [];
                    message.subtitles.push($root.SubtitleTrack.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.endTime = value;
                    else
                        delete message.endTime;
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.loop = value;
                    else
                        delete message.loop;
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.autoplay = value;
                    else
                        delete message.autoplay;
                    continue;
                }
            case 11: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.muted = value;
                    else
                        delete message.muted;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.id = value;
                    else
                        delete message.id;
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.widthConfig = $root.streamlit.WidthConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.widthConfig);
                    message._widthConfig = "widthConfig";
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    message.alt = reader.stringVerify();
                    message._alt = "alt";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Video message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Video
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Video} Video
     */
    Video.fromObject = function (object, _depth) {
        if (object instanceof $root.Video)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Video: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Video();
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        if (object.startTime != null)
            if ($Number(object.startTime) !== 0)
                message.startTime = object.startTime | 0;
        if (object.type !== 0 && (typeof object.type !== "string" || $root.Video.Type[object.type] !== 0))
            switch (object.type) {
            case "UNUSED":
            case 0:
                message.type = 0;
                break;
            case "NATIVE":
            case 1:
                message.type = 1;
                break;
            case "YOUTUBE_IFRAME":
            case 2:
                message.type = 2;
                break;
            default:
                if (typeof object.type === "number" && (object.type | 0) === object.type)
                    message.type = object.type;
            }
        if (object.subtitles) {
            if (!$Array.isArray(object.subtitles))
                throw $TypeError(".Video.subtitles: array expected");
            message.subtitles = $Array(object.subtitles.length);
            for (let i = 0; i < object.subtitles.length; ++i) {
                if (!$util.isObject(object.subtitles[i]))
                    throw $TypeError(".Video.subtitles: object expected");
                message.subtitles[i] = $root.SubtitleTrack.fromObject(object.subtitles[i], _depth + 1);
            }
        }
        if (object.endTime != null)
            if ($Number(object.endTime) !== 0)
                message.endTime = object.endTime | 0;
        if (object.loop != null)
            if (object.loop)
                message.loop = $Boolean(object.loop);
        if (object.autoplay != null)
            if (object.autoplay)
                message.autoplay = $Boolean(object.autoplay);
        if (object.muted != null)
            if (object.muted)
                message.muted = $Boolean(object.muted);
        if (object.id != null)
            if (typeof object.id !== "string" || object.id.length)
                message.id = $String(object.id);
        if (object.widthConfig != null) {
            if (!$util.isObject(object.widthConfig))
                throw $TypeError(".Video.widthConfig: object expected");
            message.widthConfig = $root.streamlit.WidthConfig.fromObject(object.widthConfig, _depth + 1);
        }
        if (object.alt != null)
            message.alt = $String(object.alt);
        return message;
    };

    /**
     * Creates a plain object from a Video message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Video
     * @static
     * @param {Video} message Video
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Video.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.subtitles = [];
        if (options.defaults) {
            object.startTime = 0;
            object.type = options.enums === $String ? "UNUSED" : 0;
            object.url = "";
            object.endTime = 0;
            object.loop = false;
            object.autoplay = false;
            object.muted = false;
            object.id = "";
        }
        if (message.startTime != null && $Object.hasOwnProperty.call(message, "startTime"))
            object.startTime = message.startTime;
        if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
            object.type = options.enums === $String ? $root.Video.Type[message.type] === $undefined ? message.type : $root.Video.Type[message.type] : message.type;
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        if (message.subtitles && message.subtitles.length) {
            object.subtitles = $Array(message.subtitles.length);
            for (let j = 0; j < message.subtitles.length; ++j)
                object.subtitles[j] = $root.SubtitleTrack.toObject(message.subtitles[j], options, _depth + 1);
        }
        if (message.endTime != null && $Object.hasOwnProperty.call(message, "endTime"))
            object.endTime = message.endTime;
        if (message.loop != null && $Object.hasOwnProperty.call(message, "loop"))
            object.loop = message.loop;
        if (message.autoplay != null && $Object.hasOwnProperty.call(message, "autoplay"))
            object.autoplay = message.autoplay;
        if (message.muted != null && $Object.hasOwnProperty.call(message, "muted"))
            object.muted = message.muted;
        if (message.id != null && $Object.hasOwnProperty.call(message, "id"))
            object.id = message.id;
        if (message.widthConfig != null && $Object.hasOwnProperty.call(message, "widthConfig"))
            object.widthConfig = $root.streamlit.WidthConfig.toObject(message.widthConfig, options, _depth + 1);
        if (message.alt != null && $Object.hasOwnProperty.call(message, "alt"))
            object.alt = message.alt;
        return object;
    };

    /**
     * Converts this Video to JSON.
     * @function toJSON
     * @memberof Video
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Video.prototype.toJSON = function() {
        return Video.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Video
     * @function getTypeUrl
     * @memberof Video
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Video.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Video";
    };

    /**
     * Type enum.
     * @name Video.Type
     * @enum {number}
     * @property {number} UNUSED=0 UNUSED value
     * @property {number} NATIVE=1 NATIVE value
     * @property {number} YOUTUBE_IFRAME=2 YOUTUBE_IFRAME value
     */
    Video.Type = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "UNUSED"] = 0;
        values[valuesById[1] = "NATIVE"] = 1;
        values[valuesById[2] = "YOUTUBE_IFRAME"] = 2;
        return values;
    })();

    return Video;
})();

export const Transient = $root.Transient = (() => {

    /**
     * Properties of a Transient.
     * @typedef {Object} Transient.$Properties
     * @property {Array.<Element.$Properties>|null} [elements] Transient elements
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Transient.
     * @exports ITransient
     * @interface ITransient
     * @augments Transient.$Properties
     * @deprecated Use Transient.$Properties instead.
     */

    /**
     * Shape of a Transient.
     * @typedef {{
     *   elements?: Array.<Element.$Shape>|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} Transient.$Shape
     */

    /**
     * Constructs a new Transient.
     * @exports Transient
     * @classdesc Represents a Transient.
     * @constructor
     * @param {Transient.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Transient = function (properties) {
        this.elements = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Transient elements.
     * @member {Array.<Element.$Properties>} elements
     * @memberof Transient
     * @instance
     */
    Transient.prototype.elements = $util.emptyArray;

    /**
     * Creates a new Transient instance using the specified properties.
     * @function create
     * @memberof Transient
     * @static
     * @param {Transient.$Properties=} [properties] Properties to set
     * @returns {Transient} Transient instance
     * @type {{
     *   (properties: Transient.$Shape): Transient & Transient.$Shape;
     *   (properties?: Transient.$Properties): Transient;
     * }}
     */
    Transient.create = function(properties) {
        return new Transient(properties);
    };

    /**
     * Encodes the specified Transient message. Does not implicitly {@link Transient.verify|verify} messages.
     * @function encode
     * @memberof Transient
     * @static
     * @param {Transient.$Properties} message Transient message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Transient.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.elements != null && message.elements.length)
            for (let i = 0; i < message.elements.length; ++i)
                $root.Element.encode(message.elements[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Transient message from the specified reader or buffer.
     * @function decode
     * @memberof Transient
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Transient & Transient.$Shape} Transient
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Transient.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Transient();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if (!(message.elements && message.elements.length))
                        message.elements = [];
                    message.elements.push($root.Element.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Transient message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Transient
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Transient} Transient
     */
    Transient.fromObject = function (object, _depth) {
        if (object instanceof $root.Transient)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Transient: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Transient();
        if (object.elements) {
            if (!$Array.isArray(object.elements))
                throw $TypeError(".Transient.elements: array expected");
            message.elements = $Array(object.elements.length);
            for (let i = 0; i < object.elements.length; ++i) {
                if (!$util.isObject(object.elements[i]))
                    throw $TypeError(".Transient.elements: object expected");
                message.elements[i] = $root.Element.fromObject(object.elements[i], _depth + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Transient message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Transient
     * @static
     * @param {Transient} message Transient
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Transient.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.elements = [];
        if (message.elements && message.elements.length) {
            object.elements = $Array(message.elements.length);
            for (let j = 0; j < message.elements.length; ++j)
                object.elements[j] = $root.Element.toObject(message.elements[j], options, _depth + 1);
        }
        return object;
    };

    /**
     * Converts this Transient to JSON.
     * @function toJSON
     * @memberof Transient
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Transient.prototype.toJSON = function() {
        return Transient.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Transient
     * @function getTypeUrl
     * @memberof Transient
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Transient.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Transient";
    };

    return Transient;
})();

export const ForwardMsg = $root.ForwardMsg = (() => {

    /**
     * Properties of a ForwardMsg.
     * @typedef {Object} ForwardMsg.$Properties
     * @property {string|null} [hash] ForwardMsg hash
     * @property {ForwardMsgMetadata.$Properties|null} [metadata] ForwardMsg metadata
     * @property {NewSession.$Properties|null} [newSession] ForwardMsg newSession
     * @property {Delta.$Properties|null} [delta] ForwardMsg delta
     * @property {PageInfo.$Properties|null} [pageInfoChanged] ForwardMsg pageInfoChanged
     * @property {PageConfig.$Properties|null} [pageConfigChanged] ForwardMsg pageConfigChanged
     * @property {ForwardMsg.ScriptFinishedStatus|null} [scriptFinished] ForwardMsg scriptFinished
     * @property {GitInfo.$Properties|null} [gitInfoChanged] ForwardMsg gitInfoChanged
     * @property {PageProfile.$Properties|null} [pageProfile] ForwardMsg pageProfile
     * @property {SessionStatus.$Properties|null} [sessionStatusChanged] ForwardMsg sessionStatusChanged
     * @property {SessionEvent.$Properties|null} [sessionEvent] ForwardMsg sessionEvent
     * @property {Navigation.$Properties|null} [navigation] ForwardMsg navigation
     * @property {PageNotFound.$Properties|null} [pageNotFound] ForwardMsg pageNotFound
     * @property {FileURLsResponse.$Properties|null} [fileUrlsResponse] ForwardMsg fileUrlsResponse
     * @property {AutoRerun.$Properties|null} [autoRerun] ForwardMsg autoRerun
     * @property {StopAutoRerun.$Properties|null} [stopAutoRerun] ForwardMsg stopAutoRerun
     * @property {Logo.$Properties|null} [logo] ForwardMsg logo
     * @property {AuthRedirect.$Properties|null} [authRedirect] ForwardMsg authRedirect
     * @property {ParentMessage.$Properties|null} [parentMessage] ForwardMsg parentMessage
     * @property {string|null} [refHash] ForwardMsg refHash
     * @property {boolean|null} [heartbeatAck] ForwardMsg heartbeatAck
     * @property {BackendOperationResponse.$Properties|null} [backendOperationResponse] ForwardMsg backendOperationResponse
     * @property {string|null} [debugLastBackmsgId] ForwardMsg debugLastBackmsgId
     * @property {"newSession"|"delta"|"pageInfoChanged"|"pageConfigChanged"|"scriptFinished"|"gitInfoChanged"|"pageProfile"|"sessionStatusChanged"|"sessionEvent"|"navigation"|"pageNotFound"|"fileUrlsResponse"|"autoRerun"|"stopAutoRerun"|"logo"|"authRedirect"|"parentMessage"|"refHash"|"heartbeatAck"|"backendOperationResponse"} [type] ForwardMsg type
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ForwardMsg.
     * @exports IForwardMsg
     * @interface IForwardMsg
     * @augments ForwardMsg.$Properties
     * @deprecated Use ForwardMsg.$Properties instead.
     */

    /**
     * Narrowed shape of a ForwardMsg.
     * @typedef {{
     *   hash?: string|null;
     *   metadata?: ForwardMsgMetadata.$Shape|null;
     *   newSession?: NewSession.$Shape|null;
     *   delta?: Delta.$Shape|null;
     *   pageInfoChanged?: PageInfo.$Shape|null;
     *   pageConfigChanged?: PageConfig.$Shape|null;
     *   scriptFinished?: ForwardMsg.ScriptFinishedStatus|null;
     *   gitInfoChanged?: GitInfo.$Shape|null;
     *   pageProfile?: PageProfile.$Shape|null;
     *   sessionStatusChanged?: SessionStatus.$Shape|null;
     *   sessionEvent?: SessionEvent.$Shape|null;
     *   navigation?: Navigation.$Shape|null;
     *   pageNotFound?: PageNotFound.$Shape|null;
     *   fileUrlsResponse?: FileURLsResponse.$Shape|null;
     *   autoRerun?: AutoRerun.$Shape|null;
     *   stopAutoRerun?: StopAutoRerun.$Shape|null;
     *   logo?: Logo.$Shape|null;
     *   authRedirect?: AuthRedirect.$Shape|null;
     *   parentMessage?: ParentMessage.$Shape|null;
     *   refHash?: string|null;
     *   heartbeatAck?: boolean|null;
     *   backendOperationResponse?: BackendOperationResponse.$Shape|null;
     *   debugLastBackmsgId?: string|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ type?: undefined; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "newSession"; newSession: NewSession.$Shape; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "delta"; newSession?: null; delta: Delta.$Shape; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "pageInfoChanged"; newSession?: null; delta?: null; pageInfoChanged: PageInfo.$Shape; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "pageConfigChanged"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged: PageConfig.$Shape; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "scriptFinished"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished: ForwardMsg.ScriptFinishedStatus; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "gitInfoChanged"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged: GitInfo.$Shape; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "pageProfile"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile: PageProfile.$Shape; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "sessionStatusChanged"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged: SessionStatus.$Shape; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "sessionEvent"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent: SessionEvent.$Shape; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "navigation"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation: Navigation.$Shape; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "pageNotFound"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound: PageNotFound.$Shape; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "fileUrlsResponse"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse: FileURLsResponse.$Shape; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "autoRerun"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun: AutoRerun.$Shape; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "stopAutoRerun"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun: StopAutoRerun.$Shape; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "logo"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo: Logo.$Shape; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "authRedirect"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect: AuthRedirect.$Shape; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "parentMessage"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage: ParentMessage.$Shape; refHash?: null; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "refHash"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash: string; heartbeatAck?: null; backendOperationResponse?: null }|{ type?: "heartbeatAck"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck: boolean; backendOperationResponse?: null }|{ type?: "backendOperationResponse"; newSession?: null; delta?: null; pageInfoChanged?: null; pageConfigChanged?: null; scriptFinished?: null; gitInfoChanged?: null; pageProfile?: null; sessionStatusChanged?: null; sessionEvent?: null; navigation?: null; pageNotFound?: null; fileUrlsResponse?: null; autoRerun?: null; stopAutoRerun?: null; logo?: null; authRedirect?: null; parentMessage?: null; refHash?: null; heartbeatAck?: null; backendOperationResponse: BackendOperationResponse.$Shape })
     * )} ForwardMsg.$Shape
     */

    /**
     * Constructs a new ForwardMsg.
     * @exports ForwardMsg
     * @classdesc Represents a ForwardMsg.
     * @constructor
     * @param {ForwardMsg.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ForwardMsg = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ForwardMsg hash.
     * @member {string} hash
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.hash = "";

    /**
     * ForwardMsg metadata.
     * @member {ForwardMsgMetadata.$Properties|null|undefined} metadata
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.metadata = null;

    /**
     * ForwardMsg newSession.
     * @member {NewSession.$Properties|null|undefined} newSession
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.newSession = null;

    /**
     * ForwardMsg delta.
     * @member {Delta.$Properties|null|undefined} delta
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.delta = null;

    /**
     * ForwardMsg pageInfoChanged.
     * @member {PageInfo.$Properties|null|undefined} pageInfoChanged
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.pageInfoChanged = null;

    /**
     * ForwardMsg pageConfigChanged.
     * @member {PageConfig.$Properties|null|undefined} pageConfigChanged
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.pageConfigChanged = null;

    /**
     * ForwardMsg scriptFinished.
     * @member {ForwardMsg.ScriptFinishedStatus|null|undefined} scriptFinished
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.scriptFinished = null;

    /**
     * ForwardMsg gitInfoChanged.
     * @member {GitInfo.$Properties|null|undefined} gitInfoChanged
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.gitInfoChanged = null;

    /**
     * ForwardMsg pageProfile.
     * @member {PageProfile.$Properties|null|undefined} pageProfile
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.pageProfile = null;

    /**
     * ForwardMsg sessionStatusChanged.
     * @member {SessionStatus.$Properties|null|undefined} sessionStatusChanged
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.sessionStatusChanged = null;

    /**
     * ForwardMsg sessionEvent.
     * @member {SessionEvent.$Properties|null|undefined} sessionEvent
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.sessionEvent = null;

    /**
     * ForwardMsg navigation.
     * @member {Navigation.$Properties|null|undefined} navigation
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.navigation = null;

    /**
     * ForwardMsg pageNotFound.
     * @member {PageNotFound.$Properties|null|undefined} pageNotFound
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.pageNotFound = null;

    /**
     * ForwardMsg fileUrlsResponse.
     * @member {FileURLsResponse.$Properties|null|undefined} fileUrlsResponse
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.fileUrlsResponse = null;

    /**
     * ForwardMsg autoRerun.
     * @member {AutoRerun.$Properties|null|undefined} autoRerun
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.autoRerun = null;

    /**
     * ForwardMsg stopAutoRerun.
     * @member {StopAutoRerun.$Properties|null|undefined} stopAutoRerun
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.stopAutoRerun = null;

    /**
     * ForwardMsg logo.
     * @member {Logo.$Properties|null|undefined} logo
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.logo = null;

    /**
     * ForwardMsg authRedirect.
     * @member {AuthRedirect.$Properties|null|undefined} authRedirect
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.authRedirect = null;

    /**
     * ForwardMsg parentMessage.
     * @member {ParentMessage.$Properties|null|undefined} parentMessage
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.parentMessage = null;

    /**
     * ForwardMsg refHash.
     * @member {string|null|undefined} refHash
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.refHash = null;

    /**
     * ForwardMsg heartbeatAck.
     * @member {boolean|null|undefined} heartbeatAck
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.heartbeatAck = null;

    /**
     * ForwardMsg backendOperationResponse.
     * @member {BackendOperationResponse.$Properties|null|undefined} backendOperationResponse
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.backendOperationResponse = null;

    /**
     * ForwardMsg debugLastBackmsgId.
     * @member {string} debugLastBackmsgId
     * @memberof ForwardMsg
     * @instance
     */
    ForwardMsg.prototype.debugLastBackmsgId = "";

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * ForwardMsg type.
     * @member {"newSession"|"delta"|"pageInfoChanged"|"pageConfigChanged"|"scriptFinished"|"gitInfoChanged"|"pageProfile"|"sessionStatusChanged"|"sessionEvent"|"navigation"|"pageNotFound"|"fileUrlsResponse"|"autoRerun"|"stopAutoRerun"|"logo"|"authRedirect"|"parentMessage"|"refHash"|"heartbeatAck"|"backendOperationResponse"|undefined} type
     * @memberof ForwardMsg
     * @instance
     */
    $Object.defineProperty(ForwardMsg.prototype, "type", {
        get: $util.oneOfGetter($oneOfFields = ["newSession", "delta", "pageInfoChanged", "pageConfigChanged", "scriptFinished", "gitInfoChanged", "pageProfile", "sessionStatusChanged", "sessionEvent", "navigation", "pageNotFound", "fileUrlsResponse", "autoRerun", "stopAutoRerun", "logo", "authRedirect", "parentMessage", "refHash", "heartbeatAck", "backendOperationResponse"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ForwardMsg instance using the specified properties.
     * @function create
     * @memberof ForwardMsg
     * @static
     * @param {ForwardMsg.$Properties=} [properties] Properties to set
     * @returns {ForwardMsg} ForwardMsg instance
     * @type {{
     *   (properties: ForwardMsg.$Shape): ForwardMsg & ForwardMsg.$Shape;
     *   (properties?: ForwardMsg.$Properties): ForwardMsg;
     * }}
     */
    ForwardMsg.create = function(properties) {
        return new ForwardMsg(properties);
    };

    /**
     * Encodes the specified ForwardMsg message. Does not implicitly {@link ForwardMsg.verify|verify} messages.
     * @function encode
     * @memberof ForwardMsg
     * @static
     * @param {ForwardMsg.$Properties} message ForwardMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardMsg.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.hash != null && $Object.hasOwnProperty.call(message, "hash") && message.hash !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.hash);
        if (message.metadata != null && $Object.hasOwnProperty.call(message, "metadata"))
            $root.ForwardMsgMetadata.encode(message.metadata, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.newSession != null && $Object.hasOwnProperty.call(message, "newSession"))
            $root.NewSession.encode(message.newSession, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
        if (message.delta != null && $Object.hasOwnProperty.call(message, "delta"))
            $root.Delta.encode(message.delta, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
        if (message.scriptFinished != null && $Object.hasOwnProperty.call(message, "scriptFinished"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.scriptFinished);
        if (message.sessionStatusChanged != null && $Object.hasOwnProperty.call(message, "sessionStatusChanged"))
            $root.SessionStatus.encode(message.sessionStatusChanged, writer.uint32(/* id 9, wireType 2 =*/74).fork(), _depth + 1).ldelim();
        if (message.sessionEvent != null && $Object.hasOwnProperty.call(message, "sessionEvent"))
            $root.SessionEvent.encode(message.sessionEvent, writer.uint32(/* id 10, wireType 2 =*/82).fork(), _depth + 1).ldelim();
        if (message.refHash != null && $Object.hasOwnProperty.call(message, "refHash"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.refHash);
        if (message.pageInfoChanged != null && $Object.hasOwnProperty.call(message, "pageInfoChanged"))
            $root.PageInfo.encode(message.pageInfoChanged, writer.uint32(/* id 12, wireType 2 =*/98).fork(), _depth + 1).ldelim();
        if (message.pageConfigChanged != null && $Object.hasOwnProperty.call(message, "pageConfigChanged"))
            $root.PageConfig.encode(message.pageConfigChanged, writer.uint32(/* id 13, wireType 2 =*/106).fork(), _depth + 1).ldelim();
        if (message.gitInfoChanged != null && $Object.hasOwnProperty.call(message, "gitInfoChanged"))
            $root.GitInfo.encode(message.gitInfoChanged, writer.uint32(/* id 14, wireType 2 =*/114).fork(), _depth + 1).ldelim();
        if (message.pageNotFound != null && $Object.hasOwnProperty.call(message, "pageNotFound"))
            $root.PageNotFound.encode(message.pageNotFound, writer.uint32(/* id 15, wireType 2 =*/122).fork(), _depth + 1).ldelim();
        if (message.debugLastBackmsgId != null && $Object.hasOwnProperty.call(message, "debugLastBackmsgId") && message.debugLastBackmsgId !== "")
            writer.uint32(/* id 17, wireType 2 =*/138).string(message.debugLastBackmsgId);
        if (message.pageProfile != null && $Object.hasOwnProperty.call(message, "pageProfile"))
            $root.PageProfile.encode(message.pageProfile, writer.uint32(/* id 18, wireType 2 =*/146).fork(), _depth + 1).ldelim();
        if (message.fileUrlsResponse != null && $Object.hasOwnProperty.call(message, "fileUrlsResponse"))
            $root.FileURLsResponse.encode(message.fileUrlsResponse, writer.uint32(/* id 19, wireType 2 =*/154).fork(), _depth + 1).ldelim();
        if (message.parentMessage != null && $Object.hasOwnProperty.call(message, "parentMessage"))
            $root.ParentMessage.encode(message.parentMessage, writer.uint32(/* id 20, wireType 2 =*/162).fork(), _depth + 1).ldelim();
        if (message.autoRerun != null && $Object.hasOwnProperty.call(message, "autoRerun"))
            $root.AutoRerun.encode(message.autoRerun, writer.uint32(/* id 21, wireType 2 =*/170).fork(), _depth + 1).ldelim();
        if (message.logo != null && $Object.hasOwnProperty.call(message, "logo"))
            $root.Logo.encode(message.logo, writer.uint32(/* id 22, wireType 2 =*/178).fork(), _depth + 1).ldelim();
        if (message.navigation != null && $Object.hasOwnProperty.call(message, "navigation"))
            $root.Navigation.encode(message.navigation, writer.uint32(/* id 23, wireType 2 =*/186).fork(), _depth + 1).ldelim();
        if (message.authRedirect != null && $Object.hasOwnProperty.call(message, "authRedirect"))
            $root.AuthRedirect.encode(message.authRedirect, writer.uint32(/* id 24, wireType 2 =*/194).fork(), _depth + 1).ldelim();
        if (message.heartbeatAck != null && $Object.hasOwnProperty.call(message, "heartbeatAck"))
            writer.uint32(/* id 26, wireType 0 =*/208).bool(message.heartbeatAck);
        if (message.backendOperationResponse != null && $Object.hasOwnProperty.call(message, "backendOperationResponse"))
            $root.BackendOperationResponse.encode(message.backendOperationResponse, writer.uint32(/* id 27, wireType 2 =*/218).fork(), _depth + 1).ldelim();
        if (message.stopAutoRerun != null && $Object.hasOwnProperty.call(message, "stopAutoRerun"))
            $root.StopAutoRerun.encode(message.stopAutoRerun, writer.uint32(/* id 28, wireType 2 =*/226).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ForwardMsg message from the specified reader or buffer.
     * @function decode
     * @memberof ForwardMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ForwardMsg & ForwardMsg.$Shape} ForwardMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardMsg.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ForwardMsg();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.hash = value;
                    else
                        delete message.hash;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    message.metadata = $root.ForwardMsgMetadata.decode(reader, reader.uint32(), $undefined, _depth + 1, message.metadata);
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.newSession = $root.NewSession.decode(reader, reader.uint32(), $undefined, _depth + 1, message.newSession);
                    message.type = "newSession";
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.delta = $root.Delta.decode(reader, reader.uint32(), $undefined, _depth + 1, message.delta);
                    message.type = "delta";
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    message.pageInfoChanged = $root.PageInfo.decode(reader, reader.uint32(), $undefined, _depth + 1, message.pageInfoChanged);
                    message.type = "pageInfoChanged";
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    message.pageConfigChanged = $root.PageConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.pageConfigChanged);
                    message.type = "pageConfigChanged";
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    message.scriptFinished = reader.int32();
                    message.type = "scriptFinished";
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    message.gitInfoChanged = $root.GitInfo.decode(reader, reader.uint32(), $undefined, _depth + 1, message.gitInfoChanged);
                    message.type = "gitInfoChanged";
                    continue;
                }
            case 18: {
                    if (wireType !== 2)
                        break;
                    message.pageProfile = $root.PageProfile.decode(reader, reader.uint32(), $undefined, _depth + 1, message.pageProfile);
                    message.type = "pageProfile";
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    message.sessionStatusChanged = $root.SessionStatus.decode(reader, reader.uint32(), $undefined, _depth + 1, message.sessionStatusChanged);
                    message.type = "sessionStatusChanged";
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    message.sessionEvent = $root.SessionEvent.decode(reader, reader.uint32(), $undefined, _depth + 1, message.sessionEvent);
                    message.type = "sessionEvent";
                    continue;
                }
            case 23: {
                    if (wireType !== 2)
                        break;
                    message.navigation = $root.Navigation.decode(reader, reader.uint32(), $undefined, _depth + 1, message.navigation);
                    message.type = "navigation";
                    continue;
                }
            case 15: {
                    if (wireType !== 2)
                        break;
                    message.pageNotFound = $root.PageNotFound.decode(reader, reader.uint32(), $undefined, _depth + 1, message.pageNotFound);
                    message.type = "pageNotFound";
                    continue;
                }
            case 19: {
                    if (wireType !== 2)
                        break;
                    message.fileUrlsResponse = $root.FileURLsResponse.decode(reader, reader.uint32(), $undefined, _depth + 1, message.fileUrlsResponse);
                    message.type = "fileUrlsResponse";
                    continue;
                }
            case 21: {
                    if (wireType !== 2)
                        break;
                    message.autoRerun = $root.AutoRerun.decode(reader, reader.uint32(), $undefined, _depth + 1, message.autoRerun);
                    message.type = "autoRerun";
                    continue;
                }
            case 28: {
                    if (wireType !== 2)
                        break;
                    message.stopAutoRerun = $root.StopAutoRerun.decode(reader, reader.uint32(), $undefined, _depth + 1, message.stopAutoRerun);
                    message.type = "stopAutoRerun";
                    continue;
                }
            case 22: {
                    if (wireType !== 2)
                        break;
                    message.logo = $root.Logo.decode(reader, reader.uint32(), $undefined, _depth + 1, message.logo);
                    message.type = "logo";
                    continue;
                }
            case 24: {
                    if (wireType !== 2)
                        break;
                    message.authRedirect = $root.AuthRedirect.decode(reader, reader.uint32(), $undefined, _depth + 1, message.authRedirect);
                    message.type = "authRedirect";
                    continue;
                }
            case 20: {
                    if (wireType !== 2)
                        break;
                    message.parentMessage = $root.ParentMessage.decode(reader, reader.uint32(), $undefined, _depth + 1, message.parentMessage);
                    message.type = "parentMessage";
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    message.refHash = reader.stringVerify();
                    message.type = "refHash";
                    continue;
                }
            case 26: {
                    if (wireType !== 0)
                        break;
                    message.heartbeatAck = reader.bool();
                    message.type = "heartbeatAck";
                    continue;
                }
            case 27: {
                    if (wireType !== 2)
                        break;
                    message.backendOperationResponse = $root.BackendOperationResponse.decode(reader, reader.uint32(), $undefined, _depth + 1, message.backendOperationResponse);
                    message.type = "backendOperationResponse";
                    continue;
                }
            case 17: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.debugLastBackmsgId = value;
                    else
                        delete message.debugLastBackmsgId;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ForwardMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ForwardMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ForwardMsg} ForwardMsg
     */
    ForwardMsg.fromObject = function (object, _depth) {
        if (object instanceof $root.ForwardMsg)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ForwardMsg: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ForwardMsg();
        if (object.hash != null)
            if (typeof object.hash !== "string" || object.hash.length)
                message.hash = $String(object.hash);
        if (object.metadata != null) {
            if (!$util.isObject(object.metadata))
                throw $TypeError(".ForwardMsg.metadata: object expected");
            message.metadata = $root.ForwardMsgMetadata.fromObject(object.metadata, _depth + 1);
        }
        if (object.newSession != null) {
            if (!$util.isObject(object.newSession))
                throw $TypeError(".ForwardMsg.newSession: object expected");
            message.newSession = $root.NewSession.fromObject(object.newSession, _depth + 1);
        }
        if (object.delta != null) {
            if (!$util.isObject(object.delta))
                throw $TypeError(".ForwardMsg.delta: object expected");
            message.delta = $root.Delta.fromObject(object.delta, _depth + 1);
        }
        if (object.pageInfoChanged != null) {
            if (!$util.isObject(object.pageInfoChanged))
                throw $TypeError(".ForwardMsg.pageInfoChanged: object expected");
            message.pageInfoChanged = $root.PageInfo.fromObject(object.pageInfoChanged, _depth + 1);
        }
        if (object.pageConfigChanged != null) {
            if (!$util.isObject(object.pageConfigChanged))
                throw $TypeError(".ForwardMsg.pageConfigChanged: object expected");
            message.pageConfigChanged = $root.PageConfig.fromObject(object.pageConfigChanged, _depth + 1);
        }
        switch (object.scriptFinished) {
        case "FINISHED_SUCCESSFULLY":
        case 0:
            message.scriptFinished = 0;
            break;
        case "FINISHED_WITH_COMPILE_ERROR":
        case 1:
            message.scriptFinished = 1;
            break;
        case "FINISHED_EARLY_FOR_RERUN":
        case 2:
            message.scriptFinished = 2;
            break;
        case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
        case 3:
            message.scriptFinished = 3;
            break;
        default:
            if (typeof object.scriptFinished === "number" && (object.scriptFinished | 0) === object.scriptFinished)
                message.scriptFinished = object.scriptFinished;
        }
        if (object.gitInfoChanged != null) {
            if (!$util.isObject(object.gitInfoChanged))
                throw $TypeError(".ForwardMsg.gitInfoChanged: object expected");
            message.gitInfoChanged = $root.GitInfo.fromObject(object.gitInfoChanged, _depth + 1);
        }
        if (object.pageProfile != null) {
            if (!$util.isObject(object.pageProfile))
                throw $TypeError(".ForwardMsg.pageProfile: object expected");
            message.pageProfile = $root.PageProfile.fromObject(object.pageProfile, _depth + 1);
        }
        if (object.sessionStatusChanged != null) {
            if (!$util.isObject(object.sessionStatusChanged))
                throw $TypeError(".ForwardMsg.sessionStatusChanged: object expected");
            message.sessionStatusChanged = $root.SessionStatus.fromObject(object.sessionStatusChanged, _depth + 1);
        }
        if (object.sessionEvent != null) {
            if (!$util.isObject(object.sessionEvent))
                throw $TypeError(".ForwardMsg.sessionEvent: object expected");
            message.sessionEvent = $root.SessionEvent.fromObject(object.sessionEvent, _depth + 1);
        }
        if (object.navigation != null) {
            if (!$util.isObject(object.navigation))
                throw $TypeError(".ForwardMsg.navigation: object expected");
            message.navigation = $root.Navigation.fromObject(object.navigation, _depth + 1);
        }
        if (object.pageNotFound != null) {
            if (!$util.isObject(object.pageNotFound))
                throw $TypeError(".ForwardMsg.pageNotFound: object expected");
            message.pageNotFound = $root.PageNotFound.fromObject(object.pageNotFound, _depth + 1);
        }
        if (object.fileUrlsResponse != null) {
            if (!$util.isObject(object.fileUrlsResponse))
                throw $TypeError(".ForwardMsg.fileUrlsResponse: object expected");
            message.fileUrlsResponse = $root.FileURLsResponse.fromObject(object.fileUrlsResponse, _depth + 1);
        }
        if (object.autoRerun != null) {
            if (!$util.isObject(object.autoRerun))
                throw $TypeError(".ForwardMsg.autoRerun: object expected");
            message.autoRerun = $root.AutoRerun.fromObject(object.autoRerun, _depth + 1);
        }
        if (object.stopAutoRerun != null) {
            if (!$util.isObject(object.stopAutoRerun))
                throw $TypeError(".ForwardMsg.stopAutoRerun: object expected");
            message.stopAutoRerun = $root.StopAutoRerun.fromObject(object.stopAutoRerun, _depth + 1);
        }
        if (object.logo != null) {
            if (!$util.isObject(object.logo))
                throw $TypeError(".ForwardMsg.logo: object expected");
            message.logo = $root.Logo.fromObject(object.logo, _depth + 1);
        }
        if (object.authRedirect != null) {
            if (!$util.isObject(object.authRedirect))
                throw $TypeError(".ForwardMsg.authRedirect: object expected");
            message.authRedirect = $root.AuthRedirect.fromObject(object.authRedirect, _depth + 1);
        }
        if (object.parentMessage != null) {
            if (!$util.isObject(object.parentMessage))
                throw $TypeError(".ForwardMsg.parentMessage: object expected");
            message.parentMessage = $root.ParentMessage.fromObject(object.parentMessage, _depth + 1);
        }
        if (object.refHash != null)
            message.refHash = $String(object.refHash);
        if (object.heartbeatAck != null)
            message.heartbeatAck = $Boolean(object.heartbeatAck);
        if (object.backendOperationResponse != null) {
            if (!$util.isObject(object.backendOperationResponse))
                throw $TypeError(".ForwardMsg.backendOperationResponse: object expected");
            message.backendOperationResponse = $root.BackendOperationResponse.fromObject(object.backendOperationResponse, _depth + 1);
        }
        if (object.debugLastBackmsgId != null)
            if (typeof object.debugLastBackmsgId !== "string" || object.debugLastBackmsgId.length)
                message.debugLastBackmsgId = $String(object.debugLastBackmsgId);
        return message;
    };

    /**
     * Creates a plain object from a ForwardMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ForwardMsg
     * @static
     * @param {ForwardMsg} message ForwardMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ForwardMsg.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.hash = "";
            object.metadata = null;
            object.debugLastBackmsgId = "";
        }
        if (message.hash != null && $Object.hasOwnProperty.call(message, "hash"))
            object.hash = message.hash;
        if (message.metadata != null && $Object.hasOwnProperty.call(message, "metadata"))
            object.metadata = $root.ForwardMsgMetadata.toObject(message.metadata, options, _depth + 1);
        if (message.newSession != null && $Object.hasOwnProperty.call(message, "newSession")) {
            object.newSession = $root.NewSession.toObject(message.newSession, options, _depth + 1);
            if (options.oneofs)
                object.type = "newSession";
        }
        if (message.delta != null && $Object.hasOwnProperty.call(message, "delta")) {
            object.delta = $root.Delta.toObject(message.delta, options, _depth + 1);
            if (options.oneofs)
                object.type = "delta";
        }
        if (message.scriptFinished != null && $Object.hasOwnProperty.call(message, "scriptFinished")) {
            object.scriptFinished = options.enums === $String ? $root.ForwardMsg.ScriptFinishedStatus[message.scriptFinished] === $undefined ? message.scriptFinished : $root.ForwardMsg.ScriptFinishedStatus[message.scriptFinished] : message.scriptFinished;
            if (options.oneofs)
                object.type = "scriptFinished";
        }
        if (message.sessionStatusChanged != null && $Object.hasOwnProperty.call(message, "sessionStatusChanged")) {
            object.sessionStatusChanged = $root.SessionStatus.toObject(message.sessionStatusChanged, options, _depth + 1);
            if (options.oneofs)
                object.type = "sessionStatusChanged";
        }
        if (message.sessionEvent != null && $Object.hasOwnProperty.call(message, "sessionEvent")) {
            object.sessionEvent = $root.SessionEvent.toObject(message.sessionEvent, options, _depth + 1);
            if (options.oneofs)
                object.type = "sessionEvent";
        }
        if (message.refHash != null && $Object.hasOwnProperty.call(message, "refHash")) {
            object.refHash = message.refHash;
            if (options.oneofs)
                object.type = "refHash";
        }
        if (message.pageInfoChanged != null && $Object.hasOwnProperty.call(message, "pageInfoChanged")) {
            object.pageInfoChanged = $root.PageInfo.toObject(message.pageInfoChanged, options, _depth + 1);
            if (options.oneofs)
                object.type = "pageInfoChanged";
        }
        if (message.pageConfigChanged != null && $Object.hasOwnProperty.call(message, "pageConfigChanged")) {
            object.pageConfigChanged = $root.PageConfig.toObject(message.pageConfigChanged, options, _depth + 1);
            if (options.oneofs)
                object.type = "pageConfigChanged";
        }
        if (message.gitInfoChanged != null && $Object.hasOwnProperty.call(message, "gitInfoChanged")) {
            object.gitInfoChanged = $root.GitInfo.toObject(message.gitInfoChanged, options, _depth + 1);
            if (options.oneofs)
                object.type = "gitInfoChanged";
        }
        if (message.pageNotFound != null && $Object.hasOwnProperty.call(message, "pageNotFound")) {
            object.pageNotFound = $root.PageNotFound.toObject(message.pageNotFound, options, _depth + 1);
            if (options.oneofs)
                object.type = "pageNotFound";
        }
        if (message.debugLastBackmsgId != null && $Object.hasOwnProperty.call(message, "debugLastBackmsgId"))
            object.debugLastBackmsgId = message.debugLastBackmsgId;
        if (message.pageProfile != null && $Object.hasOwnProperty.call(message, "pageProfile")) {
            object.pageProfile = $root.PageProfile.toObject(message.pageProfile, options, _depth + 1);
            if (options.oneofs)
                object.type = "pageProfile";
        }
        if (message.fileUrlsResponse != null && $Object.hasOwnProperty.call(message, "fileUrlsResponse")) {
            object.fileUrlsResponse = $root.FileURLsResponse.toObject(message.fileUrlsResponse, options, _depth + 1);
            if (options.oneofs)
                object.type = "fileUrlsResponse";
        }
        if (message.parentMessage != null && $Object.hasOwnProperty.call(message, "parentMessage")) {
            object.parentMessage = $root.ParentMessage.toObject(message.parentMessage, options, _depth + 1);
            if (options.oneofs)
                object.type = "parentMessage";
        }
        if (message.autoRerun != null && $Object.hasOwnProperty.call(message, "autoRerun")) {
            object.autoRerun = $root.AutoRerun.toObject(message.autoRerun, options, _depth + 1);
            if (options.oneofs)
                object.type = "autoRerun";
        }
        if (message.logo != null && $Object.hasOwnProperty.call(message, "logo")) {
            object.logo = $root.Logo.toObject(message.logo, options, _depth + 1);
            if (options.oneofs)
                object.type = "logo";
        }
        if (message.navigation != null && $Object.hasOwnProperty.call(message, "navigation")) {
            object.navigation = $root.Navigation.toObject(message.navigation, options, _depth + 1);
            if (options.oneofs)
                object.type = "navigation";
        }
        if (message.authRedirect != null && $Object.hasOwnProperty.call(message, "authRedirect")) {
            object.authRedirect = $root.AuthRedirect.toObject(message.authRedirect, options, _depth + 1);
            if (options.oneofs)
                object.type = "authRedirect";
        }
        if (message.heartbeatAck != null && $Object.hasOwnProperty.call(message, "heartbeatAck")) {
            object.heartbeatAck = message.heartbeatAck;
            if (options.oneofs)
                object.type = "heartbeatAck";
        }
        if (message.backendOperationResponse != null && $Object.hasOwnProperty.call(message, "backendOperationResponse")) {
            object.backendOperationResponse = $root.BackendOperationResponse.toObject(message.backendOperationResponse, options, _depth + 1);
            if (options.oneofs)
                object.type = "backendOperationResponse";
        }
        if (message.stopAutoRerun != null && $Object.hasOwnProperty.call(message, "stopAutoRerun")) {
            object.stopAutoRerun = $root.StopAutoRerun.toObject(message.stopAutoRerun, options, _depth + 1);
            if (options.oneofs)
                object.type = "stopAutoRerun";
        }
        return object;
    };

    /**
     * Converts this ForwardMsg to JSON.
     * @function toJSON
     * @memberof ForwardMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ForwardMsg.prototype.toJSON = function() {
        return ForwardMsg.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ForwardMsg
     * @function getTypeUrl
     * @memberof ForwardMsg
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ForwardMsg.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ForwardMsg";
    };

    /**
     * ScriptFinishedStatus enum.
     * @name ForwardMsg.ScriptFinishedStatus
     * @enum {number}
     * @property {number} FINISHED_SUCCESSFULLY=0 FINISHED_SUCCESSFULLY value
     * @property {number} FINISHED_WITH_COMPILE_ERROR=1 FINISHED_WITH_COMPILE_ERROR value
     * @property {number} FINISHED_EARLY_FOR_RERUN=2 FINISHED_EARLY_FOR_RERUN value
     * @property {number} FINISHED_FRAGMENT_RUN_SUCCESSFULLY=3 FINISHED_FRAGMENT_RUN_SUCCESSFULLY value
     */
    ForwardMsg.ScriptFinishedStatus = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "FINISHED_SUCCESSFULLY"] = 0;
        values[valuesById[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1;
        values[valuesById[2] = "FINISHED_EARLY_FOR_RERUN"] = 2;
        values[valuesById[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3;
        return values;
    })();

    return ForwardMsg;
})();

export const BackendOperationResponse = $root.BackendOperationResponse = (() => {

    /**
     * Properties of a BackendOperationResponse.
     * @typedef {Object} BackendOperationResponse.$Properties
     * @property {string|null} [requestId] BackendOperationResponse requestId
     * @property {string|null} [errorMsg] BackendOperationResponse errorMsg
     * @property {string|null} [errorReason] BackendOperationResponse errorReason
     * @property {DeferredFileResponsePayload.$Properties|null} [deferredFile] BackendOperationResponse deferredFile
     * @property {InstallSkillsResponsePayload.$Properties|null} [installSkills] BackendOperationResponse installSkills
     * @property {DismissSkillsNudgeResponsePayload.$Properties|null} [dismissSkillsNudge] BackendOperationResponse dismissSkillsNudge
     * @property {DataframeChunkResponsePayload.$Properties|null} [dataframeChunk] BackendOperationResponse dataframeChunk
     * @property {"deferredFile"|"installSkills"|"dismissSkillsNudge"|"dataframeChunk"} [payload] BackendOperationResponse payload
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a BackendOperationResponse.
     * @exports IBackendOperationResponse
     * @interface IBackendOperationResponse
     * @augments BackendOperationResponse.$Properties
     * @deprecated Use BackendOperationResponse.$Properties instead.
     */

    /**
     * Narrowed shape of a BackendOperationResponse.
     * @typedef {{
     *   requestId?: string|null;
     *   errorMsg?: string|null;
     *   errorReason?: string|null;
     *   deferredFile?: DeferredFileResponsePayload.$Shape|null;
     *   installSkills?: InstallSkillsResponsePayload.$Shape|null;
     *   dismissSkillsNudge?: DismissSkillsNudgeResponsePayload.$Shape|null;
     *   dataframeChunk?: DataframeChunkResponsePayload.$Shape|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ payload?: undefined; deferredFile?: null; installSkills?: null; dismissSkillsNudge?: null; dataframeChunk?: null }|{ payload?: "deferredFile"; deferredFile: DeferredFileResponsePayload.$Shape; installSkills?: null; dismissSkillsNudge?: null; dataframeChunk?: null }|{ payload?: "installSkills"; deferredFile?: null; installSkills: InstallSkillsResponsePayload.$Shape; dismissSkillsNudge?: null; dataframeChunk?: null }|{ payload?: "dismissSkillsNudge"; deferredFile?: null; installSkills?: null; dismissSkillsNudge: DismissSkillsNudgeResponsePayload.$Shape; dataframeChunk?: null }|{ payload?: "dataframeChunk"; deferredFile?: null; installSkills?: null; dismissSkillsNudge?: null; dataframeChunk: DataframeChunkResponsePayload.$Shape })
     * )} BackendOperationResponse.$Shape
     */

    /**
     * Constructs a new BackendOperationResponse.
     * @exports BackendOperationResponse
     * @classdesc Represents a BackendOperationResponse.
     * @constructor
     * @param {BackendOperationResponse.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const BackendOperationResponse = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * BackendOperationResponse requestId.
     * @member {string} requestId
     * @memberof BackendOperationResponse
     * @instance
     */
    BackendOperationResponse.prototype.requestId = "";

    /**
     * BackendOperationResponse errorMsg.
     * @member {string} errorMsg
     * @memberof BackendOperationResponse
     * @instance
     */
    BackendOperationResponse.prototype.errorMsg = "";

    /**
     * BackendOperationResponse errorReason.
     * @member {string} errorReason
     * @memberof BackendOperationResponse
     * @instance
     */
    BackendOperationResponse.prototype.errorReason = "";

    /**
     * BackendOperationResponse deferredFile.
     * @member {DeferredFileResponsePayload.$Properties|null|undefined} deferredFile
     * @memberof BackendOperationResponse
     * @instance
     */
    BackendOperationResponse.prototype.deferredFile = null;

    /**
     * BackendOperationResponse installSkills.
     * @member {InstallSkillsResponsePayload.$Properties|null|undefined} installSkills
     * @memberof BackendOperationResponse
     * @instance
     */
    BackendOperationResponse.prototype.installSkills = null;

    /**
     * BackendOperationResponse dismissSkillsNudge.
     * @member {DismissSkillsNudgeResponsePayload.$Properties|null|undefined} dismissSkillsNudge
     * @memberof BackendOperationResponse
     * @instance
     */
    BackendOperationResponse.prototype.dismissSkillsNudge = null;

    /**
     * BackendOperationResponse dataframeChunk.
     * @member {DataframeChunkResponsePayload.$Properties|null|undefined} dataframeChunk
     * @memberof BackendOperationResponse
     * @instance
     */
    BackendOperationResponse.prototype.dataframeChunk = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * BackendOperationResponse payload.
     * @member {"deferredFile"|"installSkills"|"dismissSkillsNudge"|"dataframeChunk"|undefined} payload
     * @memberof BackendOperationResponse
     * @instance
     */
    $Object.defineProperty(BackendOperationResponse.prototype, "payload", {
        get: $util.oneOfGetter($oneOfFields = ["deferredFile", "installSkills", "dismissSkillsNudge", "dataframeChunk"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new BackendOperationResponse instance using the specified properties.
     * @function create
     * @memberof BackendOperationResponse
     * @static
     * @param {BackendOperationResponse.$Properties=} [properties] Properties to set
     * @returns {BackendOperationResponse} BackendOperationResponse instance
     * @type {{
     *   (properties: BackendOperationResponse.$Shape): BackendOperationResponse & BackendOperationResponse.$Shape;
     *   (properties?: BackendOperationResponse.$Properties): BackendOperationResponse;
     * }}
     */
    BackendOperationResponse.create = function(properties) {
        return new BackendOperationResponse(properties);
    };

    /**
     * Encodes the specified BackendOperationResponse message. Does not implicitly {@link BackendOperationResponse.verify|verify} messages.
     * @function encode
     * @memberof BackendOperationResponse
     * @static
     * @param {BackendOperationResponse.$Properties} message BackendOperationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BackendOperationResponse.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.requestId != null && $Object.hasOwnProperty.call(message, "requestId") && message.requestId !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
        if (message.errorMsg != null && $Object.hasOwnProperty.call(message, "errorMsg") && message.errorMsg !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorMsg);
        if (message.deferredFile != null && $Object.hasOwnProperty.call(message, "deferredFile"))
            $root.DeferredFileResponsePayload.encode(message.deferredFile, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
        if (message.installSkills != null && $Object.hasOwnProperty.call(message, "installSkills"))
            $root.InstallSkillsResponsePayload.encode(message.installSkills, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
        if (message.dismissSkillsNudge != null && $Object.hasOwnProperty.call(message, "dismissSkillsNudge"))
            $root.DismissSkillsNudgeResponsePayload.encode(message.dismissSkillsNudge, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
        if (message.dataframeChunk != null && $Object.hasOwnProperty.call(message, "dataframeChunk"))
            $root.DataframeChunkResponsePayload.encode(message.dataframeChunk, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
        if (message.errorReason != null && $Object.hasOwnProperty.call(message, "errorReason") && message.errorReason !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.errorReason);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a BackendOperationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof BackendOperationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BackendOperationResponse & BackendOperationResponse.$Shape} BackendOperationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BackendOperationResponse.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.BackendOperationResponse();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.requestId = value;
                    else
                        delete message.requestId;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.errorMsg = value;
                    else
                        delete message.errorMsg;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.errorReason = value;
                    else
                        delete message.errorReason;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.deferredFile = $root.DeferredFileResponsePayload.decode(reader, reader.uint32(), $undefined, _depth + 1, message.deferredFile);
                    message.payload = "deferredFile";
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.installSkills = $root.InstallSkillsResponsePayload.decode(reader, reader.uint32(), $undefined, _depth + 1, message.installSkills);
                    message.payload = "installSkills";
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.dismissSkillsNudge = $root.DismissSkillsNudgeResponsePayload.decode(reader, reader.uint32(), $undefined, _depth + 1, message.dismissSkillsNudge);
                    message.payload = "dismissSkillsNudge";
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.dataframeChunk = $root.DataframeChunkResponsePayload.decode(reader, reader.uint32(), $undefined, _depth + 1, message.dataframeChunk);
                    message.payload = "dataframeChunk";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a BackendOperationResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BackendOperationResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BackendOperationResponse} BackendOperationResponse
     */
    BackendOperationResponse.fromObject = function (object, _depth) {
        if (object instanceof $root.BackendOperationResponse)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".BackendOperationResponse: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.BackendOperationResponse();
        if (object.requestId != null)
            if (typeof object.requestId !== "string" || object.requestId.length)
                message.requestId = $String(object.requestId);
        if (object.errorMsg != null)
            if (typeof object.errorMsg !== "string" || object.errorMsg.length)
                message.errorMsg = $String(object.errorMsg);
        if (object.errorReason != null)
            if (typeof object.errorReason !== "string" || object.errorReason.length)
                message.errorReason = $String(object.errorReason);
        if (object.deferredFile != null) {
            if (!$util.isObject(object.deferredFile))
                throw $TypeError(".BackendOperationResponse.deferredFile: object expected");
            message.deferredFile = $root.DeferredFileResponsePayload.fromObject(object.deferredFile, _depth + 1);
        }
        if (object.installSkills != null) {
            if (!$util.isObject(object.installSkills))
                throw $TypeError(".BackendOperationResponse.installSkills: object expected");
            message.installSkills = $root.InstallSkillsResponsePayload.fromObject(object.installSkills, _depth + 1);
        }
        if (object.dismissSkillsNudge != null) {
            if (!$util.isObject(object.dismissSkillsNudge))
                throw $TypeError(".BackendOperationResponse.dismissSkillsNudge: object expected");
            message.dismissSkillsNudge = $root.DismissSkillsNudgeResponsePayload.fromObject(object.dismissSkillsNudge, _depth + 1);
        }
        if (object.dataframeChunk != null) {
            if (!$util.isObject(object.dataframeChunk))
                throw $TypeError(".BackendOperationResponse.dataframeChunk: object expected");
            message.dataframeChunk = $root.DataframeChunkResponsePayload.fromObject(object.dataframeChunk, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a BackendOperationResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BackendOperationResponse
     * @static
     * @param {BackendOperationResponse} message BackendOperationResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BackendOperationResponse.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.requestId = "";
            object.errorMsg = "";
            object.errorReason = "";
        }
        if (message.requestId != null && $Object.hasOwnProperty.call(message, "requestId"))
            object.requestId = message.requestId;
        if (message.errorMsg != null && $Object.hasOwnProperty.call(message, "errorMsg"))
            object.errorMsg = message.errorMsg;
        if (message.deferredFile != null && $Object.hasOwnProperty.call(message, "deferredFile")) {
            object.deferredFile = $root.DeferredFileResponsePayload.toObject(message.deferredFile, options, _depth + 1);
            if (options.oneofs)
                object.payload = "deferredFile";
        }
        if (message.installSkills != null && $Object.hasOwnProperty.call(message, "installSkills")) {
            object.installSkills = $root.InstallSkillsResponsePayload.toObject(message.installSkills, options, _depth + 1);
            if (options.oneofs)
                object.payload = "installSkills";
        }
        if (message.dismissSkillsNudge != null && $Object.hasOwnProperty.call(message, "dismissSkillsNudge")) {
            object.dismissSkillsNudge = $root.DismissSkillsNudgeResponsePayload.toObject(message.dismissSkillsNudge, options, _depth + 1);
            if (options.oneofs)
                object.payload = "dismissSkillsNudge";
        }
        if (message.dataframeChunk != null && $Object.hasOwnProperty.call(message, "dataframeChunk")) {
            object.dataframeChunk = $root.DataframeChunkResponsePayload.toObject(message.dataframeChunk, options, _depth + 1);
            if (options.oneofs)
                object.payload = "dataframeChunk";
        }
        if (message.errorReason != null && $Object.hasOwnProperty.call(message, "errorReason"))
            object.errorReason = message.errorReason;
        return object;
    };

    /**
     * Converts this BackendOperationResponse to JSON.
     * @function toJSON
     * @memberof BackendOperationResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BackendOperationResponse.prototype.toJSON = function() {
        return BackendOperationResponse.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for BackendOperationResponse
     * @function getTypeUrl
     * @memberof BackendOperationResponse
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    BackendOperationResponse.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/BackendOperationResponse";
    };

    return BackendOperationResponse;
})();

export const DeferredFileResponsePayload = $root.DeferredFileResponsePayload = (() => {

    /**
     * Properties of a DeferredFileResponsePayload.
     * @typedef {Object} DeferredFileResponsePayload.$Properties
     * @property {string|null} [url] DeferredFileResponsePayload url
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DeferredFileResponsePayload.
     * @exports IDeferredFileResponsePayload
     * @interface IDeferredFileResponsePayload
     * @augments DeferredFileResponsePayload.$Properties
     * @deprecated Use DeferredFileResponsePayload.$Properties instead.
     */

    /**
     * Shape of a DeferredFileResponsePayload.
     * @typedef {DeferredFileResponsePayload.$Properties} DeferredFileResponsePayload.$Shape
     */

    /**
     * Constructs a new DeferredFileResponsePayload.
     * @exports DeferredFileResponsePayload
     * @classdesc Represents a DeferredFileResponsePayload.
     * @constructor
     * @param {DeferredFileResponsePayload.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DeferredFileResponsePayload = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * DeferredFileResponsePayload url.
     * @member {string} url
     * @memberof DeferredFileResponsePayload
     * @instance
     */
    DeferredFileResponsePayload.prototype.url = "";

    /**
     * Creates a new DeferredFileResponsePayload instance using the specified properties.
     * @function create
     * @memberof DeferredFileResponsePayload
     * @static
     * @param {DeferredFileResponsePayload.$Properties=} [properties] Properties to set
     * @returns {DeferredFileResponsePayload} DeferredFileResponsePayload instance
     * @type {{
     *   (properties: DeferredFileResponsePayload.$Shape): DeferredFileResponsePayload & DeferredFileResponsePayload.$Shape;
     *   (properties?: DeferredFileResponsePayload.$Properties): DeferredFileResponsePayload;
     * }}
     */
    DeferredFileResponsePayload.create = function(properties) {
        return new DeferredFileResponsePayload(properties);
    };

    /**
     * Encodes the specified DeferredFileResponsePayload message. Does not implicitly {@link DeferredFileResponsePayload.verify|verify} messages.
     * @function encode
     * @memberof DeferredFileResponsePayload
     * @static
     * @param {DeferredFileResponsePayload.$Properties} message DeferredFileResponsePayload message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeferredFileResponsePayload.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DeferredFileResponsePayload message from the specified reader or buffer.
     * @function decode
     * @memberof DeferredFileResponsePayload
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeferredFileResponsePayload & DeferredFileResponsePayload.$Shape} DeferredFileResponsePayload
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeferredFileResponsePayload.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DeferredFileResponsePayload();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DeferredFileResponsePayload message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeferredFileResponsePayload
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeferredFileResponsePayload} DeferredFileResponsePayload
     */
    DeferredFileResponsePayload.fromObject = function (object, _depth) {
        if (object instanceof $root.DeferredFileResponsePayload)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DeferredFileResponsePayload: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.DeferredFileResponsePayload();
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        return message;
    };

    /**
     * Creates a plain object from a DeferredFileResponsePayload message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeferredFileResponsePayload
     * @static
     * @param {DeferredFileResponsePayload} message DeferredFileResponsePayload
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeferredFileResponsePayload.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.url = "";
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        return object;
    };

    /**
     * Converts this DeferredFileResponsePayload to JSON.
     * @function toJSON
     * @memberof DeferredFileResponsePayload
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeferredFileResponsePayload.prototype.toJSON = function() {
        return DeferredFileResponsePayload.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DeferredFileResponsePayload
     * @function getTypeUrl
     * @memberof DeferredFileResponsePayload
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DeferredFileResponsePayload.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DeferredFileResponsePayload";
    };

    return DeferredFileResponsePayload;
})();

export const InstallSkillsResponsePayload = $root.InstallSkillsResponsePayload = (() => {

    /**
     * Properties of an InstallSkillsResponsePayload.
     * @typedef {Object} InstallSkillsResponsePayload.$Properties
     * @property {string|null} [detail] InstallSkillsResponsePayload detail
     * @property {string|null} [fallbackReason] InstallSkillsResponsePayload fallbackReason
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an InstallSkillsResponsePayload.
     * @exports IInstallSkillsResponsePayload
     * @interface IInstallSkillsResponsePayload
     * @augments InstallSkillsResponsePayload.$Properties
     * @deprecated Use InstallSkillsResponsePayload.$Properties instead.
     */

    /**
     * Shape of an InstallSkillsResponsePayload.
     * @typedef {InstallSkillsResponsePayload.$Properties} InstallSkillsResponsePayload.$Shape
     */

    /**
     * Constructs a new InstallSkillsResponsePayload.
     * @exports InstallSkillsResponsePayload
     * @classdesc Represents an InstallSkillsResponsePayload.
     * @constructor
     * @param {InstallSkillsResponsePayload.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const InstallSkillsResponsePayload = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * InstallSkillsResponsePayload detail.
     * @member {string} detail
     * @memberof InstallSkillsResponsePayload
     * @instance
     */
    InstallSkillsResponsePayload.prototype.detail = "";

    /**
     * InstallSkillsResponsePayload fallbackReason.
     * @member {string} fallbackReason
     * @memberof InstallSkillsResponsePayload
     * @instance
     */
    InstallSkillsResponsePayload.prototype.fallbackReason = "";

    /**
     * Creates a new InstallSkillsResponsePayload instance using the specified properties.
     * @function create
     * @memberof InstallSkillsResponsePayload
     * @static
     * @param {InstallSkillsResponsePayload.$Properties=} [properties] Properties to set
     * @returns {InstallSkillsResponsePayload} InstallSkillsResponsePayload instance
     * @type {{
     *   (properties: InstallSkillsResponsePayload.$Shape): InstallSkillsResponsePayload & InstallSkillsResponsePayload.$Shape;
     *   (properties?: InstallSkillsResponsePayload.$Properties): InstallSkillsResponsePayload;
     * }}
     */
    InstallSkillsResponsePayload.create = function(properties) {
        return new InstallSkillsResponsePayload(properties);
    };

    /**
     * Encodes the specified InstallSkillsResponsePayload message. Does not implicitly {@link InstallSkillsResponsePayload.verify|verify} messages.
     * @function encode
     * @memberof InstallSkillsResponsePayload
     * @static
     * @param {InstallSkillsResponsePayload.$Properties} message InstallSkillsResponsePayload message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstallSkillsResponsePayload.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.detail != null && $Object.hasOwnProperty.call(message, "detail") && message.detail !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.detail);
        if (message.fallbackReason != null && $Object.hasOwnProperty.call(message, "fallbackReason") && message.fallbackReason !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.fallbackReason);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an InstallSkillsResponsePayload message from the specified reader or buffer.
     * @function decode
     * @memberof InstallSkillsResponsePayload
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InstallSkillsResponsePayload & InstallSkillsResponsePayload.$Shape} InstallSkillsResponsePayload
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstallSkillsResponsePayload.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.InstallSkillsResponsePayload();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.detail = value;
                    else
                        delete message.detail;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.fallbackReason = value;
                    else
                        delete message.fallbackReason;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an InstallSkillsResponsePayload message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InstallSkillsResponsePayload
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InstallSkillsResponsePayload} InstallSkillsResponsePayload
     */
    InstallSkillsResponsePayload.fromObject = function (object, _depth) {
        if (object instanceof $root.InstallSkillsResponsePayload)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".InstallSkillsResponsePayload: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.InstallSkillsResponsePayload();
        if (object.detail != null)
            if (typeof object.detail !== "string" || object.detail.length)
                message.detail = $String(object.detail);
        if (object.fallbackReason != null)
            if (typeof object.fallbackReason !== "string" || object.fallbackReason.length)
                message.fallbackReason = $String(object.fallbackReason);
        return message;
    };

    /**
     * Creates a plain object from an InstallSkillsResponsePayload message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InstallSkillsResponsePayload
     * @static
     * @param {InstallSkillsResponsePayload} message InstallSkillsResponsePayload
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InstallSkillsResponsePayload.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.detail = "";
            object.fallbackReason = "";
        }
        if (message.detail != null && $Object.hasOwnProperty.call(message, "detail"))
            object.detail = message.detail;
        if (message.fallbackReason != null && $Object.hasOwnProperty.call(message, "fallbackReason"))
            object.fallbackReason = message.fallbackReason;
        return object;
    };

    /**
     * Converts this InstallSkillsResponsePayload to JSON.
     * @function toJSON
     * @memberof InstallSkillsResponsePayload
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InstallSkillsResponsePayload.prototype.toJSON = function() {
        return InstallSkillsResponsePayload.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for InstallSkillsResponsePayload
     * @function getTypeUrl
     * @memberof InstallSkillsResponsePayload
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    InstallSkillsResponsePayload.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/InstallSkillsResponsePayload";
    };

    return InstallSkillsResponsePayload;
})();

export const DismissSkillsNudgeResponsePayload = $root.DismissSkillsNudgeResponsePayload = (() => {

    /**
     * Properties of a DismissSkillsNudgeResponsePayload.
     * @typedef {Object} DismissSkillsNudgeResponsePayload.$Properties
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DismissSkillsNudgeResponsePayload.
     * @exports IDismissSkillsNudgeResponsePayload
     * @interface IDismissSkillsNudgeResponsePayload
     * @augments DismissSkillsNudgeResponsePayload.$Properties
     * @deprecated Use DismissSkillsNudgeResponsePayload.$Properties instead.
     */

    /**
     * Shape of a DismissSkillsNudgeResponsePayload.
     * @typedef {DismissSkillsNudgeResponsePayload.$Properties} DismissSkillsNudgeResponsePayload.$Shape
     */

    /**
     * Constructs a new DismissSkillsNudgeResponsePayload.
     * @exports DismissSkillsNudgeResponsePayload
     * @classdesc Represents a DismissSkillsNudgeResponsePayload.
     * @constructor
     * @param {DismissSkillsNudgeResponsePayload.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DismissSkillsNudgeResponsePayload = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Creates a new DismissSkillsNudgeResponsePayload instance using the specified properties.
     * @function create
     * @memberof DismissSkillsNudgeResponsePayload
     * @static
     * @param {DismissSkillsNudgeResponsePayload.$Properties=} [properties] Properties to set
     * @returns {DismissSkillsNudgeResponsePayload} DismissSkillsNudgeResponsePayload instance
     * @type {{
     *   (properties: DismissSkillsNudgeResponsePayload.$Shape): DismissSkillsNudgeResponsePayload & DismissSkillsNudgeResponsePayload.$Shape;
     *   (properties?: DismissSkillsNudgeResponsePayload.$Properties): DismissSkillsNudgeResponsePayload;
     * }}
     */
    DismissSkillsNudgeResponsePayload.create = function(properties) {
        return new DismissSkillsNudgeResponsePayload(properties);
    };

    /**
     * Encodes the specified DismissSkillsNudgeResponsePayload message. Does not implicitly {@link DismissSkillsNudgeResponsePayload.verify|verify} messages.
     * @function encode
     * @memberof DismissSkillsNudgeResponsePayload
     * @static
     * @param {DismissSkillsNudgeResponsePayload.$Properties} message DismissSkillsNudgeResponsePayload message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DismissSkillsNudgeResponsePayload.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DismissSkillsNudgeResponsePayload message from the specified reader or buffer.
     * @function decode
     * @memberof DismissSkillsNudgeResponsePayload
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DismissSkillsNudgeResponsePayload & DismissSkillsNudgeResponsePayload.$Shape} DismissSkillsNudgeResponsePayload
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DismissSkillsNudgeResponsePayload.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DismissSkillsNudgeResponsePayload();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            reader.skipType(tag & 7, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DismissSkillsNudgeResponsePayload message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DismissSkillsNudgeResponsePayload
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DismissSkillsNudgeResponsePayload} DismissSkillsNudgeResponsePayload
     */
    DismissSkillsNudgeResponsePayload.fromObject = function (object, _depth) {
        if (object instanceof $root.DismissSkillsNudgeResponsePayload)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DismissSkillsNudgeResponsePayload: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        return new $root.DismissSkillsNudgeResponsePayload();
    };

    /**
     * Creates a plain object from a DismissSkillsNudgeResponsePayload message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DismissSkillsNudgeResponsePayload
     * @static
     * @param {DismissSkillsNudgeResponsePayload} message DismissSkillsNudgeResponsePayload
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DismissSkillsNudgeResponsePayload.toObject = function () {
        return {};
    };

    /**
     * Converts this DismissSkillsNudgeResponsePayload to JSON.
     * @function toJSON
     * @memberof DismissSkillsNudgeResponsePayload
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DismissSkillsNudgeResponsePayload.prototype.toJSON = function() {
        return DismissSkillsNudgeResponsePayload.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DismissSkillsNudgeResponsePayload
     * @function getTypeUrl
     * @memberof DismissSkillsNudgeResponsePayload
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DismissSkillsNudgeResponsePayload.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DismissSkillsNudgeResponsePayload";
    };

    return DismissSkillsNudgeResponsePayload;
})();

export const DataframeChunkResponsePayload = $root.DataframeChunkResponsePayload = (() => {

    /**
     * Properties of a DataframeChunkResponsePayload.
     * @typedef {Object} DataframeChunkResponsePayload.$Properties
     * @property {string|null} [sourceId] DataframeChunkResponsePayload sourceId
     * @property {number|Long|null} [offset] DataframeChunkResponsePayload offset
     * @property {boolean|null} [endOfStream] DataframeChunkResponsePayload endOfStream
     * @property {ArrowData.$Properties|null} [arrowData] DataframeChunkResponsePayload arrowData
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a DataframeChunkResponsePayload.
     * @exports IDataframeChunkResponsePayload
     * @interface IDataframeChunkResponsePayload
     * @augments DataframeChunkResponsePayload.$Properties
     * @deprecated Use DataframeChunkResponsePayload.$Properties instead.
     */

    /**
     * Shape of a DataframeChunkResponsePayload.
     * @typedef {DataframeChunkResponsePayload.$Properties} DataframeChunkResponsePayload.$Shape
     */

    /**
     * Constructs a new DataframeChunkResponsePayload.
     * @exports DataframeChunkResponsePayload
     * @classdesc Represents a DataframeChunkResponsePayload.
     * @constructor
     * @param {DataframeChunkResponsePayload.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const DataframeChunkResponsePayload = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * DataframeChunkResponsePayload sourceId.
     * @member {string} sourceId
     * @memberof DataframeChunkResponsePayload
     * @instance
     */
    DataframeChunkResponsePayload.prototype.sourceId = "";

    /**
     * DataframeChunkResponsePayload offset.
     * @member {number|Long} offset
     * @memberof DataframeChunkResponsePayload
     * @instance
     */
    DataframeChunkResponsePayload.prototype.offset = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * DataframeChunkResponsePayload endOfStream.
     * @member {boolean} endOfStream
     * @memberof DataframeChunkResponsePayload
     * @instance
     */
    DataframeChunkResponsePayload.prototype.endOfStream = false;

    /**
     * DataframeChunkResponsePayload arrowData.
     * @member {ArrowData.$Properties|null|undefined} arrowData
     * @memberof DataframeChunkResponsePayload
     * @instance
     */
    DataframeChunkResponsePayload.prototype.arrowData = null;

    /**
     * Creates a new DataframeChunkResponsePayload instance using the specified properties.
     * @function create
     * @memberof DataframeChunkResponsePayload
     * @static
     * @param {DataframeChunkResponsePayload.$Properties=} [properties] Properties to set
     * @returns {DataframeChunkResponsePayload} DataframeChunkResponsePayload instance
     * @type {{
     *   (properties: DataframeChunkResponsePayload.$Shape): DataframeChunkResponsePayload & DataframeChunkResponsePayload.$Shape;
     *   (properties?: DataframeChunkResponsePayload.$Properties): DataframeChunkResponsePayload;
     * }}
     */
    DataframeChunkResponsePayload.create = function(properties) {
        return new DataframeChunkResponsePayload(properties);
    };

    /**
     * Encodes the specified DataframeChunkResponsePayload message. Does not implicitly {@link DataframeChunkResponsePayload.verify|verify} messages.
     * @function encode
     * @memberof DataframeChunkResponsePayload
     * @static
     * @param {DataframeChunkResponsePayload.$Properties} message DataframeChunkResponsePayload message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DataframeChunkResponsePayload.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.sourceId != null && $Object.hasOwnProperty.call(message, "sourceId") && message.sourceId !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.sourceId);
        if (message.offset != null && $Object.hasOwnProperty.call(message, "offset") && (typeof message.offset === "object" ? message.offset.low || message.offset.high : message.offset !== 0))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.offset);
        if (message.endOfStream != null && $Object.hasOwnProperty.call(message, "endOfStream") && message.endOfStream !== false)
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.endOfStream);
        if (message.arrowData != null && $Object.hasOwnProperty.call(message, "arrowData"))
            $root.ArrowData.encode(message.arrowData, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a DataframeChunkResponsePayload message from the specified reader or buffer.
     * @function decode
     * @memberof DataframeChunkResponsePayload
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DataframeChunkResponsePayload & DataframeChunkResponsePayload.$Shape} DataframeChunkResponsePayload
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DataframeChunkResponsePayload.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.DataframeChunkResponsePayload();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.sourceId = value;
                    else
                        delete message.sourceId;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                        message.offset = value;
                    else
                        delete message.offset;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.endOfStream = value;
                    else
                        delete message.endOfStream;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.arrowData = $root.ArrowData.decode(reader, reader.uint32(), $undefined, _depth + 1, message.arrowData);
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a DataframeChunkResponsePayload message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DataframeChunkResponsePayload
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DataframeChunkResponsePayload} DataframeChunkResponsePayload
     */
    DataframeChunkResponsePayload.fromObject = function (object, _depth) {
        if (object instanceof $root.DataframeChunkResponsePayload)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".DataframeChunkResponsePayload: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.DataframeChunkResponsePayload();
        if (object.sourceId != null)
            if (typeof object.sourceId !== "string" || object.sourceId.length)
                message.sourceId = $String(object.sourceId);
        if (object.offset != null)
            if (typeof object.offset === "object" ? object.offset.low || object.offset.high : $Number(object.offset) !== 0)
                if ($util.Long)
                    message.offset = $util.Long.fromValue(object.offset, true);
                else if (typeof object.offset === "string")
                    message.offset = $parseInt(object.offset, 10);
                else if (typeof object.offset === "number")
                    message.offset = object.offset;
                else if (typeof object.offset === "object")
                    message.offset = new $util.LongBits(object.offset.low >>> 0, object.offset.high >>> 0).toNumber(true);
        if (object.endOfStream != null)
            if (object.endOfStream)
                message.endOfStream = $Boolean(object.endOfStream);
        if (object.arrowData != null) {
            if (!$util.isObject(object.arrowData))
                throw $TypeError(".DataframeChunkResponsePayload.arrowData: object expected");
            message.arrowData = $root.ArrowData.fromObject(object.arrowData, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a DataframeChunkResponsePayload message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DataframeChunkResponsePayload
     * @static
     * @param {DataframeChunkResponsePayload} message DataframeChunkResponsePayload
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DataframeChunkResponsePayload.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.sourceId = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.offset = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.offset = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            object.endOfStream = false;
            object.arrowData = null;
        }
        if (message.sourceId != null && $Object.hasOwnProperty.call(message, "sourceId"))
            object.sourceId = message.sourceId;
        if (message.offset != null && $Object.hasOwnProperty.call(message, "offset"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.offset = typeof message.offset === "number" ? $BigInt(message.offset) : $util.Long.fromBits(message.offset.low >>> 0, message.offset.high >>> 0, true).toBigInt();
            else if (typeof message.offset === "number")
                object.offset = options.longs === $String ? $String(message.offset) : message.offset;
            else
                object.offset = options.longs === $String ? $util.Long.prototype.toString.call(message.offset) : options.longs === $Number ? new $util.LongBits(message.offset.low >>> 0, message.offset.high >>> 0).toNumber(true) : message.offset;
        if (message.endOfStream != null && $Object.hasOwnProperty.call(message, "endOfStream"))
            object.endOfStream = message.endOfStream;
        if (message.arrowData != null && $Object.hasOwnProperty.call(message, "arrowData"))
            object.arrowData = $root.ArrowData.toObject(message.arrowData, options, _depth + 1);
        return object;
    };

    /**
     * Converts this DataframeChunkResponsePayload to JSON.
     * @function toJSON
     * @memberof DataframeChunkResponsePayload
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DataframeChunkResponsePayload.prototype.toJSON = function() {
        return DataframeChunkResponsePayload.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for DataframeChunkResponsePayload
     * @function getTypeUrl
     * @memberof DataframeChunkResponsePayload
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    DataframeChunkResponsePayload.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/DataframeChunkResponsePayload";
    };

    return DataframeChunkResponsePayload;
})();

export const ForwardMsgMetadata = $root.ForwardMsgMetadata = (() => {

    /**
     * Properties of a ForwardMsgMetadata.
     * @typedef {Object} ForwardMsgMetadata.$Properties
     * @property {boolean|null} [cacheable] ForwardMsgMetadata cacheable
     * @property {Array.<number>|null} [deltaPath] ForwardMsgMetadata deltaPath
     * @property {string|null} [activeScriptHash] ForwardMsgMetadata activeScriptHash
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ForwardMsgMetadata.
     * @exports IForwardMsgMetadata
     * @interface IForwardMsgMetadata
     * @augments ForwardMsgMetadata.$Properties
     * @deprecated Use ForwardMsgMetadata.$Properties instead.
     */

    /**
     * Shape of a ForwardMsgMetadata.
     * @typedef {ForwardMsgMetadata.$Properties} ForwardMsgMetadata.$Shape
     */

    /**
     * Constructs a new ForwardMsgMetadata.
     * @exports ForwardMsgMetadata
     * @classdesc Represents a ForwardMsgMetadata.
     * @constructor
     * @param {ForwardMsgMetadata.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ForwardMsgMetadata = function (properties) {
        this.deltaPath = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ForwardMsgMetadata cacheable.
     * @member {boolean} cacheable
     * @memberof ForwardMsgMetadata
     * @instance
     */
    ForwardMsgMetadata.prototype.cacheable = false;

    /**
     * ForwardMsgMetadata deltaPath.
     * @member {Array.<number>} deltaPath
     * @memberof ForwardMsgMetadata
     * @instance
     */
    ForwardMsgMetadata.prototype.deltaPath = $util.emptyArray;

    /**
     * ForwardMsgMetadata activeScriptHash.
     * @member {string} activeScriptHash
     * @memberof ForwardMsgMetadata
     * @instance
     */
    ForwardMsgMetadata.prototype.activeScriptHash = "";

    /**
     * Creates a new ForwardMsgMetadata instance using the specified properties.
     * @function create
     * @memberof ForwardMsgMetadata
     * @static
     * @param {ForwardMsgMetadata.$Properties=} [properties] Properties to set
     * @returns {ForwardMsgMetadata} ForwardMsgMetadata instance
     * @type {{
     *   (properties: ForwardMsgMetadata.$Shape): ForwardMsgMetadata & ForwardMsgMetadata.$Shape;
     *   (properties?: ForwardMsgMetadata.$Properties): ForwardMsgMetadata;
     * }}
     */
    ForwardMsgMetadata.create = function(properties) {
        return new ForwardMsgMetadata(properties);
    };

    /**
     * Encodes the specified ForwardMsgMetadata message. Does not implicitly {@link ForwardMsgMetadata.verify|verify} messages.
     * @function encode
     * @memberof ForwardMsgMetadata
     * @static
     * @param {ForwardMsgMetadata.$Properties} message ForwardMsgMetadata message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardMsgMetadata.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.cacheable != null && $Object.hasOwnProperty.call(message, "cacheable") && message.cacheable !== false)
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.cacheable);
        if (message.deltaPath != null && message.deltaPath.length)
            writer.uint32(/* id 2, wireType 2 =*/18).uint32s(message.deltaPath);
        if (message.activeScriptHash != null && $Object.hasOwnProperty.call(message, "activeScriptHash") && message.activeScriptHash !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.activeScriptHash);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ForwardMsgMetadata message from the specified reader or buffer.
     * @function decode
     * @memberof ForwardMsgMetadata
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ForwardMsgMetadata & ForwardMsgMetadata.$Shape} ForwardMsgMetadata
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardMsgMetadata.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ForwardMsgMetadata();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.cacheable = value;
                    else
                        delete message.cacheable;
                    continue;
                }
            case 2: {
                    if (wireType === 2) {
                        if (!(message.deltaPath && message.deltaPath.length))
                            message.deltaPath = [];
                        reader.uint32s(message.deltaPath);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message.deltaPath && message.deltaPath.length))
                        message.deltaPath = [];
                    message.deltaPath.push(reader.uint32());
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.activeScriptHash = value;
                    else
                        delete message.activeScriptHash;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ForwardMsgMetadata message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ForwardMsgMetadata
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ForwardMsgMetadata} ForwardMsgMetadata
     */
    ForwardMsgMetadata.fromObject = function (object, _depth) {
        if (object instanceof $root.ForwardMsgMetadata)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ForwardMsgMetadata: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ForwardMsgMetadata();
        if (object.cacheable != null)
            if (object.cacheable)
                message.cacheable = $Boolean(object.cacheable);
        if (object.deltaPath) {
            if (!$Array.isArray(object.deltaPath))
                throw $TypeError(".ForwardMsgMetadata.deltaPath: array expected");
            message.deltaPath = $Array(object.deltaPath.length);
            for (let i = 0; i < object.deltaPath.length; ++i)
                message.deltaPath[i] = object.deltaPath[i] >>> 0;
        }
        if (object.activeScriptHash != null)
            if (typeof object.activeScriptHash !== "string" || object.activeScriptHash.length)
                message.activeScriptHash = $String(object.activeScriptHash);
        return message;
    };

    /**
     * Creates a plain object from a ForwardMsgMetadata message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ForwardMsgMetadata
     * @static
     * @param {ForwardMsgMetadata} message ForwardMsgMetadata
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ForwardMsgMetadata.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.deltaPath = [];
        if (options.defaults) {
            object.cacheable = false;
            object.activeScriptHash = "";
        }
        if (message.cacheable != null && $Object.hasOwnProperty.call(message, "cacheable"))
            object.cacheable = message.cacheable;
        if (message.deltaPath && message.deltaPath.length) {
            object.deltaPath = $Array(message.deltaPath.length);
            for (let j = 0; j < message.deltaPath.length; ++j)
                object.deltaPath[j] = message.deltaPath[j];
        }
        if (message.activeScriptHash != null && $Object.hasOwnProperty.call(message, "activeScriptHash"))
            object.activeScriptHash = message.activeScriptHash;
        return object;
    };

    /**
     * Converts this ForwardMsgMetadata to JSON.
     * @function toJSON
     * @memberof ForwardMsgMetadata
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ForwardMsgMetadata.prototype.toJSON = function() {
        return ForwardMsgMetadata.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ForwardMsgMetadata
     * @function getTypeUrl
     * @memberof ForwardMsgMetadata
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ForwardMsgMetadata.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ForwardMsgMetadata";
    };

    return ForwardMsgMetadata;
})();

export const ForwardMsgList = $root.ForwardMsgList = (() => {

    /**
     * Properties of a ForwardMsgList.
     * @typedef {Object} ForwardMsgList.$Properties
     * @property {Array.<ForwardMsg.$Properties>|null} [messages] ForwardMsgList messages
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ForwardMsgList.
     * @exports IForwardMsgList
     * @interface IForwardMsgList
     * @augments ForwardMsgList.$Properties
     * @deprecated Use ForwardMsgList.$Properties instead.
     */

    /**
     * Shape of a ForwardMsgList.
     * @typedef {{
     *   messages?: Array.<ForwardMsg.$Shape>|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} ForwardMsgList.$Shape
     */

    /**
     * Constructs a new ForwardMsgList.
     * @exports ForwardMsgList
     * @classdesc Represents a ForwardMsgList.
     * @constructor
     * @param {ForwardMsgList.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ForwardMsgList = function (properties) {
        this.messages = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ForwardMsgList messages.
     * @member {Array.<ForwardMsg.$Properties>} messages
     * @memberof ForwardMsgList
     * @instance
     */
    ForwardMsgList.prototype.messages = $util.emptyArray;

    /**
     * Creates a new ForwardMsgList instance using the specified properties.
     * @function create
     * @memberof ForwardMsgList
     * @static
     * @param {ForwardMsgList.$Properties=} [properties] Properties to set
     * @returns {ForwardMsgList} ForwardMsgList instance
     * @type {{
     *   (properties: ForwardMsgList.$Shape): ForwardMsgList & ForwardMsgList.$Shape;
     *   (properties?: ForwardMsgList.$Properties): ForwardMsgList;
     * }}
     */
    ForwardMsgList.create = function(properties) {
        return new ForwardMsgList(properties);
    };

    /**
     * Encodes the specified ForwardMsgList message. Does not implicitly {@link ForwardMsgList.verify|verify} messages.
     * @function encode
     * @memberof ForwardMsgList
     * @static
     * @param {ForwardMsgList.$Properties} message ForwardMsgList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardMsgList.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.messages != null && message.messages.length)
            for (let i = 0; i < message.messages.length; ++i)
                $root.ForwardMsg.encode(message.messages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ForwardMsgList message from the specified reader or buffer.
     * @function decode
     * @memberof ForwardMsgList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ForwardMsgList & ForwardMsgList.$Shape} ForwardMsgList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardMsgList.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ForwardMsgList();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if (!(message.messages && message.messages.length))
                        message.messages = [];
                    message.messages.push($root.ForwardMsg.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ForwardMsgList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ForwardMsgList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ForwardMsgList} ForwardMsgList
     */
    ForwardMsgList.fromObject = function (object, _depth) {
        if (object instanceof $root.ForwardMsgList)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ForwardMsgList: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ForwardMsgList();
        if (object.messages) {
            if (!$Array.isArray(object.messages))
                throw $TypeError(".ForwardMsgList.messages: array expected");
            message.messages = $Array(object.messages.length);
            for (let i = 0; i < object.messages.length; ++i) {
                if (!$util.isObject(object.messages[i]))
                    throw $TypeError(".ForwardMsgList.messages: object expected");
                message.messages[i] = $root.ForwardMsg.fromObject(object.messages[i], _depth + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ForwardMsgList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ForwardMsgList
     * @static
     * @param {ForwardMsgList} message ForwardMsgList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ForwardMsgList.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.messages = [];
        if (message.messages && message.messages.length) {
            object.messages = $Array(message.messages.length);
            for (let j = 0; j < message.messages.length; ++j)
                object.messages[j] = $root.ForwardMsg.toObject(message.messages[j], options, _depth + 1);
        }
        return object;
    };

    /**
     * Converts this ForwardMsgList to JSON.
     * @function toJSON
     * @memberof ForwardMsgList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ForwardMsgList.prototype.toJSON = function() {
        return ForwardMsgList.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ForwardMsgList
     * @function getTypeUrl
     * @memberof ForwardMsgList
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ForwardMsgList.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ForwardMsgList";
    };

    return ForwardMsgList;
})();

export const GitInfo = $root.GitInfo = (() => {

    /**
     * Properties of a GitInfo.
     * @typedef {Object} GitInfo.$Properties
     * @property {string|null} [repository] GitInfo repository
     * @property {string|null} [branch] GitInfo branch
     * @property {string|null} [module] GitInfo module
     * @property {Array.<string>|null} [untrackedFiles] GitInfo untrackedFiles
     * @property {Array.<string>|null} [uncommittedFiles] GitInfo uncommittedFiles
     * @property {GitInfo.GitStates|null} [state] GitInfo state
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a GitInfo.
     * @exports IGitInfo
     * @interface IGitInfo
     * @augments GitInfo.$Properties
     * @deprecated Use GitInfo.$Properties instead.
     */

    /**
     * Shape of a GitInfo.
     * @typedef {GitInfo.$Properties} GitInfo.$Shape
     */

    /**
     * Constructs a new GitInfo.
     * @exports GitInfo
     * @classdesc Represents a GitInfo.
     * @constructor
     * @param {GitInfo.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const GitInfo = function (properties) {
        this.untrackedFiles = [];
        this.uncommittedFiles = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * GitInfo repository.
     * @member {string} repository
     * @memberof GitInfo
     * @instance
     */
    GitInfo.prototype.repository = "";

    /**
     * GitInfo branch.
     * @member {string} branch
     * @memberof GitInfo
     * @instance
     */
    GitInfo.prototype.branch = "";

    /**
     * GitInfo module.
     * @member {string} module
     * @memberof GitInfo
     * @instance
     */
    GitInfo.prototype.module = "";

    /**
     * GitInfo untrackedFiles.
     * @member {Array.<string>} untrackedFiles
     * @memberof GitInfo
     * @instance
     */
    GitInfo.prototype.untrackedFiles = $util.emptyArray;

    /**
     * GitInfo uncommittedFiles.
     * @member {Array.<string>} uncommittedFiles
     * @memberof GitInfo
     * @instance
     */
    GitInfo.prototype.uncommittedFiles = $util.emptyArray;

    /**
     * GitInfo state.
     * @member {GitInfo.GitStates} state
     * @memberof GitInfo
     * @instance
     */
    GitInfo.prototype.state = 0;

    /**
     * Creates a new GitInfo instance using the specified properties.
     * @function create
     * @memberof GitInfo
     * @static
     * @param {GitInfo.$Properties=} [properties] Properties to set
     * @returns {GitInfo} GitInfo instance
     * @type {{
     *   (properties: GitInfo.$Shape): GitInfo & GitInfo.$Shape;
     *   (properties?: GitInfo.$Properties): GitInfo;
     * }}
     */
    GitInfo.create = function(properties) {
        return new GitInfo(properties);
    };

    /**
     * Encodes the specified GitInfo message. Does not implicitly {@link GitInfo.verify|verify} messages.
     * @function encode
     * @memberof GitInfo
     * @static
     * @param {GitInfo.$Properties} message GitInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GitInfo.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.repository != null && $Object.hasOwnProperty.call(message, "repository") && message.repository !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.repository);
        if (message.branch != null && $Object.hasOwnProperty.call(message, "branch") && message.branch !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.branch);
        if (message.module != null && $Object.hasOwnProperty.call(message, "module") && message.module !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.module);
        if (message.untrackedFiles != null && message.untrackedFiles.length)
            for (let i = 0; i < message.untrackedFiles.length; ++i)
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.untrackedFiles[i]);
        if (message.uncommittedFiles != null && message.uncommittedFiles.length)
            for (let i = 0; i < message.uncommittedFiles.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.uncommittedFiles[i]);
        if (message.state != null && $Object.hasOwnProperty.call(message, "state") && message.state !== 0)
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.state);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a GitInfo message from the specified reader or buffer.
     * @function decode
     * @memberof GitInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GitInfo & GitInfo.$Shape} GitInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GitInfo.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.GitInfo();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.repository = value;
                    else
                        delete message.repository;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.branch = value;
                    else
                        delete message.branch;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.module = value;
                    else
                        delete message.module;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if (!(message.untrackedFiles && message.untrackedFiles.length))
                        message.untrackedFiles = [];
                    message.untrackedFiles.push(reader.stringVerify());
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if (!(message.uncommittedFiles && message.uncommittedFiles.length))
                        message.uncommittedFiles = [];
                    message.uncommittedFiles.push(reader.stringVerify());
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.state = value;
                    else
                        delete message.state;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a GitInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GitInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GitInfo} GitInfo
     */
    GitInfo.fromObject = function (object, _depth) {
        if (object instanceof $root.GitInfo)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".GitInfo: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.GitInfo();
        if (object.repository != null)
            if (typeof object.repository !== "string" || object.repository.length)
                message.repository = $String(object.repository);
        if (object.branch != null)
            if (typeof object.branch !== "string" || object.branch.length)
                message.branch = $String(object.branch);
        if (object.module != null)
            if (typeof object.module !== "string" || object.module.length)
                message.module = $String(object.module);
        if (object.untrackedFiles) {
            if (!$Array.isArray(object.untrackedFiles))
                throw $TypeError(".GitInfo.untrackedFiles: array expected");
            message.untrackedFiles = $Array(object.untrackedFiles.length);
            for (let i = 0; i < object.untrackedFiles.length; ++i)
                message.untrackedFiles[i] = $String(object.untrackedFiles[i]);
        }
        if (object.uncommittedFiles) {
            if (!$Array.isArray(object.uncommittedFiles))
                throw $TypeError(".GitInfo.uncommittedFiles: array expected");
            message.uncommittedFiles = $Array(object.uncommittedFiles.length);
            for (let i = 0; i < object.uncommittedFiles.length; ++i)
                message.uncommittedFiles[i] = $String(object.uncommittedFiles[i]);
        }
        if (object.state !== 0 && (typeof object.state !== "string" || $root.GitInfo.GitStates[object.state] !== 0))
            switch (object.state) {
            case "DEFAULT":
            case 0:
                message.state = 0;
                break;
            case "HEAD_DETACHED":
            case 1:
                message.state = 1;
                break;
            case "AHEAD_OF_REMOTE":
            case 2:
                message.state = 2;
                break;
            default:
                if (typeof object.state === "number" && (object.state | 0) === object.state)
                    message.state = object.state;
            }
        return message;
    };

    /**
     * Creates a plain object from a GitInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GitInfo
     * @static
     * @param {GitInfo} message GitInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GitInfo.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object.untrackedFiles = [];
            object.uncommittedFiles = [];
        }
        if (options.defaults) {
            object.repository = "";
            object.branch = "";
            object.module = "";
            object.state = options.enums === $String ? "DEFAULT" : 0;
        }
        if (message.repository != null && $Object.hasOwnProperty.call(message, "repository"))
            object.repository = message.repository;
        if (message.branch != null && $Object.hasOwnProperty.call(message, "branch"))
            object.branch = message.branch;
        if (message.module != null && $Object.hasOwnProperty.call(message, "module"))
            object.module = message.module;
        if (message.untrackedFiles && message.untrackedFiles.length) {
            object.untrackedFiles = $Array(message.untrackedFiles.length);
            for (let j = 0; j < message.untrackedFiles.length; ++j)
                object.untrackedFiles[j] = message.untrackedFiles[j];
        }
        if (message.uncommittedFiles && message.uncommittedFiles.length) {
            object.uncommittedFiles = $Array(message.uncommittedFiles.length);
            for (let j = 0; j < message.uncommittedFiles.length; ++j)
                object.uncommittedFiles[j] = message.uncommittedFiles[j];
        }
        if (message.state != null && $Object.hasOwnProperty.call(message, "state"))
            object.state = options.enums === $String ? $root.GitInfo.GitStates[message.state] === $undefined ? message.state : $root.GitInfo.GitStates[message.state] : message.state;
        return object;
    };

    /**
     * Converts this GitInfo to JSON.
     * @function toJSON
     * @memberof GitInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GitInfo.prototype.toJSON = function() {
        return GitInfo.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for GitInfo
     * @function getTypeUrl
     * @memberof GitInfo
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    GitInfo.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/GitInfo";
    };

    /**
     * GitStates enum.
     * @name GitInfo.GitStates
     * @enum {number}
     * @property {number} DEFAULT=0 DEFAULT value
     * @property {number} HEAD_DETACHED=1 HEAD_DETACHED value
     * @property {number} AHEAD_OF_REMOTE=2 AHEAD_OF_REMOTE value
     */
    GitInfo.GitStates = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "DEFAULT"] = 0;
        values[valuesById[1] = "HEAD_DETACHED"] = 1;
        values[valuesById[2] = "AHEAD_OF_REMOTE"] = 2;
        return values;
    })();

    return GitInfo;
})();

export const Logo = $root.Logo = (() => {

    /**
     * Properties of a Logo.
     * @typedef {Object} Logo.$Properties
     * @property {string|null} [image] Logo image
     * @property {string|null} [link] Logo link
     * @property {string|null} [iconImage] Logo iconImage
     * @property {string|null} [size] Logo size
     * @property {Logo.ImageType|null} [imageType] Logo imageType
     * @property {Logo.ImageType|null} [iconImageType] Logo iconImageType
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Logo.
     * @exports ILogo
     * @interface ILogo
     * @augments Logo.$Properties
     * @deprecated Use Logo.$Properties instead.
     */

    /**
     * Shape of a Logo.
     * @typedef {Logo.$Properties} Logo.$Shape
     */

    /**
     * Constructs a new Logo.
     * @exports Logo
     * @classdesc Represents a Logo.
     * @constructor
     * @param {Logo.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Logo = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Logo image.
     * @member {string} image
     * @memberof Logo
     * @instance
     */
    Logo.prototype.image = "";

    /**
     * Logo link.
     * @member {string} link
     * @memberof Logo
     * @instance
     */
    Logo.prototype.link = "";

    /**
     * Logo iconImage.
     * @member {string} iconImage
     * @memberof Logo
     * @instance
     */
    Logo.prototype.iconImage = "";

    /**
     * Logo size.
     * @member {string} size
     * @memberof Logo
     * @instance
     */
    Logo.prototype.size = "";

    /**
     * Logo imageType.
     * @member {Logo.ImageType} imageType
     * @memberof Logo
     * @instance
     */
    Logo.prototype.imageType = 0;

    /**
     * Logo iconImageType.
     * @member {Logo.ImageType} iconImageType
     * @memberof Logo
     * @instance
     */
    Logo.prototype.iconImageType = 0;

    /**
     * Creates a new Logo instance using the specified properties.
     * @function create
     * @memberof Logo
     * @static
     * @param {Logo.$Properties=} [properties] Properties to set
     * @returns {Logo} Logo instance
     * @type {{
     *   (properties: Logo.$Shape): Logo & Logo.$Shape;
     *   (properties?: Logo.$Properties): Logo;
     * }}
     */
    Logo.create = function(properties) {
        return new Logo(properties);
    };

    /**
     * Encodes the specified Logo message. Does not implicitly {@link Logo.verify|verify} messages.
     * @function encode
     * @memberof Logo
     * @static
     * @param {Logo.$Properties} message Logo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Logo.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.image != null && $Object.hasOwnProperty.call(message, "image") && message.image !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.image);
        if (message.link != null && $Object.hasOwnProperty.call(message, "link") && message.link !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.link);
        if (message.iconImage != null && $Object.hasOwnProperty.call(message, "iconImage") && message.iconImage !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.iconImage);
        if (message.size != null && $Object.hasOwnProperty.call(message, "size") && message.size !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.size);
        if (message.imageType != null && $Object.hasOwnProperty.call(message, "imageType") && message.imageType !== 0)
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.imageType);
        if (message.iconImageType != null && $Object.hasOwnProperty.call(message, "iconImageType") && message.iconImageType !== 0)
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.iconImageType);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Logo message from the specified reader or buffer.
     * @function decode
     * @memberof Logo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Logo & Logo.$Shape} Logo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Logo.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Logo();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.image = value;
                    else
                        delete message.image;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.link = value;
                    else
                        delete message.link;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.iconImage = value;
                    else
                        delete message.iconImage;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.size = value;
                    else
                        delete message.size;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.imageType = value;
                    else
                        delete message.imageType;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.iconImageType = value;
                    else
                        delete message.iconImageType;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Logo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Logo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Logo} Logo
     */
    Logo.fromObject = function (object, _depth) {
        if (object instanceof $root.Logo)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Logo: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Logo();
        if (object.image != null)
            if (typeof object.image !== "string" || object.image.length)
                message.image = $String(object.image);
        if (object.link != null)
            if (typeof object.link !== "string" || object.link.length)
                message.link = $String(object.link);
        if (object.iconImage != null)
            if (typeof object.iconImage !== "string" || object.iconImage.length)
                message.iconImage = $String(object.iconImage);
        if (object.size != null)
            if (typeof object.size !== "string" || object.size.length)
                message.size = $String(object.size);
        if (object.imageType !== 0 && (typeof object.imageType !== "string" || $root.Logo.ImageType[object.imageType] !== 0))
            switch (object.imageType) {
            case "IMAGE":
            case 0:
                message.imageType = 0;
                break;
            case "EMOJI":
            case 1:
                message.imageType = 1;
                break;
            case "ICON":
            case 2:
                message.imageType = 2;
                break;
            default:
                if (typeof object.imageType === "number" && (object.imageType | 0) === object.imageType)
                    message.imageType = object.imageType;
            }
        if (object.iconImageType !== 0 && (typeof object.iconImageType !== "string" || $root.Logo.ImageType[object.iconImageType] !== 0))
            switch (object.iconImageType) {
            case "IMAGE":
            case 0:
                message.iconImageType = 0;
                break;
            case "EMOJI":
            case 1:
                message.iconImageType = 1;
                break;
            case "ICON":
            case 2:
                message.iconImageType = 2;
                break;
            default:
                if (typeof object.iconImageType === "number" && (object.iconImageType | 0) === object.iconImageType)
                    message.iconImageType = object.iconImageType;
            }
        return message;
    };

    /**
     * Creates a plain object from a Logo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Logo
     * @static
     * @param {Logo} message Logo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Logo.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.image = "";
            object.link = "";
            object.iconImage = "";
            object.size = "";
            object.imageType = options.enums === $String ? "IMAGE" : 0;
            object.iconImageType = options.enums === $String ? "IMAGE" : 0;
        }
        if (message.image != null && $Object.hasOwnProperty.call(message, "image"))
            object.image = message.image;
        if (message.link != null && $Object.hasOwnProperty.call(message, "link"))
            object.link = message.link;
        if (message.iconImage != null && $Object.hasOwnProperty.call(message, "iconImage"))
            object.iconImage = message.iconImage;
        if (message.size != null && $Object.hasOwnProperty.call(message, "size"))
            object.size = message.size;
        if (message.imageType != null && $Object.hasOwnProperty.call(message, "imageType"))
            object.imageType = options.enums === $String ? $root.Logo.ImageType[message.imageType] === $undefined ? message.imageType : $root.Logo.ImageType[message.imageType] : message.imageType;
        if (message.iconImageType != null && $Object.hasOwnProperty.call(message, "iconImageType"))
            object.iconImageType = options.enums === $String ? $root.Logo.ImageType[message.iconImageType] === $undefined ? message.iconImageType : $root.Logo.ImageType[message.iconImageType] : message.iconImageType;
        return object;
    };

    /**
     * Converts this Logo to JSON.
     * @function toJSON
     * @memberof Logo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Logo.prototype.toJSON = function() {
        return Logo.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Logo
     * @function getTypeUrl
     * @memberof Logo
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Logo.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Logo";
    };

    /**
     * ImageType enum.
     * @name Logo.ImageType
     * @enum {number}
     * @property {number} IMAGE=0 IMAGE value
     * @property {number} EMOJI=1 EMOJI value
     * @property {number} ICON=2 ICON value
     */
    Logo.ImageType = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "IMAGE"] = 0;
        values[valuesById[1] = "EMOJI"] = 1;
        values[valuesById[2] = "ICON"] = 2;
        return values;
    })();

    return Logo;
})();

export const Navigation = $root.Navigation = (() => {

    /**
     * Properties of a Navigation.
     * @typedef {Object} Navigation.$Properties
     * @property {Array.<string>|null} [sections] Navigation sections
     * @property {Array.<AppPage.$Properties>|null} [appPages] Navigation appPages
     * @property {Navigation.Position|null} [position] Navigation position
     * @property {string|null} [pageScriptHash] Navigation pageScriptHash
     * @property {boolean|null} [expanded] Navigation expanded
     * @property {number|null} [visibleItems] Navigation visibleItems
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Navigation.
     * @exports INavigation
     * @interface INavigation
     * @augments Navigation.$Properties
     * @deprecated Use Navigation.$Properties instead.
     */

    /**
     * Shape of a Navigation.
     * @typedef {Navigation.$Properties} Navigation.$Shape
     */

    /**
     * Constructs a new Navigation.
     * @exports Navigation
     * @classdesc Represents a Navigation.
     * @constructor
     * @param {Navigation.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Navigation = function (properties) {
        this.sections = [];
        this.appPages = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Navigation sections.
     * @member {Array.<string>} sections
     * @memberof Navigation
     * @instance
     */
    Navigation.prototype.sections = $util.emptyArray;

    /**
     * Navigation appPages.
     * @member {Array.<AppPage.$Properties>} appPages
     * @memberof Navigation
     * @instance
     */
    Navigation.prototype.appPages = $util.emptyArray;

    /**
     * Navigation position.
     * @member {Navigation.Position} position
     * @memberof Navigation
     * @instance
     */
    Navigation.prototype.position = 0;

    /**
     * Navigation pageScriptHash.
     * @member {string} pageScriptHash
     * @memberof Navigation
     * @instance
     */
    Navigation.prototype.pageScriptHash = "";

    /**
     * Navigation expanded.
     * @member {boolean} expanded
     * @memberof Navigation
     * @instance
     */
    Navigation.prototype.expanded = false;

    /**
     * Navigation visibleItems.
     * @member {number|null|undefined} visibleItems
     * @memberof Navigation
     * @instance
     */
    Navigation.prototype.visibleItems = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(Navigation.prototype, "_visibleItems", {
        get: $util.oneOfGetter($oneOfFields = ["visibleItems"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Navigation instance using the specified properties.
     * @function create
     * @memberof Navigation
     * @static
     * @param {Navigation.$Properties=} [properties] Properties to set
     * @returns {Navigation} Navigation instance
     * @type {{
     *   (properties: Navigation.$Shape): Navigation & Navigation.$Shape;
     *   (properties?: Navigation.$Properties): Navigation;
     * }}
     */
    Navigation.create = function(properties) {
        return new Navigation(properties);
    };

    /**
     * Encodes the specified Navigation message. Does not implicitly {@link Navigation.verify|verify} messages.
     * @function encode
     * @memberof Navigation
     * @static
     * @param {Navigation.$Properties} message Navigation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Navigation.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.sections != null && message.sections.length)
            for (let i = 0; i < message.sections.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.sections[i]);
        if (message.appPages != null && message.appPages.length)
            for (let i = 0; i < message.appPages.length; ++i)
                $root.AppPage.encode(message.appPages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.position != null && $Object.hasOwnProperty.call(message, "position") && message.position !== 0)
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.position);
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash") && message.pageScriptHash !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageScriptHash);
        if (message.expanded != null && $Object.hasOwnProperty.call(message, "expanded") && message.expanded !== false)
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.expanded);
        if (message.visibleItems != null && $Object.hasOwnProperty.call(message, "visibleItems"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.visibleItems);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Navigation message from the specified reader or buffer.
     * @function decode
     * @memberof Navigation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Navigation & Navigation.$Shape} Navigation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Navigation.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Navigation();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if (!(message.sections && message.sections.length))
                        message.sections = [];
                    message.sections.push(reader.stringVerify());
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if (!(message.appPages && message.appPages.length))
                        message.appPages = [];
                    message.appPages.push($root.AppPage.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.position = value;
                    else
                        delete message.position;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pageScriptHash = value;
                    else
                        delete message.pageScriptHash;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.expanded = value;
                    else
                        delete message.expanded;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    message.visibleItems = reader.uint32();
                    message._visibleItems = "visibleItems";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Navigation message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Navigation
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Navigation} Navigation
     */
    Navigation.fromObject = function (object, _depth) {
        if (object instanceof $root.Navigation)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Navigation: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Navigation();
        if (object.sections) {
            if (!$Array.isArray(object.sections))
                throw $TypeError(".Navigation.sections: array expected");
            message.sections = $Array(object.sections.length);
            for (let i = 0; i < object.sections.length; ++i)
                message.sections[i] = $String(object.sections[i]);
        }
        if (object.appPages) {
            if (!$Array.isArray(object.appPages))
                throw $TypeError(".Navigation.appPages: array expected");
            message.appPages = $Array(object.appPages.length);
            for (let i = 0; i < object.appPages.length; ++i) {
                if (!$util.isObject(object.appPages[i]))
                    throw $TypeError(".Navigation.appPages: object expected");
                message.appPages[i] = $root.AppPage.fromObject(object.appPages[i], _depth + 1);
            }
        }
        if (object.position !== 0 && (typeof object.position !== "string" || $root.Navigation.Position[object.position] !== 0))
            switch (object.position) {
            case "HIDDEN":
            case 0:
                message.position = 0;
                break;
            case "SIDEBAR":
            case 1:
                message.position = 1;
                break;
            case "TOP":
            case 2:
                message.position = 2;
                break;
            default:
                if (typeof object.position === "number" && (object.position | 0) === object.position)
                    message.position = object.position;
            }
        if (object.pageScriptHash != null)
            if (typeof object.pageScriptHash !== "string" || object.pageScriptHash.length)
                message.pageScriptHash = $String(object.pageScriptHash);
        if (object.expanded != null)
            if (object.expanded)
                message.expanded = $Boolean(object.expanded);
        if (object.visibleItems != null)
            message.visibleItems = object.visibleItems >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Navigation message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Navigation
     * @static
     * @param {Navigation} message Navigation
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Navigation.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object.sections = [];
            object.appPages = [];
        }
        if (options.defaults) {
            object.position = options.enums === $String ? "HIDDEN" : 0;
            object.pageScriptHash = "";
            object.expanded = false;
        }
        if (message.sections && message.sections.length) {
            object.sections = $Array(message.sections.length);
            for (let j = 0; j < message.sections.length; ++j)
                object.sections[j] = message.sections[j];
        }
        if (message.appPages && message.appPages.length) {
            object.appPages = $Array(message.appPages.length);
            for (let j = 0; j < message.appPages.length; ++j)
                object.appPages[j] = $root.AppPage.toObject(message.appPages[j], options, _depth + 1);
        }
        if (message.position != null && $Object.hasOwnProperty.call(message, "position"))
            object.position = options.enums === $String ? $root.Navigation.Position[message.position] === $undefined ? message.position : $root.Navigation.Position[message.position] : message.position;
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash"))
            object.pageScriptHash = message.pageScriptHash;
        if (message.expanded != null && $Object.hasOwnProperty.call(message, "expanded"))
            object.expanded = message.expanded;
        if (message.visibleItems != null && $Object.hasOwnProperty.call(message, "visibleItems"))
            object.visibleItems = message.visibleItems;
        return object;
    };

    /**
     * Converts this Navigation to JSON.
     * @function toJSON
     * @memberof Navigation
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Navigation.prototype.toJSON = function() {
        return Navigation.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Navigation
     * @function getTypeUrl
     * @memberof Navigation
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Navigation.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Navigation";
    };

    /**
     * Position enum.
     * @name Navigation.Position
     * @enum {number}
     * @property {number} HIDDEN=0 HIDDEN value
     * @property {number} SIDEBAR=1 SIDEBAR value
     * @property {number} TOP=2 TOP value
     */
    Navigation.Position = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "HIDDEN"] = 0;
        values[valuesById[1] = "SIDEBAR"] = 1;
        values[valuesById[2] = "TOP"] = 2;
        return values;
    })();

    return Navigation;
})();

export const NewSession = $root.NewSession = (() => {

    /**
     * Properties of a NewSession.
     * @typedef {Object} NewSession.$Properties
     * @property {Initialize.$Properties|null} [initialize] NewSession initialize
     * @property {string|null} [scriptRunId] NewSession scriptRunId
     * @property {string|null} [name] NewSession name
     * @property {string|null} [mainScriptPath] NewSession mainScriptPath
     * @property {Config.$Properties|null} [config] NewSession config
     * @property {CustomThemeConfig.$Properties|null} [customTheme] NewSession customTheme
     * @property {Array.<AppPage.$Properties>|null} [appPages] NewSession appPages
     * @property {string|null} [pageScriptHash] NewSession pageScriptHash
     * @property {Array.<string>|null} [fragmentIdsThisRun] NewSession fragmentIdsThisRun
     * @property {string|null} [mainScriptHash] NewSession mainScriptHash
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a NewSession.
     * @exports INewSession
     * @interface INewSession
     * @augments NewSession.$Properties
     * @deprecated Use NewSession.$Properties instead.
     */

    /**
     * Shape of a NewSession.
     * @typedef {NewSession.$Properties} NewSession.$Shape
     */

    /**
     * Constructs a new NewSession.
     * @exports NewSession
     * @classdesc Represents a NewSession.
     * @constructor
     * @param {NewSession.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const NewSession = function (properties) {
        this.appPages = [];
        this.fragmentIdsThisRun = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * NewSession initialize.
     * @member {Initialize.$Properties|null|undefined} initialize
     * @memberof NewSession
     * @instance
     */
    NewSession.prototype.initialize = null;

    /**
     * NewSession scriptRunId.
     * @member {string} scriptRunId
     * @memberof NewSession
     * @instance
     */
    NewSession.prototype.scriptRunId = "";

    /**
     * NewSession name.
     * @member {string} name
     * @memberof NewSession
     * @instance
     */
    NewSession.prototype.name = "";

    /**
     * NewSession mainScriptPath.
     * @member {string} mainScriptPath
     * @memberof NewSession
     * @instance
     */
    NewSession.prototype.mainScriptPath = "";

    /**
     * NewSession config.
     * @member {Config.$Properties|null|undefined} config
     * @memberof NewSession
     * @instance
     */
    NewSession.prototype.config = null;

    /**
     * NewSession customTheme.
     * @member {CustomThemeConfig.$Properties|null|undefined} customTheme
     * @memberof NewSession
     * @instance
     */
    NewSession.prototype.customTheme = null;

    /**
     * NewSession appPages.
     * @member {Array.<AppPage.$Properties>} appPages
     * @memberof NewSession
     * @instance
     */
    NewSession.prototype.appPages = $util.emptyArray;

    /**
     * NewSession pageScriptHash.
     * @member {string} pageScriptHash
     * @memberof NewSession
     * @instance
     */
    NewSession.prototype.pageScriptHash = "";

    /**
     * NewSession fragmentIdsThisRun.
     * @member {Array.<string>} fragmentIdsThisRun
     * @memberof NewSession
     * @instance
     */
    NewSession.prototype.fragmentIdsThisRun = $util.emptyArray;

    /**
     * NewSession mainScriptHash.
     * @member {string} mainScriptHash
     * @memberof NewSession
     * @instance
     */
    NewSession.prototype.mainScriptHash = "";

    /**
     * Creates a new NewSession instance using the specified properties.
     * @function create
     * @memberof NewSession
     * @static
     * @param {NewSession.$Properties=} [properties] Properties to set
     * @returns {NewSession} NewSession instance
     * @type {{
     *   (properties: NewSession.$Shape): NewSession & NewSession.$Shape;
     *   (properties?: NewSession.$Properties): NewSession;
     * }}
     */
    NewSession.create = function(properties) {
        return new NewSession(properties);
    };

    /**
     * Encodes the specified NewSession message. Does not implicitly {@link NewSession.verify|verify} messages.
     * @function encode
     * @memberof NewSession
     * @static
     * @param {NewSession.$Properties} message NewSession message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewSession.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.initialize != null && $Object.hasOwnProperty.call(message, "initialize"))
            $root.Initialize.encode(message.initialize, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.scriptRunId != null && $Object.hasOwnProperty.call(message, "scriptRunId") && message.scriptRunId !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.scriptRunId);
        if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
        if (message.mainScriptPath != null && $Object.hasOwnProperty.call(message, "mainScriptPath") && message.mainScriptPath !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.mainScriptPath);
        if (message.config != null && $Object.hasOwnProperty.call(message, "config"))
            $root.Config.encode(message.config, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
        if (message.customTheme != null && $Object.hasOwnProperty.call(message, "customTheme"))
            $root.CustomThemeConfig.encode(message.customTheme, writer.uint32(/* id 7, wireType 2 =*/58).fork(), _depth + 1).ldelim();
        if (message.appPages != null && message.appPages.length)
            for (let i = 0; i < message.appPages.length; ++i)
                $root.AppPage.encode(message.appPages[i], writer.uint32(/* id 8, wireType 2 =*/66).fork(), _depth + 1).ldelim();
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash") && message.pageScriptHash !== "")
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.pageScriptHash);
        if (message.fragmentIdsThisRun != null && message.fragmentIdsThisRun.length)
            for (let i = 0; i < message.fragmentIdsThisRun.length; ++i)
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.fragmentIdsThisRun[i]);
        if (message.mainScriptHash != null && $Object.hasOwnProperty.call(message, "mainScriptHash") && message.mainScriptHash !== "")
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.mainScriptHash);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a NewSession message from the specified reader or buffer.
     * @function decode
     * @memberof NewSession
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NewSession & NewSession.$Shape} NewSession
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewSession.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.NewSession();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.initialize = $root.Initialize.decode(reader, reader.uint32(), $undefined, _depth + 1, message.initialize);
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.scriptRunId = value;
                    else
                        delete message.scriptRunId;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.name = value;
                    else
                        delete message.name;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.mainScriptPath = value;
                    else
                        delete message.mainScriptPath;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.config = $root.Config.decode(reader, reader.uint32(), $undefined, _depth + 1, message.config);
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    message.customTheme = $root.CustomThemeConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.customTheme);
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    if (!(message.appPages && message.appPages.length))
                        message.appPages = [];
                    message.appPages.push($root.AppPage.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pageScriptHash = value;
                    else
                        delete message.pageScriptHash;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if (!(message.fragmentIdsThisRun && message.fragmentIdsThisRun.length))
                        message.fragmentIdsThisRun = [];
                    message.fragmentIdsThisRun.push(reader.stringVerify());
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.mainScriptHash = value;
                    else
                        delete message.mainScriptHash;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a NewSession message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NewSession
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NewSession} NewSession
     */
    NewSession.fromObject = function (object, _depth) {
        if (object instanceof $root.NewSession)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".NewSession: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.NewSession();
        if (object.initialize != null) {
            if (!$util.isObject(object.initialize))
                throw $TypeError(".NewSession.initialize: object expected");
            message.initialize = $root.Initialize.fromObject(object.initialize, _depth + 1);
        }
        if (object.scriptRunId != null)
            if (typeof object.scriptRunId !== "string" || object.scriptRunId.length)
                message.scriptRunId = $String(object.scriptRunId);
        if (object.name != null)
            if (typeof object.name !== "string" || object.name.length)
                message.name = $String(object.name);
        if (object.mainScriptPath != null)
            if (typeof object.mainScriptPath !== "string" || object.mainScriptPath.length)
                message.mainScriptPath = $String(object.mainScriptPath);
        if (object.config != null) {
            if (!$util.isObject(object.config))
                throw $TypeError(".NewSession.config: object expected");
            message.config = $root.Config.fromObject(object.config, _depth + 1);
        }
        if (object.customTheme != null) {
            if (!$util.isObject(object.customTheme))
                throw $TypeError(".NewSession.customTheme: object expected");
            message.customTheme = $root.CustomThemeConfig.fromObject(object.customTheme, _depth + 1);
        }
        if (object.appPages) {
            if (!$Array.isArray(object.appPages))
                throw $TypeError(".NewSession.appPages: array expected");
            message.appPages = $Array(object.appPages.length);
            for (let i = 0; i < object.appPages.length; ++i) {
                if (!$util.isObject(object.appPages[i]))
                    throw $TypeError(".NewSession.appPages: object expected");
                message.appPages[i] = $root.AppPage.fromObject(object.appPages[i], _depth + 1);
            }
        }
        if (object.pageScriptHash != null)
            if (typeof object.pageScriptHash !== "string" || object.pageScriptHash.length)
                message.pageScriptHash = $String(object.pageScriptHash);
        if (object.fragmentIdsThisRun) {
            if (!$Array.isArray(object.fragmentIdsThisRun))
                throw $TypeError(".NewSession.fragmentIdsThisRun: array expected");
            message.fragmentIdsThisRun = $Array(object.fragmentIdsThisRun.length);
            for (let i = 0; i < object.fragmentIdsThisRun.length; ++i)
                message.fragmentIdsThisRun[i] = $String(object.fragmentIdsThisRun[i]);
        }
        if (object.mainScriptHash != null)
            if (typeof object.mainScriptHash !== "string" || object.mainScriptHash.length)
                message.mainScriptHash = $String(object.mainScriptHash);
        return message;
    };

    /**
     * Creates a plain object from a NewSession message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NewSession
     * @static
     * @param {NewSession} message NewSession
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NewSession.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object.appPages = [];
            object.fragmentIdsThisRun = [];
        }
        if (options.defaults) {
            object.initialize = null;
            object.scriptRunId = "";
            object.name = "";
            object.mainScriptPath = "";
            object.config = null;
            object.customTheme = null;
            object.pageScriptHash = "";
            object.mainScriptHash = "";
        }
        if (message.initialize != null && $Object.hasOwnProperty.call(message, "initialize"))
            object.initialize = $root.Initialize.toObject(message.initialize, options, _depth + 1);
        if (message.scriptRunId != null && $Object.hasOwnProperty.call(message, "scriptRunId"))
            object.scriptRunId = message.scriptRunId;
        if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
            object.name = message.name;
        if (message.mainScriptPath != null && $Object.hasOwnProperty.call(message, "mainScriptPath"))
            object.mainScriptPath = message.mainScriptPath;
        if (message.config != null && $Object.hasOwnProperty.call(message, "config"))
            object.config = $root.Config.toObject(message.config, options, _depth + 1);
        if (message.customTheme != null && $Object.hasOwnProperty.call(message, "customTheme"))
            object.customTheme = $root.CustomThemeConfig.toObject(message.customTheme, options, _depth + 1);
        if (message.appPages && message.appPages.length) {
            object.appPages = $Array(message.appPages.length);
            for (let j = 0; j < message.appPages.length; ++j)
                object.appPages[j] = $root.AppPage.toObject(message.appPages[j], options, _depth + 1);
        }
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash"))
            object.pageScriptHash = message.pageScriptHash;
        if (message.fragmentIdsThisRun && message.fragmentIdsThisRun.length) {
            object.fragmentIdsThisRun = $Array(message.fragmentIdsThisRun.length);
            for (let j = 0; j < message.fragmentIdsThisRun.length; ++j)
                object.fragmentIdsThisRun[j] = message.fragmentIdsThisRun[j];
        }
        if (message.mainScriptHash != null && $Object.hasOwnProperty.call(message, "mainScriptHash"))
            object.mainScriptHash = message.mainScriptHash;
        return object;
    };

    /**
     * Converts this NewSession to JSON.
     * @function toJSON
     * @memberof NewSession
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NewSession.prototype.toJSON = function() {
        return NewSession.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for NewSession
     * @function getTypeUrl
     * @memberof NewSession
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    NewSession.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/NewSession";
    };

    return NewSession;
})();

export const Initialize = $root.Initialize = (() => {

    /**
     * Properties of an Initialize.
     * @typedef {Object} Initialize.$Properties
     * @property {UserInfo.$Properties|null} [userInfo] Initialize userInfo
     * @property {EnvironmentInfo.$Properties|null} [environmentInfo] Initialize environmentInfo
     * @property {SessionStatus.$Properties|null} [sessionStatus] Initialize sessionStatus
     * @property {string|null} [sessionId] Initialize sessionId
     * @property {boolean|null} [isHello] Initialize isHello
     * @property {boolean|null} [recommendSkillsInstall] Initialize recommendSkillsInstall
     * @property {string|null} [skillsNudgeSuppressedReason] Initialize skillsNudgeSuppressedReason
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an Initialize.
     * @exports IInitialize
     * @interface IInitialize
     * @augments Initialize.$Properties
     * @deprecated Use Initialize.$Properties instead.
     */

    /**
     * Shape of an Initialize.
     * @typedef {Initialize.$Properties} Initialize.$Shape
     */

    /**
     * Constructs a new Initialize.
     * @exports Initialize
     * @classdesc Represents an Initialize.
     * @constructor
     * @param {Initialize.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Initialize = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Initialize userInfo.
     * @member {UserInfo.$Properties|null|undefined} userInfo
     * @memberof Initialize
     * @instance
     */
    Initialize.prototype.userInfo = null;

    /**
     * Initialize environmentInfo.
     * @member {EnvironmentInfo.$Properties|null|undefined} environmentInfo
     * @memberof Initialize
     * @instance
     */
    Initialize.prototype.environmentInfo = null;

    /**
     * Initialize sessionStatus.
     * @member {SessionStatus.$Properties|null|undefined} sessionStatus
     * @memberof Initialize
     * @instance
     */
    Initialize.prototype.sessionStatus = null;

    /**
     * Initialize sessionId.
     * @member {string} sessionId
     * @memberof Initialize
     * @instance
     */
    Initialize.prototype.sessionId = "";

    /**
     * Initialize isHello.
     * @member {boolean} isHello
     * @memberof Initialize
     * @instance
     */
    Initialize.prototype.isHello = false;

    /**
     * Initialize recommendSkillsInstall.
     * @member {boolean} recommendSkillsInstall
     * @memberof Initialize
     * @instance
     */
    Initialize.prototype.recommendSkillsInstall = false;

    /**
     * Initialize skillsNudgeSuppressedReason.
     * @member {string} skillsNudgeSuppressedReason
     * @memberof Initialize
     * @instance
     */
    Initialize.prototype.skillsNudgeSuppressedReason = "";

    /**
     * Creates a new Initialize instance using the specified properties.
     * @function create
     * @memberof Initialize
     * @static
     * @param {Initialize.$Properties=} [properties] Properties to set
     * @returns {Initialize} Initialize instance
     * @type {{
     *   (properties: Initialize.$Shape): Initialize & Initialize.$Shape;
     *   (properties?: Initialize.$Properties): Initialize;
     * }}
     */
    Initialize.create = function(properties) {
        return new Initialize(properties);
    };

    /**
     * Encodes the specified Initialize message. Does not implicitly {@link Initialize.verify|verify} messages.
     * @function encode
     * @memberof Initialize
     * @static
     * @param {Initialize.$Properties} message Initialize message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Initialize.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.userInfo != null && $Object.hasOwnProperty.call(message, "userInfo"))
            $root.UserInfo.encode(message.userInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.environmentInfo != null && $Object.hasOwnProperty.call(message, "environmentInfo"))
            $root.EnvironmentInfo.encode(message.environmentInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
        if (message.sessionStatus != null && $Object.hasOwnProperty.call(message, "sessionStatus"))
            $root.SessionStatus.encode(message.sessionStatus, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
        if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId") && message.sessionId !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.sessionId);
        if (message.isHello != null && $Object.hasOwnProperty.call(message, "isHello") && message.isHello !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isHello);
        if (message.recommendSkillsInstall != null && $Object.hasOwnProperty.call(message, "recommendSkillsInstall") && message.recommendSkillsInstall !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.recommendSkillsInstall);
        if (message.skillsNudgeSuppressedReason != null && $Object.hasOwnProperty.call(message, "skillsNudgeSuppressedReason") && message.skillsNudgeSuppressedReason !== "")
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.skillsNudgeSuppressedReason);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an Initialize message from the specified reader or buffer.
     * @function decode
     * @memberof Initialize
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Initialize & Initialize.$Shape} Initialize
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Initialize.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Initialize();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    message.userInfo = $root.UserInfo.decode(reader, reader.uint32(), $undefined, _depth + 1, message.userInfo);
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.environmentInfo = $root.EnvironmentInfo.decode(reader, reader.uint32(), $undefined, _depth + 1, message.environmentInfo);
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    message.sessionStatus = $root.SessionStatus.decode(reader, reader.uint32(), $undefined, _depth + 1, message.sessionStatus);
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.sessionId = value;
                    else
                        delete message.sessionId;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isHello = value;
                    else
                        delete message.isHello;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.recommendSkillsInstall = value;
                    else
                        delete message.recommendSkillsInstall;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.skillsNudgeSuppressedReason = value;
                    else
                        delete message.skillsNudgeSuppressedReason;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an Initialize message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Initialize
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Initialize} Initialize
     */
    Initialize.fromObject = function (object, _depth) {
        if (object instanceof $root.Initialize)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Initialize: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Initialize();
        if (object.userInfo != null) {
            if (!$util.isObject(object.userInfo))
                throw $TypeError(".Initialize.userInfo: object expected");
            message.userInfo = $root.UserInfo.fromObject(object.userInfo, _depth + 1);
        }
        if (object.environmentInfo != null) {
            if (!$util.isObject(object.environmentInfo))
                throw $TypeError(".Initialize.environmentInfo: object expected");
            message.environmentInfo = $root.EnvironmentInfo.fromObject(object.environmentInfo, _depth + 1);
        }
        if (object.sessionStatus != null) {
            if (!$util.isObject(object.sessionStatus))
                throw $TypeError(".Initialize.sessionStatus: object expected");
            message.sessionStatus = $root.SessionStatus.fromObject(object.sessionStatus, _depth + 1);
        }
        if (object.sessionId != null)
            if (typeof object.sessionId !== "string" || object.sessionId.length)
                message.sessionId = $String(object.sessionId);
        if (object.isHello != null)
            if (object.isHello)
                message.isHello = $Boolean(object.isHello);
        if (object.recommendSkillsInstall != null)
            if (object.recommendSkillsInstall)
                message.recommendSkillsInstall = $Boolean(object.recommendSkillsInstall);
        if (object.skillsNudgeSuppressedReason != null)
            if (typeof object.skillsNudgeSuppressedReason !== "string" || object.skillsNudgeSuppressedReason.length)
                message.skillsNudgeSuppressedReason = $String(object.skillsNudgeSuppressedReason);
        return message;
    };

    /**
     * Creates a plain object from an Initialize message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Initialize
     * @static
     * @param {Initialize} message Initialize
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Initialize.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.userInfo = null;
            object.environmentInfo = null;
            object.sessionStatus = null;
            object.sessionId = "";
            object.isHello = false;
            object.recommendSkillsInstall = false;
            object.skillsNudgeSuppressedReason = "";
        }
        if (message.userInfo != null && $Object.hasOwnProperty.call(message, "userInfo"))
            object.userInfo = $root.UserInfo.toObject(message.userInfo, options, _depth + 1);
        if (message.environmentInfo != null && $Object.hasOwnProperty.call(message, "environmentInfo"))
            object.environmentInfo = $root.EnvironmentInfo.toObject(message.environmentInfo, options, _depth + 1);
        if (message.sessionStatus != null && $Object.hasOwnProperty.call(message, "sessionStatus"))
            object.sessionStatus = $root.SessionStatus.toObject(message.sessionStatus, options, _depth + 1);
        if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId"))
            object.sessionId = message.sessionId;
        if (message.isHello != null && $Object.hasOwnProperty.call(message, "isHello"))
            object.isHello = message.isHello;
        if (message.recommendSkillsInstall != null && $Object.hasOwnProperty.call(message, "recommendSkillsInstall"))
            object.recommendSkillsInstall = message.recommendSkillsInstall;
        if (message.skillsNudgeSuppressedReason != null && $Object.hasOwnProperty.call(message, "skillsNudgeSuppressedReason"))
            object.skillsNudgeSuppressedReason = message.skillsNudgeSuppressedReason;
        return object;
    };

    /**
     * Converts this Initialize to JSON.
     * @function toJSON
     * @memberof Initialize
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Initialize.prototype.toJSON = function() {
        return Initialize.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Initialize
     * @function getTypeUrl
     * @memberof Initialize
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Initialize.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Initialize";
    };

    return Initialize;
})();

export const Config = $root.Config = (() => {

    /**
     * Properties of a Config.
     * @typedef {Object} Config.$Properties
     * @property {boolean|null} [gatherUsageStats] Config gatherUsageStats
     * @property {number|null} [maxCachedMessageAge] Config maxCachedMessageAge
     * @property {boolean|null} [allowRunOnSave] Config allowRunOnSave
     * @property {boolean|null} [hideTopBar] Config hideTopBar
     * @property {boolean|null} [hideSidebarNav] Config hideSidebarNav
     * @property {Config.ToolbarMode|null} [toolbarMode] Config toolbarMode
     * @property {Config.ShowErrorLinks|null} [showErrorLinks] Config showErrorLinks
     * @property {boolean|null} [disableDataExport] Config disableDataExport
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Config.
     * @exports IConfig
     * @interface IConfig
     * @augments Config.$Properties
     * @deprecated Use Config.$Properties instead.
     */

    /**
     * Shape of a Config.
     * @typedef {Config.$Properties} Config.$Shape
     */

    /**
     * Constructs a new Config.
     * @exports Config
     * @classdesc Represents a Config.
     * @constructor
     * @param {Config.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Config = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Config gatherUsageStats.
     * @member {boolean} gatherUsageStats
     * @memberof Config
     * @instance
     */
    Config.prototype.gatherUsageStats = false;

    /**
     * Config maxCachedMessageAge.
     * @member {number} maxCachedMessageAge
     * @memberof Config
     * @instance
     */
    Config.prototype.maxCachedMessageAge = 0;

    /**
     * Config allowRunOnSave.
     * @member {boolean} allowRunOnSave
     * @memberof Config
     * @instance
     */
    Config.prototype.allowRunOnSave = false;

    /**
     * Config hideTopBar.
     * @member {boolean} hideTopBar
     * @memberof Config
     * @instance
     */
    Config.prototype.hideTopBar = false;

    /**
     * Config hideSidebarNav.
     * @member {boolean} hideSidebarNav
     * @memberof Config
     * @instance
     */
    Config.prototype.hideSidebarNav = false;

    /**
     * Config toolbarMode.
     * @member {Config.ToolbarMode} toolbarMode
     * @memberof Config
     * @instance
     */
    Config.prototype.toolbarMode = 0;

    /**
     * Config showErrorLinks.
     * @member {Config.ShowErrorLinks} showErrorLinks
     * @memberof Config
     * @instance
     */
    Config.prototype.showErrorLinks = 0;

    /**
     * Config disableDataExport.
     * @member {boolean} disableDataExport
     * @memberof Config
     * @instance
     */
    Config.prototype.disableDataExport = false;

    /**
     * Creates a new Config instance using the specified properties.
     * @function create
     * @memberof Config
     * @static
     * @param {Config.$Properties=} [properties] Properties to set
     * @returns {Config} Config instance
     * @type {{
     *   (properties: Config.$Shape): Config & Config.$Shape;
     *   (properties?: Config.$Properties): Config;
     * }}
     */
    Config.create = function(properties) {
        return new Config(properties);
    };

    /**
     * Encodes the specified Config message. Does not implicitly {@link Config.verify|verify} messages.
     * @function encode
     * @memberof Config
     * @static
     * @param {Config.$Properties} message Config message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Config.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.gatherUsageStats != null && $Object.hasOwnProperty.call(message, "gatherUsageStats") && message.gatherUsageStats !== false)
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.gatherUsageStats);
        if (message.maxCachedMessageAge != null && $Object.hasOwnProperty.call(message, "maxCachedMessageAge") && message.maxCachedMessageAge !== 0)
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxCachedMessageAge);
        if (message.allowRunOnSave != null && $Object.hasOwnProperty.call(message, "allowRunOnSave") && message.allowRunOnSave !== false)
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.allowRunOnSave);
        if (message.hideTopBar != null && $Object.hasOwnProperty.call(message, "hideTopBar") && message.hideTopBar !== false)
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.hideTopBar);
        if (message.hideSidebarNav != null && $Object.hasOwnProperty.call(message, "hideSidebarNav") && message.hideSidebarNav !== false)
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.hideSidebarNav);
        if (message.toolbarMode != null && $Object.hasOwnProperty.call(message, "toolbarMode") && message.toolbarMode !== 0)
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.toolbarMode);
        if (message.showErrorLinks != null && $Object.hasOwnProperty.call(message, "showErrorLinks") && message.showErrorLinks !== 0)
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.showErrorLinks);
        if (message.disableDataExport != null && $Object.hasOwnProperty.call(message, "disableDataExport") && message.disableDataExport !== false)
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.disableDataExport);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Config message from the specified reader or buffer.
     * @function decode
     * @memberof Config
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Config & Config.$Shape} Config
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Config.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Config();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.gatherUsageStats = value;
                    else
                        delete message.gatherUsageStats;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.maxCachedMessageAge = value;
                    else
                        delete message.maxCachedMessageAge;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.allowRunOnSave = value;
                    else
                        delete message.allowRunOnSave;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hideTopBar = value;
                    else
                        delete message.hideTopBar;
                    continue;
                }
            case 7: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hideSidebarNav = value;
                    else
                        delete message.hideSidebarNav;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.toolbarMode = value;
                    else
                        delete message.toolbarMode;
                    continue;
                }
            case 9: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.showErrorLinks = value;
                    else
                        delete message.showErrorLinks;
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.disableDataExport = value;
                    else
                        delete message.disableDataExport;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Config message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Config
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Config} Config
     */
    Config.fromObject = function (object, _depth) {
        if (object instanceof $root.Config)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Config: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Config();
        if (object.gatherUsageStats != null)
            if (object.gatherUsageStats)
                message.gatherUsageStats = $Boolean(object.gatherUsageStats);
        if (object.maxCachedMessageAge != null)
            if ($Number(object.maxCachedMessageAge) !== 0)
                message.maxCachedMessageAge = object.maxCachedMessageAge | 0;
        if (object.allowRunOnSave != null)
            if (object.allowRunOnSave)
                message.allowRunOnSave = $Boolean(object.allowRunOnSave);
        if (object.hideTopBar != null)
            if (object.hideTopBar)
                message.hideTopBar = $Boolean(object.hideTopBar);
        if (object.hideSidebarNav != null)
            if (object.hideSidebarNav)
                message.hideSidebarNav = $Boolean(object.hideSidebarNav);
        if (object.toolbarMode !== 0 && (typeof object.toolbarMode !== "string" || $root.Config.ToolbarMode[object.toolbarMode] !== 0))
            switch (object.toolbarMode) {
            case "AUTO":
            case 0:
                message.toolbarMode = 0;
                break;
            case "DEVELOPER":
            case 1:
                message.toolbarMode = 1;
                break;
            case "VIEWER":
            case 2:
                message.toolbarMode = 2;
                break;
            case "MINIMAL":
            case 3:
                message.toolbarMode = 3;
                break;
            default:
                if (typeof object.toolbarMode === "number" && (object.toolbarMode | 0) === object.toolbarMode)
                    message.toolbarMode = object.toolbarMode;
            }
        if (object.showErrorLinks !== 0 && (typeof object.showErrorLinks !== "string" || $root.Config.ShowErrorLinks[object.showErrorLinks] !== 0))
            switch (object.showErrorLinks) {
            case "SHOW_ERROR_LINKS_UNSPECIFIED":
            case 0:
                message.showErrorLinks = 0;
                break;
            case "SHOW_ERROR_LINKS_AUTO":
            case 1:
                message.showErrorLinks = 1;
                break;
            case "SHOW_ERROR_LINKS_TRUE":
            case 2:
                message.showErrorLinks = 2;
                break;
            case "SHOW_ERROR_LINKS_FALSE":
            case 3:
                message.showErrorLinks = 3;
                break;
            default:
                if (typeof object.showErrorLinks === "number" && (object.showErrorLinks | 0) === object.showErrorLinks)
                    message.showErrorLinks = object.showErrorLinks;
            }
        if (object.disableDataExport != null)
            if (object.disableDataExport)
                message.disableDataExport = $Boolean(object.disableDataExport);
        return message;
    };

    /**
     * Creates a plain object from a Config message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Config
     * @static
     * @param {Config} message Config
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Config.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.gatherUsageStats = false;
            object.maxCachedMessageAge = 0;
            object.allowRunOnSave = false;
            object.hideTopBar = false;
            object.hideSidebarNav = false;
            object.toolbarMode = options.enums === $String ? "AUTO" : 0;
            object.showErrorLinks = options.enums === $String ? "SHOW_ERROR_LINKS_UNSPECIFIED" : 0;
            object.disableDataExport = false;
        }
        if (message.gatherUsageStats != null && $Object.hasOwnProperty.call(message, "gatherUsageStats"))
            object.gatherUsageStats = message.gatherUsageStats;
        if (message.maxCachedMessageAge != null && $Object.hasOwnProperty.call(message, "maxCachedMessageAge"))
            object.maxCachedMessageAge = message.maxCachedMessageAge;
        if (message.allowRunOnSave != null && $Object.hasOwnProperty.call(message, "allowRunOnSave"))
            object.allowRunOnSave = message.allowRunOnSave;
        if (message.hideTopBar != null && $Object.hasOwnProperty.call(message, "hideTopBar"))
            object.hideTopBar = message.hideTopBar;
        if (message.hideSidebarNav != null && $Object.hasOwnProperty.call(message, "hideSidebarNav"))
            object.hideSidebarNav = message.hideSidebarNav;
        if (message.toolbarMode != null && $Object.hasOwnProperty.call(message, "toolbarMode"))
            object.toolbarMode = options.enums === $String ? $root.Config.ToolbarMode[message.toolbarMode] === $undefined ? message.toolbarMode : $root.Config.ToolbarMode[message.toolbarMode] : message.toolbarMode;
        if (message.showErrorLinks != null && $Object.hasOwnProperty.call(message, "showErrorLinks"))
            object.showErrorLinks = options.enums === $String ? $root.Config.ShowErrorLinks[message.showErrorLinks] === $undefined ? message.showErrorLinks : $root.Config.ShowErrorLinks[message.showErrorLinks] : message.showErrorLinks;
        if (message.disableDataExport != null && $Object.hasOwnProperty.call(message, "disableDataExport"))
            object.disableDataExport = message.disableDataExport;
        return object;
    };

    /**
     * Converts this Config to JSON.
     * @function toJSON
     * @memberof Config
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Config.prototype.toJSON = function() {
        return Config.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Config
     * @function getTypeUrl
     * @memberof Config
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Config.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Config";
    };

    /**
     * ToolbarMode enum.
     * @name Config.ToolbarMode
     * @enum {number}
     * @property {number} AUTO=0 AUTO value
     * @property {number} DEVELOPER=1 DEVELOPER value
     * @property {number} VIEWER=2 VIEWER value
     * @property {number} MINIMAL=3 MINIMAL value
     */
    Config.ToolbarMode = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "AUTO"] = 0;
        values[valuesById[1] = "DEVELOPER"] = 1;
        values[valuesById[2] = "VIEWER"] = 2;
        values[valuesById[3] = "MINIMAL"] = 3;
        return values;
    })();

    /**
     * ShowErrorLinks enum.
     * @name Config.ShowErrorLinks
     * @enum {number}
     * @property {number} SHOW_ERROR_LINKS_UNSPECIFIED=0 SHOW_ERROR_LINKS_UNSPECIFIED value
     * @property {number} SHOW_ERROR_LINKS_AUTO=1 SHOW_ERROR_LINKS_AUTO value
     * @property {number} SHOW_ERROR_LINKS_TRUE=2 SHOW_ERROR_LINKS_TRUE value
     * @property {number} SHOW_ERROR_LINKS_FALSE=3 SHOW_ERROR_LINKS_FALSE value
     */
    Config.ShowErrorLinks = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "SHOW_ERROR_LINKS_UNSPECIFIED"] = 0;
        values[valuesById[1] = "SHOW_ERROR_LINKS_AUTO"] = 1;
        values[valuesById[2] = "SHOW_ERROR_LINKS_TRUE"] = 2;
        values[valuesById[3] = "SHOW_ERROR_LINKS_FALSE"] = 3;
        return values;
    })();

    return Config;
})();

export const CustomThemeConfig = $root.CustomThemeConfig = (() => {

    /**
     * Properties of a CustomThemeConfig.
     * @typedef {Object} CustomThemeConfig.$Properties
     * @property {string|null} [primaryColor] CustomThemeConfig primaryColor
     * @property {string|null} [secondaryBackgroundColor] CustomThemeConfig secondaryBackgroundColor
     * @property {string|null} [backgroundColor] CustomThemeConfig backgroundColor
     * @property {string|null} [textColor] CustomThemeConfig textColor
     * @property {CustomThemeConfig.BaseTheme|null} [base] CustomThemeConfig base
     * @property {string|null} [headingFont] CustomThemeConfig headingFont
     * @property {string|null} [bodyFont] CustomThemeConfig bodyFont
     * @property {string|null} [codeFont] CustomThemeConfig codeFont
     * @property {Array.<FontFace.$Properties>|null} [fontFaces] CustomThemeConfig fontFaces
     * @property {Array.<FontSource.$Properties>|null} [fontSources] CustomThemeConfig fontSources
     * @property {string|null} [baseRadius] CustomThemeConfig baseRadius
     * @property {string|null} [buttonRadius] CustomThemeConfig buttonRadius
     * @property {string|null} [borderColor] CustomThemeConfig borderColor
     * @property {string|null} [dataframeBorderColor] CustomThemeConfig dataframeBorderColor
     * @property {boolean|null} [showWidgetBorder] CustomThemeConfig showWidgetBorder
     * @property {string|null} [linkColor] CustomThemeConfig linkColor
     * @property {boolean|null} [linkUnderline] CustomThemeConfig linkUnderline
     * @property {number|null} [baseFontSize] CustomThemeConfig baseFontSize
     * @property {number|null} [baseFontWeight] CustomThemeConfig baseFontWeight
     * @property {number|null} [codeFontWeight] CustomThemeConfig codeFontWeight
     * @property {string|null} [codeFontSize] CustomThemeConfig codeFontSize
     * @property {Array.<string>|null} [headingFontSizes] CustomThemeConfig headingFontSizes
     * @property {Array.<number>|null} [headingFontWeights] CustomThemeConfig headingFontWeights
     * @property {boolean|null} [showSidebarBorder] CustomThemeConfig showSidebarBorder
     * @property {string|null} [codeTextColor] CustomThemeConfig codeTextColor
     * @property {string|null} [codeBackgroundColor] CustomThemeConfig codeBackgroundColor
     * @property {string|null} [dataframeHeaderBackgroundColor] CustomThemeConfig dataframeHeaderBackgroundColor
     * @property {string|null} [dataframeHeaderTextColor] CustomThemeConfig dataframeHeaderTextColor
     * @property {Array.<string>|null} [chartCategoricalColors] CustomThemeConfig chartCategoricalColors
     * @property {Array.<string>|null} [chartSequentialColors] CustomThemeConfig chartSequentialColors
     * @property {Array.<string>|null} [chartDivergingColors] CustomThemeConfig chartDivergingColors
     * @property {string|null} [redColor] CustomThemeConfig redColor
     * @property {string|null} [orangeColor] CustomThemeConfig orangeColor
     * @property {string|null} [yellowColor] CustomThemeConfig yellowColor
     * @property {string|null} [blueColor] CustomThemeConfig blueColor
     * @property {string|null} [greenColor] CustomThemeConfig greenColor
     * @property {string|null} [violetColor] CustomThemeConfig violetColor
     * @property {string|null} [grayColor] CustomThemeConfig grayColor
     * @property {string|null} [redBackgroundColor] CustomThemeConfig redBackgroundColor
     * @property {string|null} [orangeBackgroundColor] CustomThemeConfig orangeBackgroundColor
     * @property {string|null} [yellowBackgroundColor] CustomThemeConfig yellowBackgroundColor
     * @property {string|null} [blueBackgroundColor] CustomThemeConfig blueBackgroundColor
     * @property {string|null} [greenBackgroundColor] CustomThemeConfig greenBackgroundColor
     * @property {string|null} [violetBackgroundColor] CustomThemeConfig violetBackgroundColor
     * @property {string|null} [grayBackgroundColor] CustomThemeConfig grayBackgroundColor
     * @property {string|null} [redTextColor] CustomThemeConfig redTextColor
     * @property {string|null} [orangeTextColor] CustomThemeConfig orangeTextColor
     * @property {string|null} [yellowTextColor] CustomThemeConfig yellowTextColor
     * @property {string|null} [blueTextColor] CustomThemeConfig blueTextColor
     * @property {string|null} [greenTextColor] CustomThemeConfig greenTextColor
     * @property {string|null} [violetTextColor] CustomThemeConfig violetTextColor
     * @property {string|null} [grayTextColor] CustomThemeConfig grayTextColor
     * @property {string|null} [metricValueFontSize] CustomThemeConfig metricValueFontSize
     * @property {number|null} [metricValueFontWeight] CustomThemeConfig metricValueFontWeight
     * @property {CustomThemeConfig.$Properties|null} [sidebar] CustomThemeConfig sidebar
     * @property {CustomThemeConfig.$Properties|null} [light] CustomThemeConfig light
     * @property {CustomThemeConfig.$Properties|null} [dark] CustomThemeConfig dark
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a CustomThemeConfig.
     * @exports ICustomThemeConfig
     * @interface ICustomThemeConfig
     * @augments CustomThemeConfig.$Properties
     * @deprecated Use CustomThemeConfig.$Properties instead.
     */

    /**
     * Shape of a CustomThemeConfig.
     * @typedef {CustomThemeConfig.$Properties} CustomThemeConfig.$Shape
     */

    /**
     * Constructs a new CustomThemeConfig.
     * @exports CustomThemeConfig
     * @classdesc Represents a CustomThemeConfig.
     * @constructor
     * @param {CustomThemeConfig.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const CustomThemeConfig = function (properties) {
        this.fontFaces = [];
        this.fontSources = [];
        this.headingFontSizes = [];
        this.headingFontWeights = [];
        this.chartCategoricalColors = [];
        this.chartSequentialColors = [];
        this.chartDivergingColors = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * CustomThemeConfig primaryColor.
     * @member {string} primaryColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.primaryColor = "";

    /**
     * CustomThemeConfig secondaryBackgroundColor.
     * @member {string} secondaryBackgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.secondaryBackgroundColor = "";

    /**
     * CustomThemeConfig backgroundColor.
     * @member {string} backgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.backgroundColor = "";

    /**
     * CustomThemeConfig textColor.
     * @member {string} textColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.textColor = "";

    /**
     * CustomThemeConfig base.
     * @member {CustomThemeConfig.BaseTheme} base
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.base = 0;

    /**
     * CustomThemeConfig headingFont.
     * @member {string} headingFont
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.headingFont = "";

    /**
     * CustomThemeConfig bodyFont.
     * @member {string} bodyFont
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.bodyFont = "";

    /**
     * CustomThemeConfig codeFont.
     * @member {string} codeFont
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.codeFont = "";

    /**
     * CustomThemeConfig fontFaces.
     * @member {Array.<FontFace.$Properties>} fontFaces
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.fontFaces = $util.emptyArray;

    /**
     * CustomThemeConfig fontSources.
     * @member {Array.<FontSource.$Properties>} fontSources
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.fontSources = $util.emptyArray;

    /**
     * CustomThemeConfig baseRadius.
     * @member {string|null|undefined} baseRadius
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.baseRadius = null;

    /**
     * CustomThemeConfig buttonRadius.
     * @member {string|null|undefined} buttonRadius
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.buttonRadius = null;

    /**
     * CustomThemeConfig borderColor.
     * @member {string|null|undefined} borderColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.borderColor = null;

    /**
     * CustomThemeConfig dataframeBorderColor.
     * @member {string|null|undefined} dataframeBorderColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.dataframeBorderColor = null;

    /**
     * CustomThemeConfig showWidgetBorder.
     * @member {boolean|null|undefined} showWidgetBorder
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.showWidgetBorder = null;

    /**
     * CustomThemeConfig linkColor.
     * @member {string|null|undefined} linkColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.linkColor = null;

    /**
     * CustomThemeConfig linkUnderline.
     * @member {boolean|null|undefined} linkUnderline
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.linkUnderline = null;

    /**
     * CustomThemeConfig baseFontSize.
     * @member {number|null|undefined} baseFontSize
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.baseFontSize = null;

    /**
     * CustomThemeConfig baseFontWeight.
     * @member {number|null|undefined} baseFontWeight
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.baseFontWeight = null;

    /**
     * CustomThemeConfig codeFontWeight.
     * @member {number|null|undefined} codeFontWeight
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.codeFontWeight = null;

    /**
     * CustomThemeConfig codeFontSize.
     * @member {string|null|undefined} codeFontSize
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.codeFontSize = null;

    /**
     * CustomThemeConfig headingFontSizes.
     * @member {Array.<string>} headingFontSizes
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.headingFontSizes = $util.emptyArray;

    /**
     * CustomThemeConfig headingFontWeights.
     * @member {Array.<number>} headingFontWeights
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.headingFontWeights = $util.emptyArray;

    /**
     * CustomThemeConfig showSidebarBorder.
     * @member {boolean|null|undefined} showSidebarBorder
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.showSidebarBorder = null;

    /**
     * CustomThemeConfig codeTextColor.
     * @member {string|null|undefined} codeTextColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.codeTextColor = null;

    /**
     * CustomThemeConfig codeBackgroundColor.
     * @member {string|null|undefined} codeBackgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.codeBackgroundColor = null;

    /**
     * CustomThemeConfig dataframeHeaderBackgroundColor.
     * @member {string|null|undefined} dataframeHeaderBackgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.dataframeHeaderBackgroundColor = null;

    /**
     * CustomThemeConfig dataframeHeaderTextColor.
     * @member {string|null|undefined} dataframeHeaderTextColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.dataframeHeaderTextColor = null;

    /**
     * CustomThemeConfig chartCategoricalColors.
     * @member {Array.<string>} chartCategoricalColors
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.chartCategoricalColors = $util.emptyArray;

    /**
     * CustomThemeConfig chartSequentialColors.
     * @member {Array.<string>} chartSequentialColors
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.chartSequentialColors = $util.emptyArray;

    /**
     * CustomThemeConfig chartDivergingColors.
     * @member {Array.<string>} chartDivergingColors
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.chartDivergingColors = $util.emptyArray;

    /**
     * CustomThemeConfig redColor.
     * @member {string|null|undefined} redColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.redColor = null;

    /**
     * CustomThemeConfig orangeColor.
     * @member {string|null|undefined} orangeColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.orangeColor = null;

    /**
     * CustomThemeConfig yellowColor.
     * @member {string|null|undefined} yellowColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.yellowColor = null;

    /**
     * CustomThemeConfig blueColor.
     * @member {string|null|undefined} blueColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.blueColor = null;

    /**
     * CustomThemeConfig greenColor.
     * @member {string|null|undefined} greenColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.greenColor = null;

    /**
     * CustomThemeConfig violetColor.
     * @member {string|null|undefined} violetColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.violetColor = null;

    /**
     * CustomThemeConfig grayColor.
     * @member {string|null|undefined} grayColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.grayColor = null;

    /**
     * CustomThemeConfig redBackgroundColor.
     * @member {string|null|undefined} redBackgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.redBackgroundColor = null;

    /**
     * CustomThemeConfig orangeBackgroundColor.
     * @member {string|null|undefined} orangeBackgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.orangeBackgroundColor = null;

    /**
     * CustomThemeConfig yellowBackgroundColor.
     * @member {string|null|undefined} yellowBackgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.yellowBackgroundColor = null;

    /**
     * CustomThemeConfig blueBackgroundColor.
     * @member {string|null|undefined} blueBackgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.blueBackgroundColor = null;

    /**
     * CustomThemeConfig greenBackgroundColor.
     * @member {string|null|undefined} greenBackgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.greenBackgroundColor = null;

    /**
     * CustomThemeConfig violetBackgroundColor.
     * @member {string|null|undefined} violetBackgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.violetBackgroundColor = null;

    /**
     * CustomThemeConfig grayBackgroundColor.
     * @member {string|null|undefined} grayBackgroundColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.grayBackgroundColor = null;

    /**
     * CustomThemeConfig redTextColor.
     * @member {string|null|undefined} redTextColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.redTextColor = null;

    /**
     * CustomThemeConfig orangeTextColor.
     * @member {string|null|undefined} orangeTextColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.orangeTextColor = null;

    /**
     * CustomThemeConfig yellowTextColor.
     * @member {string|null|undefined} yellowTextColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.yellowTextColor = null;

    /**
     * CustomThemeConfig blueTextColor.
     * @member {string|null|undefined} blueTextColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.blueTextColor = null;

    /**
     * CustomThemeConfig greenTextColor.
     * @member {string|null|undefined} greenTextColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.greenTextColor = null;

    /**
     * CustomThemeConfig violetTextColor.
     * @member {string|null|undefined} violetTextColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.violetTextColor = null;

    /**
     * CustomThemeConfig grayTextColor.
     * @member {string|null|undefined} grayTextColor
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.grayTextColor = null;

    /**
     * CustomThemeConfig metricValueFontSize.
     * @member {string|null|undefined} metricValueFontSize
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.metricValueFontSize = null;

    /**
     * CustomThemeConfig metricValueFontWeight.
     * @member {number|null|undefined} metricValueFontWeight
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.metricValueFontWeight = null;

    /**
     * CustomThemeConfig sidebar.
     * @member {CustomThemeConfig.$Properties|null|undefined} sidebar
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.sidebar = null;

    /**
     * CustomThemeConfig light.
     * @member {CustomThemeConfig.$Properties|null|undefined} light
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.light = null;

    /**
     * CustomThemeConfig dark.
     * @member {CustomThemeConfig.$Properties|null|undefined} dark
     * @memberof CustomThemeConfig
     * @instance
     */
    CustomThemeConfig.prototype.dark = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_baseRadius", {
        get: $util.oneOfGetter($oneOfFields = ["baseRadius"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_buttonRadius", {
        get: $util.oneOfGetter($oneOfFields = ["buttonRadius"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_borderColor", {
        get: $util.oneOfGetter($oneOfFields = ["borderColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_dataframeBorderColor", {
        get: $util.oneOfGetter($oneOfFields = ["dataframeBorderColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_showWidgetBorder", {
        get: $util.oneOfGetter($oneOfFields = ["showWidgetBorder"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_linkColor", {
        get: $util.oneOfGetter($oneOfFields = ["linkColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_linkUnderline", {
        get: $util.oneOfGetter($oneOfFields = ["linkUnderline"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_baseFontSize", {
        get: $util.oneOfGetter($oneOfFields = ["baseFontSize"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_baseFontWeight", {
        get: $util.oneOfGetter($oneOfFields = ["baseFontWeight"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_codeFontWeight", {
        get: $util.oneOfGetter($oneOfFields = ["codeFontWeight"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_codeFontSize", {
        get: $util.oneOfGetter($oneOfFields = ["codeFontSize"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_showSidebarBorder", {
        get: $util.oneOfGetter($oneOfFields = ["showSidebarBorder"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_codeTextColor", {
        get: $util.oneOfGetter($oneOfFields = ["codeTextColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_codeBackgroundColor", {
        get: $util.oneOfGetter($oneOfFields = ["codeBackgroundColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_dataframeHeaderBackgroundColor", {
        get: $util.oneOfGetter($oneOfFields = ["dataframeHeaderBackgroundColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_dataframeHeaderTextColor", {
        get: $util.oneOfGetter($oneOfFields = ["dataframeHeaderTextColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_redColor", {
        get: $util.oneOfGetter($oneOfFields = ["redColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_orangeColor", {
        get: $util.oneOfGetter($oneOfFields = ["orangeColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_yellowColor", {
        get: $util.oneOfGetter($oneOfFields = ["yellowColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_blueColor", {
        get: $util.oneOfGetter($oneOfFields = ["blueColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_greenColor", {
        get: $util.oneOfGetter($oneOfFields = ["greenColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_violetColor", {
        get: $util.oneOfGetter($oneOfFields = ["violetColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_grayColor", {
        get: $util.oneOfGetter($oneOfFields = ["grayColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_redBackgroundColor", {
        get: $util.oneOfGetter($oneOfFields = ["redBackgroundColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_orangeBackgroundColor", {
        get: $util.oneOfGetter($oneOfFields = ["orangeBackgroundColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_yellowBackgroundColor", {
        get: $util.oneOfGetter($oneOfFields = ["yellowBackgroundColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_blueBackgroundColor", {
        get: $util.oneOfGetter($oneOfFields = ["blueBackgroundColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_greenBackgroundColor", {
        get: $util.oneOfGetter($oneOfFields = ["greenBackgroundColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_violetBackgroundColor", {
        get: $util.oneOfGetter($oneOfFields = ["violetBackgroundColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_grayBackgroundColor", {
        get: $util.oneOfGetter($oneOfFields = ["grayBackgroundColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_redTextColor", {
        get: $util.oneOfGetter($oneOfFields = ["redTextColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_orangeTextColor", {
        get: $util.oneOfGetter($oneOfFields = ["orangeTextColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_yellowTextColor", {
        get: $util.oneOfGetter($oneOfFields = ["yellowTextColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_blueTextColor", {
        get: $util.oneOfGetter($oneOfFields = ["blueTextColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_greenTextColor", {
        get: $util.oneOfGetter($oneOfFields = ["greenTextColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_violetTextColor", {
        get: $util.oneOfGetter($oneOfFields = ["violetTextColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_grayTextColor", {
        get: $util.oneOfGetter($oneOfFields = ["grayTextColor"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_metricValueFontSize", {
        get: $util.oneOfGetter($oneOfFields = ["metricValueFontSize"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_metricValueFontWeight", {
        get: $util.oneOfGetter($oneOfFields = ["metricValueFontWeight"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_sidebar", {
        get: $util.oneOfGetter($oneOfFields = ["sidebar"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_light", {
        get: $util.oneOfGetter($oneOfFields = ["light"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(CustomThemeConfig.prototype, "_dark", {
        get: $util.oneOfGetter($oneOfFields = ["dark"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new CustomThemeConfig instance using the specified properties.
     * @function create
     * @memberof CustomThemeConfig
     * @static
     * @param {CustomThemeConfig.$Properties=} [properties] Properties to set
     * @returns {CustomThemeConfig} CustomThemeConfig instance
     * @type {{
     *   (properties: CustomThemeConfig.$Shape): CustomThemeConfig & CustomThemeConfig.$Shape;
     *   (properties?: CustomThemeConfig.$Properties): CustomThemeConfig;
     * }}
     */
    CustomThemeConfig.create = function(properties) {
        return new CustomThemeConfig(properties);
    };

    /**
     * Encodes the specified CustomThemeConfig message. Does not implicitly {@link CustomThemeConfig.verify|verify} messages.
     * @function encode
     * @memberof CustomThemeConfig
     * @static
     * @param {CustomThemeConfig.$Properties} message CustomThemeConfig message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CustomThemeConfig.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.primaryColor != null && $Object.hasOwnProperty.call(message, "primaryColor") && message.primaryColor !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.primaryColor);
        if (message.secondaryBackgroundColor != null && $Object.hasOwnProperty.call(message, "secondaryBackgroundColor") && message.secondaryBackgroundColor !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.secondaryBackgroundColor);
        if (message.backgroundColor != null && $Object.hasOwnProperty.call(message, "backgroundColor") && message.backgroundColor !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.backgroundColor);
        if (message.textColor != null && $Object.hasOwnProperty.call(message, "textColor") && message.textColor !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.textColor);
        if (message.base != null && $Object.hasOwnProperty.call(message, "base") && message.base !== 0)
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.base);
        if (message.headingFont != null && $Object.hasOwnProperty.call(message, "headingFont") && message.headingFont !== "")
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.headingFont);
        if (message.bodyFont != null && $Object.hasOwnProperty.call(message, "bodyFont") && message.bodyFont !== "")
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.bodyFont);
        if (message.codeFont != null && $Object.hasOwnProperty.call(message, "codeFont") && message.codeFont !== "")
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.codeFont);
        if (message.fontFaces != null && message.fontFaces.length)
            for (let i = 0; i < message.fontFaces.length; ++i)
                $root.FontFace.encode(message.fontFaces[i], writer.uint32(/* id 15, wireType 2 =*/122).fork(), _depth + 1).ldelim();
        if (message.baseRadius != null && $Object.hasOwnProperty.call(message, "baseRadius"))
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.baseRadius);
        if (message.borderColor != null && $Object.hasOwnProperty.call(message, "borderColor"))
            writer.uint32(/* id 19, wireType 2 =*/154).string(message.borderColor);
        if (message.showWidgetBorder != null && $Object.hasOwnProperty.call(message, "showWidgetBorder"))
            writer.uint32(/* id 20, wireType 0 =*/160).bool(message.showWidgetBorder);
        if (message.linkColor != null && $Object.hasOwnProperty.call(message, "linkColor"))
            writer.uint32(/* id 21, wireType 2 =*/170).string(message.linkColor);
        if (message.baseFontSize != null && $Object.hasOwnProperty.call(message, "baseFontSize"))
            writer.uint32(/* id 22, wireType 0 =*/176).int32(message.baseFontSize);
        if (message.showSidebarBorder != null && $Object.hasOwnProperty.call(message, "showSidebarBorder"))
            writer.uint32(/* id 23, wireType 0 =*/184).bool(message.showSidebarBorder);
        if (message.sidebar != null && $Object.hasOwnProperty.call(message, "sidebar"))
            $root.CustomThemeConfig.encode(message.sidebar, writer.uint32(/* id 24, wireType 2 =*/194).fork(), _depth + 1).ldelim();
        if (message.codeBackgroundColor != null && $Object.hasOwnProperty.call(message, "codeBackgroundColor"))
            writer.uint32(/* id 25, wireType 2 =*/202).string(message.codeBackgroundColor);
        if (message.buttonRadius != null && $Object.hasOwnProperty.call(message, "buttonRadius"))
            writer.uint32(/* id 26, wireType 2 =*/210).string(message.buttonRadius);
        if (message.dataframeBorderColor != null && $Object.hasOwnProperty.call(message, "dataframeBorderColor"))
            writer.uint32(/* id 27, wireType 2 =*/218).string(message.dataframeBorderColor);
        if (message.codeFontSize != null && $Object.hasOwnProperty.call(message, "codeFontSize"))
            writer.uint32(/* id 28, wireType 2 =*/226).string(message.codeFontSize);
        if (message.linkUnderline != null && $Object.hasOwnProperty.call(message, "linkUnderline"))
            writer.uint32(/* id 29, wireType 0 =*/232).bool(message.linkUnderline);
        if (message.baseFontWeight != null && $Object.hasOwnProperty.call(message, "baseFontWeight"))
            writer.uint32(/* id 30, wireType 0 =*/240).int32(message.baseFontWeight);
        if (message.dataframeHeaderBackgroundColor != null && $Object.hasOwnProperty.call(message, "dataframeHeaderBackgroundColor"))
            writer.uint32(/* id 31, wireType 2 =*/250).string(message.dataframeHeaderBackgroundColor);
        if (message.codeFontWeight != null && $Object.hasOwnProperty.call(message, "codeFontWeight"))
            writer.uint32(/* id 32, wireType 0 =*/256).int32(message.codeFontWeight);
        if (message.chartCategoricalColors != null && message.chartCategoricalColors.length)
            for (let i = 0; i < message.chartCategoricalColors.length; ++i)
                writer.uint32(/* id 33, wireType 2 =*/266).string(message.chartCategoricalColors[i]);
        if (message.headingFontWeights != null && message.headingFontWeights.length)
            writer.uint32(/* id 34, wireType 2 =*/274).int32s(message.headingFontWeights);
        if (message.headingFontSizes != null && message.headingFontSizes.length)
            for (let i = 0; i < message.headingFontSizes.length; ++i)
                writer.uint32(/* id 35, wireType 2 =*/282).string(message.headingFontSizes[i]);
        if (message.chartSequentialColors != null && message.chartSequentialColors.length)
            for (let i = 0; i < message.chartSequentialColors.length; ++i)
                writer.uint32(/* id 36, wireType 2 =*/290).string(message.chartSequentialColors[i]);
        if (message.fontSources != null && message.fontSources.length)
            for (let i = 0; i < message.fontSources.length; ++i)
                $root.FontSource.encode(message.fontSources[i], writer.uint32(/* id 37, wireType 2 =*/298).fork(), _depth + 1).ldelim();
        if (message.redColor != null && $Object.hasOwnProperty.call(message, "redColor"))
            writer.uint32(/* id 38, wireType 2 =*/306).string(message.redColor);
        if (message.orangeColor != null && $Object.hasOwnProperty.call(message, "orangeColor"))
            writer.uint32(/* id 39, wireType 2 =*/314).string(message.orangeColor);
        if (message.yellowColor != null && $Object.hasOwnProperty.call(message, "yellowColor"))
            writer.uint32(/* id 40, wireType 2 =*/322).string(message.yellowColor);
        if (message.blueColor != null && $Object.hasOwnProperty.call(message, "blueColor"))
            writer.uint32(/* id 41, wireType 2 =*/330).string(message.blueColor);
        if (message.greenColor != null && $Object.hasOwnProperty.call(message, "greenColor"))
            writer.uint32(/* id 42, wireType 2 =*/338).string(message.greenColor);
        if (message.violetColor != null && $Object.hasOwnProperty.call(message, "violetColor"))
            writer.uint32(/* id 43, wireType 2 =*/346).string(message.violetColor);
        if (message.grayColor != null && $Object.hasOwnProperty.call(message, "grayColor"))
            writer.uint32(/* id 44, wireType 2 =*/354).string(message.grayColor);
        if (message.redBackgroundColor != null && $Object.hasOwnProperty.call(message, "redBackgroundColor"))
            writer.uint32(/* id 45, wireType 2 =*/362).string(message.redBackgroundColor);
        if (message.orangeBackgroundColor != null && $Object.hasOwnProperty.call(message, "orangeBackgroundColor"))
            writer.uint32(/* id 46, wireType 2 =*/370).string(message.orangeBackgroundColor);
        if (message.yellowBackgroundColor != null && $Object.hasOwnProperty.call(message, "yellowBackgroundColor"))
            writer.uint32(/* id 47, wireType 2 =*/378).string(message.yellowBackgroundColor);
        if (message.blueBackgroundColor != null && $Object.hasOwnProperty.call(message, "blueBackgroundColor"))
            writer.uint32(/* id 48, wireType 2 =*/386).string(message.blueBackgroundColor);
        if (message.greenBackgroundColor != null && $Object.hasOwnProperty.call(message, "greenBackgroundColor"))
            writer.uint32(/* id 49, wireType 2 =*/394).string(message.greenBackgroundColor);
        if (message.violetBackgroundColor != null && $Object.hasOwnProperty.call(message, "violetBackgroundColor"))
            writer.uint32(/* id 50, wireType 2 =*/402).string(message.violetBackgroundColor);
        if (message.grayBackgroundColor != null && $Object.hasOwnProperty.call(message, "grayBackgroundColor"))
            writer.uint32(/* id 51, wireType 2 =*/410).string(message.grayBackgroundColor);
        if (message.redTextColor != null && $Object.hasOwnProperty.call(message, "redTextColor"))
            writer.uint32(/* id 52, wireType 2 =*/418).string(message.redTextColor);
        if (message.orangeTextColor != null && $Object.hasOwnProperty.call(message, "orangeTextColor"))
            writer.uint32(/* id 53, wireType 2 =*/426).string(message.orangeTextColor);
        if (message.yellowTextColor != null && $Object.hasOwnProperty.call(message, "yellowTextColor"))
            writer.uint32(/* id 54, wireType 2 =*/434).string(message.yellowTextColor);
        if (message.blueTextColor != null && $Object.hasOwnProperty.call(message, "blueTextColor"))
            writer.uint32(/* id 55, wireType 2 =*/442).string(message.blueTextColor);
        if (message.greenTextColor != null && $Object.hasOwnProperty.call(message, "greenTextColor"))
            writer.uint32(/* id 56, wireType 2 =*/450).string(message.greenTextColor);
        if (message.violetTextColor != null && $Object.hasOwnProperty.call(message, "violetTextColor"))
            writer.uint32(/* id 57, wireType 2 =*/458).string(message.violetTextColor);
        if (message.grayTextColor != null && $Object.hasOwnProperty.call(message, "grayTextColor"))
            writer.uint32(/* id 58, wireType 2 =*/466).string(message.grayTextColor);
        if (message.codeTextColor != null && $Object.hasOwnProperty.call(message, "codeTextColor"))
            writer.uint32(/* id 59, wireType 2 =*/474).string(message.codeTextColor);
        if (message.light != null && $Object.hasOwnProperty.call(message, "light"))
            $root.CustomThemeConfig.encode(message.light, writer.uint32(/* id 60, wireType 2 =*/482).fork(), _depth + 1).ldelim();
        if (message.dark != null && $Object.hasOwnProperty.call(message, "dark"))
            $root.CustomThemeConfig.encode(message.dark, writer.uint32(/* id 61, wireType 2 =*/490).fork(), _depth + 1).ldelim();
        if (message.chartDivergingColors != null && message.chartDivergingColors.length)
            for (let i = 0; i < message.chartDivergingColors.length; ++i)
                writer.uint32(/* id 62, wireType 2 =*/498).string(message.chartDivergingColors[i]);
        if (message.metricValueFontSize != null && $Object.hasOwnProperty.call(message, "metricValueFontSize"))
            writer.uint32(/* id 64, wireType 2 =*/514).string(message.metricValueFontSize);
        if (message.metricValueFontWeight != null && $Object.hasOwnProperty.call(message, "metricValueFontWeight"))
            writer.uint32(/* id 65, wireType 0 =*/520).int32(message.metricValueFontWeight);
        if (message.dataframeHeaderTextColor != null && $Object.hasOwnProperty.call(message, "dataframeHeaderTextColor"))
            writer.uint32(/* id 66, wireType 2 =*/530).string(message.dataframeHeaderTextColor);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a CustomThemeConfig message from the specified reader or buffer.
     * @function decode
     * @memberof CustomThemeConfig
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CustomThemeConfig & CustomThemeConfig.$Shape} CustomThemeConfig
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CustomThemeConfig.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.CustomThemeConfig();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.primaryColor = value;
                    else
                        delete message.primaryColor;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.secondaryBackgroundColor = value;
                    else
                        delete message.secondaryBackgroundColor;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.backgroundColor = value;
                    else
                        delete message.backgroundColor;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.textColor = value;
                    else
                        delete message.textColor;
                    continue;
                }
            case 6: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.base = value;
                    else
                        delete message.base;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.headingFont = value;
                    else
                        delete message.headingFont;
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.bodyFont = value;
                    else
                        delete message.bodyFont;
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.codeFont = value;
                    else
                        delete message.codeFont;
                    continue;
                }
            case 15: {
                    if (wireType !== 2)
                        break;
                    if (!(message.fontFaces && message.fontFaces.length))
                        message.fontFaces = [];
                    message.fontFaces.push($root.FontFace.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 37: {
                    if (wireType !== 2)
                        break;
                    if (!(message.fontSources && message.fontSources.length))
                        message.fontSources = [];
                    message.fontSources.push($root.FontSource.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 18: {
                    if (wireType !== 2)
                        break;
                    message.baseRadius = reader.stringVerify();
                    message._baseRadius = "baseRadius";
                    continue;
                }
            case 26: {
                    if (wireType !== 2)
                        break;
                    message.buttonRadius = reader.stringVerify();
                    message._buttonRadius = "buttonRadius";
                    continue;
                }
            case 19: {
                    if (wireType !== 2)
                        break;
                    message.borderColor = reader.stringVerify();
                    message._borderColor = "borderColor";
                    continue;
                }
            case 27: {
                    if (wireType !== 2)
                        break;
                    message.dataframeBorderColor = reader.stringVerify();
                    message._dataframeBorderColor = "dataframeBorderColor";
                    continue;
                }
            case 20: {
                    if (wireType !== 0)
                        break;
                    message.showWidgetBorder = reader.bool();
                    message._showWidgetBorder = "showWidgetBorder";
                    continue;
                }
            case 21: {
                    if (wireType !== 2)
                        break;
                    message.linkColor = reader.stringVerify();
                    message._linkColor = "linkColor";
                    continue;
                }
            case 29: {
                    if (wireType !== 0)
                        break;
                    message.linkUnderline = reader.bool();
                    message._linkUnderline = "linkUnderline";
                    continue;
                }
            case 22: {
                    if (wireType !== 0)
                        break;
                    message.baseFontSize = reader.int32();
                    message._baseFontSize = "baseFontSize";
                    continue;
                }
            case 30: {
                    if (wireType !== 0)
                        break;
                    message.baseFontWeight = reader.int32();
                    message._baseFontWeight = "baseFontWeight";
                    continue;
                }
            case 32: {
                    if (wireType !== 0)
                        break;
                    message.codeFontWeight = reader.int32();
                    message._codeFontWeight = "codeFontWeight";
                    continue;
                }
            case 28: {
                    if (wireType !== 2)
                        break;
                    message.codeFontSize = reader.stringVerify();
                    message._codeFontSize = "codeFontSize";
                    continue;
                }
            case 35: {
                    if (wireType !== 2)
                        break;
                    if (!(message.headingFontSizes && message.headingFontSizes.length))
                        message.headingFontSizes = [];
                    message.headingFontSizes.push(reader.stringVerify());
                    continue;
                }
            case 34: {
                    if (wireType === 2) {
                        if (!(message.headingFontWeights && message.headingFontWeights.length))
                            message.headingFontWeights = [];
                        reader.int32s(message.headingFontWeights);
                        continue;
                    }
                    if (wireType !== 0)
                        break;
                    if (!(message.headingFontWeights && message.headingFontWeights.length))
                        message.headingFontWeights = [];
                    message.headingFontWeights.push(reader.int32());
                    continue;
                }
            case 23: {
                    if (wireType !== 0)
                        break;
                    message.showSidebarBorder = reader.bool();
                    message._showSidebarBorder = "showSidebarBorder";
                    continue;
                }
            case 59: {
                    if (wireType !== 2)
                        break;
                    message.codeTextColor = reader.stringVerify();
                    message._codeTextColor = "codeTextColor";
                    continue;
                }
            case 25: {
                    if (wireType !== 2)
                        break;
                    message.codeBackgroundColor = reader.stringVerify();
                    message._codeBackgroundColor = "codeBackgroundColor";
                    continue;
                }
            case 31: {
                    if (wireType !== 2)
                        break;
                    message.dataframeHeaderBackgroundColor = reader.stringVerify();
                    message._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor";
                    continue;
                }
            case 66: {
                    if (wireType !== 2)
                        break;
                    message.dataframeHeaderTextColor = reader.stringVerify();
                    message._dataframeHeaderTextColor = "dataframeHeaderTextColor";
                    continue;
                }
            case 33: {
                    if (wireType !== 2)
                        break;
                    if (!(message.chartCategoricalColors && message.chartCategoricalColors.length))
                        message.chartCategoricalColors = [];
                    message.chartCategoricalColors.push(reader.stringVerify());
                    continue;
                }
            case 36: {
                    if (wireType !== 2)
                        break;
                    if (!(message.chartSequentialColors && message.chartSequentialColors.length))
                        message.chartSequentialColors = [];
                    message.chartSequentialColors.push(reader.stringVerify());
                    continue;
                }
            case 62: {
                    if (wireType !== 2)
                        break;
                    if (!(message.chartDivergingColors && message.chartDivergingColors.length))
                        message.chartDivergingColors = [];
                    message.chartDivergingColors.push(reader.stringVerify());
                    continue;
                }
            case 38: {
                    if (wireType !== 2)
                        break;
                    message.redColor = reader.stringVerify();
                    message._redColor = "redColor";
                    continue;
                }
            case 39: {
                    if (wireType !== 2)
                        break;
                    message.orangeColor = reader.stringVerify();
                    message._orangeColor = "orangeColor";
                    continue;
                }
            case 40: {
                    if (wireType !== 2)
                        break;
                    message.yellowColor = reader.stringVerify();
                    message._yellowColor = "yellowColor";
                    continue;
                }
            case 41: {
                    if (wireType !== 2)
                        break;
                    message.blueColor = reader.stringVerify();
                    message._blueColor = "blueColor";
                    continue;
                }
            case 42: {
                    if (wireType !== 2)
                        break;
                    message.greenColor = reader.stringVerify();
                    message._greenColor = "greenColor";
                    continue;
                }
            case 43: {
                    if (wireType !== 2)
                        break;
                    message.violetColor = reader.stringVerify();
                    message._violetColor = "violetColor";
                    continue;
                }
            case 44: {
                    if (wireType !== 2)
                        break;
                    message.grayColor = reader.stringVerify();
                    message._grayColor = "grayColor";
                    continue;
                }
            case 45: {
                    if (wireType !== 2)
                        break;
                    message.redBackgroundColor = reader.stringVerify();
                    message._redBackgroundColor = "redBackgroundColor";
                    continue;
                }
            case 46: {
                    if (wireType !== 2)
                        break;
                    message.orangeBackgroundColor = reader.stringVerify();
                    message._orangeBackgroundColor = "orangeBackgroundColor";
                    continue;
                }
            case 47: {
                    if (wireType !== 2)
                        break;
                    message.yellowBackgroundColor = reader.stringVerify();
                    message._yellowBackgroundColor = "yellowBackgroundColor";
                    continue;
                }
            case 48: {
                    if (wireType !== 2)
                        break;
                    message.blueBackgroundColor = reader.stringVerify();
                    message._blueBackgroundColor = "blueBackgroundColor";
                    continue;
                }
            case 49: {
                    if (wireType !== 2)
                        break;
                    message.greenBackgroundColor = reader.stringVerify();
                    message._greenBackgroundColor = "greenBackgroundColor";
                    continue;
                }
            case 50: {
                    if (wireType !== 2)
                        break;
                    message.violetBackgroundColor = reader.stringVerify();
                    message._violetBackgroundColor = "violetBackgroundColor";
                    continue;
                }
            case 51: {
                    if (wireType !== 2)
                        break;
                    message.grayBackgroundColor = reader.stringVerify();
                    message._grayBackgroundColor = "grayBackgroundColor";
                    continue;
                }
            case 52: {
                    if (wireType !== 2)
                        break;
                    message.redTextColor = reader.stringVerify();
                    message._redTextColor = "redTextColor";
                    continue;
                }
            case 53: {
                    if (wireType !== 2)
                        break;
                    message.orangeTextColor = reader.stringVerify();
                    message._orangeTextColor = "orangeTextColor";
                    continue;
                }
            case 54: {
                    if (wireType !== 2)
                        break;
                    message.yellowTextColor = reader.stringVerify();
                    message._yellowTextColor = "yellowTextColor";
                    continue;
                }
            case 55: {
                    if (wireType !== 2)
                        break;
                    message.blueTextColor = reader.stringVerify();
                    message._blueTextColor = "blueTextColor";
                    continue;
                }
            case 56: {
                    if (wireType !== 2)
                        break;
                    message.greenTextColor = reader.stringVerify();
                    message._greenTextColor = "greenTextColor";
                    continue;
                }
            case 57: {
                    if (wireType !== 2)
                        break;
                    message.violetTextColor = reader.stringVerify();
                    message._violetTextColor = "violetTextColor";
                    continue;
                }
            case 58: {
                    if (wireType !== 2)
                        break;
                    message.grayTextColor = reader.stringVerify();
                    message._grayTextColor = "grayTextColor";
                    continue;
                }
            case 64: {
                    if (wireType !== 2)
                        break;
                    message.metricValueFontSize = reader.stringVerify();
                    message._metricValueFontSize = "metricValueFontSize";
                    continue;
                }
            case 65: {
                    if (wireType !== 0)
                        break;
                    message.metricValueFontWeight = reader.int32();
                    message._metricValueFontWeight = "metricValueFontWeight";
                    continue;
                }
            case 24: {
                    if (wireType !== 2)
                        break;
                    message.sidebar = $root.CustomThemeConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.sidebar);
                    message._sidebar = "sidebar";
                    continue;
                }
            case 60: {
                    if (wireType !== 2)
                        break;
                    message.light = $root.CustomThemeConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.light);
                    message._light = "light";
                    continue;
                }
            case 61: {
                    if (wireType !== 2)
                        break;
                    message.dark = $root.CustomThemeConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.dark);
                    message._dark = "dark";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a CustomThemeConfig message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CustomThemeConfig
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CustomThemeConfig} CustomThemeConfig
     */
    CustomThemeConfig.fromObject = function (object, _depth) {
        if (object instanceof $root.CustomThemeConfig)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".CustomThemeConfig: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.CustomThemeConfig();
        if (object.primaryColor != null)
            if (typeof object.primaryColor !== "string" || object.primaryColor.length)
                message.primaryColor = $String(object.primaryColor);
        if (object.secondaryBackgroundColor != null)
            if (typeof object.secondaryBackgroundColor !== "string" || object.secondaryBackgroundColor.length)
                message.secondaryBackgroundColor = $String(object.secondaryBackgroundColor);
        if (object.backgroundColor != null)
            if (typeof object.backgroundColor !== "string" || object.backgroundColor.length)
                message.backgroundColor = $String(object.backgroundColor);
        if (object.textColor != null)
            if (typeof object.textColor !== "string" || object.textColor.length)
                message.textColor = $String(object.textColor);
        if (object.base !== 0 && (typeof object.base !== "string" || $root.CustomThemeConfig.BaseTheme[object.base] !== 0))
            switch (object.base) {
            case "LIGHT":
            case 0:
                message.base = 0;
                break;
            case "DARK":
            case 1:
                message.base = 1;
                break;
            default:
                if (typeof object.base === "number" && (object.base | 0) === object.base)
                    message.base = object.base;
            }
        if (object.headingFont != null)
            if (typeof object.headingFont !== "string" || object.headingFont.length)
                message.headingFont = $String(object.headingFont);
        if (object.bodyFont != null)
            if (typeof object.bodyFont !== "string" || object.bodyFont.length)
                message.bodyFont = $String(object.bodyFont);
        if (object.codeFont != null)
            if (typeof object.codeFont !== "string" || object.codeFont.length)
                message.codeFont = $String(object.codeFont);
        if (object.fontFaces) {
            if (!$Array.isArray(object.fontFaces))
                throw $TypeError(".CustomThemeConfig.fontFaces: array expected");
            message.fontFaces = $Array(object.fontFaces.length);
            for (let i = 0; i < object.fontFaces.length; ++i) {
                if (!$util.isObject(object.fontFaces[i]))
                    throw $TypeError(".CustomThemeConfig.fontFaces: object expected");
                message.fontFaces[i] = $root.FontFace.fromObject(object.fontFaces[i], _depth + 1);
            }
        }
        if (object.fontSources) {
            if (!$Array.isArray(object.fontSources))
                throw $TypeError(".CustomThemeConfig.fontSources: array expected");
            message.fontSources = $Array(object.fontSources.length);
            for (let i = 0; i < object.fontSources.length; ++i) {
                if (!$util.isObject(object.fontSources[i]))
                    throw $TypeError(".CustomThemeConfig.fontSources: object expected");
                message.fontSources[i] = $root.FontSource.fromObject(object.fontSources[i], _depth + 1);
            }
        }
        if (object.baseRadius != null)
            message.baseRadius = $String(object.baseRadius);
        if (object.buttonRadius != null)
            message.buttonRadius = $String(object.buttonRadius);
        if (object.borderColor != null)
            message.borderColor = $String(object.borderColor);
        if (object.dataframeBorderColor != null)
            message.dataframeBorderColor = $String(object.dataframeBorderColor);
        if (object.showWidgetBorder != null)
            message.showWidgetBorder = $Boolean(object.showWidgetBorder);
        if (object.linkColor != null)
            message.linkColor = $String(object.linkColor);
        if (object.linkUnderline != null)
            message.linkUnderline = $Boolean(object.linkUnderline);
        if (object.baseFontSize != null)
            message.baseFontSize = object.baseFontSize | 0;
        if (object.baseFontWeight != null)
            message.baseFontWeight = object.baseFontWeight | 0;
        if (object.codeFontWeight != null)
            message.codeFontWeight = object.codeFontWeight | 0;
        if (object.codeFontSize != null)
            message.codeFontSize = $String(object.codeFontSize);
        if (object.headingFontSizes) {
            if (!$Array.isArray(object.headingFontSizes))
                throw $TypeError(".CustomThemeConfig.headingFontSizes: array expected");
            message.headingFontSizes = $Array(object.headingFontSizes.length);
            for (let i = 0; i < object.headingFontSizes.length; ++i)
                message.headingFontSizes[i] = $String(object.headingFontSizes[i]);
        }
        if (object.headingFontWeights) {
            if (!$Array.isArray(object.headingFontWeights))
                throw $TypeError(".CustomThemeConfig.headingFontWeights: array expected");
            message.headingFontWeights = $Array(object.headingFontWeights.length);
            for (let i = 0; i < object.headingFontWeights.length; ++i)
                message.headingFontWeights[i] = object.headingFontWeights[i] | 0;
        }
        if (object.showSidebarBorder != null)
            message.showSidebarBorder = $Boolean(object.showSidebarBorder);
        if (object.codeTextColor != null)
            message.codeTextColor = $String(object.codeTextColor);
        if (object.codeBackgroundColor != null)
            message.codeBackgroundColor = $String(object.codeBackgroundColor);
        if (object.dataframeHeaderBackgroundColor != null)
            message.dataframeHeaderBackgroundColor = $String(object.dataframeHeaderBackgroundColor);
        if (object.dataframeHeaderTextColor != null)
            message.dataframeHeaderTextColor = $String(object.dataframeHeaderTextColor);
        if (object.chartCategoricalColors) {
            if (!$Array.isArray(object.chartCategoricalColors))
                throw $TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
            message.chartCategoricalColors = $Array(object.chartCategoricalColors.length);
            for (let i = 0; i < object.chartCategoricalColors.length; ++i)
                message.chartCategoricalColors[i] = $String(object.chartCategoricalColors[i]);
        }
        if (object.chartSequentialColors) {
            if (!$Array.isArray(object.chartSequentialColors))
                throw $TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
            message.chartSequentialColors = $Array(object.chartSequentialColors.length);
            for (let i = 0; i < object.chartSequentialColors.length; ++i)
                message.chartSequentialColors[i] = $String(object.chartSequentialColors[i]);
        }
        if (object.chartDivergingColors) {
            if (!$Array.isArray(object.chartDivergingColors))
                throw $TypeError(".CustomThemeConfig.chartDivergingColors: array expected");
            message.chartDivergingColors = $Array(object.chartDivergingColors.length);
            for (let i = 0; i < object.chartDivergingColors.length; ++i)
                message.chartDivergingColors[i] = $String(object.chartDivergingColors[i]);
        }
        if (object.redColor != null)
            message.redColor = $String(object.redColor);
        if (object.orangeColor != null)
            message.orangeColor = $String(object.orangeColor);
        if (object.yellowColor != null)
            message.yellowColor = $String(object.yellowColor);
        if (object.blueColor != null)
            message.blueColor = $String(object.blueColor);
        if (object.greenColor != null)
            message.greenColor = $String(object.greenColor);
        if (object.violetColor != null)
            message.violetColor = $String(object.violetColor);
        if (object.grayColor != null)
            message.grayColor = $String(object.grayColor);
        if (object.redBackgroundColor != null)
            message.redBackgroundColor = $String(object.redBackgroundColor);
        if (object.orangeBackgroundColor != null)
            message.orangeBackgroundColor = $String(object.orangeBackgroundColor);
        if (object.yellowBackgroundColor != null)
            message.yellowBackgroundColor = $String(object.yellowBackgroundColor);
        if (object.blueBackgroundColor != null)
            message.blueBackgroundColor = $String(object.blueBackgroundColor);
        if (object.greenBackgroundColor != null)
            message.greenBackgroundColor = $String(object.greenBackgroundColor);
        if (object.violetBackgroundColor != null)
            message.violetBackgroundColor = $String(object.violetBackgroundColor);
        if (object.grayBackgroundColor != null)
            message.grayBackgroundColor = $String(object.grayBackgroundColor);
        if (object.redTextColor != null)
            message.redTextColor = $String(object.redTextColor);
        if (object.orangeTextColor != null)
            message.orangeTextColor = $String(object.orangeTextColor);
        if (object.yellowTextColor != null)
            message.yellowTextColor = $String(object.yellowTextColor);
        if (object.blueTextColor != null)
            message.blueTextColor = $String(object.blueTextColor);
        if (object.greenTextColor != null)
            message.greenTextColor = $String(object.greenTextColor);
        if (object.violetTextColor != null)
            message.violetTextColor = $String(object.violetTextColor);
        if (object.grayTextColor != null)
            message.grayTextColor = $String(object.grayTextColor);
        if (object.metricValueFontSize != null)
            message.metricValueFontSize = $String(object.metricValueFontSize);
        if (object.metricValueFontWeight != null)
            message.metricValueFontWeight = object.metricValueFontWeight | 0;
        if (object.sidebar != null) {
            if (!$util.isObject(object.sidebar))
                throw $TypeError(".CustomThemeConfig.sidebar: object expected");
            message.sidebar = $root.CustomThemeConfig.fromObject(object.sidebar, _depth + 1);
        }
        if (object.light != null) {
            if (!$util.isObject(object.light))
                throw $TypeError(".CustomThemeConfig.light: object expected");
            message.light = $root.CustomThemeConfig.fromObject(object.light, _depth + 1);
        }
        if (object.dark != null) {
            if (!$util.isObject(object.dark))
                throw $TypeError(".CustomThemeConfig.dark: object expected");
            message.dark = $root.CustomThemeConfig.fromObject(object.dark, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a CustomThemeConfig message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CustomThemeConfig
     * @static
     * @param {CustomThemeConfig} message CustomThemeConfig
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CustomThemeConfig.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object.fontFaces = [];
            object.chartCategoricalColors = [];
            object.headingFontWeights = [];
            object.headingFontSizes = [];
            object.chartSequentialColors = [];
            object.fontSources = [];
            object.chartDivergingColors = [];
        }
        if (options.defaults) {
            object.primaryColor = "";
            object.secondaryBackgroundColor = "";
            object.backgroundColor = "";
            object.textColor = "";
            object.base = options.enums === $String ? "LIGHT" : 0;
            object.headingFont = "";
            object.bodyFont = "";
            object.codeFont = "";
        }
        if (message.primaryColor != null && $Object.hasOwnProperty.call(message, "primaryColor"))
            object.primaryColor = message.primaryColor;
        if (message.secondaryBackgroundColor != null && $Object.hasOwnProperty.call(message, "secondaryBackgroundColor"))
            object.secondaryBackgroundColor = message.secondaryBackgroundColor;
        if (message.backgroundColor != null && $Object.hasOwnProperty.call(message, "backgroundColor"))
            object.backgroundColor = message.backgroundColor;
        if (message.textColor != null && $Object.hasOwnProperty.call(message, "textColor"))
            object.textColor = message.textColor;
        if (message.base != null && $Object.hasOwnProperty.call(message, "base"))
            object.base = options.enums === $String ? $root.CustomThemeConfig.BaseTheme[message.base] === $undefined ? message.base : $root.CustomThemeConfig.BaseTheme[message.base] : message.base;
        if (message.headingFont != null && $Object.hasOwnProperty.call(message, "headingFont"))
            object.headingFont = message.headingFont;
        if (message.bodyFont != null && $Object.hasOwnProperty.call(message, "bodyFont"))
            object.bodyFont = message.bodyFont;
        if (message.codeFont != null && $Object.hasOwnProperty.call(message, "codeFont"))
            object.codeFont = message.codeFont;
        if (message.fontFaces && message.fontFaces.length) {
            object.fontFaces = $Array(message.fontFaces.length);
            for (let j = 0; j < message.fontFaces.length; ++j)
                object.fontFaces[j] = $root.FontFace.toObject(message.fontFaces[j], options, _depth + 1);
        }
        if (message.baseRadius != null && $Object.hasOwnProperty.call(message, "baseRadius"))
            object.baseRadius = message.baseRadius;
        if (message.borderColor != null && $Object.hasOwnProperty.call(message, "borderColor"))
            object.borderColor = message.borderColor;
        if (message.showWidgetBorder != null && $Object.hasOwnProperty.call(message, "showWidgetBorder"))
            object.showWidgetBorder = message.showWidgetBorder;
        if (message.linkColor != null && $Object.hasOwnProperty.call(message, "linkColor"))
            object.linkColor = message.linkColor;
        if (message.baseFontSize != null && $Object.hasOwnProperty.call(message, "baseFontSize"))
            object.baseFontSize = message.baseFontSize;
        if (message.showSidebarBorder != null && $Object.hasOwnProperty.call(message, "showSidebarBorder"))
            object.showSidebarBorder = message.showSidebarBorder;
        if (message.sidebar != null && $Object.hasOwnProperty.call(message, "sidebar"))
            object.sidebar = $root.CustomThemeConfig.toObject(message.sidebar, options, _depth + 1);
        if (message.codeBackgroundColor != null && $Object.hasOwnProperty.call(message, "codeBackgroundColor"))
            object.codeBackgroundColor = message.codeBackgroundColor;
        if (message.buttonRadius != null && $Object.hasOwnProperty.call(message, "buttonRadius"))
            object.buttonRadius = message.buttonRadius;
        if (message.dataframeBorderColor != null && $Object.hasOwnProperty.call(message, "dataframeBorderColor"))
            object.dataframeBorderColor = message.dataframeBorderColor;
        if (message.codeFontSize != null && $Object.hasOwnProperty.call(message, "codeFontSize"))
            object.codeFontSize = message.codeFontSize;
        if (message.linkUnderline != null && $Object.hasOwnProperty.call(message, "linkUnderline"))
            object.linkUnderline = message.linkUnderline;
        if (message.baseFontWeight != null && $Object.hasOwnProperty.call(message, "baseFontWeight"))
            object.baseFontWeight = message.baseFontWeight;
        if (message.dataframeHeaderBackgroundColor != null && $Object.hasOwnProperty.call(message, "dataframeHeaderBackgroundColor"))
            object.dataframeHeaderBackgroundColor = message.dataframeHeaderBackgroundColor;
        if (message.codeFontWeight != null && $Object.hasOwnProperty.call(message, "codeFontWeight"))
            object.codeFontWeight = message.codeFontWeight;
        if (message.chartCategoricalColors && message.chartCategoricalColors.length) {
            object.chartCategoricalColors = $Array(message.chartCategoricalColors.length);
            for (let j = 0; j < message.chartCategoricalColors.length; ++j)
                object.chartCategoricalColors[j] = message.chartCategoricalColors[j];
        }
        if (message.headingFontWeights && message.headingFontWeights.length) {
            object.headingFontWeights = $Array(message.headingFontWeights.length);
            for (let j = 0; j < message.headingFontWeights.length; ++j)
                object.headingFontWeights[j] = message.headingFontWeights[j];
        }
        if (message.headingFontSizes && message.headingFontSizes.length) {
            object.headingFontSizes = $Array(message.headingFontSizes.length);
            for (let j = 0; j < message.headingFontSizes.length; ++j)
                object.headingFontSizes[j] = message.headingFontSizes[j];
        }
        if (message.chartSequentialColors && message.chartSequentialColors.length) {
            object.chartSequentialColors = $Array(message.chartSequentialColors.length);
            for (let j = 0; j < message.chartSequentialColors.length; ++j)
                object.chartSequentialColors[j] = message.chartSequentialColors[j];
        }
        if (message.fontSources && message.fontSources.length) {
            object.fontSources = $Array(message.fontSources.length);
            for (let j = 0; j < message.fontSources.length; ++j)
                object.fontSources[j] = $root.FontSource.toObject(message.fontSources[j], options, _depth + 1);
        }
        if (message.redColor != null && $Object.hasOwnProperty.call(message, "redColor"))
            object.redColor = message.redColor;
        if (message.orangeColor != null && $Object.hasOwnProperty.call(message, "orangeColor"))
            object.orangeColor = message.orangeColor;
        if (message.yellowColor != null && $Object.hasOwnProperty.call(message, "yellowColor"))
            object.yellowColor = message.yellowColor;
        if (message.blueColor != null && $Object.hasOwnProperty.call(message, "blueColor"))
            object.blueColor = message.blueColor;
        if (message.greenColor != null && $Object.hasOwnProperty.call(message, "greenColor"))
            object.greenColor = message.greenColor;
        if (message.violetColor != null && $Object.hasOwnProperty.call(message, "violetColor"))
            object.violetColor = message.violetColor;
        if (message.grayColor != null && $Object.hasOwnProperty.call(message, "grayColor"))
            object.grayColor = message.grayColor;
        if (message.redBackgroundColor != null && $Object.hasOwnProperty.call(message, "redBackgroundColor"))
            object.redBackgroundColor = message.redBackgroundColor;
        if (message.orangeBackgroundColor != null && $Object.hasOwnProperty.call(message, "orangeBackgroundColor"))
            object.orangeBackgroundColor = message.orangeBackgroundColor;
        if (message.yellowBackgroundColor != null && $Object.hasOwnProperty.call(message, "yellowBackgroundColor"))
            object.yellowBackgroundColor = message.yellowBackgroundColor;
        if (message.blueBackgroundColor != null && $Object.hasOwnProperty.call(message, "blueBackgroundColor"))
            object.blueBackgroundColor = message.blueBackgroundColor;
        if (message.greenBackgroundColor != null && $Object.hasOwnProperty.call(message, "greenBackgroundColor"))
            object.greenBackgroundColor = message.greenBackgroundColor;
        if (message.violetBackgroundColor != null && $Object.hasOwnProperty.call(message, "violetBackgroundColor"))
            object.violetBackgroundColor = message.violetBackgroundColor;
        if (message.grayBackgroundColor != null && $Object.hasOwnProperty.call(message, "grayBackgroundColor"))
            object.grayBackgroundColor = message.grayBackgroundColor;
        if (message.redTextColor != null && $Object.hasOwnProperty.call(message, "redTextColor"))
            object.redTextColor = message.redTextColor;
        if (message.orangeTextColor != null && $Object.hasOwnProperty.call(message, "orangeTextColor"))
            object.orangeTextColor = message.orangeTextColor;
        if (message.yellowTextColor != null && $Object.hasOwnProperty.call(message, "yellowTextColor"))
            object.yellowTextColor = message.yellowTextColor;
        if (message.blueTextColor != null && $Object.hasOwnProperty.call(message, "blueTextColor"))
            object.blueTextColor = message.blueTextColor;
        if (message.greenTextColor != null && $Object.hasOwnProperty.call(message, "greenTextColor"))
            object.greenTextColor = message.greenTextColor;
        if (message.violetTextColor != null && $Object.hasOwnProperty.call(message, "violetTextColor"))
            object.violetTextColor = message.violetTextColor;
        if (message.grayTextColor != null && $Object.hasOwnProperty.call(message, "grayTextColor"))
            object.grayTextColor = message.grayTextColor;
        if (message.codeTextColor != null && $Object.hasOwnProperty.call(message, "codeTextColor"))
            object.codeTextColor = message.codeTextColor;
        if (message.light != null && $Object.hasOwnProperty.call(message, "light"))
            object.light = $root.CustomThemeConfig.toObject(message.light, options, _depth + 1);
        if (message.dark != null && $Object.hasOwnProperty.call(message, "dark"))
            object.dark = $root.CustomThemeConfig.toObject(message.dark, options, _depth + 1);
        if (message.chartDivergingColors && message.chartDivergingColors.length) {
            object.chartDivergingColors = $Array(message.chartDivergingColors.length);
            for (let j = 0; j < message.chartDivergingColors.length; ++j)
                object.chartDivergingColors[j] = message.chartDivergingColors[j];
        }
        if (message.metricValueFontSize != null && $Object.hasOwnProperty.call(message, "metricValueFontSize"))
            object.metricValueFontSize = message.metricValueFontSize;
        if (message.metricValueFontWeight != null && $Object.hasOwnProperty.call(message, "metricValueFontWeight"))
            object.metricValueFontWeight = message.metricValueFontWeight;
        if (message.dataframeHeaderTextColor != null && $Object.hasOwnProperty.call(message, "dataframeHeaderTextColor"))
            object.dataframeHeaderTextColor = message.dataframeHeaderTextColor;
        return object;
    };

    /**
     * Converts this CustomThemeConfig to JSON.
     * @function toJSON
     * @memberof CustomThemeConfig
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CustomThemeConfig.prototype.toJSON = function() {
        return CustomThemeConfig.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for CustomThemeConfig
     * @function getTypeUrl
     * @memberof CustomThemeConfig
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    CustomThemeConfig.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/CustomThemeConfig";
    };

    /**
     * BaseTheme enum.
     * @name CustomThemeConfig.BaseTheme
     * @enum {number}
     * @property {number} LIGHT=0 LIGHT value
     * @property {number} DARK=1 DARK value
     */
    CustomThemeConfig.BaseTheme = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "LIGHT"] = 0;
        values[valuesById[1] = "DARK"] = 1;
        return values;
    })();

    return CustomThemeConfig;
})();

export const FontFace = $root.FontFace = (() => {

    /**
     * Properties of a FontFace.
     * @typedef {Object} FontFace.$Properties
     * @property {string|null} [url] FontFace url
     * @property {string|null} [family] FontFace family
     * @property {string|null} [weightRange] FontFace weightRange
     * @property {string|null} [style] FontFace style
     * @property {string|null} [unicodeRange] FontFace unicodeRange
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a FontFace.
     * @exports IFontFace
     * @interface IFontFace
     * @augments FontFace.$Properties
     * @deprecated Use FontFace.$Properties instead.
     */

    /**
     * Shape of a FontFace.
     * @typedef {FontFace.$Properties} FontFace.$Shape
     */

    /**
     * Constructs a new FontFace.
     * @exports FontFace
     * @classdesc Represents a FontFace.
     * @constructor
     * @param {FontFace.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const FontFace = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * FontFace url.
     * @member {string} url
     * @memberof FontFace
     * @instance
     */
    FontFace.prototype.url = "";

    /**
     * FontFace family.
     * @member {string} family
     * @memberof FontFace
     * @instance
     */
    FontFace.prototype.family = "";

    /**
     * FontFace weightRange.
     * @member {string} weightRange
     * @memberof FontFace
     * @instance
     */
    FontFace.prototype.weightRange = "";

    /**
     * FontFace style.
     * @member {string} style
     * @memberof FontFace
     * @instance
     */
    FontFace.prototype.style = "";

    /**
     * FontFace unicodeRange.
     * @member {string} unicodeRange
     * @memberof FontFace
     * @instance
     */
    FontFace.prototype.unicodeRange = "";

    /**
     * Creates a new FontFace instance using the specified properties.
     * @function create
     * @memberof FontFace
     * @static
     * @param {FontFace.$Properties=} [properties] Properties to set
     * @returns {FontFace} FontFace instance
     * @type {{
     *   (properties: FontFace.$Shape): FontFace & FontFace.$Shape;
     *   (properties?: FontFace.$Properties): FontFace;
     * }}
     */
    FontFace.create = function(properties) {
        return new FontFace(properties);
    };

    /**
     * Encodes the specified FontFace message. Does not implicitly {@link FontFace.verify|verify} messages.
     * @function encode
     * @memberof FontFace
     * @static
     * @param {FontFace.$Properties} message FontFace message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FontFace.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.url != null && $Object.hasOwnProperty.call(message, "url") && message.url !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
        if (message.family != null && $Object.hasOwnProperty.call(message, "family") && message.family !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.family);
        if (message.style != null && $Object.hasOwnProperty.call(message, "style") && message.style !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.style);
        if (message.weightRange != null && $Object.hasOwnProperty.call(message, "weightRange") && message.weightRange !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.weightRange);
        if (message.unicodeRange != null && $Object.hasOwnProperty.call(message, "unicodeRange") && message.unicodeRange !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.unicodeRange);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a FontFace message from the specified reader or buffer.
     * @function decode
     * @memberof FontFace
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FontFace & FontFace.$Shape} FontFace
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FontFace.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.FontFace();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.url = value;
                    else
                        delete message.url;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.family = value;
                    else
                        delete message.family;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.weightRange = value;
                    else
                        delete message.weightRange;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.style = value;
                    else
                        delete message.style;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.unicodeRange = value;
                    else
                        delete message.unicodeRange;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a FontFace message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FontFace
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FontFace} FontFace
     */
    FontFace.fromObject = function (object, _depth) {
        if (object instanceof $root.FontFace)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".FontFace: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.FontFace();
        if (object.url != null)
            if (typeof object.url !== "string" || object.url.length)
                message.url = $String(object.url);
        if (object.family != null)
            if (typeof object.family !== "string" || object.family.length)
                message.family = $String(object.family);
        if (object.weightRange != null)
            if (typeof object.weightRange !== "string" || object.weightRange.length)
                message.weightRange = $String(object.weightRange);
        if (object.style != null)
            if (typeof object.style !== "string" || object.style.length)
                message.style = $String(object.style);
        if (object.unicodeRange != null)
            if (typeof object.unicodeRange !== "string" || object.unicodeRange.length)
                message.unicodeRange = $String(object.unicodeRange);
        return message;
    };

    /**
     * Creates a plain object from a FontFace message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FontFace
     * @static
     * @param {FontFace} message FontFace
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FontFace.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.url = "";
            object.family = "";
            object.style = "";
            object.weightRange = "";
            object.unicodeRange = "";
        }
        if (message.url != null && $Object.hasOwnProperty.call(message, "url"))
            object.url = message.url;
        if (message.family != null && $Object.hasOwnProperty.call(message, "family"))
            object.family = message.family;
        if (message.style != null && $Object.hasOwnProperty.call(message, "style"))
            object.style = message.style;
        if (message.weightRange != null && $Object.hasOwnProperty.call(message, "weightRange"))
            object.weightRange = message.weightRange;
        if (message.unicodeRange != null && $Object.hasOwnProperty.call(message, "unicodeRange"))
            object.unicodeRange = message.unicodeRange;
        return object;
    };

    /**
     * Converts this FontFace to JSON.
     * @function toJSON
     * @memberof FontFace
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FontFace.prototype.toJSON = function() {
        return FontFace.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for FontFace
     * @function getTypeUrl
     * @memberof FontFace
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    FontFace.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/FontFace";
    };

    return FontFace;
})();

export const FontSource = $root.FontSource = (() => {

    /**
     * Properties of a FontSource.
     * @typedef {Object} FontSource.$Properties
     * @property {string|null} [configName] FontSource configName
     * @property {string|null} [sourceUrl] FontSource sourceUrl
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a FontSource.
     * @exports IFontSource
     * @interface IFontSource
     * @augments FontSource.$Properties
     * @deprecated Use FontSource.$Properties instead.
     */

    /**
     * Shape of a FontSource.
     * @typedef {FontSource.$Properties} FontSource.$Shape
     */

    /**
     * Constructs a new FontSource.
     * @exports FontSource
     * @classdesc Represents a FontSource.
     * @constructor
     * @param {FontSource.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const FontSource = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * FontSource configName.
     * @member {string} configName
     * @memberof FontSource
     * @instance
     */
    FontSource.prototype.configName = "";

    /**
     * FontSource sourceUrl.
     * @member {string} sourceUrl
     * @memberof FontSource
     * @instance
     */
    FontSource.prototype.sourceUrl = "";

    /**
     * Creates a new FontSource instance using the specified properties.
     * @function create
     * @memberof FontSource
     * @static
     * @param {FontSource.$Properties=} [properties] Properties to set
     * @returns {FontSource} FontSource instance
     * @type {{
     *   (properties: FontSource.$Shape): FontSource & FontSource.$Shape;
     *   (properties?: FontSource.$Properties): FontSource;
     * }}
     */
    FontSource.create = function(properties) {
        return new FontSource(properties);
    };

    /**
     * Encodes the specified FontSource message. Does not implicitly {@link FontSource.verify|verify} messages.
     * @function encode
     * @memberof FontSource
     * @static
     * @param {FontSource.$Properties} message FontSource message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FontSource.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.configName != null && $Object.hasOwnProperty.call(message, "configName") && message.configName !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.configName);
        if (message.sourceUrl != null && $Object.hasOwnProperty.call(message, "sourceUrl") && message.sourceUrl !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.sourceUrl);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a FontSource message from the specified reader or buffer.
     * @function decode
     * @memberof FontSource
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FontSource & FontSource.$Shape} FontSource
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FontSource.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.FontSource();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.configName = value;
                    else
                        delete message.configName;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.sourceUrl = value;
                    else
                        delete message.sourceUrl;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a FontSource message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FontSource
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FontSource} FontSource
     */
    FontSource.fromObject = function (object, _depth) {
        if (object instanceof $root.FontSource)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".FontSource: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.FontSource();
        if (object.configName != null)
            if (typeof object.configName !== "string" || object.configName.length)
                message.configName = $String(object.configName);
        if (object.sourceUrl != null)
            if (typeof object.sourceUrl !== "string" || object.sourceUrl.length)
                message.sourceUrl = $String(object.sourceUrl);
        return message;
    };

    /**
     * Creates a plain object from a FontSource message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FontSource
     * @static
     * @param {FontSource} message FontSource
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FontSource.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.configName = "";
            object.sourceUrl = "";
        }
        if (message.configName != null && $Object.hasOwnProperty.call(message, "configName"))
            object.configName = message.configName;
        if (message.sourceUrl != null && $Object.hasOwnProperty.call(message, "sourceUrl"))
            object.sourceUrl = message.sourceUrl;
        return object;
    };

    /**
     * Converts this FontSource to JSON.
     * @function toJSON
     * @memberof FontSource
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FontSource.prototype.toJSON = function() {
        return FontSource.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for FontSource
     * @function getTypeUrl
     * @memberof FontSource
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    FontSource.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/FontSource";
    };

    return FontSource;
})();

export const UserInfo = $root.UserInfo = (() => {

    /**
     * Properties of a UserInfo.
     * @typedef {Object} UserInfo.$Properties
     * @property {string|null} [installationId] UserInfo installationId
     * @property {string|null} [installationIdV3] UserInfo installationIdV3
     * @property {string|null} [installationIdV4] UserInfo installationIdV4
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a UserInfo.
     * @exports IUserInfo
     * @interface IUserInfo
     * @augments UserInfo.$Properties
     * @deprecated Use UserInfo.$Properties instead.
     */

    /**
     * Shape of a UserInfo.
     * @typedef {UserInfo.$Properties} UserInfo.$Shape
     */

    /**
     * Constructs a new UserInfo.
     * @exports UserInfo
     * @classdesc Represents a UserInfo.
     * @constructor
     * @param {UserInfo.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const UserInfo = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * UserInfo installationId.
     * @member {string} installationId
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.installationId = "";

    /**
     * UserInfo installationIdV3.
     * @member {string} installationIdV3
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.installationIdV3 = "";

    /**
     * UserInfo installationIdV4.
     * @member {string} installationIdV4
     * @memberof UserInfo
     * @instance
     */
    UserInfo.prototype.installationIdV4 = "";

    /**
     * Creates a new UserInfo instance using the specified properties.
     * @function create
     * @memberof UserInfo
     * @static
     * @param {UserInfo.$Properties=} [properties] Properties to set
     * @returns {UserInfo} UserInfo instance
     * @type {{
     *   (properties: UserInfo.$Shape): UserInfo & UserInfo.$Shape;
     *   (properties?: UserInfo.$Properties): UserInfo;
     * }}
     */
    UserInfo.create = function(properties) {
        return new UserInfo(properties);
    };

    /**
     * Encodes the specified UserInfo message. Does not implicitly {@link UserInfo.verify|verify} messages.
     * @function encode
     * @memberof UserInfo
     * @static
     * @param {UserInfo.$Properties} message UserInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserInfo.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.installationId != null && $Object.hasOwnProperty.call(message, "installationId") && message.installationId !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.installationId);
        if (message.installationIdV3 != null && $Object.hasOwnProperty.call(message, "installationIdV3") && message.installationIdV3 !== "")
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.installationIdV3);
        if (message.installationIdV4 != null && $Object.hasOwnProperty.call(message, "installationIdV4") && message.installationIdV4 !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.installationIdV4);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a UserInfo message from the specified reader or buffer.
     * @function decode
     * @memberof UserInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserInfo & UserInfo.$Shape} UserInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserInfo.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.UserInfo();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.installationId = value;
                    else
                        delete message.installationId;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.installationIdV3 = value;
                    else
                        delete message.installationIdV3;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.installationIdV4 = value;
                    else
                        delete message.installationIdV4;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a UserInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserInfo} UserInfo
     */
    UserInfo.fromObject = function (object, _depth) {
        if (object instanceof $root.UserInfo)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".UserInfo: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.UserInfo();
        if (object.installationId != null)
            if (typeof object.installationId !== "string" || object.installationId.length)
                message.installationId = $String(object.installationId);
        if (object.installationIdV3 != null)
            if (typeof object.installationIdV3 !== "string" || object.installationIdV3.length)
                message.installationIdV3 = $String(object.installationIdV3);
        if (object.installationIdV4 != null)
            if (typeof object.installationIdV4 !== "string" || object.installationIdV4.length)
                message.installationIdV4 = $String(object.installationIdV4);
        return message;
    };

    /**
     * Creates a plain object from a UserInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserInfo
     * @static
     * @param {UserInfo} message UserInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserInfo.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.installationId = "";
            object.installationIdV3 = "";
            object.installationIdV4 = "";
        }
        if (message.installationId != null && $Object.hasOwnProperty.call(message, "installationId"))
            object.installationId = message.installationId;
        if (message.installationIdV3 != null && $Object.hasOwnProperty.call(message, "installationIdV3"))
            object.installationIdV3 = message.installationIdV3;
        if (message.installationIdV4 != null && $Object.hasOwnProperty.call(message, "installationIdV4"))
            object.installationIdV4 = message.installationIdV4;
        return object;
    };

    /**
     * Converts this UserInfo to JSON.
     * @function toJSON
     * @memberof UserInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserInfo.prototype.toJSON = function() {
        return UserInfo.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for UserInfo
     * @function getTypeUrl
     * @memberof UserInfo
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    UserInfo.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/UserInfo";
    };

    return UserInfo;
})();

export const EnvironmentInfo = $root.EnvironmentInfo = (() => {

    /**
     * Properties of an EnvironmentInfo.
     * @typedef {Object} EnvironmentInfo.$Properties
     * @property {string|null} [streamlitVersion] EnvironmentInfo streamlitVersion
     * @property {string|null} [pythonVersion] EnvironmentInfo pythonVersion
     * @property {string|null} [serverOs] EnvironmentInfo serverOs
     * @property {boolean|null} [hasDisplay] EnvironmentInfo hasDisplay
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an EnvironmentInfo.
     * @exports IEnvironmentInfo
     * @interface IEnvironmentInfo
     * @augments EnvironmentInfo.$Properties
     * @deprecated Use EnvironmentInfo.$Properties instead.
     */

    /**
     * Shape of an EnvironmentInfo.
     * @typedef {EnvironmentInfo.$Properties} EnvironmentInfo.$Shape
     */

    /**
     * Constructs a new EnvironmentInfo.
     * @exports EnvironmentInfo
     * @classdesc Represents an EnvironmentInfo.
     * @constructor
     * @param {EnvironmentInfo.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const EnvironmentInfo = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * EnvironmentInfo streamlitVersion.
     * @member {string} streamlitVersion
     * @memberof EnvironmentInfo
     * @instance
     */
    EnvironmentInfo.prototype.streamlitVersion = "";

    /**
     * EnvironmentInfo pythonVersion.
     * @member {string} pythonVersion
     * @memberof EnvironmentInfo
     * @instance
     */
    EnvironmentInfo.prototype.pythonVersion = "";

    /**
     * EnvironmentInfo serverOs.
     * @member {string} serverOs
     * @memberof EnvironmentInfo
     * @instance
     */
    EnvironmentInfo.prototype.serverOs = "";

    /**
     * EnvironmentInfo hasDisplay.
     * @member {boolean} hasDisplay
     * @memberof EnvironmentInfo
     * @instance
     */
    EnvironmentInfo.prototype.hasDisplay = false;

    /**
     * Creates a new EnvironmentInfo instance using the specified properties.
     * @function create
     * @memberof EnvironmentInfo
     * @static
     * @param {EnvironmentInfo.$Properties=} [properties] Properties to set
     * @returns {EnvironmentInfo} EnvironmentInfo instance
     * @type {{
     *   (properties: EnvironmentInfo.$Shape): EnvironmentInfo & EnvironmentInfo.$Shape;
     *   (properties?: EnvironmentInfo.$Properties): EnvironmentInfo;
     * }}
     */
    EnvironmentInfo.create = function(properties) {
        return new EnvironmentInfo(properties);
    };

    /**
     * Encodes the specified EnvironmentInfo message. Does not implicitly {@link EnvironmentInfo.verify|verify} messages.
     * @function encode
     * @memberof EnvironmentInfo
     * @static
     * @param {EnvironmentInfo.$Properties} message EnvironmentInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EnvironmentInfo.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.streamlitVersion != null && $Object.hasOwnProperty.call(message, "streamlitVersion") && message.streamlitVersion !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.streamlitVersion);
        if (message.pythonVersion != null && $Object.hasOwnProperty.call(message, "pythonVersion") && message.pythonVersion !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pythonVersion);
        if (message.serverOs != null && $Object.hasOwnProperty.call(message, "serverOs") && message.serverOs !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.serverOs);
        if (message.hasDisplay != null && $Object.hasOwnProperty.call(message, "hasDisplay") && message.hasDisplay !== false)
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.hasDisplay);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an EnvironmentInfo message from the specified reader or buffer.
     * @function decode
     * @memberof EnvironmentInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EnvironmentInfo & EnvironmentInfo.$Shape} EnvironmentInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EnvironmentInfo.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.EnvironmentInfo();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.streamlitVersion = value;
                    else
                        delete message.streamlitVersion;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pythonVersion = value;
                    else
                        delete message.pythonVersion;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.serverOs = value;
                    else
                        delete message.serverOs;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hasDisplay = value;
                    else
                        delete message.hasDisplay;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an EnvironmentInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EnvironmentInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EnvironmentInfo} EnvironmentInfo
     */
    EnvironmentInfo.fromObject = function (object, _depth) {
        if (object instanceof $root.EnvironmentInfo)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".EnvironmentInfo: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.EnvironmentInfo();
        if (object.streamlitVersion != null)
            if (typeof object.streamlitVersion !== "string" || object.streamlitVersion.length)
                message.streamlitVersion = $String(object.streamlitVersion);
        if (object.pythonVersion != null)
            if (typeof object.pythonVersion !== "string" || object.pythonVersion.length)
                message.pythonVersion = $String(object.pythonVersion);
        if (object.serverOs != null)
            if (typeof object.serverOs !== "string" || object.serverOs.length)
                message.serverOs = $String(object.serverOs);
        if (object.hasDisplay != null)
            if (object.hasDisplay)
                message.hasDisplay = $Boolean(object.hasDisplay);
        return message;
    };

    /**
     * Creates a plain object from an EnvironmentInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EnvironmentInfo
     * @static
     * @param {EnvironmentInfo} message EnvironmentInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EnvironmentInfo.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.streamlitVersion = "";
            object.pythonVersion = "";
            object.serverOs = "";
            object.hasDisplay = false;
        }
        if (message.streamlitVersion != null && $Object.hasOwnProperty.call(message, "streamlitVersion"))
            object.streamlitVersion = message.streamlitVersion;
        if (message.pythonVersion != null && $Object.hasOwnProperty.call(message, "pythonVersion"))
            object.pythonVersion = message.pythonVersion;
        if (message.serverOs != null && $Object.hasOwnProperty.call(message, "serverOs"))
            object.serverOs = message.serverOs;
        if (message.hasDisplay != null && $Object.hasOwnProperty.call(message, "hasDisplay"))
            object.hasDisplay = message.hasDisplay;
        return object;
    };

    /**
     * Converts this EnvironmentInfo to JSON.
     * @function toJSON
     * @memberof EnvironmentInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EnvironmentInfo.prototype.toJSON = function() {
        return EnvironmentInfo.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for EnvironmentInfo
     * @function getTypeUrl
     * @memberof EnvironmentInfo
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    EnvironmentInfo.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/EnvironmentInfo";
    };

    return EnvironmentInfo;
})();

export const SessionStatus = $root.SessionStatus = (() => {

    /**
     * Properties of a SessionStatus.
     * @typedef {Object} SessionStatus.$Properties
     * @property {boolean|null} [runOnSave] SessionStatus runOnSave
     * @property {boolean|null} [scriptIsRunning] SessionStatus scriptIsRunning
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a SessionStatus.
     * @exports ISessionStatus
     * @interface ISessionStatus
     * @augments SessionStatus.$Properties
     * @deprecated Use SessionStatus.$Properties instead.
     */

    /**
     * Shape of a SessionStatus.
     * @typedef {SessionStatus.$Properties} SessionStatus.$Shape
     */

    /**
     * Constructs a new SessionStatus.
     * @exports SessionStatus
     * @classdesc Represents a SessionStatus.
     * @constructor
     * @param {SessionStatus.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const SessionStatus = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * SessionStatus runOnSave.
     * @member {boolean} runOnSave
     * @memberof SessionStatus
     * @instance
     */
    SessionStatus.prototype.runOnSave = false;

    /**
     * SessionStatus scriptIsRunning.
     * @member {boolean} scriptIsRunning
     * @memberof SessionStatus
     * @instance
     */
    SessionStatus.prototype.scriptIsRunning = false;

    /**
     * Creates a new SessionStatus instance using the specified properties.
     * @function create
     * @memberof SessionStatus
     * @static
     * @param {SessionStatus.$Properties=} [properties] Properties to set
     * @returns {SessionStatus} SessionStatus instance
     * @type {{
     *   (properties: SessionStatus.$Shape): SessionStatus & SessionStatus.$Shape;
     *   (properties?: SessionStatus.$Properties): SessionStatus;
     * }}
     */
    SessionStatus.create = function(properties) {
        return new SessionStatus(properties);
    };

    /**
     * Encodes the specified SessionStatus message. Does not implicitly {@link SessionStatus.verify|verify} messages.
     * @function encode
     * @memberof SessionStatus
     * @static
     * @param {SessionStatus.$Properties} message SessionStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SessionStatus.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.runOnSave != null && $Object.hasOwnProperty.call(message, "runOnSave") && message.runOnSave !== false)
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.runOnSave);
        if (message.scriptIsRunning != null && $Object.hasOwnProperty.call(message, "scriptIsRunning") && message.scriptIsRunning !== false)
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.scriptIsRunning);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a SessionStatus message from the specified reader or buffer.
     * @function decode
     * @memberof SessionStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SessionStatus & SessionStatus.$Shape} SessionStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SessionStatus.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.SessionStatus();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.runOnSave = value;
                    else
                        delete message.runOnSave;
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.scriptIsRunning = value;
                    else
                        delete message.scriptIsRunning;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a SessionStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SessionStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SessionStatus} SessionStatus
     */
    SessionStatus.fromObject = function (object, _depth) {
        if (object instanceof $root.SessionStatus)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".SessionStatus: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.SessionStatus();
        if (object.runOnSave != null)
            if (object.runOnSave)
                message.runOnSave = $Boolean(object.runOnSave);
        if (object.scriptIsRunning != null)
            if (object.scriptIsRunning)
                message.scriptIsRunning = $Boolean(object.scriptIsRunning);
        return message;
    };

    /**
     * Creates a plain object from a SessionStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SessionStatus
     * @static
     * @param {SessionStatus} message SessionStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SessionStatus.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.runOnSave = false;
            object.scriptIsRunning = false;
        }
        if (message.runOnSave != null && $Object.hasOwnProperty.call(message, "runOnSave"))
            object.runOnSave = message.runOnSave;
        if (message.scriptIsRunning != null && $Object.hasOwnProperty.call(message, "scriptIsRunning"))
            object.scriptIsRunning = message.scriptIsRunning;
        return object;
    };

    /**
     * Converts this SessionStatus to JSON.
     * @function toJSON
     * @memberof SessionStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SessionStatus.prototype.toJSON = function() {
        return SessionStatus.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for SessionStatus
     * @function getTypeUrl
     * @memberof SessionStatus
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    SessionStatus.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/SessionStatus";
    };

    return SessionStatus;
})();

export const PageConfig = $root.PageConfig = (() => {

    /**
     * Properties of a PageConfig.
     * @typedef {Object} PageConfig.$Properties
     * @property {string|null} [title] PageConfig title
     * @property {string|null} [favicon] PageConfig favicon
     * @property {PageConfig.Layout|null} [layout] PageConfig layout
     * @property {PageConfig.SidebarState|null} [initialSidebarState] PageConfig initialSidebarState
     * @property {PageConfig.MenuItems.$Properties|null} [menuItems] PageConfig menuItems
     * @property {PageConfig.SidebarWidthConfig.$Properties|null} [initialSidebarWidth] PageConfig initialSidebarWidth
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a PageConfig.
     * @exports IPageConfig
     * @interface IPageConfig
     * @augments PageConfig.$Properties
     * @deprecated Use PageConfig.$Properties instead.
     */

    /**
     * Shape of a PageConfig.
     * @typedef {{
     *   title?: string|null;
     *   favicon?: string|null;
     *   layout?: PageConfig.Layout|null;
     *   initialSidebarState?: PageConfig.SidebarState|null;
     *   menuItems?: PageConfig.MenuItems.$Shape|null;
     *   initialSidebarWidth?: PageConfig.SidebarWidthConfig.$Shape|null;
     *   $unknowns?: Array.<Uint8Array>;
     * }} PageConfig.$Shape
     */

    /**
     * Constructs a new PageConfig.
     * @exports PageConfig
     * @classdesc Represents a PageConfig.
     * @constructor
     * @param {PageConfig.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const PageConfig = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * PageConfig title.
     * @member {string} title
     * @memberof PageConfig
     * @instance
     */
    PageConfig.prototype.title = "";

    /**
     * PageConfig favicon.
     * @member {string} favicon
     * @memberof PageConfig
     * @instance
     */
    PageConfig.prototype.favicon = "";

    /**
     * PageConfig layout.
     * @member {PageConfig.Layout} layout
     * @memberof PageConfig
     * @instance
     */
    PageConfig.prototype.layout = 0;

    /**
     * PageConfig initialSidebarState.
     * @member {PageConfig.SidebarState} initialSidebarState
     * @memberof PageConfig
     * @instance
     */
    PageConfig.prototype.initialSidebarState = 0;

    /**
     * PageConfig menuItems.
     * @member {PageConfig.MenuItems.$Properties|null|undefined} menuItems
     * @memberof PageConfig
     * @instance
     */
    PageConfig.prototype.menuItems = null;

    /**
     * PageConfig initialSidebarWidth.
     * @member {PageConfig.SidebarWidthConfig.$Properties|null|undefined} initialSidebarWidth
     * @memberof PageConfig
     * @instance
     */
    PageConfig.prototype.initialSidebarWidth = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    // Virtual OneOf for proto3 optional field
    $Object.defineProperty(PageConfig.prototype, "_initialSidebarWidth", {
        get: $util.oneOfGetter($oneOfFields = ["initialSidebarWidth"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new PageConfig instance using the specified properties.
     * @function create
     * @memberof PageConfig
     * @static
     * @param {PageConfig.$Properties=} [properties] Properties to set
     * @returns {PageConfig} PageConfig instance
     * @type {{
     *   (properties: PageConfig.$Shape): PageConfig & PageConfig.$Shape;
     *   (properties?: PageConfig.$Properties): PageConfig;
     * }}
     */
    PageConfig.create = function(properties) {
        return new PageConfig(properties);
    };

    /**
     * Encodes the specified PageConfig message. Does not implicitly {@link PageConfig.verify|verify} messages.
     * @function encode
     * @memberof PageConfig
     * @static
     * @param {PageConfig.$Properties} message PageConfig message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageConfig.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.title != null && $Object.hasOwnProperty.call(message, "title") && message.title !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
        if (message.favicon != null && $Object.hasOwnProperty.call(message, "favicon") && message.favicon !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.favicon);
        if (message.layout != null && $Object.hasOwnProperty.call(message, "layout") && message.layout !== 0)
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.layout);
        if (message.initialSidebarState != null && $Object.hasOwnProperty.call(message, "initialSidebarState") && message.initialSidebarState !== 0)
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.initialSidebarState);
        if (message.menuItems != null && $Object.hasOwnProperty.call(message, "menuItems"))
            $root.PageConfig.MenuItems.encode(message.menuItems, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
        if (message.initialSidebarWidth != null && $Object.hasOwnProperty.call(message, "initialSidebarWidth"))
            $root.PageConfig.SidebarWidthConfig.encode(message.initialSidebarWidth, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a PageConfig message from the specified reader or buffer.
     * @function decode
     * @memberof PageConfig
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PageConfig & PageConfig.$Shape} PageConfig
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageConfig.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.PageConfig();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.title = value;
                    else
                        delete message.title;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.favicon = value;
                    else
                        delete message.favicon;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.layout = value;
                    else
                        delete message.layout;
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.initialSidebarState = value;
                    else
                        delete message.initialSidebarState;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    message.menuItems = $root.PageConfig.MenuItems.decode(reader, reader.uint32(), $undefined, _depth + 1, message.menuItems);
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    message.initialSidebarWidth = $root.PageConfig.SidebarWidthConfig.decode(reader, reader.uint32(), $undefined, _depth + 1, message.initialSidebarWidth);
                    message._initialSidebarWidth = "initialSidebarWidth";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a PageConfig message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PageConfig
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PageConfig} PageConfig
     */
    PageConfig.fromObject = function (object, _depth) {
        if (object instanceof $root.PageConfig)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".PageConfig: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.PageConfig();
        if (object.title != null)
            if (typeof object.title !== "string" || object.title.length)
                message.title = $String(object.title);
        if (object.favicon != null)
            if (typeof object.favicon !== "string" || object.favicon.length)
                message.favicon = $String(object.favicon);
        if (object.layout !== 0 && (typeof object.layout !== "string" || $root.PageConfig.Layout[object.layout] !== 0))
            switch (object.layout) {
            case "CENTERED":
            case 0:
                message.layout = 0;
                break;
            case "WIDE":
            case 1:
                message.layout = 1;
                break;
            case "LAYOUT_UNSET":
            case 2:
                message.layout = 2;
                break;
            default:
                if (typeof object.layout === "number" && (object.layout | 0) === object.layout)
                    message.layout = object.layout;
            }
        if (object.initialSidebarState !== 0 && (typeof object.initialSidebarState !== "string" || $root.PageConfig.SidebarState[object.initialSidebarState] !== 0))
            switch (object.initialSidebarState) {
            case "AUTO":
            case 0:
                message.initialSidebarState = 0;
                break;
            case "EXPANDED":
            case 1:
                message.initialSidebarState = 1;
                break;
            case "COLLAPSED":
            case 2:
                message.initialSidebarState = 2;
                break;
            case "SIDEBAR_UNSET":
            case 3:
                message.initialSidebarState = 3;
                break;
            case "LOCKED":
            case 4:
                message.initialSidebarState = 4;
                break;
            default:
                if (typeof object.initialSidebarState === "number" && (object.initialSidebarState | 0) === object.initialSidebarState)
                    message.initialSidebarState = object.initialSidebarState;
            }
        if (object.menuItems != null) {
            if (!$util.isObject(object.menuItems))
                throw $TypeError(".PageConfig.menuItems: object expected");
            message.menuItems = $root.PageConfig.MenuItems.fromObject(object.menuItems, _depth + 1);
        }
        if (object.initialSidebarWidth != null) {
            if (!$util.isObject(object.initialSidebarWidth))
                throw $TypeError(".PageConfig.initialSidebarWidth: object expected");
            message.initialSidebarWidth = $root.PageConfig.SidebarWidthConfig.fromObject(object.initialSidebarWidth, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a PageConfig message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PageConfig
     * @static
     * @param {PageConfig} message PageConfig
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PageConfig.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.title = "";
            object.favicon = "";
            object.layout = options.enums === $String ? "CENTERED" : 0;
            object.initialSidebarState = options.enums === $String ? "AUTO" : 0;
            object.menuItems = null;
        }
        if (message.title != null && $Object.hasOwnProperty.call(message, "title"))
            object.title = message.title;
        if (message.favicon != null && $Object.hasOwnProperty.call(message, "favicon"))
            object.favicon = message.favicon;
        if (message.layout != null && $Object.hasOwnProperty.call(message, "layout"))
            object.layout = options.enums === $String ? $root.PageConfig.Layout[message.layout] === $undefined ? message.layout : $root.PageConfig.Layout[message.layout] : message.layout;
        if (message.initialSidebarState != null && $Object.hasOwnProperty.call(message, "initialSidebarState"))
            object.initialSidebarState = options.enums === $String ? $root.PageConfig.SidebarState[message.initialSidebarState] === $undefined ? message.initialSidebarState : $root.PageConfig.SidebarState[message.initialSidebarState] : message.initialSidebarState;
        if (message.menuItems != null && $Object.hasOwnProperty.call(message, "menuItems"))
            object.menuItems = $root.PageConfig.MenuItems.toObject(message.menuItems, options, _depth + 1);
        if (message.initialSidebarWidth != null && $Object.hasOwnProperty.call(message, "initialSidebarWidth"))
            object.initialSidebarWidth = $root.PageConfig.SidebarWidthConfig.toObject(message.initialSidebarWidth, options, _depth + 1);
        return object;
    };

    /**
     * Converts this PageConfig to JSON.
     * @function toJSON
     * @memberof PageConfig
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PageConfig.prototype.toJSON = function() {
        return PageConfig.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for PageConfig
     * @function getTypeUrl
     * @memberof PageConfig
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    PageConfig.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/PageConfig";
    };

    PageConfig.MenuItems = (function() {

        /**
         * Properties of a MenuItems.
         * @typedef {Object} PageConfig.MenuItems.$Properties
         * @property {string|null} [getHelpUrl] MenuItems getHelpUrl
         * @property {boolean|null} [hideGetHelp] MenuItems hideGetHelp
         * @property {string|null} [reportABugUrl] MenuItems reportABugUrl
         * @property {boolean|null} [hideReportABug] MenuItems hideReportABug
         * @property {string|null} [aboutSectionMd] MenuItems aboutSectionMd
         * @property {boolean|null} [clearAboutMd] MenuItems clearAboutMd
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a MenuItems.
         * @memberof PageConfig
         * @interface IMenuItems
         * @augments PageConfig.MenuItems.$Properties
         * @deprecated Use PageConfig.MenuItems.$Properties instead.
         */

        /**
         * Shape of a MenuItems.
         * @typedef {PageConfig.MenuItems.$Properties} PageConfig.MenuItems.$Shape
         */

        /**
         * Constructs a new MenuItems.
         * @memberof PageConfig
         * @classdesc Represents a MenuItems.
         * @constructor
         * @param {PageConfig.MenuItems.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const MenuItems = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * MenuItems getHelpUrl.
         * @member {string} getHelpUrl
         * @memberof PageConfig.MenuItems
         * @instance
         */
        MenuItems.prototype.getHelpUrl = "";

        /**
         * MenuItems hideGetHelp.
         * @member {boolean} hideGetHelp
         * @memberof PageConfig.MenuItems
         * @instance
         */
        MenuItems.prototype.hideGetHelp = false;

        /**
         * MenuItems reportABugUrl.
         * @member {string} reportABugUrl
         * @memberof PageConfig.MenuItems
         * @instance
         */
        MenuItems.prototype.reportABugUrl = "";

        /**
         * MenuItems hideReportABug.
         * @member {boolean} hideReportABug
         * @memberof PageConfig.MenuItems
         * @instance
         */
        MenuItems.prototype.hideReportABug = false;

        /**
         * MenuItems aboutSectionMd.
         * @member {string} aboutSectionMd
         * @memberof PageConfig.MenuItems
         * @instance
         */
        MenuItems.prototype.aboutSectionMd = "";

        /**
         * MenuItems clearAboutMd.
         * @member {boolean} clearAboutMd
         * @memberof PageConfig.MenuItems
         * @instance
         */
        MenuItems.prototype.clearAboutMd = false;

        /**
         * Creates a new MenuItems instance using the specified properties.
         * @function create
         * @memberof PageConfig.MenuItems
         * @static
         * @param {PageConfig.MenuItems.$Properties=} [properties] Properties to set
         * @returns {PageConfig.MenuItems} MenuItems instance
         * @type {{
         *   (properties: PageConfig.MenuItems.$Shape): PageConfig.MenuItems & PageConfig.MenuItems.$Shape;
         *   (properties?: PageConfig.MenuItems.$Properties): PageConfig.MenuItems;
         * }}
         */
        MenuItems.create = function(properties) {
            return new MenuItems(properties);
        };

        /**
         * Encodes the specified MenuItems message. Does not implicitly {@link PageConfig.MenuItems.verify|verify} messages.
         * @function encode
         * @memberof PageConfig.MenuItems
         * @static
         * @param {PageConfig.MenuItems.$Properties} message MenuItems message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MenuItems.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.getHelpUrl != null && $Object.hasOwnProperty.call(message, "getHelpUrl") && message.getHelpUrl !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.getHelpUrl);
            if (message.hideGetHelp != null && $Object.hasOwnProperty.call(message, "hideGetHelp") && message.hideGetHelp !== false)
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.hideGetHelp);
            if (message.reportABugUrl != null && $Object.hasOwnProperty.call(message, "reportABugUrl") && message.reportABugUrl !== "")
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.reportABugUrl);
            if (message.hideReportABug != null && $Object.hasOwnProperty.call(message, "hideReportABug") && message.hideReportABug !== false)
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.hideReportABug);
            if (message.aboutSectionMd != null && $Object.hasOwnProperty.call(message, "aboutSectionMd") && message.aboutSectionMd !== "")
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.aboutSectionMd);
            if (message.clearAboutMd != null && $Object.hasOwnProperty.call(message, "clearAboutMd") && message.clearAboutMd !== false)
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.clearAboutMd);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a MenuItems message from the specified reader or buffer.
         * @function decode
         * @memberof PageConfig.MenuItems
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {PageConfig.MenuItems & PageConfig.MenuItems.$Shape} MenuItems
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MenuItems.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.PageConfig.MenuItems();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.getHelpUrl = value;
                        else
                            delete message.getHelpUrl;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.hideGetHelp = value;
                        else
                            delete message.hideGetHelp;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.reportABugUrl = value;
                        else
                            delete message.reportABugUrl;
                        continue;
                    }
                case 4: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.hideReportABug = value;
                        else
                            delete message.hideReportABug;
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.aboutSectionMd = value;
                        else
                            delete message.aboutSectionMd;
                        continue;
                    }
                case 6: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.bool())
                            message.clearAboutMd = value;
                        else
                            delete message.clearAboutMd;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a MenuItems message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof PageConfig.MenuItems
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {PageConfig.MenuItems} MenuItems
         */
        MenuItems.fromObject = function (object, _depth) {
            if (object instanceof $root.PageConfig.MenuItems)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".PageConfig.MenuItems: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.PageConfig.MenuItems();
            if (object.getHelpUrl != null)
                if (typeof object.getHelpUrl !== "string" || object.getHelpUrl.length)
                    message.getHelpUrl = $String(object.getHelpUrl);
            if (object.hideGetHelp != null)
                if (object.hideGetHelp)
                    message.hideGetHelp = $Boolean(object.hideGetHelp);
            if (object.reportABugUrl != null)
                if (typeof object.reportABugUrl !== "string" || object.reportABugUrl.length)
                    message.reportABugUrl = $String(object.reportABugUrl);
            if (object.hideReportABug != null)
                if (object.hideReportABug)
                    message.hideReportABug = $Boolean(object.hideReportABug);
            if (object.aboutSectionMd != null)
                if (typeof object.aboutSectionMd !== "string" || object.aboutSectionMd.length)
                    message.aboutSectionMd = $String(object.aboutSectionMd);
            if (object.clearAboutMd != null)
                if (object.clearAboutMd)
                    message.clearAboutMd = $Boolean(object.clearAboutMd);
            return message;
        };

        /**
         * Creates a plain object from a MenuItems message. Also converts values to other types if specified.
         * @function toObject
         * @memberof PageConfig.MenuItems
         * @static
         * @param {PageConfig.MenuItems} message MenuItems
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MenuItems.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.getHelpUrl = "";
                object.hideGetHelp = false;
                object.reportABugUrl = "";
                object.hideReportABug = false;
                object.aboutSectionMd = "";
                object.clearAboutMd = false;
            }
            if (message.getHelpUrl != null && $Object.hasOwnProperty.call(message, "getHelpUrl"))
                object.getHelpUrl = message.getHelpUrl;
            if (message.hideGetHelp != null && $Object.hasOwnProperty.call(message, "hideGetHelp"))
                object.hideGetHelp = message.hideGetHelp;
            if (message.reportABugUrl != null && $Object.hasOwnProperty.call(message, "reportABugUrl"))
                object.reportABugUrl = message.reportABugUrl;
            if (message.hideReportABug != null && $Object.hasOwnProperty.call(message, "hideReportABug"))
                object.hideReportABug = message.hideReportABug;
            if (message.aboutSectionMd != null && $Object.hasOwnProperty.call(message, "aboutSectionMd"))
                object.aboutSectionMd = message.aboutSectionMd;
            if (message.clearAboutMd != null && $Object.hasOwnProperty.call(message, "clearAboutMd"))
                object.clearAboutMd = message.clearAboutMd;
            return object;
        };

        /**
         * Converts this MenuItems to JSON.
         * @function toJSON
         * @memberof PageConfig.MenuItems
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MenuItems.prototype.toJSON = function() {
            return MenuItems.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for MenuItems
         * @function getTypeUrl
         * @memberof PageConfig.MenuItems
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        MenuItems.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/PageConfig.MenuItems";
        };

        return MenuItems;
    })();

    /**
     * Layout enum.
     * @name PageConfig.Layout
     * @enum {number}
     * @property {number} CENTERED=0 CENTERED value
     * @property {number} WIDE=1 WIDE value
     * @property {number} LAYOUT_UNSET=2 LAYOUT_UNSET value
     */
    PageConfig.Layout = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "CENTERED"] = 0;
        values[valuesById[1] = "WIDE"] = 1;
        values[valuesById[2] = "LAYOUT_UNSET"] = 2;
        return values;
    })();

    /**
     * SidebarState enum.
     * @name PageConfig.SidebarState
     * @enum {number}
     * @property {number} AUTO=0 AUTO value
     * @property {number} EXPANDED=1 EXPANDED value
     * @property {number} COLLAPSED=2 COLLAPSED value
     * @property {number} SIDEBAR_UNSET=3 SIDEBAR_UNSET value
     * @property {number} LOCKED=4 LOCKED value
     */
    PageConfig.SidebarState = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "AUTO"] = 0;
        values[valuesById[1] = "EXPANDED"] = 1;
        values[valuesById[2] = "COLLAPSED"] = 2;
        values[valuesById[3] = "SIDEBAR_UNSET"] = 3;
        values[valuesById[4] = "LOCKED"] = 4;
        return values;
    })();

    PageConfig.SidebarWidthConfig = (function() {

        /**
         * Properties of a SidebarWidthConfig.
         * @typedef {Object} PageConfig.SidebarWidthConfig.$Properties
         * @property {number|null} [pixelWidth] SidebarWidthConfig pixelWidth
         * @property {"pixelWidth"} [widthSpec] SidebarWidthConfig widthSpec
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a SidebarWidthConfig.
         * @memberof PageConfig
         * @interface ISidebarWidthConfig
         * @augments PageConfig.SidebarWidthConfig.$Properties
         * @deprecated Use PageConfig.SidebarWidthConfig.$Properties instead.
         */

        /**
         * Narrowed shape of a SidebarWidthConfig.
         * @typedef {{
         *   pixelWidth?: number|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ widthSpec?: undefined; pixelWidth?: null }|{ widthSpec?: "pixelWidth"; pixelWidth: number })
         * )} PageConfig.SidebarWidthConfig.$Shape
         */

        /**
         * Constructs a new SidebarWidthConfig.
         * @memberof PageConfig
         * @classdesc Represents a SidebarWidthConfig.
         * @constructor
         * @param {PageConfig.SidebarWidthConfig.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const SidebarWidthConfig = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * SidebarWidthConfig pixelWidth.
         * @member {number|null|undefined} pixelWidth
         * @memberof PageConfig.SidebarWidthConfig
         * @instance
         */
        SidebarWidthConfig.prototype.pixelWidth = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * SidebarWidthConfig widthSpec.
         * @member {"pixelWidth"|undefined} widthSpec
         * @memberof PageConfig.SidebarWidthConfig
         * @instance
         */
        $Object.defineProperty(SidebarWidthConfig.prototype, "widthSpec", {
            get: $util.oneOfGetter($oneOfFields = ["pixelWidth"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SidebarWidthConfig instance using the specified properties.
         * @function create
         * @memberof PageConfig.SidebarWidthConfig
         * @static
         * @param {PageConfig.SidebarWidthConfig.$Properties=} [properties] Properties to set
         * @returns {PageConfig.SidebarWidthConfig} SidebarWidthConfig instance
         * @type {{
         *   (properties: PageConfig.SidebarWidthConfig.$Shape): PageConfig.SidebarWidthConfig & PageConfig.SidebarWidthConfig.$Shape;
         *   (properties?: PageConfig.SidebarWidthConfig.$Properties): PageConfig.SidebarWidthConfig;
         * }}
         */
        SidebarWidthConfig.create = function(properties) {
            return new SidebarWidthConfig(properties);
        };

        /**
         * Encodes the specified SidebarWidthConfig message. Does not implicitly {@link PageConfig.SidebarWidthConfig.verify|verify} messages.
         * @function encode
         * @memberof PageConfig.SidebarWidthConfig
         * @static
         * @param {PageConfig.SidebarWidthConfig.$Properties} message SidebarWidthConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SidebarWidthConfig.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.pixelWidth != null && $Object.hasOwnProperty.call(message, "pixelWidth"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pixelWidth);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a SidebarWidthConfig message from the specified reader or buffer.
         * @function decode
         * @memberof PageConfig.SidebarWidthConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {PageConfig.SidebarWidthConfig & PageConfig.SidebarWidthConfig.$Shape} SidebarWidthConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SidebarWidthConfig.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.PageConfig.SidebarWidthConfig();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 0)
                            break;
                        message.pixelWidth = reader.uint32();
                        message.widthSpec = "pixelWidth";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a SidebarWidthConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof PageConfig.SidebarWidthConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {PageConfig.SidebarWidthConfig} SidebarWidthConfig
         */
        SidebarWidthConfig.fromObject = function (object, _depth) {
            if (object instanceof $root.PageConfig.SidebarWidthConfig)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".PageConfig.SidebarWidthConfig: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.PageConfig.SidebarWidthConfig();
            if (object.pixelWidth != null)
                message.pixelWidth = object.pixelWidth >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a SidebarWidthConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof PageConfig.SidebarWidthConfig
         * @static
         * @param {PageConfig.SidebarWidthConfig} message SidebarWidthConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SidebarWidthConfig.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (message.pixelWidth != null && $Object.hasOwnProperty.call(message, "pixelWidth")) {
                object.pixelWidth = message.pixelWidth;
                if (options.oneofs)
                    object.widthSpec = "pixelWidth";
            }
            return object;
        };

        /**
         * Converts this SidebarWidthConfig to JSON.
         * @function toJSON
         * @memberof PageConfig.SidebarWidthConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SidebarWidthConfig.prototype.toJSON = function() {
            return SidebarWidthConfig.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for SidebarWidthConfig
         * @function getTypeUrl
         * @memberof PageConfig.SidebarWidthConfig
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        SidebarWidthConfig.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/PageConfig.SidebarWidthConfig";
        };

        return SidebarWidthConfig;
    })();

    return PageConfig;
})();

export const PageInfo = $root.PageInfo = (() => {

    /**
     * Properties of a PageInfo.
     * @typedef {Object} PageInfo.$Properties
     * @property {string|null} [queryString] PageInfo queryString
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a PageInfo.
     * @exports IPageInfo
     * @interface IPageInfo
     * @augments PageInfo.$Properties
     * @deprecated Use PageInfo.$Properties instead.
     */

    /**
     * Shape of a PageInfo.
     * @typedef {PageInfo.$Properties} PageInfo.$Shape
     */

    /**
     * Constructs a new PageInfo.
     * @exports PageInfo
     * @classdesc Represents a PageInfo.
     * @constructor
     * @param {PageInfo.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const PageInfo = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * PageInfo queryString.
     * @member {string} queryString
     * @memberof PageInfo
     * @instance
     */
    PageInfo.prototype.queryString = "";

    /**
     * Creates a new PageInfo instance using the specified properties.
     * @function create
     * @memberof PageInfo
     * @static
     * @param {PageInfo.$Properties=} [properties] Properties to set
     * @returns {PageInfo} PageInfo instance
     * @type {{
     *   (properties: PageInfo.$Shape): PageInfo & PageInfo.$Shape;
     *   (properties?: PageInfo.$Properties): PageInfo;
     * }}
     */
    PageInfo.create = function(properties) {
        return new PageInfo(properties);
    };

    /**
     * Encodes the specified PageInfo message. Does not implicitly {@link PageInfo.verify|verify} messages.
     * @function encode
     * @memberof PageInfo
     * @static
     * @param {PageInfo.$Properties} message PageInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageInfo.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.queryString != null && $Object.hasOwnProperty.call(message, "queryString") && message.queryString !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.queryString);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a PageInfo message from the specified reader or buffer.
     * @function decode
     * @memberof PageInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PageInfo & PageInfo.$Shape} PageInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageInfo.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.PageInfo();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.queryString = value;
                    else
                        delete message.queryString;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a PageInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PageInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PageInfo} PageInfo
     */
    PageInfo.fromObject = function (object, _depth) {
        if (object instanceof $root.PageInfo)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".PageInfo: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.PageInfo();
        if (object.queryString != null)
            if (typeof object.queryString !== "string" || object.queryString.length)
                message.queryString = $String(object.queryString);
        return message;
    };

    /**
     * Creates a plain object from a PageInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PageInfo
     * @static
     * @param {PageInfo} message PageInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PageInfo.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.queryString = "";
        if (message.queryString != null && $Object.hasOwnProperty.call(message, "queryString"))
            object.queryString = message.queryString;
        return object;
    };

    /**
     * Converts this PageInfo to JSON.
     * @function toJSON
     * @memberof PageInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PageInfo.prototype.toJSON = function() {
        return PageInfo.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for PageInfo
     * @function getTypeUrl
     * @memberof PageInfo
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    PageInfo.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/PageInfo";
    };

    return PageInfo;
})();

export const PageNotFound = $root.PageNotFound = (() => {

    /**
     * Properties of a PageNotFound.
     * @typedef {Object} PageNotFound.$Properties
     * @property {string|null} [pageName] PageNotFound pageName
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a PageNotFound.
     * @exports IPageNotFound
     * @interface IPageNotFound
     * @augments PageNotFound.$Properties
     * @deprecated Use PageNotFound.$Properties instead.
     */

    /**
     * Shape of a PageNotFound.
     * @typedef {PageNotFound.$Properties} PageNotFound.$Shape
     */

    /**
     * Constructs a new PageNotFound.
     * @exports PageNotFound
     * @classdesc Represents a PageNotFound.
     * @constructor
     * @param {PageNotFound.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const PageNotFound = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * PageNotFound pageName.
     * @member {string} pageName
     * @memberof PageNotFound
     * @instance
     */
    PageNotFound.prototype.pageName = "";

    /**
     * Creates a new PageNotFound instance using the specified properties.
     * @function create
     * @memberof PageNotFound
     * @static
     * @param {PageNotFound.$Properties=} [properties] Properties to set
     * @returns {PageNotFound} PageNotFound instance
     * @type {{
     *   (properties: PageNotFound.$Shape): PageNotFound & PageNotFound.$Shape;
     *   (properties?: PageNotFound.$Properties): PageNotFound;
     * }}
     */
    PageNotFound.create = function(properties) {
        return new PageNotFound(properties);
    };

    /**
     * Encodes the specified PageNotFound message. Does not implicitly {@link PageNotFound.verify|verify} messages.
     * @function encode
     * @memberof PageNotFound
     * @static
     * @param {PageNotFound.$Properties} message PageNotFound message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageNotFound.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.pageName != null && $Object.hasOwnProperty.call(message, "pageName") && message.pageName !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.pageName);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a PageNotFound message from the specified reader or buffer.
     * @function decode
     * @memberof PageNotFound
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PageNotFound & PageNotFound.$Shape} PageNotFound
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageNotFound.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.PageNotFound();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pageName = value;
                    else
                        delete message.pageName;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a PageNotFound message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PageNotFound
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PageNotFound} PageNotFound
     */
    PageNotFound.fromObject = function (object, _depth) {
        if (object instanceof $root.PageNotFound)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".PageNotFound: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.PageNotFound();
        if (object.pageName != null)
            if (typeof object.pageName !== "string" || object.pageName.length)
                message.pageName = $String(object.pageName);
        return message;
    };

    /**
     * Creates a plain object from a PageNotFound message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PageNotFound
     * @static
     * @param {PageNotFound} message PageNotFound
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PageNotFound.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.pageName = "";
        if (message.pageName != null && $Object.hasOwnProperty.call(message, "pageName"))
            object.pageName = message.pageName;
        return object;
    };

    /**
     * Converts this PageNotFound to JSON.
     * @function toJSON
     * @memberof PageNotFound
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PageNotFound.prototype.toJSON = function() {
        return PageNotFound.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for PageNotFound
     * @function getTypeUrl
     * @memberof PageNotFound
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    PageNotFound.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/PageNotFound";
    };

    return PageNotFound;
})();

export const PageProfile = $root.PageProfile = (() => {

    /**
     * Properties of a PageProfile.
     * @typedef {Object} PageProfile.$Properties
     * @property {Array.<Command.$Properties>|null} [commands] PageProfile commands
     * @property {number|Long|null} [execTime] PageProfile execTime
     * @property {number|Long|null} [prepTime] PageProfile prepTime
     * @property {Array.<string>|null} [config] PageProfile config
     * @property {string|null} [uncaughtException] PageProfile uncaughtException
     * @property {Array.<string>|null} [attributions] PageProfile attributions
     * @property {string|null} [os] PageProfile os
     * @property {string|null} [timezone] PageProfile timezone
     * @property {boolean|null} [headless] PageProfile headless
     * @property {boolean|null} [isFragmentRun] PageProfile isFragmentRun
     * @property {string|null} [serverMode] PageProfile serverMode
     * @property {Array.<string>|null} [installedSkills] PageProfile installedSkills
     * @property {Array.<string>|null} [installedAgents] PageProfile installedAgents
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a PageProfile.
     * @exports IPageProfile
     * @interface IPageProfile
     * @augments PageProfile.$Properties
     * @deprecated Use PageProfile.$Properties instead.
     */

    /**
     * Shape of a PageProfile.
     * @typedef {PageProfile.$Properties} PageProfile.$Shape
     */

    /**
     * Constructs a new PageProfile.
     * @exports PageProfile
     * @classdesc Represents a PageProfile.
     * @constructor
     * @param {PageProfile.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const PageProfile = function (properties) {
        this.commands = [];
        this.config = [];
        this.attributions = [];
        this.installedSkills = [];
        this.installedAgents = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * PageProfile commands.
     * @member {Array.<Command.$Properties>} commands
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.commands = $util.emptyArray;

    /**
     * PageProfile execTime.
     * @member {number|Long} execTime
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.execTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PageProfile prepTime.
     * @member {number|Long} prepTime
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.prepTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PageProfile config.
     * @member {Array.<string>} config
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.config = $util.emptyArray;

    /**
     * PageProfile uncaughtException.
     * @member {string} uncaughtException
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.uncaughtException = "";

    /**
     * PageProfile attributions.
     * @member {Array.<string>} attributions
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.attributions = $util.emptyArray;

    /**
     * PageProfile os.
     * @member {string} os
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.os = "";

    /**
     * PageProfile timezone.
     * @member {string} timezone
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.timezone = "";

    /**
     * PageProfile headless.
     * @member {boolean} headless
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.headless = false;

    /**
     * PageProfile isFragmentRun.
     * @member {boolean} isFragmentRun
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.isFragmentRun = false;

    /**
     * PageProfile serverMode.
     * @member {string} serverMode
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.serverMode = "";

    /**
     * PageProfile installedSkills.
     * @member {Array.<string>} installedSkills
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.installedSkills = $util.emptyArray;

    /**
     * PageProfile installedAgents.
     * @member {Array.<string>} installedAgents
     * @memberof PageProfile
     * @instance
     */
    PageProfile.prototype.installedAgents = $util.emptyArray;

    /**
     * Creates a new PageProfile instance using the specified properties.
     * @function create
     * @memberof PageProfile
     * @static
     * @param {PageProfile.$Properties=} [properties] Properties to set
     * @returns {PageProfile} PageProfile instance
     * @type {{
     *   (properties: PageProfile.$Shape): PageProfile & PageProfile.$Shape;
     *   (properties?: PageProfile.$Properties): PageProfile;
     * }}
     */
    PageProfile.create = function(properties) {
        return new PageProfile(properties);
    };

    /**
     * Encodes the specified PageProfile message. Does not implicitly {@link PageProfile.verify|verify} messages.
     * @function encode
     * @memberof PageProfile
     * @static
     * @param {PageProfile.$Properties} message PageProfile message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PageProfile.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.commands != null && message.commands.length)
            for (let i = 0; i < message.commands.length; ++i)
                $root.Command.encode(message.commands[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
        if (message.execTime != null && $Object.hasOwnProperty.call(message, "execTime") && (typeof message.execTime === "object" ? message.execTime.low || message.execTime.high : message.execTime !== 0))
            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.execTime);
        if (message.prepTime != null && $Object.hasOwnProperty.call(message, "prepTime") && (typeof message.prepTime === "object" ? message.prepTime.low || message.prepTime.high : message.prepTime !== 0))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.prepTime);
        if (message.config != null && message.config.length)
            for (let i = 0; i < message.config.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.config[i]);
        if (message.uncaughtException != null && $Object.hasOwnProperty.call(message, "uncaughtException") && message.uncaughtException !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.uncaughtException);
        if (message.attributions != null && message.attributions.length)
            for (let i = 0; i < message.attributions.length; ++i)
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.attributions[i]);
        if (message.os != null && $Object.hasOwnProperty.call(message, "os") && message.os !== "")
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.os);
        if (message.timezone != null && $Object.hasOwnProperty.call(message, "timezone") && message.timezone !== "")
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.timezone);
        if (message.headless != null && $Object.hasOwnProperty.call(message, "headless") && message.headless !== false)
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.headless);
        if (message.isFragmentRun != null && $Object.hasOwnProperty.call(message, "isFragmentRun") && message.isFragmentRun !== false)
            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.isFragmentRun);
        if (message.serverMode != null && $Object.hasOwnProperty.call(message, "serverMode") && message.serverMode !== "")
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.serverMode);
        if (message.installedSkills != null && message.installedSkills.length)
            for (let i = 0; i < message.installedSkills.length; ++i)
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.installedSkills[i]);
        if (message.installedAgents != null && message.installedAgents.length)
            for (let i = 0; i < message.installedAgents.length; ++i)
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.installedAgents[i]);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a PageProfile message from the specified reader or buffer.
     * @function decode
     * @memberof PageProfile
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PageProfile & PageProfile.$Shape} PageProfile
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PageProfile.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.PageProfile();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if (!(message.commands && message.commands.length))
                        message.commands = [];
                    message.commands.push($root.Command.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                        message.execTime = value;
                    else
                        delete message.execTime;
                    continue;
                }
            case 3: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                        message.prepTime = value;
                    else
                        delete message.prepTime;
                    continue;
                }
            case 5: {
                    if (wireType !== 2)
                        break;
                    if (!(message.config && message.config.length))
                        message.config = [];
                    message.config.push(reader.stringVerify());
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.uncaughtException = value;
                    else
                        delete message.uncaughtException;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if (!(message.attributions && message.attributions.length))
                        message.attributions = [];
                    message.attributions.push(reader.stringVerify());
                    continue;
                }
            case 8: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.os = value;
                    else
                        delete message.os;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.timezone = value;
                    else
                        delete message.timezone;
                    continue;
                }
            case 10: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.headless = value;
                    else
                        delete message.headless;
                    continue;
                }
            case 11: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isFragmentRun = value;
                    else
                        delete message.isFragmentRun;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.serverMode = value;
                    else
                        delete message.serverMode;
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    if (!(message.installedSkills && message.installedSkills.length))
                        message.installedSkills = [];
                    message.installedSkills.push(reader.stringVerify());
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    if (!(message.installedAgents && message.installedAgents.length))
                        message.installedAgents = [];
                    message.installedAgents.push(reader.stringVerify());
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a PageProfile message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PageProfile
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PageProfile} PageProfile
     */
    PageProfile.fromObject = function (object, _depth) {
        if (object instanceof $root.PageProfile)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".PageProfile: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.PageProfile();
        if (object.commands) {
            if (!$Array.isArray(object.commands))
                throw $TypeError(".PageProfile.commands: array expected");
            message.commands = $Array(object.commands.length);
            for (let i = 0; i < object.commands.length; ++i) {
                if (!$util.isObject(object.commands[i]))
                    throw $TypeError(".PageProfile.commands: object expected");
                message.commands[i] = $root.Command.fromObject(object.commands[i], _depth + 1);
            }
        }
        if (object.execTime != null)
            if (typeof object.execTime === "object" ? object.execTime.low || object.execTime.high : $Number(object.execTime) !== 0)
                if ($util.Long)
                    message.execTime = $util.Long.fromValue(object.execTime, false);
                else if (typeof object.execTime === "string")
                    message.execTime = $parseInt(object.execTime, 10);
                else if (typeof object.execTime === "number")
                    message.execTime = object.execTime;
                else if (typeof object.execTime === "object")
                    message.execTime = new $util.LongBits(object.execTime.low >>> 0, object.execTime.high >>> 0).toNumber();
        if (object.prepTime != null)
            if (typeof object.prepTime === "object" ? object.prepTime.low || object.prepTime.high : $Number(object.prepTime) !== 0)
                if ($util.Long)
                    message.prepTime = $util.Long.fromValue(object.prepTime, false);
                else if (typeof object.prepTime === "string")
                    message.prepTime = $parseInt(object.prepTime, 10);
                else if (typeof object.prepTime === "number")
                    message.prepTime = object.prepTime;
                else if (typeof object.prepTime === "object")
                    message.prepTime = new $util.LongBits(object.prepTime.low >>> 0, object.prepTime.high >>> 0).toNumber();
        if (object.config) {
            if (!$Array.isArray(object.config))
                throw $TypeError(".PageProfile.config: array expected");
            message.config = $Array(object.config.length);
            for (let i = 0; i < object.config.length; ++i)
                message.config[i] = $String(object.config[i]);
        }
        if (object.uncaughtException != null)
            if (typeof object.uncaughtException !== "string" || object.uncaughtException.length)
                message.uncaughtException = $String(object.uncaughtException);
        if (object.attributions) {
            if (!$Array.isArray(object.attributions))
                throw $TypeError(".PageProfile.attributions: array expected");
            message.attributions = $Array(object.attributions.length);
            for (let i = 0; i < object.attributions.length; ++i)
                message.attributions[i] = $String(object.attributions[i]);
        }
        if (object.os != null)
            if (typeof object.os !== "string" || object.os.length)
                message.os = $String(object.os);
        if (object.timezone != null)
            if (typeof object.timezone !== "string" || object.timezone.length)
                message.timezone = $String(object.timezone);
        if (object.headless != null)
            if (object.headless)
                message.headless = $Boolean(object.headless);
        if (object.isFragmentRun != null)
            if (object.isFragmentRun)
                message.isFragmentRun = $Boolean(object.isFragmentRun);
        if (object.serverMode != null)
            if (typeof object.serverMode !== "string" || object.serverMode.length)
                message.serverMode = $String(object.serverMode);
        if (object.installedSkills) {
            if (!$Array.isArray(object.installedSkills))
                throw $TypeError(".PageProfile.installedSkills: array expected");
            message.installedSkills = $Array(object.installedSkills.length);
            for (let i = 0; i < object.installedSkills.length; ++i)
                message.installedSkills[i] = $String(object.installedSkills[i]);
        }
        if (object.installedAgents) {
            if (!$Array.isArray(object.installedAgents))
                throw $TypeError(".PageProfile.installedAgents: array expected");
            message.installedAgents = $Array(object.installedAgents.length);
            for (let i = 0; i < object.installedAgents.length; ++i)
                message.installedAgents[i] = $String(object.installedAgents[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a PageProfile message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PageProfile
     * @static
     * @param {PageProfile} message PageProfile
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PageProfile.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object.commands = [];
            object.config = [];
            object.attributions = [];
            object.installedSkills = [];
            object.installedAgents = [];
        }
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.execTime = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.execTime = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.prepTime = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.prepTime = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            object.uncaughtException = "";
            object.os = "";
            object.timezone = "";
            object.headless = false;
            object.isFragmentRun = false;
            object.serverMode = "";
        }
        if (message.commands && message.commands.length) {
            object.commands = $Array(message.commands.length);
            for (let j = 0; j < message.commands.length; ++j)
                object.commands[j] = $root.Command.toObject(message.commands[j], options, _depth + 1);
        }
        if (message.execTime != null && $Object.hasOwnProperty.call(message, "execTime"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.execTime = typeof message.execTime === "number" ? $BigInt(message.execTime) : $util.Long.fromBits(message.execTime.low >>> 0, message.execTime.high >>> 0, false).toBigInt();
            else if (typeof message.execTime === "number")
                object.execTime = options.longs === $String ? $String(message.execTime) : message.execTime;
            else
                object.execTime = options.longs === $String ? $util.Long.prototype.toString.call(message.execTime) : options.longs === $Number ? new $util.LongBits(message.execTime.low >>> 0, message.execTime.high >>> 0).toNumber() : message.execTime;
        if (message.prepTime != null && $Object.hasOwnProperty.call(message, "prepTime"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.prepTime = typeof message.prepTime === "number" ? $BigInt(message.prepTime) : $util.Long.fromBits(message.prepTime.low >>> 0, message.prepTime.high >>> 0, false).toBigInt();
            else if (typeof message.prepTime === "number")
                object.prepTime = options.longs === $String ? $String(message.prepTime) : message.prepTime;
            else
                object.prepTime = options.longs === $String ? $util.Long.prototype.toString.call(message.prepTime) : options.longs === $Number ? new $util.LongBits(message.prepTime.low >>> 0, message.prepTime.high >>> 0).toNumber() : message.prepTime;
        if (message.config && message.config.length) {
            object.config = $Array(message.config.length);
            for (let j = 0; j < message.config.length; ++j)
                object.config[j] = message.config[j];
        }
        if (message.uncaughtException != null && $Object.hasOwnProperty.call(message, "uncaughtException"))
            object.uncaughtException = message.uncaughtException;
        if (message.attributions && message.attributions.length) {
            object.attributions = $Array(message.attributions.length);
            for (let j = 0; j < message.attributions.length; ++j)
                object.attributions[j] = message.attributions[j];
        }
        if (message.os != null && $Object.hasOwnProperty.call(message, "os"))
            object.os = message.os;
        if (message.timezone != null && $Object.hasOwnProperty.call(message, "timezone"))
            object.timezone = message.timezone;
        if (message.headless != null && $Object.hasOwnProperty.call(message, "headless"))
            object.headless = message.headless;
        if (message.isFragmentRun != null && $Object.hasOwnProperty.call(message, "isFragmentRun"))
            object.isFragmentRun = message.isFragmentRun;
        if (message.serverMode != null && $Object.hasOwnProperty.call(message, "serverMode"))
            object.serverMode = message.serverMode;
        if (message.installedSkills && message.installedSkills.length) {
            object.installedSkills = $Array(message.installedSkills.length);
            for (let j = 0; j < message.installedSkills.length; ++j)
                object.installedSkills[j] = message.installedSkills[j];
        }
        if (message.installedAgents && message.installedAgents.length) {
            object.installedAgents = $Array(message.installedAgents.length);
            for (let j = 0; j < message.installedAgents.length; ++j)
                object.installedAgents[j] = message.installedAgents[j];
        }
        return object;
    };

    /**
     * Converts this PageProfile to JSON.
     * @function toJSON
     * @memberof PageProfile
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PageProfile.prototype.toJSON = function() {
        return PageProfile.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for PageProfile
     * @function getTypeUrl
     * @memberof PageProfile
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    PageProfile.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/PageProfile";
    };

    return PageProfile;
})();

export const Argument = $root.Argument = (() => {

    /**
     * Properties of an Argument.
     * @typedef {Object} Argument.$Properties
     * @property {string|null} [k] Argument k
     * @property {string|null} [t] Argument t
     * @property {string|null} [m] Argument m
     * @property {number|null} [p] Argument p
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of an Argument.
     * @exports IArgument
     * @interface IArgument
     * @augments Argument.$Properties
     * @deprecated Use Argument.$Properties instead.
     */

    /**
     * Shape of an Argument.
     * @typedef {Argument.$Properties} Argument.$Shape
     */

    /**
     * Constructs a new Argument.
     * @exports Argument
     * @classdesc Represents an Argument.
     * @constructor
     * @param {Argument.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Argument = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Argument k.
     * @member {string} k
     * @memberof Argument
     * @instance
     */
    Argument.prototype.k = "";

    /**
     * Argument t.
     * @member {string} t
     * @memberof Argument
     * @instance
     */
    Argument.prototype.t = "";

    /**
     * Argument m.
     * @member {string} m
     * @memberof Argument
     * @instance
     */
    Argument.prototype.m = "";

    /**
     * Argument p.
     * @member {number} p
     * @memberof Argument
     * @instance
     */
    Argument.prototype.p = 0;

    /**
     * Creates a new Argument instance using the specified properties.
     * @function create
     * @memberof Argument
     * @static
     * @param {Argument.$Properties=} [properties] Properties to set
     * @returns {Argument} Argument instance
     * @type {{
     *   (properties: Argument.$Shape): Argument & Argument.$Shape;
     *   (properties?: Argument.$Properties): Argument;
     * }}
     */
    Argument.create = function(properties) {
        return new Argument(properties);
    };

    /**
     * Encodes the specified Argument message. Does not implicitly {@link Argument.verify|verify} messages.
     * @function encode
     * @memberof Argument
     * @static
     * @param {Argument.$Properties} message Argument message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Argument.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.k != null && $Object.hasOwnProperty.call(message, "k") && message.k !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.k);
        if (message.t != null && $Object.hasOwnProperty.call(message, "t") && message.t !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.t);
        if (message.m != null && $Object.hasOwnProperty.call(message, "m") && message.m !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.m);
        if (message.p != null && $Object.hasOwnProperty.call(message, "p") && message.p !== 0)
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.p);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes an Argument message from the specified reader or buffer.
     * @function decode
     * @memberof Argument
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Argument & Argument.$Shape} Argument
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Argument.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Argument();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.k = value;
                    else
                        delete message.k;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.t = value;
                    else
                        delete message.t;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.m = value;
                    else
                        delete message.m;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.int32())
                        message.p = value;
                    else
                        delete message.p;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates an Argument message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Argument
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Argument} Argument
     */
    Argument.fromObject = function (object, _depth) {
        if (object instanceof $root.Argument)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Argument: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Argument();
        if (object.k != null)
            if (typeof object.k !== "string" || object.k.length)
                message.k = $String(object.k);
        if (object.t != null)
            if (typeof object.t !== "string" || object.t.length)
                message.t = $String(object.t);
        if (object.m != null)
            if (typeof object.m !== "string" || object.m.length)
                message.m = $String(object.m);
        if (object.p != null)
            if ($Number(object.p) !== 0)
                message.p = object.p | 0;
        return message;
    };

    /**
     * Creates a plain object from an Argument message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Argument
     * @static
     * @param {Argument} message Argument
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Argument.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.k = "";
            object.t = "";
            object.m = "";
            object.p = 0;
        }
        if (message.k != null && $Object.hasOwnProperty.call(message, "k"))
            object.k = message.k;
        if (message.t != null && $Object.hasOwnProperty.call(message, "t"))
            object.t = message.t;
        if (message.m != null && $Object.hasOwnProperty.call(message, "m"))
            object.m = message.m;
        if (message.p != null && $Object.hasOwnProperty.call(message, "p"))
            object.p = message.p;
        return object;
    };

    /**
     * Converts this Argument to JSON.
     * @function toJSON
     * @memberof Argument
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Argument.prototype.toJSON = function() {
        return Argument.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Argument
     * @function getTypeUrl
     * @memberof Argument
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Argument.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Argument";
    };

    return Argument;
})();

export const Command = $root.Command = (() => {

    /**
     * Properties of a Command.
     * @typedef {Object} Command.$Properties
     * @property {string|null} [name] Command name
     * @property {Array.<Argument.$Properties>|null} [args] Command args
     * @property {number|Long|null} [time] Command time
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a Command.
     * @exports ICommand
     * @interface ICommand
     * @augments Command.$Properties
     * @deprecated Use Command.$Properties instead.
     */

    /**
     * Shape of a Command.
     * @typedef {Command.$Properties} Command.$Shape
     */

    /**
     * Constructs a new Command.
     * @exports Command
     * @classdesc Represents a Command.
     * @constructor
     * @param {Command.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const Command = function (properties) {
        this.args = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * Command name.
     * @member {string} name
     * @memberof Command
     * @instance
     */
    Command.prototype.name = "";

    /**
     * Command args.
     * @member {Array.<Argument.$Properties>} args
     * @memberof Command
     * @instance
     */
    Command.prototype.args = $util.emptyArray;

    /**
     * Command time.
     * @member {number|Long} time
     * @memberof Command
     * @instance
     */
    Command.prototype.time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new Command instance using the specified properties.
     * @function create
     * @memberof Command
     * @static
     * @param {Command.$Properties=} [properties] Properties to set
     * @returns {Command} Command instance
     * @type {{
     *   (properties: Command.$Shape): Command & Command.$Shape;
     *   (properties?: Command.$Properties): Command;
     * }}
     */
    Command.create = function(properties) {
        return new Command(properties);
    };

    /**
     * Encodes the specified Command message. Does not implicitly {@link Command.verify|verify} messages.
     * @function encode
     * @memberof Command
     * @static
     * @param {Command.$Properties} message Command message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Command.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
        if (message.args != null && message.args.length)
            for (let i = 0; i < message.args.length; ++i)
                $root.Argument.encode(message.args[i], writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
        if (message.time != null && $Object.hasOwnProperty.call(message, "time") && (typeof message.time === "object" ? message.time.low || message.time.high : message.time !== 0))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.time);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a Command message from the specified reader or buffer.
     * @function decode
     * @memberof Command
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Command & Command.$Shape} Command
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Command.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.Command();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.name = value;
                    else
                        delete message.name;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if (!(message.args && message.args.length))
                        message.args = [];
                    message.args.push($root.Argument.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 4: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                        message.time = value;
                    else
                        delete message.time;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a Command message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Command
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Command} Command
     */
    Command.fromObject = function (object, _depth) {
        if (object instanceof $root.Command)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".Command: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.Command();
        if (object.name != null)
            if (typeof object.name !== "string" || object.name.length)
                message.name = $String(object.name);
        if (object.args) {
            if (!$Array.isArray(object.args))
                throw $TypeError(".Command.args: array expected");
            message.args = $Array(object.args.length);
            for (let i = 0; i < object.args.length; ++i) {
                if (!$util.isObject(object.args[i]))
                    throw $TypeError(".Command.args: object expected");
                message.args[i] = $root.Argument.fromObject(object.args[i], _depth + 1);
            }
        }
        if (object.time != null)
            if (typeof object.time === "object" ? object.time.low || object.time.high : $Number(object.time) !== 0)
                if ($util.Long)
                    message.time = $util.Long.fromValue(object.time, false);
                else if (typeof object.time === "string")
                    message.time = $parseInt(object.time, 10);
                else if (typeof object.time === "number")
                    message.time = object.time;
                else if (typeof object.time === "object")
                    message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a Command message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Command
     * @static
     * @param {Command} message Command
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Command.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults)
            object.args = [];
        if (options.defaults) {
            object.name = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.time = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.time = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
        }
        if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
            object.name = message.name;
        if (message.args && message.args.length) {
            object.args = $Array(message.args.length);
            for (let j = 0; j < message.args.length; ++j)
                object.args[j] = $root.Argument.toObject(message.args[j], options, _depth + 1);
        }
        if (message.time != null && $Object.hasOwnProperty.call(message, "time"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.time = typeof message.time === "number" ? $BigInt(message.time) : $util.Long.fromBits(message.time.low >>> 0, message.time.high >>> 0, false).toBigInt();
            else if (typeof message.time === "number")
                object.time = options.longs === $String ? $String(message.time) : message.time;
            else
                object.time = options.longs === $String ? $util.Long.prototype.toString.call(message.time) : options.longs === $Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
        return object;
    };

    /**
     * Converts this Command to JSON.
     * @function toJSON
     * @memberof Command
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Command.prototype.toJSON = function() {
        return Command.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for Command
     * @function getTypeUrl
     * @memberof Command
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    Command.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/Command";
    };

    return Command;
})();

export const ParentMessage = $root.ParentMessage = (() => {

    /**
     * Properties of a ParentMessage.
     * @typedef {Object} ParentMessage.$Properties
     * @property {string|null} [message] ParentMessage message
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a ParentMessage.
     * @exports IParentMessage
     * @interface IParentMessage
     * @augments ParentMessage.$Properties
     * @deprecated Use ParentMessage.$Properties instead.
     */

    /**
     * Shape of a ParentMessage.
     * @typedef {ParentMessage.$Properties} ParentMessage.$Shape
     */

    /**
     * Constructs a new ParentMessage.
     * @exports ParentMessage
     * @classdesc Represents a ParentMessage.
     * @constructor
     * @param {ParentMessage.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const ParentMessage = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * ParentMessage message.
     * @member {string} message
     * @memberof ParentMessage
     * @instance
     */
    ParentMessage.prototype.message = "";

    /**
     * Creates a new ParentMessage instance using the specified properties.
     * @function create
     * @memberof ParentMessage
     * @static
     * @param {ParentMessage.$Properties=} [properties] Properties to set
     * @returns {ParentMessage} ParentMessage instance
     * @type {{
     *   (properties: ParentMessage.$Shape): ParentMessage & ParentMessage.$Shape;
     *   (properties?: ParentMessage.$Properties): ParentMessage;
     * }}
     */
    ParentMessage.create = function(properties) {
        return new ParentMessage(properties);
    };

    /**
     * Encodes the specified ParentMessage message. Does not implicitly {@link ParentMessage.verify|verify} messages.
     * @function encode
     * @memberof ParentMessage
     * @static
     * @param {ParentMessage.$Properties} message ParentMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ParentMessage.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.message != null && $Object.hasOwnProperty.call(message, "message") && message.message !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a ParentMessage message from the specified reader or buffer.
     * @function decode
     * @memberof ParentMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ParentMessage & ParentMessage.$Shape} ParentMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ParentMessage.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.ParentMessage();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.message = value;
                    else
                        delete message.message;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a ParentMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ParentMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ParentMessage} ParentMessage
     */
    ParentMessage.fromObject = function (object, _depth) {
        if (object instanceof $root.ParentMessage)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".ParentMessage: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.ParentMessage();
        if (object.message != null)
            if (typeof object.message !== "string" || object.message.length)
                message.message = $String(object.message);
        return message;
    };

    /**
     * Creates a plain object from a ParentMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ParentMessage
     * @static
     * @param {ParentMessage} message ParentMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ParentMessage.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults)
            object.message = "";
        if (message.message != null && $Object.hasOwnProperty.call(message, "message"))
            object.message = message.message;
        return object;
    };

    /**
     * Converts this ParentMessage to JSON.
     * @function toJSON
     * @memberof ParentMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ParentMessage.prototype.toJSON = function() {
        return ParentMessage.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for ParentMessage
     * @function getTypeUrl
     * @memberof ParentMessage
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    ParentMessage.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/ParentMessage";
    };

    return ParentMessage;
})();

export const SessionEvent = $root.SessionEvent = (() => {

    /**
     * Properties of a SessionEvent.
     * @typedef {Object} SessionEvent.$Properties
     * @property {boolean|null} [scriptChangedOnDisk] SessionEvent scriptChangedOnDisk
     * @property {boolean|null} [scriptWasManuallyStopped] SessionEvent scriptWasManuallyStopped
     * @property {Exception.$Properties|null} [scriptCompilationException] SessionEvent scriptCompilationException
     * @property {"scriptChangedOnDisk"|"scriptWasManuallyStopped"|"scriptCompilationException"} [type] SessionEvent type
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a SessionEvent.
     * @exports ISessionEvent
     * @interface ISessionEvent
     * @augments SessionEvent.$Properties
     * @deprecated Use SessionEvent.$Properties instead.
     */

    /**
     * Narrowed shape of a SessionEvent.
     * @typedef {{
     *   scriptChangedOnDisk?: boolean|null;
     *   scriptWasManuallyStopped?: boolean|null;
     *   scriptCompilationException?: Exception.$Shape|null;
     *   $unknowns?: Array.<Uint8Array>;
     * } & (
     *   ({ type?: undefined; scriptChangedOnDisk?: null; scriptWasManuallyStopped?: null; scriptCompilationException?: null }|{ type?: "scriptChangedOnDisk"; scriptChangedOnDisk: boolean; scriptWasManuallyStopped?: null; scriptCompilationException?: null }|{ type?: "scriptWasManuallyStopped"; scriptChangedOnDisk?: null; scriptWasManuallyStopped: boolean; scriptCompilationException?: null }|{ type?: "scriptCompilationException"; scriptChangedOnDisk?: null; scriptWasManuallyStopped?: null; scriptCompilationException: Exception.$Shape })
     * )} SessionEvent.$Shape
     */

    /**
     * Constructs a new SessionEvent.
     * @exports SessionEvent
     * @classdesc Represents a SessionEvent.
     * @constructor
     * @param {SessionEvent.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const SessionEvent = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * SessionEvent scriptChangedOnDisk.
     * @member {boolean|null|undefined} scriptChangedOnDisk
     * @memberof SessionEvent
     * @instance
     */
    SessionEvent.prototype.scriptChangedOnDisk = null;

    /**
     * SessionEvent scriptWasManuallyStopped.
     * @member {boolean|null|undefined} scriptWasManuallyStopped
     * @memberof SessionEvent
     * @instance
     */
    SessionEvent.prototype.scriptWasManuallyStopped = null;

    /**
     * SessionEvent scriptCompilationException.
     * @member {Exception.$Properties|null|undefined} scriptCompilationException
     * @memberof SessionEvent
     * @instance
     */
    SessionEvent.prototype.scriptCompilationException = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * SessionEvent type.
     * @member {"scriptChangedOnDisk"|"scriptWasManuallyStopped"|"scriptCompilationException"|undefined} type
     * @memberof SessionEvent
     * @instance
     */
    $Object.defineProperty(SessionEvent.prototype, "type", {
        get: $util.oneOfGetter($oneOfFields = ["scriptChangedOnDisk", "scriptWasManuallyStopped", "scriptCompilationException"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new SessionEvent instance using the specified properties.
     * @function create
     * @memberof SessionEvent
     * @static
     * @param {SessionEvent.$Properties=} [properties] Properties to set
     * @returns {SessionEvent} SessionEvent instance
     * @type {{
     *   (properties: SessionEvent.$Shape): SessionEvent & SessionEvent.$Shape;
     *   (properties?: SessionEvent.$Properties): SessionEvent;
     * }}
     */
    SessionEvent.create = function(properties) {
        return new SessionEvent(properties);
    };

    /**
     * Encodes the specified SessionEvent message. Does not implicitly {@link SessionEvent.verify|verify} messages.
     * @function encode
     * @memberof SessionEvent
     * @static
     * @param {SessionEvent.$Properties} message SessionEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SessionEvent.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.scriptChangedOnDisk != null && $Object.hasOwnProperty.call(message, "scriptChangedOnDisk"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.scriptChangedOnDisk);
        if (message.scriptWasManuallyStopped != null && $Object.hasOwnProperty.call(message, "scriptWasManuallyStopped"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.scriptWasManuallyStopped);
        if (message.scriptCompilationException != null && $Object.hasOwnProperty.call(message, "scriptCompilationException"))
            $root.Exception.encode(message.scriptCompilationException, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a SessionEvent message from the specified reader or buffer.
     * @function decode
     * @memberof SessionEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SessionEvent & SessionEvent.$Shape} SessionEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SessionEvent.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.SessionEvent();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 0)
                        break;
                    message.scriptChangedOnDisk = reader.bool();
                    message.type = "scriptChangedOnDisk";
                    continue;
                }
            case 2: {
                    if (wireType !== 0)
                        break;
                    message.scriptWasManuallyStopped = reader.bool();
                    message.type = "scriptWasManuallyStopped";
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    message.scriptCompilationException = $root.Exception.decode(reader, reader.uint32(), $undefined, _depth + 1, message.scriptCompilationException);
                    message.type = "scriptCompilationException";
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a SessionEvent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SessionEvent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SessionEvent} SessionEvent
     */
    SessionEvent.fromObject = function (object, _depth) {
        if (object instanceof $root.SessionEvent)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".SessionEvent: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.SessionEvent();
        if (object.scriptChangedOnDisk != null)
            message.scriptChangedOnDisk = $Boolean(object.scriptChangedOnDisk);
        if (object.scriptWasManuallyStopped != null)
            message.scriptWasManuallyStopped = $Boolean(object.scriptWasManuallyStopped);
        if (object.scriptCompilationException != null) {
            if (!$util.isObject(object.scriptCompilationException))
                throw $TypeError(".SessionEvent.scriptCompilationException: object expected");
            message.scriptCompilationException = $root.Exception.fromObject(object.scriptCompilationException, _depth + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a SessionEvent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SessionEvent
     * @static
     * @param {SessionEvent} message SessionEvent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SessionEvent.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (message.scriptChangedOnDisk != null && $Object.hasOwnProperty.call(message, "scriptChangedOnDisk")) {
            object.scriptChangedOnDisk = message.scriptChangedOnDisk;
            if (options.oneofs)
                object.type = "scriptChangedOnDisk";
        }
        if (message.scriptWasManuallyStopped != null && $Object.hasOwnProperty.call(message, "scriptWasManuallyStopped")) {
            object.scriptWasManuallyStopped = message.scriptWasManuallyStopped;
            if (options.oneofs)
                object.type = "scriptWasManuallyStopped";
        }
        if (message.scriptCompilationException != null && $Object.hasOwnProperty.call(message, "scriptCompilationException")) {
            object.scriptCompilationException = $root.Exception.toObject(message.scriptCompilationException, options, _depth + 1);
            if (options.oneofs)
                object.type = "scriptCompilationException";
        }
        return object;
    };

    /**
     * Converts this SessionEvent to JSON.
     * @function toJSON
     * @memberof SessionEvent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SessionEvent.prototype.toJSON = function() {
        return SessionEvent.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for SessionEvent
     * @function getTypeUrl
     * @memberof SessionEvent
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    SessionEvent.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/SessionEvent";
    };

    return SessionEvent;
})();

export const MetricsEvent = $root.MetricsEvent = (() => {

    /**
     * Properties of a MetricsEvent.
     * @typedef {Object} MetricsEvent.$Properties
     * @property {string|null} [event] MetricsEvent event
     * @property {string|null} [anonymousId] MetricsEvent anonymousId
     * @property {string|null} [machineIdV3] MetricsEvent machineIdV3
     * @property {string|null} [machineIdV4] MetricsEvent machineIdV4
     * @property {string|null} [reportHash] MetricsEvent reportHash
     * @property {boolean|null} [dev] MetricsEvent dev
     * @property {string|null} [source] MetricsEvent source
     * @property {string|null} [streamlitVersion] MetricsEvent streamlitVersion
     * @property {boolean|null} [isHello] MetricsEvent isHello
     * @property {string|null} [appId] MetricsEvent appId
     * @property {string|null} [sessionId] MetricsEvent sessionId
     * @property {string|null} [pythonVersion] MetricsEvent pythonVersion
     * @property {string|null} [serverOs] MetricsEvent serverOs
     * @property {boolean|null} [hasDisplay] MetricsEvent hasDisplay
     * @property {boolean|null} [isWebdriver] MetricsEvent isWebdriver
     * @property {string|null} [hostedAt] MetricsEvent hostedAt
     * @property {string|null} [owner] MetricsEvent owner
     * @property {string|null} [repo] MetricsEvent repo
     * @property {string|null} [branch] MetricsEvent branch
     * @property {string|null} [mainModule] MetricsEvent mainModule
     * @property {string|null} [creatorId] MetricsEvent creatorId
     * @property {string|null} [contextPageUrl] MetricsEvent contextPageUrl
     * @property {string|null} [contextPageTitle] MetricsEvent contextPageTitle
     * @property {string|null} [contextPagePath] MetricsEvent contextPagePath
     * @property {string|null} [contextPageReferrer] MetricsEvent contextPageReferrer
     * @property {string|null} [contextPageSearch] MetricsEvent contextPageSearch
     * @property {string|null} [contextLocale] MetricsEvent contextLocale
     * @property {string|null} [contextUserAgent] MetricsEvent contextUserAgent
     * @property {string|null} [label] MetricsEvent label
     * @property {string|null} [surface] MetricsEvent surface
     * @property {Array.<Command.$Properties>|null} [commands] MetricsEvent commands
     * @property {number|Long|null} [execTime] MetricsEvent execTime
     * @property {number|Long|null} [prepTime] MetricsEvent prepTime
     * @property {Array.<string>|null} [config] MetricsEvent config
     * @property {string|null} [uncaughtException] MetricsEvent uncaughtException
     * @property {Array.<string>|null} [attributions] MetricsEvent attributions
     * @property {string|null} [os] MetricsEvent os
     * @property {string|null} [timezone] MetricsEvent timezone
     * @property {boolean|null} [headless] MetricsEvent headless
     * @property {boolean|null} [isFragmentRun] MetricsEvent isFragmentRun
     * @property {number|Long|null} [numPages] MetricsEvent numPages
     * @property {string|null} [pageScriptHash] MetricsEvent pageScriptHash
     * @property {string|null} [activeTheme] MetricsEvent activeTheme
     * @property {number|Long|null} [totalLoadTime] MetricsEvent totalLoadTime
     * @property {BrowserInfo.$Properties|null} [browserInfo] MetricsEvent browserInfo
     * @property {string|null} [serverMode] MetricsEvent serverMode
     * @property {Array.<string>|null} [installedSkills] MetricsEvent installedSkills
     * @property {Array.<string>|null} [installedAgents] MetricsEvent installedAgents
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a MetricsEvent.
     * @exports IMetricsEvent
     * @interface IMetricsEvent
     * @augments MetricsEvent.$Properties
     * @deprecated Use MetricsEvent.$Properties instead.
     */

    /**
     * Shape of a MetricsEvent.
     * @typedef {MetricsEvent.$Properties} MetricsEvent.$Shape
     */

    /**
     * Constructs a new MetricsEvent.
     * @exports MetricsEvent
     * @classdesc Represents a MetricsEvent.
     * @constructor
     * @param {MetricsEvent.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const MetricsEvent = function (properties) {
        this.commands = [];
        this.config = [];
        this.attributions = [];
        this.installedSkills = [];
        this.installedAgents = [];
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * MetricsEvent event.
     * @member {string} event
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.event = "";

    /**
     * MetricsEvent anonymousId.
     * @member {string} anonymousId
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.anonymousId = "";

    /**
     * MetricsEvent machineIdV3.
     * @member {string} machineIdV3
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.machineIdV3 = "";

    /**
     * MetricsEvent machineIdV4.
     * @member {string} machineIdV4
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.machineIdV4 = "";

    /**
     * MetricsEvent reportHash.
     * @member {string} reportHash
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.reportHash = "";

    /**
     * MetricsEvent dev.
     * @member {boolean} dev
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.dev = false;

    /**
     * MetricsEvent source.
     * @member {string} source
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.source = "";

    /**
     * MetricsEvent streamlitVersion.
     * @member {string} streamlitVersion
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.streamlitVersion = "";

    /**
     * MetricsEvent isHello.
     * @member {boolean} isHello
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.isHello = false;

    /**
     * MetricsEvent appId.
     * @member {string} appId
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.appId = "";

    /**
     * MetricsEvent sessionId.
     * @member {string} sessionId
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.sessionId = "";

    /**
     * MetricsEvent pythonVersion.
     * @member {string} pythonVersion
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.pythonVersion = "";

    /**
     * MetricsEvent serverOs.
     * @member {string} serverOs
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.serverOs = "";

    /**
     * MetricsEvent hasDisplay.
     * @member {boolean} hasDisplay
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.hasDisplay = false;

    /**
     * MetricsEvent isWebdriver.
     * @member {boolean} isWebdriver
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.isWebdriver = false;

    /**
     * MetricsEvent hostedAt.
     * @member {string} hostedAt
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.hostedAt = "";

    /**
     * MetricsEvent owner.
     * @member {string} owner
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.owner = "";

    /**
     * MetricsEvent repo.
     * @member {string} repo
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.repo = "";

    /**
     * MetricsEvent branch.
     * @member {string} branch
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.branch = "";

    /**
     * MetricsEvent mainModule.
     * @member {string} mainModule
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.mainModule = "";

    /**
     * MetricsEvent creatorId.
     * @member {string} creatorId
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.creatorId = "";

    /**
     * MetricsEvent contextPageUrl.
     * @member {string} contextPageUrl
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.contextPageUrl = "";

    /**
     * MetricsEvent contextPageTitle.
     * @member {string} contextPageTitle
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.contextPageTitle = "";

    /**
     * MetricsEvent contextPagePath.
     * @member {string} contextPagePath
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.contextPagePath = "";

    /**
     * MetricsEvent contextPageReferrer.
     * @member {string} contextPageReferrer
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.contextPageReferrer = "";

    /**
     * MetricsEvent contextPageSearch.
     * @member {string} contextPageSearch
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.contextPageSearch = "";

    /**
     * MetricsEvent contextLocale.
     * @member {string} contextLocale
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.contextLocale = "";

    /**
     * MetricsEvent contextUserAgent.
     * @member {string} contextUserAgent
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.contextUserAgent = "";

    /**
     * MetricsEvent label.
     * @member {string} label
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.label = "";

    /**
     * MetricsEvent surface.
     * @member {string} surface
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.surface = "";

    /**
     * MetricsEvent commands.
     * @member {Array.<Command.$Properties>} commands
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.commands = $util.emptyArray;

    /**
     * MetricsEvent execTime.
     * @member {number|Long} execTime
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.execTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * MetricsEvent prepTime.
     * @member {number|Long} prepTime
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.prepTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * MetricsEvent config.
     * @member {Array.<string>} config
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.config = $util.emptyArray;

    /**
     * MetricsEvent uncaughtException.
     * @member {string} uncaughtException
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.uncaughtException = "";

    /**
     * MetricsEvent attributions.
     * @member {Array.<string>} attributions
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.attributions = $util.emptyArray;

    /**
     * MetricsEvent os.
     * @member {string} os
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.os = "";

    /**
     * MetricsEvent timezone.
     * @member {string} timezone
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.timezone = "";

    /**
     * MetricsEvent headless.
     * @member {boolean} headless
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.headless = false;

    /**
     * MetricsEvent isFragmentRun.
     * @member {boolean} isFragmentRun
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.isFragmentRun = false;

    /**
     * MetricsEvent numPages.
     * @member {number|Long} numPages
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.numPages = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * MetricsEvent pageScriptHash.
     * @member {string} pageScriptHash
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.pageScriptHash = "";

    /**
     * MetricsEvent activeTheme.
     * @member {string} activeTheme
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.activeTheme = "";

    /**
     * MetricsEvent totalLoadTime.
     * @member {number|Long} totalLoadTime
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.totalLoadTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * MetricsEvent browserInfo.
     * @member {BrowserInfo.$Properties|null|undefined} browserInfo
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.browserInfo = null;

    /**
     * MetricsEvent serverMode.
     * @member {string} serverMode
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.serverMode = "";

    /**
     * MetricsEvent installedSkills.
     * @member {Array.<string>} installedSkills
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.installedSkills = $util.emptyArray;

    /**
     * MetricsEvent installedAgents.
     * @member {Array.<string>} installedAgents
     * @memberof MetricsEvent
     * @instance
     */
    MetricsEvent.prototype.installedAgents = $util.emptyArray;

    /**
     * Creates a new MetricsEvent instance using the specified properties.
     * @function create
     * @memberof MetricsEvent
     * @static
     * @param {MetricsEvent.$Properties=} [properties] Properties to set
     * @returns {MetricsEvent} MetricsEvent instance
     * @type {{
     *   (properties: MetricsEvent.$Shape): MetricsEvent & MetricsEvent.$Shape;
     *   (properties?: MetricsEvent.$Properties): MetricsEvent;
     * }}
     */
    MetricsEvent.create = function(properties) {
        return new MetricsEvent(properties);
    };

    /**
     * Encodes the specified MetricsEvent message. Does not implicitly {@link MetricsEvent.verify|verify} messages.
     * @function encode
     * @memberof MetricsEvent
     * @static
     * @param {MetricsEvent.$Properties} message MetricsEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MetricsEvent.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.event != null && $Object.hasOwnProperty.call(message, "event") && message.event !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.event);
        if (message.anonymousId != null && $Object.hasOwnProperty.call(message, "anonymousId") && message.anonymousId !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.anonymousId);
        if (message.machineIdV3 != null && $Object.hasOwnProperty.call(message, "machineIdV3") && message.machineIdV3 !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.machineIdV3);
        if (message.reportHash != null && $Object.hasOwnProperty.call(message, "reportHash") && message.reportHash !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.reportHash);
        if (message.dev != null && $Object.hasOwnProperty.call(message, "dev") && message.dev !== false)
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.dev);
        if (message.source != null && $Object.hasOwnProperty.call(message, "source") && message.source !== "")
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.source);
        if (message.streamlitVersion != null && $Object.hasOwnProperty.call(message, "streamlitVersion") && message.streamlitVersion !== "")
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.streamlitVersion);
        if (message.isHello != null && $Object.hasOwnProperty.call(message, "isHello") && message.isHello !== false)
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isHello);
        if (message.hostedAt != null && $Object.hasOwnProperty.call(message, "hostedAt") && message.hostedAt !== "")
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.hostedAt);
        if (message.owner != null && $Object.hasOwnProperty.call(message, "owner") && message.owner !== "")
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.owner);
        if (message.repo != null && $Object.hasOwnProperty.call(message, "repo") && message.repo !== "")
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.repo);
        if (message.branch != null && $Object.hasOwnProperty.call(message, "branch") && message.branch !== "")
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.branch);
        if (message.mainModule != null && $Object.hasOwnProperty.call(message, "mainModule") && message.mainModule !== "")
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.mainModule);
        if (message.creatorId != null && $Object.hasOwnProperty.call(message, "creatorId") && message.creatorId !== "")
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.creatorId);
        if (message.contextPageUrl != null && $Object.hasOwnProperty.call(message, "contextPageUrl") && message.contextPageUrl !== "")
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.contextPageUrl);
        if (message.contextPageTitle != null && $Object.hasOwnProperty.call(message, "contextPageTitle") && message.contextPageTitle !== "")
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.contextPageTitle);
        if (message.contextPagePath != null && $Object.hasOwnProperty.call(message, "contextPagePath") && message.contextPagePath !== "")
            writer.uint32(/* id 17, wireType 2 =*/138).string(message.contextPagePath);
        if (message.contextPageReferrer != null && $Object.hasOwnProperty.call(message, "contextPageReferrer") && message.contextPageReferrer !== "")
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.contextPageReferrer);
        if (message.contextPageSearch != null && $Object.hasOwnProperty.call(message, "contextPageSearch") && message.contextPageSearch !== "")
            writer.uint32(/* id 19, wireType 2 =*/154).string(message.contextPageSearch);
        if (message.contextLocale != null && $Object.hasOwnProperty.call(message, "contextLocale") && message.contextLocale !== "")
            writer.uint32(/* id 20, wireType 2 =*/162).string(message.contextLocale);
        if (message.contextUserAgent != null && $Object.hasOwnProperty.call(message, "contextUserAgent") && message.contextUserAgent !== "")
            writer.uint32(/* id 21, wireType 2 =*/170).string(message.contextUserAgent);
        if (message.label != null && $Object.hasOwnProperty.call(message, "label") && message.label !== "")
            writer.uint32(/* id 22, wireType 2 =*/178).string(message.label);
        if (message.commands != null && message.commands.length)
            for (let i = 0; i < message.commands.length; ++i)
                $root.Command.encode(message.commands[i], writer.uint32(/* id 23, wireType 2 =*/186).fork(), _depth + 1).ldelim();
        if (message.execTime != null && $Object.hasOwnProperty.call(message, "execTime") && (typeof message.execTime === "object" ? message.execTime.low || message.execTime.high : message.execTime !== 0))
            writer.uint32(/* id 24, wireType 0 =*/192).int64(message.execTime);
        if (message.prepTime != null && $Object.hasOwnProperty.call(message, "prepTime") && (typeof message.prepTime === "object" ? message.prepTime.low || message.prepTime.high : message.prepTime !== 0))
            writer.uint32(/* id 25, wireType 0 =*/200).int64(message.prepTime);
        if (message.config != null && message.config.length)
            for (let i = 0; i < message.config.length; ++i)
                writer.uint32(/* id 26, wireType 2 =*/210).string(message.config[i]);
        if (message.uncaughtException != null && $Object.hasOwnProperty.call(message, "uncaughtException") && message.uncaughtException !== "")
            writer.uint32(/* id 27, wireType 2 =*/218).string(message.uncaughtException);
        if (message.attributions != null && message.attributions.length)
            for (let i = 0; i < message.attributions.length; ++i)
                writer.uint32(/* id 28, wireType 2 =*/226).string(message.attributions[i]);
        if (message.os != null && $Object.hasOwnProperty.call(message, "os") && message.os !== "")
            writer.uint32(/* id 29, wireType 2 =*/234).string(message.os);
        if (message.timezone != null && $Object.hasOwnProperty.call(message, "timezone") && message.timezone !== "")
            writer.uint32(/* id 30, wireType 2 =*/242).string(message.timezone);
        if (message.headless != null && $Object.hasOwnProperty.call(message, "headless") && message.headless !== false)
            writer.uint32(/* id 31, wireType 0 =*/248).bool(message.headless);
        if (message.isFragmentRun != null && $Object.hasOwnProperty.call(message, "isFragmentRun") && message.isFragmentRun !== false)
            writer.uint32(/* id 32, wireType 0 =*/256).bool(message.isFragmentRun);
        if (message.appId != null && $Object.hasOwnProperty.call(message, "appId") && message.appId !== "")
            writer.uint32(/* id 33, wireType 2 =*/266).string(message.appId);
        if (message.numPages != null && $Object.hasOwnProperty.call(message, "numPages") && (typeof message.numPages === "object" ? message.numPages.low || message.numPages.high : message.numPages !== 0))
            writer.uint32(/* id 34, wireType 0 =*/272).int64(message.numPages);
        if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId") && message.sessionId !== "")
            writer.uint32(/* id 35, wireType 2 =*/282).string(message.sessionId);
        if (message.pythonVersion != null && $Object.hasOwnProperty.call(message, "pythonVersion") && message.pythonVersion !== "")
            writer.uint32(/* id 36, wireType 2 =*/290).string(message.pythonVersion);
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash") && message.pageScriptHash !== "")
            writer.uint32(/* id 37, wireType 2 =*/298).string(message.pageScriptHash);
        if (message.activeTheme != null && $Object.hasOwnProperty.call(message, "activeTheme") && message.activeTheme !== "")
            writer.uint32(/* id 38, wireType 2 =*/306).string(message.activeTheme);
        if (message.totalLoadTime != null && $Object.hasOwnProperty.call(message, "totalLoadTime") && (typeof message.totalLoadTime === "object" ? message.totalLoadTime.low || message.totalLoadTime.high : message.totalLoadTime !== 0))
            writer.uint32(/* id 39, wireType 0 =*/312).int64(message.totalLoadTime);
        if (message.browserInfo != null && $Object.hasOwnProperty.call(message, "browserInfo"))
            $root.BrowserInfo.encode(message.browserInfo, writer.uint32(/* id 40, wireType 2 =*/322).fork(), _depth + 1).ldelim();
        if (message.machineIdV4 != null && $Object.hasOwnProperty.call(message, "machineIdV4") && message.machineIdV4 !== "")
            writer.uint32(/* id 41, wireType 2 =*/330).string(message.machineIdV4);
        if (message.serverOs != null && $Object.hasOwnProperty.call(message, "serverOs") && message.serverOs !== "")
            writer.uint32(/* id 42, wireType 2 =*/338).string(message.serverOs);
        if (message.hasDisplay != null && $Object.hasOwnProperty.call(message, "hasDisplay") && message.hasDisplay !== false)
            writer.uint32(/* id 43, wireType 0 =*/344).bool(message.hasDisplay);
        if (message.isWebdriver != null && $Object.hasOwnProperty.call(message, "isWebdriver") && message.isWebdriver !== false)
            writer.uint32(/* id 44, wireType 0 =*/352).bool(message.isWebdriver);
        if (message.serverMode != null && $Object.hasOwnProperty.call(message, "serverMode") && message.serverMode !== "")
            writer.uint32(/* id 45, wireType 2 =*/362).string(message.serverMode);
        if (message.installedSkills != null && message.installedSkills.length)
            for (let i = 0; i < message.installedSkills.length; ++i)
                writer.uint32(/* id 46, wireType 2 =*/370).string(message.installedSkills[i]);
        if (message.installedAgents != null && message.installedAgents.length)
            for (let i = 0; i < message.installedAgents.length; ++i)
                writer.uint32(/* id 47, wireType 2 =*/378).string(message.installedAgents[i]);
        if (message.surface != null && $Object.hasOwnProperty.call(message, "surface") && message.surface !== "")
            writer.uint32(/* id 48, wireType 2 =*/386).string(message.surface);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a MetricsEvent message from the specified reader or buffer.
     * @function decode
     * @memberof MetricsEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MetricsEvent & MetricsEvent.$Shape} MetricsEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MetricsEvent.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.MetricsEvent();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.event = value;
                    else
                        delete message.event;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.anonymousId = value;
                    else
                        delete message.anonymousId;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.machineIdV3 = value;
                    else
                        delete message.machineIdV3;
                    continue;
                }
            case 41: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.machineIdV4 = value;
                    else
                        delete message.machineIdV4;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.reportHash = value;
                    else
                        delete message.reportHash;
                    continue;
                }
            case 5: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.dev = value;
                    else
                        delete message.dev;
                    continue;
                }
            case 6: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.source = value;
                    else
                        delete message.source;
                    continue;
                }
            case 7: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.streamlitVersion = value;
                    else
                        delete message.streamlitVersion;
                    continue;
                }
            case 8: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isHello = value;
                    else
                        delete message.isHello;
                    continue;
                }
            case 33: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.appId = value;
                    else
                        delete message.appId;
                    continue;
                }
            case 35: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.sessionId = value;
                    else
                        delete message.sessionId;
                    continue;
                }
            case 36: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pythonVersion = value;
                    else
                        delete message.pythonVersion;
                    continue;
                }
            case 42: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.serverOs = value;
                    else
                        delete message.serverOs;
                    continue;
                }
            case 43: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.hasDisplay = value;
                    else
                        delete message.hasDisplay;
                    continue;
                }
            case 44: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isWebdriver = value;
                    else
                        delete message.isWebdriver;
                    continue;
                }
            case 9: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.hostedAt = value;
                    else
                        delete message.hostedAt;
                    continue;
                }
            case 10: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.owner = value;
                    else
                        delete message.owner;
                    continue;
                }
            case 11: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.repo = value;
                    else
                        delete message.repo;
                    continue;
                }
            case 12: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.branch = value;
                    else
                        delete message.branch;
                    continue;
                }
            case 13: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.mainModule = value;
                    else
                        delete message.mainModule;
                    continue;
                }
            case 14: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.creatorId = value;
                    else
                        delete message.creatorId;
                    continue;
                }
            case 15: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.contextPageUrl = value;
                    else
                        delete message.contextPageUrl;
                    continue;
                }
            case 16: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.contextPageTitle = value;
                    else
                        delete message.contextPageTitle;
                    continue;
                }
            case 17: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.contextPagePath = value;
                    else
                        delete message.contextPagePath;
                    continue;
                }
            case 18: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.contextPageReferrer = value;
                    else
                        delete message.contextPageReferrer;
                    continue;
                }
            case 19: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.contextPageSearch = value;
                    else
                        delete message.contextPageSearch;
                    continue;
                }
            case 20: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.contextLocale = value;
                    else
                        delete message.contextLocale;
                    continue;
                }
            case 21: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.contextUserAgent = value;
                    else
                        delete message.contextUserAgent;
                    continue;
                }
            case 22: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.label = value;
                    else
                        delete message.label;
                    continue;
                }
            case 48: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.surface = value;
                    else
                        delete message.surface;
                    continue;
                }
            case 23: {
                    if (wireType !== 2)
                        break;
                    if (!(message.commands && message.commands.length))
                        message.commands = [];
                    message.commands.push($root.Command.decode(reader, reader.uint32(), $undefined, _depth + 1));
                    continue;
                }
            case 24: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                        message.execTime = value;
                    else
                        delete message.execTime;
                    continue;
                }
            case 25: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                        message.prepTime = value;
                    else
                        delete message.prepTime;
                    continue;
                }
            case 26: {
                    if (wireType !== 2)
                        break;
                    if (!(message.config && message.config.length))
                        message.config = [];
                    message.config.push(reader.stringVerify());
                    continue;
                }
            case 27: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.uncaughtException = value;
                    else
                        delete message.uncaughtException;
                    continue;
                }
            case 28: {
                    if (wireType !== 2)
                        break;
                    if (!(message.attributions && message.attributions.length))
                        message.attributions = [];
                    message.attributions.push(reader.stringVerify());
                    continue;
                }
            case 29: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.os = value;
                    else
                        delete message.os;
                    continue;
                }
            case 30: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.timezone = value;
                    else
                        delete message.timezone;
                    continue;
                }
            case 31: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.headless = value;
                    else
                        delete message.headless;
                    continue;
                }
            case 32: {
                    if (wireType !== 0)
                        break;
                    if (value = reader.bool())
                        message.isFragmentRun = value;
                    else
                        delete message.isFragmentRun;
                    continue;
                }
            case 34: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                        message.numPages = value;
                    else
                        delete message.numPages;
                    continue;
                }
            case 37: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.pageScriptHash = value;
                    else
                        delete message.pageScriptHash;
                    continue;
                }
            case 38: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.activeTheme = value;
                    else
                        delete message.activeTheme;
                    continue;
                }
            case 39: {
                    if (wireType !== 0)
                        break;
                    if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                        message.totalLoadTime = value;
                    else
                        delete message.totalLoadTime;
                    continue;
                }
            case 40: {
                    if (wireType !== 2)
                        break;
                    message.browserInfo = $root.BrowserInfo.decode(reader, reader.uint32(), $undefined, _depth + 1, message.browserInfo);
                    continue;
                }
            case 45: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.serverMode = value;
                    else
                        delete message.serverMode;
                    continue;
                }
            case 46: {
                    if (wireType !== 2)
                        break;
                    if (!(message.installedSkills && message.installedSkills.length))
                        message.installedSkills = [];
                    message.installedSkills.push(reader.stringVerify());
                    continue;
                }
            case 47: {
                    if (wireType !== 2)
                        break;
                    if (!(message.installedAgents && message.installedAgents.length))
                        message.installedAgents = [];
                    message.installedAgents.push(reader.stringVerify());
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a MetricsEvent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MetricsEvent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MetricsEvent} MetricsEvent
     */
    MetricsEvent.fromObject = function (object, _depth) {
        if (object instanceof $root.MetricsEvent)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".MetricsEvent: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.MetricsEvent();
        if (object.event != null)
            if (typeof object.event !== "string" || object.event.length)
                message.event = $String(object.event);
        if (object.anonymousId != null)
            if (typeof object.anonymousId !== "string" || object.anonymousId.length)
                message.anonymousId = $String(object.anonymousId);
        if (object.machineIdV3 != null)
            if (typeof object.machineIdV3 !== "string" || object.machineIdV3.length)
                message.machineIdV3 = $String(object.machineIdV3);
        if (object.machineIdV4 != null)
            if (typeof object.machineIdV4 !== "string" || object.machineIdV4.length)
                message.machineIdV4 = $String(object.machineIdV4);
        if (object.reportHash != null)
            if (typeof object.reportHash !== "string" || object.reportHash.length)
                message.reportHash = $String(object.reportHash);
        if (object.dev != null)
            if (object.dev)
                message.dev = $Boolean(object.dev);
        if (object.source != null)
            if (typeof object.source !== "string" || object.source.length)
                message.source = $String(object.source);
        if (object.streamlitVersion != null)
            if (typeof object.streamlitVersion !== "string" || object.streamlitVersion.length)
                message.streamlitVersion = $String(object.streamlitVersion);
        if (object.isHello != null)
            if (object.isHello)
                message.isHello = $Boolean(object.isHello);
        if (object.appId != null)
            if (typeof object.appId !== "string" || object.appId.length)
                message.appId = $String(object.appId);
        if (object.sessionId != null)
            if (typeof object.sessionId !== "string" || object.sessionId.length)
                message.sessionId = $String(object.sessionId);
        if (object.pythonVersion != null)
            if (typeof object.pythonVersion !== "string" || object.pythonVersion.length)
                message.pythonVersion = $String(object.pythonVersion);
        if (object.serverOs != null)
            if (typeof object.serverOs !== "string" || object.serverOs.length)
                message.serverOs = $String(object.serverOs);
        if (object.hasDisplay != null)
            if (object.hasDisplay)
                message.hasDisplay = $Boolean(object.hasDisplay);
        if (object.isWebdriver != null)
            if (object.isWebdriver)
                message.isWebdriver = $Boolean(object.isWebdriver);
        if (object.hostedAt != null)
            if (typeof object.hostedAt !== "string" || object.hostedAt.length)
                message.hostedAt = $String(object.hostedAt);
        if (object.owner != null)
            if (typeof object.owner !== "string" || object.owner.length)
                message.owner = $String(object.owner);
        if (object.repo != null)
            if (typeof object.repo !== "string" || object.repo.length)
                message.repo = $String(object.repo);
        if (object.branch != null)
            if (typeof object.branch !== "string" || object.branch.length)
                message.branch = $String(object.branch);
        if (object.mainModule != null)
            if (typeof object.mainModule !== "string" || object.mainModule.length)
                message.mainModule = $String(object.mainModule);
        if (object.creatorId != null)
            if (typeof object.creatorId !== "string" || object.creatorId.length)
                message.creatorId = $String(object.creatorId);
        if (object.contextPageUrl != null)
            if (typeof object.contextPageUrl !== "string" || object.contextPageUrl.length)
                message.contextPageUrl = $String(object.contextPageUrl);
        if (object.contextPageTitle != null)
            if (typeof object.contextPageTitle !== "string" || object.contextPageTitle.length)
                message.contextPageTitle = $String(object.contextPageTitle);
        if (object.contextPagePath != null)
            if (typeof object.contextPagePath !== "string" || object.contextPagePath.length)
                message.contextPagePath = $String(object.contextPagePath);
        if (object.contextPageReferrer != null)
            if (typeof object.contextPageReferrer !== "string" || object.contextPageReferrer.length)
                message.contextPageReferrer = $String(object.contextPageReferrer);
        if (object.contextPageSearch != null)
            if (typeof object.contextPageSearch !== "string" || object.contextPageSearch.length)
                message.contextPageSearch = $String(object.contextPageSearch);
        if (object.contextLocale != null)
            if (typeof object.contextLocale !== "string" || object.contextLocale.length)
                message.contextLocale = $String(object.contextLocale);
        if (object.contextUserAgent != null)
            if (typeof object.contextUserAgent !== "string" || object.contextUserAgent.length)
                message.contextUserAgent = $String(object.contextUserAgent);
        if (object.label != null)
            if (typeof object.label !== "string" || object.label.length)
                message.label = $String(object.label);
        if (object.surface != null)
            if (typeof object.surface !== "string" || object.surface.length)
                message.surface = $String(object.surface);
        if (object.commands) {
            if (!$Array.isArray(object.commands))
                throw $TypeError(".MetricsEvent.commands: array expected");
            message.commands = $Array(object.commands.length);
            for (let i = 0; i < object.commands.length; ++i) {
                if (!$util.isObject(object.commands[i]))
                    throw $TypeError(".MetricsEvent.commands: object expected");
                message.commands[i] = $root.Command.fromObject(object.commands[i], _depth + 1);
            }
        }
        if (object.execTime != null)
            if (typeof object.execTime === "object" ? object.execTime.low || object.execTime.high : $Number(object.execTime) !== 0)
                if ($util.Long)
                    message.execTime = $util.Long.fromValue(object.execTime, false);
                else if (typeof object.execTime === "string")
                    message.execTime = $parseInt(object.execTime, 10);
                else if (typeof object.execTime === "number")
                    message.execTime = object.execTime;
                else if (typeof object.execTime === "object")
                    message.execTime = new $util.LongBits(object.execTime.low >>> 0, object.execTime.high >>> 0).toNumber();
        if (object.prepTime != null)
            if (typeof object.prepTime === "object" ? object.prepTime.low || object.prepTime.high : $Number(object.prepTime) !== 0)
                if ($util.Long)
                    message.prepTime = $util.Long.fromValue(object.prepTime, false);
                else if (typeof object.prepTime === "string")
                    message.prepTime = $parseInt(object.prepTime, 10);
                else if (typeof object.prepTime === "number")
                    message.prepTime = object.prepTime;
                else if (typeof object.prepTime === "object")
                    message.prepTime = new $util.LongBits(object.prepTime.low >>> 0, object.prepTime.high >>> 0).toNumber();
        if (object.config) {
            if (!$Array.isArray(object.config))
                throw $TypeError(".MetricsEvent.config: array expected");
            message.config = $Array(object.config.length);
            for (let i = 0; i < object.config.length; ++i)
                message.config[i] = $String(object.config[i]);
        }
        if (object.uncaughtException != null)
            if (typeof object.uncaughtException !== "string" || object.uncaughtException.length)
                message.uncaughtException = $String(object.uncaughtException);
        if (object.attributions) {
            if (!$Array.isArray(object.attributions))
                throw $TypeError(".MetricsEvent.attributions: array expected");
            message.attributions = $Array(object.attributions.length);
            for (let i = 0; i < object.attributions.length; ++i)
                message.attributions[i] = $String(object.attributions[i]);
        }
        if (object.os != null)
            if (typeof object.os !== "string" || object.os.length)
                message.os = $String(object.os);
        if (object.timezone != null)
            if (typeof object.timezone !== "string" || object.timezone.length)
                message.timezone = $String(object.timezone);
        if (object.headless != null)
            if (object.headless)
                message.headless = $Boolean(object.headless);
        if (object.isFragmentRun != null)
            if (object.isFragmentRun)
                message.isFragmentRun = $Boolean(object.isFragmentRun);
        if (object.numPages != null)
            if (typeof object.numPages === "object" ? object.numPages.low || object.numPages.high : $Number(object.numPages) !== 0)
                if ($util.Long)
                    message.numPages = $util.Long.fromValue(object.numPages, false);
                else if (typeof object.numPages === "string")
                    message.numPages = $parseInt(object.numPages, 10);
                else if (typeof object.numPages === "number")
                    message.numPages = object.numPages;
                else if (typeof object.numPages === "object")
                    message.numPages = new $util.LongBits(object.numPages.low >>> 0, object.numPages.high >>> 0).toNumber();
        if (object.pageScriptHash != null)
            if (typeof object.pageScriptHash !== "string" || object.pageScriptHash.length)
                message.pageScriptHash = $String(object.pageScriptHash);
        if (object.activeTheme != null)
            if (typeof object.activeTheme !== "string" || object.activeTheme.length)
                message.activeTheme = $String(object.activeTheme);
        if (object.totalLoadTime != null)
            if (typeof object.totalLoadTime === "object" ? object.totalLoadTime.low || object.totalLoadTime.high : $Number(object.totalLoadTime) !== 0)
                if ($util.Long)
                    message.totalLoadTime = $util.Long.fromValue(object.totalLoadTime, false);
                else if (typeof object.totalLoadTime === "string")
                    message.totalLoadTime = $parseInt(object.totalLoadTime, 10);
                else if (typeof object.totalLoadTime === "number")
                    message.totalLoadTime = object.totalLoadTime;
                else if (typeof object.totalLoadTime === "object")
                    message.totalLoadTime = new $util.LongBits(object.totalLoadTime.low >>> 0, object.totalLoadTime.high >>> 0).toNumber();
        if (object.browserInfo != null) {
            if (!$util.isObject(object.browserInfo))
                throw $TypeError(".MetricsEvent.browserInfo: object expected");
            message.browserInfo = $root.BrowserInfo.fromObject(object.browserInfo, _depth + 1);
        }
        if (object.serverMode != null)
            if (typeof object.serverMode !== "string" || object.serverMode.length)
                message.serverMode = $String(object.serverMode);
        if (object.installedSkills) {
            if (!$Array.isArray(object.installedSkills))
                throw $TypeError(".MetricsEvent.installedSkills: array expected");
            message.installedSkills = $Array(object.installedSkills.length);
            for (let i = 0; i < object.installedSkills.length; ++i)
                message.installedSkills[i] = $String(object.installedSkills[i]);
        }
        if (object.installedAgents) {
            if (!$Array.isArray(object.installedAgents))
                throw $TypeError(".MetricsEvent.installedAgents: array expected");
            message.installedAgents = $Array(object.installedAgents.length);
            for (let i = 0; i < object.installedAgents.length; ++i)
                message.installedAgents[i] = $String(object.installedAgents[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a MetricsEvent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MetricsEvent
     * @static
     * @param {MetricsEvent} message MetricsEvent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MetricsEvent.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.arrays || options.defaults) {
            object.commands = [];
            object.config = [];
            object.attributions = [];
            object.installedSkills = [];
            object.installedAgents = [];
        }
        if (options.defaults) {
            object.event = "";
            object.anonymousId = "";
            object.machineIdV3 = "";
            object.reportHash = "";
            object.dev = false;
            object.source = "";
            object.streamlitVersion = "";
            object.isHello = false;
            object.hostedAt = "";
            object.owner = "";
            object.repo = "";
            object.branch = "";
            object.mainModule = "";
            object.creatorId = "";
            object.contextPageUrl = "";
            object.contextPageTitle = "";
            object.contextPagePath = "";
            object.contextPageReferrer = "";
            object.contextPageSearch = "";
            object.contextLocale = "";
            object.contextUserAgent = "";
            object.label = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.execTime = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.execTime = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.prepTime = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.prepTime = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            object.uncaughtException = "";
            object.os = "";
            object.timezone = "";
            object.headless = false;
            object.isFragmentRun = false;
            object.appId = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.numPages = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.numPages = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            object.sessionId = "";
            object.pythonVersion = "";
            object.pageScriptHash = "";
            object.activeTheme = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.totalLoadTime = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
            } else
                object.totalLoadTime = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
            object.browserInfo = null;
            object.machineIdV4 = "";
            object.serverOs = "";
            object.hasDisplay = false;
            object.isWebdriver = false;
            object.serverMode = "";
            object.surface = "";
        }
        if (message.event != null && $Object.hasOwnProperty.call(message, "event"))
            object.event = message.event;
        if (message.anonymousId != null && $Object.hasOwnProperty.call(message, "anonymousId"))
            object.anonymousId = message.anonymousId;
        if (message.machineIdV3 != null && $Object.hasOwnProperty.call(message, "machineIdV3"))
            object.machineIdV3 = message.machineIdV3;
        if (message.reportHash != null && $Object.hasOwnProperty.call(message, "reportHash"))
            object.reportHash = message.reportHash;
        if (message.dev != null && $Object.hasOwnProperty.call(message, "dev"))
            object.dev = message.dev;
        if (message.source != null && $Object.hasOwnProperty.call(message, "source"))
            object.source = message.source;
        if (message.streamlitVersion != null && $Object.hasOwnProperty.call(message, "streamlitVersion"))
            object.streamlitVersion = message.streamlitVersion;
        if (message.isHello != null && $Object.hasOwnProperty.call(message, "isHello"))
            object.isHello = message.isHello;
        if (message.hostedAt != null && $Object.hasOwnProperty.call(message, "hostedAt"))
            object.hostedAt = message.hostedAt;
        if (message.owner != null && $Object.hasOwnProperty.call(message, "owner"))
            object.owner = message.owner;
        if (message.repo != null && $Object.hasOwnProperty.call(message, "repo"))
            object.repo = message.repo;
        if (message.branch != null && $Object.hasOwnProperty.call(message, "branch"))
            object.branch = message.branch;
        if (message.mainModule != null && $Object.hasOwnProperty.call(message, "mainModule"))
            object.mainModule = message.mainModule;
        if (message.creatorId != null && $Object.hasOwnProperty.call(message, "creatorId"))
            object.creatorId = message.creatorId;
        if (message.contextPageUrl != null && $Object.hasOwnProperty.call(message, "contextPageUrl"))
            object.contextPageUrl = message.contextPageUrl;
        if (message.contextPageTitle != null && $Object.hasOwnProperty.call(message, "contextPageTitle"))
            object.contextPageTitle = message.contextPageTitle;
        if (message.contextPagePath != null && $Object.hasOwnProperty.call(message, "contextPagePath"))
            object.contextPagePath = message.contextPagePath;
        if (message.contextPageReferrer != null && $Object.hasOwnProperty.call(message, "contextPageReferrer"))
            object.contextPageReferrer = message.contextPageReferrer;
        if (message.contextPageSearch != null && $Object.hasOwnProperty.call(message, "contextPageSearch"))
            object.contextPageSearch = message.contextPageSearch;
        if (message.contextLocale != null && $Object.hasOwnProperty.call(message, "contextLocale"))
            object.contextLocale = message.contextLocale;
        if (message.contextUserAgent != null && $Object.hasOwnProperty.call(message, "contextUserAgent"))
            object.contextUserAgent = message.contextUserAgent;
        if (message.label != null && $Object.hasOwnProperty.call(message, "label"))
            object.label = message.label;
        if (message.commands && message.commands.length) {
            object.commands = $Array(message.commands.length);
            for (let j = 0; j < message.commands.length; ++j)
                object.commands[j] = $root.Command.toObject(message.commands[j], options, _depth + 1);
        }
        if (message.execTime != null && $Object.hasOwnProperty.call(message, "execTime"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.execTime = typeof message.execTime === "number" ? $BigInt(message.execTime) : $util.Long.fromBits(message.execTime.low >>> 0, message.execTime.high >>> 0, false).toBigInt();
            else if (typeof message.execTime === "number")
                object.execTime = options.longs === $String ? $String(message.execTime) : message.execTime;
            else
                object.execTime = options.longs === $String ? $util.Long.prototype.toString.call(message.execTime) : options.longs === $Number ? new $util.LongBits(message.execTime.low >>> 0, message.execTime.high >>> 0).toNumber() : message.execTime;
        if (message.prepTime != null && $Object.hasOwnProperty.call(message, "prepTime"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.prepTime = typeof message.prepTime === "number" ? $BigInt(message.prepTime) : $util.Long.fromBits(message.prepTime.low >>> 0, message.prepTime.high >>> 0, false).toBigInt();
            else if (typeof message.prepTime === "number")
                object.prepTime = options.longs === $String ? $String(message.prepTime) : message.prepTime;
            else
                object.prepTime = options.longs === $String ? $util.Long.prototype.toString.call(message.prepTime) : options.longs === $Number ? new $util.LongBits(message.prepTime.low >>> 0, message.prepTime.high >>> 0).toNumber() : message.prepTime;
        if (message.config && message.config.length) {
            object.config = $Array(message.config.length);
            for (let j = 0; j < message.config.length; ++j)
                object.config[j] = message.config[j];
        }
        if (message.uncaughtException != null && $Object.hasOwnProperty.call(message, "uncaughtException"))
            object.uncaughtException = message.uncaughtException;
        if (message.attributions && message.attributions.length) {
            object.attributions = $Array(message.attributions.length);
            for (let j = 0; j < message.attributions.length; ++j)
                object.attributions[j] = message.attributions[j];
        }
        if (message.os != null && $Object.hasOwnProperty.call(message, "os"))
            object.os = message.os;
        if (message.timezone != null && $Object.hasOwnProperty.call(message, "timezone"))
            object.timezone = message.timezone;
        if (message.headless != null && $Object.hasOwnProperty.call(message, "headless"))
            object.headless = message.headless;
        if (message.isFragmentRun != null && $Object.hasOwnProperty.call(message, "isFragmentRun"))
            object.isFragmentRun = message.isFragmentRun;
        if (message.appId != null && $Object.hasOwnProperty.call(message, "appId"))
            object.appId = message.appId;
        if (message.numPages != null && $Object.hasOwnProperty.call(message, "numPages"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.numPages = typeof message.numPages === "number" ? $BigInt(message.numPages) : $util.Long.fromBits(message.numPages.low >>> 0, message.numPages.high >>> 0, false).toBigInt();
            else if (typeof message.numPages === "number")
                object.numPages = options.longs === $String ? $String(message.numPages) : message.numPages;
            else
                object.numPages = options.longs === $String ? $util.Long.prototype.toString.call(message.numPages) : options.longs === $Number ? new $util.LongBits(message.numPages.low >>> 0, message.numPages.high >>> 0).toNumber() : message.numPages;
        if (message.sessionId != null && $Object.hasOwnProperty.call(message, "sessionId"))
            object.sessionId = message.sessionId;
        if (message.pythonVersion != null && $Object.hasOwnProperty.call(message, "pythonVersion"))
            object.pythonVersion = message.pythonVersion;
        if (message.pageScriptHash != null && $Object.hasOwnProperty.call(message, "pageScriptHash"))
            object.pageScriptHash = message.pageScriptHash;
        if (message.activeTheme != null && $Object.hasOwnProperty.call(message, "activeTheme"))
            object.activeTheme = message.activeTheme;
        if (message.totalLoadTime != null && $Object.hasOwnProperty.call(message, "totalLoadTime"))
            if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                object.totalLoadTime = typeof message.totalLoadTime === "number" ? $BigInt(message.totalLoadTime) : $util.Long.fromBits(message.totalLoadTime.low >>> 0, message.totalLoadTime.high >>> 0, false).toBigInt();
            else if (typeof message.totalLoadTime === "number")
                object.totalLoadTime = options.longs === $String ? $String(message.totalLoadTime) : message.totalLoadTime;
            else
                object.totalLoadTime = options.longs === $String ? $util.Long.prototype.toString.call(message.totalLoadTime) : options.longs === $Number ? new $util.LongBits(message.totalLoadTime.low >>> 0, message.totalLoadTime.high >>> 0).toNumber() : message.totalLoadTime;
        if (message.browserInfo != null && $Object.hasOwnProperty.call(message, "browserInfo"))
            object.browserInfo = $root.BrowserInfo.toObject(message.browserInfo, options, _depth + 1);
        if (message.machineIdV4 != null && $Object.hasOwnProperty.call(message, "machineIdV4"))
            object.machineIdV4 = message.machineIdV4;
        if (message.serverOs != null && $Object.hasOwnProperty.call(message, "serverOs"))
            object.serverOs = message.serverOs;
        if (message.hasDisplay != null && $Object.hasOwnProperty.call(message, "hasDisplay"))
            object.hasDisplay = message.hasDisplay;
        if (message.isWebdriver != null && $Object.hasOwnProperty.call(message, "isWebdriver"))
            object.isWebdriver = message.isWebdriver;
        if (message.serverMode != null && $Object.hasOwnProperty.call(message, "serverMode"))
            object.serverMode = message.serverMode;
        if (message.installedSkills && message.installedSkills.length) {
            object.installedSkills = $Array(message.installedSkills.length);
            for (let j = 0; j < message.installedSkills.length; ++j)
                object.installedSkills[j] = message.installedSkills[j];
        }
        if (message.installedAgents && message.installedAgents.length) {
            object.installedAgents = $Array(message.installedAgents.length);
            for (let j = 0; j < message.installedAgents.length; ++j)
                object.installedAgents[j] = message.installedAgents[j];
        }
        if (message.surface != null && $Object.hasOwnProperty.call(message, "surface"))
            object.surface = message.surface;
        return object;
    };

    /**
     * Converts this MetricsEvent to JSON.
     * @function toJSON
     * @memberof MetricsEvent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MetricsEvent.prototype.toJSON = function() {
        return MetricsEvent.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for MetricsEvent
     * @function getTypeUrl
     * @memberof MetricsEvent
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    MetricsEvent.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/MetricsEvent";
    };

    return MetricsEvent;
})();

export const BrowserInfo = $root.BrowserInfo = (() => {

    /**
     * Properties of a BrowserInfo.
     * @typedef {Object} BrowserInfo.$Properties
     * @property {string|null} [browserName] BrowserInfo browserName
     * @property {string|null} [browserVersion] BrowserInfo browserVersion
     * @property {string|null} [deviceType] BrowserInfo deviceType
     * @property {string|null} [os] BrowserInfo os
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */

    /**
     * Properties of a BrowserInfo.
     * @exports IBrowserInfo
     * @interface IBrowserInfo
     * @augments BrowserInfo.$Properties
     * @deprecated Use BrowserInfo.$Properties instead.
     */

    /**
     * Shape of a BrowserInfo.
     * @typedef {BrowserInfo.$Properties} BrowserInfo.$Shape
     */

    /**
     * Constructs a new BrowserInfo.
     * @exports BrowserInfo
     * @classdesc Represents a BrowserInfo.
     * @constructor
     * @param {BrowserInfo.$Properties=} [properties] Properties to set
     * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
     */
    const BrowserInfo = function (properties) {
        if (properties)
            for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    };

    /**
     * BrowserInfo browserName.
     * @member {string} browserName
     * @memberof BrowserInfo
     * @instance
     */
    BrowserInfo.prototype.browserName = "";

    /**
     * BrowserInfo browserVersion.
     * @member {string} browserVersion
     * @memberof BrowserInfo
     * @instance
     */
    BrowserInfo.prototype.browserVersion = "";

    /**
     * BrowserInfo deviceType.
     * @member {string} deviceType
     * @memberof BrowserInfo
     * @instance
     */
    BrowserInfo.prototype.deviceType = "";

    /**
     * BrowserInfo os.
     * @member {string} os
     * @memberof BrowserInfo
     * @instance
     */
    BrowserInfo.prototype.os = "";

    /**
     * Creates a new BrowserInfo instance using the specified properties.
     * @function create
     * @memberof BrowserInfo
     * @static
     * @param {BrowserInfo.$Properties=} [properties] Properties to set
     * @returns {BrowserInfo} BrowserInfo instance
     * @type {{
     *   (properties: BrowserInfo.$Shape): BrowserInfo & BrowserInfo.$Shape;
     *   (properties?: BrowserInfo.$Properties): BrowserInfo;
     * }}
     */
    BrowserInfo.create = function(properties) {
        return new BrowserInfo(properties);
    };

    /**
     * Encodes the specified BrowserInfo message. Does not implicitly {@link BrowserInfo.verify|verify} messages.
     * @function encode
     * @memberof BrowserInfo
     * @static
     * @param {BrowserInfo.$Properties} message BrowserInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BrowserInfo.encode = function (message, writer, _depth) {
        if (!writer)
            writer = $Writer.create();
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        if (message.browserName != null && $Object.hasOwnProperty.call(message, "browserName") && message.browserName !== "")
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.browserName);
        if (message.browserVersion != null && $Object.hasOwnProperty.call(message, "browserVersion") && message.browserVersion !== "")
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.browserVersion);
        if (message.deviceType != null && $Object.hasOwnProperty.call(message, "deviceType") && message.deviceType !== "")
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.deviceType);
        if (message.os != null && $Object.hasOwnProperty.call(message, "os") && message.os !== "")
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.os);
        if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
            for (let i = 0; i < message.$unknowns.length; ++i)
                writer.raw(message.$unknowns[i]);
        return writer;
    };

    /**
     * Decodes a BrowserInfo message from the specified reader or buffer.
     * @function decode
     * @memberof BrowserInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BrowserInfo & BrowserInfo.$Shape} BrowserInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BrowserInfo.decode = function (reader, length, _end, _depth, _target) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $Reader.recursionLimit)
            throw $Error("max depth exceeded");
        let end, message, value;
        if (length === $undefined)
            end = reader.len;
        else {
            end = reader.pos + length;
            if (end > reader.len)
                throw $RangeError("index out of range");
            length = reader.len;
            reader.len = end;
        }
        message = _target || new $root.BrowserInfo();
        while (reader.pos < end) {
            let start = reader.pos;
            let tag = reader.tag();
            if (tag === _end) {
                _end = $undefined;
                break;
            }
            let wireType = tag & 7;
            switch (tag >>>= 3) {
            case 1: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.browserName = value;
                    else
                        delete message.browserName;
                    continue;
                }
            case 2: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.browserVersion = value;
                    else
                        delete message.browserVersion;
                    continue;
                }
            case 3: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.deviceType = value;
                    else
                        delete message.deviceType;
                    continue;
                }
            case 4: {
                    if (wireType !== 2)
                        break;
                    if ((value = reader.stringVerify()).length)
                        message.os = value;
                    else
                        delete message.os;
                    continue;
                }
            }
            reader.skipType(wireType, _depth, tag);
            if (!reader.discardUnknown) {
                $util.makeProp(message, "$unknowns", false);
                (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
            }
        }
        if (length !== $undefined) {
            if (reader.pos !== end)
                throw $RangeError("index out of range");
            reader.len = length;
        }
        if (_end !== $undefined)
            throw $Error("missing end group");
        return message;
    };

    /**
     * Creates a BrowserInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BrowserInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BrowserInfo} BrowserInfo
     */
    BrowserInfo.fromObject = function (object, _depth) {
        if (object instanceof $root.BrowserInfo)
            return object;
        if (!$util.isObject(object))
            throw $TypeError(".BrowserInfo: object expected");
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let message = new $root.BrowserInfo();
        if (object.browserName != null)
            if (typeof object.browserName !== "string" || object.browserName.length)
                message.browserName = $String(object.browserName);
        if (object.browserVersion != null)
            if (typeof object.browserVersion !== "string" || object.browserVersion.length)
                message.browserVersion = $String(object.browserVersion);
        if (object.deviceType != null)
            if (typeof object.deviceType !== "string" || object.deviceType.length)
                message.deviceType = $String(object.deviceType);
        if (object.os != null)
            if (typeof object.os !== "string" || object.os.length)
                message.os = $String(object.os);
        return message;
    };

    /**
     * Creates a plain object from a BrowserInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BrowserInfo
     * @static
     * @param {BrowserInfo} message BrowserInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BrowserInfo.toObject = function (message, options, _depth) {
        if (!options)
            options = {};
        if (_depth === $undefined)
            _depth = 0;
        if (_depth > $util.recursionLimit)
            throw $Error("max depth exceeded");
        let object = {};
        if (options.defaults) {
            object.browserName = "";
            object.browserVersion = "";
            object.deviceType = "";
            object.os = "";
        }
        if (message.browserName != null && $Object.hasOwnProperty.call(message, "browserName"))
            object.browserName = message.browserName;
        if (message.browserVersion != null && $Object.hasOwnProperty.call(message, "browserVersion"))
            object.browserVersion = message.browserVersion;
        if (message.deviceType != null && $Object.hasOwnProperty.call(message, "deviceType"))
            object.deviceType = message.deviceType;
        if (message.os != null && $Object.hasOwnProperty.call(message, "os"))
            object.os = message.os;
        return object;
    };

    /**
     * Converts this BrowserInfo to JSON.
     * @function toJSON
     * @memberof BrowserInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BrowserInfo.prototype.toJSON = function() {
        return BrowserInfo.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the type url for BrowserInfo
     * @function getTypeUrl
     * @memberof BrowserInfo
     * @static
     * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
     * @returns {string} The type url
     */
    BrowserInfo.getTypeUrl = function(prefix) {
        if (prefix === $undefined)
            prefix = "type.googleapis.com";
        return prefix + "/BrowserInfo";
    };

    return BrowserInfo;
})();

export const openmetrics = $root.openmetrics = (() => {

    /**
     * Namespace openmetrics.
     * @exports openmetrics
     * @namespace
     */
    const openmetrics = {};

    openmetrics.MetricSet = (function() {

        /**
         * Properties of a MetricSet.
         * @typedef {Object} openmetrics.MetricSet.$Properties
         * @property {Array.<openmetrics.MetricFamily.$Properties>|null} [metricFamilies] MetricSet metricFamilies
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a MetricSet.
         * @memberof openmetrics
         * @interface IMetricSet
         * @augments openmetrics.MetricSet.$Properties
         * @deprecated Use openmetrics.MetricSet.$Properties instead.
         */

        /**
         * Shape of a MetricSet.
         * @typedef {openmetrics.MetricSet.$Properties} openmetrics.MetricSet.$Shape
         */

        /**
         * Constructs a new MetricSet.
         * @memberof openmetrics
         * @classdesc Represents a MetricSet.
         * @constructor
         * @param {openmetrics.MetricSet.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const MetricSet = function (properties) {
            this.metricFamilies = [];
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * MetricSet metricFamilies.
         * @member {Array.<openmetrics.MetricFamily.$Properties>} metricFamilies
         * @memberof openmetrics.MetricSet
         * @instance
         */
        MetricSet.prototype.metricFamilies = $util.emptyArray;

        /**
         * Creates a new MetricSet instance using the specified properties.
         * @function create
         * @memberof openmetrics.MetricSet
         * @static
         * @param {openmetrics.MetricSet.$Properties=} [properties] Properties to set
         * @returns {openmetrics.MetricSet} MetricSet instance
         * @type {{
         *   (properties: openmetrics.MetricSet.$Shape): openmetrics.MetricSet & openmetrics.MetricSet.$Shape;
         *   (properties?: openmetrics.MetricSet.$Properties): openmetrics.MetricSet;
         * }}
         */
        MetricSet.create = function(properties) {
            return new MetricSet(properties);
        };

        /**
         * Encodes the specified MetricSet message. Does not implicitly {@link openmetrics.MetricSet.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.MetricSet
         * @static
         * @param {openmetrics.MetricSet.$Properties} message MetricSet message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MetricSet.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.metricFamilies != null && message.metricFamilies.length)
                for (let i = 0; i < message.metricFamilies.length; ++i)
                    $root.openmetrics.MetricFamily.encode(message.metricFamilies[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a MetricSet message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.MetricSet
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.MetricSet & openmetrics.MetricSet.$Shape} MetricSet
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MetricSet.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.MetricSet();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if (!(message.metricFamilies && message.metricFamilies.length))
                            message.metricFamilies = [];
                        message.metricFamilies.push($root.openmetrics.MetricFamily.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a MetricSet message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.MetricSet
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.MetricSet} MetricSet
         */
        MetricSet.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.MetricSet)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.MetricSet: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.MetricSet();
            if (object.metricFamilies) {
                if (!$Array.isArray(object.metricFamilies))
                    throw $TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
                message.metricFamilies = $Array(object.metricFamilies.length);
                for (let i = 0; i < object.metricFamilies.length; ++i) {
                    if (!$util.isObject(object.metricFamilies[i]))
                        throw $TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
                    message.metricFamilies[i] = $root.openmetrics.MetricFamily.fromObject(object.metricFamilies[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MetricSet message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.MetricSet
         * @static
         * @param {openmetrics.MetricSet} message MetricSet
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MetricSet.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.metricFamilies = [];
            if (message.metricFamilies && message.metricFamilies.length) {
                object.metricFamilies = $Array(message.metricFamilies.length);
                for (let j = 0; j < message.metricFamilies.length; ++j)
                    object.metricFamilies[j] = $root.openmetrics.MetricFamily.toObject(message.metricFamilies[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this MetricSet to JSON.
         * @function toJSON
         * @memberof openmetrics.MetricSet
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MetricSet.prototype.toJSON = function() {
            return MetricSet.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for MetricSet
         * @function getTypeUrl
         * @memberof openmetrics.MetricSet
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        MetricSet.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.MetricSet";
        };

        return MetricSet;
    })();

    openmetrics.MetricFamily = (function() {

        /**
         * Properties of a MetricFamily.
         * @typedef {Object} openmetrics.MetricFamily.$Properties
         * @property {string|null} [name] MetricFamily name
         * @property {openmetrics.MetricType|null} [type] MetricFamily type
         * @property {string|null} [unit] MetricFamily unit
         * @property {string|null} [help] MetricFamily help
         * @property {Array.<Metric.$Properties>|null} [metrics] MetricFamily metrics
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a MetricFamily.
         * @memberof openmetrics
         * @interface IMetricFamily
         * @augments openmetrics.MetricFamily.$Properties
         * @deprecated Use openmetrics.MetricFamily.$Properties instead.
         */

        /**
         * Shape of a MetricFamily.
         * @typedef {openmetrics.MetricFamily.$Properties} openmetrics.MetricFamily.$Shape
         */

        /**
         * Constructs a new MetricFamily.
         * @memberof openmetrics
         * @classdesc Represents a MetricFamily.
         * @constructor
         * @param {openmetrics.MetricFamily.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const MetricFamily = function (properties) {
            this.metrics = [];
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * MetricFamily name.
         * @member {string} name
         * @memberof openmetrics.MetricFamily
         * @instance
         */
        MetricFamily.prototype.name = "";

        /**
         * MetricFamily type.
         * @member {openmetrics.MetricType} type
         * @memberof openmetrics.MetricFamily
         * @instance
         */
        MetricFamily.prototype.type = 0;

        /**
         * MetricFamily unit.
         * @member {string} unit
         * @memberof openmetrics.MetricFamily
         * @instance
         */
        MetricFamily.prototype.unit = "";

        /**
         * MetricFamily help.
         * @member {string} help
         * @memberof openmetrics.MetricFamily
         * @instance
         */
        MetricFamily.prototype.help = "";

        /**
         * MetricFamily metrics.
         * @member {Array.<Metric.$Properties>} metrics
         * @memberof openmetrics.MetricFamily
         * @instance
         */
        MetricFamily.prototype.metrics = $util.emptyArray;

        /**
         * Creates a new MetricFamily instance using the specified properties.
         * @function create
         * @memberof openmetrics.MetricFamily
         * @static
         * @param {openmetrics.MetricFamily.$Properties=} [properties] Properties to set
         * @returns {openmetrics.MetricFamily} MetricFamily instance
         * @type {{
         *   (properties: openmetrics.MetricFamily.$Shape): openmetrics.MetricFamily & openmetrics.MetricFamily.$Shape;
         *   (properties?: openmetrics.MetricFamily.$Properties): openmetrics.MetricFamily;
         * }}
         */
        MetricFamily.create = function(properties) {
            return new MetricFamily(properties);
        };

        /**
         * Encodes the specified MetricFamily message. Does not implicitly {@link openmetrics.MetricFamily.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.MetricFamily
         * @static
         * @param {openmetrics.MetricFamily.$Properties} message MetricFamily message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MetricFamily.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.type != null && $Object.hasOwnProperty.call(message, "type") && message.type !== 0)
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
            if (message.unit != null && $Object.hasOwnProperty.call(message, "unit") && message.unit !== "")
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.unit);
            if (message.help != null && $Object.hasOwnProperty.call(message, "help") && message.help !== "")
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.help);
            if (message.metrics != null && message.metrics.length)
                for (let i = 0; i < message.metrics.length; ++i)
                    $root.Metric.encode(message.metrics[i], writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a MetricFamily message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.MetricFamily
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.MetricFamily & openmetrics.MetricFamily.$Shape} MetricFamily
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MetricFamily.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.MetricFamily();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.name = value;
                        else
                            delete message.name;
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        if (value = reader.int32())
                            message.type = value;
                        else
                            delete message.type;
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.unit = value;
                        else
                            delete message.unit;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.help = value;
                        else
                            delete message.help;
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if (!(message.metrics && message.metrics.length))
                            message.metrics = [];
                        message.metrics.push($root.Metric.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a MetricFamily message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.MetricFamily
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.MetricFamily} MetricFamily
         */
        MetricFamily.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.MetricFamily)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.MetricFamily: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.MetricFamily();
            if (object.name != null)
                if (typeof object.name !== "string" || object.name.length)
                    message.name = $String(object.name);
            if (object.type !== 0 && (typeof object.type !== "string" || $root.openmetrics.MetricType[object.type] !== 0))
                switch (object.type) {
                case "UNKNOWN":
                case 0:
                    message.type = 0;
                    break;
                case "GAUGE":
                case 1:
                    message.type = 1;
                    break;
                case "COUNTER":
                case 2:
                    message.type = 2;
                    break;
                case "STATE_SET":
                case 3:
                    message.type = 3;
                    break;
                case "INFO":
                case 4:
                    message.type = 4;
                    break;
                case "HISTOGRAM":
                case 5:
                    message.type = 5;
                    break;
                case "GAUGE_HISTOGRAM":
                case 6:
                    message.type = 6;
                    break;
                case "SUMMARY":
                case 7:
                    message.type = 7;
                    break;
                default:
                    if (typeof object.type === "number" && (object.type | 0) === object.type)
                        message.type = object.type;
                }
            if (object.unit != null)
                if (typeof object.unit !== "string" || object.unit.length)
                    message.unit = $String(object.unit);
            if (object.help != null)
                if (typeof object.help !== "string" || object.help.length)
                    message.help = $String(object.help);
            if (object.metrics) {
                if (!$Array.isArray(object.metrics))
                    throw $TypeError(".openmetrics.MetricFamily.metrics: array expected");
                message.metrics = $Array(object.metrics.length);
                for (let i = 0; i < object.metrics.length; ++i) {
                    if (!$util.isObject(object.metrics[i]))
                        throw $TypeError(".openmetrics.MetricFamily.metrics: object expected");
                    message.metrics[i] = $root.Metric.fromObject(object.metrics[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MetricFamily message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.MetricFamily
         * @static
         * @param {openmetrics.MetricFamily} message MetricFamily
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MetricFamily.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.metrics = [];
            if (options.defaults) {
                object.name = "";
                object.type = options.enums === $String ? "UNKNOWN" : 0;
                object.unit = "";
                object.help = "";
            }
            if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
                object.name = message.name;
            if (message.type != null && $Object.hasOwnProperty.call(message, "type"))
                object.type = options.enums === $String ? $root.openmetrics.MetricType[message.type] === $undefined ? message.type : $root.openmetrics.MetricType[message.type] : message.type;
            if (message.unit != null && $Object.hasOwnProperty.call(message, "unit"))
                object.unit = message.unit;
            if (message.help != null && $Object.hasOwnProperty.call(message, "help"))
                object.help = message.help;
            if (message.metrics && message.metrics.length) {
                object.metrics = $Array(message.metrics.length);
                for (let j = 0; j < message.metrics.length; ++j)
                    object.metrics[j] = $root.Metric.toObject(message.metrics[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this MetricFamily to JSON.
         * @function toJSON
         * @memberof openmetrics.MetricFamily
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MetricFamily.prototype.toJSON = function() {
            return MetricFamily.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for MetricFamily
         * @function getTypeUrl
         * @memberof openmetrics.MetricFamily
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        MetricFamily.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.MetricFamily";
        };

        return MetricFamily;
    })();

    /**
     * MetricType enum.
     * @name openmetrics.MetricType
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} GAUGE=1 GAUGE value
     * @property {number} COUNTER=2 COUNTER value
     * @property {number} STATE_SET=3 STATE_SET value
     * @property {number} INFO=4 INFO value
     * @property {number} HISTOGRAM=5 HISTOGRAM value
     * @property {number} GAUGE_HISTOGRAM=6 GAUGE_HISTOGRAM value
     * @property {number} SUMMARY=7 SUMMARY value
     */
    openmetrics.MetricType = (function() {
        const valuesById = $Object.create(null), values = $Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "GAUGE"] = 1;
        values[valuesById[2] = "COUNTER"] = 2;
        values[valuesById[3] = "STATE_SET"] = 3;
        values[valuesById[4] = "INFO"] = 4;
        values[valuesById[5] = "HISTOGRAM"] = 5;
        values[valuesById[6] = "GAUGE_HISTOGRAM"] = 6;
        values[valuesById[7] = "SUMMARY"] = 7;
        return values;
    })();

    openmetrics.Metric = (function() {

        /**
         * Properties of a Metric.
         * @typedef {Object} openmetrics.Metric.$Properties
         * @property {Array.<openmetrics.Label.$Properties>|null} [labels] Metric labels
         * @property {Array.<openmetrics.MetricPoint.$Properties>|null} [metricPoints] Metric metricPoints
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Metric.
         * @memberof openmetrics
         * @interface IMetric
         * @augments openmetrics.Metric.$Properties
         * @deprecated Use openmetrics.Metric.$Properties instead.
         */

        /**
         * Shape of a Metric.
         * @typedef {{
         *   labels?: Array.<openmetrics.Label.$Shape>|null;
         *   metricPoints?: Array.<openmetrics.MetricPoint.$Shape>|null;
         *   $unknowns?: Array.<Uint8Array>;
         * }} openmetrics.Metric.$Shape
         */

        /**
         * Constructs a new Metric.
         * @memberof openmetrics
         * @classdesc Represents a Metric.
         * @constructor
         * @param {openmetrics.Metric.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Metric = function (properties) {
            this.labels = [];
            this.metricPoints = [];
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Metric labels.
         * @member {Array.<openmetrics.Label.$Properties>} labels
         * @memberof openmetrics.Metric
         * @instance
         */
        Metric.prototype.labels = $util.emptyArray;

        /**
         * Metric metricPoints.
         * @member {Array.<openmetrics.MetricPoint.$Properties>} metricPoints
         * @memberof openmetrics.Metric
         * @instance
         */
        Metric.prototype.metricPoints = $util.emptyArray;

        /**
         * Creates a new Metric instance using the specified properties.
         * @function create
         * @memberof openmetrics.Metric
         * @static
         * @param {openmetrics.Metric.$Properties=} [properties] Properties to set
         * @returns {openmetrics.Metric} Metric instance
         * @type {{
         *   (properties: openmetrics.Metric.$Shape): openmetrics.Metric & openmetrics.Metric.$Shape;
         *   (properties?: openmetrics.Metric.$Properties): openmetrics.Metric;
         * }}
         */
        Metric.create = function(properties) {
            return new Metric(properties);
        };

        /**
         * Encodes the specified Metric message. Does not implicitly {@link openmetrics.Metric.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.Metric
         * @static
         * @param {openmetrics.Metric.$Properties} message Metric message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Metric.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.labels != null && message.labels.length)
                for (let i = 0; i < message.labels.length; ++i)
                    $root.openmetrics.Label.encode(message.labels[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.metricPoints != null && message.metricPoints.length)
                for (let i = 0; i < message.metricPoints.length; ++i)
                    $root.openmetrics.MetricPoint.encode(message.metricPoints[i], writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a Metric message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.Metric
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.Metric & openmetrics.Metric.$Shape} Metric
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Metric.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.Metric();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if (!(message.labels && message.labels.length))
                            message.labels = [];
                        message.labels.push($root.openmetrics.Label.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if (!(message.metricPoints && message.metricPoints.length))
                            message.metricPoints = [];
                        message.metricPoints.push($root.openmetrics.MetricPoint.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a Metric message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.Metric
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.Metric} Metric
         */
        Metric.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.Metric)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.Metric: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.Metric();
            if (object.labels) {
                if (!$Array.isArray(object.labels))
                    throw $TypeError(".openmetrics.Metric.labels: array expected");
                message.labels = $Array(object.labels.length);
                for (let i = 0; i < object.labels.length; ++i) {
                    if (!$util.isObject(object.labels[i]))
                        throw $TypeError(".openmetrics.Metric.labels: object expected");
                    message.labels[i] = $root.openmetrics.Label.fromObject(object.labels[i], _depth + 1);
                }
            }
            if (object.metricPoints) {
                if (!$Array.isArray(object.metricPoints))
                    throw $TypeError(".openmetrics.Metric.metricPoints: array expected");
                message.metricPoints = $Array(object.metricPoints.length);
                for (let i = 0; i < object.metricPoints.length; ++i) {
                    if (!$util.isObject(object.metricPoints[i]))
                        throw $TypeError(".openmetrics.Metric.metricPoints: object expected");
                    message.metricPoints[i] = $root.openmetrics.MetricPoint.fromObject(object.metricPoints[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Metric message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.Metric
         * @static
         * @param {openmetrics.Metric} message Metric
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Metric.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults) {
                object.labels = [];
                object.metricPoints = [];
            }
            if (message.labels && message.labels.length) {
                object.labels = $Array(message.labels.length);
                for (let j = 0; j < message.labels.length; ++j)
                    object.labels[j] = $root.openmetrics.Label.toObject(message.labels[j], options, _depth + 1);
            }
            if (message.metricPoints && message.metricPoints.length) {
                object.metricPoints = $Array(message.metricPoints.length);
                for (let j = 0; j < message.metricPoints.length; ++j)
                    object.metricPoints[j] = $root.openmetrics.MetricPoint.toObject(message.metricPoints[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this Metric to JSON.
         * @function toJSON
         * @memberof openmetrics.Metric
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Metric.prototype.toJSON = function() {
            return Metric.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Metric
         * @function getTypeUrl
         * @memberof openmetrics.Metric
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Metric.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.Metric";
        };

        return Metric;
    })();

    openmetrics.Label = (function() {

        /**
         * Properties of a Label.
         * @typedef {Object} openmetrics.Label.$Properties
         * @property {string|null} [name] Label name
         * @property {string|null} [value] Label value
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a Label.
         * @memberof openmetrics
         * @interface ILabel
         * @augments openmetrics.Label.$Properties
         * @deprecated Use openmetrics.Label.$Properties instead.
         */

        /**
         * Shape of a Label.
         * @typedef {openmetrics.Label.$Properties} openmetrics.Label.$Shape
         */

        /**
         * Constructs a new Label.
         * @memberof openmetrics
         * @classdesc Represents a Label.
         * @constructor
         * @param {openmetrics.Label.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Label = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Label name.
         * @member {string} name
         * @memberof openmetrics.Label
         * @instance
         */
        Label.prototype.name = "";

        /**
         * Label value.
         * @member {string} value
         * @memberof openmetrics.Label
         * @instance
         */
        Label.prototype.value = "";

        /**
         * Creates a new Label instance using the specified properties.
         * @function create
         * @memberof openmetrics.Label
         * @static
         * @param {openmetrics.Label.$Properties=} [properties] Properties to set
         * @returns {openmetrics.Label} Label instance
         * @type {{
         *   (properties: openmetrics.Label.$Shape): openmetrics.Label & openmetrics.Label.$Shape;
         *   (properties?: openmetrics.Label.$Properties): openmetrics.Label;
         * }}
         */
        Label.create = function(properties) {
            return new Label(properties);
        };

        /**
         * Encodes the specified Label message. Does not implicitly {@link openmetrics.Label.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.Label
         * @static
         * @param {openmetrics.Label.$Properties} message Label message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Label.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.value != null && $Object.hasOwnProperty.call(message, "value") && message.value !== "")
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a Label message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.Label
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.Label & openmetrics.Label.$Shape} Label
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Label.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.Label();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.name = value;
                        else
                            delete message.name;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        if ((value = reader.stringVerify()).length)
                            message.value = value;
                        else
                            delete message.value;
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a Label message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.Label
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.Label} Label
         */
        Label.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.Label)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.Label: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.Label();
            if (object.name != null)
                if (typeof object.name !== "string" || object.name.length)
                    message.name = $String(object.name);
            if (object.value != null)
                if (typeof object.value !== "string" || object.value.length)
                    message.value = $String(object.value);
            return message;
        };

        /**
         * Creates a plain object from a Label message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.Label
         * @static
         * @param {openmetrics.Label} message Label
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Label.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.name = "";
                object.value = "";
            }
            if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
                object.name = message.name;
            if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this Label to JSON.
         * @function toJSON
         * @memberof openmetrics.Label
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Label.prototype.toJSON = function() {
            return Label.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Label
         * @function getTypeUrl
         * @memberof openmetrics.Label
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Label.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.Label";
        };

        return Label;
    })();

    openmetrics.MetricPoint = (function() {

        /**
         * Properties of a MetricPoint.
         * @typedef {Object} openmetrics.MetricPoint.$Properties
         * @property {openmetrics.UnknownValue.$Properties|null} [unknownValue] MetricPoint unknownValue
         * @property {openmetrics.GaugeValue.$Properties|null} [gaugeValue] MetricPoint gaugeValue
         * @property {openmetrics.CounterValue.$Properties|null} [counterValue] MetricPoint counterValue
         * @property {openmetrics.HistogramValue.$Properties|null} [histogramValue] MetricPoint histogramValue
         * @property {openmetrics.StateSetValue.$Properties|null} [stateSetValue] MetricPoint stateSetValue
         * @property {openmetrics.InfoValue.$Properties|null} [infoValue] MetricPoint infoValue
         * @property {openmetrics.SummaryValue.$Properties|null} [summaryValue] MetricPoint summaryValue
         * @property {google.protobuf.Timestamp.$Properties|null} [timestamp] MetricPoint timestamp
         * @property {"unknownValue"|"gaugeValue"|"counterValue"|"histogramValue"|"stateSetValue"|"infoValue"|"summaryValue"} [value] MetricPoint value
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a MetricPoint.
         * @memberof openmetrics
         * @interface IMetricPoint
         * @augments openmetrics.MetricPoint.$Properties
         * @deprecated Use openmetrics.MetricPoint.$Properties instead.
         */

        /**
         * Narrowed shape of a MetricPoint.
         * @typedef {{
         *   unknownValue?: openmetrics.UnknownValue.$Shape|null;
         *   gaugeValue?: openmetrics.GaugeValue.$Shape|null;
         *   counterValue?: openmetrics.CounterValue.$Shape|null;
         *   histogramValue?: openmetrics.HistogramValue.$Shape|null;
         *   stateSetValue?: openmetrics.StateSetValue.$Shape|null;
         *   infoValue?: openmetrics.InfoValue.$Shape|null;
         *   summaryValue?: openmetrics.SummaryValue.$Shape|null;
         *   timestamp?: google.protobuf.Timestamp.$Shape|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ value?: undefined; unknownValue?: null; gaugeValue?: null; counterValue?: null; histogramValue?: null; stateSetValue?: null; infoValue?: null; summaryValue?: null }|{ value?: "unknownValue"; unknownValue: openmetrics.UnknownValue.$Shape; gaugeValue?: null; counterValue?: null; histogramValue?: null; stateSetValue?: null; infoValue?: null; summaryValue?: null }|{ value?: "gaugeValue"; unknownValue?: null; gaugeValue: openmetrics.GaugeValue.$Shape; counterValue?: null; histogramValue?: null; stateSetValue?: null; infoValue?: null; summaryValue?: null }|{ value?: "counterValue"; unknownValue?: null; gaugeValue?: null; counterValue: openmetrics.CounterValue.$Shape; histogramValue?: null; stateSetValue?: null; infoValue?: null; summaryValue?: null }|{ value?: "histogramValue"; unknownValue?: null; gaugeValue?: null; counterValue?: null; histogramValue: openmetrics.HistogramValue.$Shape; stateSetValue?: null; infoValue?: null; summaryValue?: null }|{ value?: "stateSetValue"; unknownValue?: null; gaugeValue?: null; counterValue?: null; histogramValue?: null; stateSetValue: openmetrics.StateSetValue.$Shape; infoValue?: null; summaryValue?: null }|{ value?: "infoValue"; unknownValue?: null; gaugeValue?: null; counterValue?: null; histogramValue?: null; stateSetValue?: null; infoValue: openmetrics.InfoValue.$Shape; summaryValue?: null }|{ value?: "summaryValue"; unknownValue?: null; gaugeValue?: null; counterValue?: null; histogramValue?: null; stateSetValue?: null; infoValue?: null; summaryValue: openmetrics.SummaryValue.$Shape })
         * )} openmetrics.MetricPoint.$Shape
         */

        /**
         * Constructs a new MetricPoint.
         * @memberof openmetrics
         * @classdesc Represents a MetricPoint.
         * @constructor
         * @param {openmetrics.MetricPoint.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const MetricPoint = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * MetricPoint unknownValue.
         * @member {openmetrics.UnknownValue.$Properties|null|undefined} unknownValue
         * @memberof openmetrics.MetricPoint
         * @instance
         */
        MetricPoint.prototype.unknownValue = null;

        /**
         * MetricPoint gaugeValue.
         * @member {openmetrics.GaugeValue.$Properties|null|undefined} gaugeValue
         * @memberof openmetrics.MetricPoint
         * @instance
         */
        MetricPoint.prototype.gaugeValue = null;

        /**
         * MetricPoint counterValue.
         * @member {openmetrics.CounterValue.$Properties|null|undefined} counterValue
         * @memberof openmetrics.MetricPoint
         * @instance
         */
        MetricPoint.prototype.counterValue = null;

        /**
         * MetricPoint histogramValue.
         * @member {openmetrics.HistogramValue.$Properties|null|undefined} histogramValue
         * @memberof openmetrics.MetricPoint
         * @instance
         */
        MetricPoint.prototype.histogramValue = null;

        /**
         * MetricPoint stateSetValue.
         * @member {openmetrics.StateSetValue.$Properties|null|undefined} stateSetValue
         * @memberof openmetrics.MetricPoint
         * @instance
         */
        MetricPoint.prototype.stateSetValue = null;

        /**
         * MetricPoint infoValue.
         * @member {openmetrics.InfoValue.$Properties|null|undefined} infoValue
         * @memberof openmetrics.MetricPoint
         * @instance
         */
        MetricPoint.prototype.infoValue = null;

        /**
         * MetricPoint summaryValue.
         * @member {openmetrics.SummaryValue.$Properties|null|undefined} summaryValue
         * @memberof openmetrics.MetricPoint
         * @instance
         */
        MetricPoint.prototype.summaryValue = null;

        /**
         * MetricPoint timestamp.
         * @member {google.protobuf.Timestamp.$Properties|null|undefined} timestamp
         * @memberof openmetrics.MetricPoint
         * @instance
         */
        MetricPoint.prototype.timestamp = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * MetricPoint value.
         * @member {"unknownValue"|"gaugeValue"|"counterValue"|"histogramValue"|"stateSetValue"|"infoValue"|"summaryValue"|undefined} value
         * @memberof openmetrics.MetricPoint
         * @instance
         */
        $Object.defineProperty(MetricPoint.prototype, "value", {
            get: $util.oneOfGetter($oneOfFields = ["unknownValue", "gaugeValue", "counterValue", "histogramValue", "stateSetValue", "infoValue", "summaryValue"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new MetricPoint instance using the specified properties.
         * @function create
         * @memberof openmetrics.MetricPoint
         * @static
         * @param {openmetrics.MetricPoint.$Properties=} [properties] Properties to set
         * @returns {openmetrics.MetricPoint} MetricPoint instance
         * @type {{
         *   (properties: openmetrics.MetricPoint.$Shape): openmetrics.MetricPoint & openmetrics.MetricPoint.$Shape;
         *   (properties?: openmetrics.MetricPoint.$Properties): openmetrics.MetricPoint;
         * }}
         */
        MetricPoint.create = function(properties) {
            return new MetricPoint(properties);
        };

        /**
         * Encodes the specified MetricPoint message. Does not implicitly {@link openmetrics.MetricPoint.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.MetricPoint
         * @static
         * @param {openmetrics.MetricPoint.$Properties} message MetricPoint message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MetricPoint.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.unknownValue != null && $Object.hasOwnProperty.call(message, "unknownValue"))
                $root.openmetrics.UnknownValue.encode(message.unknownValue, writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.gaugeValue != null && $Object.hasOwnProperty.call(message, "gaugeValue"))
                $root.openmetrics.GaugeValue.encode(message.gaugeValue, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
            if (message.counterValue != null && $Object.hasOwnProperty.call(message, "counterValue"))
                $root.openmetrics.CounterValue.encode(message.counterValue, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
            if (message.histogramValue != null && $Object.hasOwnProperty.call(message, "histogramValue"))
                $root.openmetrics.HistogramValue.encode(message.histogramValue, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
            if (message.stateSetValue != null && $Object.hasOwnProperty.call(message, "stateSetValue"))
                $root.openmetrics.StateSetValue.encode(message.stateSetValue, writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
            if (message.infoValue != null && $Object.hasOwnProperty.call(message, "infoValue"))
                $root.openmetrics.InfoValue.encode(message.infoValue, writer.uint32(/* id 6, wireType 2 =*/50).fork(), _depth + 1).ldelim();
            if (message.summaryValue != null && $Object.hasOwnProperty.call(message, "summaryValue"))
                $root.openmetrics.SummaryValue.encode(message.summaryValue, writer.uint32(/* id 7, wireType 2 =*/58).fork(), _depth + 1).ldelim();
            if (message.timestamp != null && $Object.hasOwnProperty.call(message, "timestamp"))
                $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(/* id 8, wireType 2 =*/66).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a MetricPoint message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.MetricPoint
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.MetricPoint & openmetrics.MetricPoint.$Shape} MetricPoint
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MetricPoint.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.MetricPoint();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        message.unknownValue = $root.openmetrics.UnknownValue.decode(reader, reader.uint32(), $undefined, _depth + 1, message.unknownValue);
                        message.value = "unknownValue";
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        message.gaugeValue = $root.openmetrics.GaugeValue.decode(reader, reader.uint32(), $undefined, _depth + 1, message.gaugeValue);
                        message.value = "gaugeValue";
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        message.counterValue = $root.openmetrics.CounterValue.decode(reader, reader.uint32(), $undefined, _depth + 1, message.counterValue);
                        message.value = "counterValue";
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.histogramValue = $root.openmetrics.HistogramValue.decode(reader, reader.uint32(), $undefined, _depth + 1, message.histogramValue);
                        message.value = "histogramValue";
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        message.stateSetValue = $root.openmetrics.StateSetValue.decode(reader, reader.uint32(), $undefined, _depth + 1, message.stateSetValue);
                        message.value = "stateSetValue";
                        continue;
                    }
                case 6: {
                        if (wireType !== 2)
                            break;
                        message.infoValue = $root.openmetrics.InfoValue.decode(reader, reader.uint32(), $undefined, _depth + 1, message.infoValue);
                        message.value = "infoValue";
                        continue;
                    }
                case 7: {
                        if (wireType !== 2)
                            break;
                        message.summaryValue = $root.openmetrics.SummaryValue.decode(reader, reader.uint32(), $undefined, _depth + 1, message.summaryValue);
                        message.value = "summaryValue";
                        continue;
                    }
                case 8: {
                        if (wireType !== 2)
                            break;
                        message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.timestamp);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a MetricPoint message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.MetricPoint
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.MetricPoint} MetricPoint
         */
        MetricPoint.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.MetricPoint)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.MetricPoint: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.MetricPoint();
            if (object.unknownValue != null) {
                if (!$util.isObject(object.unknownValue))
                    throw $TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
                message.unknownValue = $root.openmetrics.UnknownValue.fromObject(object.unknownValue, _depth + 1);
            }
            if (object.gaugeValue != null) {
                if (!$util.isObject(object.gaugeValue))
                    throw $TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
                message.gaugeValue = $root.openmetrics.GaugeValue.fromObject(object.gaugeValue, _depth + 1);
            }
            if (object.counterValue != null) {
                if (!$util.isObject(object.counterValue))
                    throw $TypeError(".openmetrics.MetricPoint.counterValue: object expected");
                message.counterValue = $root.openmetrics.CounterValue.fromObject(object.counterValue, _depth + 1);
            }
            if (object.histogramValue != null) {
                if (!$util.isObject(object.histogramValue))
                    throw $TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
                message.histogramValue = $root.openmetrics.HistogramValue.fromObject(object.histogramValue, _depth + 1);
            }
            if (object.stateSetValue != null) {
                if (!$util.isObject(object.stateSetValue))
                    throw $TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
                message.stateSetValue = $root.openmetrics.StateSetValue.fromObject(object.stateSetValue, _depth + 1);
            }
            if (object.infoValue != null) {
                if (!$util.isObject(object.infoValue))
                    throw $TypeError(".openmetrics.MetricPoint.infoValue: object expected");
                message.infoValue = $root.openmetrics.InfoValue.fromObject(object.infoValue, _depth + 1);
            }
            if (object.summaryValue != null) {
                if (!$util.isObject(object.summaryValue))
                    throw $TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
                message.summaryValue = $root.openmetrics.SummaryValue.fromObject(object.summaryValue, _depth + 1);
            }
            if (object.timestamp != null) {
                if (!$util.isObject(object.timestamp))
                    throw $TypeError(".openmetrics.MetricPoint.timestamp: object expected");
                message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a MetricPoint message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.MetricPoint
         * @static
         * @param {openmetrics.MetricPoint} message MetricPoint
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MetricPoint.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults)
                object.timestamp = null;
            if (message.unknownValue != null && $Object.hasOwnProperty.call(message, "unknownValue")) {
                object.unknownValue = $root.openmetrics.UnknownValue.toObject(message.unknownValue, options, _depth + 1);
                if (options.oneofs)
                    object.value = "unknownValue";
            }
            if (message.gaugeValue != null && $Object.hasOwnProperty.call(message, "gaugeValue")) {
                object.gaugeValue = $root.openmetrics.GaugeValue.toObject(message.gaugeValue, options, _depth + 1);
                if (options.oneofs)
                    object.value = "gaugeValue";
            }
            if (message.counterValue != null && $Object.hasOwnProperty.call(message, "counterValue")) {
                object.counterValue = $root.openmetrics.CounterValue.toObject(message.counterValue, options, _depth + 1);
                if (options.oneofs)
                    object.value = "counterValue";
            }
            if (message.histogramValue != null && $Object.hasOwnProperty.call(message, "histogramValue")) {
                object.histogramValue = $root.openmetrics.HistogramValue.toObject(message.histogramValue, options, _depth + 1);
                if (options.oneofs)
                    object.value = "histogramValue";
            }
            if (message.stateSetValue != null && $Object.hasOwnProperty.call(message, "stateSetValue")) {
                object.stateSetValue = $root.openmetrics.StateSetValue.toObject(message.stateSetValue, options, _depth + 1);
                if (options.oneofs)
                    object.value = "stateSetValue";
            }
            if (message.infoValue != null && $Object.hasOwnProperty.call(message, "infoValue")) {
                object.infoValue = $root.openmetrics.InfoValue.toObject(message.infoValue, options, _depth + 1);
                if (options.oneofs)
                    object.value = "infoValue";
            }
            if (message.summaryValue != null && $Object.hasOwnProperty.call(message, "summaryValue")) {
                object.summaryValue = $root.openmetrics.SummaryValue.toObject(message.summaryValue, options, _depth + 1);
                if (options.oneofs)
                    object.value = "summaryValue";
            }
            if (message.timestamp != null && $Object.hasOwnProperty.call(message, "timestamp"))
                object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options, _depth + 1);
            return object;
        };

        /**
         * Converts this MetricPoint to JSON.
         * @function toJSON
         * @memberof openmetrics.MetricPoint
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MetricPoint.prototype.toJSON = function() {
            return MetricPoint.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for MetricPoint
         * @function getTypeUrl
         * @memberof openmetrics.MetricPoint
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        MetricPoint.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.MetricPoint";
        };

        return MetricPoint;
    })();

    openmetrics.UnknownValue = (function() {

        /**
         * Properties of an UnknownValue.
         * @typedef {Object} openmetrics.UnknownValue.$Properties
         * @property {number|null} [doubleValue] UnknownValue doubleValue
         * @property {number|Long|null} [intValue] UnknownValue intValue
         * @property {"doubleValue"|"intValue"} [value] UnknownValue value
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an UnknownValue.
         * @memberof openmetrics
         * @interface IUnknownValue
         * @augments openmetrics.UnknownValue.$Properties
         * @deprecated Use openmetrics.UnknownValue.$Properties instead.
         */

        /**
         * Narrowed shape of an UnknownValue.
         * @typedef {{
         *   doubleValue?: number|null;
         *   intValue?: number|Long|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ value?: undefined; doubleValue?: null; intValue?: null }|{ value?: "doubleValue"; doubleValue: number; intValue?: null }|{ value?: "intValue"; doubleValue?: null; intValue: number|Long })
         * )} openmetrics.UnknownValue.$Shape
         */

        /**
         * Constructs a new UnknownValue.
         * @memberof openmetrics
         * @classdesc Represents an UnknownValue.
         * @constructor
         * @param {openmetrics.UnknownValue.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const UnknownValue = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * UnknownValue doubleValue.
         * @member {number|null|undefined} doubleValue
         * @memberof openmetrics.UnknownValue
         * @instance
         */
        UnknownValue.prototype.doubleValue = null;

        /**
         * UnknownValue intValue.
         * @member {number|Long|null|undefined} intValue
         * @memberof openmetrics.UnknownValue
         * @instance
         */
        UnknownValue.prototype.intValue = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * UnknownValue value.
         * @member {"doubleValue"|"intValue"|undefined} value
         * @memberof openmetrics.UnknownValue
         * @instance
         */
        $Object.defineProperty(UnknownValue.prototype, "value", {
            get: $util.oneOfGetter($oneOfFields = ["doubleValue", "intValue"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UnknownValue instance using the specified properties.
         * @function create
         * @memberof openmetrics.UnknownValue
         * @static
         * @param {openmetrics.UnknownValue.$Properties=} [properties] Properties to set
         * @returns {openmetrics.UnknownValue} UnknownValue instance
         * @type {{
         *   (properties: openmetrics.UnknownValue.$Shape): openmetrics.UnknownValue & openmetrics.UnknownValue.$Shape;
         *   (properties?: openmetrics.UnknownValue.$Properties): openmetrics.UnknownValue;
         * }}
         */
        UnknownValue.create = function(properties) {
            return new UnknownValue(properties);
        };

        /**
         * Encodes the specified UnknownValue message. Does not implicitly {@link openmetrics.UnknownValue.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.UnknownValue
         * @static
         * @param {openmetrics.UnknownValue.$Properties} message UnknownValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnknownValue.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.doubleValue);
            if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.intValue);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes an UnknownValue message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.UnknownValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.UnknownValue & openmetrics.UnknownValue.$Shape} UnknownValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnknownValue.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.UnknownValue();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 1)
                            break;
                        message.doubleValue = reader.double();
                        message.value = "doubleValue";
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        message.intValue = reader.int64();
                        message.value = "intValue";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates an UnknownValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.UnknownValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.UnknownValue} UnknownValue
         */
        UnknownValue.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.UnknownValue)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.UnknownValue: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.UnknownValue();
            if (object.doubleValue != null)
                message.doubleValue = $Number(object.doubleValue);
            if (object.intValue != null)
                if ($util.Long)
                    message.intValue = $util.Long.fromValue(object.intValue, false);
                else if (typeof object.intValue === "string")
                    message.intValue = $parseInt(object.intValue, 10);
                else if (typeof object.intValue === "number")
                    message.intValue = object.intValue;
                else if (typeof object.intValue === "object")
                    message.intValue = new $util.LongBits(object.intValue.low >>> 0, object.intValue.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an UnknownValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.UnknownValue
         * @static
         * @param {openmetrics.UnknownValue} message UnknownValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UnknownValue.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue")) {
                object.doubleValue = options.json && !$isFinite(message.doubleValue) ? $String(message.doubleValue) : message.doubleValue;
                if (options.oneofs)
                    object.value = "doubleValue";
            }
            if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue")) {
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.intValue = typeof message.intValue === "number" ? $BigInt(message.intValue) : $util.Long.fromBits(message.intValue.low >>> 0, message.intValue.high >>> 0, false).toBigInt();
                else if (typeof message.intValue === "number")
                    object.intValue = options.longs === $String ? $String(message.intValue) : message.intValue;
                else
                    object.intValue = options.longs === $String ? $util.Long.prototype.toString.call(message.intValue) : options.longs === $Number ? new $util.LongBits(message.intValue.low >>> 0, message.intValue.high >>> 0).toNumber() : message.intValue;
                if (options.oneofs)
                    object.value = "intValue";
            }
            return object;
        };

        /**
         * Converts this UnknownValue to JSON.
         * @function toJSON
         * @memberof openmetrics.UnknownValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UnknownValue.prototype.toJSON = function() {
            return UnknownValue.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for UnknownValue
         * @function getTypeUrl
         * @memberof openmetrics.UnknownValue
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        UnknownValue.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.UnknownValue";
        };

        return UnknownValue;
    })();

    openmetrics.GaugeValue = (function() {

        /**
         * Properties of a GaugeValue.
         * @typedef {Object} openmetrics.GaugeValue.$Properties
         * @property {number|null} [doubleValue] GaugeValue doubleValue
         * @property {number|Long|null} [intValue] GaugeValue intValue
         * @property {"doubleValue"|"intValue"} [value] GaugeValue value
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a GaugeValue.
         * @memberof openmetrics
         * @interface IGaugeValue
         * @augments openmetrics.GaugeValue.$Properties
         * @deprecated Use openmetrics.GaugeValue.$Properties instead.
         */

        /**
         * Narrowed shape of a GaugeValue.
         * @typedef {{
         *   doubleValue?: number|null;
         *   intValue?: number|Long|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ value?: undefined; doubleValue?: null; intValue?: null }|{ value?: "doubleValue"; doubleValue: number; intValue?: null }|{ value?: "intValue"; doubleValue?: null; intValue: number|Long })
         * )} openmetrics.GaugeValue.$Shape
         */

        /**
         * Constructs a new GaugeValue.
         * @memberof openmetrics
         * @classdesc Represents a GaugeValue.
         * @constructor
         * @param {openmetrics.GaugeValue.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const GaugeValue = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * GaugeValue doubleValue.
         * @member {number|null|undefined} doubleValue
         * @memberof openmetrics.GaugeValue
         * @instance
         */
        GaugeValue.prototype.doubleValue = null;

        /**
         * GaugeValue intValue.
         * @member {number|Long|null|undefined} intValue
         * @memberof openmetrics.GaugeValue
         * @instance
         */
        GaugeValue.prototype.intValue = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * GaugeValue value.
         * @member {"doubleValue"|"intValue"|undefined} value
         * @memberof openmetrics.GaugeValue
         * @instance
         */
        $Object.defineProperty(GaugeValue.prototype, "value", {
            get: $util.oneOfGetter($oneOfFields = ["doubleValue", "intValue"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GaugeValue instance using the specified properties.
         * @function create
         * @memberof openmetrics.GaugeValue
         * @static
         * @param {openmetrics.GaugeValue.$Properties=} [properties] Properties to set
         * @returns {openmetrics.GaugeValue} GaugeValue instance
         * @type {{
         *   (properties: openmetrics.GaugeValue.$Shape): openmetrics.GaugeValue & openmetrics.GaugeValue.$Shape;
         *   (properties?: openmetrics.GaugeValue.$Properties): openmetrics.GaugeValue;
         * }}
         */
        GaugeValue.create = function(properties) {
            return new GaugeValue(properties);
        };

        /**
         * Encodes the specified GaugeValue message. Does not implicitly {@link openmetrics.GaugeValue.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.GaugeValue
         * @static
         * @param {openmetrics.GaugeValue.$Properties} message GaugeValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GaugeValue.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.doubleValue);
            if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.intValue);
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a GaugeValue message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.GaugeValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.GaugeValue & openmetrics.GaugeValue.$Shape} GaugeValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GaugeValue.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.GaugeValue();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 1)
                            break;
                        message.doubleValue = reader.double();
                        message.value = "doubleValue";
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        message.intValue = reader.int64();
                        message.value = "intValue";
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a GaugeValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.GaugeValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.GaugeValue} GaugeValue
         */
        GaugeValue.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.GaugeValue)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.GaugeValue: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.GaugeValue();
            if (object.doubleValue != null)
                message.doubleValue = $Number(object.doubleValue);
            if (object.intValue != null)
                if ($util.Long)
                    message.intValue = $util.Long.fromValue(object.intValue, false);
                else if (typeof object.intValue === "string")
                    message.intValue = $parseInt(object.intValue, 10);
                else if (typeof object.intValue === "number")
                    message.intValue = object.intValue;
                else if (typeof object.intValue === "object")
                    message.intValue = new $util.LongBits(object.intValue.low >>> 0, object.intValue.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a GaugeValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.GaugeValue
         * @static
         * @param {openmetrics.GaugeValue} message GaugeValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GaugeValue.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue")) {
                object.doubleValue = options.json && !$isFinite(message.doubleValue) ? $String(message.doubleValue) : message.doubleValue;
                if (options.oneofs)
                    object.value = "doubleValue";
            }
            if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue")) {
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.intValue = typeof message.intValue === "number" ? $BigInt(message.intValue) : $util.Long.fromBits(message.intValue.low >>> 0, message.intValue.high >>> 0, false).toBigInt();
                else if (typeof message.intValue === "number")
                    object.intValue = options.longs === $String ? $String(message.intValue) : message.intValue;
                else
                    object.intValue = options.longs === $String ? $util.Long.prototype.toString.call(message.intValue) : options.longs === $Number ? new $util.LongBits(message.intValue.low >>> 0, message.intValue.high >>> 0).toNumber() : message.intValue;
                if (options.oneofs)
                    object.value = "intValue";
            }
            return object;
        };

        /**
         * Converts this GaugeValue to JSON.
         * @function toJSON
         * @memberof openmetrics.GaugeValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GaugeValue.prototype.toJSON = function() {
            return GaugeValue.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for GaugeValue
         * @function getTypeUrl
         * @memberof openmetrics.GaugeValue
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        GaugeValue.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.GaugeValue";
        };

        return GaugeValue;
    })();

    openmetrics.CounterValue = (function() {

        /**
         * Properties of a CounterValue.
         * @typedef {Object} openmetrics.CounterValue.$Properties
         * @property {number|null} [doubleValue] CounterValue doubleValue
         * @property {number|Long|null} [intValue] CounterValue intValue
         * @property {google.protobuf.Timestamp.$Properties|null} [created] CounterValue created
         * @property {openmetrics.Exemplar.$Properties|null} [exemplar] CounterValue exemplar
         * @property {"doubleValue"|"intValue"} [total] CounterValue total
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a CounterValue.
         * @memberof openmetrics
         * @interface ICounterValue
         * @augments openmetrics.CounterValue.$Properties
         * @deprecated Use openmetrics.CounterValue.$Properties instead.
         */

        /**
         * Narrowed shape of a CounterValue.
         * @typedef {{
         *   doubleValue?: number|null;
         *   intValue?: number|Long|null;
         *   created?: google.protobuf.Timestamp.$Shape|null;
         *   exemplar?: openmetrics.Exemplar.$Shape|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ total?: undefined; doubleValue?: null; intValue?: null }|{ total?: "doubleValue"; doubleValue: number; intValue?: null }|{ total?: "intValue"; doubleValue?: null; intValue: number|Long })
         * )} openmetrics.CounterValue.$Shape
         */

        /**
         * Constructs a new CounterValue.
         * @memberof openmetrics
         * @classdesc Represents a CounterValue.
         * @constructor
         * @param {openmetrics.CounterValue.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const CounterValue = function (properties) {
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * CounterValue doubleValue.
         * @member {number|null|undefined} doubleValue
         * @memberof openmetrics.CounterValue
         * @instance
         */
        CounterValue.prototype.doubleValue = null;

        /**
         * CounterValue intValue.
         * @member {number|Long|null|undefined} intValue
         * @memberof openmetrics.CounterValue
         * @instance
         */
        CounterValue.prototype.intValue = null;

        /**
         * CounterValue created.
         * @member {google.protobuf.Timestamp.$Properties|null|undefined} created
         * @memberof openmetrics.CounterValue
         * @instance
         */
        CounterValue.prototype.created = null;

        /**
         * CounterValue exemplar.
         * @member {openmetrics.Exemplar.$Properties|null|undefined} exemplar
         * @memberof openmetrics.CounterValue
         * @instance
         */
        CounterValue.prototype.exemplar = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * CounterValue total.
         * @member {"doubleValue"|"intValue"|undefined} total
         * @memberof openmetrics.CounterValue
         * @instance
         */
        $Object.defineProperty(CounterValue.prototype, "total", {
            get: $util.oneOfGetter($oneOfFields = ["doubleValue", "intValue"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new CounterValue instance using the specified properties.
         * @function create
         * @memberof openmetrics.CounterValue
         * @static
         * @param {openmetrics.CounterValue.$Properties=} [properties] Properties to set
         * @returns {openmetrics.CounterValue} CounterValue instance
         * @type {{
         *   (properties: openmetrics.CounterValue.$Shape): openmetrics.CounterValue & openmetrics.CounterValue.$Shape;
         *   (properties?: openmetrics.CounterValue.$Properties): openmetrics.CounterValue;
         * }}
         */
        CounterValue.create = function(properties) {
            return new CounterValue(properties);
        };

        /**
         * Encodes the specified CounterValue message. Does not implicitly {@link openmetrics.CounterValue.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.CounterValue
         * @static
         * @param {openmetrics.CounterValue.$Properties} message CounterValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CounterValue.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.doubleValue);
            if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.intValue);
            if (message.created != null && $Object.hasOwnProperty.call(message, "created"))
                $root.google.protobuf.Timestamp.encode(message.created, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
            if (message.exemplar != null && $Object.hasOwnProperty.call(message, "exemplar"))
                $root.openmetrics.Exemplar.encode(message.exemplar, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a CounterValue message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.CounterValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.CounterValue & openmetrics.CounterValue.$Shape} CounterValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CounterValue.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.CounterValue();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 1)
                            break;
                        message.doubleValue = reader.double();
                        message.total = "doubleValue";
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        message.intValue = reader.uint64();
                        message.total = "intValue";
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        message.created = $root.google.protobuf.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.created);
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.exemplar = $root.openmetrics.Exemplar.decode(reader, reader.uint32(), $undefined, _depth + 1, message.exemplar);
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a CounterValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.CounterValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.CounterValue} CounterValue
         */
        CounterValue.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.CounterValue)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.CounterValue: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.CounterValue();
            if (object.doubleValue != null)
                message.doubleValue = $Number(object.doubleValue);
            if (object.intValue != null)
                if ($util.Long)
                    message.intValue = $util.Long.fromValue(object.intValue, true);
                else if (typeof object.intValue === "string")
                    message.intValue = $parseInt(object.intValue, 10);
                else if (typeof object.intValue === "number")
                    message.intValue = object.intValue;
                else if (typeof object.intValue === "object")
                    message.intValue = new $util.LongBits(object.intValue.low >>> 0, object.intValue.high >>> 0).toNumber(true);
            if (object.created != null) {
                if (!$util.isObject(object.created))
                    throw $TypeError(".openmetrics.CounterValue.created: object expected");
                message.created = $root.google.protobuf.Timestamp.fromObject(object.created, _depth + 1);
            }
            if (object.exemplar != null) {
                if (!$util.isObject(object.exemplar))
                    throw $TypeError(".openmetrics.CounterValue.exemplar: object expected");
                message.exemplar = $root.openmetrics.Exemplar.fromObject(object.exemplar, _depth + 1);
            }
            return message;
        };

        /**
         * Creates a plain object from a CounterValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.CounterValue
         * @static
         * @param {openmetrics.CounterValue} message CounterValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CounterValue.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.defaults) {
                object.created = null;
                object.exemplar = null;
            }
            if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue")) {
                object.doubleValue = options.json && !$isFinite(message.doubleValue) ? $String(message.doubleValue) : message.doubleValue;
                if (options.oneofs)
                    object.total = "doubleValue";
            }
            if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue")) {
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.intValue = typeof message.intValue === "number" ? $BigInt(message.intValue) : $util.Long.fromBits(message.intValue.low >>> 0, message.intValue.high >>> 0, true).toBigInt();
                else if (typeof message.intValue === "number")
                    object.intValue = options.longs === $String ? $String(message.intValue) : message.intValue;
                else
                    object.intValue = options.longs === $String ? $util.Long.prototype.toString.call(message.intValue) : options.longs === $Number ? new $util.LongBits(message.intValue.low >>> 0, message.intValue.high >>> 0).toNumber(true) : message.intValue;
                if (options.oneofs)
                    object.total = "intValue";
            }
            if (message.created != null && $Object.hasOwnProperty.call(message, "created"))
                object.created = $root.google.protobuf.Timestamp.toObject(message.created, options, _depth + 1);
            if (message.exemplar != null && $Object.hasOwnProperty.call(message, "exemplar"))
                object.exemplar = $root.openmetrics.Exemplar.toObject(message.exemplar, options, _depth + 1);
            return object;
        };

        /**
         * Converts this CounterValue to JSON.
         * @function toJSON
         * @memberof openmetrics.CounterValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CounterValue.prototype.toJSON = function() {
            return CounterValue.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for CounterValue
         * @function getTypeUrl
         * @memberof openmetrics.CounterValue
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        CounterValue.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.CounterValue";
        };

        return CounterValue;
    })();

    openmetrics.HistogramValue = (function() {

        /**
         * Properties of a HistogramValue.
         * @typedef {Object} openmetrics.HistogramValue.$Properties
         * @property {number|null} [doubleValue] HistogramValue doubleValue
         * @property {number|Long|null} [intValue] HistogramValue intValue
         * @property {number|Long|null} [count] HistogramValue count
         * @property {google.protobuf.Timestamp.$Properties|null} [created] HistogramValue created
         * @property {Array.<openmetrics.HistogramValue.Bucket.$Properties>|null} [buckets] HistogramValue buckets
         * @property {"doubleValue"|"intValue"} [sum] HistogramValue sum
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a HistogramValue.
         * @memberof openmetrics
         * @interface IHistogramValue
         * @augments openmetrics.HistogramValue.$Properties
         * @deprecated Use openmetrics.HistogramValue.$Properties instead.
         */

        /**
         * Narrowed shape of a HistogramValue.
         * @typedef {{
         *   doubleValue?: number|null;
         *   intValue?: number|Long|null;
         *   count?: number|Long|null;
         *   created?: google.protobuf.Timestamp.$Shape|null;
         *   buckets?: Array.<openmetrics.HistogramValue.Bucket.$Shape>|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ sum?: undefined; doubleValue?: null; intValue?: null }|{ sum?: "doubleValue"; doubleValue: number; intValue?: null }|{ sum?: "intValue"; doubleValue?: null; intValue: number|Long })
         * )} openmetrics.HistogramValue.$Shape
         */

        /**
         * Constructs a new HistogramValue.
         * @memberof openmetrics
         * @classdesc Represents a HistogramValue.
         * @constructor
         * @param {openmetrics.HistogramValue.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const HistogramValue = function (properties) {
            this.buckets = [];
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * HistogramValue doubleValue.
         * @member {number|null|undefined} doubleValue
         * @memberof openmetrics.HistogramValue
         * @instance
         */
        HistogramValue.prototype.doubleValue = null;

        /**
         * HistogramValue intValue.
         * @member {number|Long|null|undefined} intValue
         * @memberof openmetrics.HistogramValue
         * @instance
         */
        HistogramValue.prototype.intValue = null;

        /**
         * HistogramValue count.
         * @member {number|Long} count
         * @memberof openmetrics.HistogramValue
         * @instance
         */
        HistogramValue.prototype.count = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * HistogramValue created.
         * @member {google.protobuf.Timestamp.$Properties|null|undefined} created
         * @memberof openmetrics.HistogramValue
         * @instance
         */
        HistogramValue.prototype.created = null;

        /**
         * HistogramValue buckets.
         * @member {Array.<openmetrics.HistogramValue.Bucket.$Properties>} buckets
         * @memberof openmetrics.HistogramValue
         * @instance
         */
        HistogramValue.prototype.buckets = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * HistogramValue sum.
         * @member {"doubleValue"|"intValue"|undefined} sum
         * @memberof openmetrics.HistogramValue
         * @instance
         */
        $Object.defineProperty(HistogramValue.prototype, "sum", {
            get: $util.oneOfGetter($oneOfFields = ["doubleValue", "intValue"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new HistogramValue instance using the specified properties.
         * @function create
         * @memberof openmetrics.HistogramValue
         * @static
         * @param {openmetrics.HistogramValue.$Properties=} [properties] Properties to set
         * @returns {openmetrics.HistogramValue} HistogramValue instance
         * @type {{
         *   (properties: openmetrics.HistogramValue.$Shape): openmetrics.HistogramValue & openmetrics.HistogramValue.$Shape;
         *   (properties?: openmetrics.HistogramValue.$Properties): openmetrics.HistogramValue;
         * }}
         */
        HistogramValue.create = function(properties) {
            return new HistogramValue(properties);
        };

        /**
         * Encodes the specified HistogramValue message. Does not implicitly {@link openmetrics.HistogramValue.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.HistogramValue
         * @static
         * @param {openmetrics.HistogramValue.$Properties} message HistogramValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HistogramValue.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.doubleValue);
            if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.intValue);
            if (message.count != null && $Object.hasOwnProperty.call(message, "count") && (typeof message.count === "object" ? message.count.low || message.count.high : message.count !== 0))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.count);
            if (message.created != null && $Object.hasOwnProperty.call(message, "created"))
                $root.google.protobuf.Timestamp.encode(message.created, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
            if (message.buckets != null && message.buckets.length)
                for (let i = 0; i < message.buckets.length; ++i)
                    $root.openmetrics.HistogramValue.Bucket.encode(message.buckets[i], writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a HistogramValue message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.HistogramValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.HistogramValue & openmetrics.HistogramValue.$Shape} HistogramValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HistogramValue.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.HistogramValue();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 1)
                            break;
                        message.doubleValue = reader.double();
                        message.sum = "doubleValue";
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        message.intValue = reader.int64();
                        message.sum = "intValue";
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                            message.count = value;
                        else
                            delete message.count;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.created = $root.google.protobuf.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.created);
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if (!(message.buckets && message.buckets.length))
                            message.buckets = [];
                        message.buckets.push($root.openmetrics.HistogramValue.Bucket.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a HistogramValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.HistogramValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.HistogramValue} HistogramValue
         */
        HistogramValue.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.HistogramValue)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.HistogramValue: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.HistogramValue();
            if (object.doubleValue != null)
                message.doubleValue = $Number(object.doubleValue);
            if (object.intValue != null)
                if ($util.Long)
                    message.intValue = $util.Long.fromValue(object.intValue, false);
                else if (typeof object.intValue === "string")
                    message.intValue = $parseInt(object.intValue, 10);
                else if (typeof object.intValue === "number")
                    message.intValue = object.intValue;
                else if (typeof object.intValue === "object")
                    message.intValue = new $util.LongBits(object.intValue.low >>> 0, object.intValue.high >>> 0).toNumber();
            if (object.count != null)
                if (typeof object.count === "object" ? object.count.low || object.count.high : $Number(object.count) !== 0)
                    if ($util.Long)
                        message.count = $util.Long.fromValue(object.count, true);
                    else if (typeof object.count === "string")
                        message.count = $parseInt(object.count, 10);
                    else if (typeof object.count === "number")
                        message.count = object.count;
                    else if (typeof object.count === "object")
                        message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber(true);
            if (object.created != null) {
                if (!$util.isObject(object.created))
                    throw $TypeError(".openmetrics.HistogramValue.created: object expected");
                message.created = $root.google.protobuf.Timestamp.fromObject(object.created, _depth + 1);
            }
            if (object.buckets) {
                if (!$Array.isArray(object.buckets))
                    throw $TypeError(".openmetrics.HistogramValue.buckets: array expected");
                message.buckets = $Array(object.buckets.length);
                for (let i = 0; i < object.buckets.length; ++i) {
                    if (!$util.isObject(object.buckets[i]))
                        throw $TypeError(".openmetrics.HistogramValue.buckets: object expected");
                    message.buckets[i] = $root.openmetrics.HistogramValue.Bucket.fromObject(object.buckets[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a HistogramValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.HistogramValue
         * @static
         * @param {openmetrics.HistogramValue} message HistogramValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HistogramValue.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.buckets = [];
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.count = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.count = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                object.created = null;
            }
            if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue")) {
                object.doubleValue = options.json && !$isFinite(message.doubleValue) ? $String(message.doubleValue) : message.doubleValue;
                if (options.oneofs)
                    object.sum = "doubleValue";
            }
            if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue")) {
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.intValue = typeof message.intValue === "number" ? $BigInt(message.intValue) : $util.Long.fromBits(message.intValue.low >>> 0, message.intValue.high >>> 0, false).toBigInt();
                else if (typeof message.intValue === "number")
                    object.intValue = options.longs === $String ? $String(message.intValue) : message.intValue;
                else
                    object.intValue = options.longs === $String ? $util.Long.prototype.toString.call(message.intValue) : options.longs === $Number ? new $util.LongBits(message.intValue.low >>> 0, message.intValue.high >>> 0).toNumber() : message.intValue;
                if (options.oneofs)
                    object.sum = "intValue";
            }
            if (message.count != null && $Object.hasOwnProperty.call(message, "count"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.count = typeof message.count === "number" ? $BigInt(message.count) : $util.Long.fromBits(message.count.low >>> 0, message.count.high >>> 0, true).toBigInt();
                else if (typeof message.count === "number")
                    object.count = options.longs === $String ? $String(message.count) : message.count;
                else
                    object.count = options.longs === $String ? $util.Long.prototype.toString.call(message.count) : options.longs === $Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber(true) : message.count;
            if (message.created != null && $Object.hasOwnProperty.call(message, "created"))
                object.created = $root.google.protobuf.Timestamp.toObject(message.created, options, _depth + 1);
            if (message.buckets && message.buckets.length) {
                object.buckets = $Array(message.buckets.length);
                for (let j = 0; j < message.buckets.length; ++j)
                    object.buckets[j] = $root.openmetrics.HistogramValue.Bucket.toObject(message.buckets[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this HistogramValue to JSON.
         * @function toJSON
         * @memberof openmetrics.HistogramValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HistogramValue.prototype.toJSON = function() {
            return HistogramValue.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for HistogramValue
         * @function getTypeUrl
         * @memberof openmetrics.HistogramValue
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        HistogramValue.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.HistogramValue";
        };

        HistogramValue.Bucket = (function() {

            /**
             * Properties of a Bucket.
             * @typedef {Object} openmetrics.HistogramValue.Bucket.$Properties
             * @property {number|Long|null} [count] Bucket count
             * @property {number|null} [upperBound] Bucket upperBound
             * @property {openmetrics.Exemplar.$Properties|null} [exemplar] Bucket exemplar
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */

            /**
             * Properties of a Bucket.
             * @memberof openmetrics.HistogramValue
             * @interface IBucket
             * @augments openmetrics.HistogramValue.Bucket.$Properties
             * @deprecated Use openmetrics.HistogramValue.Bucket.$Properties instead.
             */

            /**
             * Shape of a Bucket.
             * @typedef {openmetrics.HistogramValue.Bucket.$Properties} openmetrics.HistogramValue.Bucket.$Shape
             */

            /**
             * Constructs a new Bucket.
             * @memberof openmetrics.HistogramValue
             * @classdesc Represents a Bucket.
             * @constructor
             * @param {openmetrics.HistogramValue.Bucket.$Properties=} [properties] Properties to set
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */
            const Bucket = function (properties) {
                if (properties)
                    for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            };

            /**
             * Bucket count.
             * @member {number|Long} count
             * @memberof openmetrics.HistogramValue.Bucket
             * @instance
             */
            Bucket.prototype.count = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Bucket upperBound.
             * @member {number} upperBound
             * @memberof openmetrics.HistogramValue.Bucket
             * @instance
             */
            Bucket.prototype.upperBound = 0;

            /**
             * Bucket exemplar.
             * @member {openmetrics.Exemplar.$Properties|null|undefined} exemplar
             * @memberof openmetrics.HistogramValue.Bucket
             * @instance
             */
            Bucket.prototype.exemplar = null;

            /**
             * Creates a new Bucket instance using the specified properties.
             * @function create
             * @memberof openmetrics.HistogramValue.Bucket
             * @static
             * @param {openmetrics.HistogramValue.Bucket.$Properties=} [properties] Properties to set
             * @returns {openmetrics.HistogramValue.Bucket} Bucket instance
             * @type {{
             *   (properties: openmetrics.HistogramValue.Bucket.$Shape): openmetrics.HistogramValue.Bucket & openmetrics.HistogramValue.Bucket.$Shape;
             *   (properties?: openmetrics.HistogramValue.Bucket.$Properties): openmetrics.HistogramValue.Bucket;
             * }}
             */
            Bucket.create = function(properties) {
                return new Bucket(properties);
            };

            /**
             * Encodes the specified Bucket message. Does not implicitly {@link openmetrics.HistogramValue.Bucket.verify|verify} messages.
             * @function encode
             * @memberof openmetrics.HistogramValue.Bucket
             * @static
             * @param {openmetrics.HistogramValue.Bucket.$Properties} message Bucket message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Bucket.encode = function (message, writer, _depth) {
                if (!writer)
                    writer = $Writer.create();
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                if (message.count != null && $Object.hasOwnProperty.call(message, "count") && (typeof message.count === "object" ? message.count.low || message.count.high : message.count !== 0))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.count);
                if (message.upperBound != null && $Object.hasOwnProperty.call(message, "upperBound") && !$Object.is(message.upperBound, 0))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.upperBound);
                if (message.exemplar != null && $Object.hasOwnProperty.call(message, "exemplar"))
                    $root.openmetrics.Exemplar.encode(message.exemplar, writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
                if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                    for (let i = 0; i < message.$unknowns.length; ++i)
                        writer.raw(message.$unknowns[i]);
                return writer;
            };

            /**
             * Decodes a Bucket message from the specified reader or buffer.
             * @function decode
             * @memberof openmetrics.HistogramValue.Bucket
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {openmetrics.HistogramValue.Bucket & openmetrics.HistogramValue.Bucket.$Shape} Bucket
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Bucket.decode = function (reader, length, _end, _depth, _target) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $Reader.recursionLimit)
                    throw $Error("max depth exceeded");
                let end, message, value;
                if (length === $undefined)
                    end = reader.len;
                else {
                    end = reader.pos + length;
                    if (end > reader.len)
                        throw $RangeError("index out of range");
                    length = reader.len;
                    reader.len = end;
                }
                message = _target || new $root.openmetrics.HistogramValue.Bucket();
                while (reader.pos < end) {
                    let start = reader.pos;
                    let tag = reader.tag();
                    if (tag === _end) {
                        _end = $undefined;
                        break;
                    }
                    let wireType = tag & 7;
                    switch (tag >>>= 3) {
                    case 1: {
                            if (wireType !== 0)
                                break;
                            if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                                message.count = value;
                            else
                                delete message.count;
                            continue;
                        }
                    case 2: {
                            if (wireType !== 1)
                                break;
                            if (!$Object.is(value = reader.double(), 0))
                                message.upperBound = value;
                            else
                                delete message.upperBound;
                            continue;
                        }
                    case 3: {
                            if (wireType !== 2)
                                break;
                            message.exemplar = $root.openmetrics.Exemplar.decode(reader, reader.uint32(), $undefined, _depth + 1, message.exemplar);
                            continue;
                        }
                    }
                    reader.skipType(wireType, _depth, tag);
                    if (!reader.discardUnknown) {
                        $util.makeProp(message, "$unknowns", false);
                        (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                    }
                }
                if (length !== $undefined) {
                    if (reader.pos !== end)
                        throw $RangeError("index out of range");
                    reader.len = length;
                }
                if (_end !== $undefined)
                    throw $Error("missing end group");
                return message;
            };

            /**
             * Creates a Bucket message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof openmetrics.HistogramValue.Bucket
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {openmetrics.HistogramValue.Bucket} Bucket
             */
            Bucket.fromObject = function (object, _depth) {
                if (object instanceof $root.openmetrics.HistogramValue.Bucket)
                    return object;
                if (!$util.isObject(object))
                    throw $TypeError(".openmetrics.HistogramValue.Bucket: object expected");
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                let message = new $root.openmetrics.HistogramValue.Bucket();
                if (object.count != null)
                    if (typeof object.count === "object" ? object.count.low || object.count.high : $Number(object.count) !== 0)
                        if ($util.Long)
                            message.count = $util.Long.fromValue(object.count, true);
                        else if (typeof object.count === "string")
                            message.count = $parseInt(object.count, 10);
                        else if (typeof object.count === "number")
                            message.count = object.count;
                        else if (typeof object.count === "object")
                            message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber(true);
                if (object.upperBound != null)
                    if (!$Object.is($Number(object.upperBound), 0))
                        message.upperBound = $Number(object.upperBound);
                if (object.exemplar != null) {
                    if (!$util.isObject(object.exemplar))
                        throw $TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
                    message.exemplar = $root.openmetrics.Exemplar.fromObject(object.exemplar, _depth + 1);
                }
                return message;
            };

            /**
             * Creates a plain object from a Bucket message. Also converts values to other types if specified.
             * @function toObject
             * @memberof openmetrics.HistogramValue.Bucket
             * @static
             * @param {openmetrics.HistogramValue.Bucket} message Bucket
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Bucket.toObject = function (message, options, _depth) {
                if (!options)
                    options = {};
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.count = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                    } else
                        object.count = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                    object.upperBound = 0;
                    object.exemplar = null;
                }
                if (message.count != null && $Object.hasOwnProperty.call(message, "count"))
                    if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                        object.count = typeof message.count === "number" ? $BigInt(message.count) : $util.Long.fromBits(message.count.low >>> 0, message.count.high >>> 0, true).toBigInt();
                    else if (typeof message.count === "number")
                        object.count = options.longs === $String ? $String(message.count) : message.count;
                    else
                        object.count = options.longs === $String ? $util.Long.prototype.toString.call(message.count) : options.longs === $Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber(true) : message.count;
                if (message.upperBound != null && $Object.hasOwnProperty.call(message, "upperBound"))
                    object.upperBound = options.json && !$isFinite(message.upperBound) ? $String(message.upperBound) : message.upperBound;
                if (message.exemplar != null && $Object.hasOwnProperty.call(message, "exemplar"))
                    object.exemplar = $root.openmetrics.Exemplar.toObject(message.exemplar, options, _depth + 1);
                return object;
            };

            /**
             * Converts this Bucket to JSON.
             * @function toJSON
             * @memberof openmetrics.HistogramValue.Bucket
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Bucket.prototype.toJSON = function() {
                return Bucket.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the type url for Bucket
             * @function getTypeUrl
             * @memberof openmetrics.HistogramValue.Bucket
             * @static
             * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
             * @returns {string} The type url
             */
            Bucket.getTypeUrl = function(prefix) {
                if (prefix === $undefined)
                    prefix = "type.googleapis.com";
                return prefix + "/openmetrics.HistogramValue.Bucket";
            };

            return Bucket;
        })();

        return HistogramValue;
    })();

    openmetrics.Exemplar = (function() {

        /**
         * Properties of an Exemplar.
         * @typedef {Object} openmetrics.Exemplar.$Properties
         * @property {number|null} [value] Exemplar value
         * @property {google.protobuf.Timestamp.$Properties|null} [timestamp] Exemplar timestamp
         * @property {Array.<openmetrics.Label.$Properties>|null} [label] Exemplar label
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an Exemplar.
         * @memberof openmetrics
         * @interface IExemplar
         * @augments openmetrics.Exemplar.$Properties
         * @deprecated Use openmetrics.Exemplar.$Properties instead.
         */

        /**
         * Shape of an Exemplar.
         * @typedef {openmetrics.Exemplar.$Properties} openmetrics.Exemplar.$Shape
         */

        /**
         * Constructs a new Exemplar.
         * @memberof openmetrics
         * @classdesc Represents an Exemplar.
         * @constructor
         * @param {openmetrics.Exemplar.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const Exemplar = function (properties) {
            this.label = [];
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * Exemplar value.
         * @member {number} value
         * @memberof openmetrics.Exemplar
         * @instance
         */
        Exemplar.prototype.value = 0;

        /**
         * Exemplar timestamp.
         * @member {google.protobuf.Timestamp.$Properties|null|undefined} timestamp
         * @memberof openmetrics.Exemplar
         * @instance
         */
        Exemplar.prototype.timestamp = null;

        /**
         * Exemplar label.
         * @member {Array.<openmetrics.Label.$Properties>} label
         * @memberof openmetrics.Exemplar
         * @instance
         */
        Exemplar.prototype.label = $util.emptyArray;

        /**
         * Creates a new Exemplar instance using the specified properties.
         * @function create
         * @memberof openmetrics.Exemplar
         * @static
         * @param {openmetrics.Exemplar.$Properties=} [properties] Properties to set
         * @returns {openmetrics.Exemplar} Exemplar instance
         * @type {{
         *   (properties: openmetrics.Exemplar.$Shape): openmetrics.Exemplar & openmetrics.Exemplar.$Shape;
         *   (properties?: openmetrics.Exemplar.$Properties): openmetrics.Exemplar;
         * }}
         */
        Exemplar.create = function(properties) {
            return new Exemplar(properties);
        };

        /**
         * Encodes the specified Exemplar message. Does not implicitly {@link openmetrics.Exemplar.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.Exemplar
         * @static
         * @param {openmetrics.Exemplar.$Properties} message Exemplar message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Exemplar.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.value != null && $Object.hasOwnProperty.call(message, "value") && !$Object.is(message.value, 0))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.value);
            if (message.timestamp != null && $Object.hasOwnProperty.call(message, "timestamp"))
                $root.google.protobuf.Timestamp.encode(message.timestamp, writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
            if (message.label != null && message.label.length)
                for (let i = 0; i < message.label.length; ++i)
                    $root.openmetrics.Label.encode(message.label[i], writer.uint32(/* id 3, wireType 2 =*/26).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes an Exemplar message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.Exemplar
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.Exemplar & openmetrics.Exemplar.$Shape} Exemplar
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Exemplar.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.Exemplar();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 1)
                            break;
                        if (!$Object.is(value = reader.double(), 0))
                            message.value = value;
                        else
                            delete message.value;
                        continue;
                    }
                case 2: {
                        if (wireType !== 2)
                            break;
                        message.timestamp = $root.google.protobuf.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.timestamp);
                        continue;
                    }
                case 3: {
                        if (wireType !== 2)
                            break;
                        if (!(message.label && message.label.length))
                            message.label = [];
                        message.label.push($root.openmetrics.Label.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates an Exemplar message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.Exemplar
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.Exemplar} Exemplar
         */
        Exemplar.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.Exemplar)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.Exemplar: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.Exemplar();
            if (object.value != null)
                if (!$Object.is($Number(object.value), 0))
                    message.value = $Number(object.value);
            if (object.timestamp != null) {
                if (!$util.isObject(object.timestamp))
                    throw $TypeError(".openmetrics.Exemplar.timestamp: object expected");
                message.timestamp = $root.google.protobuf.Timestamp.fromObject(object.timestamp, _depth + 1);
            }
            if (object.label) {
                if (!$Array.isArray(object.label))
                    throw $TypeError(".openmetrics.Exemplar.label: array expected");
                message.label = $Array(object.label.length);
                for (let i = 0; i < object.label.length; ++i) {
                    if (!$util.isObject(object.label[i]))
                        throw $TypeError(".openmetrics.Exemplar.label: object expected");
                    message.label[i] = $root.openmetrics.Label.fromObject(object.label[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an Exemplar message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.Exemplar
         * @static
         * @param {openmetrics.Exemplar} message Exemplar
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Exemplar.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.label = [];
            if (options.defaults) {
                object.value = 0;
                object.timestamp = null;
            }
            if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
                object.value = options.json && !$isFinite(message.value) ? $String(message.value) : message.value;
            if (message.timestamp != null && $Object.hasOwnProperty.call(message, "timestamp"))
                object.timestamp = $root.google.protobuf.Timestamp.toObject(message.timestamp, options, _depth + 1);
            if (message.label && message.label.length) {
                object.label = $Array(message.label.length);
                for (let j = 0; j < message.label.length; ++j)
                    object.label[j] = $root.openmetrics.Label.toObject(message.label[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this Exemplar to JSON.
         * @function toJSON
         * @memberof openmetrics.Exemplar
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Exemplar.prototype.toJSON = function() {
            return Exemplar.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for Exemplar
         * @function getTypeUrl
         * @memberof openmetrics.Exemplar
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        Exemplar.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.Exemplar";
        };

        return Exemplar;
    })();

    openmetrics.StateSetValue = (function() {

        /**
         * Properties of a StateSetValue.
         * @typedef {Object} openmetrics.StateSetValue.$Properties
         * @property {Array.<openmetrics.StateSetValue.State.$Properties>|null} [states] StateSetValue states
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a StateSetValue.
         * @memberof openmetrics
         * @interface IStateSetValue
         * @augments openmetrics.StateSetValue.$Properties
         * @deprecated Use openmetrics.StateSetValue.$Properties instead.
         */

        /**
         * Shape of a StateSetValue.
         * @typedef {openmetrics.StateSetValue.$Properties} openmetrics.StateSetValue.$Shape
         */

        /**
         * Constructs a new StateSetValue.
         * @memberof openmetrics
         * @classdesc Represents a StateSetValue.
         * @constructor
         * @param {openmetrics.StateSetValue.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const StateSetValue = function (properties) {
            this.states = [];
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * StateSetValue states.
         * @member {Array.<openmetrics.StateSetValue.State.$Properties>} states
         * @memberof openmetrics.StateSetValue
         * @instance
         */
        StateSetValue.prototype.states = $util.emptyArray;

        /**
         * Creates a new StateSetValue instance using the specified properties.
         * @function create
         * @memberof openmetrics.StateSetValue
         * @static
         * @param {openmetrics.StateSetValue.$Properties=} [properties] Properties to set
         * @returns {openmetrics.StateSetValue} StateSetValue instance
         * @type {{
         *   (properties: openmetrics.StateSetValue.$Shape): openmetrics.StateSetValue & openmetrics.StateSetValue.$Shape;
         *   (properties?: openmetrics.StateSetValue.$Properties): openmetrics.StateSetValue;
         * }}
         */
        StateSetValue.create = function(properties) {
            return new StateSetValue(properties);
        };

        /**
         * Encodes the specified StateSetValue message. Does not implicitly {@link openmetrics.StateSetValue.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.StateSetValue
         * @static
         * @param {openmetrics.StateSetValue.$Properties} message StateSetValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StateSetValue.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.states != null && message.states.length)
                for (let i = 0; i < message.states.length; ++i)
                    $root.openmetrics.StateSetValue.State.encode(message.states[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a StateSetValue message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.StateSetValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.StateSetValue & openmetrics.StateSetValue.$Shape} StateSetValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StateSetValue.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.StateSetValue();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if (!(message.states && message.states.length))
                            message.states = [];
                        message.states.push($root.openmetrics.StateSetValue.State.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a StateSetValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.StateSetValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.StateSetValue} StateSetValue
         */
        StateSetValue.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.StateSetValue)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.StateSetValue: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.StateSetValue();
            if (object.states) {
                if (!$Array.isArray(object.states))
                    throw $TypeError(".openmetrics.StateSetValue.states: array expected");
                message.states = $Array(object.states.length);
                for (let i = 0; i < object.states.length; ++i) {
                    if (!$util.isObject(object.states[i]))
                        throw $TypeError(".openmetrics.StateSetValue.states: object expected");
                    message.states[i] = $root.openmetrics.StateSetValue.State.fromObject(object.states[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a StateSetValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.StateSetValue
         * @static
         * @param {openmetrics.StateSetValue} message StateSetValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StateSetValue.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.states = [];
            if (message.states && message.states.length) {
                object.states = $Array(message.states.length);
                for (let j = 0; j < message.states.length; ++j)
                    object.states[j] = $root.openmetrics.StateSetValue.State.toObject(message.states[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this StateSetValue to JSON.
         * @function toJSON
         * @memberof openmetrics.StateSetValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StateSetValue.prototype.toJSON = function() {
            return StateSetValue.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for StateSetValue
         * @function getTypeUrl
         * @memberof openmetrics.StateSetValue
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        StateSetValue.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.StateSetValue";
        };

        StateSetValue.State = (function() {

            /**
             * Properties of a State.
             * @typedef {Object} openmetrics.StateSetValue.State.$Properties
             * @property {boolean|null} [enabled] State enabled
             * @property {string|null} [name] State name
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */

            /**
             * Properties of a State.
             * @memberof openmetrics.StateSetValue
             * @interface IState
             * @augments openmetrics.StateSetValue.State.$Properties
             * @deprecated Use openmetrics.StateSetValue.State.$Properties instead.
             */

            /**
             * Shape of a State.
             * @typedef {openmetrics.StateSetValue.State.$Properties} openmetrics.StateSetValue.State.$Shape
             */

            /**
             * Constructs a new State.
             * @memberof openmetrics.StateSetValue
             * @classdesc Represents a State.
             * @constructor
             * @param {openmetrics.StateSetValue.State.$Properties=} [properties] Properties to set
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */
            const State = function (properties) {
                if (properties)
                    for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            };

            /**
             * State enabled.
             * @member {boolean} enabled
             * @memberof openmetrics.StateSetValue.State
             * @instance
             */
            State.prototype.enabled = false;

            /**
             * State name.
             * @member {string} name
             * @memberof openmetrics.StateSetValue.State
             * @instance
             */
            State.prototype.name = "";

            /**
             * Creates a new State instance using the specified properties.
             * @function create
             * @memberof openmetrics.StateSetValue.State
             * @static
             * @param {openmetrics.StateSetValue.State.$Properties=} [properties] Properties to set
             * @returns {openmetrics.StateSetValue.State} State instance
             * @type {{
             *   (properties: openmetrics.StateSetValue.State.$Shape): openmetrics.StateSetValue.State & openmetrics.StateSetValue.State.$Shape;
             *   (properties?: openmetrics.StateSetValue.State.$Properties): openmetrics.StateSetValue.State;
             * }}
             */
            State.create = function(properties) {
                return new State(properties);
            };

            /**
             * Encodes the specified State message. Does not implicitly {@link openmetrics.StateSetValue.State.verify|verify} messages.
             * @function encode
             * @memberof openmetrics.StateSetValue.State
             * @static
             * @param {openmetrics.StateSetValue.State.$Properties} message State message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            State.encode = function (message, writer, _depth) {
                if (!writer)
                    writer = $Writer.create();
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                if (message.enabled != null && $Object.hasOwnProperty.call(message, "enabled") && message.enabled !== false)
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
                if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                    for (let i = 0; i < message.$unknowns.length; ++i)
                        writer.raw(message.$unknowns[i]);
                return writer;
            };

            /**
             * Decodes a State message from the specified reader or buffer.
             * @function decode
             * @memberof openmetrics.StateSetValue.State
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {openmetrics.StateSetValue.State & openmetrics.StateSetValue.State.$Shape} State
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            State.decode = function (reader, length, _end, _depth, _target) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $Reader.recursionLimit)
                    throw $Error("max depth exceeded");
                let end, message, value;
                if (length === $undefined)
                    end = reader.len;
                else {
                    end = reader.pos + length;
                    if (end > reader.len)
                        throw $RangeError("index out of range");
                    length = reader.len;
                    reader.len = end;
                }
                message = _target || new $root.openmetrics.StateSetValue.State();
                while (reader.pos < end) {
                    let start = reader.pos;
                    let tag = reader.tag();
                    if (tag === _end) {
                        _end = $undefined;
                        break;
                    }
                    let wireType = tag & 7;
                    switch (tag >>>= 3) {
                    case 1: {
                            if (wireType !== 0)
                                break;
                            if (value = reader.bool())
                                message.enabled = value;
                            else
                                delete message.enabled;
                            continue;
                        }
                    case 2: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.stringVerify()).length)
                                message.name = value;
                            else
                                delete message.name;
                            continue;
                        }
                    }
                    reader.skipType(wireType, _depth, tag);
                    if (!reader.discardUnknown) {
                        $util.makeProp(message, "$unknowns", false);
                        (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                    }
                }
                if (length !== $undefined) {
                    if (reader.pos !== end)
                        throw $RangeError("index out of range");
                    reader.len = length;
                }
                if (_end !== $undefined)
                    throw $Error("missing end group");
                return message;
            };

            /**
             * Creates a State message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof openmetrics.StateSetValue.State
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {openmetrics.StateSetValue.State} State
             */
            State.fromObject = function (object, _depth) {
                if (object instanceof $root.openmetrics.StateSetValue.State)
                    return object;
                if (!$util.isObject(object))
                    throw $TypeError(".openmetrics.StateSetValue.State: object expected");
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                let message = new $root.openmetrics.StateSetValue.State();
                if (object.enabled != null)
                    if (object.enabled)
                        message.enabled = $Boolean(object.enabled);
                if (object.name != null)
                    if (typeof object.name !== "string" || object.name.length)
                        message.name = $String(object.name);
                return message;
            };

            /**
             * Creates a plain object from a State message. Also converts values to other types if specified.
             * @function toObject
             * @memberof openmetrics.StateSetValue.State
             * @static
             * @param {openmetrics.StateSetValue.State} message State
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            State.toObject = function (message, options, _depth) {
                if (!options)
                    options = {};
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                let object = {};
                if (options.defaults) {
                    object.enabled = false;
                    object.name = "";
                }
                if (message.enabled != null && $Object.hasOwnProperty.call(message, "enabled"))
                    object.enabled = message.enabled;
                if (message.name != null && $Object.hasOwnProperty.call(message, "name"))
                    object.name = message.name;
                return object;
            };

            /**
             * Converts this State to JSON.
             * @function toJSON
             * @memberof openmetrics.StateSetValue.State
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            State.prototype.toJSON = function() {
                return State.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the type url for State
             * @function getTypeUrl
             * @memberof openmetrics.StateSetValue.State
             * @static
             * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
             * @returns {string} The type url
             */
            State.getTypeUrl = function(prefix) {
                if (prefix === $undefined)
                    prefix = "type.googleapis.com";
                return prefix + "/openmetrics.StateSetValue.State";
            };

            return State;
        })();

        return StateSetValue;
    })();

    openmetrics.InfoValue = (function() {

        /**
         * Properties of an InfoValue.
         * @typedef {Object} openmetrics.InfoValue.$Properties
         * @property {Array.<openmetrics.Label.$Properties>|null} [info] InfoValue info
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of an InfoValue.
         * @memberof openmetrics
         * @interface IInfoValue
         * @augments openmetrics.InfoValue.$Properties
         * @deprecated Use openmetrics.InfoValue.$Properties instead.
         */

        /**
         * Shape of an InfoValue.
         * @typedef {openmetrics.InfoValue.$Properties} openmetrics.InfoValue.$Shape
         */

        /**
         * Constructs a new InfoValue.
         * @memberof openmetrics
         * @classdesc Represents an InfoValue.
         * @constructor
         * @param {openmetrics.InfoValue.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const InfoValue = function (properties) {
            this.info = [];
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * InfoValue info.
         * @member {Array.<openmetrics.Label.$Properties>} info
         * @memberof openmetrics.InfoValue
         * @instance
         */
        InfoValue.prototype.info = $util.emptyArray;

        /**
         * Creates a new InfoValue instance using the specified properties.
         * @function create
         * @memberof openmetrics.InfoValue
         * @static
         * @param {openmetrics.InfoValue.$Properties=} [properties] Properties to set
         * @returns {openmetrics.InfoValue} InfoValue instance
         * @type {{
         *   (properties: openmetrics.InfoValue.$Shape): openmetrics.InfoValue & openmetrics.InfoValue.$Shape;
         *   (properties?: openmetrics.InfoValue.$Properties): openmetrics.InfoValue;
         * }}
         */
        InfoValue.create = function(properties) {
            return new InfoValue(properties);
        };

        /**
         * Encodes the specified InfoValue message. Does not implicitly {@link openmetrics.InfoValue.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.InfoValue
         * @static
         * @param {openmetrics.InfoValue.$Properties} message InfoValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InfoValue.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.info != null && message.info.length)
                for (let i = 0; i < message.info.length; ++i)
                    $root.openmetrics.Label.encode(message.info[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes an InfoValue message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.InfoValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.InfoValue & openmetrics.InfoValue.$Shape} InfoValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InfoValue.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.InfoValue();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 2)
                            break;
                        if (!(message.info && message.info.length))
                            message.info = [];
                        message.info.push($root.openmetrics.Label.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates an InfoValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.InfoValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.InfoValue} InfoValue
         */
        InfoValue.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.InfoValue)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.InfoValue: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.InfoValue();
            if (object.info) {
                if (!$Array.isArray(object.info))
                    throw $TypeError(".openmetrics.InfoValue.info: array expected");
                message.info = $Array(object.info.length);
                for (let i = 0; i < object.info.length; ++i) {
                    if (!$util.isObject(object.info[i]))
                        throw $TypeError(".openmetrics.InfoValue.info: object expected");
                    message.info[i] = $root.openmetrics.Label.fromObject(object.info[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an InfoValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.InfoValue
         * @static
         * @param {openmetrics.InfoValue} message InfoValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InfoValue.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.info = [];
            if (message.info && message.info.length) {
                object.info = $Array(message.info.length);
                for (let j = 0; j < message.info.length; ++j)
                    object.info[j] = $root.openmetrics.Label.toObject(message.info[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this InfoValue to JSON.
         * @function toJSON
         * @memberof openmetrics.InfoValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InfoValue.prototype.toJSON = function() {
            return InfoValue.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for InfoValue
         * @function getTypeUrl
         * @memberof openmetrics.InfoValue
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        InfoValue.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.InfoValue";
        };

        return InfoValue;
    })();

    openmetrics.SummaryValue = (function() {

        /**
         * Properties of a SummaryValue.
         * @typedef {Object} openmetrics.SummaryValue.$Properties
         * @property {number|null} [doubleValue] SummaryValue doubleValue
         * @property {number|Long|null} [intValue] SummaryValue intValue
         * @property {number|Long|null} [count] SummaryValue count
         * @property {google.protobuf.Timestamp.$Properties|null} [created] SummaryValue created
         * @property {Array.<openmetrics.SummaryValue.Quantile.$Properties>|null} [quantile] SummaryValue quantile
         * @property {"doubleValue"|"intValue"} [sum] SummaryValue sum
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */

        /**
         * Properties of a SummaryValue.
         * @memberof openmetrics
         * @interface ISummaryValue
         * @augments openmetrics.SummaryValue.$Properties
         * @deprecated Use openmetrics.SummaryValue.$Properties instead.
         */

        /**
         * Narrowed shape of a SummaryValue.
         * @typedef {{
         *   doubleValue?: number|null;
         *   intValue?: number|Long|null;
         *   count?: number|Long|null;
         *   created?: google.protobuf.Timestamp.$Shape|null;
         *   quantile?: Array.<openmetrics.SummaryValue.Quantile.$Shape>|null;
         *   $unknowns?: Array.<Uint8Array>;
         * } & (
         *   ({ sum?: undefined; doubleValue?: null; intValue?: null }|{ sum?: "doubleValue"; doubleValue: number; intValue?: null }|{ sum?: "intValue"; doubleValue?: null; intValue: number|Long })
         * )} openmetrics.SummaryValue.$Shape
         */

        /**
         * Constructs a new SummaryValue.
         * @memberof openmetrics
         * @classdesc Represents a SummaryValue.
         * @constructor
         * @param {openmetrics.SummaryValue.$Properties=} [properties] Properties to set
         * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
         */
        const SummaryValue = function (properties) {
            this.quantile = [];
            if (properties)
                for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null && keys[i] !== "__proto__")
                        this[keys[i]] = properties[keys[i]];
        };

        /**
         * SummaryValue doubleValue.
         * @member {number|null|undefined} doubleValue
         * @memberof openmetrics.SummaryValue
         * @instance
         */
        SummaryValue.prototype.doubleValue = null;

        /**
         * SummaryValue intValue.
         * @member {number|Long|null|undefined} intValue
         * @memberof openmetrics.SummaryValue
         * @instance
         */
        SummaryValue.prototype.intValue = null;

        /**
         * SummaryValue count.
         * @member {number|Long} count
         * @memberof openmetrics.SummaryValue
         * @instance
         */
        SummaryValue.prototype.count = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SummaryValue created.
         * @member {google.protobuf.Timestamp.$Properties|null|undefined} created
         * @memberof openmetrics.SummaryValue
         * @instance
         */
        SummaryValue.prototype.created = null;

        /**
         * SummaryValue quantile.
         * @member {Array.<openmetrics.SummaryValue.Quantile.$Properties>} quantile
         * @memberof openmetrics.SummaryValue
         * @instance
         */
        SummaryValue.prototype.quantile = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * SummaryValue sum.
         * @member {"doubleValue"|"intValue"|undefined} sum
         * @memberof openmetrics.SummaryValue
         * @instance
         */
        $Object.defineProperty(SummaryValue.prototype, "sum", {
            get: $util.oneOfGetter($oneOfFields = ["doubleValue", "intValue"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SummaryValue instance using the specified properties.
         * @function create
         * @memberof openmetrics.SummaryValue
         * @static
         * @param {openmetrics.SummaryValue.$Properties=} [properties] Properties to set
         * @returns {openmetrics.SummaryValue} SummaryValue instance
         * @type {{
         *   (properties: openmetrics.SummaryValue.$Shape): openmetrics.SummaryValue & openmetrics.SummaryValue.$Shape;
         *   (properties?: openmetrics.SummaryValue.$Properties): openmetrics.SummaryValue;
         * }}
         */
        SummaryValue.create = function(properties) {
            return new SummaryValue(properties);
        };

        /**
         * Encodes the specified SummaryValue message. Does not implicitly {@link openmetrics.SummaryValue.verify|verify} messages.
         * @function encode
         * @memberof openmetrics.SummaryValue
         * @static
         * @param {openmetrics.SummaryValue.$Properties} message SummaryValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SummaryValue.encode = function (message, writer, _depth) {
            if (!writer)
                writer = $Writer.create();
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.doubleValue);
            if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.intValue);
            if (message.count != null && $Object.hasOwnProperty.call(message, "count") && (typeof message.count === "object" ? message.count.low || message.count.high : message.count !== 0))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.count);
            if (message.created != null && $Object.hasOwnProperty.call(message, "created"))
                $root.google.protobuf.Timestamp.encode(message.created, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
            if (message.quantile != null && message.quantile.length)
                for (let i = 0; i < message.quantile.length; ++i)
                    $root.openmetrics.SummaryValue.Quantile.encode(message.quantile[i], writer.uint32(/* id 5, wireType 2 =*/42).fork(), _depth + 1).ldelim();
            if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                for (let i = 0; i < message.$unknowns.length; ++i)
                    writer.raw(message.$unknowns[i]);
            return writer;
        };

        /**
         * Decodes a SummaryValue message from the specified reader or buffer.
         * @function decode
         * @memberof openmetrics.SummaryValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {openmetrics.SummaryValue & openmetrics.SummaryValue.$Shape} SummaryValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SummaryValue.decode = function (reader, length, _end, _depth, _target) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $Reader.recursionLimit)
                throw $Error("max depth exceeded");
            let end, message, value;
            if (length === $undefined)
                end = reader.len;
            else {
                end = reader.pos + length;
                if (end > reader.len)
                    throw $RangeError("index out of range");
                length = reader.len;
                reader.len = end;
            }
            message = _target || new $root.openmetrics.SummaryValue();
            while (reader.pos < end) {
                let start = reader.pos;
                let tag = reader.tag();
                if (tag === _end) {
                    _end = $undefined;
                    break;
                }
                let wireType = tag & 7;
                switch (tag >>>= 3) {
                case 1: {
                        if (wireType !== 1)
                            break;
                        message.doubleValue = reader.double();
                        message.sum = "doubleValue";
                        continue;
                    }
                case 2: {
                        if (wireType !== 0)
                            break;
                        message.intValue = reader.int64();
                        message.sum = "intValue";
                        continue;
                    }
                case 3: {
                        if (wireType !== 0)
                            break;
                        if (typeof (value = reader.uint64()) === "object" ? value.low || value.high : value !== 0)
                            message.count = value;
                        else
                            delete message.count;
                        continue;
                    }
                case 4: {
                        if (wireType !== 2)
                            break;
                        message.created = $root.google.protobuf.Timestamp.decode(reader, reader.uint32(), $undefined, _depth + 1, message.created);
                        continue;
                    }
                case 5: {
                        if (wireType !== 2)
                            break;
                        if (!(message.quantile && message.quantile.length))
                            message.quantile = [];
                        message.quantile.push($root.openmetrics.SummaryValue.Quantile.decode(reader, reader.uint32(), $undefined, _depth + 1));
                        continue;
                    }
                }
                reader.skipType(wireType, _depth, tag);
                if (!reader.discardUnknown) {
                    $util.makeProp(message, "$unknowns", false);
                    (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                }
            }
            if (length !== $undefined) {
                if (reader.pos !== end)
                    throw $RangeError("index out of range");
                reader.len = length;
            }
            if (_end !== $undefined)
                throw $Error("missing end group");
            return message;
        };

        /**
         * Creates a SummaryValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof openmetrics.SummaryValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {openmetrics.SummaryValue} SummaryValue
         */
        SummaryValue.fromObject = function (object, _depth) {
            if (object instanceof $root.openmetrics.SummaryValue)
                return object;
            if (!$util.isObject(object))
                throw $TypeError(".openmetrics.SummaryValue: object expected");
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let message = new $root.openmetrics.SummaryValue();
            if (object.doubleValue != null)
                message.doubleValue = $Number(object.doubleValue);
            if (object.intValue != null)
                if ($util.Long)
                    message.intValue = $util.Long.fromValue(object.intValue, false);
                else if (typeof object.intValue === "string")
                    message.intValue = $parseInt(object.intValue, 10);
                else if (typeof object.intValue === "number")
                    message.intValue = object.intValue;
                else if (typeof object.intValue === "object")
                    message.intValue = new $util.LongBits(object.intValue.low >>> 0, object.intValue.high >>> 0).toNumber();
            if (object.count != null)
                if (typeof object.count === "object" ? object.count.low || object.count.high : $Number(object.count) !== 0)
                    if ($util.Long)
                        message.count = $util.Long.fromValue(object.count, true);
                    else if (typeof object.count === "string")
                        message.count = $parseInt(object.count, 10);
                    else if (typeof object.count === "number")
                        message.count = object.count;
                    else if (typeof object.count === "object")
                        message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber(true);
            if (object.created != null) {
                if (!$util.isObject(object.created))
                    throw $TypeError(".openmetrics.SummaryValue.created: object expected");
                message.created = $root.google.protobuf.Timestamp.fromObject(object.created, _depth + 1);
            }
            if (object.quantile) {
                if (!$Array.isArray(object.quantile))
                    throw $TypeError(".openmetrics.SummaryValue.quantile: array expected");
                message.quantile = $Array(object.quantile.length);
                for (let i = 0; i < object.quantile.length; ++i) {
                    if (!$util.isObject(object.quantile[i]))
                        throw $TypeError(".openmetrics.SummaryValue.quantile: object expected");
                    message.quantile[i] = $root.openmetrics.SummaryValue.Quantile.fromObject(object.quantile[i], _depth + 1);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SummaryValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof openmetrics.SummaryValue
         * @static
         * @param {openmetrics.SummaryValue} message SummaryValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SummaryValue.toObject = function (message, options, _depth) {
            if (!options)
                options = {};
            if (_depth === $undefined)
                _depth = 0;
            if (_depth > $util.recursionLimit)
                throw $Error("max depth exceeded");
            let object = {};
            if (options.arrays || options.defaults)
                object.quantile = [];
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.count = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                } else
                    object.count = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                object.created = null;
            }
            if (message.doubleValue != null && $Object.hasOwnProperty.call(message, "doubleValue")) {
                object.doubleValue = options.json && !$isFinite(message.doubleValue) ? $String(message.doubleValue) : message.doubleValue;
                if (options.oneofs)
                    object.sum = "doubleValue";
            }
            if (message.intValue != null && $Object.hasOwnProperty.call(message, "intValue")) {
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.intValue = typeof message.intValue === "number" ? $BigInt(message.intValue) : $util.Long.fromBits(message.intValue.low >>> 0, message.intValue.high >>> 0, false).toBigInt();
                else if (typeof message.intValue === "number")
                    object.intValue = options.longs === $String ? $String(message.intValue) : message.intValue;
                else
                    object.intValue = options.longs === $String ? $util.Long.prototype.toString.call(message.intValue) : options.longs === $Number ? new $util.LongBits(message.intValue.low >>> 0, message.intValue.high >>> 0).toNumber() : message.intValue;
                if (options.oneofs)
                    object.sum = "intValue";
            }
            if (message.count != null && $Object.hasOwnProperty.call(message, "count"))
                if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                    object.count = typeof message.count === "number" ? $BigInt(message.count) : $util.Long.fromBits(message.count.low >>> 0, message.count.high >>> 0, true).toBigInt();
                else if (typeof message.count === "number")
                    object.count = options.longs === $String ? $String(message.count) : message.count;
                else
                    object.count = options.longs === $String ? $util.Long.prototype.toString.call(message.count) : options.longs === $Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber(true) : message.count;
            if (message.created != null && $Object.hasOwnProperty.call(message, "created"))
                object.created = $root.google.protobuf.Timestamp.toObject(message.created, options, _depth + 1);
            if (message.quantile && message.quantile.length) {
                object.quantile = $Array(message.quantile.length);
                for (let j = 0; j < message.quantile.length; ++j)
                    object.quantile[j] = $root.openmetrics.SummaryValue.Quantile.toObject(message.quantile[j], options, _depth + 1);
            }
            return object;
        };

        /**
         * Converts this SummaryValue to JSON.
         * @function toJSON
         * @memberof openmetrics.SummaryValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SummaryValue.prototype.toJSON = function() {
            return SummaryValue.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the type url for SummaryValue
         * @function getTypeUrl
         * @memberof openmetrics.SummaryValue
         * @static
         * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
         * @returns {string} The type url
         */
        SummaryValue.getTypeUrl = function(prefix) {
            if (prefix === $undefined)
                prefix = "type.googleapis.com";
            return prefix + "/openmetrics.SummaryValue";
        };

        SummaryValue.Quantile = (function() {

            /**
             * Properties of a Quantile.
             * @typedef {Object} openmetrics.SummaryValue.Quantile.$Properties
             * @property {number|null} [quantile] Quantile quantile
             * @property {number|null} [value] Quantile value
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */

            /**
             * Properties of a Quantile.
             * @memberof openmetrics.SummaryValue
             * @interface IQuantile
             * @augments openmetrics.SummaryValue.Quantile.$Properties
             * @deprecated Use openmetrics.SummaryValue.Quantile.$Properties instead.
             */

            /**
             * Shape of a Quantile.
             * @typedef {openmetrics.SummaryValue.Quantile.$Properties} openmetrics.SummaryValue.Quantile.$Shape
             */

            /**
             * Constructs a new Quantile.
             * @memberof openmetrics.SummaryValue
             * @classdesc Represents a Quantile.
             * @constructor
             * @param {openmetrics.SummaryValue.Quantile.$Properties=} [properties] Properties to set
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */
            const Quantile = function (properties) {
                if (properties)
                    for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            };

            /**
             * Quantile quantile.
             * @member {number} quantile
             * @memberof openmetrics.SummaryValue.Quantile
             * @instance
             */
            Quantile.prototype.quantile = 0;

            /**
             * Quantile value.
             * @member {number} value
             * @memberof openmetrics.SummaryValue.Quantile
             * @instance
             */
            Quantile.prototype.value = 0;

            /**
             * Creates a new Quantile instance using the specified properties.
             * @function create
             * @memberof openmetrics.SummaryValue.Quantile
             * @static
             * @param {openmetrics.SummaryValue.Quantile.$Properties=} [properties] Properties to set
             * @returns {openmetrics.SummaryValue.Quantile} Quantile instance
             * @type {{
             *   (properties: openmetrics.SummaryValue.Quantile.$Shape): openmetrics.SummaryValue.Quantile & openmetrics.SummaryValue.Quantile.$Shape;
             *   (properties?: openmetrics.SummaryValue.Quantile.$Properties): openmetrics.SummaryValue.Quantile;
             * }}
             */
            Quantile.create = function(properties) {
                return new Quantile(properties);
            };

            /**
             * Encodes the specified Quantile message. Does not implicitly {@link openmetrics.SummaryValue.Quantile.verify|verify} messages.
             * @function encode
             * @memberof openmetrics.SummaryValue.Quantile
             * @static
             * @param {openmetrics.SummaryValue.Quantile.$Properties} message Quantile message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Quantile.encode = function (message, writer, _depth) {
                if (!writer)
                    writer = $Writer.create();
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                if (message.quantile != null && $Object.hasOwnProperty.call(message, "quantile") && !$Object.is(message.quantile, 0))
                    writer.uint32(/* id 1, wireType 1 =*/9).double(message.quantile);
                if (message.value != null && $Object.hasOwnProperty.call(message, "value") && !$Object.is(message.value, 0))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.value);
                if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                    for (let i = 0; i < message.$unknowns.length; ++i)
                        writer.raw(message.$unknowns[i]);
                return writer;
            };

            /**
             * Decodes a Quantile message from the specified reader or buffer.
             * @function decode
             * @memberof openmetrics.SummaryValue.Quantile
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {openmetrics.SummaryValue.Quantile & openmetrics.SummaryValue.Quantile.$Shape} Quantile
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Quantile.decode = function (reader, length, _end, _depth, _target) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $Reader.recursionLimit)
                    throw $Error("max depth exceeded");
                let end, message, value;
                if (length === $undefined)
                    end = reader.len;
                else {
                    end = reader.pos + length;
                    if (end > reader.len)
                        throw $RangeError("index out of range");
                    length = reader.len;
                    reader.len = end;
                }
                message = _target || new $root.openmetrics.SummaryValue.Quantile();
                while (reader.pos < end) {
                    let start = reader.pos;
                    let tag = reader.tag();
                    if (tag === _end) {
                        _end = $undefined;
                        break;
                    }
                    let wireType = tag & 7;
                    switch (tag >>>= 3) {
                    case 1: {
                            if (wireType !== 1)
                                break;
                            if (!$Object.is(value = reader.double(), 0))
                                message.quantile = value;
                            else
                                delete message.quantile;
                            continue;
                        }
                    case 2: {
                            if (wireType !== 1)
                                break;
                            if (!$Object.is(value = reader.double(), 0))
                                message.value = value;
                            else
                                delete message.value;
                            continue;
                        }
                    }
                    reader.skipType(wireType, _depth, tag);
                    if (!reader.discardUnknown) {
                        $util.makeProp(message, "$unknowns", false);
                        (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                    }
                }
                if (length !== $undefined) {
                    if (reader.pos !== end)
                        throw $RangeError("index out of range");
                    reader.len = length;
                }
                if (_end !== $undefined)
                    throw $Error("missing end group");
                return message;
            };

            /**
             * Creates a Quantile message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof openmetrics.SummaryValue.Quantile
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {openmetrics.SummaryValue.Quantile} Quantile
             */
            Quantile.fromObject = function (object, _depth) {
                if (object instanceof $root.openmetrics.SummaryValue.Quantile)
                    return object;
                if (!$util.isObject(object))
                    throw $TypeError(".openmetrics.SummaryValue.Quantile: object expected");
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                let message = new $root.openmetrics.SummaryValue.Quantile();
                if (object.quantile != null)
                    if (!$Object.is($Number(object.quantile), 0))
                        message.quantile = $Number(object.quantile);
                if (object.value != null)
                    if (!$Object.is($Number(object.value), 0))
                        message.value = $Number(object.value);
                return message;
            };

            /**
             * Creates a plain object from a Quantile message. Also converts values to other types if specified.
             * @function toObject
             * @memberof openmetrics.SummaryValue.Quantile
             * @static
             * @param {openmetrics.SummaryValue.Quantile} message Quantile
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Quantile.toObject = function (message, options, _depth) {
                if (!options)
                    options = {};
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                let object = {};
                if (options.defaults) {
                    object.quantile = 0;
                    object.value = 0;
                }
                if (message.quantile != null && $Object.hasOwnProperty.call(message, "quantile"))
                    object.quantile = options.json && !$isFinite(message.quantile) ? $String(message.quantile) : message.quantile;
                if (message.value != null && $Object.hasOwnProperty.call(message, "value"))
                    object.value = options.json && !$isFinite(message.value) ? $String(message.value) : message.value;
                return object;
            };

            /**
             * Converts this Quantile to JSON.
             * @function toJSON
             * @memberof openmetrics.SummaryValue.Quantile
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Quantile.prototype.toJSON = function() {
                return Quantile.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the type url for Quantile
             * @function getTypeUrl
             * @memberof openmetrics.SummaryValue.Quantile
             * @static
             * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
             * @returns {string} The type url
             */
            Quantile.getTypeUrl = function(prefix) {
                if (prefix === $undefined)
                    prefix = "type.googleapis.com";
                return prefix + "/openmetrics.SummaryValue.Quantile";
            };

            return Quantile;
        })();

        return SummaryValue;
    })();

    return openmetrics;
})();

export const google = $root.google = (() => {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    const google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        const protobuf = {};

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @typedef {Object} google.protobuf.Timestamp.$Properties
             * @property {number|Long|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @augments google.protobuf.Timestamp.$Properties
             * @deprecated Use google.protobuf.Timestamp.$Properties instead.
             */

            /**
             * Shape of a Timestamp.
             * @typedef {google.protobuf.Timestamp.$Properties} google.protobuf.Timestamp.$Shape
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @constructor
             * @param {google.protobuf.Timestamp.$Properties=} [properties] Properties to set
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */
            const Timestamp = function (properties) {
                if (properties)
                    for (let keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            };

            /**
             * Timestamp seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp.$Properties=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             * @type {{
             *   (properties: google.protobuf.Timestamp.$Shape): google.protobuf.Timestamp & google.protobuf.Timestamp.$Shape;
             *   (properties?: google.protobuf.Timestamp.$Properties): google.protobuf.Timestamp;
             * }}
             */
            Timestamp.create = function(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp.$Properties} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function (message, writer, _depth) {
                if (!writer)
                    writer = $Writer.create();
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                if (message.seconds != null && $Object.hasOwnProperty.call(message, "seconds") && (typeof message.seconds === "object" ? message.seconds.low || message.seconds.high : message.seconds !== 0))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && $Object.hasOwnProperty.call(message, "nanos") && message.nanos !== 0)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                    for (let i = 0; i < message.$unknowns.length; ++i)
                        writer.raw(message.$unknowns[i]);
                return writer;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Timestamp & google.protobuf.Timestamp.$Shape} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function (reader, length, _end, _depth, _target) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $Reader.recursionLimit)
                    throw $Error("max depth exceeded");
                let end, message, value;
                if (length === $undefined)
                    end = reader.len;
                else {
                    end = reader.pos + length;
                    if (end > reader.len)
                        throw $RangeError("index out of range");
                    length = reader.len;
                    reader.len = end;
                }
                message = _target || new $root.google.protobuf.Timestamp();
                while (reader.pos < end) {
                    let start = reader.pos;
                    let tag = reader.tag();
                    if (tag === _end) {
                        _end = $undefined;
                        break;
                    }
                    let wireType = tag & 7;
                    switch (tag >>>= 3) {
                    case 1: {
                            if (wireType !== 0)
                                break;
                            if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                                message.seconds = value;
                            else
                                delete message.seconds;
                            continue;
                        }
                    case 2: {
                            if (wireType !== 0)
                                break;
                            if (value = reader.int32())
                                message.nanos = value;
                            else
                                delete message.nanos;
                            continue;
                        }
                    }
                    reader.skipType(wireType, _depth, tag);
                    if (!reader.discardUnknown) {
                        $util.makeProp(message, "$unknowns", false);
                        (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                    }
                }
                if (length !== $undefined) {
                    if (reader.pos !== end)
                        throw $RangeError("index out of range");
                    reader.len = length;
                }
                if (_end !== $undefined)
                    throw $Error("missing end group");
                return message;
            };

            /**
             * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Timestamp} Timestamp
             */
            Timestamp.fromObject = function (object, _depth) {
                if (object instanceof $root.google.protobuf.Timestamp)
                    return object;
                if (!$util.isObject(object))
                    throw $TypeError(".google.protobuf.Timestamp: object expected");
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                let message = new $root.google.protobuf.Timestamp();
                if (object.seconds != null)
                    if (typeof object.seconds === "object" ? object.seconds.low || object.seconds.high : $Number(object.seconds) !== 0)
                        if ($util.Long)
                            message.seconds = $util.Long.fromValue(object.seconds, false);
                        else if (typeof object.seconds === "string")
                            message.seconds = $parseInt(object.seconds, 10);
                        else if (typeof object.seconds === "number")
                            message.seconds = object.seconds;
                        else if (typeof object.seconds === "object")
                            message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    if ($Number(object.nanos) !== 0)
                        message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp} message Timestamp
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Timestamp.toObject = function (message, options, _depth) {
                if (!options)
                    options = {};
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === $String ? long.toString() : options.longs === $Number ? long.toNumber() : typeof $BigInt !== "undefined" && options.longs === $BigInt ? long.toBigInt() : long;
                    } else
                        object.seconds = options.longs === $String ? "0" : typeof $BigInt !== "undefined" && options.longs === $BigInt ? $BigInt("0") : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && $Object.hasOwnProperty.call(message, "seconds"))
                    if (typeof $BigInt !== "undefined" && options.longs === $BigInt)
                        object.seconds = typeof message.seconds === "number" ? $BigInt(message.seconds) : $util.Long.fromBits(message.seconds.low >>> 0, message.seconds.high >>> 0, false).toBigInt();
                    else if (typeof message.seconds === "number")
                        object.seconds = options.longs === $String ? $String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === $String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === $Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && $Object.hasOwnProperty.call(message, "nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Timestamp to JSON.
             * @function toJSON
             * @memberof google.protobuf.Timestamp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Timestamp.prototype.toJSON = function() {
                return Timestamp.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the type url for Timestamp
             * @function getTypeUrl
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
             * @returns {string} The type url
             */
            Timestamp.getTypeUrl = function(prefix) {
                if (prefix === $undefined)
                    prefix = "type.googleapis.com";
                return prefix + "/google.protobuf.Timestamp";
            };

            return Timestamp;
        })();

        return protobuf;
    })();

    return google;
})();

/**
 * RootContainer enum.
 * @name RootContainer
 * @enum {number}
 * @property {number} MAIN=0 MAIN value
 * @property {number} SIDEBAR=1 SIDEBAR value
 * @property {number} EVENT=2 EVENT value
 * @property {number} BOTTOM=3 BOTTOM value
 */
export const RootContainer = $root.RootContainer = (() => {
    const valuesById = $Object.create(null), values = $Object.create(valuesById);
    values[valuesById[0] = "MAIN"] = 0;
    values[valuesById[1] = "SIDEBAR"] = 1;
    values[valuesById[2] = "EVENT"] = 2;
    values[valuesById[3] = "BOTTOM"] = 3;
    return values;
})();

export {
  $root as default
};
